webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(482);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKSPACE_COLLECTION = exports.WORKSPACE = exports.UNARCHIVE_STUDY_REQUEST = exports.USER_COLLECTION = exports.USER = exports.TAG_COLLECTION = exports.TAG = exports.SEARCH_COLLECTION = exports.SEARCH = exports.ROLE_COLLECTION = exports.ROLE = exports.RESPONSE = exports.REPORT_COLLECTION = exports.REPORT = exports.PROJECT_COLLECTION = exports.PROJECT = exports.NONE = exports.META_TAG_COLLECTION = exports.META_TAG = exports.HIGHLIGHT_COLLECTION = exports.HIGHLIGHT = exports.EMAIL_DOMAIN_COLLECTION = exports.EMAIL_DOMAIN = exports.COUNTRY_COLLECTION = exports.COUNTRY = exports.COMPANY_COLLECTION = exports.COMPANY = exports.CLIP = exports.BRANDING = exports.BOX_TRANSCRIPT_PRODUCT_COLLECTION = exports.BOX_TRANSCRIPT_PRODUCT = exports.ARCHIVED_STUDY_COLLECTION = exports.ARCHIVED_STUDY = undefined;

var _normalizr = __webpack_require__(62);

var archivedStudy = new _normalizr.Schema('archivedStudies');
var boxTranscriptProduct = new _normalizr.Schema('boxTranscriptProducts');
var branding = new _normalizr.Schema('brandings');
var clip = new _normalizr.Schema('clips');
var company = new _normalizr.Schema('companies');
var country = new _normalizr.Schema('countries');
var emailDomain = new _normalizr.Schema('emailDomains');
var highlight = new _normalizr.Schema('highlights');
var metaTag = new _normalizr.Schema('metaTags');
var project = new _normalizr.Schema('projects');
var report = new _normalizr.Schema('reports');
var response = new _normalizr.Schema('responses');
var role = new _normalizr.Schema('roles');
var search = new _normalizr.Schema('searches');
var tag = new _normalizr.Schema('tags');
var user = new _normalizr.Schema('users');
var unarchiveStudyRequest = new _normalizr.Schema('unarchiveStudyRequests');
var workspace = new _normalizr.Schema('workspaces');

clip.define({
  workspaces: (0, _normalizr.arrayOf)(workspace)
});

highlight.define({
  metaTags: (0, _normalizr.arrayOf)(metaTag),
  owner: user,
  tags: (0, _normalizr.arrayOf)(tag),
  workspaces: (0, _normalizr.arrayOf)(workspace)
});

project.define({
  countries: (0, _normalizr.arrayOf)(country),
  metaTags: (0, _normalizr.arrayOf)(metaTag),
  owner: user,
  tags: (0, _normalizr.arrayOf)(tag),
  workspaces: (0, _normalizr.arrayOf)(workspace)
});

report.define({
  tags: (0, _normalizr.arrayOf)(tag),
  workspaces: (0, _normalizr.arrayOf)(workspace)
});

response.define({
  workspaces: (0, _normalizr.arrayOf)(workspace)
});

workspace.define({
  owner: user
});

var ARCHIVED_STUDY = exports.ARCHIVED_STUDY = archivedStudy;
var ARCHIVED_STUDY_COLLECTION = exports.ARCHIVED_STUDY_COLLECTION = (0, _normalizr.arrayOf)(archivedStudy);
var BOX_TRANSCRIPT_PRODUCT = exports.BOX_TRANSCRIPT_PRODUCT = boxTranscriptProduct;
var BOX_TRANSCRIPT_PRODUCT_COLLECTION = exports.BOX_TRANSCRIPT_PRODUCT_COLLECTION = (0, _normalizr.arrayOf)(boxTranscriptProduct);
var BRANDING = exports.BRANDING = branding;
var CLIP = exports.CLIP = clip;
var COMPANY = exports.COMPANY = company;
var COMPANY_COLLECTION = exports.COMPANY_COLLECTION = (0, _normalizr.arrayOf)(company);
var COUNTRY = exports.COUNTRY = country;
var COUNTRY_COLLECTION = exports.COUNTRY_COLLECTION = (0, _normalizr.arrayOf)(country);
var EMAIL_DOMAIN = exports.EMAIL_DOMAIN = emailDomain;
var EMAIL_DOMAIN_COLLECTION = exports.EMAIL_DOMAIN_COLLECTION = (0, _normalizr.arrayOf)(emailDomain);
var HIGHLIGHT = exports.HIGHLIGHT = highlight;
var HIGHLIGHT_COLLECTION = exports.HIGHLIGHT_COLLECTION = (0, _normalizr.arrayOf)(highlight);
var META_TAG = exports.META_TAG = metaTag;
var META_TAG_COLLECTION = exports.META_TAG_COLLECTION = (0, _normalizr.arrayOf)(metaTag);
var NONE = exports.NONE = 'NONE';
var PROJECT = exports.PROJECT = project;
var PROJECT_COLLECTION = exports.PROJECT_COLLECTION = (0, _normalizr.arrayOf)(project);
var REPORT = exports.REPORT = report;
var REPORT_COLLECTION = exports.REPORT_COLLECTION = (0, _normalizr.arrayOf)(report);
var RESPONSE = exports.RESPONSE = response;
var ROLE = exports.ROLE = role;
var ROLE_COLLECTION = exports.ROLE_COLLECTION = (0, _normalizr.arrayOf)(role);
var SEARCH = exports.SEARCH = search;
var SEARCH_COLLECTION = exports.SEARCH_COLLECTION = (0, _normalizr.arrayOf)(search);
var TAG = exports.TAG = tag;
var TAG_COLLECTION = exports.TAG_COLLECTION = (0, _normalizr.arrayOf)(tag);
var USER = exports.USER = user;
var USER_COLLECTION = exports.USER_COLLECTION = (0, _normalizr.arrayOf)(user);
var UNARCHIVE_STUDY_REQUEST = exports.UNARCHIVE_STUDY_REQUEST = unarchiveStudyRequest;
var WORKSPACE = exports.WORKSPACE = workspace;
var WORKSPACE_COLLECTION = exports.WORKSPACE_COLLECTION = (0, _normalizr.arrayOf)(workspace);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REQUEST_DELETE = exports.REQUEST_PUT = exports.REQUEST_POST = exports.REQUEST_GET = exports.CALL_API = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _humps = __webpack_require__(22);

var _index = __webpack_require__(3);

var _environmentConstants = __webpack_require__(96);

var _normalizr = __webpack_require__(62);

var _axios = __webpack_require__(63);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var API_ROOT = '/r/api/common/';

function callApi(endpoint, requestType, schema, data, dataGetter) {
  if (endpoint.indexOf(API_ROOT) === -1) {
    endpoint = API_ROOT + endpoint;
  }

  if (endpoint.indexOf('token=') === -1) {
    var symbol = endpoint.indexOf('?') === -1 ? '?' : '&';
    endpoint = endpoint + symbol + 'token=' + _environmentConstants.API_KEY;
  }

  if (typeof data !== 'undefined') {
    data = (0, _humps.decamelizeKeys)(data);
  }

  if (requestType === REQUEST_GET) {
    data = { params: data };
  }

  return _axios2.default[requestType](endpoint, data).then(function (response) {
    var camelizedJson = (0, _humps.camelizeKeys)(response.data);

    if (schema === _index.NONE) {
      return camelizedJson;
    }

    var responseData = camelizedJson;

    if (dataGetter) {
      responseData = dataGetter(camelizedJson);
    }

    var normalized = responseData ? (0, _normalizr.normalize)(responseData, schema) : {};

    return Object.assign({}, camelizedJson, normalized);
  });
}

var CALL_API = exports.CALL_API = Symbol('Call API');
var REQUEST_GET = exports.REQUEST_GET = 'get';
var REQUEST_POST = exports.REQUEST_POST = 'post';
var REQUEST_PUT = exports.REQUEST_PUT = 'put';
var REQUEST_DELETE = exports.REQUEST_DELETE = 'delete';

exports.default = function (store) {
  return function (next) {
    return function (action) {
      var _actionData;

      var callAPI = action[CALL_API];
      if (typeof callAPI === 'undefined') {
        return next(action);
      }

      var endpoint = callAPI.endpoint;
      var bailout = callAPI.bailout,
          data = callAPI.data,
          requestType = callAPI.requestType,
          schema = callAPI.schema,
          types = callAPI.types,
          dataGetter = callAPI.dataGetter;


      if (typeof endpoint === 'function') {
        endpoint = endpoint(store.getState());
      }

      if (typeof endpoint !== 'string') {
        throw new Error('Specify a string endpoint URL');
      }

      if (!schema) {
        throw new Error('Specify a schema');
      }

      if (!Array.isArray(types) || types.length !== 3) {
        throw new Error('Expected an array of three action types');
      }

      if (!types.every(function (type) {
        return typeof type === 'string';
      })) {
        throw new Error('Expected action types to be strings.');
      }

      if ([REQUEST_GET, REQUEST_PUT, REQUEST_POST, REQUEST_DELETE].indexOf(requestType) === -1) {
        throw new Error('Expected requestType to be one of "GET", "PUT", "POST", "DELETE"');
      }

      if (typeof bailout !== 'undefined' && typeof bailout !== 'function') {
        throw new Error('Expected bailout to either be undefined or a function');
      }

      if (typeof dataGetter !== 'undefined' && typeof dataGetter !== 'function') {
        throw new Error('Expected dataGetter to either be undefined or a function');
      }

      if (bailout && bailout(store.getState())) {
        return Promise.resolve();
      }

      var _types = _slicedToArray(types, 3),
          REQUEST = _types[0],
          SUCCESS = _types[1],
          FAILURE = _types[2];

      var actionData = (_actionData = {}, _defineProperty(_actionData, REQUEST, action[REQUEST]), _defineProperty(_actionData, SUCCESS, action[SUCCESS]), _defineProperty(_actionData, FAILURE, action[FAILURE]), _actionData);
      delete action[REQUEST];
      delete action[SUCCESS];
      delete action[FAILURE];

      function actionWith(data) {
        var finalAction = Object.assign({}, action, data);
        delete finalAction[CALL_API];
        return finalAction;
      }

      var actionDataFor = function actionDataFor(type, fn) {
        var data = actionData[type] || {};
        return typeof data === 'function' ? fn(data) : data;
      };

      next(actionWith(Object.assign({ type: REQUEST }, actionData[REQUEST])));

      return callApi(endpoint, requestType, schema, data, dataGetter).then(function (response) {
        return next(actionWith(Object.assign({
          type: SUCCESS,
          response: response
        }, actionDataFor(SUCCESS, function (data) {
          return data(response);
        }))));
      }, function (error) {
        return next(actionWith(Object.assign({
          type: FAILURE,
          error: error.data
        }, actionDataFor(FAILURE, function (data) {
          return data(error.data);
        }))));
      });
    };
  };
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(403);


var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */].bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ __webpack_exports__["default"] = (newStyled);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WARNING = exports.SUCCESS = exports.INFO = exports.ERROR = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _CloseButton = __webpack_require__(221);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _i18n = __webpack_require__(90);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ERROR = exports.ERROR = 'ERROR';
var INFO = exports.INFO = 'INFO';
var SUCCESS = exports.SUCCESS = 'SUCCESS';
var WARNING = exports.WARNING = 'WARNING';

var AlertListItem = (_temp = _class = function (_PureComponent) {
  _inherits(AlertListItem, _PureComponent);

  function AlertListItem(props) {
    _classCallCheck(this, AlertListItem);

    var _this = _possibleConstructorReturn(this, (AlertListItem.__proto__ || Object.getPrototypeOf(AlertListItem)).call(this, props));

    _this.closeAlert = _this.closeAlert.bind(_this);
    return _this;
  }

  _createClass(AlertListItem, [{
    key: 'closeAlert',
    value: function closeAlert() {
      var _props = this.props,
          alert = _props.alert,
          onCloseClick = _props.onCloseClick;

      onCloseClick(alert);
    }
  }, {
    key: 'render',
    value: function render() {
      var alert = this.props.alert;
      var persistent = alert.persistent,
          htmlSafe = alert.htmlSafe,
          message = alert.message,
          type = alert.type;


      var classes = (0, _classnames2.default)('alert', {
        'alert-danger': type === ERROR,
        'alert-info': type === INFO,
        'alert-success': type === SUCCESS,
        'alert-warning': type === WARNING
      });

      return _react2.default.createElement(
        'div',
        { className: classes },
        !persistent && _react2.default.createElement(_CloseButton2.default, { onClick: this.closeAlert }),
        htmlSafe && _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: message } }),
        !htmlSafe && _react2.default.createElement(
          'span',
          null,
          _i18n2.default.t(message)
        )
      );
    }
  }]);

  return AlertListItem;
}(_react.PureComponent), _class.propTypes = {
  alert: _propTypes2.default.shape({
    persistent: _propTypes2.default.bool,
    htmlSafe: _propTypes2.default.bool,
    message: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.oneOf([ERROR, INFO, SUCCESS, WARNING]).isRequired
  }),
  onCloseClick: _propTypes2.default.func
}, _temp);
exports.default = AlertListItem;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

__webpack_require__(717);
var React = __webpack_require__(0);
var core = __webpack_require__(41);
var polished = __webpack_require__(718);
var recompose = __webpack_require__(719);
var Downshift = __webpack_require__(722);
var emotionTheming = __webpack_require__(668);
var PropTypes = __webpack_require__(1);
var reactRouterDom = __webpack_require__(84);
var reactDom = __webpack_require__(46);
var reactPopper = __webpack_require__(734);
var invariant = __webpack_require__(19);
var formik = __webpack_require__(759);
var ReactDropzone = __webpack_require__(768);
__webpack_require__(5);
var withProps = __webpack_require__(772);
var Media = __webpack_require__(776);
var Transition = __webpack_require__(779);
var warning = __webpack_require__(781);
var reactMotion = __webpack_require__(782);
var reactTable = __webpack_require__(790);
var AutosizeInput = __webpack_require__(792);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Downshift__default = /*#__PURE__*/_interopDefaultLegacy(Downshift);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var invariant__default = /*#__PURE__*/_interopDefaultLegacy(invariant);
var ReactDropzone__default = /*#__PURE__*/_interopDefaultLegacy(ReactDropzone);
var withProps__default = /*#__PURE__*/_interopDefaultLegacy(withProps);
var Media__default = /*#__PURE__*/_interopDefaultLegacy(Media);
var Transition__default = /*#__PURE__*/_interopDefaultLegacy(Transition);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
var AutosizeInput__default = /*#__PURE__*/_interopDefaultLegacy(AutosizeInput);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      if (!isBrowser && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (false) {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var testOmitPropsOnStringTag = index;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var isBrowser$1 = typeof document !== 'undefined';

var createStyled = function createStyled(tag, options) {
  if (false) {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var identifierName;
  var shouldForwardProp;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
      options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = core.withEmotionCache(function (props, context, ref) {
      return React.createElement(core.ThemeContext.Consumer, null, function (theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = theme;
        }

        if (typeof props.className === 'string') {
          className = getRegisteredStyles(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = serializeStyles(styles.concat(classInterpolations), context.registered, mergedProps);
        var rules = insertStyles(context, serialized, typeof finalTag === 'string');
        className += context.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref || props.innerRef;

        if (false) {
          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
        }

        var ele = React.createElement(finalTag, newProps);

        if (!isBrowser$1 && rules !== undefined) {
          var _ref;

          var serializedNames = serialized.name;
          var next = serialized.next;

          while (next !== undefined) {
            serializedNames += ' ' + next.name;
            next = next.next;
          }

          return React.createElement(React.Fragment, null, React.createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
          }, _ref.nonce = context.sheet.nonce, _ref)), ele);
        }

        return ele;
      });
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
    };

    return Styled;
  };
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var curry = (function (fn) {
  var curried = function curried() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length >= fn.length) {
      return fn.apply(void 0, args);
    }

    return function () {
      for (var _len2 = arguments.length, args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args2[_key2] = arguments[_key2];
      }

      return curried.apply(void 0, _toConsumableArray(args.concat(args2)));
    };
  };

  return curried;
});

var BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
var mediaUp = function mediaUp(size) {
  return "@media (min-width: ".concat(BREAKPOINTS[size], "px)");
};
var mediaDn = function mediaDn(size) {
  return "@media (max-width: ".concat(BREAKPOINTS[size], "px)");
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var borderRadiusProperty = curry(function (property, size, _ref2) {
  var theme = _ref2.theme;
  return /*#__PURE__*/core.css(property, ":", theme.fvStyle.borderRadius[size], ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
});
var borderRadius = borderRadiusProperty('border-radius');
var borderTopLeftRadius = borderRadiusProperty('border-top-left-radius');
var borderTopRightRadius = borderRadiusProperty('border-top-right-radius');
var borderBottomRightRadius = borderRadiusProperty('border-bottom-right-radius');
var borderBottomLeftRadius = borderRadiusProperty('border-bottom-left-radius');
var color = curry(function (name, _ref3) {
  var theme = _ref3.theme;
  return theme.fvStyle.brand[name];
});
var gradientStart = curry(function (name, _ref4) {
  var theme = _ref4.theme;
  return theme.fvStyle.brand["".concat(name, "Gradient")].start;
});
var gradientEnd = curry(function (name, _ref5) {
  var theme = _ref5.theme;
  return theme.fvStyle.brand["".concat(name, "Gradient")].end;
});
var rem = curry(function (px, _ref6) {
  var theme = _ref6.theme;
  return polished.rem(px, theme.fvStyle.font.base);
});
var fontSize = curry(function (size, _ref7) {
  var theme = _ref7.theme;
  return /*#__PURE__*/core.css("font-size:", theme.fvStyle.font.size[size], ";line-height:", theme.fvStyle.font.lineHeight[size], ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
});
var fontWeight = curry(function (weight, _ref8) {
  var theme = _ref8.theme;
  return /*#__PURE__*/core.css("font-weight:", theme.fvStyle.font.weight[weight], ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
});
var margin = curry(function (size, _ref9) {
  var theme = _ref9.theme;
  return /*#__PURE__*/core.css("margin:", theme.fvStyle.spacing[size].y, " ", theme.fvStyle.spacing[size].x, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
});
var padding = curry(function (size, _ref10) {
  var theme = _ref10.theme;
  return /*#__PURE__*/core.css("padding:", theme.fvStyle.spacing[size].y, " ", theme.fvStyle.spacing[size].x, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlEMEIiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IGN1cnJ5IGZyb20gJy4uL3V0aWxzL2N1cnJ5J1xuaW1wb3J0IHsgbWVkaWFEbiwgbWVkaWFVcCwgQlJFQUtQT0lOVFMgfSBmcm9tICcuLi91dGlscy9icmVha3BvaW50cydcbmltcG9ydCB7IHJlbSBhcyB0b1JlbSwgcmdiYSB9IGZyb20gJ3BvbGlzaGVkJ1xuXG5jb25zdCBib3JkZXJSYWRpdXNQcm9wZXJ0eSA9IGN1cnJ5KFxuICAocHJvcGVydHksIHNpemUsIHsgdGhlbWUgfSkgPT4gY3NzYFxuICAgICR7cHJvcGVydHl9OiAke3RoZW1lLmZ2U3R5bGUuYm9yZGVyUmFkaXVzW3NpemVdfTtcbiAgYFxuKVxuXG5leHBvcnQgY29uc3QgYm9yZGVyUmFkaXVzID0gYm9yZGVyUmFkaXVzUHJvcGVydHkoJ2JvcmRlci1yYWRpdXMnKVxuZXhwb3J0IGNvbnN0IGJvcmRlclRvcExlZnRSYWRpdXMgPSBib3JkZXJSYWRpdXNQcm9wZXJ0eShcbiAgJ2JvcmRlci10b3AtbGVmdC1yYWRpdXMnXG4pXG5leHBvcnQgY29uc3QgYm9yZGVyVG9wUmlnaHRSYWRpdXMgPSBib3JkZXJSYWRpdXNQcm9wZXJ0eShcbiAgJ2JvcmRlci10b3AtcmlnaHQtcmFkaXVzJ1xuKVxuZXhwb3J0IGNvbnN0IGJvcmRlckJvdHRvbVJpZ2h0UmFkaXVzID0gYm9yZGVyUmFkaXVzUHJvcGVydHkoXG4gICdib3JkZXItYm90dG9tLXJpZ2h0LXJhZGl1cydcbilcbmV4cG9ydCBjb25zdCBib3JkZXJCb3R0b21MZWZ0UmFkaXVzID0gYm9yZGVyUmFkaXVzUHJvcGVydHkoXG4gICdib3JkZXItYm90dG9tLWxlZnQtcmFkaXVzJ1xuKVxuXG5leHBvcnQgY29uc3QgY29sb3IgPSBjdXJyeSgobmFtZSwgeyB0aGVtZSB9KSA9PiB0aGVtZS5mdlN0eWxlLmJyYW5kW25hbWVdKVxuXG5leHBvcnQgY29uc3QgZ3JhZGllbnRTdGFydCA9IGN1cnJ5KFxuICAobmFtZSwgeyB0aGVtZSB9KSA9PiB0aGVtZS5mdlN0eWxlLmJyYW5kW2Ake25hbWV9R3JhZGllbnRgXS5zdGFydFxuKVxuXG5leHBvcnQgY29uc3QgZ3JhZGllbnRFbmQgPSBjdXJyeShcbiAgKG5hbWUsIHsgdGhlbWUgfSkgPT4gdGhlbWUuZnZTdHlsZS5icmFuZFtgJHtuYW1lfUdyYWRpZW50YF0uZW5kXG4pXG5cbmV4cG9ydCBjb25zdCByZW0gPSBjdXJyeSgocHgsIHsgdGhlbWUgfSkgPT4gdG9SZW0ocHgsIHRoZW1lLmZ2U3R5bGUuZm9udC5iYXNlKSlcblxuZXhwb3J0IGNvbnN0IGZvbnRTaXplID0gY3VycnkoXG4gIChzaXplLCB7IHRoZW1lIH0pID0+IGNzc2BcbiAgICBmb250LXNpemU6ICR7dGhlbWUuZnZTdHlsZS5mb250LnNpemVbc2l6ZV19O1xuICAgIGxpbmUtaGVpZ2h0OiAke3RoZW1lLmZ2U3R5bGUuZm9udC5saW5lSGVpZ2h0W3NpemVdfTtcbiAgYFxuKVxuXG5leHBvcnQgY29uc3QgZm9udFdlaWdodCA9IGN1cnJ5KFxuICAod2VpZ2h0LCB7IHRoZW1lIH0pID0+IGNzc2BcbiAgICBmb250LXdlaWdodDogJHt0aGVtZS5mdlN0eWxlLmZvbnQud2VpZ2h0W3dlaWdodF19O1xuICBgXG4pXG5cbmV4cG9ydCBjb25zdCBtYXJnaW4gPSBjdXJyeShcbiAgKHNpemUsIHsgdGhlbWUgfSkgPT4gY3NzYFxuICAgIG1hcmdpbjogJHt0aGVtZS5mdlN0eWxlLnNwYWNpbmdbc2l6ZV0ueX0gJHt0aGVtZS5mdlN0eWxlLnNwYWNpbmdbc2l6ZV0ueH07XG4gIGBcbilcblxuZXhwb3J0IGNvbnN0IHBhZGRpbmcgPSBjdXJyeShcbiAgKHNpemUsIHsgdGhlbWUgfSkgPT4gY3NzYFxuICAgIHBhZGRpbmc6ICR7dGhlbWUuZnZTdHlsZS5zcGFjaW5nW3NpemVdLnl9ICR7dGhlbWUuZnZTdHlsZS5zcGFjaW5nW3NpemVdLnh9O1xuICBgXG4pXG5cbmV4cG9ydCBjb25zdCBzaGFkb3cgPSBjdXJyeShcbiAgKGtpbmQsIHsgdGhlbWUgfSkgPT4gY3NzYFxuICAgIGJveC1zaGFkb3c6ICR7dGhlbWUuZnZTdHlsZS5zaGFkb3dba2luZF19O1xuICBgXG4pXG5cbmV4cG9ydCBjb25zdCBzcGFjZXIgPSBjdXJyeShcbiAgKHZhcmlhbnQsIHsgdGhlbWUgfSkgPT4gdGhlbWUuZnZTdHlsZS5zcGFjaW5nLnNpemVbYHNwYWNlciR7dmFyaWFudH1gXVxuKVxuXG5leHBvcnQgY29uc3QgdHJhbnNwYXJlbnRpemUgPSBjdXJyeSgoY29sb3JOYW1lLCBhbW91bnQsIHsgdGhlbWUgfSkgPT5cbiAgcmdiYShjb2xvcihjb2xvck5hbWUsIHsgdGhlbWUgfSksIGFtb3VudClcbilcblxuZXhwb3J0IGNvbnN0IHR5cG9ncmFwaHkgPSBjdXJyeSgoc3R5bGUsIHsgdGhlbWUgfSkgPT5cbiAgY3NzKHRoZW1lLmZ2U3R5bGUudHlwb2dyYXBoeVtzdHlsZV0pXG4pXG5cbmV4cG9ydCBjb25zdCByZXNwb25zaXZlQ29udGFpbmVyID0gKHsgZmx1aWQgfSkgPT5cbiAgZmx1aWRcbiAgICA/IGNzc2BcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBgXG4gICAgOiBjc3NgXG4gICAgICAgICR7bWVkaWFVcCgneGwnKX0ge1xuICAgICAgICAgIHdpZHRoOiAke0JSRUFLUE9JTlRTLnhsfXB4O1xuICAgICAgICB9XG5cbiAgICAgICAgJHttZWRpYURuKCd4bCcpfSB7XG4gICAgICAgICAgd2lkdGg6ICR7QlJFQUtQT0lOVFMubGd9cHg7XG4gICAgICAgIH1cblxuICAgICAgICAke21lZGlhRG4oJ2xnJyl9IHtcbiAgICAgICAgICB3aWR0aDogJHtCUkVBS1BPSU5UUy5tZH1weDtcbiAgICAgICAgfVxuXG4gICAgICAgICR7bWVkaWFEbignbWQnKX0ge1xuICAgICAgICAgIHdpZHRoOiAke0JSRUFLUE9JTlRTLnNtfXB4O1xuICAgICAgICB9XG5cbiAgICAgICAgJHttZWRpYURuKCdzbScpfSB7XG4gICAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIH1cbiAgICAgIGBcbiJdfQ== */"));
});
var shadow = curry(function (kind, _ref11) {
  var theme = _ref11.theme;
  return /*#__PURE__*/core.css("box-shadow:", theme.fvStyle.shadow[kind], ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
});
var spacer = curry(function (variant, _ref12) {
  var theme = _ref12.theme;
  return theme.fvStyle.spacing.size["spacer".concat(variant)];
});
var transparentize = curry(function (colorName, amount, _ref13) {
  var theme = _ref13.theme;
  return polished.rgba(color(colorName, {
    theme: theme
  }), amount);
});
var typography = curry(function (style, _ref14) {
  var theme = _ref14.theme;
  return /*#__PURE__*/core.css(theme.fvStyle.typography[style],  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
});

var _ref =  true ? {
  name: "8atqhb",
  styles: "width:100%;"
} : {
  name: "8atqhb",
  styles: "width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var responsiveContainer = function responsiveContainer(_ref15) {
  var fluid = _ref15.fluid;
  return fluid ? _ref : /*#__PURE__*/core.css(mediaUp('xl'), "{width:", BREAKPOINTS.xl, "px;}", mediaDn('xl'), "{width:", BREAKPOINTS.lg, "px;}", mediaDn('lg'), "{width:", BREAKPOINTS.md, "px;}", mediaDn('md'), "{width:", BREAKPOINTS.sm, "px;}", mediaDn('sm'), "{width:100%;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var prop = curry(function (name, obj) {
  return obj[name];
});
var defaultTo = curry(function (fallback, obj) {
  return obj == null ? fallback : obj;
});

var FILTERED_PROPS = ['size', 'ref'];

var namedColor = function namedColor(colorName, fallback) {
  return function (_ref) {
    var theme = _ref.theme,
        props = _objectWithoutProperties(_ref, ["theme"]);

    return color(props[colorName], {
      theme: theme
    }) || props[colorName] || fallback;
  };
}; // 1.5rem default = 24px (the viewBox) with 16px base size


var size = function size(_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return theme.fvStyle.font.size[size] || size || '1.5rem';
};

var SVGIcon = /*#__PURE__*/createStyled('svg', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return FILTERED_PROPS.indexOf(prop) === -1;
  },
  target: "e1l6927m0",
  label: "SVGIcon"
})("color:", namedColor('color', 'currentColor'), ";fill:", namedColor('fill', 'none'), ";width:", size, ";height:", size, ";cursor:", prop('cursor'), ";stroke:currentColor;pointer-events:", prop('pointerEvents'), ";vertical-align:middle;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNWR0ljb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0JFIiwiZmlsZSI6IlNWR0ljb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNvbG9yIH0gZnJvbSAnLi4vc3R5bGVzJ1xuaW1wb3J0IHsgcHJvcCB9IGZyb20gJy4uL3V0aWxzL2ZwJ1xuXG5jb25zdCBGSUxURVJFRF9QUk9QUyA9IFsnc2l6ZScsICdyZWYnXVxuXG5jb25zdCBuYW1lZENvbG9yID0gKGNvbG9yTmFtZSwgZmFsbGJhY2spID0+ICh7IHRoZW1lLCAuLi5wcm9wcyB9KSA9PlxuICBjb2xvcihwcm9wc1tjb2xvck5hbWVdLCB7IHRoZW1lIH0pIHx8IHByb3BzW2NvbG9yTmFtZV0gfHwgZmFsbGJhY2tcblxuLy8gMS41cmVtIGRlZmF1bHQgPSAyNHB4ICh0aGUgdmlld0JveCkgd2l0aCAxNnB4IGJhc2Ugc2l6ZVxuY29uc3Qgc2l6ZSA9ICh7IHRoZW1lLCBzaXplIH0pID0+XG4gIHRoZW1lLmZ2U3R5bGUuZm9udC5zaXplW3NpemVdIHx8IHNpemUgfHwgJzEuNXJlbSdcblxuY29uc3QgU1ZHSWNvbiA9IHN0eWxlZCgnc3ZnJywge1xuICBzaG91bGRGb3J3YXJkUHJvcDogKHByb3ApID0+IEZJTFRFUkVEX1BST1BTLmluZGV4T2YocHJvcCkgPT09IC0xLFxufSlgXG4gIGNvbG9yOiAke25hbWVkQ29sb3IoJ2NvbG9yJywgJ2N1cnJlbnRDb2xvcicpfTtcbiAgZmlsbDogJHtuYW1lZENvbG9yKCdmaWxsJywgJ25vbmUnKX07XG4gIHdpZHRoOiAke3NpemV9O1xuICBoZWlnaHQ6ICR7c2l6ZX07XG4gIGN1cnNvcjogJHtwcm9wKCdjdXJzb3InKX07XG4gIHN0cm9rZTogY3VycmVudENvbG9yO1xuICBwb2ludGVyLWV2ZW50czogJHtwcm9wKCdwb2ludGVyRXZlbnRzJyl9O1xuICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuYFxuXG5jb25zdCBTVkdJY29uV2l0aERlZmF1bHRzID0gKHtcbiAgdmlld0JveCA9ICcwIDAgMjQgMjQnLFxuICB4bWxucyA9ICdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZycsXG4gIC4uLnByb3BzXG59KSA9PiA8U1ZHSWNvbiB7Li4ucHJvcHN9IHZpZXdCb3g9e3ZpZXdCb3h9IHhtbG5zPXt4bWxuc30gLz5cblxuZXhwb3J0IGRlZmF1bHQgU1ZHSWNvbldpdGhEZWZhdWx0c1xuIl19 */"));

var SVGIconWithDefaults = function SVGIconWithDefaults(_ref3) {
  var _ref3$viewBox = _ref3.viewBox,
      viewBox = _ref3$viewBox === void 0 ? '0 0 24 24' : _ref3$viewBox,
      _ref3$xmlns = _ref3.xmlns,
      xmlns = _ref3$xmlns === void 0 ? 'http://www.w3.org/2000/svg' : _ref3$xmlns,
      props = _objectWithoutProperties(_ref3, ["viewBox", "xmlns"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIcon, _extends({}, props, {
    viewBox: viewBox,
    xmlns: xmlns
  }));
};

var FeatherSVG = /*#__PURE__*/createStyled(SVGIconWithDefaults, {
  target: "e1r10n8r0",
  label: "FeatherSVG"
})("stroke-width:", recompose.compose(defaultTo(2), prop('strokeWidth')), ";stroke-linecap:round;stroke-linejoin:round;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZlYXRoZXJTVkcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSWtDIiwiZmlsZSI6IkZlYXRoZXJTVkcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCBTVkdJY29uIGZyb20gJy4uL1NWR0ljb24nXG5pbXBvcnQgeyBjb21wb3NlLCBkZWZhdWx0VG8sIHByb3AgfSBmcm9tICcuLi8uLi91dGlscy9mcCdcblxuY29uc3QgRmVhdGhlclNWRyA9IHN0eWxlZChTVkdJY29uKWBcbiAgc3Ryb2tlLXdpZHRoOiAke2NvbXBvc2UoZGVmYXVsdFRvKDIpLCBwcm9wKCdzdHJva2VXaWR0aCcpKX07XG4gIHN0cm9rZS1saW5lY2FwOiByb3VuZDtcbiAgc3Ryb2tlLWxpbmVqb2luOiByb3VuZDtcbmBcblxuZXhwb3J0IGRlZmF1bHQgRmVhdGhlclNWR1xuIl19 */"));

var AlertCircle = function AlertCircle(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "alert-circle"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "12"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "16"
  }));
};

var AlertTriangle = function AlertTriangle(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "warning"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "13"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "17"
  }));
};

var Archive = function Archive(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "archive"), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "21 8 21 21 3 21 3 8"
  }), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "1",
    y: "3",
    width: "22",
    height: "5"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "10",
    y1: "12",
    x2: "14",
    y2: "12"
  }));
};

var DIRECTIONS = {
  up: /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "19",
    x2: "12",
    y2: "5"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "5 12 12 5 19 12"
  })),
  down: /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "19 12 12 19 5 12"
  })),
  left: /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "19",
    y1: "12",
    x2: "5",
    y2: "12"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "12 19 5 12 12 5"
  })),
  right: /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "12 5 19 12 12 19"
  }))
};

var Arrow = function Arrow(_ref) {
  var direction = _ref.direction,
      props = _objectWithoutProperties(_ref, ["direction"]);

  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "arrow-", direction), DIRECTIONS[direction]);
};

var Bookmark = function Bookmark(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "bookmark"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
  }));
};

var Calendar = function Calendar(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  }));
};

var Cancel = function Cancel(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "cancel"), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }));
};

var Caret = function Caret(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, _extends({
    fill: "currentColor",
    strokeWidth: 0
  }, props), /*#__PURE__*/React__default['default'].createElement("title", null, "caret"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M0 6h24L12 18z"
  }));
};

var Chat = function Chat(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "chat"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
  }));
};

var CheckCircle = function CheckCircle(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "check-circle"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "17 9 11 16.01 8 13.01"
  }));
};

var Check = function Check(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "check"), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "20 6 9 17 4 12"
  }));
};

var pathFor = function pathFor(direction) {
  switch (direction) {
    case 'down':
      return /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "6 9 12 15 18 9"
      });

    case 'left':
      return /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "15 18 9 12 15 6"
      });

    case 'up':
      return /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "18 15 12 9 6 15"
      });

    case 'right':
      return /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "9 18 15 12 9 6"
      });

    default:
      throw new Error('invalid direction');
  }
};

var Chevron = function Chevron(_ref) {
  var direction = _ref.direction,
      props = _objectWithoutProperties(_ref, ["direction"]);

  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "chevron-", direction), pathFor(direction));
};

var Disc = function Disc(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "disc"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }));
};

var Download = function Download(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "download"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "7 10 12 15 17 10"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "3"
  }));
};

var Edit = function Edit(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "edit"), /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "16 3 21 8 8 21 3 21 3 16 16 3"
  }));
};

var ExternalLink = function ExternalLink(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "external-link"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "15 3 21 3 21 9"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "10",
    y1: "14",
    x2: "21",
    y2: "3"
  }));
};

var File = function File(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "file"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "13 2 13 9 20 9"
  }));
};

var FilePlus = function FilePlus(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "file-plus"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "14 2 14 8 20 8"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "12"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "9",
    y1: "15",
    x2: "15",
    y2: "15"
  }));
};

var Hamburger = function Hamburger(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "hamburger"), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "3",
    y1: "6",
    x2: "21",
    y2: "6"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "3",
    y1: "18",
    x2: "21",
    y2: "18"
  }));
};

Hamburger.defaultProps = {
  cursor: 'pointer'
};

var Hash = function Hash(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "hash"), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "4",
    y1: "9",
    x2: "20",
    y2: "9"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "4",
    y1: "15",
    x2: "20",
    y2: "15"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "10",
    y1: "3",
    x2: "8",
    y2: "21"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "16",
    y1: "3",
    x2: "14",
    y2: "21"
  }));
};

var Help = function Help(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "help"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "17"
  }));
};

var Home = function Home(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "home"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "9 22 9 12 15 12 15 22"
  }));
};

var Image = function Image(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "image"), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "1.5"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "21 15 16 10 5 21"
  }));
};

var Info = function Info(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "info"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "8"
  }));
};

var Lock = function Lock(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "lock"), /*#__PURE__*/React__default['default'].createElement("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2",
    ry: "2"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  }));
};

var Maximize = function Maximize(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "maximize"), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "15 3 21 3 21 9"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "9 21 3 21 3 15"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "21",
    y1: "3",
    x2: "14",
    y2: "10"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "3",
    y1: "21",
    x2: "10",
    y2: "14"
  }));
};

var Minimize = function Minimize(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "minimize"), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "4 14 10 14 10 20"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "20 10 14 10 14 4"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "14",
    y1: "10",
    x2: "21",
    y2: "3"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "3",
    y1: "21",
    x2: "10",
    y2: "14"
  }));
};

var DIRECTIONS$1 = {
  horizontal: /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "19",
    cy: "12",
    r: "1"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "5",
    cy: "12",
    r: "1"
  })),
  vertical: /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "5",
    r: "1"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  }))
};

var More = function More(_ref) {
  var direction = _ref.direction,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["direction", "title"]);

  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, title), DIRECTIONS$1[direction]);
};

More.defaultProps = {
  direction: 'horizontal',
  title: 'More'
};

var Play = function Play(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "play"), /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "5 3 19 12 5 21 5 3"
  }));
};

var Plus = function Plus(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "plus"), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  }));
};

var svgFor = function svgFor(direction) {
  switch (direction) {
    case 'cw':
      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "23 4 23 10 17 10"
      }), /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "1 20 1 14 7 14"
      }), /*#__PURE__*/React__default['default'].createElement("path", {
        d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
      }));

    case 'ccw':
      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "1 4 1 10 7 10"
      }), /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "23 20 23 14 17 14"
      }), /*#__PURE__*/React__default['default'].createElement("path", {
        d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
      }));

    default:
      throw new Error("invalid direction. Valid options are 'cw', 'ccw'");
  }
};

var Refresh = function Refresh(_ref) {
  var direction = _ref.direction,
      props = _objectWithoutProperties(_ref, ["direction"]);

  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "refresh-", direction), svgFor(direction));
};

var svgFor$1 = function svgFor(direction) {
  switch (direction) {
    case 'cw':
      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "23 4 23 10 17 10"
      }), /*#__PURE__*/React__default['default'].createElement("path", {
        d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
      }));

    case 'ccw':
      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement("polyline", {
        points: "1 4 1 10 7 10"
      }), /*#__PURE__*/React__default['default'].createElement("path", {
        d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
      }));

    default:
      throw new Error("invalid direction. Valid options are 'cw', 'ccw'");
  }
};

var Rotate = function Rotate(_ref) {
  var direction = _ref.direction,
      props = _objectWithoutProperties(_ref, ["direction"]);

  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "rotate-", direction), svgFor$1(direction));
};

var Save = function Save(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "save"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "17 21 17 13 7 13 7 21"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "7 3 7 8 15 8"
  }));
};

var Search = function Search(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "search"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  }));
};

var Settings = function Settings(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "settings"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
  }));
};

var Share = function Share(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "share"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "18",
    cy: "5",
    r: "3"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "6",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "18",
    cy: "19",
    r: "3"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "8.59",
    y1: "13.51",
    x2: "15.42",
    y2: "17.49"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "15.41",
    y1: "6.51",
    x2: "8.59",
    y2: "10.49"
  }));
};

var Slash = function Slash(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "slash"), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "4.93",
    y1: "4.93",
    x2: "19.07",
    y2: "19.07"
  }));
};

var Sort = function Sort(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "sort"), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "10 6 6 2 2 6"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "6",
    y1: "2",
    x2: "6",
    y2: "18"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "22 18 18 22 14 18"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "18",
    y1: "22",
    x2: "18",
    y2: "6"
  }));
};

var Star = function Star(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "star"), /*#__PURE__*/React__default['default'].createElement("polygon", {
    points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
  }));
};

var pathFor$1 = function pathFor(direction) {
  switch (direction) {
    case 'up':
      return 'M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3';

    case 'down':
      return 'M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17';

    default:
      throw new Error('invalid direction. Supported values are ["up", "down"]');
  }
};

var Thumb = function Thumb(_ref) {
  var direction = _ref.direction,
      props = _objectWithoutProperties(_ref, ["direction"]);

  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "thumbs-", direction), /*#__PURE__*/React__default['default'].createElement("path", {
    d: pathFor$1(direction)
  }));
};

var Trash = function Trash(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "trash"), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "3 6 5 6 21 6"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "10",
    y1: "11",
    x2: "10",
    y2: "17"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "14",
    y1: "11",
    x2: "14",
    y2: "17"
  }));
};

var Upload = function Upload(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "upload"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /*#__PURE__*/React__default['default'].createElement("polyline", {
    points: "17 8 12 3 7 8"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "15"
  }));
};

var User = function User(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "user"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  }));
};

var UserPlus = function UserPlus(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "user-plus"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "8.5",
    cy: "7",
    r: "4"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "20",
    y1: "8",
    x2: "20",
    y2: "14"
  }), /*#__PURE__*/React__default['default'].createElement("line", {
    x1: "23",
    y1: "11",
    x2: "17",
    y2: "11"
  }));
};

var Users = function Users(props) {
  return /*#__PURE__*/React__default['default'].createElement(FeatherSVG, props, /*#__PURE__*/React__default['default'].createElement("title", null, "users"), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "9",
    cy: "7",
    r: "4"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M23 21v-2a4 4 0 0 0-3-3.87"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var SVGIconV2 = /*#__PURE__*/createStyled(SVGIconWithDefaults, {
  target: "eo2ba600",
  label: "SVGIconV2"
})( true ? {
  name: "n1nkg7",
  styles: "fill:initial;stroke:initial;"
} : {
  name: "n1nkg7",
  styles: "fill:initial;stroke:initial;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNWR0ljb25WMi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHaUMiLCJmaWxlIjoiU1ZHSWNvblYyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgU1ZHSWNvbiBmcm9tICcuLi9TVkdJY29uJ1xuXG5jb25zdCBTVkdJY29uVjIgPSBzdHlsZWQoU1ZHSWNvbilgXG4gIGZpbGw6IGluaXRpYWw7XG4gIHN0cm9rZTogaW5pdGlhbDtcbmBcbmV4cG9ydCBkZWZhdWx0IFNWR0ljb25WMlxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});

var AlertCircleV2 = function AlertCircleV2(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'alert-circle' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, props, /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",
    fill: "#16263B"
  }));
};

var AppSelect = function AppSelect(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'app-select' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, props, /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z",
    fill: "#16263B"
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$1 =  true ? {
  name: "1qx34im",
  styles: "transform:rotate(90deg);"
} : {
  name: "1qx34im",
  styles: "transform:rotate(90deg);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZXZyb25JY29uVjIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUWdCIiwiZmlsZSI6IkNoZXZyb25JY29uVjIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgU1ZHSWNvblYyIGZyb20gJy4vU1ZHSWNvblYyJ1xuXG5jb25zdCBkaXJlY3Rpb25Dc3MgPSAoeyBkaXJlY3Rpb24gfSkgPT4ge1xuICBzd2l0Y2ggKGRpcmVjdGlvbikge1xuICAgIGNhc2UgJ2xlZnQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpO1xuICAgICAgYFxuICAgIGNhc2UgJ3VwJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHRyYW5zZm9ybTogcm90YXRlKDE4MGRlZyk7XG4gICAgICBgXG4gICAgY2FzZSAncmlnaHQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdHJhbnNmb3JtOiByb3RhdGUoMjcwZGVnKTtcbiAgICAgIGBcbiAgICBjYXNlICdkb3duJzpcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIG51bGxcbiAgfVxufVxuXG5jb25zdCBSb3RhdGVkU3ZnID0gc3R5bGVkKFNWR0ljb25WMilgXG4gICR7ZGlyZWN0aW9uQ3NzfTtcbmBcblxuY29uc3QgQ2hldnJvbiA9ICh7IHRpdGxlID0gJ2NoZXZyb24nLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxSb3RhdGVkU3ZnIHsuLi5wcm9wc30gdmlld0JveD1cIjAgMCA4IDZcIiBzaXplPVwiOHB4XCI+XG4gICAgPHRpdGxlPnt0aXRsZX08L3RpdGxlPlxuICAgIDxwYXRoIGQ9XCJNNy4wNiAwLjcyNjY4NUw0IDMuNzgwMDJMMC45NCAwLjcyNjY4NUwwIDEuNjY2NjhMNCA1LjY2NjY4TDggMS42NjY2OEw3LjA2IDAuNzI2Njg1WlwiIC8+XG4gIDwvUm90YXRlZFN2Zz5cbilcblxuZXhwb3J0IGRlZmF1bHQgQ2hldnJvblxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

var _ref2 =  true ? {
  name: "4ky835",
  styles: "transform:rotate(180deg);"
} : {
  name: "4ky835",
  styles: "transform:rotate(180deg);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZXZyb25JY29uVjIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWWdCIiwiZmlsZSI6IkNoZXZyb25JY29uVjIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgU1ZHSWNvblYyIGZyb20gJy4vU1ZHSWNvblYyJ1xuXG5jb25zdCBkaXJlY3Rpb25Dc3MgPSAoeyBkaXJlY3Rpb24gfSkgPT4ge1xuICBzd2l0Y2ggKGRpcmVjdGlvbikge1xuICAgIGNhc2UgJ2xlZnQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdHJhbnNmb3JtOiByb3RhdGUoOTBkZWcpO1xuICAgICAgYFxuICAgIGNhc2UgJ3VwJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHRyYW5zZm9ybTogcm90YXRlKDE4MGRlZyk7XG4gICAgICBgXG4gICAgY2FzZSAncmlnaHQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdHJhbnNmb3JtOiByb3RhdGUoMjcwZGVnKTtcbiAgICAgIGBcbiAgICBjYXNlICdkb3duJzpcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIG51bGxcbiAgfVxufVxuXG5jb25zdCBSb3RhdGVkU3ZnID0gc3R5bGVkKFNWR0ljb25WMilgXG4gICR7ZGlyZWN0aW9uQ3NzfTtcbmBcblxuY29uc3QgQ2hldnJvbiA9ICh7IHRpdGxlID0gJ2NoZXZyb24nLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxSb3RhdGVkU3ZnIHsuLi5wcm9wc30gdmlld0JveD1cIjAgMCA4IDZcIiBzaXplPVwiOHB4XCI+XG4gICAgPHRpdGxlPnt0aXRsZX08L3RpdGxlPlxuICAgIDxwYXRoIGQ9XCJNNy4wNiAwLjcyNjY4NUw0IDMuNzgwMDJMMC45NCAwLjcyNjY4NUwwIDEuNjY2NjhMNCA1LjY2NjY4TDggMS42NjY2OEw3LjA2IDAuNzI2Njg1WlwiIC8+XG4gIDwvUm90YXRlZFN2Zz5cbilcblxuZXhwb3J0IGRlZmF1bHQgQ2hldnJvblxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

var _ref3 =  true ? {
  name: "jbc4oa",
  styles: "transform:rotate(270deg);"
} : {
  name: "jbc4oa",
  styles: "transform:rotate(270deg);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZXZyb25JY29uVjIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0JnQiIsImZpbGUiOiJDaGV2cm9uSWNvblYyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IFNWR0ljb25WMiBmcm9tICcuL1NWR0ljb25WMidcblxuY29uc3QgZGlyZWN0aW9uQ3NzID0gKHsgZGlyZWN0aW9uIH0pID0+IHtcbiAgc3dpdGNoIChkaXJlY3Rpb24pIHtcbiAgICBjYXNlICdsZWZ0JzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHRyYW5zZm9ybTogcm90YXRlKDkwZGVnKTtcbiAgICAgIGBcbiAgICBjYXNlICd1cCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB0cmFuc2Zvcm06IHJvdGF0ZSgxODBkZWcpO1xuICAgICAgYFxuICAgIGNhc2UgJ3JpZ2h0JzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHRyYW5zZm9ybTogcm90YXRlKDI3MGRlZyk7XG4gICAgICBgXG4gICAgY2FzZSAnZG93bic6XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBudWxsXG4gIH1cbn1cblxuY29uc3QgUm90YXRlZFN2ZyA9IHN0eWxlZChTVkdJY29uVjIpYFxuICAke2RpcmVjdGlvbkNzc307XG5gXG5cbmNvbnN0IENoZXZyb24gPSAoeyB0aXRsZSA9ICdjaGV2cm9uJywgLi4ucHJvcHMgfSkgPT4gKFxuICA8Um90YXRlZFN2ZyB7Li4ucHJvcHN9IHZpZXdCb3g9XCIwIDAgOCA2XCIgc2l6ZT1cIjhweFwiPlxuICAgIDx0aXRsZT57dGl0bGV9PC90aXRsZT5cbiAgICA8cGF0aCBkPVwiTTcuMDYgMC43MjY2ODVMNCAzLjc4MDAyTDAuOTQgMC43MjY2ODVMMCAxLjY2NjY4TDQgNS42NjY2OEw4IDEuNjY2NjhMNy4wNiAwLjcyNjY4NVpcIiAvPlxuICA8L1JvdGF0ZWRTdmc+XG4pXG5cbmV4cG9ydCBkZWZhdWx0IENoZXZyb25cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
};

var directionCss = function directionCss(_ref4) {
  var direction = _ref4.direction;

  switch (direction) {
    case 'left':
      return _ref$1;

    case 'up':
      return _ref2;

    case 'right':
      return _ref3;

    case 'down':
    default:
      return null;
  }
};

var RotatedSvg = /*#__PURE__*/createStyled(SVGIconV2, {
  target: "ebszsgg0",
  label: "RotatedSvg"
})(directionCss, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZXZyb25JY29uVjIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeUJvQyIsImZpbGUiOiJDaGV2cm9uSWNvblYyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IFNWR0ljb25WMiBmcm9tICcuL1NWR0ljb25WMidcblxuY29uc3QgZGlyZWN0aW9uQ3NzID0gKHsgZGlyZWN0aW9uIH0pID0+IHtcbiAgc3dpdGNoIChkaXJlY3Rpb24pIHtcbiAgICBjYXNlICdsZWZ0JzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHRyYW5zZm9ybTogcm90YXRlKDkwZGVnKTtcbiAgICAgIGBcbiAgICBjYXNlICd1cCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB0cmFuc2Zvcm06IHJvdGF0ZSgxODBkZWcpO1xuICAgICAgYFxuICAgIGNhc2UgJ3JpZ2h0JzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHRyYW5zZm9ybTogcm90YXRlKDI3MGRlZyk7XG4gICAgICBgXG4gICAgY2FzZSAnZG93bic6XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBudWxsXG4gIH1cbn1cblxuY29uc3QgUm90YXRlZFN2ZyA9IHN0eWxlZChTVkdJY29uVjIpYFxuICAke2RpcmVjdGlvbkNzc307XG5gXG5cbmNvbnN0IENoZXZyb24gPSAoeyB0aXRsZSA9ICdjaGV2cm9uJywgLi4ucHJvcHMgfSkgPT4gKFxuICA8Um90YXRlZFN2ZyB7Li4ucHJvcHN9IHZpZXdCb3g9XCIwIDAgOCA2XCIgc2l6ZT1cIjhweFwiPlxuICAgIDx0aXRsZT57dGl0bGV9PC90aXRsZT5cbiAgICA8cGF0aCBkPVwiTTcuMDYgMC43MjY2ODVMNCAzLjc4MDAyTDAuOTQgMC43MjY2ODVMMCAxLjY2NjY4TDQgNS42NjY2OEw4IDEuNjY2NjhMNy4wNiAwLjcyNjY4NVpcIiAvPlxuICA8L1JvdGF0ZWRTdmc+XG4pXG5cbmV4cG9ydCBkZWZhdWx0IENoZXZyb25cbiJdfQ== */"));

var Chevron$1 = function Chevron(_ref5) {
  var _ref5$title = _ref5.title,
      title = _ref5$title === void 0 ? 'chevron' : _ref5$title,
      props = _objectWithoutProperties(_ref5, ["title"]);

  return /*#__PURE__*/React__default['default'].createElement(RotatedSvg, _extends({}, props, {
    viewBox: "0 0 8 6",
    size: "8px"
  }), /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M7.06 0.726685L4 3.78002L0.94 0.726685L0 1.66668L4 5.66668L8 1.66668L7.06 0.726685Z"
  }));
};

var BellFill = function BellFill(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'bell-fill' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, props, /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z"
  }));
};

var ExternalLinkIconV2 = function ExternalLinkIconV2(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'external-link' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, props, /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
  }));
};

var HelpIconV2 = function HelpIconV2(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'help-icon' : _ref$title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, props, /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",
    fill: "#16263B"
  }));
};

var QuestionMarkCircleIcon = function QuestionMarkCircleIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'question-mark-circle' : _ref$title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 20 20' : _ref$viewBox,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '1.25rem' : _ref$size,
      props = _objectWithoutProperties(_ref, ["title", "viewBox", "size"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, _extends({
    viewBox: viewBox,
    size: size
  }, props), /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z"
  }));
};

var Bell = function Bell(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'bell' : _ref$title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 40 40' : _ref$viewBox,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '2.5rem' : _ref$size,
      props = _objectWithoutProperties(_ref, ["title", "viewBox", "size"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, _extends({
    viewBox: viewBox,
    size: size
  }, props), /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20 30C21.1 30 22 29.1 22 28H18C18 29.1 18.9 30 20 30ZM26 24V19C26 15.93 24.37 13.36 21.5 12.68V12C21.5 11.17 20.83 10.5 20 10.5C19.17 10.5 18.5 11.17 18.5 12V12.68C15.64 13.36 14 15.92 14 19V24L12 26V27H28V26L26 24ZM24 25H16V19C16 16.52 17.51 14.5 20 14.5C22.49 14.5 24 16.52 24 19V25Z"
  }));
};

var COLORS = {
  success: 'lightGreen',
  error: 'lightRed',
  warning: 'lightOrange',
  info: 'lightBlue'
};

var Container = createStyled("div", {
  target: "ezofa9h0",
  label: "Container"
})("display:flex;align-items:center;color:", color('slate'), ";background:", function (_ref) {
  var kind = _ref.kind,
      theme = _ref.theme;
  return color(COLORS[kind], {
    theme: theme
  });
}, ";", padding('xs'), ";", borderRadius('sm'), ";svg{margin-right:", spacer(3), ";vertical-align:middle;width:1.5rem;height:1.5rem;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzcGFjZXIsIHBhZGRpbmcgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IENPTE9SUyA9IHtcbiAgc3VjY2VzczogJ2xpZ2h0R3JlZW4nLFxuICBlcnJvcjogJ2xpZ2h0UmVkJyxcbiAgd2FybmluZzogJ2xpZ2h0T3JhbmdlJyxcbiAgaW5mbzogJ2xpZ2h0Qmx1ZSdcbn1cblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgY29sb3I6ICR7Y29sb3IoJ3NsYXRlJyl9O1xuICBiYWNrZ3JvdW5kOiAkeyh7IGtpbmQsIHRoZW1lIH0pID0+IGNvbG9yKENPTE9SU1traW5kXSwgeyB0aGVtZSB9KX07XG5cbiAgJHtwYWRkaW5nKCd4cycpfTtcbiAgJHtib3JkZXJSYWRpdXMoJ3NtJyl9O1xuXG4gIHN2ZyB7XG4gICAgbWFyZ2luLXJpZ2h0OiAke3NwYWNlcigzKX07XG4gICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICB3aWR0aDogMS41cmVtO1xuICAgIGhlaWdodDogMS41cmVtO1xuICB9XG5gXG5cbkNvbnRhaW5lci5kaXNwbGF5TmFtZSA9ICdBbGVydC5Db250YWluZXInXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */"));

Container.displayName = 'Alert.Container';

var Icon = function Icon(_ref) {
  var kind = _ref.kind;

  switch (kind) {
    case 'error':
      return /*#__PURE__*/React__default['default'].createElement(AlertCircle, {
        color: "red"
      });

    case 'info':
      return /*#__PURE__*/React__default['default'].createElement(Info, {
        color: "blue"
      });

    case 'success':
      return /*#__PURE__*/React__default['default'].createElement(CheckCircle, {
        color: "green"
      });

    case 'warning':
      return /*#__PURE__*/React__default['default'].createElement(AlertTriangle, {
        color: "orange"
      });

    default:
      return null;
  }
};

Icon.displayName = 'Alert.Icon';

var Message = createStyled("span", {
  target: "eya5dlj0",
  label: "Message"
})(typography('body2Medium'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lc3NhZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRzJCIiwiZmlsZSI6Ik1lc3NhZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IHR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IE1lc3NhZ2UgPSBzdHlsZWQuc3BhbmBcbiAgJHt0eXBvZ3JhcGh5KCdib2R5Mk1lZGl1bScpfTtcbmBcblxuTWVzc2FnZS5kaXNwbGF5TmFtZSA9ICdBbGVydC5NZXNzYWdlJ1xuXG5leHBvcnQgZGVmYXVsdCBNZXNzYWdlXG4iXX0= */"));

Message.displayName = 'Alert.Message';

var Alert = function Alert(_ref) {
  var className = _ref.className,
      kind = _ref.kind,
      message = _ref.message,
      hideIcon = _ref.hideIcon;
  return /*#__PURE__*/React__default['default'].createElement(Container, {
    className: className,
    kind: kind,
    role: "alert"
  }, !hideIcon && /*#__PURE__*/React__default['default'].createElement(Icon, {
    kind: kind
  }), /*#__PURE__*/React__default['default'].createElement(Message, null, message));
};

var size$1 = function size(_ref) {
  var size = _ref.size,
      theme = _ref.theme;

  switch (size) {
    case 'lg':
      return /*#__PURE__*/core.css("right:", spacer(4, {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFnQiIsImZpbGUiOiJDYXJldC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCBDYXJldEljb24gZnJvbSAnLi4vaWNvbnMvQ2FyZXQnXG5pbXBvcnQgeyBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHJpZ2h0OiAke3NwYWNlcig0LCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgcmlnaHQ6ICR7c3BhY2VyKDMsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IENhcmV0ID0gc3R5bGVkKENhcmV0SWNvbilgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcbiAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG5cbiAgJHtzaXplfTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgQ2FyZXRcbiJdfQ== */"));

    default:
      return /*#__PURE__*/core.css("right:", spacer(3, {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVlnQiIsImZpbGUiOiJDYXJldC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCBDYXJldEljb24gZnJvbSAnLi4vaWNvbnMvQ2FyZXQnXG5pbXBvcnQgeyBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHJpZ2h0OiAke3NwYWNlcig0LCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgcmlnaHQ6ICR7c3BhY2VyKDMsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IENhcmV0ID0gc3R5bGVkKENhcmV0SWNvbilgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcbiAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG5cbiAgJHtzaXplfTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgQ2FyZXRcbiJdfQ== */"));
  }
};

var Caret$1 = /*#__PURE__*/createStyled(Caret, {
  target: "e146npfq0",
  label: "Caret"
})("position:absolute;top:50%;transform:translateY(-50%);pointer-events:none;", size$1, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcmV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCK0IiLCJmaWxlIjoiQ2FyZXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgQ2FyZXRJY29uIGZyb20gJy4uL2ljb25zL0NhcmV0J1xuaW1wb3J0IHsgc3BhY2VyIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBzaXplID0gKHsgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdsZyc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICByaWdodDogJHtzcGFjZXIoNCwgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHJpZ2h0OiAke3NwYWNlcigzLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBDYXJldCA9IHN0eWxlZChDYXJldEljb24pYFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHRvcDogNTAlO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gIHBvaW50ZXItZXZlbnRzOiBub25lO1xuXG4gICR7c2l6ZX07XG5gXG5cbmV4cG9ydCBkZWZhdWx0IENhcmV0XG4iXX0= */"));

var Container$1 = createStyled("div", {
  target: "e107w2xj0",
  label: "Container"
})("position:relative;width:", function (_ref) {
  var width = _ref.width;
  return width;
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgd2lkdGg6ICR7KHsgd2lkdGggfSkgPT4gd2lkdGh9O1xuYFxuXG5Db250YWluZXIuZGlzcGxheU5hbWUgPSAnRHJvcGRvd24uQ29udGFpbmVyJ1xuXG5Db250YWluZXIuZGVmYXVsdFByb3BzID0ge1xuICB3aWR0aDogJ2F1dG8nXG59XG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */"));

Container$1.displayName = 'Dropdown.Container';
Container$1.defaultProps = {
  width: 'auto'
};

var size$2 = function size(_ref) {
  var size = _ref.size,
      theme = _ref.theme;

  switch (size) {
    case 'lg':
      return /*#__PURE__*/core.css(typography('body3', {
        theme: theme
      }), ";", padding('xs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    default:
      return /*#__PURE__*/core.css(typography('body2', {
        theme: theme
      }), ";", padding('xxs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  }
};

var kind = function kind(_ref2) {
  var kind = _ref2.kind,
      theme = _ref2.theme,
      valid = _ref2.valid;

  switch (kind) {
    case 'ghost':
      return /*#__PURE__*/core.css("border:none;color:", color('pewter', {
        theme: theme
      }), ";", fontWeight('medium', {
        theme: theme
      }), ";&:hover{background-color:", transparentize('slate', 0.08, {
        theme: theme
      }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    default:
      return /*#__PURE__*/core.css("border:1px solid ", color(valid ? 'silver' : 'red', {
        theme: theme
      }), ";[aria-expanded='true'] &{border:1px solid ", color('slate', {
        theme: theme
      }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  }
};

var Input = createStyled("input", {
  target: "euyrevo0",
  label: "Input"
})("width:100%;transition:all 0.3s ease 0s;outline-color:", color('slate'), ";", borderRadius('default'), ";", typography('body2'), ";", size$2, ";", kind, ";[aria-expanded='true'] &{color:", color('white'), ";background-color:", color('slate'), ";outline:none;&::placeholder{color:", color('white'), ";}}&:active{border-color:", color('slate'), ";}&:focus{outline-color:", color('slate'), ";outline-offset:-2px;}&:not([disabled]){cursor:pointer;&:focus{cursor:text;}}&[disabled]{cursor:not-allowed;color:", color('cadet'), ";background:", color('offWhite'), ";border:1px solid ", color('paleGrey'), ";}&::placeholder{color:", color('cadet'), ";opacity:1;", fontWeight('regular'), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var InputContainer = createStyled("div", {
  target: "eltkgwi0",
  label: "InputContainer"
})( true ? {
  name: "79elbk",
  styles: "position:relative;"
} : {
  name: "79elbk",
  styles: "position:relative;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0Q29udGFpbmVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVpQyIsImZpbGUiOiJJbnB1dENvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5jb25zdCBJbnB1dENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgSW5wdXRDb250YWluZXJcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

var stopStart = function stopStart(_ref) {
  var dark = _ref.dark,
      size = _ref.size,
      theme = _ref.theme;

  switch (size) {
    case 'sm':
      return {
        stopColor: color(dark ? 'white' : 'pewter', {
          theme: theme
        })
      };

    default:
      return {
        stopColor: gradientEnd('green', {
          theme: theme
        })
      };
  }
};

var stopEnd = function stopEnd(_ref2) {
  var dark = _ref2.dark,
      size = _ref2.size,
      theme = _ref2.theme;

  switch (size) {
    case 'sm':
      return {
        stopColor: color(dark ? 'white' : 'pewter', {
          theme: theme
        }),
        stopOpacity: 0.75
      };

    default:
      return {
        stopColor: gradientStart('green', {
          theme: theme
        })
      };
  }
};

var properties = function properties(bar) {
  return bar ? {
    x1: '0%',
    y1: '0%',
    x2: '100%',
    y2: '0%',
    gradientUnits: 'userSpaceOnUse'
  } : {
    x1: '15.996%',
    y1: '100%',
    y2: '15.004%'
  };
};

var Gradient = function Gradient(_ref3) {
  var dark = _ref3.dark,
      size = _ref3.size,
      bar = _ref3.bar,
      theme = _ref3.theme,
      rest = _objectWithoutProperties(_ref3, ["dark", "size", "bar", "theme"]);

  return /*#__PURE__*/React__default['default'].createElement("linearGradient", _extends({}, properties(bar), rest), /*#__PURE__*/React__default['default'].createElement("stop", _extends({
    offset: "0%"
  }, stopStart({
    dark: dark,
    size: size,
    theme: theme
  }))), /*#__PURE__*/React__default['default'].createElement("stop", _extends({
    offset: "100%"
  }, stopEnd({
    dark: dark,
    size: size,
    theme: theme
  }))));
};

Gradient.displayName = 'Loader.Gradient';

var dimensions = function dimensions(_ref) {
  var size = _ref.size,
      bar = _ref.bar;

  if (bar) {
    return {
      preserveAspectRatio: 'none',
      width: '100%'
    };
  }

  switch (size) {
    case 'sm':
      return {
        width: 24,
        height: 24
      };

    case 'lg':
      return {
        width: 56,
        height: 56
      };

    default:
      return {
        width: 36,
        height: 36
      };
  }
};

var viewBox = function viewBox(bar) {
  return bar ? '0 0 100 1' : '0 0 36 36';
};

var SVG = function SVG(_ref2) {
  var children = _ref2.children,
      size = _ref2.size,
      bar = _ref2.bar,
      props = _objectWithoutProperties(_ref2, ["children", "size", "bar"]);

  return /*#__PURE__*/React__default['default'].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: viewBox(bar)
  }, dimensions({
    size: size,
    bar: bar
  }), props), children);
};

SVG.displayName = 'Loader.SVG';

var BarRail = function BarRail(props) {
  return /*#__PURE__*/React__default['default'].createElement("path", _extends({
    d: "M 0,0.5 L 100,0.5",
    strokeWidth: "1"
  }, props));
};

var RadialRail = function RadialRail(props) {
  return /*#__PURE__*/React__default['default'].createElement("circle", _extends({
    cx: "18",
    cy: "18",
    r: "16.5",
    strokeWidth: "3"
  }, props));
};

var Rail = function Rail(_ref) {
  var dark = _ref.dark,
      size = _ref.size,
      bar = _ref.bar,
      theme = _ref.theme;
  var props = {};

  if (size === 'sm') {
    props.stroke = color(dark ? 'white' : 'pewter', {
      theme: theme
    });
    props.opacity = 0.3;
  } else {
    props.stroke = color(dark ? 'slate' : 'paleGrey', {
      theme: theme
    });
  }

  return bar ? /*#__PURE__*/React__default['default'].createElement(BarRail, props) : /*#__PURE__*/React__default['default'].createElement(RadialRail, props);
};

Rail.displayName = 'Loader.Rail';

var Indefinite = function Indefinite(_ref) {
  var bar = _ref.bar,
      rest = _objectWithoutProperties(_ref, ["bar"]);

  return bar ? /*#__PURE__*/React__default['default'].createElement("path", _extends({
    d: "M 0,0.5 L 100,0.5",
    strokeWidth: "3"
  }, rest), /*#__PURE__*/React__default['default'].createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "translate",
    dur: "1.2s",
    values: "0,0.5; 25,0.5; 100,0.5",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React__default['default'].createElement("animateTransform", {
    attributeType: "xml",
    attributeName: "transform",
    type: "scale",
    dur: "1.2s",
    values: "0.1;0.75;0.1",
    repeatCount: "indefinite",
    additive: "sum"
  })) : /*#__PURE__*/React__default['default'].createElement("path", _extends({
    d: "M 18,18 m 0,-16.5 a 16.5,16.5 0 1 1 0,33",
    strokeWidth: "3"
  }, rest), /*#__PURE__*/React__default['default'].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "1.4s",
    repeatCount: "indefinite",
    from: "0 18 18",
    to: "360 18 18"
  }));
};

var radialLength = 104;

var Percentage = function Percentage(_ref) {
  var bar = _ref.bar,
      percentage = _ref.percentage,
      rest = _objectWithoutProperties(_ref, ["bar", "percentage"]);

  var ratio = percentage / 100;
  var dashLength = bar ? 100 : radialLength;
  var path = bar ? 'M 0,0.5 L 100,0.5' : 'M 18,18 m 0,-16.5 a 16.5,16.5 0 1 1 0,33 a 16.5,16.5 0 1 1 0,-33';
  return /*#__PURE__*/React__default['default'].createElement("path", _extends({
    d: path,
    strokeWidth: "3",
    strokeDasharray: dashLength,
    strokeDashoffset: dashLength - dashLength * ratio
  }, rest));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var LoaderImage = function LoaderImage(_ref) {
  var dark = _ref.dark,
      theme = _ref.theme,
      size = _ref.size,
      bar = _ref.bar,
      _ref$percentage = _ref.percentage,
      percentage = _ref$percentage === void 0 ? null : _ref$percentage,
      props = _objectWithoutProperties(_ref, ["dark", "theme", "size", "bar", "percentage"]);

  return /*#__PURE__*/React__default['default'].createElement(SVG, _extends({
    size: size,
    bar: bar,
    role: "img"
  }, props), /*#__PURE__*/React__default['default'].createElement(Gradient, {
    id: "gradient",
    dark: dark,
    size: size,
    bar: bar,
    theme: theme
  }), /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React__default['default'].createElement(Rail, {
    theme: theme,
    dark: dark,
    size: size,
    bar: bar
  }), percentage !== null ? /*#__PURE__*/React__default['default'].createElement(Percentage, {
    stroke: "url(#gradient)",
    bar: bar,
    percentage: percentage
  }) : /*#__PURE__*/React__default['default'].createElement(Indefinite, {
    stroke: "url(#gradient)",
    bar: bar
  })));
};

var CenteredContainer = createStyled("div", {
  target: "edi01n60",
  label: "CenteredContainer"
})( true ? {
  name: "r20d3a",
  styles: "height:100%;display:flex;align-items:center;justify-content:center;"
} : {
  name: "r20d3a",
  styles: "height:100%;display:flex;align-items:center;justify-content:center;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdDb0MiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBodHRwczovL3dhcHAtZnZ1YXRsaXZlc3R5bGVndWlkZS1jdXMtdHN0LmF6dXJld2Vic2l0ZXMubmV0LzE0LWxvYWRpbmcuaHRtbFxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyB3aXRoVGhlbWUgfSBmcm9tICdlbW90aW9uLXRoZW1pbmcnXG5pbXBvcnQgR3JhZGllbnQgZnJvbSAnLi9HcmFkaWVudCdcbmltcG9ydCBTVkcgZnJvbSAnLi9TVkcnXG5pbXBvcnQgUmFpbCBmcm9tICcuL1JhaWwnXG5pbXBvcnQgSW5kZWZpbml0ZSBmcm9tICcuL0luZGVmaW5pdGUnXG5pbXBvcnQgUGVyY2VudGFnZSBmcm9tICcuL1BlcmNlbnRhZ2UnXG5pbXBvcnQgeyBjb2xvciwgZ3JhZGllbnRTdGFydCwgZ3JhZGllbnRFbmQgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IExvYWRlckltYWdlID0gKHtcbiAgZGFyayxcbiAgdGhlbWUsXG4gIHNpemUsXG4gIGJhcixcbiAgcGVyY2VudGFnZSA9IG51bGwsXG4gIC4uLnByb3BzXG59KSA9PiAoXG4gIDxTVkcgc2l6ZT17c2l6ZX0gYmFyPXtiYXJ9IHJvbGU9XCJpbWdcIiBkYXRhLXRlc3RpZD1cImxvYWRlclwiIHsuLi5wcm9wc30+XG4gICAgPEdyYWRpZW50IGlkPVwiZ3JhZGllbnRcIiBkYXJrPXtkYXJrfSBzaXplPXtzaXplfSBiYXI9e2Jhcn0gdGhlbWU9e3RoZW1lfSAvPlxuICAgIDxnIGZpbGw9XCJub25lXCI+XG4gICAgICA8UmFpbCB0aGVtZT17dGhlbWV9IGRhcms9e2Rhcmt9IHNpemU9e3NpemV9IGJhcj17YmFyfSAvPlxuICAgICAge3BlcmNlbnRhZ2UgIT09IG51bGwgPyAoXG4gICAgICAgIDxQZXJjZW50YWdlIHN0cm9rZT1cInVybCgjZ3JhZGllbnQpXCIgYmFyPXtiYXJ9IHBlcmNlbnRhZ2U9e3BlcmNlbnRhZ2V9IC8+XG4gICAgICApIDogKFxuICAgICAgICA8SW5kZWZpbml0ZSBzdHJva2U9XCJ1cmwoI2dyYWRpZW50KVwiIGJhcj17YmFyfSAvPlxuICAgICAgKX1cbiAgICA8L2c+XG4gIDwvU1ZHPlxuKVxuXG5jb25zdCBDZW50ZXJlZENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGhlaWdodDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5gXG5cbmNvbnN0IExvYWRlciA9ICh7IGNlbnRlcmVkLCAuLi5wcm9wcyB9KSA9PlxuICBjZW50ZXJlZCA/IChcbiAgICA8Q2VudGVyZWRDb250YWluZXI+XG4gICAgICA8TG9hZGVySW1hZ2Ugey4uLnByb3BzfSAvPlxuICAgIDwvQ2VudGVyZWRDb250YWluZXI+XG4gICkgOiAoXG4gICAgPExvYWRlckltYWdlIHsuLi5wcm9wc30gLz5cbiAgKVxuXG5leHBvcnQgZGVmYXVsdCB3aXRoVGhlbWUoTG9hZGVyKVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});

var Loader = function Loader(_ref2) {
  var centered = _ref2.centered,
      props = _objectWithoutProperties(_ref2, ["centered"]);

  return centered ? /*#__PURE__*/React__default['default'].createElement(CenteredContainer, null, /*#__PURE__*/React__default['default'].createElement(LoaderImage, props)) : /*#__PURE__*/React__default['default'].createElement(LoaderImage, props);
};

var Loader$1 = emotionTheming.withTheme(Loader);

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$2 =  true ? {
  name: "1rgczi2",
  styles: "width:24px;height:24px;right:2.5rem;"
} : {
  name: "1rgczi2",
  styles: "width:24px;height:24px;right:2.5rem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTZ0IiLCJmaWxlIjoiTG9hZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IExvYWRlciBmcm9tICcuLi9Mb2FkZXInXG5pbXBvcnQgeyB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnXG5cbmNvbnN0IHNpemUgPSAoeyBsb2FkZXJTaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAobG9hZGVyU2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHdpZHRoOiAyNHB4O1xuICAgICAgICBoZWlnaHQ6IDI0cHg7XG4gICAgICAgIHJpZ2h0OiAyLjVyZW07XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHdpZHRoOiAyMHB4O1xuICAgICAgICBoZWlnaHQ6IDIwcHg7XG4gICAgICAgIHJpZ2h0OiAycmVtO1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IEF1dG9jb21wbGV0ZUxvYWRlciA9IHN0eWxlZCgoeyBsb2FkZXJTaXplLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxMb2FkZXIgey4uLnByb3BzfSAvPlxuKSlgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcblxuICAke3NpemV9O1xuYFxuXG5leHBvcnQgZGVmYXVsdCB3aXRoUHJvcHMoKHsgc2l6ZSB9KSA9PiAoeyBsb2FkZXJTaXplOiBzaXplLCBzaXplOiAnc20nIH0pKShcbiAgQXV0b2NvbXBsZXRlTG9hZGVyXG4pXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
};

var _ref2$1 =  true ? {
  name: "1it4r02",
  styles: "width:20px;height:20px;right:2rem;"
} : {
  name: "1it4r02",
  styles: "width:20px;height:20px;right:2rem;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFlZ0IiLCJmaWxlIjoiTG9hZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IExvYWRlciBmcm9tICcuLi9Mb2FkZXInXG5pbXBvcnQgeyB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnXG5cbmNvbnN0IHNpemUgPSAoeyBsb2FkZXJTaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAobG9hZGVyU2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHdpZHRoOiAyNHB4O1xuICAgICAgICBoZWlnaHQ6IDI0cHg7XG4gICAgICAgIHJpZ2h0OiAyLjVyZW07XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHdpZHRoOiAyMHB4O1xuICAgICAgICBoZWlnaHQ6IDIwcHg7XG4gICAgICAgIHJpZ2h0OiAycmVtO1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IEF1dG9jb21wbGV0ZUxvYWRlciA9IHN0eWxlZCgoeyBsb2FkZXJTaXplLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxMb2FkZXIgey4uLnByb3BzfSAvPlxuKSlgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcblxuICAke3NpemV9O1xuYFxuXG5leHBvcnQgZGVmYXVsdCB3aXRoUHJvcHMoKHsgc2l6ZSB9KSA9PiAoeyBsb2FkZXJTaXplOiBzaXplLCBzaXplOiAnc20nIH0pKShcbiAgQXV0b2NvbXBsZXRlTG9hZGVyXG4pXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
};

var size$3 = function size(_ref3) {
  var loaderSize = _ref3.loaderSize,
      theme = _ref3.theme;

  switch (loaderSize) {
    case 'lg':
      return _ref$2;

    default:
      return _ref2$1;
  }
};

var AutocompleteLoader = /*#__PURE__*/createStyled(function (_ref4) {
  var loaderSize = _ref4.loaderSize,
      props = _objectWithoutProperties(_ref4, ["loaderSize"]);

  return /*#__PURE__*/React__default['default'].createElement(Loader$1, props);
}, {
  target: "eeq6p1r0",
  label: "AutocompleteLoader"
})("position:absolute;top:50%;transform:translateY(-50%);", size$3, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5QkUiLCJmaWxlIjoiTG9hZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IExvYWRlciBmcm9tICcuLi9Mb2FkZXInXG5pbXBvcnQgeyB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnXG5cbmNvbnN0IHNpemUgPSAoeyBsb2FkZXJTaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAobG9hZGVyU2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHdpZHRoOiAyNHB4O1xuICAgICAgICBoZWlnaHQ6IDI0cHg7XG4gICAgICAgIHJpZ2h0OiAyLjVyZW07XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHdpZHRoOiAyMHB4O1xuICAgICAgICBoZWlnaHQ6IDIwcHg7XG4gICAgICAgIHJpZ2h0OiAycmVtO1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IEF1dG9jb21wbGV0ZUxvYWRlciA9IHN0eWxlZCgoeyBsb2FkZXJTaXplLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxMb2FkZXIgey4uLnByb3BzfSAvPlxuKSlgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcblxuICAke3NpemV9O1xuYFxuXG5leHBvcnQgZGVmYXVsdCB3aXRoUHJvcHMoKHsgc2l6ZSB9KSA9PiAoeyBsb2FkZXJTaXplOiBzaXplLCBzaXplOiAnc20nIH0pKShcbiAgQXV0b2NvbXBsZXRlTG9hZGVyXG4pXG4iXX0= */"));

var Loader$2 = recompose.withProps(function (_ref5) {
  var size = _ref5.size;
  return {
    loaderSize: size,
    size: 'sm'
  };
})(AutocompleteLoader);

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var selectedCss = function selectedCss(_ref2) {
  var selected = _ref2.selected,
      theme = _ref2.theme;
  return selected && /*#__PURE__*/core.css("background-color:", transparentize('brandGreen', 0.15, {
    theme: theme
  }), ";", fontWeight('medium', {
    theme: theme
  }),  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYUsiLCJmaWxlIjoiSXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIHBhZGRpbmcsXG4gIHNwYWNlcixcbiAgdHJhbnNwYXJlbnRpemUsXG4gIGZvbnRXZWlnaHQsXG4gIHR5cG9ncmFwaHlcbn0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBzZWxlY3RlZENzcyA9ICh7IHNlbGVjdGVkLCB0aGVtZSB9KSA9PlxuICBzZWxlY3RlZCAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYnJhbmRHcmVlbicsIDAuMTUsIHsgdGhlbWUgfSl9O1xuICAgICR7Zm9udFdlaWdodCgnbWVkaXVtJywgeyB0aGVtZSB9KX1cbiAgYFxuXG5jb25zdCBmb2N1c2VkQ3NzID0gKHsgZm9jdXNlZCwgdGhlbWUgfSkgPT5cbiAgZm9jdXNlZCAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYnJhbmRHcmVlbicsIDAuMTUsIHsgdGhlbWUgfSl9O1xuICBgXG5cbmNvbnN0IGRpc2FibGVkQ3NzID0gKHsgZGlzYWJsZWQsIHRoZW1lIH0pID0+XG4gIGRpc2FibGVkICYmXG4gIGNzc2BcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICBjb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjQsIHsgdGhlbWUgfSl9O1xuICBgXG5cbmNvbnN0IHBvaW50ZXJDc3MgPSAoeyBwb2ludGVyIH0pID0+XG4gIHBvaW50ZXIgJiZcbiAgY3NzYFxuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgYFxuXG5jb25zdCBzaXplQ3NzID0gKHsgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdsZyc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3R5cG9ncmFwaHkoJ2JvZHkzJywgeyB0aGVtZSB9KX07XG4gICAgICAgICR7cGFkZGluZygneHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHtwYWRkaW5nKCd4eHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBJdGVtID0gc3R5bGVkKCdsaScpYFxuICBkaXNwbGF5OiBibG9jaztcbiAgcGFkZGluZzogJHtzcGFjZXIoMil9ICR7c3BhY2VyKDMpfTtcblxuICAmOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdicmFuZEdyZWVuJywgMC4xNSl9O1xuICB9XG5cbiAgJHtzZWxlY3RlZENzc31cbiAgJHtmb2N1c2VkQ3NzfVxuICAke2Rpc2FibGVkQ3NzfVxuICAke3BvaW50ZXJDc3N9XG4gICR7c2l6ZUNzc31cbmBcblxuZXhwb3J0IGRlZmF1bHQgSXRlbVxuIl19 */");
};

var focusedCss = function focusedCss(_ref3) {
  var focused = _ref3.focused,
      theme = _ref3.theme;
  return focused && /*#__PURE__*/core.css("background-color:", transparentize('brandGreen', 0.15, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0JLIiwiZmlsZSI6Ikl0ZW0uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQge1xuICBwYWRkaW5nLFxuICBzcGFjZXIsXG4gIHRyYW5zcGFyZW50aXplLFxuICBmb250V2VpZ2h0LFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2VsZWN0ZWRDc3MgPSAoeyBzZWxlY3RlZCwgdGhlbWUgfSkgPT5cbiAgc2VsZWN0ZWQgJiZcbiAgY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1LCB7IHRoZW1lIH0pfTtcbiAgICAke2ZvbnRXZWlnaHQoJ21lZGl1bScsIHsgdGhlbWUgfSl9XG4gIGBcblxuY29uc3QgZm9jdXNlZENzcyA9ICh7IGZvY3VzZWQsIHRoZW1lIH0pID0+XG4gIGZvY3VzZWQgJiZcbiAgY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1LCB7IHRoZW1lIH0pfTtcbiAgYFxuXG5jb25zdCBkaXNhYmxlZENzcyA9ICh7IGRpc2FibGVkLCB0aGVtZSB9KSA9PlxuICBkaXNhYmxlZCAmJlxuICBjc3NgXG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gICAgY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC40LCB7IHRoZW1lIH0pfTtcbiAgYFxuXG5jb25zdCBwb2ludGVyQ3NzID0gKHsgcG9pbnRlciB9KSA9PlxuICBwb2ludGVyICYmXG4gIGNzc2BcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIGBcblxuY29uc3Qgc2l6ZUNzcyA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnbGcnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHt0eXBvZ3JhcGh5KCdib2R5MycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke3BhZGRpbmcoJ3hzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7cGFkZGluZygneHhzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gIH1cbn1cblxuY29uc3QgSXRlbSA9IHN0eWxlZCgnbGknKWBcbiAgZGlzcGxheTogYmxvY2s7XG4gIHBhZGRpbmc6ICR7c3BhY2VyKDIpfSAke3NwYWNlcigzKX07XG5cbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYnJhbmRHcmVlbicsIDAuMTUpfTtcbiAgfVxuXG4gICR7c2VsZWN0ZWRDc3N9XG4gICR7Zm9jdXNlZENzc31cbiAgJHtkaXNhYmxlZENzc31cbiAgJHtwb2ludGVyQ3NzfVxuICAke3NpemVDc3N9XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEl0ZW1cbiJdfQ== */"));
};

var disabledCss = function disabledCss(_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  return disabled && /*#__PURE__*/core.css("pointer-events:none;color:", transparentize('slate', 0.4, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEJLIiwiZmlsZSI6Ikl0ZW0uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQge1xuICBwYWRkaW5nLFxuICBzcGFjZXIsXG4gIHRyYW5zcGFyZW50aXplLFxuICBmb250V2VpZ2h0LFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2VsZWN0ZWRDc3MgPSAoeyBzZWxlY3RlZCwgdGhlbWUgfSkgPT5cbiAgc2VsZWN0ZWQgJiZcbiAgY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1LCB7IHRoZW1lIH0pfTtcbiAgICAke2ZvbnRXZWlnaHQoJ21lZGl1bScsIHsgdGhlbWUgfSl9XG4gIGBcblxuY29uc3QgZm9jdXNlZENzcyA9ICh7IGZvY3VzZWQsIHRoZW1lIH0pID0+XG4gIGZvY3VzZWQgJiZcbiAgY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1LCB7IHRoZW1lIH0pfTtcbiAgYFxuXG5jb25zdCBkaXNhYmxlZENzcyA9ICh7IGRpc2FibGVkLCB0aGVtZSB9KSA9PlxuICBkaXNhYmxlZCAmJlxuICBjc3NgXG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gICAgY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC40LCB7IHRoZW1lIH0pfTtcbiAgYFxuXG5jb25zdCBwb2ludGVyQ3NzID0gKHsgcG9pbnRlciB9KSA9PlxuICBwb2ludGVyICYmXG4gIGNzc2BcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIGBcblxuY29uc3Qgc2l6ZUNzcyA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnbGcnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHt0eXBvZ3JhcGh5KCdib2R5MycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke3BhZGRpbmcoJ3hzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7cGFkZGluZygneHhzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gIH1cbn1cblxuY29uc3QgSXRlbSA9IHN0eWxlZCgnbGknKWBcbiAgZGlzcGxheTogYmxvY2s7XG4gIHBhZGRpbmc6ICR7c3BhY2VyKDIpfSAke3NwYWNlcigzKX07XG5cbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYnJhbmRHcmVlbicsIDAuMTUpfTtcbiAgfVxuXG4gICR7c2VsZWN0ZWRDc3N9XG4gICR7Zm9jdXNlZENzc31cbiAgJHtkaXNhYmxlZENzc31cbiAgJHtwb2ludGVyQ3NzfVxuICAke3NpemVDc3N9XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEl0ZW1cbiJdfQ== */"));
};

var _ref$3 =  true ? {
  name: "4g6ai3",
  styles: "cursor:pointer;"
} : {
  name: "4g6ai3",
  styles: "cursor:pointer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUNLIiwiZmlsZSI6Ikl0ZW0uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQge1xuICBwYWRkaW5nLFxuICBzcGFjZXIsXG4gIHRyYW5zcGFyZW50aXplLFxuICBmb250V2VpZ2h0LFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2VsZWN0ZWRDc3MgPSAoeyBzZWxlY3RlZCwgdGhlbWUgfSkgPT5cbiAgc2VsZWN0ZWQgJiZcbiAgY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1LCB7IHRoZW1lIH0pfTtcbiAgICAke2ZvbnRXZWlnaHQoJ21lZGl1bScsIHsgdGhlbWUgfSl9XG4gIGBcblxuY29uc3QgZm9jdXNlZENzcyA9ICh7IGZvY3VzZWQsIHRoZW1lIH0pID0+XG4gIGZvY3VzZWQgJiZcbiAgY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1LCB7IHRoZW1lIH0pfTtcbiAgYFxuXG5jb25zdCBkaXNhYmxlZENzcyA9ICh7IGRpc2FibGVkLCB0aGVtZSB9KSA9PlxuICBkaXNhYmxlZCAmJlxuICBjc3NgXG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gICAgY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC40LCB7IHRoZW1lIH0pfTtcbiAgYFxuXG5jb25zdCBwb2ludGVyQ3NzID0gKHsgcG9pbnRlciB9KSA9PlxuICBwb2ludGVyICYmXG4gIGNzc2BcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIGBcblxuY29uc3Qgc2l6ZUNzcyA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnbGcnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHt0eXBvZ3JhcGh5KCdib2R5MycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke3BhZGRpbmcoJ3hzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7cGFkZGluZygneHhzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gIH1cbn1cblxuY29uc3QgSXRlbSA9IHN0eWxlZCgnbGknKWBcbiAgZGlzcGxheTogYmxvY2s7XG4gIHBhZGRpbmc6ICR7c3BhY2VyKDIpfSAke3NwYWNlcigzKX07XG5cbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYnJhbmRHcmVlbicsIDAuMTUpfTtcbiAgfVxuXG4gICR7c2VsZWN0ZWRDc3N9XG4gICR7Zm9jdXNlZENzc31cbiAgJHtkaXNhYmxlZENzc31cbiAgJHtwb2ludGVyQ3NzfVxuICAke3NpemVDc3N9XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEl0ZW1cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
};

var pointerCss = function pointerCss(_ref5) {
  var pointer = _ref5.pointer;
  return pointer && _ref$3;
};

var sizeCss = function sizeCss(_ref6) {
  var size = _ref6.size,
      theme = _ref6.theme;

  switch (size) {
    case 'lg':
      return /*#__PURE__*/core.css(typography('body3', {
        theme: theme
      }), ";", padding('xs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0NnQiIsImZpbGUiOiJJdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHtcbiAgcGFkZGluZyxcbiAgc3BhY2VyLFxuICB0cmFuc3BhcmVudGl6ZSxcbiAgZm9udFdlaWdodCxcbiAgdHlwb2dyYXBoeVxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNlbGVjdGVkQ3NzID0gKHsgc2VsZWN0ZWQsIHRoZW1lIH0pID0+XG4gIHNlbGVjdGVkICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdicmFuZEdyZWVuJywgMC4xNSwgeyB0aGVtZSB9KX07XG4gICAgJHtmb250V2VpZ2h0KCdtZWRpdW0nLCB7IHRoZW1lIH0pfVxuICBgXG5cbmNvbnN0IGZvY3VzZWRDc3MgPSAoeyBmb2N1c2VkLCB0aGVtZSB9KSA9PlxuICBmb2N1c2VkICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdicmFuZEdyZWVuJywgMC4xNSwgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgZGlzYWJsZWRDc3MgPSAoeyBkaXNhYmxlZCwgdGhlbWUgfSkgPT5cbiAgZGlzYWJsZWQgJiZcbiAgY3NzYFxuICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgIGNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuNCwgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgcG9pbnRlckNzcyA9ICh7IHBvaW50ZXIgfSkgPT5cbiAgcG9pbnRlciAmJlxuICBjc3NgXG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICBgXG5cbmNvbnN0IHNpemVDc3MgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7dHlwb2dyYXBoeSgnYm9keTMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgJHtwYWRkaW5nKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IEl0ZW0gPSBzdHlsZWQoJ2xpJylgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwYWRkaW5nOiAke3NwYWNlcigyKX0gJHtzcGFjZXIoMyl9O1xuXG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1KX07XG4gIH1cblxuICAke3NlbGVjdGVkQ3NzfVxuICAke2ZvY3VzZWRDc3N9XG4gICR7ZGlzYWJsZWRDc3N9XG4gICR7cG9pbnRlckNzc31cbiAgJHtzaXplQ3NzfVxuYFxuXG5leHBvcnQgZGVmYXVsdCBJdGVtXG4iXX0= */"));

    default:
      return /*#__PURE__*/core.css(padding('xxs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNkNnQiIsImZpbGUiOiJJdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHtcbiAgcGFkZGluZyxcbiAgc3BhY2VyLFxuICB0cmFuc3BhcmVudGl6ZSxcbiAgZm9udFdlaWdodCxcbiAgdHlwb2dyYXBoeVxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNlbGVjdGVkQ3NzID0gKHsgc2VsZWN0ZWQsIHRoZW1lIH0pID0+XG4gIHNlbGVjdGVkICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdicmFuZEdyZWVuJywgMC4xNSwgeyB0aGVtZSB9KX07XG4gICAgJHtmb250V2VpZ2h0KCdtZWRpdW0nLCB7IHRoZW1lIH0pfVxuICBgXG5cbmNvbnN0IGZvY3VzZWRDc3MgPSAoeyBmb2N1c2VkLCB0aGVtZSB9KSA9PlxuICBmb2N1c2VkICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdicmFuZEdyZWVuJywgMC4xNSwgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgZGlzYWJsZWRDc3MgPSAoeyBkaXNhYmxlZCwgdGhlbWUgfSkgPT5cbiAgZGlzYWJsZWQgJiZcbiAgY3NzYFxuICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgIGNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuNCwgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgcG9pbnRlckNzcyA9ICh7IHBvaW50ZXIgfSkgPT5cbiAgcG9pbnRlciAmJlxuICBjc3NgXG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICBgXG5cbmNvbnN0IHNpemVDc3MgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7dHlwb2dyYXBoeSgnYm9keTMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgJHtwYWRkaW5nKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IEl0ZW0gPSBzdHlsZWQoJ2xpJylgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwYWRkaW5nOiAke3NwYWNlcigyKX0gJHtzcGFjZXIoMyl9O1xuXG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1KX07XG4gIH1cblxuICAke3NlbGVjdGVkQ3NzfVxuICAke2ZvY3VzZWRDc3N9XG4gICR7ZGlzYWJsZWRDc3N9XG4gICR7cG9pbnRlckNzc31cbiAgJHtzaXplQ3NzfVxuYFxuXG5leHBvcnQgZGVmYXVsdCBJdGVtXG4iXX0= */"));
  }
};

var Item = /*#__PURE__*/createStyled('li', {
  target: "ez8x3c80",
  label: "Item"
})("display:block;padding:", spacer(2), " ", spacer(3), ";&:hover{background-color:", transparentize('brandGreen', 0.15), ";}", selectedCss, " ", focusedCss, " ", disabledCss, " ", pointerCss, " ", sizeCss,  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUR5QiIsImZpbGUiOiJJdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHtcbiAgcGFkZGluZyxcbiAgc3BhY2VyLFxuICB0cmFuc3BhcmVudGl6ZSxcbiAgZm9udFdlaWdodCxcbiAgdHlwb2dyYXBoeVxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNlbGVjdGVkQ3NzID0gKHsgc2VsZWN0ZWQsIHRoZW1lIH0pID0+XG4gIHNlbGVjdGVkICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdicmFuZEdyZWVuJywgMC4xNSwgeyB0aGVtZSB9KX07XG4gICAgJHtmb250V2VpZ2h0KCdtZWRpdW0nLCB7IHRoZW1lIH0pfVxuICBgXG5cbmNvbnN0IGZvY3VzZWRDc3MgPSAoeyBmb2N1c2VkLCB0aGVtZSB9KSA9PlxuICBmb2N1c2VkICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdicmFuZEdyZWVuJywgMC4xNSwgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgZGlzYWJsZWRDc3MgPSAoeyBkaXNhYmxlZCwgdGhlbWUgfSkgPT5cbiAgZGlzYWJsZWQgJiZcbiAgY3NzYFxuICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgIGNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuNCwgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgcG9pbnRlckNzcyA9ICh7IHBvaW50ZXIgfSkgPT5cbiAgcG9pbnRlciAmJlxuICBjc3NgXG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICBgXG5cbmNvbnN0IHNpemVDc3MgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7dHlwb2dyYXBoeSgnYm9keTMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgJHtwYWRkaW5nKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IEl0ZW0gPSBzdHlsZWQoJ2xpJylgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICBwYWRkaW5nOiAke3NwYWNlcigyKX0gJHtzcGFjZXIoMyl9O1xuXG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JyYW5kR3JlZW4nLCAwLjE1KX07XG4gIH1cblxuICAke3NlbGVjdGVkQ3NzfVxuICAke2ZvY3VzZWRDc3N9XG4gICR7ZGlzYWJsZWRDc3N9XG4gICR7cG9pbnRlckNzc31cbiAgJHtzaXplQ3NzfVxuYFxuXG5leHBvcnQgZGVmYXVsdCBJdGVtXG4iXX0= */");

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var maxHeightCss = function maxHeightCss(_ref2) {
  var maxHeight = _ref2.maxHeight;
  return /*#__PURE__*/core.css("max-height:", maxHeight || '275px', ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFLIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHtcbiAgY29sb3IsXG4gIHNoYWRvdyxcbiAgc3BhY2VyLFxuICBib3JkZXJSYWRpdXMsXG4gIHBhZGRpbmcsXG4gIHR5cG9ncmFwaHlcbn0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuaW1wb3J0IEl0ZW0gZnJvbSAnLi9JdGVtJ1xuXG5jb25zdCBtYXhIZWlnaHRDc3MgPSAoeyBtYXhIZWlnaHQgfSkgPT5cbiAgY3NzYFxuICAgIG1heC1oZWlnaHQ6ICR7bWF4SGVpZ2h0IHx8ICcyNzVweCd9O1xuICBgXG5cbmNvbnN0IG1pbldpZHRoQ3NzID0gKHsgbWluV2lkdGggfSkgPT5cbiAgY3NzYFxuICAgIG1pbi13aWR0aDogJHttaW5XaWR0aCB8fCAnMjAwcHgnfTtcbiAgYFxuXG5jb25zdCBjbG9zZWRDc3MgPSAoeyBjbG9zZWQgfSkgPT5cbiAgY2xvc2VkICYmXG4gIGNzc2BcbiAgICB2aXNpYmlsaXR5OiBoaWRkZW47XG4gIGBcblxuY29uc3QgTGlzdEJveCA9IHN0eWxlZCgndWwnKWBcbiAgbGlzdC1zdHlsZTogbm9uZTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignd2hpdGUnKX07XG4gIG1hcmdpbjogJHtzcGFjZXIoMSl9IDAgMCAwO1xuICBwYWRkaW5nOiAke3NwYWNlcigxKX0gMDtcbiAgb3ZlcmZsb3cteTogYXV0bztcblxuICAke21heEhlaWdodENzc31cbiAgJHttaW5XaWR0aENzc31cbiAgJHtjbG9zZWRDc3N9XG4gICR7c2hhZG93KCdkaXN0YW50Jyl9O1xuICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcpfTtcbmBcblxuTGlzdEJveC5JdGVtID0gSXRlbVxuXG5leHBvcnQgZGVmYXVsdCBMaXN0Qm94XG4iXX0= */"));
};

var minWidthCss = function minWidthCss(_ref3) {
  var minWidth = _ref3.minWidth;
  return /*#__PURE__*/core.css("min-width:", minWidth || '200px', ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCSyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIGNvbG9yLFxuICBzaGFkb3csXG4gIHNwYWNlcixcbiAgYm9yZGVyUmFkaXVzLFxuICBwYWRkaW5nLFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcbmltcG9ydCBJdGVtIGZyb20gJy4vSXRlbSdcblxuY29uc3QgbWF4SGVpZ2h0Q3NzID0gKHsgbWF4SGVpZ2h0IH0pID0+XG4gIGNzc2BcbiAgICBtYXgtaGVpZ2h0OiAke21heEhlaWdodCB8fCAnMjc1cHgnfTtcbiAgYFxuXG5jb25zdCBtaW5XaWR0aENzcyA9ICh7IG1pbldpZHRoIH0pID0+XG4gIGNzc2BcbiAgICBtaW4td2lkdGg6ICR7bWluV2lkdGggfHwgJzIwMHB4J307XG4gIGBcblxuY29uc3QgY2xvc2VkQ3NzID0gKHsgY2xvc2VkIH0pID0+XG4gIGNsb3NlZCAmJlxuICBjc3NgXG4gICAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICBgXG5cbmNvbnN0IExpc3RCb3ggPSBzdHlsZWQoJ3VsJylgXG4gIGxpc3Qtc3R5bGU6IG5vbmU7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICBtYXJnaW46ICR7c3BhY2VyKDEpfSAwIDAgMDtcbiAgcGFkZGluZzogJHtzcGFjZXIoMSl9IDA7XG4gIG92ZXJmbG93LXk6IGF1dG87XG5cbiAgJHttYXhIZWlnaHRDc3N9XG4gICR7bWluV2lkdGhDc3N9XG4gICR7Y2xvc2VkQ3NzfVxuICAke3NoYWRvdygnZGlzdGFudCcpfTtcbiAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnKX07XG5gXG5cbkxpc3RCb3guSXRlbSA9IEl0ZW1cblxuZXhwb3J0IGRlZmF1bHQgTGlzdEJveFxuIl19 */"));
};

var _ref$4 =  true ? {
  name: "gyp8mm",
  styles: "visibility:hidden;"
} : {
  name: "gyp8mm",
  styles: "visibility:hidden;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCSyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIGNvbG9yLFxuICBzaGFkb3csXG4gIHNwYWNlcixcbiAgYm9yZGVyUmFkaXVzLFxuICBwYWRkaW5nLFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcbmltcG9ydCBJdGVtIGZyb20gJy4vSXRlbSdcblxuY29uc3QgbWF4SGVpZ2h0Q3NzID0gKHsgbWF4SGVpZ2h0IH0pID0+XG4gIGNzc2BcbiAgICBtYXgtaGVpZ2h0OiAke21heEhlaWdodCB8fCAnMjc1cHgnfTtcbiAgYFxuXG5jb25zdCBtaW5XaWR0aENzcyA9ICh7IG1pbldpZHRoIH0pID0+XG4gIGNzc2BcbiAgICBtaW4td2lkdGg6ICR7bWluV2lkdGggfHwgJzIwMHB4J307XG4gIGBcblxuY29uc3QgY2xvc2VkQ3NzID0gKHsgY2xvc2VkIH0pID0+XG4gIGNsb3NlZCAmJlxuICBjc3NgXG4gICAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICBgXG5cbmNvbnN0IExpc3RCb3ggPSBzdHlsZWQoJ3VsJylgXG4gIGxpc3Qtc3R5bGU6IG5vbmU7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICBtYXJnaW46ICR7c3BhY2VyKDEpfSAwIDAgMDtcbiAgcGFkZGluZzogJHtzcGFjZXIoMSl9IDA7XG4gIG92ZXJmbG93LXk6IGF1dG87XG5cbiAgJHttYXhIZWlnaHRDc3N9XG4gICR7bWluV2lkdGhDc3N9XG4gICR7Y2xvc2VkQ3NzfVxuICAke3NoYWRvdygnZGlzdGFudCcpfTtcbiAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnKX07XG5gXG5cbkxpc3RCb3guSXRlbSA9IEl0ZW1cblxuZXhwb3J0IGRlZmF1bHQgTGlzdEJveFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
};

var closedCss = function closedCss(_ref4) {
  var closed = _ref4.closed;
  return closed && _ref$4;
};

var ListBox = /*#__PURE__*/createStyled('ul', {
  target: "e1dy2ip70",
  label: "ListBox"
})("list-style:none;background-color:", color('white'), ";margin:", spacer(1), " 0 0 0;padding:", spacer(1), " 0;overflow-y:auto;", maxHeightCss, " ", minWidthCss, " ", closedCss, " ", shadow('distant'), ";", borderRadius('default'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRCNEIiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQge1xuICBjb2xvcixcbiAgc2hhZG93LFxuICBzcGFjZXIsXG4gIGJvcmRlclJhZGl1cyxcbiAgcGFkZGluZyxcbiAgdHlwb2dyYXBoeVxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5pbXBvcnQgSXRlbSBmcm9tICcuL0l0ZW0nXG5cbmNvbnN0IG1heEhlaWdodENzcyA9ICh7IG1heEhlaWdodCB9KSA9PlxuICBjc3NgXG4gICAgbWF4LWhlaWdodDogJHttYXhIZWlnaHQgfHwgJzI3NXB4J307XG4gIGBcblxuY29uc3QgbWluV2lkdGhDc3MgPSAoeyBtaW5XaWR0aCB9KSA9PlxuICBjc3NgXG4gICAgbWluLXdpZHRoOiAke21pbldpZHRoIHx8ICcyMDBweCd9O1xuICBgXG5cbmNvbnN0IGNsb3NlZENzcyA9ICh7IGNsb3NlZCB9KSA9PlxuICBjbG9zZWQgJiZcbiAgY3NzYFxuICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgYFxuXG5jb25zdCBMaXN0Qm94ID0gc3R5bGVkKCd1bCcpYFxuICBsaXN0LXN0eWxlOiBub25lO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgbWFyZ2luOiAke3NwYWNlcigxKX0gMCAwIDA7XG4gIHBhZGRpbmc6ICR7c3BhY2VyKDEpfSAwO1xuICBvdmVyZmxvdy15OiBhdXRvO1xuXG4gICR7bWF4SGVpZ2h0Q3NzfVxuICAke21pbldpZHRoQ3NzfVxuICAke2Nsb3NlZENzc31cbiAgJHtzaGFkb3coJ2Rpc3RhbnQnKX07XG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuYFxuXG5MaXN0Qm94Lkl0ZW0gPSBJdGVtXG5cbmV4cG9ydCBkZWZhdWx0IExpc3RCb3hcbiJdfQ== */"));

ListBox.Item = Item;

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Item$1 = /*#__PURE__*/createStyled(ListBox.Item, {
  target: "ecifaok0",
  label: "Item"
})( true ? {
  name: "1lekzkb",
  styles: "display:flex;align-items:center;justify-content:space-between;"
} : {
  name: "1lekzkb",
  styles: "display:flex;align-items:center;justify-content:space-between;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk9wdGlvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLaUMiLCJmaWxlIjoiT3B0aW9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgQ2hlY2sgZnJvbSAnLi4vaWNvbnMvQ2hlY2snXG5pbXBvcnQgTGlzdEJveCBmcm9tICcuLi9MaXN0Qm94J1xuXG5jb25zdCBJdGVtID0gc3R5bGVkKExpc3RCb3guSXRlbSlgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbmBcblxuY29uc3QgaWNvblNpemUgPSBzaXplID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnbGcnOlxuICAgICAgcmV0dXJuICcyNXB4J1xuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gJzE2cHgnXG4gIH1cbn1cblxuY29uc3QgT3B0aW9uID0gKHsgY2hpbGRyZW4sIHNlbGVjdGVkLCBzaXplLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxJdGVtIHNlbGVjdGVkPXtzZWxlY3RlZH0gc2l6ZT17c2l6ZX0gcG9pbnRlciB7Li4ucHJvcHN9PlxuICAgIHtjaGlsZHJlbn1cbiAgICB7c2VsZWN0ZWQgJiYgPENoZWNrIHNpemU9e2ljb25TaXplKHNpemUpfSBjb2xvcj1cImJyYW5kR3JlZW5cIiAvPn1cbiAgPC9JdGVtPlxuKVxuXG5PcHRpb24uZGlzcGxheU5hbWUgPSAnRHJvcGRvd24uT3B0aW9uJ1xuXG5leHBvcnQgZGVmYXVsdCBPcHRpb25cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});

var iconSize = function iconSize(size) {
  switch (size) {
    case 'lg':
      return '25px';

    default:
      return '16px';
  }
};

var Option = function Option(_ref) {
  var children = _ref.children,
      selected = _ref.selected,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["children", "selected", "size"]);

  return /*#__PURE__*/React__default['default'].createElement(Item$1, _extends({
    selected: selected,
    size: size,
    pointer: true
  }, props), children, selected && /*#__PURE__*/React__default['default'].createElement(Check, {
    size: iconSize(size),
    color: "brandGreen"
  }));
};

Option.displayName = 'Dropdown.Option';

var Autocomplete = function Autocomplete(_ref) {
  var DataSource = _ref.dataSource,
      disabled = _ref.disabled,
      idValue = _ref.idValue,
      kind = _ref.kind,
      name = _ref.name,
      onChange = _ref.onChange,
      formatItem = _ref.formatItem,
      placeholder = _ref.placeholder,
      size = _ref.size,
      valid = _ref.valid,
      value = _ref.value,
      width = _ref.width;
  return /*#__PURE__*/React__default['default'].createElement(Downshift__default['default'], {
    itemToString: function itemToString(item) {
      return item ? formatItem(item) : '';
    },
    onChange: onChange,
    selectedItem: value,
    inputId: name
  }, function (_ref2) {
    var getRootProps = _ref2.getRootProps,
        getInputProps = _ref2.getInputProps,
        getItemProps = _ref2.getItemProps,
        getMenuProps = _ref2.getMenuProps,
        highlightedIndex = _ref2.highlightedIndex,
        isOpen = _ref2.isOpen,
        inputValue = _ref2.inputValue,
        openMenu = _ref2.openMenu,
        selectedItem = _ref2.selectedItem;
    return /*#__PURE__*/React__default['default'].createElement(Container$1, _extends({
      width: width
    }, getRootProps()), /*#__PURE__*/React__default['default'].createElement(DataSource, {
      inputValue: inputValue
    }, function (_ref3) {
      var loading = _ref3.loading,
          items = _ref3.items;
      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(InputContainer, null, /*#__PURE__*/React__default['default'].createElement(Input, _extends({
        type: "text",
        placeholder: placeholder,
        size: size,
        kind: kind,
        valid: valid
      }, getInputProps({
        disabled: disabled,
        autoComplete: 'off',
        onFocus: openMenu
      }))), loading && /*#__PURE__*/React__default['default'].createElement(Loader$2, {
        dark: isOpen,
        size: size
      }), /*#__PURE__*/React__default['default'].createElement(Caret$1, {
        size: "8px",
        fill: "cadet"
      })), isOpen && /*#__PURE__*/React__default['default'].createElement(ListBox, getMenuProps(), loading ? /*#__PURE__*/React__default['default'].createElement(Option, {
        disabled: true,
        size: size
      }, "Loading...") : !inputValue && items.length === 0 ? /*#__PURE__*/React__default['default'].createElement(Option, {
        disabled: true,
        size: size
      }, "Type to search") : inputValue && items.length === 0 ? /*#__PURE__*/React__default['default'].createElement(Option, {
        disabled: true,
        size: size
      }, "No items") : items.map(function (item, idx) {
        return /*#__PURE__*/React__default['default'].createElement(Option, _extends({
          size: size,
          selected: selectedItem === item,
          highlighted: highlightedIndex === idx
        }, getItemProps({
          key: idValue(item),
          item: item
        })), formatItem(item));
      })));
    }));
  });
};

Autocomplete.defaultProps = {
  idValue: function idValue(item) {
    return item.id;
  },
  placeholder: 'Select...',
  valid: true
};

var size$4 = '29px';

var avatarUrlCss = function avatarUrlCss(_ref) {
  var avatarUrl = _ref.avatarUrl;
  return avatarUrl ? /*#__PURE__*/core.css("background:url(", avatarUrl, ");background-repeat:no-repeat;background-size:cover;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPUyIsImZpbGUiOiJDb250YWluZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBjb2xvciwgdHJhbnNwYXJlbnRpemUsIHR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAnMjlweCdcbmNvbnN0IGF2YXRhclVybENzcyA9ICh7IGF2YXRhclVybCB9KSA9PlxuICBhdmF0YXJVcmxcbiAgICA/IGNzc2BcbiAgICAgICAgYmFja2dyb3VuZDogdXJsKCR7YXZhdGFyVXJsfSk7XG4gICAgICAgIGJhY2tncm91bmQtcmVwZWF0OiBuby1yZXBlYXQ7XG4gICAgICAgIGJhY2tncm91bmQtc2l6ZTogY292ZXI7XG4gICAgICBgXG4gICAgOiBudWxsXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG4gIHdpZHRoOiAke3NpemV9O1xuICBoZWlnaHQ6ICR7c2l6ZX07XG5cbiAgJHt0eXBvZ3JhcGh5KCdib2R5Mk1lZGl1bScpfTtcblxuICAkeyh7IGxpZ2h0LCB0aGVtZSB9KSA9PiBjc3NgXG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHtsaWdodFxuICAgICAgPyBjb2xvcigncGFsZUdyZXknLCB7IHRoZW1lIH0pXG4gICAgICA6IGNvbG9yKCdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICAgIGNvbG9yOiAke2xpZ2h0XG4gICAgICA/IHRyYW5zcGFyZW50aXplKCdjYWRldCcsIDAuNSwgeyB0aGVtZSB9KVxuICAgICAgOiBjb2xvcignY2FkZXQnLCB7IHRoZW1lIH0pfTtcbiAgICBib3JkZXI6IDFweCBzb2xpZFxuICAgICAgJHtsaWdodCA/IGNvbG9yKCdwYWxlR3JleScsIHsgdGhlbWUgfSkgOiBjb2xvcignc2xhdGUnLCB7IHRoZW1lIH0pfTtcbiAgYH07XG4gICR7YXZhdGFyVXJsQ3NzfTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ0F2YXRhci5Db250YWluZXInXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */")) : null;
};

var Container$2 = createStyled("div", {
  target: "evg9tqh0",
  label: "Container"
})("display:flex;justify-content:center;align-items:center;border-radius:50%;width:", size$4, ";height:", size$4, ";", typography('body2Medium'), ";", function (_ref2) {
  var light = _ref2.light,
      theme = _ref2.theme;
  return /*#__PURE__*/core.css("background-color:", light ? color('paleGrey', {
    theme: theme
  }) : color('slate', {
    theme: theme
  }), ";color:", light ? transparentize('cadet', 0.5, {
    theme: theme
  }) : color('cadet', {
    theme: theme
  }), ";border:1px solid ", light ? color('paleGrey', {
    theme: theme
  }) : color('slate', {
    theme: theme
  }), ";;label:Container;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3QjZCIiwiZmlsZSI6IkNvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGNvbG9yLCB0cmFuc3BhcmVudGl6ZSwgdHlwb2dyYXBoeSB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2l6ZSA9ICcyOXB4J1xuY29uc3QgYXZhdGFyVXJsQ3NzID0gKHsgYXZhdGFyVXJsIH0pID0+XG4gIGF2YXRhclVybFxuICAgID8gY3NzYFxuICAgICAgICBiYWNrZ3JvdW5kOiB1cmwoJHthdmF0YXJVcmx9KTtcbiAgICAgICAgYmFja2dyb3VuZC1yZXBlYXQ6IG5vLXJlcGVhdDtcbiAgICAgICAgYmFja2dyb3VuZC1zaXplOiBjb3ZlcjtcbiAgICAgIGBcbiAgICA6IG51bGxcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgd2lkdGg6ICR7c2l6ZX07XG4gIGhlaWdodDogJHtzaXplfTtcblxuICAke3R5cG9ncmFwaHkoJ2JvZHkyTWVkaXVtJyl9O1xuXG4gICR7KHsgbGlnaHQsIHRoZW1lIH0pID0+IGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2xpZ2h0XG4gICAgICA/IGNvbG9yKCdwYWxlR3JleScsIHsgdGhlbWUgfSlcbiAgICAgIDogY29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgY29sb3I6ICR7bGlnaHRcbiAgICAgID8gdHJhbnNwYXJlbnRpemUoJ2NhZGV0JywgMC41LCB7IHRoZW1lIH0pXG4gICAgICA6IGNvbG9yKCdjYWRldCcsIHsgdGhlbWUgfSl9O1xuICAgIGJvcmRlcjogMXB4IHNvbGlkXG4gICAgICAke2xpZ2h0ID8gY29sb3IoJ3BhbGVHcmV5JywgeyB0aGVtZSB9KSA6IGNvbG9yKCdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICBgfTtcbiAgJHthdmF0YXJVcmxDc3N9O1xuYFxuXG5Db250YWluZXIuZGlzcGxheU5hbWUgPSAnQXZhdGFyLkNvbnRhaW5lcidcblxuZXhwb3J0IGRlZmF1bHQgQ29udGFpbmVyXG4iXX0= */"));
}, ";", avatarUrlCss, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgY29sb3IsIHRyYW5zcGFyZW50aXplLCB0eXBvZ3JhcGh5IH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBzaXplID0gJzI5cHgnXG5jb25zdCBhdmF0YXJVcmxDc3MgPSAoeyBhdmF0YXJVcmwgfSkgPT5cbiAgYXZhdGFyVXJsXG4gICAgPyBjc3NgXG4gICAgICAgIGJhY2tncm91bmQ6IHVybCgke2F2YXRhclVybH0pO1xuICAgICAgICBiYWNrZ3JvdW5kLXJlcGVhdDogbm8tcmVwZWF0O1xuICAgICAgICBiYWNrZ3JvdW5kLXNpemU6IGNvdmVyO1xuICAgICAgYFxuICAgIDogbnVsbFxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICB3aWR0aDogJHtzaXplfTtcbiAgaGVpZ2h0OiAke3NpemV9O1xuXG4gICR7dHlwb2dyYXBoeSgnYm9keTJNZWRpdW0nKX07XG5cbiAgJHsoeyBsaWdodCwgdGhlbWUgfSkgPT4gY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7bGlnaHRcbiAgICAgID8gY29sb3IoJ3BhbGVHcmV5JywgeyB0aGVtZSB9KVxuICAgICAgOiBjb2xvcignc2xhdGUnLCB7IHRoZW1lIH0pfTtcbiAgICBjb2xvcjogJHtsaWdodFxuICAgICAgPyB0cmFuc3BhcmVudGl6ZSgnY2FkZXQnLCAwLjUsIHsgdGhlbWUgfSlcbiAgICAgIDogY29sb3IoJ2NhZGV0JywgeyB0aGVtZSB9KX07XG4gICAgYm9yZGVyOiAxcHggc29saWRcbiAgICAgICR7bGlnaHQgPyBjb2xvcigncGFsZUdyZXknLCB7IHRoZW1lIH0pIDogY29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gIGB9O1xuICAke2F2YXRhclVybENzc307XG5gXG5cbkNvbnRhaW5lci5kaXNwbGF5TmFtZSA9ICdBdmF0YXIuQ29udGFpbmVyJ1xuXG5leHBvcnQgZGVmYXVsdCBDb250YWluZXJcbiJdfQ== */"));

Container$2.displayName = 'Avatar.Container';

// https://wapp-fvuatlivestyleguide-cus-tst.azurewebsites.net/03-avatars.html

var nameOrEmailInitials = function nameOrEmailInitials(_ref) {
  var firstName = _ref.firstName,
      lastName = _ref.lastName,
      email = _ref.email;

  if (firstName || lastName) {
    return [firstName, lastName].filter(function (val) {
      return Boolean(val);
    }).map(function (val) {
      return val[0];
    }).join('').toUpperCase();
  }

  if (email) {
    return email[0].toUpperCase();
  }

  return '?';
};

var Avatar = function Avatar(_ref2) {
  var firstName = _ref2.firstName,
      lastName = _ref2.lastName,
      email = _ref2.email,
      light = _ref2.light,
      avatarUrl = _ref2.avatarUrl;
  return /*#__PURE__*/React__default['default'].createElement(Container$2, {
    light: light,
    avatarUrl: avatarUrl
  }, avatarUrl ? null : nameOrEmailInitials({
    firstName: firstName,
    lastName: lastName,
    email: email
  }));
};

Avatar.propTypes = {
  firstName: PropTypes__default['default'].string,
  lastName: PropTypes__default['default'].string,
  light: PropTypes__default['default'].bool,
  email: PropTypes__default['default'].string,
  avatarUrl: PropTypes__default['default'].string
};
Avatar.defaultProps = {
  firstName: '',
  lastName: '',
  email: '',
  light: false,
  avatarUrl: ''
};

var variant = function variant(colorName, theme) {
  return /*#__PURE__*/core.css("color:", color(colorName, {
    theme: theme
  }), ";background-color:", transparentize(colorName, 0.1, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhZGdlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUt5QyIsImZpbGUiOiJCYWRnZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIGh0dHBzOi8vd2FwcC1mdnVhdGxpdmVzdHlsZWd1aWRlLWN1cy10c3QuYXp1cmV3ZWJzaXRlcy5uZXQvMDQtYmFkZ2VzLmh0bWxcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGNvbG9yLCBwYWRkaW5nLCB0cmFuc3BhcmVudGl6ZSwgdHlwb2dyYXBoeSB9IGZyb20gJy4uL3N0eWxlcydcblxuY29uc3QgdmFyaWFudCA9IChjb2xvck5hbWUsIHRoZW1lKSA9PiBjc3NgXG4gIGNvbG9yOiAke2NvbG9yKGNvbG9yTmFtZSwgeyB0aGVtZSB9KX07XG4gIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoY29sb3JOYW1lLCAwLjEsIHsgdGhlbWUgfSl9O1xuYFxuXG5jb25zdCBzb2xpZFZhcmlhbnQgPSAoY29sb3JOYW1lLCB0aGVtZSkgPT4gY3NzYFxuICBjb2xvcjogJHtjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcihjb2xvck5hbWUsIHsgdGhlbWUgfSl9O1xuYFxuXG5jb25zdCBraW5kID0gKHsga2luZCwgdGhlbWUgfSkgPT4ge1xuICBzd2l0Y2ggKGtpbmQpIHtcbiAgICBjYXNlICdkcmFmdCc6XG4gICAgICByZXR1cm4gdmFyaWFudCgnZGFya1B1cnBsZScsIHRoZW1lKVxuICAgIGNhc2UgJ2xpdmUnOlxuICAgICAgcmV0dXJuIHZhcmlhbnQoJ2ZvcmVzdCcsIHRoZW1lKVxuICAgIGNhc2UgJ2Nsb3NlZCc6XG4gICAgICByZXR1cm4gdmFyaWFudCgnb2NlYW4nLCB0aGVtZSlcbiAgICBjYXNlICdhcmNoaXZlZCc6XG4gICAgICByZXR1cm4gdmFyaWFudCgncGV3dGVyJywgdGhlbWUpXG4gICAgY2FzZSAncHJvJzpcbiAgICAgIHJldHVybiBzb2xpZFZhcmlhbnQoJ2RhcmtPY2VhbicsIHRoZW1lKVxuICAgIGRlZmF1bHQ6XG4gICAgLy8gbm90aGluZ1xuICB9XG59XG5cbmNvbnN0IGNvbG9yU3R5bGVzID0gKHsga2luZCwgY29sb3IsIHNvbGlkLCB0aGVtZSB9KSA9PlxuICBraW5kID8gJycgOiBzb2xpZCA/IHNvbGlkVmFyaWFudChjb2xvciwgdGhlbWUpIDogdmFyaWFudChjb2xvciwgdGhlbWUpXG5cbmNvbnN0IEJhZGdlID0gc3R5bGVkLnNwYW5gXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgYm9yZGVyLXJhZGl1czogMTByZW07XG4gIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG5cbiAgJHtwYWRkaW5nKCd4eHhzJyl9O1xuICAke3R5cG9ncmFwaHkoJ3N1YmhlYWRpbmcxJyl9O1xuICAke2NvbG9yU3R5bGVzfTtcbiAgJHtraW5kfTtcbmBcblxuQmFkZ2UuZGVmYXVsdFByb3BzID0geyBjb2xvcjogJ3NsYXRlJyB9XG5cbmV4cG9ydCBkZWZhdWx0IEJhZGdlXG4iXX0= */"));
};

var solidVariant = function solidVariant(colorName, theme) {
  return /*#__PURE__*/core.css("color:", color('white', {
    theme: theme
  }), ";background-color:", color(colorName, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhZGdlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVU4QyIsImZpbGUiOiJCYWRnZS5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIGh0dHBzOi8vd2FwcC1mdnVhdGxpdmVzdHlsZWd1aWRlLWN1cy10c3QuYXp1cmV3ZWJzaXRlcy5uZXQvMDQtYmFkZ2VzLmh0bWxcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGNvbG9yLCBwYWRkaW5nLCB0cmFuc3BhcmVudGl6ZSwgdHlwb2dyYXBoeSB9IGZyb20gJy4uL3N0eWxlcydcblxuY29uc3QgdmFyaWFudCA9IChjb2xvck5hbWUsIHRoZW1lKSA9PiBjc3NgXG4gIGNvbG9yOiAke2NvbG9yKGNvbG9yTmFtZSwgeyB0aGVtZSB9KX07XG4gIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoY29sb3JOYW1lLCAwLjEsIHsgdGhlbWUgfSl9O1xuYFxuXG5jb25zdCBzb2xpZFZhcmlhbnQgPSAoY29sb3JOYW1lLCB0aGVtZSkgPT4gY3NzYFxuICBjb2xvcjogJHtjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcihjb2xvck5hbWUsIHsgdGhlbWUgfSl9O1xuYFxuXG5jb25zdCBraW5kID0gKHsga2luZCwgdGhlbWUgfSkgPT4ge1xuICBzd2l0Y2ggKGtpbmQpIHtcbiAgICBjYXNlICdkcmFmdCc6XG4gICAgICByZXR1cm4gdmFyaWFudCgnZGFya1B1cnBsZScsIHRoZW1lKVxuICAgIGNhc2UgJ2xpdmUnOlxuICAgICAgcmV0dXJuIHZhcmlhbnQoJ2ZvcmVzdCcsIHRoZW1lKVxuICAgIGNhc2UgJ2Nsb3NlZCc6XG4gICAgICByZXR1cm4gdmFyaWFudCgnb2NlYW4nLCB0aGVtZSlcbiAgICBjYXNlICdhcmNoaXZlZCc6XG4gICAgICByZXR1cm4gdmFyaWFudCgncGV3dGVyJywgdGhlbWUpXG4gICAgY2FzZSAncHJvJzpcbiAgICAgIHJldHVybiBzb2xpZFZhcmlhbnQoJ2RhcmtPY2VhbicsIHRoZW1lKVxuICAgIGRlZmF1bHQ6XG4gICAgLy8gbm90aGluZ1xuICB9XG59XG5cbmNvbnN0IGNvbG9yU3R5bGVzID0gKHsga2luZCwgY29sb3IsIHNvbGlkLCB0aGVtZSB9KSA9PlxuICBraW5kID8gJycgOiBzb2xpZCA/IHNvbGlkVmFyaWFudChjb2xvciwgdGhlbWUpIDogdmFyaWFudChjb2xvciwgdGhlbWUpXG5cbmNvbnN0IEJhZGdlID0gc3R5bGVkLnNwYW5gXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgYm9yZGVyLXJhZGl1czogMTByZW07XG4gIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7XG5cbiAgJHtwYWRkaW5nKCd4eHhzJyl9O1xuICAke3R5cG9ncmFwaHkoJ3N1YmhlYWRpbmcxJyl9O1xuICAke2NvbG9yU3R5bGVzfTtcbiAgJHtraW5kfTtcbmBcblxuQmFkZ2UuZGVmYXVsdFByb3BzID0geyBjb2xvcjogJ3NsYXRlJyB9XG5cbmV4cG9ydCBkZWZhdWx0IEJhZGdlXG4iXX0= */"));
};

var kind$1 = function kind(_ref) {
  var kind = _ref.kind,
      theme = _ref.theme;

  switch (kind) {
    case 'draft':
      return variant('darkPurple', theme);

    case 'live':
      return variant('forest', theme);

    case 'closed':
      return variant('ocean', theme);

    case 'archived':
      return variant('pewter', theme);

    case 'pro':
      return solidVariant('darkOcean', theme);

  }
};

var colorStyles = function colorStyles(_ref2) {
  var kind = _ref2.kind,
      color = _ref2.color,
      solid = _ref2.solid,
      theme = _ref2.theme;
  return kind ? '' : solid ? solidVariant(color, theme) : variant(color, theme);
};

var Badge = createStyled("span", {
  target: "e1f9b1kq0",
  label: "Badge"
})("display:inline-block;border-radius:10rem;vertical-align:middle;", padding('xxxs'), ";", typography('subheading1'), ";", colorStyles, ";", kind$1, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhZGdlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1DeUIiLCJmaWxlIjoiQmFkZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBodHRwczovL3dhcHAtZnZ1YXRsaXZlc3R5bGVndWlkZS1jdXMtdHN0LmF6dXJld2Vic2l0ZXMubmV0LzA0LWJhZGdlcy5odG1sXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBjb2xvciwgcGFkZGluZywgdHJhbnNwYXJlbnRpemUsIHR5cG9ncmFwaHkgfSBmcm9tICcuLi9zdHlsZXMnXG5cbmNvbnN0IHZhcmlhbnQgPSAoY29sb3JOYW1lLCB0aGVtZSkgPT4gY3NzYFxuICBjb2xvcjogJHtjb2xvcihjb2xvck5hbWUsIHsgdGhlbWUgfSl9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKGNvbG9yTmFtZSwgMC4xLCB7IHRoZW1lIH0pfTtcbmBcblxuY29uc3Qgc29saWRWYXJpYW50ID0gKGNvbG9yTmFtZSwgdGhlbWUpID0+IGNzc2BcbiAgY29sb3I6ICR7Y29sb3IoJ3doaXRlJywgeyB0aGVtZSB9KX07XG4gIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoY29sb3JOYW1lLCB7IHRoZW1lIH0pfTtcbmBcblxuY29uc3Qga2luZCA9ICh7IGtpbmQsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChraW5kKSB7XG4gICAgY2FzZSAnZHJhZnQnOlxuICAgICAgcmV0dXJuIHZhcmlhbnQoJ2RhcmtQdXJwbGUnLCB0aGVtZSlcbiAgICBjYXNlICdsaXZlJzpcbiAgICAgIHJldHVybiB2YXJpYW50KCdmb3Jlc3QnLCB0aGVtZSlcbiAgICBjYXNlICdjbG9zZWQnOlxuICAgICAgcmV0dXJuIHZhcmlhbnQoJ29jZWFuJywgdGhlbWUpXG4gICAgY2FzZSAnYXJjaGl2ZWQnOlxuICAgICAgcmV0dXJuIHZhcmlhbnQoJ3Bld3RlcicsIHRoZW1lKVxuICAgIGNhc2UgJ3Bybyc6XG4gICAgICByZXR1cm4gc29saWRWYXJpYW50KCdkYXJrT2NlYW4nLCB0aGVtZSlcbiAgICBkZWZhdWx0OlxuICAgIC8vIG5vdGhpbmdcbiAgfVxufVxuXG5jb25zdCBjb2xvclN0eWxlcyA9ICh7IGtpbmQsIGNvbG9yLCBzb2xpZCwgdGhlbWUgfSkgPT5cbiAga2luZCA/ICcnIDogc29saWQgPyBzb2xpZFZhcmlhbnQoY29sb3IsIHRoZW1lKSA6IHZhcmlhbnQoY29sb3IsIHRoZW1lKVxuXG5jb25zdCBCYWRnZSA9IHN0eWxlZC5zcGFuYFxuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIGJvcmRlci1yYWRpdXM6IDEwcmVtO1xuICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuXG4gICR7cGFkZGluZygneHh4cycpfTtcbiAgJHt0eXBvZ3JhcGh5KCdzdWJoZWFkaW5nMScpfTtcbiAgJHtjb2xvclN0eWxlc307XG4gICR7a2luZH07XG5gXG5cbkJhZGdlLmRlZmF1bHRQcm9wcyA9IHsgY29sb3I6ICdzbGF0ZScgfVxuXG5leHBvcnQgZGVmYXVsdCBCYWRnZVxuIl19 */"));

Badge.defaultProps = {
  color: 'slate'
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var kind$2 = function kind(_ref2) {
  var dark = _ref2.dark,
      kind = _ref2.kind,
      theme = _ref2.theme;

  switch (kind) {
    case 'primary':
      return /*#__PURE__*/core.css("color:", color('ink', {
        theme: theme
      }), ";background-color:", color('lightBrandGreen', {
        theme: theme
      }), ";border-color:", color('lightBrandGreen', {
        theme: theme
      }), ";&:hover,&:active,&.focus-visible{background-color:", color('lighterBrandGreen', {
        theme: theme
      }), ";border-color:", color('lighterBrandGreen', {
        theme: theme
      }), ";}&:disabled{color:", color('white', {
        theme: theme
      }), ";background-color:", color('silver', {
        theme: theme
      }), ";border-color:", color('silver', {
        theme: theme
      }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    case 'standard':
      return /*#__PURE__*/core.css("color:", dark ? color('white', {
        theme: theme
      }) : color('slate', {
        theme: theme
      }), ";background-color:", dark ? color('ink', {
        theme: theme
      }) : color('white', {
        theme: theme
      }), ";border-color:", dark ? transparentize('offWhite', 0.5, {
        theme: theme
      }) : transparentize('slate', 0.5, {
        theme: theme
      }), ";&:hover,&:active,&.focus-visible{color:", dark ? color('ink', {
        theme: theme
      }) : color('white', {
        theme: theme
      }), ";background-color:", dark ? color('white', {
        theme: theme
      }) : color('slate', {
        theme: theme
      }), ";border-color:", dark ? color('white', {
        theme: theme
      }) : color('slate', {
        theme: theme
      }), ";}&:disabled{color:", dark ? transparentize('offWhite', 0.3, {
        theme: theme
      }) : transparentize('slate', 0.3, {
        theme: theme
      }), ";background-color:", dark ? transparentize('offWhite', 0.2, {
        theme: theme
      }) : transparentize('slate', 0.1, {
        theme: theme
      }), ";border-color:transparent;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtQ2dCIiwiZmlsZSI6IkJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIGh0dHBzOi8vd2FwcC1mdnVhdGxpdmVzdHlsZWd1aWRlLWN1cy10c3QuYXp1cmV3ZWJzaXRlcy5uZXQvMDUtYnV0dG9ucy5odG1sXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQge1xuICBib3JkZXJSYWRpdXMsXG4gIGNvbG9yLFxuICBmb250U2l6ZSxcbiAgZm9udFdlaWdodCxcbiAgcGFkZGluZyxcbiAgc3BhY2VyLFxuICB0cmFuc3BhcmVudGl6ZVxufSBmcm9tICcuLi9zdHlsZXMnXG5cbmNvbnN0IGtpbmQgPSAoeyBkYXJrLCBraW5kLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoa2luZCkge1xuICAgIGNhc2UgJ3ByaW1hcnknOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgY29sb3I6ICR7Y29sb3IoJ2luaycsIHsgdGhlbWUgfSl9O1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCdsaWdodEJyYW5kR3JlZW4nLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKCdsaWdodEJyYW5kR3JlZW4nLCB7IHRoZW1lIH0pfTtcblxuICAgICAgICAmOmhvdmVyLFxuICAgICAgICAmOmFjdGl2ZSxcbiAgICAgICAgJi5mb2N1cy12aXNpYmxlIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCdsaWdodGVyQnJhbmRHcmVlbicsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcignbGlnaHRlckJyYW5kR3JlZW4nLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgfVxuXG4gICAgICAgICY6ZGlzYWJsZWQge1xuICAgICAgICAgIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3NpbHZlcicsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcignc2lsdmVyJywgeyB0aGVtZSB9KX07XG4gICAgICAgIH1cbiAgICAgIGBcbiAgICBjYXNlICdzdGFuZGFyZCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBjb2xvcjogJHtkYXJrID8gY29sb3IoJ3doaXRlJywgeyB0aGVtZSB9KSA6IGNvbG9yKCdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2RhcmtcbiAgICAgICAgICA/IGNvbG9yKCdpbmsnLCB7IHRoZW1lIH0pXG4gICAgICAgICAgOiBjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiAke2RhcmtcbiAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuNSwgeyB0aGVtZSB9KVxuICAgICAgICAgIDogdHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC41LCB7IHRoZW1lIH0pfTtcblxuICAgICAgICAmOmhvdmVyLFxuICAgICAgICAmOmFjdGl2ZSxcbiAgICAgICAgJi5mb2N1cy12aXNpYmxlIHtcbiAgICAgICAgICBjb2xvcjogJHtkYXJrID8gY29sb3IoJ2luaycsIHsgdGhlbWUgfSkgOiBjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2RhcmtcbiAgICAgICAgICAgID8gY29sb3IoJ3doaXRlJywgeyB0aGVtZSB9KVxuICAgICAgICAgICAgOiBjb2xvcignc2xhdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgICBib3JkZXItY29sb3I6ICR7ZGFya1xuICAgICAgICAgICAgPyBjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pXG4gICAgICAgICAgICA6IGNvbG9yKCdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgICB9XG5cbiAgICAgICAgJjpkaXNhYmxlZCB7XG4gICAgICAgICAgY29sb3I6ICR7ZGFya1xuICAgICAgICAgICAgPyB0cmFuc3BhcmVudGl6ZSgnb2ZmV2hpdGUnLCAwLjMsIHsgdGhlbWUgfSlcbiAgICAgICAgICAgIDogdHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC4zLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2RhcmtcbiAgICAgICAgICAgID8gdHJhbnNwYXJlbnRpemUoJ29mZldoaXRlJywgMC4yLCB7IHRoZW1lIH0pXG4gICAgICAgICAgICA6IHRyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuMSwgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYm9yZGVyLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgICAgICAgfVxuICAgICAgYFxuICAgIGNhc2UgJ3V0aWxpdHknOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgY29sb3I6ICR7ZGFya1xuICAgICAgICAgID8gY29sb3IoJ29mZldoaXRlJywgeyB0aGVtZSB9KVxuICAgICAgICAgIDogY29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7ZGFya1xuICAgICAgICAgID8gdHJhbnNwYXJlbnRpemUoJ29mZldoaXRlJywgMC4yLCB7IHRoZW1lIH0pXG4gICAgICAgICAgOiB0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjA4LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiB0cmFuc3BhcmVudDtcblxuICAgICAgICAmOmhvdmVyLFxuICAgICAgICAmOmFjdGl2ZSxcbiAgICAgICAgJi5mb2N1cy12aXNpYmxlIHtcbiAgICAgICAgICBjb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IGNvbG9yKCdvZmZXaGl0ZScsIHsgdGhlbWUgfSlcbiAgICAgICAgICAgIDogY29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuMywgeyB0aGVtZSB9KVxuICAgICAgICAgICAgOiB0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjE2LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgfVxuXG4gICAgICAgICY6ZGlzYWJsZWQge1xuICAgICAgICAgIGNvbG9yOiAke2RhcmtcbiAgICAgICAgICAgID8gdHJhbnNwYXJlbnRpemUoJ29mZldoaXRlJywgMC4zLCB7IHRoZW1lIH0pXG4gICAgICAgICAgICA6IHRyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuMywgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuMiwgeyB0aGVtZSB9KVxuICAgICAgICAgICAgOiB0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjEsIHsgdGhlbWUgfSl9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAnZ2hvc3QnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgY29sb3I6ICR7ZGFya1xuICAgICAgICAgID8gY29sb3IoJ29mZldoaXRlJywgeyB0aGVtZSB9KVxuICAgICAgICAgIDogY29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgIGJhY2tncm91bmQ6IG5vbmU7XG4gICAgICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG5cbiAgICAgICAgJjpob3ZlcixcbiAgICAgICAgJjphY3RpdmUsXG4gICAgICAgICYuZm9jdXMtdmlzaWJsZSB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuMTYsIHsgdGhlbWUgfSlcbiAgICAgICAgICAgIDogdHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC4wOCwgeyB0aGVtZSB9KX07XG4gICAgICAgIH1cblxuICAgICAgICAmOmRpc2FibGVkIHtcbiAgICAgICAgICBjb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuMywgeyB0aGVtZSB9KVxuICAgICAgICAgICAgOiB0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjMsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJhY2tncm91bmQ6ICR7ZGFyayA/ICdub25lJyA6ICdpbmhlcml0J307XG4gICAgICAgIH1cbiAgICAgIGBcblxuICAgIGNhc2UgJ2Rhbmdlcic6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBjb2xvcjogJHtjb2xvcignb2ZmV2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcigncmVkJywgeyB0aGVtZSB9KX07XG4gICAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcigncmVkJywgeyB0aGVtZSB9KX07XG5cbiAgICAgICAgJjpob3ZlcixcbiAgICAgICAgJjphY3RpdmUsXG4gICAgICAgICYuZm9jdXMtdmlzaWJsZSB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignZGFya1JlZCcsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcignZGFya1JlZCcsIHsgdGhlbWUgfSl9O1xuICAgICAgICB9XG5cbiAgICAgICAgJjpkaXNhYmxlZCB7XG4gICAgICAgICAgY29sb3I6ICR7Y29sb3IoJ3doaXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignc2lsdmVyJywgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKCdzaWx2ZXInLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgfVxuICAgICAgYFxuXG4gICAgZGVmYXVsdDpcbiAgICAvLyBub3RoaW5nXG4gIH1cbn1cblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnbGcnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHtwYWRkaW5nKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke2ZvbnRTaXplKCdzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gICAgY2FzZSAnc20nOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHtwYWRkaW5nKCd4eHhzJywgeyB0aGVtZSB9KX07XG4gICAgICAgICR7Zm9udFNpemUoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke2ZvbnRTaXplKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IGJsb2NrID0gKHsgYmxvY2sgfSkgPT5cbiAgYmxvY2sgJiZcbiAgY3NzYFxuICAgIHdpZHRoOiAxMDAlO1xuICBgXG5cbmNvbnN0IG1hcmdpbiA9ICh7XG4gIG1hcmdpbkxlZnQsXG4gIG1hcmdpblJpZ2h0LFxuICBtYXJnaW5Ub3AsXG4gIG1hcmdpbkJvdHRvbSxcbiAgd2l0aE1hcmdpbnMsXG4gIHRoZW1lXG59KSA9PiBjc3NgXG4gICR7KG1hcmdpbkxlZnQgfHwgd2l0aE1hcmdpbnMpICYmIGBtYXJnaW4tbGVmdDogJHtzcGFjZXIoMiwgeyB0aGVtZSB9KX1gfTtcbiAgJHsobWFyZ2luUmlnaHQgfHwgd2l0aE1hcmdpbnMpICYmIGBtYXJnaW4tcmlnaHQ6ICR7c3BhY2VyKDIsIHsgdGhlbWUgfSl9YH07XG4gICR7KG1hcmdpblRvcCB8fCB3aXRoTWFyZ2lucykgJiYgYG1hcmdpbi10b3A6ICR7c3BhY2VyKDIsIHsgdGhlbWUgfSl9YH07XG4gICR7KG1hcmdpbkJvdHRvbSB8fCB3aXRoTWFyZ2lucykgJiYgYG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDIsIHsgdGhlbWUgfSl9YH07XG5gXG5cbmNvbnN0IEJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICB1c2VyLXNlbGVjdDogbm9uZTtcbiAgY29sb3I6IGN1cnJlbnRDb2xvcjtcbiAgZm9udC1mYW1pbHk6IGluaGVyaXQ7XG4gIGJvcmRlci13aWR0aDogMXB4O1xuICBib3JkZXItc3R5bGU6IHNvbGlkO1xuICBmbGV4LXNocmluazogMDtcbiAgdHJhbnNpdGlvbjogY29sb3IgMC4xcyBlYXNlLWluLW91dCwgYmFja2dyb3VuZC1jb2xvciAwLjFzIGVhc2UtaW4tb3V0LFxuICAgIGJvcmRlci1jb2xvciAwLjFzIGVhc2UtaW4tb3V0LCBib3gtc2hhZG93IDAuMXMgZWFzZS1pbi1vdXQgMHM7XG4gICR7Zm9udFdlaWdodCgnYm9sZCcpfTtcbiAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnKX07XG5cbiAgJjplbmFibGVkIHtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIH1cblxuICAmOmhvdmVyLFxuICAmOmZvY3VzIHtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gICAgb3V0bGluZTogMDtcbiAgfVxuXG4gICY6aG92ZXIsXG4gICY6Zm9jdXMge1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuXG4gICY6ZGlzYWJsZWQge1xuICAgIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gIH1cblxuICAke2tpbmR9O1xuICAke3NpemV9O1xuICAke2Jsb2NrfTtcbiAgJHttYXJnaW59O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBCdXR0b25cbiJdfQ== */"));

    case 'utility':
      return /*#__PURE__*/core.css("color:", dark ? color('offWhite', {
        theme: theme
      }) : color('slate', {
        theme: theme
      }), ";background-color:", dark ? transparentize('offWhite', 0.2, {
        theme: theme
      }) : transparentize('slate', 0.08, {
        theme: theme
      }), ";border-color:transparent;&:hover,&:active,&.focus-visible{color:", dark ? color('offWhite', {
        theme: theme
      }) : color('slate', {
        theme: theme
      }), ";background-color:", dark ? transparentize('offWhite', 0.3, {
        theme: theme
      }) : transparentize('slate', 0.16, {
        theme: theme
      }), ";}&:disabled{color:", dark ? transparentize('offWhite', 0.3, {
        theme: theme
      }) : transparentize('slate', 0.3, {
        theme: theme
      }), ";background-color:", dark ? transparentize('offWhite', 0.2, {
        theme: theme
      }) : transparentize('slate', 0.1, {
        theme: theme
      }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    case 'ghost':
      return /*#__PURE__*/core.css("color:", dark ? color('offWhite', {
        theme: theme
      }) : color('slate', {
        theme: theme
      }), ";background:none;border-color:transparent;&:hover,&:active,&.focus-visible{background-color:", dark ? transparentize('offWhite', 0.16, {
        theme: theme
      }) : transparentize('slate', 0.08, {
        theme: theme
      }), ";}&:disabled{color:", dark ? transparentize('offWhite', 0.3, {
        theme: theme
      }) : transparentize('slate', 0.3, {
        theme: theme
      }), ";background:", dark ? 'none' : 'inherit', ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpR2dCIiwiZmlsZSI6IkJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIGh0dHBzOi8vd2FwcC1mdnVhdGxpdmVzdHlsZWd1aWRlLWN1cy10c3QuYXp1cmV3ZWJzaXRlcy5uZXQvMDUtYnV0dG9ucy5odG1sXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQge1xuICBib3JkZXJSYWRpdXMsXG4gIGNvbG9yLFxuICBmb250U2l6ZSxcbiAgZm9udFdlaWdodCxcbiAgcGFkZGluZyxcbiAgc3BhY2VyLFxuICB0cmFuc3BhcmVudGl6ZVxufSBmcm9tICcuLi9zdHlsZXMnXG5cbmNvbnN0IGtpbmQgPSAoeyBkYXJrLCBraW5kLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoa2luZCkge1xuICAgIGNhc2UgJ3ByaW1hcnknOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgY29sb3I6ICR7Y29sb3IoJ2luaycsIHsgdGhlbWUgfSl9O1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCdsaWdodEJyYW5kR3JlZW4nLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKCdsaWdodEJyYW5kR3JlZW4nLCB7IHRoZW1lIH0pfTtcblxuICAgICAgICAmOmhvdmVyLFxuICAgICAgICAmOmFjdGl2ZSxcbiAgICAgICAgJi5mb2N1cy12aXNpYmxlIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCdsaWdodGVyQnJhbmRHcmVlbicsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcignbGlnaHRlckJyYW5kR3JlZW4nLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgfVxuXG4gICAgICAgICY6ZGlzYWJsZWQge1xuICAgICAgICAgIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3NpbHZlcicsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcignc2lsdmVyJywgeyB0aGVtZSB9KX07XG4gICAgICAgIH1cbiAgICAgIGBcbiAgICBjYXNlICdzdGFuZGFyZCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBjb2xvcjogJHtkYXJrID8gY29sb3IoJ3doaXRlJywgeyB0aGVtZSB9KSA6IGNvbG9yKCdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2RhcmtcbiAgICAgICAgICA/IGNvbG9yKCdpbmsnLCB7IHRoZW1lIH0pXG4gICAgICAgICAgOiBjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiAke2RhcmtcbiAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuNSwgeyB0aGVtZSB9KVxuICAgICAgICAgIDogdHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC41LCB7IHRoZW1lIH0pfTtcblxuICAgICAgICAmOmhvdmVyLFxuICAgICAgICAmOmFjdGl2ZSxcbiAgICAgICAgJi5mb2N1cy12aXNpYmxlIHtcbiAgICAgICAgICBjb2xvcjogJHtkYXJrID8gY29sb3IoJ2luaycsIHsgdGhlbWUgfSkgOiBjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2RhcmtcbiAgICAgICAgICAgID8gY29sb3IoJ3doaXRlJywgeyB0aGVtZSB9KVxuICAgICAgICAgICAgOiBjb2xvcignc2xhdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgICBib3JkZXItY29sb3I6ICR7ZGFya1xuICAgICAgICAgICAgPyBjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pXG4gICAgICAgICAgICA6IGNvbG9yKCdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgICB9XG5cbiAgICAgICAgJjpkaXNhYmxlZCB7XG4gICAgICAgICAgY29sb3I6ICR7ZGFya1xuICAgICAgICAgICAgPyB0cmFuc3BhcmVudGl6ZSgnb2ZmV2hpdGUnLCAwLjMsIHsgdGhlbWUgfSlcbiAgICAgICAgICAgIDogdHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC4zLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2RhcmtcbiAgICAgICAgICAgID8gdHJhbnNwYXJlbnRpemUoJ29mZldoaXRlJywgMC4yLCB7IHRoZW1lIH0pXG4gICAgICAgICAgICA6IHRyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuMSwgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYm9yZGVyLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgICAgICAgfVxuICAgICAgYFxuICAgIGNhc2UgJ3V0aWxpdHknOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgY29sb3I6ICR7ZGFya1xuICAgICAgICAgID8gY29sb3IoJ29mZldoaXRlJywgeyB0aGVtZSB9KVxuICAgICAgICAgIDogY29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7ZGFya1xuICAgICAgICAgID8gdHJhbnNwYXJlbnRpemUoJ29mZldoaXRlJywgMC4yLCB7IHRoZW1lIH0pXG4gICAgICAgICAgOiB0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjA4LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYm9yZGVyLWNvbG9yOiB0cmFuc3BhcmVudDtcblxuICAgICAgICAmOmhvdmVyLFxuICAgICAgICAmOmFjdGl2ZSxcbiAgICAgICAgJi5mb2N1cy12aXNpYmxlIHtcbiAgICAgICAgICBjb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IGNvbG9yKCdvZmZXaGl0ZScsIHsgdGhlbWUgfSlcbiAgICAgICAgICAgIDogY29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuMywgeyB0aGVtZSB9KVxuICAgICAgICAgICAgOiB0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjE2LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgfVxuXG4gICAgICAgICY6ZGlzYWJsZWQge1xuICAgICAgICAgIGNvbG9yOiAke2RhcmtcbiAgICAgICAgICAgID8gdHJhbnNwYXJlbnRpemUoJ29mZldoaXRlJywgMC4zLCB7IHRoZW1lIH0pXG4gICAgICAgICAgICA6IHRyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuMywgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuMiwgeyB0aGVtZSB9KVxuICAgICAgICAgICAgOiB0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjEsIHsgdGhlbWUgfSl9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAnZ2hvc3QnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgY29sb3I6ICR7ZGFya1xuICAgICAgICAgID8gY29sb3IoJ29mZldoaXRlJywgeyB0aGVtZSB9KVxuICAgICAgICAgIDogY29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgIGJhY2tncm91bmQ6IG5vbmU7XG4gICAgICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG5cbiAgICAgICAgJjpob3ZlcixcbiAgICAgICAgJjphY3RpdmUsXG4gICAgICAgICYuZm9jdXMtdmlzaWJsZSB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuMTYsIHsgdGhlbWUgfSlcbiAgICAgICAgICAgIDogdHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC4wOCwgeyB0aGVtZSB9KX07XG4gICAgICAgIH1cblxuICAgICAgICAmOmRpc2FibGVkIHtcbiAgICAgICAgICBjb2xvcjogJHtkYXJrXG4gICAgICAgICAgICA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuMywgeyB0aGVtZSB9KVxuICAgICAgICAgICAgOiB0cmFuc3BhcmVudGl6ZSgnc2xhdGUnLCAwLjMsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJhY2tncm91bmQ6ICR7ZGFyayA/ICdub25lJyA6ICdpbmhlcml0J307XG4gICAgICAgIH1cbiAgICAgIGBcblxuICAgIGNhc2UgJ2Rhbmdlcic6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBjb2xvcjogJHtjb2xvcignb2ZmV2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcigncmVkJywgeyB0aGVtZSB9KX07XG4gICAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcigncmVkJywgeyB0aGVtZSB9KX07XG5cbiAgICAgICAgJjpob3ZlcixcbiAgICAgICAgJjphY3RpdmUsXG4gICAgICAgICYuZm9jdXMtdmlzaWJsZSB7XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignZGFya1JlZCcsIHsgdGhlbWUgfSl9O1xuICAgICAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcignZGFya1JlZCcsIHsgdGhlbWUgfSl9O1xuICAgICAgICB9XG5cbiAgICAgICAgJjpkaXNhYmxlZCB7XG4gICAgICAgICAgY29sb3I6ICR7Y29sb3IoJ3doaXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignc2lsdmVyJywgeyB0aGVtZSB9KX07XG4gICAgICAgICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKCdzaWx2ZXInLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgfVxuICAgICAgYFxuXG4gICAgZGVmYXVsdDpcbiAgICAvLyBub3RoaW5nXG4gIH1cbn1cblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnbGcnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHtwYWRkaW5nKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke2ZvbnRTaXplKCdzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gICAgY2FzZSAnc20nOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHtwYWRkaW5nKCd4eHhzJywgeyB0aGVtZSB9KX07XG4gICAgICAgICR7Zm9udFNpemUoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke2ZvbnRTaXplKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IGJsb2NrID0gKHsgYmxvY2sgfSkgPT5cbiAgYmxvY2sgJiZcbiAgY3NzYFxuICAgIHdpZHRoOiAxMDAlO1xuICBgXG5cbmNvbnN0IG1hcmdpbiA9ICh7XG4gIG1hcmdpbkxlZnQsXG4gIG1hcmdpblJpZ2h0LFxuICBtYXJnaW5Ub3AsXG4gIG1hcmdpbkJvdHRvbSxcbiAgd2l0aE1hcmdpbnMsXG4gIHRoZW1lXG59KSA9PiBjc3NgXG4gICR7KG1hcmdpbkxlZnQgfHwgd2l0aE1hcmdpbnMpICYmIGBtYXJnaW4tbGVmdDogJHtzcGFjZXIoMiwgeyB0aGVtZSB9KX1gfTtcbiAgJHsobWFyZ2luUmlnaHQgfHwgd2l0aE1hcmdpbnMpICYmIGBtYXJnaW4tcmlnaHQ6ICR7c3BhY2VyKDIsIHsgdGhlbWUgfSl9YH07XG4gICR7KG1hcmdpblRvcCB8fCB3aXRoTWFyZ2lucykgJiYgYG1hcmdpbi10b3A6ICR7c3BhY2VyKDIsIHsgdGhlbWUgfSl9YH07XG4gICR7KG1hcmdpbkJvdHRvbSB8fCB3aXRoTWFyZ2lucykgJiYgYG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDIsIHsgdGhlbWUgfSl9YH07XG5gXG5cbmNvbnN0IEJ1dHRvbiA9IHN0eWxlZC5idXR0b25gXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICB1c2VyLXNlbGVjdDogbm9uZTtcbiAgY29sb3I6IGN1cnJlbnRDb2xvcjtcbiAgZm9udC1mYW1pbHk6IGluaGVyaXQ7XG4gIGJvcmRlci13aWR0aDogMXB4O1xuICBib3JkZXItc3R5bGU6IHNvbGlkO1xuICBmbGV4LXNocmluazogMDtcbiAgdHJhbnNpdGlvbjogY29sb3IgMC4xcyBlYXNlLWluLW91dCwgYmFja2dyb3VuZC1jb2xvciAwLjFzIGVhc2UtaW4tb3V0LFxuICAgIGJvcmRlci1jb2xvciAwLjFzIGVhc2UtaW4tb3V0LCBib3gtc2hhZG93IDAuMXMgZWFzZS1pbi1vdXQgMHM7XG4gICR7Zm9udFdlaWdodCgnYm9sZCcpfTtcbiAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnKX07XG5cbiAgJjplbmFibGVkIHtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIH1cblxuICAmOmhvdmVyLFxuICAmOmZvY3VzIHtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gICAgb3V0bGluZTogMDtcbiAgfVxuXG4gICY6aG92ZXIsXG4gICY6Zm9jdXMge1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuXG4gICY6ZGlzYWJsZWQge1xuICAgIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gIH1cblxuICAke2tpbmR9O1xuICAke3NpemV9O1xuICAke2Jsb2NrfTtcbiAgJHttYXJnaW59O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBCdXR0b25cbiJdfQ== */"));

    case 'danger':
      return /*#__PURE__*/core.css("color:", color('offWhite', {
        theme: theme
      }), ";background-color:", color('red', {
        theme: theme
      }), ";border-color:", color('red', {
        theme: theme
      }), ";&:hover,&:active,&.focus-visible{background-color:", color('darkRed', {
        theme: theme
      }), ";border-color:", color('darkRed', {
        theme: theme
      }), ";}&:disabled{color:", color('white', {
        theme: theme
      }), ";background-color:", color('silver', {
        theme: theme
      }), ";border-color:", color('silver', {
        theme: theme
      }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

  }
};

var size$5 = function size(_ref3) {
  var size = _ref3.size,
      theme = _ref3.theme;

  switch (size) {
    case 'lg':
      return /*#__PURE__*/core.css(padding('xs', {
        theme: theme
      }), ";", fontSize('s', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    case 'sm':
      return /*#__PURE__*/core.css(padding('xxxs', {
        theme: theme
      }), ";", fontSize('xxs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    default:
      return /*#__PURE__*/core.css(padding('xxs', {
        theme: theme
      }), ";", fontSize('xs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  }
};

var _ref$5 =  true ? {
  name: "8atqhb",
  styles: "width:100%;"
} : {
  name: "8atqhb",
  styles: "width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
};

var block = function block(_ref4) {
  var block = _ref4.block;
  return block && _ref$5;
};

var margin$1 = function margin(_ref5) {
  var marginLeft = _ref5.marginLeft,
      marginRight = _ref5.marginRight,
      marginTop = _ref5.marginTop,
      marginBottom = _ref5.marginBottom,
      withMargins = _ref5.withMargins,
      theme = _ref5.theme;
  return /*#__PURE__*/core.css((marginLeft || withMargins) && "margin-left: ".concat(spacer(2, {
    theme: theme
  })), ";", (marginRight || withMargins) && "margin-right: ".concat(spacer(2, {
    theme: theme
  })), ";", (marginTop || withMargins) && "margin-top: ".concat(spacer(2, {
    theme: theme
  })), ";", (marginBottom || withMargins) && "margin-bottom: ".concat(spacer(2, {
    theme: theme
  })), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var Button = createStyled("button", {
  target: "e16kt4pu0",
  label: "Button"
})("display:inline-block;text-align:center;white-space:nowrap;vertical-align:middle;user-select:none;color:currentColor;font-family:inherit;border-width:1px;border-style:solid;flex-shrink:0;transition:color 0.1s ease-in-out,background-color 0.1s ease-in-out,border-color 0.1s ease-in-out,box-shadow 0.1s ease-in-out 0s;", fontWeight('bold'), ";", borderRadius('default'), ";&:enabled{cursor:pointer;}&:hover,&:focus{text-decoration:none;outline:0;}&:hover,&:focus{cursor:pointer;}&:disabled{cursor:not-allowed;}", kind$2, ";", size$5, ";", block, ";", margin$1, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var ButtonLink = Button.withComponent(function (_ref) {
  var block = _ref.block,
      dark = _ref.dark,
      withMargins = _ref.withMargins,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight,
      marginTop = _ref.marginTop,
      marginBottom = _ref.marginBottom,
      rest = _objectWithoutProperties(_ref, ["block", "dark", "withMargins", "marginLeft", "marginRight", "marginTop", "marginBottom"]);

  return /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Link, rest);
}, {
  target: "e1hm67to0",
  label: "ButtonLink"
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var CheckboxHidden = recompose.withProps({
  type: 'checkbox'
})(createStyled("input", {
  target: "e1gydqdp0",
  label: "CheckboxHidden"
})( true ? {
  name: "sz9j72",
  styles: "opacity:0;position:absolute;z-index:-1;"
} : {
  name: "sz9j72",
  styles: "opacity:0;position:absolute;z-index:-1;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrYm94SGlkZGVuLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtlIiwiZmlsZSI6IkNoZWNrYm94SGlkZGVuLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnXG5cbmNvbnN0IENoZWNrYm94SGlkZGVuID0gd2l0aFByb3BzKHtcbiAgdHlwZTogJ2NoZWNrYm94J1xufSkoc3R5bGVkLmlucHV0YFxuICBvcGFjaXR5OiAwO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHotaW5kZXg6IC0xO1xuYClcblxuZXhwb3J0IGRlZmF1bHQgQ2hlY2tib3hIaWRkZW5cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
}));

var checkboxBackgroundColor = function checkboxBackgroundColor(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled;

  if (disabled) {
    return checked ? 'silver' : 'offWhite';
  }

  return checked && 'brandGreen';
};

var checkboxBorderColor = function checkboxBorderColor(_ref2) {
  var checked = _ref2.checked,
      disabled = _ref2.disabled,
      valid = _ref2.valid;

  if (disabled) {
    return 'silver';
  } else if (!valid) {
    return 'red';
  }

  return !checked && 'cadet';
};

var findColor = function findColor(props) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
    return key;
  };
  var colorKey = fn(props);

  if (colorKey) {
    return color(colorKey)({
      theme: props.theme
    });
  }

  return 'transparent';
};

var CheckboxDisplay = createStyled("div", {
  target: "esu9zsz0",
  label: "CheckboxDisplay"
})("background-color:", function (props) {
  return findColor(props, checkboxBackgroundColor);
}, ";border:solid 0.0675rem ", function (props) {
  return findColor(props, checkboxBorderColor);
}, ";border-radius:0.125rem;height:", spacer(4), ";width:", spacer(4), ";display:inline-block;margin-right:", spacer(3), ";margin-left:-1px;vertical-align:middle;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrYm94RGlzcGxheS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0QmtDIiwiZmlsZSI6IkNoZWNrYm94RGlzcGxheS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY29sb3IsIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgY2hlY2tib3hCYWNrZ3JvdW5kQ29sb3IgPSAoeyBjaGVja2VkLCBkaXNhYmxlZCB9KSA9PiB7XG4gIGlmIChkaXNhYmxlZCkge1xuICAgIHJldHVybiBjaGVja2VkID8gJ3NpbHZlcicgOiAnb2ZmV2hpdGUnXG4gIH1cbiAgcmV0dXJuIGNoZWNrZWQgJiYgJ2JyYW5kR3JlZW4nXG59XG5cbmNvbnN0IGNoZWNrYm94Qm9yZGVyQ29sb3IgPSAoeyBjaGVja2VkLCBkaXNhYmxlZCwgdmFsaWQgfSkgPT4ge1xuICBpZiAoZGlzYWJsZWQpIHtcbiAgICByZXR1cm4gJ3NpbHZlcidcbiAgfSBlbHNlIGlmICghdmFsaWQpIHtcbiAgICByZXR1cm4gJ3JlZCdcbiAgfVxuXG4gIHJldHVybiAhY2hlY2tlZCAmJiAnY2FkZXQnXG59XG5cbmNvbnN0IGZpbmRDb2xvciA9IChwcm9wcywgZm4gPSBrZXkgPT4ga2V5KSA9PiB7XG4gIGNvbnN0IGNvbG9yS2V5ID0gZm4ocHJvcHMpXG4gIGlmIChjb2xvcktleSkge1xuICAgIHJldHVybiBjb2xvcihjb2xvcktleSkoeyB0aGVtZTogcHJvcHMudGhlbWUgfSlcbiAgfVxuICByZXR1cm4gJ3RyYW5zcGFyZW50J1xufVxuXG5jb25zdCBDaGVja2JveERpc3BsYXkgPSBzdHlsZWQuZGl2YFxuICBiYWNrZ3JvdW5kLWNvbG9yOiAke3Byb3BzID0+IGZpbmRDb2xvcihwcm9wcywgY2hlY2tib3hCYWNrZ3JvdW5kQ29sb3IpfTtcbiAgYm9yZGVyOiBzb2xpZCAwLjA2NzVyZW0gJHtwcm9wcyA9PiBmaW5kQ29sb3IocHJvcHMsIGNoZWNrYm94Qm9yZGVyQ29sb3IpfTtcbiAgYm9yZGVyLXJhZGl1czogMC4xMjVyZW07XG4gIGhlaWdodDogJHtzcGFjZXIoNCl9O1xuICB3aWR0aDogJHtzcGFjZXIoNCl9O1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIG1hcmdpbi1yaWdodDogJHtzcGFjZXIoMyl9O1xuICBtYXJnaW4tbGVmdDogLTFweDtcbiAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgQ2hlY2tib3hEaXNwbGF5XG4iXX0= */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Label = createStyled("label", {
  target: "ex0aosg0",
  label: "Label"
})("display:flex;align-items:center;margin-bottom:0;cursor:", function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var LabelText = createStyled("span", {
  target: "ex0aosg1",
  label: "LabelText"
})("margin-bottom:0;color:", color('slate'), ";vertical-align:middle;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var CheckboxContainer = createStyled("div", {
  target: "ex0aosg2",
  label: "CheckboxContainer"
})( true ? {
  name: "79elbk",
  styles: "position:relative;"
} : {
  name: "79elbk",
  styles: "position:relative;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});

var Checkbox = function Checkbox(_ref2) {
  var checked = _ref2.checked,
      label = _ref2.label,
      disabled = _ref2.disabled,
      valid = _ref2.valid,
      id = _ref2.id,
      theme = _ref2.theme,
      rest = _objectWithoutProperties(_ref2, ["checked", "label", "disabled", "valid", "id", "theme"]);

  return /*#__PURE__*/React__default['default'].createElement(CheckboxContainer, null, /*#__PURE__*/React__default['default'].createElement(CheckboxHidden, _extends({
    checked: checked,
    disabled: disabled,
    id: id
  }, rest)), /*#__PURE__*/React__default['default'].createElement(Label, {
    disabled: disabled,
    htmlFor: id
  }, /*#__PURE__*/React__default['default'].createElement(CheckboxDisplay, {
    checked: checked,
    disabled: disabled,
    valid: valid
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "-4 -6 20 20"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none"
  }, checked && /*#__PURE__*/React__default['default'].createElement("path", {
    stroke: color('white')({
      theme: theme
    }),
    strokeWidth: "2",
    d: "M1.5 3.75l3 3 6-6"
  })))), /*#__PURE__*/React__default['default'].createElement(LabelText, null, label)));
};

Checkbox.propTypes = {
  checked: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  label: PropTypes__default['default'].node,
  valid: PropTypes__default['default'].bool,
  id: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func
};
Checkbox.defaultProps = {
  onChange: function onChange() {},
  checked: false,
  disabled: false,
  valid: true
};
var Checkbox$1 = emotionTheming.withTheme(Checkbox);

var sizeWithDefault = recompose.compose(defaultTo('1.75rem'), prop('size'));

var CloseButton = /*#__PURE__*/createStyled(recompose.withProps({
  kind: 'ghost',
  size: 'sm',
  children: /*#__PURE__*/React__default['default'].createElement(Cancel, {
    size: "80%"
  })
})(Button), {
  target: "em0p5l20",
  label: "CloseButton"
})("padding:0;display:flex;align-items:center;justify-content:center;border-radius:50%;width:", sizeWithDefault, ";height:", sizeWithDefault, ";svg{fill:", transparentize('slate', 0.5), ";transition:fill 0.1s ease-out;}&:hover{svg{opacity:1;fill:", color('slate'), ";}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNsb3NlQnV0dG9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCQyIsImZpbGUiOiJDbG9zZUJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBCdXR0b24gZnJvbSAnLi9CdXR0b24nXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCBDYW5jZWxJY29uIGZyb20gJy4vaWNvbnMvQ2FuY2VsJ1xuaW1wb3J0IHsgY29sb3IsIHNwYWNlciwgdHJhbnNwYXJlbnRpemUgfSBmcm9tICcuLi9zdHlsZXMnXG5pbXBvcnQgeyBjb21wb3NlLCBkZWZhdWx0VG8sIHByb3AgfSBmcm9tICcuLi91dGlscy9mcCdcbmltcG9ydCB7IHdpdGhQcm9wcyB9IGZyb20gJ3JlY29tcG9zZSdcblxuY29uc3Qgc2l6ZVdpdGhEZWZhdWx0ID0gY29tcG9zZShkZWZhdWx0VG8oJzEuNzVyZW0nKSwgcHJvcCgnc2l6ZScpKVxuXG5jb25zdCBDbG9zZUJ1dHRvbiA9IHN0eWxlZChcbiAgd2l0aFByb3BzKHtcbiAgICBraW5kOiAnZ2hvc3QnLFxuICAgIHNpemU6ICdzbScsXG4gICAgY2hpbGRyZW46IDxDYW5jZWxJY29uIHNpemU9XCI4MCVcIiAvPlxuICB9KShCdXR0b24pXG4pYFxuICBwYWRkaW5nOiAwO1xuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICB3aWR0aDogJHtzaXplV2l0aERlZmF1bHR9O1xuICBoZWlnaHQ6ICR7c2l6ZVdpdGhEZWZhdWx0fTtcblxuICBzdmcge1xuICAgIGZpbGw6ICR7dHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC41KX07XG4gICAgdHJhbnNpdGlvbjogZmlsbCAwLjFzIGVhc2Utb3V0O1xuICB9XG5cbiAgJjpob3ZlciB7XG4gICAgc3ZnIHtcbiAgICAgIG9wYWNpdHk6IDE7XG4gICAgICBmaWxsOiAke2NvbG9yKCdzbGF0ZScpfTtcbiAgICB9XG4gIH1cbmBcblxuZXhwb3J0IGRlZmF1bHQgQ2xvc2VCdXR0b25cbiJdfQ== */"));

var Code = createStyled("code", {
  target: "e1d25doh0",
  label: "Code"
})("background:", color('paleGrey'), ";padding:0.1rem ", spacer(1), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvZGUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3dCIiwiZmlsZSI6IkNvZGUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNvbG9yLCBzcGFjZXIgfSBmcm9tICcuLi9zdHlsZXMnXG5cbmNvbnN0IENvZGUgPSBzdHlsZWQuY29kZWBcbiAgYmFja2dyb3VuZDogJHtjb2xvcigncGFsZUdyZXknKX07XG4gIHBhZGRpbmc6IDAuMXJlbSAke3NwYWNlcigxKX07XG5gXG5cbmV4cG9ydCBkZWZhdWx0IENvZGVcbiJdfQ== */"));

var Container$3 = createStyled("div", {
  target: "eqbar9n0",
  label: "Container"
})("padding-left:", spacer(4), ";padding-right:", spacer(4), ";", responsiveContainer, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyByZXNwb25zaXZlQ29udGFpbmVyLCBzcGFjZXIgfSBmcm9tICcuLi9zdHlsZXMnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBhZGRpbmctbGVmdDogJHtzcGFjZXIoNCl9O1xuICBwYWRkaW5nLXJpZ2h0OiAke3NwYWNlcig0KX07XG4gICR7cmVzcG9uc2l2ZUNvbnRhaW5lcn07XG5gXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */"));

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0%, 24% {\n    transform: rotate(0deg) scale(1);\n  }\n  3% {\n    transform: rotate(8deg) scale(1.12);\n  }\n  9% {\n    transform: rotate(-8deg) scale(1.16);\n  }\n  15% {\n    transform: rotate(8deg) scale(1.16);\n  }\n  21% {\n    transform: rotate(-8deg) scale(1.12);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PolicyContainer = createStyled("div", {
  target: "e1tgyhq40",
  label: "PolicyContainer"
})("position:fixed;bottom:0;left:0;width:100%;background:", color('slate'), ";z-index:9999;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var PolicyText = createStyled("div", {
  target: "e1tgyhq41",
  label: "PolicyText"
})("flex:1;color:", color('white'), ";padding-right:", spacer(3), ";", fontSize('xs'), ";", mediaDn('sm'), "{padding-right:0;margin-bottom:", spacer(3), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Content = /*#__PURE__*/createStyled(Container$3, {
  target: "e1tgyhq42",
  label: "Content"
})("display:flex;justify-content:center;margin:0 auto;", padding('md'), ";", mediaUp('sm'), "{align-items:center;}", mediaDn('sm'), "{flex-direction:column;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var shake = core.keyframes(_templateObject());
var shakeAnimation = /*#__PURE__*/core.css("animation:", shake, " 5s ease-in-out;transform-origin:center;animation-iteration-count:infinite;;label:shakeAnimation;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var AcceptButton = /*#__PURE__*/createStyled(Button, {
  target: "e1tgyhq43",
  label: "AcceptButton"
})(function (_ref) {
  var highlighted = _ref.highlighted;
  return highlighted && shakeAnimation;
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var CookieBanner = function CookieBanner(_ref2) {
  var children = _ref2.children,
      onAccept = _ref2.onAccept,
      highlighted = _ref2.highlighted;
  return /*#__PURE__*/React__default['default'].createElement(PolicyContainer, null, /*#__PURE__*/React__default['default'].createElement(Content, null, /*#__PURE__*/React__default['default'].createElement(PolicyText, null, children), /*#__PURE__*/React__default['default'].createElement(AcceptButton, {
    kind: "primary",
    onClick: onAccept,
    highlighted: highlighted
  }, "Accept")));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$6 =  true ? {
  name: "y9l4wz-Backdrop",
  styles: "visibility:visible;opacity:1;;label:Backdrop;"
} : {
  name: "y9l4wz-Backdrop",
  styles: "visibility:visible;opacity:1;;label:Backdrop;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9CVyIsImZpbGUiOiJCYWNrZHJvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBCYWNrZHJvcCA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgYmFja2dyb3VuZDogJHt0cmFuc3BhcmVudGl6ZSgncGV3dGVyJywgMC42KX07XG4gIHRyYW5zaXRpb246IGFsbCAwLjNzO1xuICB6LWluZGV4OiAxMDQ5O1xuXG4gICR7KHsgdG9wID0gJzAnIH0pID0+XG4gICAgY3NzYFxuICAgICAgdG9wOiAke3RvcH07XG4gICAgYH1cblxuICAkeyh7IG9wZW4gfSkgPT5cbiAgICBvcGVuXG4gICAgICA/IGNzc2BcbiAgICAgICAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICAgIGBcbiAgICAgIDogY3NzYFxuICAgICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgICBvcGFjaXR5OiAwO1xuICAgICAgICBgfVxuYFxuXG5CYWNrZHJvcC5kaXNwbGF5TmFtZSA9ICdEcmF3ZXIuQmFja2Ryb3AnXG5cbmV4cG9ydCBkZWZhdWx0IEJhY2tkcm9wXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
};

var _ref2$2 =  true ? {
  name: "ny7m-Backdrop",
  styles: "visibility:hidden;opacity:0;;label:Backdrop;"
} : {
  name: "ny7m-Backdrop",
  styles: "visibility:hidden;opacity:0;;label:Backdrop;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCVyIsImZpbGUiOiJCYWNrZHJvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBCYWNrZHJvcCA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgYmFja2dyb3VuZDogJHt0cmFuc3BhcmVudGl6ZSgncGV3dGVyJywgMC42KX07XG4gIHRyYW5zaXRpb246IGFsbCAwLjNzO1xuICB6LWluZGV4OiAxMDQ5O1xuXG4gICR7KHsgdG9wID0gJzAnIH0pID0+XG4gICAgY3NzYFxuICAgICAgdG9wOiAke3RvcH07XG4gICAgYH1cblxuICAkeyh7IG9wZW4gfSkgPT5cbiAgICBvcGVuXG4gICAgICA/IGNzc2BcbiAgICAgICAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICAgIGBcbiAgICAgIDogY3NzYFxuICAgICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgICBvcGFjaXR5OiAwO1xuICAgICAgICBgfVxuYFxuXG5CYWNrZHJvcC5kaXNwbGF5TmFtZSA9ICdEcmF3ZXIuQmFja2Ryb3AnXG5cbmV4cG9ydCBkZWZhdWx0IEJhY2tkcm9wXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
};

var Backdrop = createStyled("div", {
  target: "e7dcb8b0",
  label: "Backdrop"
})("position:fixed;left:0;right:0;bottom:0;background:", transparentize('pewter', 0.6), ";transition:all 0.3s;z-index:1049;", function (_ref3) {
  var _ref3$top = _ref3.top,
      top = _ref3$top === void 0 ? '0' : _ref3$top;
  return /*#__PURE__*/core.css("top:", top, ";;label:Backdrop;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNPIiwiZmlsZSI6IkJhY2tkcm9wLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IEJhY2tkcm9wID0gc3R5bGVkLmRpdmBcbiAgcG9zaXRpb246IGZpeGVkO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICBiYWNrZ3JvdW5kOiAke3RyYW5zcGFyZW50aXplKCdwZXd0ZXInLCAwLjYpfTtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3M7XG4gIHotaW5kZXg6IDEwNDk7XG5cbiAgJHsoeyB0b3AgPSAnMCcgfSkgPT5cbiAgICBjc3NgXG4gICAgICB0b3A6ICR7dG9wfTtcbiAgICBgfVxuXG4gICR7KHsgb3BlbiB9KSA9PlxuICAgIG9wZW5cbiAgICAgID8gY3NzYFxuICAgICAgICAgIHZpc2liaWxpdHk6IHZpc2libGU7XG4gICAgICAgICAgb3BhY2l0eTogMTtcbiAgICAgICAgYFxuICAgICAgOiBjc3NgXG4gICAgICAgICAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICAgICAgICAgIG9wYWNpdHk6IDA7XG4gICAgICAgIGB9XG5gXG5cbkJhY2tkcm9wLmRpc3BsYXlOYW1lID0gJ0RyYXdlci5CYWNrZHJvcCdcblxuZXhwb3J0IGRlZmF1bHQgQmFja2Ryb3BcbiJdfQ== */"));
}, " ", function (_ref4) {
  var open = _ref4.open;
  return open ? _ref$6 : _ref2$2;
},  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUkyQiIsImZpbGUiOiJCYWNrZHJvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBCYWNrZHJvcCA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgYmFja2dyb3VuZDogJHt0cmFuc3BhcmVudGl6ZSgncGV3dGVyJywgMC42KX07XG4gIHRyYW5zaXRpb246IGFsbCAwLjNzO1xuICB6LWluZGV4OiAxMDQ5O1xuXG4gICR7KHsgdG9wID0gJzAnIH0pID0+XG4gICAgY3NzYFxuICAgICAgdG9wOiAke3RvcH07XG4gICAgYH1cblxuICAkeyh7IG9wZW4gfSkgPT5cbiAgICBvcGVuXG4gICAgICA/IGNzc2BcbiAgICAgICAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICAgIGBcbiAgICAgIDogY3NzYFxuICAgICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgICBvcGFjaXR5OiAwO1xuICAgICAgICBgfVxuYFxuXG5CYWNrZHJvcC5kaXNwbGF5TmFtZSA9ICdEcmF3ZXIuQmFja2Ryb3AnXG5cbmV4cG9ydCBkZWZhdWx0IEJhY2tkcm9wXG4iXX0= */");

Backdrop.displayName = 'Drawer.Backdrop';

var MenuItem = createStyled("li", {
  target: "e394io00",
  label: "MenuItem"
})("display:block;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width:100%;", padding('xxs'), ";", typography('body2'), ";&:hover{background-color:", transparentize('green', 0.15), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnVJdGVtLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUcwQiIsImZpbGUiOiJNZW51SXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgcGFkZGluZywgdHJhbnNwYXJlbnRpemUsIHR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IE1lbnVJdGVtID0gc3R5bGVkLmxpYFxuICBkaXNwbGF5OiBibG9jaztcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgd2lkdGg6IDEwMCU7XG5cbiAgJHtwYWRkaW5nKCd4eHMnKX07XG4gICR7dHlwb2dyYXBoeSgnYm9keTInKX07XG5cbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnZ3JlZW4nLCAwLjE1KX07XG4gIH1cbmBcblxuZXhwb3J0IGRlZmF1bHQgTWVudUl0ZW1cbiJdfQ== */"));

var Menu = createStyled("ul", {
  target: "e66316c0",
  label: "Menu"
})("list-style:none;margin:0;padding:", spacer(1), " 0;color:", color('black'), ";background-color:", color('white'), ";overflow:hidden;width:100%;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3NCIiwiZmlsZSI6Ik1lbnUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNvbG9yLCBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IE1lbnUgPSBzdHlsZWQudWxgXG4gIGxpc3Qtc3R5bGU6IG5vbmU7XG4gIG1hcmdpbjogMDtcbiAgcGFkZGluZzogJHtzcGFjZXIoMSl9IDA7XG4gIGNvbG9yOiAke2NvbG9yKCdibGFjaycpfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignd2hpdGUnKX07XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHdpZHRoOiAxMDAlO1xuYFxuXG5leHBvcnQgZGVmYXVsdCBNZW51XG4iXX0= */"));

var Section = createStyled("div", {
  target: "ee3e8x80",
  label: "Section"
})("&:not(:last-of-type){margin-bottom:", spacer(1), ";padding-bottom:", spacer(1), ";border-bottom:1px solid ", color('paleGrey'), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY3Rpb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRzBCIiwiZmlsZSI6IlNlY3Rpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNvbG9yLCBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IFNlY3Rpb24gPSBzdHlsZWQuZGl2YFxuICAmOm5vdCg6bGFzdC1vZi10eXBlKSB7XG4gICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoMSl9O1xuICAgIHBhZGRpbmctYm90dG9tOiAke3NwYWNlcigxKX07XG4gICAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICR7Y29sb3IoJ3BhbGVHcmV5Jyl9O1xuICB9XG5gXG5cblNlY3Rpb24uZGlzcGxheU5hbWUgPSAnRHJhd2VyLlNlY3Rpb24nXG5cbmV4cG9ydCBkZWZhdWx0IFNlY3Rpb25cbiJdfQ== */"));

Section.displayName = 'Drawer.Section';

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$7 =  true ? {
  name: "1xvdj0m-StyledDrawer",
  styles: "right:0;;label:StyledDrawer;"
} : {
  name: "1xvdj0m-StyledDrawer",
  styles: "right:0;;label:StyledDrawer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};

var _ref2$3 =  true ? {
  name: "1pewjvw-StyledDrawer",
  styles: "left:0;;label:StyledDrawer;"
} : {
  name: "1pewjvw-StyledDrawer",
  styles: "left:0;;label:StyledDrawer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};

var _ref3$1 =  true ? {
  name: "e6xju2-StyledDrawer",
  styles: "transform:translate(0);;label:StyledDrawer;"
} : {
  name: "e6xju2-StyledDrawer",
  styles: "transform:translate(0);;label:StyledDrawer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};

var _ref4 =  true ? {
  name: "d68r64-StyledDrawer",
  styles: "transform:translate(100%);;label:StyledDrawer;"
} : {
  name: "d68r64-StyledDrawer",
  styles: "transform:translate(100%);;label:StyledDrawer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};

var _ref5 =  true ? {
  name: "3kykr3-StyledDrawer",
  styles: "transform:translate(-100%);;label:StyledDrawer;"
} : {
  name: "3kykr3-StyledDrawer",
  styles: "transform:translate(-100%);;label:StyledDrawer;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
};

var StyledDrawer = createStyled("div", {
  target: "ei3r4r10",
  label: "StyledDrawer"
})("transition:all 0.3s ease-in-out;position:fixed;box-shadow:0 3px 8px 0 rgba(22,38,59,0.2);z-index:1015;overflow:hidden;background:white;", function (_ref6) {
  var _ref6$width = _ref6.width,
      width = _ref6$width === void 0 ? '200px' : _ref6$width;
  return /*#__PURE__*/core.css("width:", width, ";;label:StyledDrawer;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
}, " ", function (_ref7) {
  var _ref7$height = _ref7.height,
      height = _ref7$height === void 0 ? '100vh' : _ref7$height;
  return /*#__PURE__*/core.css("height:", height, ";;label:StyledDrawer;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
}, " ", function (_ref8) {
  var _ref8$top = _ref8.top,
      top = _ref8$top === void 0 ? '0' : _ref8$top;
  return /*#__PURE__*/core.css("top:", top, ";;label:StyledDrawer;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTJCTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyB1c2VFZmZlY3QsIHVzZVJlZiwgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCBCYWNrZHJvcCBmcm9tICcuL0JhY2tkcm9wJ1xuaW1wb3J0IE1lbnVJdGVtIGZyb20gJy4vTWVudUl0ZW0nXG5pbXBvcnQgTWVudSBmcm9tICcuL01lbnUnXG5pbXBvcnQgU2VjdGlvbiBmcm9tICcuL1NlY3Rpb24nXG5cbmNvbnN0IFN0eWxlZERyYXdlciA9IHN0eWxlZC5kaXZgXG4gIHRyYW5zaXRpb246IGFsbCAwLjNzIGVhc2UtaW4tb3V0O1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIGJveC1zaGFkb3c6IDAgM3B4IDhweCAwIHJnYmEoMjIsIDM4LCA1OSwgMC4yKTtcbiAgei1pbmRleDogMTAxNTtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgYmFja2dyb3VuZDogd2hpdGU7XG5cbiAgJHsoeyB3aWR0aCA9ICcyMDBweCcgfSkgPT5cbiAgICBjc3NgXG4gICAgICB3aWR0aDogJHt3aWR0aH07XG4gICAgYH1cblxuICAkeyh7IGhlaWdodCA9ICcxMDB2aCcgfSkgPT5cbiAgICBjc3NgXG4gICAgICBoZWlnaHQ6ICR7aGVpZ2h0fTtcbiAgICBgfVxuXG4gICR7KHsgdG9wID0gJzAnIH0pID0+XG4gICAgY3NzYFxuICAgICAgdG9wOiAke3RvcH07XG4gICAgYH1cblxuICAkeyh7IHNpZGUgfSkgPT5cbiAgICBzaWRlID09PSAncmlnaHQnXG4gICAgICA/IGNzc2BcbiAgICAgICAgICByaWdodDogMDtcbiAgICAgICAgYFxuICAgICAgOiBjc3NgXG4gICAgICAgICAgbGVmdDogMDtcbiAgICAgICAgYH1cblxuICAkeyh7IG9wZW4sIHNpZGUgfSkgPT5cbiAgICBvcGVuXG4gICAgICA/IGNzc2BcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgwKTtcbiAgICAgICAgYFxuICAgICAgOiBzaWRlID09PSAncmlnaHQnXG4gICAgICA/IGNzc2BcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgxMDAlKTtcbiAgICAgICAgYFxuICAgICAgOiBjc3NgXG4gICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTEwMCUpO1xuICAgICAgICBgfVxuYFxuXG5jb25zdCBEcmF3ZXIgPSAoeyBvcGVuOiBvcGVuUHJvcCwgLi4ucHJvcHMgfSkgPT4ge1xuICBjb25zdCBkcmF3ZXJSZWYgPSB1c2VSZWYobnVsbClcbiAgY29uc3QgW29wZW4sIHNldE9wZW5dID0gdXNlU3RhdGUob3BlblByb3ApXG5cbiAgdXNlRWZmZWN0KCgpID0+IHtcbiAgICBzZXRPcGVuKG9wZW5Qcm9wKVxuICB9LCBbb3BlblByb3BdKVxuXG4gIHJldHVybiA8U3R5bGVkRHJhd2VyIHJlZj17ZHJhd2VyUmVmfSBvcGVuPXtvcGVufSB7Li4ucHJvcHN9IC8+XG59XG5cbkRyYXdlci5CYWNrZHJvcCA9IEJhY2tkcm9wXG5EcmF3ZXIuTWVudUl0ZW0gPSBNZW51SXRlbVxuRHJhd2VyLk1lbnUgPSBNZW51XG5EcmF3ZXIuU2VjdGlvbiA9IFNlY3Rpb25cblxuZXhwb3J0IGRlZmF1bHQgRHJhd2VyXG4iXX0= */"));
}, " ", function (_ref9) {
  var side = _ref9.side;
  return side === 'right' ? _ref$7 : _ref2$3;
}, " ", function (_ref10) {
  var open = _ref10.open,
      side = _ref10.side;
  return open ? _ref3$1 : side === 'right' ? _ref4 : _ref5;
},  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var Drawer = function Drawer(_ref11) {
  var openProp = _ref11.open,
      props = _objectWithoutProperties(_ref11, ["open"]);

  var drawerRef = React.useRef(null);

  var _useState = React.useState(openProp),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  React.useEffect(function () {
    setOpen(openProp);
  }, [openProp]);
  return /*#__PURE__*/React__default['default'].createElement(StyledDrawer, _extends({
    ref: drawerRef,
    open: open
  }, props));
};

Drawer.Backdrop = Backdrop;
Drawer.MenuItem = MenuItem;
Drawer.Menu = Menu;
Drawer.Section = Section;

var SecondaryLink = /*#__PURE__*/createStyled(function (_ref) {
  var dark = _ref.dark,
      external = _ref.external,
      rest = _objectWithoutProperties(_ref, ["dark", "external"]);

  return external ? /*#__PURE__*/React__default['default'].createElement("a", rest) : /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Link, rest);
}, {
  target: "e1b31dpt0",
  label: "SecondaryLink"
})("text-decoration:underline;", typography('body2Medium'), ";", function (_ref2) {
  var dark = _ref2.dark,
      theme = _ref2.theme;
  return /*#__PURE__*/core.css("color:", color(dark ? 'silver' : 'pewter', {
    theme: theme
  }), ";&:hover{color:", color(dark ? 'white' : 'black', {
    theme: theme
  }), ";};label:SecondaryLink;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY29uZGFyeUxpbmsuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZTRCIiwiZmlsZSI6IlNlY29uZGFyeUxpbmsuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBodHRwczovL3dhcHAtZnZ1YXRsaXZlc3R5bGVndWlkZS1jdXMtdHN0LmF6dXJld2Vic2l0ZXMubmV0LzEzLWxpbmtzLmh0bWxcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGNvbG9yLCB0eXBvZ3JhcGh5IH0gZnJvbSAnLi4vc3R5bGVzJ1xuaW1wb3J0IHsgTGluayB9IGZyb20gJ3JlYWN0LXJvdXRlci1kb20nXG5cbmNvbnN0IFNlY29uZGFyeUxpbmsgPSBzdHlsZWQoXG4gICh7IGRhcmssIGV4dGVybmFsLCAuLi5yZXN0IH0pID0+XG4gICAgZXh0ZXJuYWwgPyA8YSB7Li4ucmVzdH0gLz4gOiA8TGluayB7Li4ucmVzdH0gLz5cbilgXG4gIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuXG4gICR7dHlwb2dyYXBoeSgnYm9keTJNZWRpdW0nKX07XG5cbiAgJHsoeyBkYXJrLCB0aGVtZSB9KSA9PiBjc3NgXG4gICAgY29sb3I6ICR7Y29sb3IoZGFyayA/ICdzaWx2ZXInIDogJ3Bld3RlcicsIHsgdGhlbWUgfSl9O1xuXG4gICAgJjpob3ZlciB7XG4gICAgICBjb2xvcjogJHtjb2xvcihkYXJrID8gJ3doaXRlJyA6ICdibGFjaycsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYH07XG5gXG5cbmV4cG9ydCBkZWZhdWx0IFNlY29uZGFyeUxpbmtcbiJdfQ== */"));
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY29uZGFyeUxpbmsuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVUMiLCJmaWxlIjoiU2Vjb25kYXJ5TGluay5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIGh0dHBzOi8vd2FwcC1mdnVhdGxpdmVzdHlsZWd1aWRlLWN1cy10c3QuYXp1cmV3ZWJzaXRlcy5uZXQvMTMtbGlua3MuaHRtbFxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgY29sb3IsIHR5cG9ncmFwaHkgfSBmcm9tICcuLi9zdHlsZXMnXG5pbXBvcnQgeyBMaW5rIH0gZnJvbSAncmVhY3Qtcm91dGVyLWRvbSdcblxuY29uc3QgU2Vjb25kYXJ5TGluayA9IHN0eWxlZChcbiAgKHsgZGFyaywgZXh0ZXJuYWwsIC4uLnJlc3QgfSkgPT5cbiAgICBleHRlcm5hbCA/IDxhIHsuLi5yZXN0fSAvPiA6IDxMaW5rIHsuLi5yZXN0fSAvPlxuKWBcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG5cbiAgJHt0eXBvZ3JhcGh5KCdib2R5Mk1lZGl1bScpfTtcblxuICAkeyh7IGRhcmssIHRoZW1lIH0pID0+IGNzc2BcbiAgICBjb2xvcjogJHtjb2xvcihkYXJrID8gJ3NpbHZlcicgOiAncGV3dGVyJywgeyB0aGVtZSB9KX07XG5cbiAgICAmOmhvdmVyIHtcbiAgICAgIGNvbG9yOiAke2NvbG9yKGRhcmsgPyAnd2hpdGUnIDogJ2JsYWNrJywgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgfTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgU2Vjb25kYXJ5TGlua1xuIl19 */"));

var DefaultCookiePolicy = function DefaultCookiePolicy() {
  return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, "This application uses cookies to store information on your computer. Some are essential for the session performance, others help us to improve your user experience. Click", ' ', /*#__PURE__*/React__default['default'].createElement(SecondaryLink, {
    external: true,
    dark: true,
    href: "https://www.focusvision.com/privacy-statement/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Privacy Policy"), ' ', "to learn more.");
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$8 =  true ? {
  name: "v2kfba",
  styles: "height:100%;width:100%;"
} : {
  name: "v2kfba",
  styles: "height:100%;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT2dCIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnZnVsbHNjcmVlbic6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgYFxuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIG1hcmdpbi10b3A6ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgd2lkdGg6IDcyMHB4O1xuICAgICAgICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA0ODBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBraW5kID0gKHsga2luZCB9KSA9PlxuICBraW5kID09PSAnZ2hvc3QnICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xuICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgYm94LXNoYWRvdzogdW5zZXQ7XG4gIGBcblxuY29uc3QgQ29udGVudCA9IHN0eWxlZC5kaXZgXG4gIGJhY2tncm91bmQ6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBtYXgtd2lkdGg6IDEwMCU7XG5cbiAgJHtzaGFkb3coJ3JhaXNlZCcpfTtcbiAgJHtzaXplfTtcbiAgJHtraW5kfTtcbmBcblxuQ29udGVudC5kaXNwbGF5TmFtZSA9ICdEaWFsb2cuQ29udGVudCdcblxuZXhwb3J0IGRlZmF1bHQgQ29udGVudFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
};

var size$6 = function size(_ref3) {
  var size = _ref3.size,
      theme = _ref3.theme;

  switch (size) {
    case 'fullscreen':
      return _ref$8;

    case 'lg':
      return /*#__PURE__*/core.css("margin-top:", spacer(5, {
        theme: theme
      }), ";margin-bottom:", spacer(5, {
        theme: theme
      }), ";width:720px;", borderRadius('default', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWWdCIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnZnVsbHNjcmVlbic6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgYFxuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIG1hcmdpbi10b3A6ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgd2lkdGg6IDcyMHB4O1xuICAgICAgICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA0ODBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBraW5kID0gKHsga2luZCB9KSA9PlxuICBraW5kID09PSAnZ2hvc3QnICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xuICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgYm94LXNoYWRvdzogdW5zZXQ7XG4gIGBcblxuY29uc3QgQ29udGVudCA9IHN0eWxlZC5kaXZgXG4gIGJhY2tncm91bmQ6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBtYXgtd2lkdGg6IDEwMCU7XG5cbiAgJHtzaGFkb3coJ3JhaXNlZCcpfTtcbiAgJHtzaXplfTtcbiAgJHtraW5kfTtcbmBcblxuQ29udGVudC5kaXNwbGF5TmFtZSA9ICdEaWFsb2cuQ29udGVudCdcblxuZXhwb3J0IGRlZmF1bHQgQ29udGVudFxuIl19 */"));

    default:
      return /*#__PURE__*/core.css("margin-top:", spacer(5, {
        theme: theme
      }), ";margin-bottom:", spacer(5, {
        theme: theme
      }), ";width:480px;", borderRadius('default', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJnQiIsImZpbGUiOiJDb250ZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgYm9yZGVyUmFkaXVzLCBjb2xvciwgc2hhZG93LCBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2Z1bGxzY3JlZW4nOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGBcbiAgICBjYXNlICdsZyc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA3MjBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgbWFyZ2luLXRvcDogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICB3aWR0aDogNDgwcHg7XG4gICAgICAgICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0JywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gIH1cbn1cblxuY29uc3Qga2luZCA9ICh7IGtpbmQgfSkgPT5cbiAga2luZCA9PT0gJ2dob3N0JyAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZDogbm9uZTtcbiAgICBib3JkZXItY29sb3I6IHRyYW5zcGFyZW50O1xuICAgIGJveC1zaGFkb3c6IHVuc2V0O1xuICBgXG5cbmNvbnN0IENvbnRlbnQgPSBzdHlsZWQuZGl2YFxuICBiYWNrZ3JvdW5kOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuXG4gICR7c2hhZG93KCdyYWlzZWQnKX07XG4gICR7c2l6ZX07XG4gICR7a2luZH07XG5gXG5cbkNvbnRlbnQuZGlzcGxheU5hbWUgPSAnRGlhbG9nLkNvbnRlbnQnXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRlbnRcbiJdfQ== */"));
  }
};

var _ref2$4 =  true ? {
  name: "1uwx7m9",
  styles: "background:none;border-color:transparent;box-shadow:unset;"
} : {
  name: "1uwx7m9",
  styles: "background:none;border-color:transparent;box-shadow:unset;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEJLIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnZnVsbHNjcmVlbic6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgYFxuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIG1hcmdpbi10b3A6ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgd2lkdGg6IDcyMHB4O1xuICAgICAgICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA0ODBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBraW5kID0gKHsga2luZCB9KSA9PlxuICBraW5kID09PSAnZ2hvc3QnICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xuICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgYm94LXNoYWRvdzogdW5zZXQ7XG4gIGBcblxuY29uc3QgQ29udGVudCA9IHN0eWxlZC5kaXZgXG4gIGJhY2tncm91bmQ6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBtYXgtd2lkdGg6IDEwMCU7XG5cbiAgJHtzaGFkb3coJ3JhaXNlZCcpfTtcbiAgJHtzaXplfTtcbiAgJHtraW5kfTtcbmBcblxuQ29udGVudC5kaXNwbGF5TmFtZSA9ICdEaWFsb2cuQ29udGVudCdcblxuZXhwb3J0IGRlZmF1bHQgQ29udGVudFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
};

var kind$3 = function kind(_ref4) {
  var kind = _ref4.kind;
  return kind === 'ghost' && _ref2$4;
};

var Content$1 = createStyled("div", {
  target: "e189eieg0",
  label: "Content"
})("background:", color('white'), ";display:flex;flex-direction:column;max-width:100%;", shadow('raised'), ";", size$6, ";", kind$3, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0MwQiIsImZpbGUiOiJDb250ZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgYm9yZGVyUmFkaXVzLCBjb2xvciwgc2hhZG93LCBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2Z1bGxzY3JlZW4nOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGBcbiAgICBjYXNlICdsZyc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA3MjBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgbWFyZ2luLXRvcDogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICB3aWR0aDogNDgwcHg7XG4gICAgICAgICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0JywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gIH1cbn1cblxuY29uc3Qga2luZCA9ICh7IGtpbmQgfSkgPT5cbiAga2luZCA9PT0gJ2dob3N0JyAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZDogbm9uZTtcbiAgICBib3JkZXItY29sb3I6IHRyYW5zcGFyZW50O1xuICAgIGJveC1zaGFkb3c6IHVuc2V0O1xuICBgXG5cbmNvbnN0IENvbnRlbnQgPSBzdHlsZWQuZGl2YFxuICBiYWNrZ3JvdW5kOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuXG4gICR7c2hhZG93KCdyYWlzZWQnKX07XG4gICR7c2l6ZX07XG4gICR7a2luZH07XG5gXG5cbkNvbnRlbnQuZGlzcGxheU5hbWUgPSAnRGlhbG9nLkNvbnRlbnQnXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRlbnRcbiJdfQ== */"));

Content$1.displayName = 'Dialog.Content';

var Container$4 = createStyled("header", {
  target: "e1eejljk0",
  label: "Container"
})("display:flex;justify-content:space-between;align-items:top;> h4:first-of-type{flex:1;margin-bottom:0;}", padding('md'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNK0IiLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgQ2xvc2VCdXR0b24gZnJvbSAnLi4vQ2xvc2VCdXR0b24nXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgeyBwYWRkaW5nIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuaGVhZGVyYFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiB0b3A7XG5cbiAgPiBoNDpmaXJzdC1vZi10eXBlIHtcbiAgICBmbGV4OiAxO1xuICAgIG1hcmdpbi1ib3R0b206IDA7XG4gIH1cblxuICAke3BhZGRpbmcoJ21kJyl9O1xuYFxuXG5Db250YWluZXIuZGlzcGxheU5hbWUgPSAnRGlhbG9nLkhlYWRlci5Db250YWluZXInXG5cbmNvbnN0IEhlYWRlciA9ICh7IGNoaWxkcmVuLCBvbkNsb3NlIH0pID0+IChcbiAgPENvbnRhaW5lcj5cbiAgICB7Y2hpbGRyZW59XG4gICAge29uQ2xvc2UgJiYgPENsb3NlQnV0dG9uIG9uQ2xpY2s9e29uQ2xvc2V9IC8+fVxuICA8L0NvbnRhaW5lcj5cbilcblxuSGVhZGVyLnByb3BUeXBlcyA9IHsgb25DbG9zZTogUHJvcFR5cGVzLmZ1bmMgfVxuSGVhZGVyLmRpc3BsYXlOYW1lID0gJ0RpYWxvZy5IZWFkZXInXG5cbmV4cG9ydCBkZWZhdWx0IEhlYWRlclxuIl19 */"));

Container$4.displayName = 'Dialog.Header.Container';

var Header = function Header(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose;
  return /*#__PURE__*/React__default['default'].createElement(Container$4, null, children, onClose && /*#__PURE__*/React__default['default'].createElement(CloseButton, {
    onClick: onClose
  }));
};

Header.propTypes = {
  onClose: PropTypes__default['default'].func
};
Header.displayName = 'Dialog.Header';

var Title = function Title(props) {
  return /*#__PURE__*/React__default['default'].createElement("h4", props);
};

Title.displayName = 'Dialog.Title';

var Body = createStyled("div", {
  target: "e1uria470",
  label: "Body"
})("padding-left:", spacer(6), ";padding-right:", spacer(6), ";flex:1;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJvZHkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3VCIiwiZmlsZSI6IkJvZHkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgQm9keSA9IHN0eWxlZC5kaXZgXG4gIHBhZGRpbmctbGVmdDogJHtzcGFjZXIoNil9O1xuICBwYWRkaW5nLXJpZ2h0OiAke3NwYWNlcig2KX07XG4gIGZsZXg6IDE7XG5gXG5cbkJvZHkuZGlzcGxheU5hbWUgPSAnRGlhbG9nLkJvZHknXG5cbmV4cG9ydCBkZWZhdWx0IEJvZHlcbiJdfQ== */"));

Body.displayName = 'Dialog.Body';

var Footer = createStyled("footer", {
  target: "eimf8yy0",
  label: "Footer"
})("display:flex;justify-content:flex-end;", padding('md'), ";", Button, " + ", Button, "{margin-left:", spacer(2), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvb3Rlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJNEIiLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgQnV0dG9uIGZyb20gJy4uL0J1dHRvbidcbmltcG9ydCB7IHBhZGRpbmcsIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgRm9vdGVyID0gc3R5bGVkLmZvb3RlcmBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgJHtwYWRkaW5nKCdtZCcpfTtcblxuICAke0J1dHRvbn0gKyAke0J1dHRvbn0ge1xuICAgIG1hcmdpbi1sZWZ0OiAke3NwYWNlcigyKX07XG4gIH1cbmBcblxuRm9vdGVyLmRpc3BsYXlOYW1lID0gJ0RpYWxvZy5Gb290ZXInXG5cbmV4cG9ydCBkZWZhdWx0IEZvb3RlclxuIl19 */"));

Footer.displayName = 'Dialog.Footer';

var CancelButton = function CancelButton(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose;
  return /*#__PURE__*/React__default['default'].createElement(Button, {
    kind: "ghost",
    type: "button",
    onClick: onClose
  }, children);
};

CancelButton.defaultProps = {
  children: 'Cancel'
};

var Dialog = function Dialog(props) {
  return /*#__PURE__*/React__default['default'].createElement(Content$1, _extends({
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, props));
};

Dialog.Body = Body;
Dialog.Footer = Footer;
Dialog.Header = Header;
Dialog.Title = Title;
Dialog.CancelButton = CancelButton;

var Placeholder = createStyled("span", {
  target: "e1317bf50",
  label: "Placeholder"
})("color:", color('cadet'), ";", fontWeight('regular'), ";[aria-expanded='true'] &{color:", color('white'), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBsYWNlaG9sZGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUcrQiIsImZpbGUiOiJQbGFjZWhvbGRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY29sb3IsIGZvbnRXZWlnaHQgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IFBsYWNlaG9sZGVyID0gc3R5bGVkLnNwYW5gXG4gIGNvbG9yOiAke2NvbG9yKCdjYWRldCcpfTtcblxuICAke2ZvbnRXZWlnaHQoJ3JlZ3VsYXInKX07XG5cbiAgW2FyaWEtZXhwYW5kZWQ9J3RydWUnXSAmIHtcbiAgICBjb2xvcjogJHtjb2xvcignd2hpdGUnKX07XG4gIH1cbmBcblxuZXhwb3J0IGRlZmF1bHQgUGxhY2Vob2xkZXJcbiJdfQ== */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var TruncateText = createStyled("span", {
  target: "e1kjqdkw0",
  label: "TruncateText"
})( true ? {
  name: "1h2ruwl",
  styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
} : {
  name: "1h2ruwl",
  styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRydW5jYXRlVGV4dC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFZ0MiLCJmaWxlIjoiVHJ1bmNhdGVUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IFRydW5jYXRlVGV4dCA9IHN0eWxlZC5zcGFuYFxuICB3aGl0ZS1zcGFjZTogbm93cmFwO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbmBcblxuZXhwb3J0IGRlZmF1bHQgVHJ1bmNhdGVUZXh0XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});

var size$7 = function size(_ref) {
  var size = _ref.size,
      theme = _ref.theme;

  switch (size) {
    case 'lg':
      return /*#__PURE__*/core.css(typography('body3', {
        theme: theme
      }), ";", padding('xs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    default:
      return /*#__PURE__*/core.css(typography('body2', {
        theme: theme
      }), ";", padding('xxs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  }
};

var kind$4 = function kind(_ref2) {
  var kind = _ref2.kind,
      theme = _ref2.theme,
      valid = _ref2.valid;

  switch (kind) {
    case 'ghost':
      return /*#__PURE__*/core.css("border:none;color:", color('pewter', {
        theme: theme
      }), ";", fontWeight('medium', {
        theme: theme
      }), ";&:hover{background-color:", transparentize('slate', 0.08, {
        theme: theme
      }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnQ2dCIiwiZmlsZSI6IkJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCBQbGFjZWhvbGRlciBmcm9tICcuL1BsYWNlaG9sZGVyJ1xuaW1wb3J0IFRydW5jYXRlVGV4dCBmcm9tICcuLi9UcnVuY2F0ZVRleHQnXG5pbXBvcnQge1xuICBib3JkZXJSYWRpdXMsXG4gIGNvbG9yLFxuICBmb250V2VpZ2h0LFxuICBwYWRkaW5nLFxuICBzcGFjZXIsXG4gIHRyYW5zcGFyZW50aXplLFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnbGcnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHt0eXBvZ3JhcGh5KCdib2R5MycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke3BhZGRpbmcoJ3hzJywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7dHlwb2dyYXBoeSgnYm9keTInLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgJHtwYWRkaW5nKCd4eHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBraW5kID0gKHsga2luZCwgdGhlbWUsIHZhbGlkIH0pID0+IHtcbiAgc3dpdGNoIChraW5kKSB7XG4gICAgY2FzZSAnZ2hvc3QnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgYm9yZGVyOiBub25lO1xuICAgICAgICBjb2xvcjogJHtjb2xvcigncGV3dGVyJywgeyB0aGVtZSB9KX07XG5cbiAgICAgICAgJHtmb250V2VpZ2h0KCdtZWRpdW0nLCB7IHRoZW1lIH0pfTtcblxuICAgICAgICAmOmhvdmVyIHtcbiAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuMDgsIHsgdGhlbWUgfSl9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICR7Y29sb3IodmFsaWQgPyAnc2lsdmVyJyA6ICdyZWQnLCB7IHRoZW1lIH0pfTtcblxuICAgICAgICBbYXJpYS1leHBhbmRlZD0ndHJ1ZSddICYge1xuICAgICAgICAgIGJvcmRlcjogMXB4IHNvbGlkICR7Y29sb3IoJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgICAgIH1cbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBCdXR0b24gPSBzdHlsZWQuYnV0dG9uYFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIHRyYW5zaXRpb246IGFsbCAwLjNzIGVhc2UgMHM7XG4gIG91dGxpbmUtY29sb3I6ICR7Y29sb3IoJ3NsYXRlJyl9O1xuICB3aWR0aDogMTAwJTtcbiAgZm9udC1mYW1pbHk6IGluaGVyaXQ7XG4gIHVzZXItc2VsZWN0OiBub25lO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgdGV4dC1hbGlnbjogbGVmdDtcblxuICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcpfTtcblxuICAke3NpemV9O1xuICAke2tpbmR9O1xuXG4gICY6Oi1tb3otZm9jdXMtaW5uZXIge1xuICAgIGJvcmRlcjogMDtcbiAgfVxuXG4gIFthcmlhLWV4cGFuZGVkPSd0cnVlJ10gJiB7XG4gICAgY29sb3I6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3NsYXRlJyl9O1xuICAgIG91dGxpbmU6IG5vbmU7XG4gIH1cblxuICAmOmFjdGl2ZSB7XG4gICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKCdzbGF0ZScpfTtcbiAgfVxuXG4gICY6Zm9jdXMge1xuICAgIG91dGxpbmUtY29sb3I6ICR7Y29sb3IoJ3NsYXRlJyl9O1xuICAgIG91dGxpbmUtb2Zmc2V0OiAtMnB4O1xuICB9XG5cbiAgJjpub3QoW2Rpc2FibGVkXSkge1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuXG4gICZbZGlzYWJsZWRdIHtcbiAgICBjdXJzb3I6IG5vdC1hbGxvd2VkO1xuICAgIGNvbG9yOiAke2NvbG9yKCdjYWRldCcpfTtcbiAgICBiYWNrZ3JvdW5kOiAke2NvbG9yKCdvZmZXaGl0ZScpfTtcbiAgICBib3JkZXI6IDFweCBzb2xpZCAke2NvbG9yKCdwYWxlR3JleScpfTtcbiAgfVxuXG4gIHN2ZyB7XG4gICAgJjpmaXJzdC1vZi10eXBlIHtcbiAgICAgIG1hcmdpbi1yaWdodDogJHtzcGFjZXIoMil9O1xuICAgIH1cblxuICAgICY6bGFzdC1vZi10eXBlIHtcbiAgICAgIG1hcmdpbi1sZWZ0OiAke3NwYWNlcigyKX07XG4gICAgfVxuICB9XG5cbiAgQHN1cHBvcnRzICgtbW96LWFwcGVhcmFuY2U6IG5vbmUpIHtcbiAgICAmOmZvY3VzIHtcbiAgICAgIG91dGxpbmUtd2lkdGg6IDFweDtcbiAgICAgIG91dGxpbmUtc3R5bGU6IGRvdHRlZDtcbiAgICB9XG4gIH1cblxuICAke1RydW5jYXRlVGV4dH0sICR7UGxhY2Vob2xkZXJ9IHtcbiAgICBmbGV4OiAxO1xuICB9XG5gXG5cbkJ1dHRvbi5kaXNwbGF5TmFtZSA9ICdEcm9wZG93bi5CdXR0b24nXG5cbmV4cG9ydCBkZWZhdWx0IEJ1dHRvblxuIl19 */"));

    default:
      return /*#__PURE__*/core.css("border:1px solid ", color(valid ? 'silver' : 'red', {
        theme: theme
      }), ";[aria-expanded='true'] &{border:1px solid ", color('slate', {
        theme: theme
      }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  }
};

var Button$1 = createStyled("button", {
  target: "e11vym1r0",
  label: "Button"
})("display:flex;justify-content:space-between;align-items:center;transition:all 0.3s ease 0s;outline-color:", color('slate'), ";width:100%;font-family:inherit;user-select:none;background-color:", color('white'), ";text-align:left;", borderRadius('default'), ";", size$7, ";", kind$4, ";&::-moz-focus-inner{border:0;}[aria-expanded='true'] &{color:", color('white'), ";background-color:", color('slate'), ";outline:none;}&:active{border-color:", color('slate'), ";}&:focus{outline-color:", color('slate'), ";outline-offset:-2px;}&:not([disabled]){cursor:pointer;}&[disabled]{cursor:not-allowed;color:", color('cadet'), ";background:", color('offWhite'), ";border:1px solid ", color('paleGrey'), ";}svg{&:first-of-type{margin-right:", spacer(2), ";}&:last-of-type{margin-left:", spacer(2), ";}}@supports (-moz-appearance:none){&:focus{outline-width:1px;outline-style:dotted;}}", TruncateText, ",", Placeholder, "{flex:1;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

Button$1.displayName = 'Dropdown.Button';

function makeOptions(enableEvents) {
  return {
    placement: 'bottom-start',
    modifiers: [// Don't always enable event listeners. Gets laggy with multiple dropdowns on a page
    {
      name: 'eventListeners',
      enabled: enableEvents
    }, // Ensure the dropdown menu is always the same width as the button
    {
      name: 'sameWidth',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref) {
        var state = _ref.state;
        state.styles.popper.width = "".concat(state.rects.reference.width, "px");
      },
      effect: function effect(_ref2) {
        var state = _ref2.state;
        state.elements.popper.style.width = "".concat(state.elements.reference.offsetWidth, "px");
      }
    }]
  };
}

function usePopper (referenceElement, popperElement, enableEvents) {
  var options = React.useMemo(function () {
    return makeOptions(enableEvents);
  }, [enableEvents]);
  return reactPopper.usePopper(referenceElement, popperElement, options);
}

var getRoot = function getRoot(kind) {
  var root = document.getElementById("".concat(kind, "-root"));

  if (false) {
    invariant__default['default'](root, "This app does not contain a ".concat(kind, " root. Follow the steps at       https://invent.focusvision.com/Portland/stylist#portal-roots to       add one to your app."));
  }

  return root;
};

var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      Icon = _ref.icon,
      itemToString = _ref.itemToString,
      disabled = _ref.disabled,
      kind = _ref.kind,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      size = _ref.size,
      valid = _ref.valid,
      value = _ref.value,
      width = _ref.width,
      portal = _ref.portal,
      portalContainer = _ref.portalContainer,
      menuStyles = _ref.menuStyles;

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      buttonEl = _useState2[0],
      setButtonEl = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      menuEl = _useState4[0],
      setMenuEl = _useState4[1];

  var _useState5 = React.useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      enableEvents = _useState6[0],
      setEnableEvents = _useState6[1];

  var _usePopper = usePopper(buttonEl, menuEl, enableEvents),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var portalRoot = React.useMemo(function () {
    if (!portal) return null;
    return portalContainer ? portalContainer : getRoot('menu');
  }, [portal, portalContainer]);
  return /*#__PURE__*/React__default['default'].createElement(Downshift__default['default'], {
    onChange: onChange,
    onStateChange: function onStateChange(changes) {
      return changes.hasOwnProperty('isOpen') && setEnableEvents(changes.isOpen);
    },
    selectedItem: value,
    itemToString: itemToString
  }, function (_ref2) {
    var getToggleButtonProps = _ref2.getToggleButtonProps,
        getItemProps = _ref2.getItemProps,
        getMenuProps = _ref2.getMenuProps,
        getRootProps = _ref2.getRootProps,
        highlightedIndex = _ref2.highlightedIndex,
        isOpen = _ref2.isOpen,
        selectedItem = _ref2.selectedItem;
    var options = React.Children.toArray(children).filter(Boolean);
    var menu = /*#__PURE__*/React__default['default'].createElement(ListBox, getMenuProps(_objectSpread2({
      ref: setMenuEl,
      closed: !isOpen,
      style: _objectSpread2(_objectSpread2({}, styles.popper), menuStyles)
    }, attributes.popper)), isOpen && options.map(function (child, idx) {
      return /*#__PURE__*/React.cloneElement(child, _objectSpread2({}, getItemProps({
        key: child.props.value,
        item: child.props.value,
        size: size,
        focused: highlightedIndex === idx,
        selected: selectedItem === child.props.value
      })));
    }));
    return /*#__PURE__*/React__default['default'].createElement(Container$1, _extends({
      width: width
    }, getRootProps()), /*#__PURE__*/React__default['default'].createElement(Button$1, getToggleButtonProps({
      ref: setButtonEl,
      disabled: disabled,
      size: size,
      kind: kind,
      valid: valid
    }), Icon && /*#__PURE__*/React__default['default'].createElement(Icon, {
      size: "m"
    }), selectedItem ? /*#__PURE__*/React__default['default'].createElement(TruncateText, null, options.find(function (_ref3) {
      var props = _ref3.props;
      return props.value === selectedItem;
    }).props.children) : /*#__PURE__*/React__default['default'].createElement(Placeholder, null, placeholder), /*#__PURE__*/React__default['default'].createElement(Caret, {
      size: "8px",
      color: "cadet"
    })), portalRoot ? /*#__PURE__*/reactDom.createPortal(menu, portalRoot) : menu);
  });
};

Dropdown.propTypes = {
  children: PropTypes__default['default'].node,
  kind: PropTypes__default['default'].oneOf(['ghost']),
  name: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func.isRequired,
  placeholder: PropTypes__default['default'].string,
  size: PropTypes__default['default'].oneOf(['lg']),
  valid: PropTypes__default['default'].bool,
  value: PropTypes__default['default'].any,
  portal: PropTypes__default['default'].bool,
  portalContainer: PropTypes__default['default'].instanceOf(Element),
  menuStyles: PropTypes__default['default'].object
};
Dropdown.defaultProps = {
  itemToString: function itemToString(value) {
    return value == null ? '' : value;
  },
  placeholder: 'Select...',
  valid: true
};
Dropdown.Option = Option;

var ExternalButtonLink = Button.withComponent('a', {
  target: "e11ttvn80",
  label: "ExternalButtonLink"
});

var Actions = function Actions(_ref) {
  var children = _ref.children,
      _ref$formik = _ref.formik,
      handleReset = _ref$formik.handleReset,
      submitForm = _ref$formik.submitForm;
  return children({
    reset: handleReset,
    submit: submitForm
  });
};

var Actions$1 = formik.connect(Actions);

var FormAlert = /*#__PURE__*/createStyled(Alert, {
  target: "e1e8qmhh0",
  label: "FormAlert"
})("margin-top:", spacer(4), ";margin-bottom:", spacer(4), ";& + &{margin-top:0;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvcm1BbGVydC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJK0IiLCJmaWxlIjoiRm9ybUFsZXJ0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgQWxlcnQgZnJvbSAnLi4vQWxlcnQnXG5pbXBvcnQgeyBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IEZvcm1BbGVydCA9IHN0eWxlZChBbGVydClgXG4gIG1hcmdpbi10b3A6ICR7c3BhY2VyKDQpfTtcbiAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNCl9O1xuXG4gICYgKyAmIHtcbiAgICBtYXJnaW4tdG9wOiAwO1xuICB9XG5gXG5cbkZvcm1BbGVydC5kaXNwbGF5TmFtZSA9ICdGb3JtLkZvcm1BbGVydCdcblxuZXhwb3J0IGRlZmF1bHQgRm9ybUFsZXJ0XG4iXX0= */"));

FormAlert.displayName = 'Form.FormAlert';

var Errors = function Errors(_ref) {
  var errors = _ref.formik.errors,
      name = _ref.name;
  return name && errors[name] ? /*#__PURE__*/React__default['default'].createElement(FormAlert, {
    kind: "error",
    message: errors[name]
  }) : Array.isArray(errors.form) ? errors.form.map(function (message, idx) {
    return /*#__PURE__*/React__default['default'].createElement(FormAlert, {
      key: idx,
      kind: "error",
      message: message
    });
  }) : errors.form ? /*#__PURE__*/React__default['default'].createElement(FormAlert, {
    kind: "error",
    message: errors.form
  }) : null;
};

var Errors$1 = formik.connect(Errors);

var FieldAlert = /*#__PURE__*/createStyled(Alert, {
  target: "e1997vs50",
  label: "FieldAlert"
})("margin-top:", spacer(2), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpZWxkQWxlcnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSWdDIiwiZmlsZSI6IkZpZWxkQWxlcnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCBBbGVydCBmcm9tICcuLi9BbGVydCdcbmltcG9ydCB7IHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgRmllbGRBbGVydCA9IHN0eWxlZChBbGVydClgXG4gIG1hcmdpbi10b3A6ICR7c3BhY2VyKDIpfTtcbmBcblxuRmllbGRBbGVydC5kaXNwbGF5TmFtZSA9ICdGb3JtLkZpZWxkQWxlcnQnXG5cbmV4cG9ydCBkZWZhdWx0IEZpZWxkQWxlcnRcbiJdfQ== */"));

FieldAlert.displayName = 'Form.FieldAlert';

var Field = function Field(_ref) {
  var name = _ref.name,
      _render = _ref.render;
  return /*#__PURE__*/React__default['default'].createElement(formik.Field, {
    name: name,
    render: function render(_ref2) {
      var field = _ref2.field,
          _ref2$form = _ref2.form,
          errors = _ref2$form.errors,
          setFieldError = _ref2$form.setFieldError,
          setFieldValue = _ref2$form.setFieldValue,
          values = _ref2$form.values;
      return _render(_objectSpread2(_objectSpread2({}, field), {}, {
        form: {
          values: values
        },
        setFieldError: setFieldError,
        setValue: function setValue(value) {
          return setFieldValue(name, value);
        },
        error: errors[field.name],
        valid: !errors[field.name],
        renderError: function renderError() {
          return errors[field.name] ? /*#__PURE__*/React__default['default'].createElement(FieldAlert, {
            kind: "error",
            message: errors[field.name]
          }) : null;
        }
      }));
    }
  });
};

var hover = function hover(theme) {
  return "\n  && {\n    border-color: ".concat(color('brandGreen', {
    theme: theme
  }), ";\n    background-color: ").concat(transparentize('lightGreen', 0.5, {
    theme: theme
  }), ";\n  }\n");
};

var disabledStyle = function disabledStyle(theme) {
  return "\n  && {\n    border-color: ".concat(color('paleGrey', {
    theme: theme
  }), ";\n    background-color: ").concat(color('offWhite', {
    theme: theme
  }), ";\n    cursor: not-allowed;\n  }\n");
};

var valid = function valid(_ref) {
  var valid = _ref.valid,
      theme = _ref.theme;
  return valid || "\n    && {\n      border-color: ".concat(color('red', {
    theme: theme
  }), ";\n      background-color: ").concat(transparentize('lightRed', 0.5, {
    theme: theme
  }), ";\n    }\n  ");
};

var Dropzone = /*#__PURE__*/createStyled(ReactDropzone__default['default'], {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['valid', 'height'].indexOf(prop) === -1;
  },
  target: "e1wkg4720",
  label: "Dropzone"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;color:", color('pewter'), ";border:2px dashed ", color('silver'), ";cursor:pointer;height:", prop('height'), ";width:100%;overflow:hidden;padding:", spacer(4), " 0;text-align:center;transition:all 0.3s cubic-bezier(0.25,0.8,0.25,1);", borderRadius('default'), ";", valid, ";&:hover{", function (_ref2) {
  var disabled = _ref2.disabled,
      theme = _ref2.theme;
  return disabled || hover(theme);
}, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVwbG9hZGVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBDRSIsImZpbGUiOiJVcGxvYWRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGcmFnbWVudCB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBDbGFzc05hbWVzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHdpdGhUaGVtZSB9IGZyb20gJ2Vtb3Rpb24tdGhlbWluZydcbmltcG9ydCBCdXR0b24gZnJvbSAnLi9CdXR0b24nXG5pbXBvcnQgUmVhY3REcm9wem9uZSBmcm9tICdyZWFjdC1kcm9wem9uZSdcbmltcG9ydCBVcGxvYWRJY29uIGZyb20gJy4vaWNvbnMvVXBsb2FkJ1xuaW1wb3J0IFNlY29uZGFyeUxpbmsgZnJvbSAnLi9TZWNvbmRhcnlMaW5rJ1xuaW1wb3J0IHtcbiAgYm9yZGVyUmFkaXVzLFxuICBjb2xvcixcbiAgc3BhY2VyLFxuICB0cmFuc3BhcmVudGl6ZSxcbiAgdHlwb2dyYXBoeVxufSBmcm9tICcuLi9zdHlsZXMnXG5pbXBvcnQgeyBwcm9wIH0gZnJvbSAnLi4vdXRpbHMvZnAnXG5cbmNvbnN0IGhvdmVyID0gdGhlbWUgPT4gYFxuICAmJiB7XG4gICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKCdicmFuZEdyZWVuJywgeyB0aGVtZSB9KX07XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnbGlnaHRHcmVlbicsIDAuNSwgeyB0aGVtZSB9KX07XG4gIH1cbmBcblxuY29uc3QgZGlzYWJsZWRTdHlsZSA9IHRoZW1lID0+IGBcbiAgJiYge1xuICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcigncGFsZUdyZXknLCB7IHRoZW1lIH0pfTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCdvZmZXaGl0ZScsIHsgdGhlbWUgfSl9O1xuICAgIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gIH1cbmBcblxuY29uc3QgdmFsaWQgPSAoeyB2YWxpZCwgdGhlbWUgfSkgPT5cbiAgdmFsaWQgfHwgYFxuICAgICYmIHtcbiAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcigncmVkJywgeyB0aGVtZSB9KX07XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdsaWdodFJlZCcsIDAuNSwgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgXG5cbmNvbnN0IERyb3B6b25lID0gc3R5bGVkKFJlYWN0RHJvcHpvbmUsIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IHByb3AgPT4gWyd2YWxpZCcsICdoZWlnaHQnXS5pbmRleE9mKHByb3ApID09PSAtMVxufSlgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBjb2xvcjogJHtjb2xvcigncGV3dGVyJyl9O1xuICBib3JkZXI6IDJweCBkYXNoZWQgJHtjb2xvcignc2lsdmVyJyl9O1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIGhlaWdodDogJHtwcm9wKCdoZWlnaHQnKX07XG4gIHdpZHRoOiAxMDAlO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICBwYWRkaW5nOiAke3NwYWNlcig0KX0gMDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICB0cmFuc2l0aW9uOiBhbGwgMC4zcyBjdWJpYy1iZXppZXIoMC4yNSwgMC44LCAwLjI1LCAxKTtcblxuICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcpfTtcbiAgJHt2YWxpZH07XG5cbiAgJjpob3ZlciB7XG4gICAgJHsoeyBkaXNhYmxlZCwgdGhlbWUgfSkgPT4gZGlzYWJsZWQgfHwgaG92ZXIodGhlbWUpfTtcbiAgfVxuYFxuXG5jb25zdCBEcm9wTGFiZWwgPSBzdHlsZWQuZGl2YFxuICAke3R5cG9ncmFwaHkoJ2JvZHkyTWVkaXVtJyl9O1xuICBtYXJnaW4tdG9wOiAke3NwYWNlcigyKX07XG4gIG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDIpfTtcbmBcblxuY29uc3QgU3ViTGFiZWwgPSBzdHlsZWQuZGl2YFxuICAke3R5cG9ncmFwaHkoJ2JvZHkxTWVkaXVtJyl9O1xuXG4gICR7U2Vjb25kYXJ5TGlua30ge1xuICAgICR7dHlwb2dyYXBoeSgnYm9keTFNZWRpdW0nKX07XG4gIH1cbmBcblxuY29uc3QgVXBsb2FkZXIgPSAoe1xuICBhY2NlcHQsXG4gIGRpc2FibGVkLFxuICBoZWlnaHQsXG4gIG11bHRpcGxlLFxuICBuYW1lLFxuICBvbkNoYW5nZSxcbiAgdGhlbWUsXG4gIHZhbGlkLFxuICB2YWx1ZSxcbiAgbGFiZWwsXG4gIHN1YkxhYmVsLFxufSkgPT4ge1xuICBjb25zdCBmaWxlcyA9IEFycmF5LmlzQXJyYXkodmFsdWUpID8gdmFsdWUgOiBbdmFsdWVdLmZpbHRlcihCb29sZWFuKVxuXG4gIHJldHVybiAoXG4gICAgPENsYXNzTmFtZXM+XG4gICAgICB7KHsgY3NzIH0pID0+IChcbiAgICAgICAgPERyb3B6b25lXG4gICAgICAgICAgYWNjZXB0PXthY2NlcHR9XG4gICAgICAgICAgYWN0aXZlQ2xhc3NOYW1lPXtjc3MoaG92ZXIodGhlbWUpKX1cbiAgICAgICAgICBkaXNhYmxlZENsYXNzTmFtZT17Y3NzKGRpc2FibGVkU3R5bGUodGhlbWUpKX1cbiAgICAgICAgICBoZWlnaHQ9e2hlaWdodH1cbiAgICAgICAgICBtdWx0aXBsZT17bXVsdGlwbGV9XG4gICAgICAgICAgbmFtZT17bmFtZX1cbiAgICAgICAgICBkaXNhYmxlZD17ZGlzYWJsZWR9XG4gICAgICAgICAgb25Ecm9wPXtmaWxlcyA9PiAobXVsdGlwbGUgPyBvbkNoYW5nZShmaWxlcykgOiBvbkNoYW5nZShmaWxlc1swXSkpfVxuICAgICAgICAgIHZhbGlkPXt2YWxpZH1cbiAgICAgICAgPlxuICAgICAgICAgIHtmaWxlcy5sZW5ndGggPiAwID8gKFxuICAgICAgICAgICAgPERyb3BMYWJlbD57ZmlsZXMubWFwKHByb3AoJ25hbWUnKSkuam9pbignLCAnKX08L0Ryb3BMYWJlbD5cbiAgICAgICAgICApIDogKFxuICAgICAgICAgICAgPEZyYWdtZW50PlxuICAgICAgICAgICAgICA8VXBsb2FkSWNvbiBzaXplPVwiMS41cmVtXCIgY29sb3I9XCJzaWx2ZXJcIiAvPlxuICAgICAgICAgICAgICA8RHJvcExhYmVsPlxuICAgICAgICAgICAgICAgIHtsYWJlbCB8fCBgRHJhZyBhbmQgRHJvcCAke211bHRpcGxlID8gJ2ZpbGVzJyA6ICdhIGZpbGUnfSBoZXJlYH1cbiAgICAgICAgICAgICAgPC9Ecm9wTGFiZWw+XG4gICAgICAgICAgICAgIDxTdWJMYWJlbD5cbiAgICAgICAgICAgICAgICB7c3ViTGFiZWwgfHwgKFxuICAgICAgICAgICAgICAgICAgPEZyYWdtZW50PlxuICAgICAgICAgICAgICAgICAgICBvciA8U2Vjb25kYXJ5TGluayBleHRlcm5hbD5Ccm93c2U8L1NlY29uZGFyeUxpbms+XG4gICAgICAgICAgICAgICAgICA8L0ZyYWdtZW50PlxuICAgICAgICAgICAgICAgICl9XG4gICAgICAgICAgICAgIDwvU3ViTGFiZWw+XG4gICAgICAgICAgICA8L0ZyYWdtZW50PlxuICAgICAgICAgICl9XG4gICAgICAgIDwvRHJvcHpvbmU+XG4gICAgICApfVxuICAgIDwvQ2xhc3NOYW1lcz5cbiAgKVxufVxuXG5VcGxvYWRlci5kZWZhdWx0UHJvcHMgPSB7XG4gIG11bHRpcGxlOiBmYWxzZSxcbiAgb25DaGFuZ2U6ICgpID0+IHt9LFxuICB2YWxpZDogdHJ1ZVxufVxuXG5leHBvcnQgZGVmYXVsdCB3aXRoVGhlbWUoVXBsb2FkZXIpXG4iXX0= */"));

var DropLabel = createStyled("div", {
  target: "e1wkg4721",
  label: "DropLabel"
})(typography('body2Medium'), ";margin-top:", spacer(2), ";margin-bottom:", spacer(2), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var SubLabel = createStyled("div", {
  target: "e1wkg4722",
  label: "SubLabel"
})(typography('body1Medium'), ";", SecondaryLink, "{", typography('body1Medium'), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Uploader = function Uploader(_ref3) {
  var accept = _ref3.accept,
      disabled = _ref3.disabled,
      height = _ref3.height,
      multiple = _ref3.multiple,
      name = _ref3.name,
      onChange = _ref3.onChange,
      theme = _ref3.theme,
      valid = _ref3.valid,
      value = _ref3.value,
      label = _ref3.label,
      subLabel = _ref3.subLabel;
  var files = Array.isArray(value) ? value : [value].filter(Boolean);
  return /*#__PURE__*/React__default['default'].createElement(core.ClassNames, null, function (_ref4) {
    var css = _ref4.css;
    return /*#__PURE__*/React__default['default'].createElement(Dropzone, {
      accept: accept,
      activeClassName: css(hover(theme)),
      disabledClassName: css(disabledStyle(theme)),
      height: height,
      multiple: multiple,
      name: name,
      disabled: disabled,
      onDrop: function onDrop(files) {
        return multiple ? onChange(files) : onChange(files[0]);
      },
      valid: valid
    }, files.length > 0 ? /*#__PURE__*/React__default['default'].createElement(DropLabel, null, files.map(prop('name')).join(', ')) : /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(Upload, {
      size: "1.5rem",
      color: "silver"
    }), /*#__PURE__*/React__default['default'].createElement(DropLabel, null, label || "Drag and Drop ".concat(multiple ? 'files' : 'a file', " here")), /*#__PURE__*/React__default['default'].createElement(SubLabel, null, subLabel || /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, "or ", /*#__PURE__*/React__default['default'].createElement(SecondaryLink, {
      external: true
    }, "Browse")))));
  });
};

Uploader.defaultProps = {
  multiple: false,
  onChange: function onChange() {},
  valid: true
};
var Uploader$1 = emotionTheming.withTheme(Uploader);

var composeHandlers = (function () {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fns.filter(Boolean).forEach(function (fn) {
      return fn.apply(void 0, args);
    });
  };
});

var FileUpload = function FileUpload(_ref) {
  var name = _ref.name,
      onChange = _ref.onChange,
      multiple = _ref.multiple,
      props = _objectWithoutProperties(_ref, ["name", "onChange", "multiple"]);

  return /*#__PURE__*/React__default['default'].createElement(Field, {
    name: name,
    render: function render(_ref2) {
      var renderError = _ref2.renderError,
          setValue = _ref2.setValue,
          form = _ref2.form,
          valid = _ref2.valid,
          value = _ref2.value;
      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(Uploader$1, _extends({}, props, {
        name: name,
        onChange: composeHandlers(setValue, onChange),
        valid: valid,
        value: value,
        multiple: multiple
      })), renderError());
    }
  });
};

var buttons = function buttons(_ref) {
  var buttons = _ref.buttons,
      theme = _ref.theme;
  return buttons && /*#__PURE__*/core.css("flex-direction:row;justify-content:flex-end;", Button, " + ", Button, ",", ButtonLink, " + ", ButtonLink, ",", Button, " + ", ButtonLink, ",", ButtonLink, " + ", Button, "{margin-left:", spacer(2, {
    theme: theme
  }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkdyb3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNLIiwiZmlsZSI6Ikdyb3VwLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gaHR0cHM6Ly93YXBwLWZ2dWF0bGl2ZXN0eWxlZ3VpZGUtY3VzLXRzdC5henVyZXdlYnNpdGVzLm5ldC8xMS1mb3JtLmh0bWxcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCBCdXR0b24gZnJvbSAnLi4vQnV0dG9uJ1xuaW1wb3J0IEJ1dHRvbkxpbmsgZnJvbSAnLi4vQnV0dG9uTGluaydcbmltcG9ydCB7IHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgYnV0dG9ucyA9ICh7IGJ1dHRvbnMsIHRoZW1lIH0pID0+XG4gIGJ1dHRvbnMgJiZcbiAgY3NzYFxuICAgIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gICAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcblxuICAgICR7QnV0dG9ufSArICR7QnV0dG9ufSxcbiAgICAke0J1dHRvbkxpbmt9ICsgJHtCdXR0b25MaW5rfSxcbiAgICAke0J1dHRvbn0gKyAke0J1dHRvbkxpbmt9LFxuICAgICR7QnV0dG9uTGlua30gKyAke0J1dHRvbn0ge1xuICAgICAgbWFyZ2luLWxlZnQ6ICR7c3BhY2VyKDIsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYFxuXG5jb25zdCBHcm91cCA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIHdpZHRoOiAxMDAlO1xuICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcig2KX07XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5cbiAgJHtidXR0b25zfTtcblxuICAmOmxhc3Qtb2YtdHlwZSB7XG4gICAgbWFyZ2luLWJvdHRvbTogMDtcbiAgfVxuYFxuXG5Hcm91cC5kaXNwbGF5TmFtZSA9ICdGb3JtLkdyb3VwJ1xuXG5leHBvcnQgZGVmYXVsdCBHcm91cFxuIl19 */"));
};

var Group = createStyled("div", {
  target: "e118sbgk0",
  label: "Group"
})("display:flex;width:100%;margin-bottom:", spacer(6), ";flex-direction:column;", buttons, ";&:last-of-type{margin-bottom:0;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkdyb3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFCd0IiLCJmaWxlIjoiR3JvdXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBodHRwczovL3dhcHAtZnZ1YXRsaXZlc3R5bGVndWlkZS1jdXMtdHN0LmF6dXJld2Vic2l0ZXMubmV0LzExLWZvcm0uaHRtbFxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IEJ1dHRvbiBmcm9tICcuLi9CdXR0b24nXG5pbXBvcnQgQnV0dG9uTGluayBmcm9tICcuLi9CdXR0b25MaW5rJ1xuaW1wb3J0IHsgc3BhY2VyIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBidXR0b25zID0gKHsgYnV0dG9ucywgdGhlbWUgfSkgPT5cbiAgYnV0dG9ucyAmJlxuICBjc3NgXG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtZW5kO1xuXG4gICAgJHtCdXR0b259ICsgJHtCdXR0b259LFxuICAgICR7QnV0dG9uTGlua30gKyAke0J1dHRvbkxpbmt9LFxuICAgICR7QnV0dG9ufSArICR7QnV0dG9uTGlua30sXG4gICAgJHtCdXR0b25MaW5rfSArICR7QnV0dG9ufSB7XG4gICAgICBtYXJnaW4tbGVmdDogJHtzcGFjZXIoMiwgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgXG5cbmNvbnN0IEdyb3VwID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgd2lkdGg6IDEwMCU7XG4gIG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDYpfTtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblxuICAke2J1dHRvbnN9O1xuXG4gICY6bGFzdC1vZi10eXBlIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuICB9XG5gXG5cbkdyb3VwLmRpc3BsYXlOYW1lID0gJ0Zvcm0uR3JvdXAnXG5cbmV4cG9ydCBkZWZhdWx0IEdyb3VwXG4iXX0= */"));

Group.displayName = 'Form.Group';

var size$8 = function size(_ref) {
  var size = _ref.size,
      theme = _ref.theme;

  switch (size) {
    case 'lg':
      return /*#__PURE__*/core.css(padding('xs', {
        theme: theme
      }), ";", fontSize('s', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFnQiIsImZpbGUiOiJJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIGh0dHBzOi8vd2FwcC1mdnVhdGxpdmVzdHlsZWd1aWRlLWN1cy10c3QuYXp1cmV3ZWJzaXRlcy5uZXQvMjUtdGV4dC1pbnB1dHMuaHRtbFxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgY29sb3IsIGJvcmRlclJhZGl1cywgZm9udFNpemUsIHBhZGRpbmcgfSBmcm9tICcuLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7cGFkZGluZygneHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgJHtmb250U2l6ZSgncycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke2ZvbnRTaXplKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IElucHV0ID0gc3R5bGVkLmlucHV0YFxuICBkaXNwbGF5OiAkeyh7IGlubGluZSB9KSA9PiAoaW5saW5lID8gJ2lubGluZS1ibG9jaycgOiAnYmxvY2snKX07XG4gIHdpZHRoOiBhdXRvO1xuICBiYWNrZ3JvdW5kLWNsaXA6IHBhZGRpbmctYm94O1xuICB0cmFuc2l0aW9uOiBib3JkZXItY29sb3IgMC4xNXMgZWFzZS1pbi1vdXQsIGJveC1zaGFkb3cgMC4xNXMgZWFzZS1pbi1vdXQ7XG4gIGNvbG9yOiAke2NvbG9yKCdibGFjaycpfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignd2hpdGUnKX07XG5cbiAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnKX07XG4gICR7c2l6ZX07XG5cbiAgJjpkaXNhYmxlZCB7XG4gICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKCdwYWxlR3JleScpfTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCdvZmZXaGl0ZScpfTtcbiAgICBjdXJzb3I6IG5vdC1hbGxvd2VkO1xuICB9XG5cbiAgJHsoeyB2YWxpZCwgdGhlbWUgfSkgPT4gY3NzYFxuICAgIGJvcmRlcjogMXB4IHNvbGlkICR7Y29sb3IodmFsaWQgPyAncGFsZUdyZXknIDogJ3JlZCcsIHsgdGhlbWUgfSl9O1xuXG4gICAgJjpmb2N1cyB7XG4gICAgICBvdXRsaW5lOiAwO1xuICAgICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKHZhbGlkID8gJ2JyYW5kR3JlZW4nIDogJ3JlZCcsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYH07XG5gXG5cbklucHV0LmRlZmF1bHRQcm9wcyA9IHtcbiAgdmFsaWQ6IHRydWUsXG4gIGlubGluZTogZmFsc2Vcbn1cblxuZXhwb3J0IGRlZmF1bHQgSW5wdXRcbiJdfQ== */"));

    default:
      return /*#__PURE__*/core.css(padding('xxs', {
        theme: theme
      }), ";", fontSize('xs', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFnQiIsImZpbGUiOiJJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIGh0dHBzOi8vd2FwcC1mdnVhdGxpdmVzdHlsZWd1aWRlLWN1cy10c3QuYXp1cmV3ZWJzaXRlcy5uZXQvMjUtdGV4dC1pbnB1dHMuaHRtbFxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgY29sb3IsIGJvcmRlclJhZGl1cywgZm9udFNpemUsIHBhZGRpbmcgfSBmcm9tICcuLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgICR7cGFkZGluZygneHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgJHtmb250U2l6ZSgncycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgICAke2ZvbnRTaXplKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IElucHV0ID0gc3R5bGVkLmlucHV0YFxuICBkaXNwbGF5OiAkeyh7IGlubGluZSB9KSA9PiAoaW5saW5lID8gJ2lubGluZS1ibG9jaycgOiAnYmxvY2snKX07XG4gIHdpZHRoOiBhdXRvO1xuICBiYWNrZ3JvdW5kLWNsaXA6IHBhZGRpbmctYm94O1xuICB0cmFuc2l0aW9uOiBib3JkZXItY29sb3IgMC4xNXMgZWFzZS1pbi1vdXQsIGJveC1zaGFkb3cgMC4xNXMgZWFzZS1pbi1vdXQ7XG4gIGNvbG9yOiAke2NvbG9yKCdibGFjaycpfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignd2hpdGUnKX07XG5cbiAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnKX07XG4gICR7c2l6ZX07XG5cbiAgJjpkaXNhYmxlZCB7XG4gICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKCdwYWxlR3JleScpfTtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCdvZmZXaGl0ZScpfTtcbiAgICBjdXJzb3I6IG5vdC1hbGxvd2VkO1xuICB9XG5cbiAgJHsoeyB2YWxpZCwgdGhlbWUgfSkgPT4gY3NzYFxuICAgIGJvcmRlcjogMXB4IHNvbGlkICR7Y29sb3IodmFsaWQgPyAncGFsZUdyZXknIDogJ3JlZCcsIHsgdGhlbWUgfSl9O1xuXG4gICAgJjpmb2N1cyB7XG4gICAgICBvdXRsaW5lOiAwO1xuICAgICAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKHZhbGlkID8gJ2JyYW5kR3JlZW4nIDogJ3JlZCcsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYH07XG5gXG5cbklucHV0LmRlZmF1bHRQcm9wcyA9IHtcbiAgdmFsaWQ6IHRydWUsXG4gIGlubGluZTogZmFsc2Vcbn1cblxuZXhwb3J0IGRlZmF1bHQgSW5wdXRcbiJdfQ== */"));
  }
};

var Input$1 = createStyled("input", {
  target: "ed7u22d0",
  label: "Input"
})("display:", function (_ref2) {
  var inline = _ref2.inline;
  return inline ? 'inline-block' : 'block';
}, ";width:auto;background-clip:padding-box;transition:border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;color:", color('black'), ";background-color:", color('white'), ";", borderRadius('default'), ";", size$8, ";&:disabled{border-color:", color('paleGrey'), ";background-color:", color('offWhite'), ";cursor:not-allowed;}", function (_ref3) {
  var valid = _ref3.valid,
      theme = _ref3.theme;
  return /*#__PURE__*/core.css("border:1px solid ", color(valid ? 'paleGrey' : 'red', {
    theme: theme
  }), ";&:focus{outline:0;border-color:", color(valid ? 'brandGreen' : 'red', {
    theme: theme
  }), ";};label:Input;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFDNkIiLCJmaWxlIjoiSW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBodHRwczovL3dhcHAtZnZ1YXRsaXZlc3R5bGVndWlkZS1jdXMtdHN0LmF6dXJld2Vic2l0ZXMubmV0LzI1LXRleHQtaW5wdXRzLmh0bWxcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGNvbG9yLCBib3JkZXJSYWRpdXMsIGZvbnRTaXplLCBwYWRkaW5nIH0gZnJvbSAnLi4vc3R5bGVzJ1xuXG5jb25zdCBzaXplID0gKHsgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdsZyc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3hzJywgeyB0aGVtZSB9KX07XG4gICAgICAgICR7Zm9udFNpemUoJ3MnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHtwYWRkaW5nKCd4eHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgJHtmb250U2l6ZSgneHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBJbnB1dCA9IHN0eWxlZC5pbnB1dGBcbiAgZGlzcGxheTogJHsoeyBpbmxpbmUgfSkgPT4gKGlubGluZSA/ICdpbmxpbmUtYmxvY2snIDogJ2Jsb2NrJyl9O1xuICB3aWR0aDogYXV0bztcbiAgYmFja2dyb3VuZC1jbGlwOiBwYWRkaW5nLWJveDtcbiAgdHJhbnNpdGlvbjogYm9yZGVyLWNvbG9yIDAuMTVzIGVhc2UtaW4tb3V0LCBib3gtc2hhZG93IDAuMTVzIGVhc2UtaW4tb3V0O1xuICBjb2xvcjogJHtjb2xvcignYmxhY2snKX07XG4gIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3doaXRlJyl9O1xuXG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3NpemV9O1xuXG4gICY6ZGlzYWJsZWQge1xuICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcigncGFsZUdyZXknKX07XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignb2ZmV2hpdGUnKX07XG4gICAgY3Vyc29yOiBub3QtYWxsb3dlZDtcbiAgfVxuXG4gICR7KHsgdmFsaWQsIHRoZW1lIH0pID0+IGNzc2BcbiAgICBib3JkZXI6IDFweCBzb2xpZCAke2NvbG9yKHZhbGlkID8gJ3BhbGVHcmV5JyA6ICdyZWQnLCB7IHRoZW1lIH0pfTtcblxuICAgICY6Zm9jdXMge1xuICAgICAgb3V0bGluZTogMDtcbiAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcih2YWxpZCA/ICdicmFuZEdyZWVuJyA6ICdyZWQnLCB7IHRoZW1lIH0pfTtcbiAgICB9XG4gIGB9O1xuYFxuXG5JbnB1dC5kZWZhdWx0UHJvcHMgPSB7XG4gIHZhbGlkOiB0cnVlLFxuICBpbmxpbmU6IGZhbHNlXG59XG5cbmV4cG9ydCBkZWZhdWx0IElucHV0XG4iXX0= */"));
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9CMEIiLCJmaWxlIjoiSW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBodHRwczovL3dhcHAtZnZ1YXRsaXZlc3R5bGVndWlkZS1jdXMtdHN0LmF6dXJld2Vic2l0ZXMubmV0LzI1LXRleHQtaW5wdXRzLmh0bWxcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGNvbG9yLCBib3JkZXJSYWRpdXMsIGZvbnRTaXplLCBwYWRkaW5nIH0gZnJvbSAnLi4vc3R5bGVzJ1xuXG5jb25zdCBzaXplID0gKHsgc2l6ZSwgdGhlbWUgfSkgPT4ge1xuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdsZyc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAke3BhZGRpbmcoJ3hzJywgeyB0aGVtZSB9KX07XG4gICAgICAgICR7Zm9udFNpemUoJ3MnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJHtwYWRkaW5nKCd4eHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgJHtmb250U2l6ZSgneHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBJbnB1dCA9IHN0eWxlZC5pbnB1dGBcbiAgZGlzcGxheTogJHsoeyBpbmxpbmUgfSkgPT4gKGlubGluZSA/ICdpbmxpbmUtYmxvY2snIDogJ2Jsb2NrJyl9O1xuICB3aWR0aDogYXV0bztcbiAgYmFja2dyb3VuZC1jbGlwOiBwYWRkaW5nLWJveDtcbiAgdHJhbnNpdGlvbjogYm9yZGVyLWNvbG9yIDAuMTVzIGVhc2UtaW4tb3V0LCBib3gtc2hhZG93IDAuMTVzIGVhc2UtaW4tb3V0O1xuICBjb2xvcjogJHtjb2xvcignYmxhY2snKX07XG4gIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3doaXRlJyl9O1xuXG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3NpemV9O1xuXG4gICY6ZGlzYWJsZWQge1xuICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcigncGFsZUdyZXknKX07XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignb2ZmV2hpdGUnKX07XG4gICAgY3Vyc29yOiBub3QtYWxsb3dlZDtcbiAgfVxuXG4gICR7KHsgdmFsaWQsIHRoZW1lIH0pID0+IGNzc2BcbiAgICBib3JkZXI6IDFweCBzb2xpZCAke2NvbG9yKHZhbGlkID8gJ3BhbGVHcmV5JyA6ICdyZWQnLCB7IHRoZW1lIH0pfTtcblxuICAgICY6Zm9jdXMge1xuICAgICAgb3V0bGluZTogMDtcbiAgICAgIGJvcmRlci1jb2xvcjogJHtjb2xvcih2YWxpZCA/ICdicmFuZEdyZWVuJyA6ICdyZWQnLCB7IHRoZW1lIH0pfTtcbiAgICB9XG4gIGB9O1xuYFxuXG5JbnB1dC5kZWZhdWx0UHJvcHMgPSB7XG4gIHZhbGlkOiB0cnVlLFxuICBpbmxpbmU6IGZhbHNlXG59XG5cbmV4cG9ydCBkZWZhdWx0IElucHV0XG4iXX0= */"));

Input$1.defaultProps = {
  valid: true,
  inline: false
};

var FormInput = function FormInput(_ref) {
  var type = _ref.type,
      label = _ref.label,
      name = _ref.name,
      _onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      formatValue = _ref.formatValue,
      props = _objectWithoutProperties(_ref, ["type", "label", "name", "onChange", "onBlur", "formatValue"]);

  return /*#__PURE__*/React__default['default'].createElement(Field, {
    name: name,
    render: function render(_ref2) {
      var fieldOnBlur = _ref2.onBlur,
          fieldOnChange = _ref2.onChange,
          renderError = _ref2.renderError,
          setValue = _ref2.setValue,
          valid = _ref2.valid,
          form = _ref2.form,
          field = _objectWithoutProperties(_ref2, ["onBlur", "onChange", "renderError", "setValue", "valid", "form"]);

      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, type === 'checkbox' ? /*#__PURE__*/React__default['default'].createElement(Checkbox$1, _extends({}, props, field, {
        onBlur: composeHandlers(fieldOnBlur, onBlur),
        onChange: composeHandlers(fieldOnChange, _onChange),
        id: field.name,
        label: label,
        checked: field.value,
        valid: valid
      })) : /*#__PURE__*/React__default['default'].createElement(Input$1, _extends({}, props, field, {
        onBlur: composeHandlers(fieldOnBlur, onBlur),
        onChange: function onChange(e) {
          _onChange && _onChange(e);
          formatValue ? setValue(formatValue(e.target.value)) : fieldOnChange(e);
        },
        type: type,
        valid: valid
      })), renderError());
    }
  });
};

FormInput.displayName = 'Form.Input';

var Select = function Select(_ref) {
  var name = _ref.name,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["name", "onChange"]);

  return /*#__PURE__*/React__default['default'].createElement(Field, {
    name: name,
    render: function render(_ref2) {
      var renderError = _ref2.renderError,
          setValue = _ref2.setValue,
          valid = _ref2.valid,
          value = _ref2.value;
      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(Dropdown, _extends({}, props, {
        name: name,
        onChange: composeHandlers(setValue, onChange),
        valid: valid,
        value: value
      })), renderError());
    }
  });
};

Select.Option = Dropdown.Option;

var SubmitButton = function SubmitButton(_ref) {
  var isSubmitting = _ref.formik.isSubmitting,
      props = _objectWithoutProperties(_ref, ["formik"]);

  return /*#__PURE__*/React__default['default'].createElement(Button, _extends({}, props, {
    disabled: isSubmitting,
    type: "submit"
  }));
};

SubmitButton.defaultProps = {
  kind: 'primary'
};
var SubmitButton$1 = formik.connect(SubmitButton);

var Icon$1 = createStyled("svg", {
  target: "es72eiu0",
  label: "Icon"
})("position:absolute;width:1.25rem;z-index:1;left:", function (_ref) {
  var left = _ref.left;
  return left;
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXVCIiwiZmlsZSI6Ikljb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuY29uc3QgSWNvbiA9IHN0eWxlZC5zdmdgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgd2lkdGg6IDEuMjVyZW07XG4gIHotaW5kZXg6IDE7XG4gIGxlZnQ6ICR7KHsgbGVmdCB9KSA9PiBsZWZ0fTtcbmBcblxuSWNvbi5kaXNwbGF5TmFtZSA9ICdTd2l0Y2hJbnB1dC5JY29uJ1xuXG5leHBvcnQgZGVmYXVsdCBJY29uXG4iXX0= */"));

Icon$1.displayName = 'SwitchInput.Icon';

var Cancel$1 = function Cancel(_ref) {
  var disabled = _ref.disabled,
      theme = _ref.theme;
  return /*#__PURE__*/React__default['default'].createElement(Icon$1, {
    left: "1.25rem",
    viewBox: "0 -3 27 27"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: color(disabled ? 'white' : 'slate', {
      theme: theme
    }),
    d: "M8.6,10l-3.3,3.3l1.4,1.4l3.3-3.3l3.3,3.3l1.4-1.4L11.4,10l3.3-3.3l-1.4-1.4L10,8.6L6.7,5.3L5.3,6.7L8.6,10z"
  }));
};

Cancel$1.displayName = 'SwitchInput.Cancel';
var Cancel$2 = emotionTheming.withTheme(Cancel$1);

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Container$5 = createStyled("div", {
  target: "e1ao7a0g0",
  label: "Container"
})( true ? {
  name: "1umqlch",
  styles: "position:relative;padding-left:3.375rem;height:20px;"
} : {
  name: "1umqlch",
  styles: "position:relative;padding-left:3.375rem;height:20px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgcGFkZGluZy1sZWZ0OiAzLjM3NXJlbTtcbiAgaGVpZ2h0OiAyMHB4O1xuYFxuXG5Db250YWluZXIuZGlzcGxheU5hbWUgPSAnU3dpdGNoSW5wdXQuQ29udGFpbmVyJ1xuXG5leHBvcnQgZGVmYXVsdCBDb250YWluZXJcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});

Container$5.displayName = 'SwitchInput.Container';

var Checkmark = function Checkmark(_ref) {
  var disabled = _ref.disabled,
      theme = _ref.theme;
  return /*#__PURE__*/React__default['default'].createElement(Icon$1, {
    left: 0,
    viewBox: "-7 -7.5 23 23"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    stroke: color(disabled ? 'white' : 'silver', {
      theme: theme
    }),
    strokeWidth: "1.5",
    d: "M1.5 3.75l3 3 6-6"
  })));
};

Checkmark.displayName = 'SwitchInput.Checkmark';
var Checkmark$1 = emotionTheming.withTheme(Checkmark);

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Input$2 = createStyled("input", {
  target: "e5fyh4g0",
  label: "Input"
})( true ? {
  name: "w9pj7n",
  styles: "z-index:-1;opacity:0;position:absolute;"
} : {
  name: "w9pj7n",
  styles: "z-index:-1;opacity:0;position:absolute;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUUwQiIsImZpbGUiOiJJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5jb25zdCBJbnB1dCA9IHN0eWxlZC5pbnB1dGBcbiAgei1pbmRleDogLTE7XG4gIG9wYWNpdHk6IDA7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbmBcblxuSW5wdXQuZGlzcGxheU5hbWUgPSAnU3dpdGNoSW5wdXQuSW5wdXQnXG5cbmV4cG9ydCBkZWZhdWx0IElucHV0XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
});

Input$2.displayName = 'SwitchInput.Input';

var Label$1 = createStyled("label", {
  target: "e124w0bc0",
  label: "Label"
})("margin-bottom:0;", typography('body2'), ";", function (_ref) {
  var disabled = _ref.disabled,
      theme = _ref.theme;
  return /*#__PURE__*/core.css("color:", color(disabled ? 'pewter' : 'slate', {
    theme: theme
  }), ";cursor:", disabled ? 'default' : 'pointer', ";;label:Label;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxhYmVsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNnQyIsImZpbGUiOiJMYWJlbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGNvbG9yLCB0eXBvZ3JhcGh5IH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBMYWJlbCA9IHN0eWxlZC5sYWJlbGBcbiAgbWFyZ2luLWJvdHRvbTogMDtcblxuICAke3R5cG9ncmFwaHkoJ2JvZHkyJyl9O1xuXG4gICR7KHsgZGlzYWJsZWQsIHRoZW1lIH0pID0+IGNzc2BcbiAgICBjb2xvcjogJHtjb2xvcihkaXNhYmxlZCA/ICdwZXd0ZXInIDogJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgY3Vyc29yOiAke2Rpc2FibGVkID8gJ2RlZmF1bHQnIDogJ3BvaW50ZXInfTtcbiAgYH07XG5cbiAgJjo6YmVmb3JlIHtcbiAgICBjb250ZW50OiAnJztcbiAgICB3aWR0aDogMS4yNXJlbTtcbiAgICBoZWlnaHQ6IDEuMjVyZW07XG4gICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgIHVzZXItc2VsZWN0OiBub25lO1xuICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBsZWZ0OiAwO1xuICAgIHotaW5kZXg6IDI7XG4gICAgdHJhbnNpdGlvbjogMC40cztcblxuICAgICR7KHsgY2hlY2tlZCwgZGlzYWJsZWQsIHRoZW1lIH0pID0+IGNzc2BcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoZGlzYWJsZWQgPyAnb2ZmV2hpdGUnIDogJ3doaXRlJywgeyB0aGVtZSB9KX07XG4gICAgICBib3JkZXI6IDFweCBzb2xpZFxuICAgICAgICAke2NvbG9yKGRpc2FibGVkIHx8ICFjaGVja2VkID8gJ3NpbHZlcicgOiAnc2xhdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgke2NoZWNrZWQgPyAnMS4yNXJlbScgOiAwfSk7XG4gICAgYH07XG4gIH1cbmBcblxuTGFiZWwuZGlzcGxheU5hbWUgPSAnU3dpdGNoSW5wdXQuTGFiZWwnXG5cbmV4cG9ydCBkZWZhdWx0IExhYmVsXG4iXX0= */"));
}, ";&::before{content:'';width:1.25rem;height:1.25rem;border-radius:50%;user-select:none;pointer-events:none;position:absolute;left:0;z-index:2;transition:0.4s;", function (_ref2) {
  var checked = _ref2.checked,
      disabled = _ref2.disabled,
      theme = _ref2.theme;
  return /*#__PURE__*/core.css("background-color:", color(disabled ? 'offWhite' : 'white', {
    theme: theme
  }), ";border:1px solid ", color(disabled || !checked ? 'silver' : 'slate', {
    theme: theme
  }), ";transform:translateX(", checked ? '1.25rem' : 0, ");;label:Label;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxhYmVsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBCMkMiLCJmaWxlIjoiTGFiZWwuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBjb2xvciwgdHlwb2dyYXBoeSB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgTGFiZWwgPSBzdHlsZWQubGFiZWxgXG4gIG1hcmdpbi1ib3R0b206IDA7XG5cbiAgJHt0eXBvZ3JhcGh5KCdib2R5MicpfTtcblxuICAkeyh7IGRpc2FibGVkLCB0aGVtZSB9KSA9PiBjc3NgXG4gICAgY29sb3I6ICR7Y29sb3IoZGlzYWJsZWQgPyAncGV3dGVyJyA6ICdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICAgIGN1cnNvcjogJHtkaXNhYmxlZCA/ICdkZWZhdWx0JyA6ICdwb2ludGVyJ307XG4gIGB9O1xuXG4gICY6OmJlZm9yZSB7XG4gICAgY29udGVudDogJyc7XG4gICAgd2lkdGg6IDEuMjVyZW07XG4gICAgaGVpZ2h0OiAxLjI1cmVtO1xuICAgIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgICB1c2VyLXNlbGVjdDogbm9uZTtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gICAgbGVmdDogMDtcbiAgICB6LWluZGV4OiAyO1xuICAgIHRyYW5zaXRpb246IDAuNHM7XG5cbiAgICAkeyh7IGNoZWNrZWQsIGRpc2FibGVkLCB0aGVtZSB9KSA9PiBjc3NgXG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKGRpc2FibGVkID8gJ29mZldoaXRlJyA6ICd3aGl0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgYm9yZGVyOiAxcHggc29saWRcbiAgICAgICAgJHtjb2xvcihkaXNhYmxlZCB8fCAhY2hlY2tlZCA/ICdzaWx2ZXInIDogJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoJHtjaGVja2VkID8gJzEuMjVyZW0nIDogMH0pO1xuICAgIGB9O1xuICB9XG5gXG5cbkxhYmVsLmRpc3BsYXlOYW1lID0gJ1N3aXRjaElucHV0LkxhYmVsJ1xuXG5leHBvcnQgZGVmYXVsdCBMYWJlbFxuIl19 */"));
}, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxhYmVsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUkwQiIsImZpbGUiOiJMYWJlbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGNvbG9yLCB0eXBvZ3JhcGh5IH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBMYWJlbCA9IHN0eWxlZC5sYWJlbGBcbiAgbWFyZ2luLWJvdHRvbTogMDtcblxuICAke3R5cG9ncmFwaHkoJ2JvZHkyJyl9O1xuXG4gICR7KHsgZGlzYWJsZWQsIHRoZW1lIH0pID0+IGNzc2BcbiAgICBjb2xvcjogJHtjb2xvcihkaXNhYmxlZCA/ICdwZXd0ZXInIDogJ3NsYXRlJywgeyB0aGVtZSB9KX07XG4gICAgY3Vyc29yOiAke2Rpc2FibGVkID8gJ2RlZmF1bHQnIDogJ3BvaW50ZXInfTtcbiAgYH07XG5cbiAgJjo6YmVmb3JlIHtcbiAgICBjb250ZW50OiAnJztcbiAgICB3aWR0aDogMS4yNXJlbTtcbiAgICBoZWlnaHQ6IDEuMjVyZW07XG4gICAgYm9yZGVyLXJhZGl1czogNTAlO1xuICAgIHVzZXItc2VsZWN0OiBub25lO1xuICAgIHBvaW50ZXItZXZlbnRzOiBub25lO1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICBsZWZ0OiAwO1xuICAgIHotaW5kZXg6IDI7XG4gICAgdHJhbnNpdGlvbjogMC40cztcblxuICAgICR7KHsgY2hlY2tlZCwgZGlzYWJsZWQsIHRoZW1lIH0pID0+IGNzc2BcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoZGlzYWJsZWQgPyAnb2ZmV2hpdGUnIDogJ3doaXRlJywgeyB0aGVtZSB9KX07XG4gICAgICBib3JkZXI6IDFweCBzb2xpZFxuICAgICAgICAke2NvbG9yKGRpc2FibGVkIHx8ICFjaGVja2VkID8gJ3NpbHZlcicgOiAnc2xhdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWCgke2NoZWNrZWQgPyAnMS4yNXJlbScgOiAwfSk7XG4gICAgYH07XG4gIH1cbmBcblxuTGFiZWwuZGlzcGxheU5hbWUgPSAnU3dpdGNoSW5wdXQuTGFiZWwnXG5cbmV4cG9ydCBkZWZhdWx0IExhYmVsXG4iXX0= */"));

Label$1.displayName = 'SwitchInput.Label';

var Slider = createStyled("span", {
  target: "eltasv70",
  label: "Slider"
})("width:2.5rem;height:1.25rem;position:absolute;left:0;border-radius:0.825rem;transition:0.4s;", function (_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      theme = _ref.theme;
  return /*#__PURE__*/core.css("background-color:", color(disabled ? 'silver' : checked ? 'slate' : 'paleGrey', {
    theme: theme
  }), ";border:1px solid ", color(disabled || !checked ? 'silver' : 'slate', {
    theme: theme
  }), ";;label:Slider;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNsaWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZeUMiLCJmaWxlIjoiU2xpZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IFNsaWRlciA9IHN0eWxlZC5zcGFuYFxuICB3aWR0aDogMi41cmVtO1xuICBoZWlnaHQ6IDEuMjVyZW07XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgbGVmdDogMDtcbiAgYm9yZGVyLXJhZGl1czogMC44MjVyZW07XG4gIHRyYW5zaXRpb246IDAuNHM7XG5cbiAgJHsoeyBjaGVja2VkLCBkaXNhYmxlZCwgdGhlbWUgfSkgPT4gY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoXG4gICAgICBkaXNhYmxlZCA/ICdzaWx2ZXInIDogY2hlY2tlZCA/ICdzbGF0ZScgOiAncGFsZUdyZXknLFxuICAgICAgeyB0aGVtZSB9XG4gICAgKX07XG4gICAgYm9yZGVyOiAxcHggc29saWRcbiAgICAgICR7Y29sb3IoZGlzYWJsZWQgfHwgIWNoZWNrZWQgPyAnc2lsdmVyJyA6ICdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICBgfTtcbmBcblxuU2xpZGVyLmRpc3BsYXlOYW1lID0gJ1N3aXRjaElucHV0LlNsaWRlcidcblxuZXhwb3J0IGRlZmF1bHQgU2xpZGVyXG4iXX0= */"));
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNsaWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJMEIiLCJmaWxlIjoiU2xpZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IFNsaWRlciA9IHN0eWxlZC5zcGFuYFxuICB3aWR0aDogMi41cmVtO1xuICBoZWlnaHQ6IDEuMjVyZW07XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgbGVmdDogMDtcbiAgYm9yZGVyLXJhZGl1czogMC44MjVyZW07XG4gIHRyYW5zaXRpb246IDAuNHM7XG5cbiAgJHsoeyBjaGVja2VkLCBkaXNhYmxlZCwgdGhlbWUgfSkgPT4gY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoXG4gICAgICBkaXNhYmxlZCA/ICdzaWx2ZXInIDogY2hlY2tlZCA/ICdzbGF0ZScgOiAncGFsZUdyZXknLFxuICAgICAgeyB0aGVtZSB9XG4gICAgKX07XG4gICAgYm9yZGVyOiAxcHggc29saWRcbiAgICAgICR7Y29sb3IoZGlzYWJsZWQgfHwgIWNoZWNrZWQgPyAnc2lsdmVyJyA6ICdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICBgfTtcbmBcblxuU2xpZGVyLmRpc3BsYXlOYW1lID0gJ1N3aXRjaElucHV0LlNsaWRlcidcblxuZXhwb3J0IGRlZmF1bHQgU2xpZGVyXG4iXX0= */"));

Slider.displayName = 'SwitchInput.Slider';

var SwitchInput = function SwitchInput(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      id = _ref.id,
      label = _ref.label,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["checked", "disabled", "id", "label", "type"]);

  return /*#__PURE__*/React__default['default'].createElement(Container$5, null, /*#__PURE__*/React__default['default'].createElement(Input$2, _extends({
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    id: id
  }, rest)), /*#__PURE__*/React__default['default'].createElement(Label$1, {
    checked: checked,
    disabled: disabled,
    htmlFor: id
  }, /*#__PURE__*/React__default['default'].createElement(Slider, {
    checked: checked,
    disabled: disabled
  }), /*#__PURE__*/React__default['default'].createElement(Checkmark$1, {
    disabled: disabled
  }), /*#__PURE__*/React__default['default'].createElement(Cancel$2, {
    disabled: disabled
  }), /*#__PURE__*/React__default['default'].createElement("span", null, label)));
};

var Switch = function Switch(_ref) {
  var label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      props = _objectWithoutProperties(_ref, ["label", "name", "onChange", "onBlur"]);

  return /*#__PURE__*/React__default['default'].createElement(Field, {
    name: name,
    render: function render(_ref2) {
      var fieldOnBlur = _ref2.onBlur,
          fieldOnChange = _ref2.onChange,
          renderError = _ref2.renderError,
          valid = _ref2.valid,
          value = _ref2.value,
          field = _objectWithoutProperties(_ref2, ["onBlur", "onChange", "renderError", "valid", "value"]);

      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(SwitchInput, _extends({}, props, field, {
        id: field.name,
        label: label,
        checked: value,
        valid: valid,
        onChange: composeHandlers(fieldOnChange, onChange)
      })), renderError());
    }
  });
};

// https://wapp-fvuatlivestyleguide-cus-tst.azurewebsites.net/25-text-inputs.html
var Textarea = Input$1.withComponent('textarea', {
  target: "e1li8p1g0",
  label: "Textarea"
});
Textarea.defaultProps = {
  valid: true
};

var FormTextarea = function FormTextarea(_ref) {
  var name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["name", "onBlur", "onChange"]);

  return /*#__PURE__*/React__default['default'].createElement(Field, {
    name: name,
    render: function render(_ref2) {
      var fieldOnBlur = _ref2.onBlur,
          fieldOnChange = _ref2.onChange,
          renderError = _ref2.renderError,
          valid = _ref2.valid,
          field = _objectWithoutProperties(_ref2, ["onBlur", "onChange", "renderError", "valid"]);

      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(Textarea, _extends({}, props, field, {
        onBlur: composeHandlers(fieldOnBlur, onBlur),
        onChange: composeHandlers(fieldOnChange, onChange),
        valid: valid
      })), renderError());
    }
  });
};

var Label$2 = createStyled("label", {
  target: "ejlcscx0",
  label: "Label"
})("display:inline-block;margin-bottom:", spacer(2), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxhYmVsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUcwQiIsImZpbGUiOiJMYWJlbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgc3BhY2VyIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBMYWJlbCA9IHN0eWxlZC5sYWJlbGBcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcigyKX07XG5gXG5cbkxhYmVsLmRpc3BsYXlOYW1lID0gJ0Zvcm0uTGFiZWwnXG5cbmV4cG9ydCBkZWZhdWx0IExhYmVsXG4iXX0= */"));

Label$2.displayName = 'Form.Label';

var Title$1 = createStyled("h5", {
  target: "e1u3ng400",
  label: "Title"
})("margin-bottom:", spacer(5), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpdGxlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUd1QiIsImZpbGUiOiJUaXRsZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgc3BhY2VyIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBUaXRsZSA9IHN0eWxlZC5oNWBcbiAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSl9O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBUaXRsZVxuIl19 */"));

var Value = function Value(_ref) {
  var children = _ref.children,
      name = _ref.name,
      _ref$formik = _ref.formik,
      setFieldValue = _ref$formik.setFieldValue,
      values = _ref$formik.values;
  return children({
    value: values[name],
    setValue: function setValue(value) {
      return setFieldValue(name, value);
    }
  });
};

var Value$1 = formik.connect(Value);

var Form = function Form(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _onSubmit = _ref.onSubmit,
      redirect = _ref.redirect,
      history = _ref.history,
      serializeErrors = _ref.serializeErrors,
      props = _objectWithoutProperties(_ref, ["children", "className", "onSubmit", "redirect", "history", "serializeErrors"]);

  return /*#__PURE__*/React__default['default'].createElement(formik.Formik, _extends({}, props, {
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting,
          setErrors = _ref2.setErrors,
          setStatus = _ref2.setStatus;
      Promise.resolve(_onSubmit(values)).then(function () {
        redirect ? history.replace(redirect) : setSubmitting(false);
      })["catch"](function (error) {
        setSubmitting(false);
        setErrors({
          form: serializeErrors ? serializeErrors(error) : error
        });
      });
    },
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit;
      return /*#__PURE__*/React__default['default'].createElement("form", {
        onSubmit: handleSubmit,
        className: className
      }, children);
    }
  }));
};

Form.displayName = 'Form';
Form.defaultProps = {
  validateOnBlur: false,
  validateOnChange: false
};
Form.Actions = Actions$1;
Form.Errors = Errors$1;
Form.Field = Field;
Form.FileUpload = FileUpload;
Form.Group = Group;
Form.Input = FormInput;
Form.Select = Select;
Form.SubmitButton = SubmitButton$1;
Form.Textarea = FormTextarea;
Form.Title = Title$1;
Form.SwitchInput = Switch;
Form.Label = Label$2;
Form.Value = Value$1;
var index$1 = reactRouterDom.withRouter(Form);

var LogoPath = createStyled("path", {
  target: "eh1gl2q0",
  label: "LogoPath"
})("fill:", color('brandMain'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvZ29QYXRoLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUc0QiIsImZpbGUiOiJMb2dvUGF0aC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IExvZ29QYXRoID0gc3R5bGVkLnBhdGhgXG4gIGZpbGw6ICR7Y29sb3IoJ2JyYW5kTWFpbicpfTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgTG9nb1BhdGhcbiJdfQ== */"));

var TextPath = createStyled("path", {
  target: "ez6h3mx0",
  label: "TextPath"
})("fill:", function (_ref) {
  var theme = _ref.theme,
      dark = _ref.dark;
  return color(dark ? 'white' : 'ink', {
    theme: theme
  });
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRleHRQYXRoLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUc0QiIsImZpbGUiOiJUZXh0UGF0aC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IFRleHRQYXRoID0gc3R5bGVkLnBhdGhgXG4gIGZpbGw6ICR7KHsgdGhlbWUsIGRhcmsgfSkgPT4gY29sb3IoZGFyayA/ICd3aGl0ZScgOiAnaW5rJywgeyB0aGVtZSB9KX07XG5gXG5cbmV4cG9ydCBkZWZhdWx0IFRleHRQYXRoXG4iXX0= */"));

var size$9 = function size(_ref) {
  var ieWidths = _ref.ieWidths,
      size = _ref.size,
      oneLineHeight = _ref.oneLineHeight;
  var height;

  switch (size) {
    case 'sm':
      height = '60px';
      break;

    case 'lg':
      height = '80px';
      break;

    default:
      height = '72px';
  } // Set height for one line logos


  if (oneLineHeight) height = "".concat(oneLineHeight[size || 'default'], "px"); // Explicitly set SVG width for IE

  return /*#__PURE__*/core.css("height:", height, ";width:auto;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:", ieWidths[size || 'default'], "px;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN2Zy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1QmMiLCJmaWxlIjoiU3ZnLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQge2Nzc30gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB3aXRoUHJvcHMgZnJvbSAncmVjb21wb3NlL3dpdGhQcm9wcydcblxuY29uc3Qgc2l6ZSA9ICh7aWVXaWR0aHMsIHNpemUsIG9uZUxpbmVIZWlnaHR9KSA9PiB7XG4gICAgbGV0IGhlaWdodFxuXG4gICAgc3dpdGNoIChzaXplKSB7XG4gICAgICAgIGNhc2UgJ3NtJzpcbiAgICAgICAgICAgIGhlaWdodCA9ICc2MHB4J1xuICAgICAgICAgICAgYnJlYWtcbiAgICAgICAgY2FzZSAnbGcnOlxuICAgICAgICAgICAgaGVpZ2h0ID0gJzgwcHgnXG4gICAgICAgICAgICBicmVha1xuICAgICAgICBkZWZhdWx0OlxuICAgICAgICAgICAgaGVpZ2h0ID0gJzcycHgnXG4gICAgfVxuXG4gICAgLy8gU2V0IGhlaWdodCBmb3Igb25lIGxpbmUgbG9nb3NcbiAgICBpZiAob25lTGluZUhlaWdodClcbiAgICAgICAgaGVpZ2h0ID0gYCR7b25lTGluZUhlaWdodFtzaXplIHx8ICdkZWZhdWx0J119cHhgXG5cbiAgICAvLyBFeHBsaWNpdGx5IHNldCBTVkcgd2lkdGggZm9yIElFXG4gICAgcmV0dXJuIGNzc2BcbiAgICBoZWlnaHQ6ICR7aGVpZ2h0fTtcbiAgICB3aWR0aDogYXV0bztcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kICgtbXMtaGlnaC1jb250cmFzdDogYWN0aXZlKSwgKC1tcy1oaWdoLWNvbnRyYXN0OiBub25lKSB7XG4gICAgICB3aWR0aDogJHtpZVdpZHRoc1tzaXplIHx8ICdkZWZhdWx0J119cHg7XG4gICAgfVxuICBgXG59XG5cbmNvbnN0IFN2ZyA9IHdpdGhQcm9wcyh7XG4gICAgeG1sbnM6ICdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zydcbn0pKHN0eWxlZC5zdmcoc2l6ZSkpXG5cbmV4cG9ydCBkZWZhdWx0IFN2Z1xuIl19 */"));
};

var Svg = withProps__default['default']({
  xmlns: 'http://www.w3.org/2000/svg'
})(createStyled("svg", {
  target: "e11xr0gk0",
  label: "Svg"
})(size$9,  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN2Zy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtQ0ciLCJmaWxlIjoiU3ZnLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQge2Nzc30gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB3aXRoUHJvcHMgZnJvbSAncmVjb21wb3NlL3dpdGhQcm9wcydcblxuY29uc3Qgc2l6ZSA9ICh7aWVXaWR0aHMsIHNpemUsIG9uZUxpbmVIZWlnaHR9KSA9PiB7XG4gICAgbGV0IGhlaWdodFxuXG4gICAgc3dpdGNoIChzaXplKSB7XG4gICAgICAgIGNhc2UgJ3NtJzpcbiAgICAgICAgICAgIGhlaWdodCA9ICc2MHB4J1xuICAgICAgICAgICAgYnJlYWtcbiAgICAgICAgY2FzZSAnbGcnOlxuICAgICAgICAgICAgaGVpZ2h0ID0gJzgwcHgnXG4gICAgICAgICAgICBicmVha1xuICAgICAgICBkZWZhdWx0OlxuICAgICAgICAgICAgaGVpZ2h0ID0gJzcycHgnXG4gICAgfVxuXG4gICAgLy8gU2V0IGhlaWdodCBmb3Igb25lIGxpbmUgbG9nb3NcbiAgICBpZiAob25lTGluZUhlaWdodClcbiAgICAgICAgaGVpZ2h0ID0gYCR7b25lTGluZUhlaWdodFtzaXplIHx8ICdkZWZhdWx0J119cHhgXG5cbiAgICAvLyBFeHBsaWNpdGx5IHNldCBTVkcgd2lkdGggZm9yIElFXG4gICAgcmV0dXJuIGNzc2BcbiAgICBoZWlnaHQ6ICR7aGVpZ2h0fTtcbiAgICB3aWR0aDogYXV0bztcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kICgtbXMtaGlnaC1jb250cmFzdDogYWN0aXZlKSwgKC1tcy1oaWdoLWNvbnRyYXN0OiBub25lKSB7XG4gICAgICB3aWR0aDogJHtpZVdpZHRoc1tzaXplIHx8ICdkZWZhdWx0J119cHg7XG4gICAgfVxuICBgXG59XG5cbmNvbnN0IFN2ZyA9IHdpdGhQcm9wcyh7XG4gICAgeG1sbnM6ICdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zydcbn0pKHN0eWxlZC5zdmcoc2l6ZSkpXG5cbmV4cG9ydCBkZWZhdWx0IFN2Z1xuIl19 */"));

var DigitalDiariesLogo = function DigitalDiariesLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    viewBox: "0 0 1032 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M244.31,72.77A40,40,0,0,0,231,64.92a49.27,49.27,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.28,37.28,0,0,0-9,12.53,40.14,40.14,0,0,0-3.32,16.6,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40,40,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40.11,40.11,0,0,0-3.32-16.6A36.94,36.94,0,0,0,244.31,72.77ZM231.7,109a19.58,19.58,0,0,1-3.4,6.25,16.84,16.84,0,0,1-5.58,4.46,18.79,18.79,0,0,1-15.4,0,16.82,16.82,0,0,1-5.58-4.46,19.28,19.28,0,0,1-3.4-6.25,22.84,22.84,0,0,1,0-14.19,18.2,18.2,0,0,1,3.32-6.1,18,18,0,0,1,20.91-4.31,17.54,17.54,0,0,1,5.59,4.31,18.71,18.71,0,0,1,3.47,6.1,21.26,21.26,0,0,1,1.21,7.09A22.68,22.68,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v23.94H118.75l-.09,36.57H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.83-21.94,3-30.06,11.61-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.81v3.93h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.15,21.15,0,0,1,535,90.29c0,7.3,0,17.52,0,23.92C529,121.13,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.44,2.89,21.35,3.06,22.62-8.92,3.1-19.62,4.7-28.92,2.8-12.85-2.61-21.52-11.64-23.78-24.57a48.73,48.73,0,0,1-.81-8.43c0-7.29,0-21.11,0-21.11l-14.77,0V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68,0s-.09,13.59.06,20.67,4.08,10.92,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.36c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.71,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.35-35.42,25.35-18.52,0-33.94-7.45-36.91-25.46h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.87,10.92-5.16c0-2.66-3-4.54-8-5.32l-15.29-2.66c-12.95-2.19-22.16-9.54-22.16-22.84,0-16,13.57-25.34,33.7-25.34,17.51,0,33.38,6.07,35.15,25l-22.45,0c-1.2-4.64-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.17,0,2.65,1.88,5,8,6.09l14,2.35C386.34,96.55,395.86,103.44,395.87,116.9Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M212.23,195.39a7.28,7.28,0,1,1-7.28-7.28A7.29,7.29,0,0,1,212.23,195.39Zm120.37-7.28a7.28,7.28,0,1,0,7.27,7.28A7.28,7.28,0,0,0,332.6,188.11Zm358.22,0a7.28,7.28,0,1,0,7.28,7.28A7.29,7.29,0,0,0,690.82,188.11Zm175.24,0a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,866.06,188.11ZM183.27,241.47c0,29.26-20.77,53.06-50,53.06H92.31V188.42h40.94C162.5,188.42,183.27,212.22,183.27,241.47Zm-10.31,0c0-23.8-16.07-43.05-39.71-43.05H102.93v86.11h30.32C156.89,284.53,173,265.28,173,241.47Zm27,53.06h10v-75.8H200Zm96.41-75.8h10V291.5c0,23-18.5,35.17-38.05,35.17-17.43,0-30-6.67-35.93-18.49l8.79-5C245,310.9,252,317,268.32,317c17.58,0,28-10,28-25.47V279.68c-6.36,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.43c13.49,0,24.26,6.51,30.62,16.67Zm0,37.9a29.86,29.86,0,1,0-29.86,30A29.57,29.57,0,0,0,296.36,256.63Zm31.23,37.9h10v-75.8h-10Zm49.57-97-10,3v18.19H351.24v9.71h15.92v45.93c0,18.19,11.37,23.19,31.83,20.16v-8.79c-14.7.61-21.83,1.67-21.83-11.37V228.44H399v-9.71H377.16Zm99.15,21.22h10v75.8h-10V279.68c-6.37,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.43c13.49,0,24.25,6.51,30.62,16.67Zm0,37.9a29.87,29.87,0,1,0-29.87,30A29.58,29.58,0,0,0,476.31,256.63Zm31.23,37.9h10V183.87h-10Zm161.6-53.06c0,29.26-20.77,53.06-50,53.06H578.18V188.42h40.93C648.37,188.42,669.14,212.22,669.14,241.47Zm-10.31,0c0-23.8-16.07-43.05-39.72-43.05H588.79v86.11h30.32C642.76,284.53,658.83,265.28,658.83,241.47Zm27,53.06h10v-75.8h-10Zm96.41-75.8h10v75.8h-10V279.68c-6.37,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.43c13.49,0,24.25,6.51,30.62,16.67Zm0,37.9a29.87,29.87,0,1,0-29.86,30A29.57,29.57,0,0,0,782.23,256.63Zm41.24-25.31V218.73h-10v75.8h10V252.39c0-18.8,11.82-25.17,23.95-25.17v-9.7C837.72,217.52,828.77,220.71,823.47,231.32Zm37.59,63.21h10v-75.8h-10ZM964.9,256.94c0,1.51-.15,3.18-.3,4.7H898.05c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.41-12.89l8.79,5.16c-6.37,10.31-18,17.43-33.35,17.43-24,0-40.33-16.82-40.33-39.72,0-22.28,16.07-39.71,39.57-39.71C950.5,216.92,964.9,236.17,964.9,256.94Zm-10.3-5c-2.13-16.67-14.25-25.31-27.29-25.31-15.92,0-27.29,10.46-29.26,25.31Zm31.08-13.34c0-8.18,8-12,15.91-12,7.28,0,15,2.88,18.2,10.61l8.33-4.85c-4.39-9.4-14.1-15.46-26.53-15.46-15.16,0-25.92,9.55-25.92,21.67,0,27.9,44.27,17.13,44.27,35.93,0,9-8.49,12.13-17.44,12.13-10.15,0-18-5-20.76-12.73l-8.49,5c3.79,9.7,14.09,17.43,29.25,17.43,16.23,0,27.44-8.94,27.44-21.83C1029.94,246.63,985.68,257.39,985.68,238.59Z"
  }));
};

var DigitalInterviewsLogo = function DigitalInterviewsLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    viewBox: "0 0 1244 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M69.78,34V58.18H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M244.31,72.77A39.81,39.81,0,0,0,231,64.93a48.93,48.93,0,0,0-32.23,0,38.84,38.84,0,0,0-13.28,7.84,37.28,37.28,0,0,0-9,12.53,40.14,40.14,0,0,0-3.32,16.6,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.53,41.53,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40.11,40.11,0,0,0-3.32-16.6A36.94,36.94,0,0,0,244.31,72.77ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.48h45.38v23.93H118.75l-.09,36.57H92.33ZM535,63.14v5.07a36.08,36.08,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.61-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.45c-5.7-4-7.91-9.7-7.69-16.41.31-9.27,6.59-16.25,15.78-17.35A21.17,21.17,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.14,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.45,2.89,21.35,3.06,22.62-8.92,3.1-19.62,4.7-28.92,2.81-12.85-2.63-21.52-11.65-23.78-24.58a48.61,48.61,0,0,1-.81-8.42c0-7.3,0-21.12,0-21.12l-14.77,0V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.05s-.09,13.6.06,20.66c.16,7.23,4.08,10.94,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.36c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.71,297,91,291.07,96.76v43.38H265.64v-77h25.43Zm104.8,44.32c0,17.53-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.66-3-4.53-8-5.32l-15.29-2.66c-12.95-2.19-22.16-9.54-22.16-22.84,0-16,13.57-25.34,33.7-25.34,17.51,0,33.38,6.07,35.15,25l-22.45,0c-1.2-4.63-6.3-7-12.7-7-6.56,0-9.52,2.35-9.52,5.16s1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.44,395.87,116.9Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M212.23,195.39a7.28,7.28,0,1,1-7.28-7.28A7.28,7.28,0,0,1,212.23,195.39Zm120.37-7.28a7.28,7.28,0,1,0,7.27,7.28A7.28,7.28,0,0,0,332.6,188.11Zm634.28,0a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,966.88,188.11ZM183.27,241.47c0,29.26-20.77,53.06-50,53.06H92.32V188.41h40.93C162.5,188.41,183.27,212.22,183.27,241.47Zm-10.31,0c0-23.8-16.07-43.05-39.71-43.05H102.93v86.11h30.32C156.89,284.53,173,265.27,173,241.47Zm27,53.06h10v-75.8H200Zm96.41-75.8h10V291.5c0,23-18.5,35.17-38.05,35.17-17.44,0-30-6.67-35.93-18.49l8.79-5C245,310.9,252,317,268.32,317c17.58,0,28-10,28-25.47V279.68c-6.36,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.44c13.49,0,24.26,6.52,30.62,16.68Zm0,37.9a29.87,29.87,0,1,0-29.86,30A29.56,29.56,0,0,0,296.36,256.63Zm31.23,37.9h10v-75.8h-10Zm49.57-97-10,3v18.19H351.24v9.71h15.92v45.93c0,18.19,11.37,23.19,31.84,20.16v-8.79c-14.71.61-21.84,1.67-21.84-11.37V228.44H399v-9.71H377.16Zm99.15,21.22h10v75.8h-10V279.68c-6.37,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.44c13.49,0,24.25,6.52,30.62,16.68Zm0,37.9a29.87,29.87,0,1,0-29.86,30A29.57,29.57,0,0,0,476.31,256.63Zm31.23,37.9h10V183.87h-10Zm70.64,0h10.61V188.41H578.18ZM647,216.91c-10.76,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C676.72,229,665.5,216.91,647,216.91Zm67.46-19.4-10,3v18.19H688.55v9.71h15.91v45.93c0,18.19,11.37,23.19,31.84,20.16v-8.79c-14.7.61-21.83,1.67-21.83-11.37V228.44H736.3v-9.71H714.47ZM821,256.94c0,1.51-.15,3.18-.3,4.7H754.19c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.4-12.89l8.8,5.16c-6.37,10.31-18,17.43-33.35,17.43-24,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C806.64,216.91,821,236.17,821,256.94Zm-10.3-5c-2.13-16.67-14.25-25.31-27.29-25.31-15.92,0-27.29,10.46-29.26,25.31ZM847,231.32V218.73H837v75.8h10V252.39c0-18.8,11.82-25.17,23.95-25.17v-9.7C861.22,217.52,852.27,220.71,847,231.32Zm65.64,52.75-26.53-65.34H875.47l31.08,75.8h12.12l31.08-75.8H939.14Zm49.27,10.46h10v-75.8h-10Zm103.84-37.59c0,1.51-.15,3.18-.3,4.7H998.87c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.4-12.89l8.8,5.16c-6.37,10.31-18,17.43-33.35,17.43-24,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C1051.32,216.91,1065.72,236.17,1065.72,256.94Zm-10.31-5c-2.12-16.67-14.25-25.31-27.28-25.31-15.92,0-27.29,10.46-29.26,25.31Zm95.82,29.72-19.86-62.92h-10l-19.86,62.92-18.64-62.92h-10.31l23.34,75.8h10.92l19.56-61.09,19.55,61.09h10.92l23.34-75.8h-10.31Zm47.45-43.06c0-8.18,8-12,15.92-12,7.27,0,15,2.88,18.19,10.61l8.33-4.85c-4.39-9.4-14.09-15.47-26.52-15.47-15.16,0-25.93,9.56-25.93,21.68,0,27.9,44.27,17.13,44.27,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.43-8.94,27.43-21.83C1242.94,246.63,1198.68,257.39,1198.68,238.59Z"
  }));
};

var ForstaLogo = function ForstaLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    viewBox: "0 0 292 57",
    ieWidths: {
      sm: 191,
      lg: 307,
      "default": 250
    },
    oneLineHeight: {
      sm: 20,
      lg: 32,
      "default": 26
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M35.449 55.339H23.3813V35.7093H0V23.6295H35.449V55.339Z"
  }), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M35.4966 -0.199951H0.0474854V11.8798H35.4966V-0.199951Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M61.0927 12.1158V23.8182H84.851V35.7092H61.0927V55.3389H47.3279V-0.15271H88.8108V12.1158H61.0927Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M133.877 35.7093C133.877 47.9779 124.826 56.4715 112.193 56.4715C99.5592 56.4715 90.3198 47.9779 90.3198 35.7093C90.3198 23.4408 99.3706 14.7584 112.193 14.7584C125.015 14.7584 133.877 23.4408 133.877 35.7093ZM121.432 35.7093C121.809 30.6132 118.038 26.272 112.947 25.8945C112.758 25.8945 112.381 25.8945 112.193 25.8945C107.102 25.7057 102.953 29.8582 102.765 34.9543C102.765 35.1431 102.765 35.5206 102.765 35.7093C102.388 40.8055 106.159 45.1467 111.25 45.5242C111.627 45.5242 111.815 45.5242 112.193 45.5242C117.284 45.7129 121.432 41.5605 121.432 36.6531C121.621 36.2756 121.621 35.8981 121.432 35.7093Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M166.497 27.7817C160.086 27.9704 155.938 29.6691 152.921 32.6891V55.3387H139.533V15.7019H152.921V20.043C156.692 16.8343 161.595 14.9469 166.497 15.1356V27.7817Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M189.124 46.6566C192.707 46.6566 194.781 45.7129 194.781 44.0142C194.781 42.693 193.273 41.5605 190.633 41.183L182.713 39.8618C175.925 38.7293 171.211 34.9543 171.211 27.9707C171.211 19.6658 178.377 14.7584 188.936 14.7584C198.364 14.7584 206.849 17.9671 207.415 28.3482H195.724C195.535 25.3282 192.707 24.007 188.936 24.007C185.542 24.007 184.033 25.1395 184.033 26.6495C184.033 27.9707 184.976 29.2919 188.182 29.8582L195.535 30.9907C202.889 32.3119 207.792 35.8981 207.792 43.0705C207.792 52.1303 199.684 56.2827 189.313 56.2827C179.131 56.2827 170.646 52.1303 169.891 41.5605H181.582C181.959 45.3354 184.976 46.6566 189.124 46.6566Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M246.069 54.5839C242.675 55.9052 239.092 56.6601 235.51 56.4714C224.762 56.4714 218.162 49.4878 218.162 38.7292V27.2156H210.431V15.8908H218.162V2.30103H231.361V15.7021H244.749V27.0269H231.361V38.1629C231.361 42.3154 233.813 44.2029 237.584 44.2029C240.035 44.0141 242.298 43.6366 244.56 42.5041L246.069 54.5839Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M292.266 15.7022V55.339H279.067V53.2628C275.861 55.339 272.09 56.4715 268.13 56.4715C257.383 56.4715 248.52 47.4116 248.52 35.5206C248.52 23.6295 257.571 14.7584 268.13 14.7584C271.902 14.7584 275.861 15.7022 279.067 17.7784V15.7022H292.266ZM279.067 41.7492V29.4807C276.993 27.2157 273.976 25.8945 270.959 25.8945C265.868 25.8945 261.531 30.0469 261.531 35.1431C261.531 35.3318 261.531 35.5206 261.531 35.5206C261.342 40.6167 265.302 44.9579 270.393 45.1467C270.582 45.1467 270.77 45.1467 270.77 45.1467C273.976 45.3354 276.993 44.0142 279.067 41.7492Z"
  }));
};

var InterVuLogo = function InterVuLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    viewBox: "0 0 561 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.22,37.22,0,0,0-9,12.54,40.06,40.06,0,0,0-3.32,16.59,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40,40,0,0,0-3.32-16.59A36.88,36.88,0,0,0,244.31,72.77ZM231.7,109a19.42,19.42,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v24H118.75l-.09,36.56H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.62-11.77,12.45-14.3,31.75-6.28,47.34,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.44,2.89,21.35,3.06,22.62-8.92,3.1-19.62,4.7-28.92,2.81-12.85-2.63-21.52-11.65-23.78-24.58a48.71,48.71,0,0,1-.81-8.42c0-7.29,0-21.12,0-21.12l-14.77.06V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.05s-.09,13.59.06,20.66c.16,7.23,4.08,10.93,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.36c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.71,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.65-3-4.54-8-5.32l-15.29-2.66c-12.95-2.19-22.16-9.54-22.16-22.84,0-16,13.57-25.33,33.7-25.33,17.51,0,33.38,6.06,35.15,25l-22.45,0c-1.2-4.63-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.16,0,2.67,1.88,5,8,6.11l14,2.34C386.34,96.56,395.86,103.44,395.87,116.9Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M92.31,188.41h10.62V294.53H92.31Zm68.83,28.5c-10.76,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C190.85,229,179.63,216.91,161.14,216.91Zm67.46-19.4-10,3v18.19H202.68v9.71H218.6v45.93c0,18.19,11.37,23.19,31.83,20.16v-8.79c-14.7.61-21.83,1.67-21.83-11.37V228.44h21.83v-9.71H228.6Zm106.58,59.43c0,1.51-.16,3.18-.31,4.7H268.32c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.41-12.89l8.79,5.16c-6.37,10.31-18,17.43-33.35,17.43-23.95,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C320.77,216.91,335.18,236.17,335.18,256.94Zm-10.31-5c-2.13-16.67-14.25-25.31-27.29-25.31-15.92,0-27.29,10.46-29.26,25.31Zm36.23-20.61V218.73h-10v75.8h10V252.39c0-18.8,11.83-25.17,23.95-25.17v-9.7C375.35,217.52,366.41,220.7,361.1,231.32Zm73.07,49.11-33.05-92H389.6l39.11,106.12h10.92l39.11-106.12H467.22Zm105.51-61.7v39.72c0,20.32-11.22,28.2-24.56,28.2-13.18,0-20.61-7.88-20.61-21.38V218.73h-10v46.54c0,19,11.22,31.08,29.71,31.08,10.77,0,19.56-4.09,25.47-13.64v11.82h10v-75.8Z"
  }));
};

var LiveVideoLogo = function LiveVideoLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    viewBox: "0 0 741 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.48H69.77V79.63H1Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.38,37.38,0,0,0-9,12.53,40.14,40.14,0,0,0-3.32,16.6,40.73,40.73,0,0,0,3.32,16.69,37.76,37.76,0,0,0,9,12.67,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.13,37.13,0,0,0,9.06-12.67,40.73,40.73,0,0,0,3.32-16.69,40.11,40.11,0,0,0-3.32-16.6A37,37,0,0,0,244.31,72.77ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,17.2,17.2,0,0,1-26.56,0,19.13,19.13,0,0,1-3.4-6.26,22.78,22.78,0,0,1,0-14.17,18.3,18.3,0,0,1,3.32-6.12,16.9,16.9,0,0,1,5.51-4.3,18.69,18.69,0,0,1,15.4,0,17.66,17.66,0,0,1,5.59,4.3,18.8,18.8,0,0,1,3.47,6.12,21.2,21.2,0,0,1,1.21,7.08A22.53,22.53,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v23.94H118.75l-.09,36.57H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.83-21.94,3-30.06,11.61-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.33A21.13,21.13,0,0,1,535,90.28c0,7.31,0,17.54,0,23.92C529,121.13,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.44,2.89,21.36,3.06,22.63-8.92,3.09-19.62,4.69-28.92,2.79-12.85-2.62-21.52-11.64-23.78-24.56a48.93,48.93,0,0,1-.81-8.44c0-7.29,0-21.11,0-21.11l-14.77,0V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.06s-.09,13.58.06,20.65c.16,7.23,4.08,10.93,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.35c6.71-5.77,14.82-9.37,26.06-9.37v24C304.8,87.71,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.31c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.44h23c2.13,4.57,7.39,6.82,14.11,6.82s10.92-1.88,10.92-5.16c0-2.66-3-4.54-8-5.32l-15.29-2.66c-12.95-2.18-22.16-9.54-22.16-22.84,0-16,13.57-25.34,33.7-25.34,17.51,0,33.38,6.08,35.15,25l-22.45,0c-1.2-4.64-6.3-7-12.7-7-6.56,0-9.52,2.33-9.52,5.15,0,2.66,1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.44,395.87,116.9Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M177.36,195.39a7.28,7.28,0,1,1-7.28-7.28A7.28,7.28,0,0,1,177.36,195.39Zm275.91-7.28a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,453.27,188.11Zm-350.34.31H92.31V294.53h59.13v-10H102.93Zm62.15,30.31h10v75.8h-10Zm85.8,0H261.5l-31.08,75.8H218.29l-31.08-75.8h10.62l26.53,65.34Zm54.73-1.81c-23.49,0-39.56,17.43-39.56,39.71,0,22.89,16.37,39.72,40.32,39.72,15.31,0,27-7.12,33.35-17.43l-8.79-5.16c-4.09,7.28-12.43,12.89-24.41,12.89-16.07,0-28-9.55-30.16-25h66.55c.15-1.52.3-3.19.3-4.7C343.21,236.17,328.81,216.92,305.61,216.92Zm-29.25,35c2-14.85,13.34-25.31,29.25-25.31,13,0,25.17,8.64,27.29,25.31Zm151.29-63.51h11.52L400.06,294.53H389.14L350,188.42h11.52l33.05,92Zm20.62,30.31h10v75.8h-10Zm96.41,14.86c-6.36-10.16-17.13-16.67-30.62-16.67a39.72,39.72,0,0,0,0,79.43c13.49,0,24.26-6.52,30.62-16.67v14.85h10V188.42h-10Zm-29.86,53.06a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,514.82,286.65Zm96.11-69.73c-23.5,0-39.56,17.43-39.56,39.71,0,22.89,16.37,39.72,40.32,39.72,15.31,0,27-7.12,33.35-17.43l-8.79-5.16c-4.09,7.28-12.43,12.89-24.41,12.89-16.07,0-28-9.55-30.17-25h66.55a46.54,46.54,0,0,0,.31-4.7C648.53,236.17,634.13,216.92,610.93,216.92Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.17,8.64,27.29,25.31Zm118.1-35a39.72,39.72,0,1,0,39.87,39.71A39.41,39.41,0,0,0,699.77,216.92Zm0,69.73a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,699.77,286.65Z"
  }));
};

var PanelManagementLogo = function PanelManagementLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    viewBox: "0 0 1441 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M244.31,72.78A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.86,37.24,37.24,0,0,0-9,12.52,40.17,40.17,0,0,0-3.32,16.6,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.53,46.53,0,0,0,32.23,0,41.53,41.53,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40.11,40.11,0,0,0-3.32-16.6A36.9,36.9,0,0,0,244.31,72.78ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,16.69,16.69,0,0,1-5.58,4.45,18.69,18.69,0,0,1-15.4,0,16.67,16.67,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.44,18.44,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.8,17.8,0,0,1,5.59,4.3,19,19,0,0,1,3.47,6.11,21.3,21.3,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v23.94H118.75l-.09,36.57H92.33ZM535,63.13v5.09a35.77,35.77,0,0,0-17.45-5.77c-11.84-.84-21.94,3-30.06,11.6-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59ZM469.09,116c.31,2.43,2.89,21.34,3.06,22.61-8.92,3.1-19.62,4.7-28.92,2.8-12.85-2.62-21.52-11.64-23.78-24.57a48.63,48.63,0,0,1-.81-8.43c0-7.29,0-21.11,0-21.11l-14.77,0V63.24h14.75V38.7h25.28V63.24h25.71v24l-25.68.05s-.09,13.59.06,20.66c.16,7.23,4.08,10.93,11.34,11A35.27,35.27,0,0,0,469.09,116Zm-178-43.37c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.72,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.66-3-4.54-8-5.32l-15.29-2.65c-12.95-2.2-22.16-9.54-22.16-22.85,0-15.94,13.57-25.34,33.7-25.34,17.51,0,33.38,6.07,35.15,25l-22.45,0c-1.2-4.64-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.16,0,2.66,1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.45,395.87,116.9Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M130.21,188.41H92.32V294.53h10.61V255.12h27.28c19.11,0,33.36-14.4,33.36-33.35C163.57,202.66,149.32,188.41,130.21,188.41Zm0,56.7H102.93V198.42h27.28c13.19,0,22.74,9.7,22.74,23.35C153,235.26,143.4,245.11,130.21,245.11Zm109.16-11.52c-6.37-10.16-17.14-16.68-30.63-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.26-6.52,30.63-16.67v14.85h10v-75.8h-10ZM209.5,286.65a30,30,0,1,1,29.87-30A29.57,29.57,0,0,1,209.5,286.65ZM335.78,248v46.54h-10V248c0-13.49-7.43-21.37-20.62-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.7-13.65,25.47-13.65C324.56,216.91,335.78,229,335.78,248Zm54.43-31.08c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.32,39.72,15.32,0,27-7.12,33.36-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28.05-9.55-30.17-25H427.5c.15-1.52.3-3.19.3-4.7C427.8,236.17,413.4,216.91,390.21,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.28,25.31Zm82.77-68.06h10V294.53h-10Zm154.48,4.54h13.19V294.53H600.78v-90l-37.14,62.16h-1.52L525,204.48v90H514.37V188.41h13.19l35.32,59.13Zm101.12,45.18c-6.37-10.16-17.13-16.68-30.63-16.68a39.72,39.72,0,0,0,0,79.44c13.5,0,24.26-6.52,30.63-16.67v14.85h10v-75.8h-10Zm-29.87,53.06a30,30,0,1,1,29.87-30A29.57,29.57,0,0,1,669.45,286.65ZM795.73,248v46.54h-10V248c0-13.49-7.43-21.37-20.62-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.71-13.65,25.47-13.65C784.51,216.91,795.73,229,795.73,248Zm84.59-14.4c-6.36-10.16-17.13-16.68-30.62-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.26-6.52,30.62-16.67v14.85h10v-75.8h-10Zm-29.86,53.06a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,850.46,286.65Zm126.28-53.06c-6.37-10.16-17.13-16.68-30.62-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.25-6.52,30.62-16.67V291.5c0,15.46-10.46,25.47-28,25.47-16.37,0-23.34-6.07-27.13-13.8l-8.79,5c5.91,11.82,18.49,18.49,35.92,18.49,19.56,0,38-12.13,38-35.17V218.73h-10Zm-29.87,53.06a30,30,0,1,1,29.87-30A29.58,29.58,0,0,1,946.87,286.65ZM1043,216.91c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.33,39.72,15.31,0,27-7.12,33.35-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28.05-9.55-30.17-25h66.55c.15-1.52.3-3.19.3-4.7C1080.58,236.17,1066.18,216.91,1043,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.29,25.31Zm191.92-4.7v47.3h-10v-47.3c0-13.49-7.73-20.61-18.5-20.61-11.67,0-21.07,7.12-21.07,25.92v42h-10v-47.3c0-13.49-7-20.61-17.73-20.61-10.92,0-21.83,7.12-21.83,25.92v42h-10v-75.8h10V229.8c5.91-9.25,14.1-12.89,23.19-12.89,10.61,0,18.8,5,23,13.8a27.83,27.83,0,0,1,24.56-13.8C1194,216.91,1205.65,228.28,1205.65,247.23Zm54.43-30.32c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.33,39.72,15.31,0,27-7.12,33.35-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28-9.55-30.17-25h66.55c.15-1.52.3-3.19.3-4.7C1297.67,236.17,1283.27,216.91,1260.08,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.28,25.31Zm148-3.94v46.54h-10V248c0-13.49-7.42-21.37-20.61-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.7-13.65,25.47-13.65C1367.56,216.91,1378.78,229,1378.78,248Zm37.75-19.55v45.93c0,13,7.12,12,21.83,11.37v8.79c-20.47,3-31.84-2-31.84-20.16V228.44h-15.91v-9.71h15.91V200.54l10-3v21.22h21.83v9.71Z"
  }));
};

var SurveysLogo = function SurveysLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    viewBox: "0 0 597 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M244.31,72.78A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.86,37.24,37.24,0,0,0-9,12.52,40.17,40.17,0,0,0-3.32,16.6,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.53,46.53,0,0,0,32.23,0,41.53,41.53,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40.11,40.11,0,0,0-3.32-16.6A36.9,36.9,0,0,0,244.31,72.78ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,16.69,16.69,0,0,1-5.58,4.45,18.69,18.69,0,0,1-15.4,0,16.67,16.67,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.44,18.44,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.8,17.8,0,0,1,5.59,4.3,19,19,0,0,1,3.47,6.11,21.3,21.3,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v23.94H118.75l-.09,36.57H92.33ZM535,63.13v5.09a35.77,35.77,0,0,0-17.45-5.77c-11.84-.84-21.94,3-30.06,11.6-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59ZM469.09,116c.31,2.43,2.89,21.34,3.06,22.61-8.92,3.1-19.62,4.7-28.92,2.8-12.85-2.62-21.52-11.64-23.78-24.57a48.63,48.63,0,0,1-.81-8.43c0-7.29,0-21.11,0-21.11l-14.77,0V63.24h14.75V38.7h25.28V63.24h25.71v24l-25.68.05s-.09,13.59.06,20.66c.16,7.23,4.08,10.93,11.34,11A35.27,35.27,0,0,0,469.09,116Zm-178-43.37c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.72,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.66-3-4.54-8-5.32l-15.29-2.65c-12.95-2.2-22.16-9.54-22.16-22.85,0-15.94,13.57-25.34,33.7-25.34,17.51,0,33.38,6.07,35.15,25l-22.45,0c-1.2-4.64-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.16,0,2.66,1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.45,395.87,116.9Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M161.44,266.64c0,18.19-14.55,29.71-35.77,29.71-19.56,0-34-9.85-39.42-25.92l9.1-5.31C99.14,277.86,109.14,286,125.82,286c16.07,0,25-7.73,25-19.1,0-12.28-10.46-16.22-26.07-21.37-17.29-5.76-34-10.31-34-29.87,0-18.64,15-29.1,32.59-29.1a37.25,37.25,0,0,1,35,22.89l-8.94,5c-3.95-9.55-12.13-17.59-26.08-17.59-12.73,0-22,6.67-22,18.35,0,11.52,9.1,15.16,23.5,19.86C144.16,241.47,161.44,246.93,161.44,266.64Zm70-8.19c0,20.32-11.22,28.2-24.56,28.2-13.19,0-20.62-7.88-20.62-21.37V218.74h-10v46.54c0,18.94,11.22,31.07,29.71,31.07,10.77,0,19.56-4.09,25.47-13.64v11.82h10V218.74h-10Zm41.24-27.13V218.74h-10v75.79h10V252.39c0-18.8,11.82-25.17,23.95-25.17v-9.7C287,217.52,278,220.71,272.72,231.32Zm65.64,52.75-26.53-65.33H301.22l31.07,75.79h12.13l31.08-75.79H364.89Zm118.85-27.13c0,1.51-.15,3.18-.3,4.7H390.36c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.4-12.89l8.8,5.16c-6.37,10.31-18,17.43-33.35,17.43-24,0-40.33-16.82-40.33-39.72,0-22.28,16.07-39.71,39.57-39.71C442.81,216.92,457.21,236.17,457.21,256.94Zm-10.31-5c-2.12-16.67-14.25-25.31-27.28-25.31-15.92,0-27.29,10.46-29.26,25.31Zm53.22,30.32-28.5-63.51H461L495,295l-2,4.7c-4.09,9.85-10.91,16.82-20.77,15.76v9.4c13.65,1.06,24.87-8.79,30.63-23.34l32.44-82.77H524.68Zm50.63-43.66c0-8.18,8-12,15.92-12,7.28,0,15,2.88,18.19,10.61l8.34-4.85c-4.4-9.4-14.1-15.46-26.53-15.46-15.16,0-25.92,9.55-25.92,21.67,0,27.9,44.26,17.13,44.26,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.73l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.44-8.94,27.44-21.83C595,246.63,550.75,257.39,550.75,238.59Z"
  }));
};

var VideoInsightsLogo = function VideoInsightsLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    viewBox: "0 0 994 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.22,37.22,0,0,0-9,12.54,40.06,40.06,0,0,0-3.32,16.59,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40,40,0,0,0-3.32-16.59A36.88,36.88,0,0,0,244.31,72.77ZM231.7,109a19.42,19.42,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v24H118.75l-.09,36.56H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.62-11.77,12.45-14.3,31.75-6.28,47.34,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.44,2.89,21.35,3.06,22.62-8.92,3.1-19.62,4.7-28.92,2.81-12.85-2.63-21.52-11.65-23.78-24.58a48.71,48.71,0,0,1-.81-8.42c0-7.29,0-21.12,0-21.12l-14.77.06V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.05s-.09,13.59.06,20.66c.16,7.23,4.08,10.93,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.36c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.71,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.65-3-4.54-8-5.32l-15.29-2.66c-12.95-2.19-22.16-9.54-22.16-22.84,0-16,13.57-25.33,33.7-25.33,17.51,0,33.38,6.06,35.15,25l-22.45,0c-1.2-4.63-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.16,0,2.67,1.88,5,8,6.11l14,2.34C386.34,96.56,395.86,103.44,395.87,116.9Z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M192.22,195.39a7.28,7.28,0,1,1-7.28-7.28A7.28,7.28,0,0,1,192.22,195.39Zm488.3-7.28a7.28,7.28,0,1,0,7.27,7.28A7.28,7.28,0,0,0,680.52,188.11Zm-521.2.3h11.52L131.73,294.53H120.81L81.7,188.41H93.22l33.05,92Zm20.62,106.12h10v-75.8h-10Zm96.41-106.12h10V294.53h-10V279.67c-6.36,10.16-17.13,16.68-30.62,16.68a39.72,39.72,0,0,1,0-79.44c13.49,0,24.26,6.52,30.62,16.68Zm0,68.22a29.86,29.86,0,1,0-29.86,30A29.57,29.57,0,0,0,276.35,256.63Zm103.85.31a46.54,46.54,0,0,1-.31,4.7H313.34c2.13,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.41-12.89l8.79,5.16c-6.37,10.31-18,17.43-33.35,17.43-23.95,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C365.8,216.91,380.2,236.17,380.2,256.94Zm-10.31-5c-2.12-16.67-14.25-25.31-27.29-25.31-15.92,0-27.29,10.46-29.26,25.31Zm101.42,4.7a39.87,39.87,0,1,1-39.87-39.72A39.41,39.41,0,0,1,471.31,256.63Zm-10,0a29.87,29.87,0,1,0-29.86,30A29.57,29.57,0,0,0,461.3,256.63Zm28.2,37.9h10.61V188.41H489.5Zm68.83-77.62c-10.77,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19C570.6,226.62,578,234.5,578,248v46.54h10V248C588,229,576.82,216.91,558.33,216.91Zm57,21.68c0-8.18,8-12,15.92-12,7.27,0,15,2.88,18.19,10.61l8.33-4.85c-4.39-9.4-14.09-15.47-26.52-15.47-15.16,0-25.93,9.56-25.93,21.68,0,27.9,44.27,17.13,44.27,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.43-8.94,27.43-21.83C659.59,246.63,615.33,257.39,615.33,238.59Zm60.18,55.94h10v-75.8h-10Zm96.42-75.8h10V291.5c0,23-18.49,35.17-38,35.17-17.43,0-30-6.67-35.93-18.5l8.8-5c3.79,7.73,10.76,13.8,27.13,13.8,17.59,0,28-10,28-25.47V279.67c-6.37,10.16-17.13,16.68-30.62,16.68a39.72,39.72,0,0,1,0-79.44c13.49,0,24.25,6.52,30.62,16.68Zm0,37.9a29.87,29.87,0,1,0-29.87,30A29.58,29.58,0,0,0,771.93,256.63Zm66.7-39.72c-10.76,0-19.55,4.1-25.47,13.65V188.41h-10V294.53h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C868.34,229,857.13,216.91,838.63,216.91Zm67.46-19.4-10,3v18.19H880.17v9.71h15.92v45.93c0,18.19,11.37,23.19,31.83,20.16v-8.79c-14.7.6-21.83,1.67-21.83-11.37V228.44h21.83v-9.71H906.09Zm41.85,41.08c0-8.18,8-12,15.91-12,7.28,0,15,2.88,18.19,10.61l8.34-4.85c-4.39-9.4-14.1-15.47-26.53-15.47-15.16,0-25.92,9.56-25.92,21.68,0,27.9,44.27,17.13,44.27,35.93,0,9-8.49,12.13-17.44,12.13-10.15,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.44-8.94,27.44-21.83C992.2,246.63,947.94,257.39,947.94,238.59Z"
  }));
};

var VIStreamlineLogo = function VIStreamlineLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    },
    viewBox: "0 0 1552.53 173"
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M1 33.45v24.17h68.78V33.45zM1 103h45.53v36.47h23.24v-60.4H1z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M244.31 72.22A40 40 0 00231 64.37a49.1 49.1 0 00-32.23 0 39 39 0 00-13.28 7.85 37.28 37.28 0 00-9 12.53 40.14 40.14 0 00-3.32 16.6 40.69 40.69 0 003.37 16.65 37.9 37.9 0 009 12.68 40.2 40.2 0 0013.28 8.08 46.68 46.68 0 0032.23 0 41.71 41.71 0 0013.28-8.08 37.27 37.27 0 009.04-12.68 40.69 40.69 0 003.32-16.68 40.11 40.11 0 00-3.32-16.6 36.94 36.94 0 00-9.06-12.5zm-12.61 36.22a19.52 19.52 0 01-3.4 6.26 16.69 16.69 0 01-5.58 4.45 18.69 18.69 0 01-15.4 0 16.67 16.67 0 01-5.58-4.45 19.23 19.23 0 01-3.4-6.26 22.81 22.81 0 010-14.18 18.34 18.34 0 013.32-6.11 18 18 0 0120.91-4.3 17.66 17.66 0 015.59 4.3 18.86 18.86 0 013.47 6.11 21.26 21.26 0 011.21 7.09 22.58 22.58 0 01-1.14 7.09zM92.33 139.59h26.33l.09-36.57h45.38V79.08h-45.38V57.61h52.79V33.45H92.33zM535 62.58v5.08a36 36 0 00-17.45-5.77c-11.84-.83-21.94 3-30.06 11.61-11.77 12.46-14.3 31.75-6.28 47.35 10.91 21.24 36.28 25.7 53.76 14.8v3.94h25.25v-77zM509.2 117c-5.7-4-7.91-9.7-7.69-16.42.31-9.26 6.59-16.24 15.78-17.34A21.17 21.17 0 01535 89.73v23.92c-6 6.93-18.24 8.64-25.8 3.35zm-53.86 1.41c-7.26-.12-11.18-3.82-11.34-11-.15-7.07-.06-20.66-.06-20.66h25.68v-24h-25.71V38.14h-25.28v24.54h-14.75v24.07h14.77v21.11a48.73 48.73 0 00.81 8.43c2.26 12.93 10.93 22 23.78 24.57 9.3 1.9 20 .3 28.92-2.8-.17-1.27-2.75-20.18-3.06-22.62a35 35 0 01-13.76 3.01zm-164.27-55.8h-25.43v77h25.43v-43.4c5.93-5.78 13.73-9 26.06-9.52v-24c-11.24 0-19.35 3.59-26.06 9.36zm81.23 30.74l-14-2.35c-6.08-1.1-8-3.44-8-6.1 0-2.82 3-5.16 9.52-5.16 6.4 0 11.5 2.32 12.7 7h22.45c-1.77-18.9-17.64-25-35.15-25-20.13 0-33.7 9.39-33.7 25.34 0 13.3 9.21 20.65 22.16 22.84l15.29 2.66c5 .78 8 2.66 8 5.32 0 3.28-4.21 5.16-10.92 5.16s-12-2.25-14.11-6.83h-23c3 18 18.39 25.45 36.91 25.45 19.82 0 35.42-7.82 35.42-25.34-.01-13.45-9.53-20.34-23.57-22.99zM642.56 125.41l-33-92H598l39.1 106.1H648l39.13-106.12h-11.52zm58.67-92.32a7.28 7.28 0 107.28 7.28 7.29 7.29 0 00-7.28-7.28zm-5 106.42h10v-75.8h-10zm96.41-60.94c-6.37-10.16-17.13-16.68-30.64-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v14.86h10V33.39h-10zm-29.86 53.06a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96.11-69.74c-23.5 0-39.57 17.44-39.57 39.72 0 22.89 16.38 39.72 40.33 39.72 15.31 0 27-7.13 33.35-17.43l-8.79-5.16c-4.1 7.28-12.43 12.89-24.41 12.89-16.07 0-28-9.55-30.17-25h66.55c.15-1.51.31-3.18.31-4.7 0-20.78-14.41-40.04-37.6-40.04zm-29.26 35c2-14.85 13.34-25.31 29.26-25.31 13 0 25.16 8.64 27.29 25.31zm118.1-35a39.72 39.72 0 1039.87 39.72 39.41 39.41 0 00-39.87-39.72zm0 69.74a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96 7.88h10.61V33.39h-10.61zm68.82-77.62c-10.76 0-19.55 4.1-25.46 13.65V63.71h-10v75.8h10V99.79c0-20.31 11.21-28.19 24.55-28.19s20.62 7.88 20.62 21.37v46.54h10V93c-.03-19-11.26-31.11-29.75-31.11zm57 21.68c0-8.18 8-12 15.91-12 7.28 0 15 2.88 18.2 10.61l8.33-4.85c-4.39-9.4-14.1-15.47-26.53-15.47-15.16 0-25.92 9.55-25.92 21.68 0 27.9 44.27 17.13 44.27 35.93 0 8.94-8.49 12.13-17.44 12.13-10.15 0-18-5-20.77-12.74l-8.48 5c3.79 9.7 14.09 17.43 29.25 17.43 16.22 0 27.44-8.94 27.44-21.83-.03-27.85-44.29-17.09-44.29-35.89zm65.19-50.48a7.28 7.28 0 107.27 7.28 7.28 7.28 0 00-7.3-7.28zm-5 106.42h10v-75.8h-10zm96.42-60.94c-6.37-10.16-17.13-16.68-30.62-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v11.83c0 15.46-10.46 25.47-28 25.47-16.37 0-23.34-6.07-27.13-13.8l-8.8 5c5.92 11.83 18.5 18.5 35.93 18.5 19.56 0 38-12.13 38-35.17V63.71h-10zm-29.87 53.06a30 30 0 1129.87-30 29.58 29.58 0 01-29.91 30zm96.57-69.74c-10.76 0-19.56 4.1-25.47 13.65V33.39h-10v106.12h10V99.79c0-20.31 11.22-28.19 24.56-28.19 13.19 0 20.62 7.88 20.62 21.37v46.54h10V93c-.04-19-11.26-31.11-29.75-31.11zm67.46-19.4l-10 3v18.22h-15.92v9.7h15.92v45.94c0 18.19 11.37 23.19 31.83 20.16v-8.79c-14.7.6-21.83 1.67-21.83-11.37V73.41h21.83v-9.7h-21.83zm41.84 41.08c0-8.18 8-12 15.92-12 7.28 0 15 2.88 18.19 10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47-15.16 0-25.92 9.55-25.92 21.68 0 27.9 44.26 17.13 44.26 35.93 0 8.94-8.49 12.13-17.43 12.13-10.16 0-18-5-20.77-12.74l-8.49 5c3.79 9.7 14.1 17.43 29.26 17.43 16.22 0 27.44-8.94 27.44-21.83-.04-27.85-44.31-17.09-44.31-35.89z"
  }));
};

var VideoInsightsLegacyLogo = function VideoInsightsLegacyLogo(_ref) {
  var dark = _ref.dark,
      rest = _objectWithoutProperties(_ref, ["dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends({
    ieWidths: {
      sm: 531,
      lg: 707,
      "default": 637
    },
    viewBox: "0 0 1162 173"
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M1 33.45v24.17h68.78V33.45zM1 103h45.53v36.47h23.24v-60.4H1z"
  }), /*#__PURE__*/React__default['default'].createElement(TextPath, {
    dark: dark,
    d: "M92.33 139.59h26.33l.09-36.57h45.38V79.08h-45.38l-.03-21.47h52.79V33.45H92.33v106.14zM253.85 125.41l-33-92h-11.57l39.11 106.12h10.92l39.11-106.14H286.9zm58.67-92.32a7.28 7.28 0 107.28 7.28 7.28 7.28 0 00-7.28-7.28zm-5 106.42h10v-75.8h-10zm96.41-60.94c-6.36-10.16-17.13-16.68-30.62-16.68a39.72 39.72 0 000 79.44c13.49 0 24.26-6.52 30.62-16.68v14.86h10V33.39h-10zm-29.86 53.06a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96.11-69.74c-23.5 0-39.57 17.44-39.57 39.72 0 22.89 16.38 39.72 40.33 39.72 15.31 0 27-7.13 33.35-17.44l-8.79-5.15c-4.1 7.28-12.43 12.89-24.41 12.89-16.07 0-28-9.55-30.17-25h66.55c.15-1.51.31-3.18.31-4.7 0-20.79-14.41-40.04-37.6-40.04zm-29.26 35c2-14.86 13.34-25.32 29.26-25.32 13 0 25.16 8.64 27.29 25.32zm118.1-35a39.72 39.72 0 1039.87 39.72A39.41 39.41 0 00559 61.89zm0 69.74a30 30 0 1129.86-30 29.58 29.58 0 01-29.88 30zm96 7.88h10.61V33.39H655zm68.78-77.62c-10.76 0-19.55 4.09-25.46 13.65V63.71h-10v75.8h10V99.79c0-20.31 11.21-28.2 24.55-28.2s20.62 7.89 20.62 21.41v46.54h10V93c.01-19-11.21-31.11-29.71-31.11zm57 21.68c0-8.19 8-12 15.91-12 7.28 0 15 2.88 18.2 10.62l8.33-4.86c-4.39-9.39-14.1-15.46-26.53-15.46-15.16 0-25.92 9.55-25.92 21.68 0 27.89 44.27 17.13 44.27 35.93 0 8.94-8.49 12.13-17.44 12.13-10.15 0-18-5-20.77-12.74l-8.48 5c3.79 9.71 14.09 17.44 29.25 17.44 16.22 0 27.44-9 27.44-21.83.01-27.88-44.25-17.11-44.25-35.91zM846 33.09a7.28 7.28 0 107.27 7.28 7.27 7.27 0 00-7.27-7.28zm-5 106.42h10v-75.8h-10zm96.42-60.94c-6.42-10.16-17.14-16.68-30.63-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v11.83c0 15.46-10.46 25.47-28 25.47-16.37 0-23.34-6.07-27.13-13.8l-8.8 5c5.92 11.83 18.5 18.5 35.93 18.5 19.56 0 38-12.13 38-35.17V63.71h-10zm-29.87 53.06a30 30 0 1129.87-30 29.58 29.58 0 01-29.88 30zm96.57-69.74c-10.76 0-19.56 4.09-25.47 13.65V33.39h-10v106.12h10V99.79c0-20.31 11.22-28.2 24.56-28.2 13.19 0 20.62 7.89 20.62 21.38v46.54h10V93c-.01-19-11.23-31.11-29.72-31.11zm67.46-19.4l-10 3v18.22h-15.92v9.7h15.92v45.94c0 18.19 11.37 23.19 31.83 20.16v-8.79c-14.7.6-21.83 1.66-21.83-11.37V73.41h21.83v-9.7h-21.83zm41.84 41.08c0-8.19 8-12 15.92-12 7.28 0 15 2.88 18.19 10.62l8.34-4.86c-4.4-9.39-14.1-15.46-26.53-15.46-15.16 0-25.92 9.55-25.92 21.68 0 27.89 44.27 17.13 44.27 35.93 0 8.94-8.5 12.13-17.44 12.13-10.16 0-18-5-20.77-12.74l-8.49 5c3.79 9.71 14.1 17.44 29.26 17.44 16.22 0 27.44-9 27.44-21.83-.01-27.88-44.28-17.11-44.28-35.91z"
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var SmallSvg = /*#__PURE__*/createStyled(Svg, {
  target: "e1trzfe50",
  label: "SmallSvg"
})( true ? {
  name: "fs1x93",
  styles: "width:24px;height:20px;"
} : {
  name: "fs1x93",
  styles: "width:24px;height:20px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZWTG9nb1NtYWxsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUs0QiIsImZpbGUiOiJGVkxvZ29TbWFsbC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBTdmcgZnJvbSAnLi9TdmcnXG5pbXBvcnQgTG9nb1BhdGggZnJvbSAnLi9Mb2dvUGF0aCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5jb25zdCBTbWFsbFN2ZyA9IHN0eWxlZChTdmcpYFxuICB3aWR0aDogMjRweDtcbiAgaGVpZ2h0OiAyMHB4O1xuYFxuXG5jb25zdCBGVkxvZ29TbWFsbCA9ICh7IC4uLnJlc3QgfSkgPT4gKFxuICA8U21hbGxTdmdcbiAgICB2aWV3Qm94PVwiMCAwIDI0IDIwXCJcbiAgICBpZVdpZHRocz17eyBzbTogMjQsIGxnOiAyNCwgZGVmYXVsdDogMjQgfX1cbiAgICB7Li4ucmVzdH1cbiAgPlxuICAgIDxMb2dvUGF0aFxuICAgICAgZD1cIk0xMy45OTI5IDEzLjM2MzZMMTguNzQ3MyAwSDIzLjM1MjRMMTYuMjk1NSAxOS44MzFMMTMuOTkyOSAxMy4zNjM2Wk0zLjc5NDk0IDEwLjY3NDlIMTMuMDMzNkwxMS41OTggNi42NDE4MkgyLjM1OTRMMy43OTQ5NCAxMC42NzQ5Wk0xMC42NzQyIDQuMDMzMDVMOS4yMzg2MiAwLjAwNzI2Njc5SDBMMS40MzU1NCA0LjAzMzA1SDEwLjY3NDJaXCJcbiAgICAgIGZpbGw9XCIjMDBDQzUyXCJcbiAgICAvPlxuICA8L1NtYWxsU3ZnPlxuKVxuXG5leHBvcnQgZGVmYXVsdCBGVkxvZ29TbWFsbFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});

var FVLogoSmall = function FVLogoSmall(_ref) {
  var rest = _extends({}, _ref);

  return /*#__PURE__*/React__default['default'].createElement(SmallSvg, _extends({
    viewBox: "0 0 24 20",
    ieWidths: {
      sm: 24,
      lg: 24,
      "default": 24
    }
  }, rest), /*#__PURE__*/React__default['default'].createElement(LogoPath, {
    d: "M13.9929 13.3636L18.7473 0H23.3524L16.2955 19.831L13.9929 13.3636ZM3.79494 10.6749H13.0336L11.598 6.64182H2.3594L3.79494 10.6749ZM10.6742 4.03305L9.23862 0.00726679H0L1.43554 4.03305H10.6742Z",
    fill: "#00CC52"
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Container$6 = createStyled("div", {
  target: "e1lhyj600",
  label: "Container"
})( true ? {
  name: "79vkaf",
  styles: "display:flex;align-items:center;flex:1;min-width:0;"
} : {
  name: "79vkaf",
  styles: "display:flex;align-items:center;flex:1;min-width:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvZ28uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSzRCIiwiZmlsZSI6IkxvZ28uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgRlZMb2dvU21hbGwgZnJvbSAnLi4vbG9nb3MvRlZMb2dvU21hbGwnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGZvbnRXZWlnaHQgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGZsZXg6IDE7XG4gIG1pbi13aWR0aDogMDtcbmBcblxuY29uc3QgQXBwTmFtZSA9IHN0eWxlZC5kaXZgXG4gIGZsZXg6IDE7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICBtYXJnaW4tbGVmdDogMC4yNWVtO1xuICBmb250LXNpemU6IDAuODc1ZW07XG4gIGxpbmUtaGVpZ2h0OiAxLjI1O1xuICAke2ZvbnRXZWlnaHQoJ2JvbGQnKX07XG5gXG5cbmNvbnN0IExvZ28gPSAoeyBhcHBOYW1lLCByZW5kZXJMb2dvID0gKCkgPT4gPEZWTG9nb1NtYWxsIC8+LCAuLi5yZXN0IH0pID0+IChcbiAgPENvbnRhaW5lciB7Li4ucmVzdH0+XG4gICAge3JlbmRlckxvZ28oKX1cbiAgICB7YXBwTmFtZSAmJiA8QXBwTmFtZT57YXBwTmFtZX08L0FwcE5hbWU+fVxuICA8L0NvbnRhaW5lcj5cbilcblxuZXhwb3J0IGRlZmF1bHQgTG9nb1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});

var AppName = createStyled("div", {
  target: "e1lhyj601",
  label: "AppName"
})("flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-left:0.25em;font-size:0.875em;line-height:1.25;", fontWeight('bold'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvZ28uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWTBCIiwiZmlsZSI6IkxvZ28uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgRlZMb2dvU21hbGwgZnJvbSAnLi4vbG9nb3MvRlZMb2dvU21hbGwnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGZvbnRXZWlnaHQgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGZsZXg6IDE7XG4gIG1pbi13aWR0aDogMDtcbmBcblxuY29uc3QgQXBwTmFtZSA9IHN0eWxlZC5kaXZgXG4gIGZsZXg6IDE7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICBtYXJnaW4tbGVmdDogMC4yNWVtO1xuICBmb250LXNpemU6IDAuODc1ZW07XG4gIGxpbmUtaGVpZ2h0OiAxLjI1O1xuICAke2ZvbnRXZWlnaHQoJ2JvbGQnKX07XG5gXG5cbmNvbnN0IExvZ28gPSAoeyBhcHBOYW1lLCByZW5kZXJMb2dvID0gKCkgPT4gPEZWTG9nb1NtYWxsIC8+LCAuLi5yZXN0IH0pID0+IChcbiAgPENvbnRhaW5lciB7Li4ucmVzdH0+XG4gICAge3JlbmRlckxvZ28oKX1cbiAgICB7YXBwTmFtZSAmJiA8QXBwTmFtZT57YXBwTmFtZX08L0FwcE5hbWU+fVxuICA8L0NvbnRhaW5lcj5cbilcblxuZXhwb3J0IGRlZmF1bHQgTG9nb1xuIl19 */"));

var Logo = function Logo(_ref) {
  var appName = _ref.appName,
      _ref$renderLogo = _ref.renderLogo,
      renderLogo = _ref$renderLogo === void 0 ? function () {
    return /*#__PURE__*/React__default['default'].createElement(FVLogoSmall, null);
  } : _ref$renderLogo,
      rest = _objectWithoutProperties(_ref, ["appName", "renderLogo"]);

  return /*#__PURE__*/React__default['default'].createElement(Container$6, rest, renderLogo(), appName && /*#__PURE__*/React__default['default'].createElement(AppName, null, appName));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$9 =  true ? {
  name: "x8h6hl",
  styles: "margin-left:0.5em;"
} : {
  name: "x8h6hl",
  styles: "margin-left:0.5em;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk5hdkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS1MiLCJmaWxlIjoiTmF2SXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcblxuY29uc3QgZXh0cmFNYXJnaW5MZWZ0Q3NzID0gKHsgZXh0cmFNYXJnaW5MZWZ0IH0pID0+XG4gIGV4dHJhTWFyZ2luTGVmdFxuICAgID8gY3NzYFxuICAgICAgICBtYXJnaW4tbGVmdDogMC41ZW07XG4gICAgICBgXG4gICAgOiAnJ1xuXG5jb25zdCBOYXZJdGVtID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIG1hcmdpbi1sZWZ0OiAwLjI1ZW07XG5cbiAgJHtleHRyYU1hcmdpbkxlZnRDc3N9O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBOYXZJdGVtXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$k
};

var extraMarginLeftCss = function extraMarginLeftCss(_ref2) {
  var extraMarginLeft = _ref2.extraMarginLeft;
  return extraMarginLeft ? _ref$9 : '';
};

var NavItem = createStyled("div", {
  target: "edpciu70",
  label: "NavItem"
})("display:flex;align-items:center;justify-content:center;margin-left:0.25em;", extraMarginLeftCss, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk5hdkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBVTBCIiwiZmlsZSI6Ik5hdkl0ZW0uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5cbmNvbnN0IGV4dHJhTWFyZ2luTGVmdENzcyA9ICh7IGV4dHJhTWFyZ2luTGVmdCB9KSA9PlxuICBleHRyYU1hcmdpbkxlZnRcbiAgICA/IGNzc2BcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDAuNWVtO1xuICAgICAgYFxuICAgIDogJydcblxuY29uc3QgTmF2SXRlbSA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBtYXJnaW4tbGVmdDogMC4yNWVtO1xuXG4gICR7ZXh0cmFNYXJnaW5MZWZ0Q3NzfTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgTmF2SXRlbVxuIl19 */"));

var lightBlue = '#d4e7fa';

var activeCss = function activeCss(_ref) {
  var active = _ref.active;
  return active ? /*#__PURE__*/core.css("background-color:", lightBlue, ";svg{fill:", color('ink'), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk5hdkl0ZW1CdXR0b24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT1MiLCJmaWxlIjoiTmF2SXRlbUJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY29sb3IsIHRyYW5zcGFyZW50aXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IGxpZ2h0Qmx1ZSB9IGZyb20gJy4vY29sb3JzJ1xuXG5jb25zdCBhY3RpdmVDc3MgPSAoeyBhY3RpdmUgfSkgPT5cbiAgYWN0aXZlXG4gICAgPyBjc3NgXG4gICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7bGlnaHRCbHVlfTtcbiAgICAgICAgc3ZnIHtcbiAgICAgICAgICBmaWxsOiAke2NvbG9yKCdpbmsnKX07XG4gICAgICAgIH1cbiAgICAgIGBcbiAgICA6ICcnXG5cbmNvbnN0IE5hdkl0ZW1CdXR0b24gPSBzdHlsZWQuYnV0dG9uYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgdXNlci1zZWxlY3Q6IG5vbmU7XG4gIGNvbG9yOiBjdXJyZW50Q29sb3I7XG4gIGZvbnQtZmFtaWx5OiBpbmhlcml0O1xuICBib3JkZXI6IDFweCBzb2xpZCB0cmFuc3BhcmVudDtcbiAgdHJhbnNpdGlvbjogY29sb3IgMC4xcyBlYXNlLWluLW91dCwgYmFja2dyb3VuZC1jb2xvciAwLjFzIGVhc2UtaW4tb3V0LFxuICAgIGJvcmRlci1jb2xvciAwLjFzIGVhc2UtaW4tb3V0LCBib3gtc2hhZG93IDAuMXMgZWFzZS1pbi1vdXQgMHM7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgZm9udC1zaXplOiAxZW07XG4gIHdpZHRoOiAyLjVlbTtcbiAgaGVpZ2h0OiAyLjVlbTtcbiAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgYmFja2dyb3VuZDogbm9uZTtcbiAgcGFkZGluZzogMDtcblxuICAmOmVuYWJsZWQge1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuXG4gICY6aG92ZXIsXG4gICY6Zm9jdXMge1xuICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgICBvdXRsaW5lOiAwO1xuICB9XG5cbiAgJjpob3ZlcixcbiAgJjpmb2N1cyB7XG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICB9XG5cbiAgJjpkaXNhYmxlZCB7XG4gICAgY3Vyc29yOiBub3QtYWxsb3dlZDtcbiAgfVxuXG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ3NsYXRlJywgMC4wOCl9O1xuICB9XG5cbiAgJjphY3RpdmUge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7bGlnaHRCbHVlfTtcbiAgICBzdmcge1xuICAgICAgZmlsbDogJHtjb2xvcignaW5rJyl9O1xuICAgIH1cbiAgfVxuXG4gICR7YWN0aXZlQ3NzfTtcblxuICBzdmcge1xuICAgIGZpbGw6ICR7Y29sb3IoJ3Bld3RlcicpfTtcbiAgfVxuYFxuXG5leHBvcnQgZGVmYXVsdCBOYXZJdGVtQnV0dG9uXG4iXX0= */")) : '';
};

var NavItemButton = createStyled("button", {
  target: "e9zwo4s0",
  label: "NavItemButton"
})("display:flex;align-items:center;justify-content:center;user-select:none;color:currentColor;font-family:inherit;border:1px solid transparent;transition:color 0.1s ease-in-out,background-color 0.1s ease-in-out,border-color 0.1s ease-in-out,box-shadow 0.1s ease-in-out 0s;border-radius:50%;font-size:1em;width:2.5em;height:2.5em;box-sizing:border-box;background:none;padding:0;&:enabled{cursor:pointer;}&:hover,&:focus{text-decoration:none;outline:0;}&:hover,&:focus{cursor:pointer;}&:disabled{cursor:not-allowed;}&:hover{background-color:", transparentize('slate', 0.08), ";}&:active{background-color:", lightBlue, ";svg{fill:", color('ink'), ";}}", activeCss, ";svg{fill:", color('pewter'), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk5hdkl0ZW1CdXR0b24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZW1DIiwiZmlsZSI6Ik5hdkl0ZW1CdXR0b24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNvbG9yLCB0cmFuc3BhcmVudGl6ZSB9IGZyb20gJy4uLy4uL3N0eWxlcydcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBsaWdodEJsdWUgfSBmcm9tICcuL2NvbG9ycydcblxuY29uc3QgYWN0aXZlQ3NzID0gKHsgYWN0aXZlIH0pID0+XG4gIGFjdGl2ZVxuICAgID8gY3NzYFxuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2xpZ2h0Qmx1ZX07XG4gICAgICAgIHN2ZyB7XG4gICAgICAgICAgZmlsbDogJHtjb2xvcignaW5rJyl9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgOiAnJ1xuXG5jb25zdCBOYXZJdGVtQnV0dG9uID0gc3R5bGVkLmJ1dHRvbmBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIHVzZXItc2VsZWN0OiBub25lO1xuICBjb2xvcjogY3VycmVudENvbG9yO1xuICBmb250LWZhbWlseTogaW5oZXJpdDtcbiAgYm9yZGVyOiAxcHggc29saWQgdHJhbnNwYXJlbnQ7XG4gIHRyYW5zaXRpb246IGNvbG9yIDAuMXMgZWFzZS1pbi1vdXQsIGJhY2tncm91bmQtY29sb3IgMC4xcyBlYXNlLWluLW91dCxcbiAgICBib3JkZXItY29sb3IgMC4xcyBlYXNlLWluLW91dCwgYm94LXNoYWRvdyAwLjFzIGVhc2UtaW4tb3V0IDBzO1xuICBib3JkZXItcmFkaXVzOiA1MCU7XG4gIGZvbnQtc2l6ZTogMWVtO1xuICB3aWR0aDogMi41ZW07XG4gIGhlaWdodDogMi41ZW07XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIGJhY2tncm91bmQ6IG5vbmU7XG4gIHBhZGRpbmc6IDA7XG5cbiAgJjplbmFibGVkIHtcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gIH1cblxuICAmOmhvdmVyLFxuICAmOmZvY3VzIHtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gICAgb3V0bGluZTogMDtcbiAgfVxuXG4gICY6aG92ZXIsXG4gICY6Zm9jdXMge1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuXG4gICY6ZGlzYWJsZWQge1xuICAgIGN1cnNvcjogbm90LWFsbG93ZWQ7XG4gIH1cblxuICAmOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdzbGF0ZScsIDAuMDgpfTtcbiAgfVxuXG4gICY6YWN0aXZlIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2xpZ2h0Qmx1ZX07XG4gICAgc3ZnIHtcbiAgICAgIGZpbGw6ICR7Y29sb3IoJ2luaycpfTtcbiAgICB9XG4gIH1cblxuICAke2FjdGl2ZUNzc307XG5cbiAgc3ZnIHtcbiAgICBmaWxsOiAke2NvbG9yKCdwZXd0ZXInKX07XG4gIH1cbmBcblxuZXhwb3J0IGRlZmF1bHQgTmF2SXRlbUJ1dHRvblxuIl19 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Container$7 = createStyled("div", {
  target: "esg9m1l0",
  label: "Container"
})( true ? {
  name: "b3pn3b",
  styles: "display:inline-block;position:relative;"
} : {
  name: "b3pn3b",
  styles: "display:inline-block;position:relative;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuYFxuXG5Db250YWluZXIuZGlzcGxheU5hbWUgPSAnRHJvcGRvd25NZW51LkNvbnRhaW5lcidcblxuZXhwb3J0IGRlZmF1bHQgQ29udGFpbmVyXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
});

Container$7.displayName = 'DropdownMenu.Container';

var ItemLink = /*#__PURE__*/createStyled(function (_ref) {
  var external = _ref.external,
      to = _ref.to,
      props = _objectWithoutProperties(_ref, ["external", "to"]);

  return external ? /*#__PURE__*/React__default['default'].createElement("a", _extends({
    href: to
  }, props)) : /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Link, _extends({
    to: to
  }, props));
}, {
  target: "e1s1uvmf0",
  label: "ItemLink"
})("display:block;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", padding('xxs'), ";", typography('body2'), ";&:hover{background-color:", transparentize('green', 0.15), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW1MaW5rLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9DIiwiZmlsZSI6Ikl0ZW1MaW5rLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBMaW5rIH0gZnJvbSAncmVhY3Qtcm91dGVyLWRvbSdcbmltcG9ydCB7IHBhZGRpbmcsIHRyYW5zcGFyZW50aXplLCB0eXBvZ3JhcGh5IH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBJdGVtTGluayA9IHN0eWxlZCgoeyBleHRlcm5hbCwgdG8sIC4uLnByb3BzIH0pID0+XG4gIGV4dGVybmFsID8gPGEgaHJlZj17dG99IHsuLi5wcm9wc30gLz4gOiA8TGluayB0bz17dG99IHsuLi5wcm9wc30gLz5cbilgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIG92ZXJmbG93OiBoaWRkZW47XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuXG4gICR7cGFkZGluZygneHhzJyl9O1xuICAke3R5cG9ncmFwaHkoJ2JvZHkyJyl9O1xuXG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2dyZWVuJywgMC4xNSl9O1xuICB9XG5gXG5cbkl0ZW1MaW5rLmRpc3BsYXlOYW1lID0gJ0Ryb3Bkb3duTWVudS5JdGVtTGluaydcblxuZXhwb3J0IGRlZmF1bHQgSXRlbUxpbmtcbiJdfQ== */"));

ItemLink.displayName = 'DropdownMenu.ItemLink';

var ItemAction = ItemLink.withComponent('a', {
  target: "e1ycn4dc0",
  label: "ItemAction"
});
ItemAction.displayName = 'DropdownMenu.ItemAction';

var Item$2 = function Item(props) {
  return /*#__PURE__*/React__default['default'].createElement("li", null, props.to ? /*#__PURE__*/React__default['default'].createElement(ItemLink, props) : /*#__PURE__*/React__default['default'].createElement(ItemAction, props));
};

Item$2.displayName = 'DropdownMenu.Item';

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$a =  true ? {
  name: "axwgli-Menu",
  styles: "right:0;;label:Menu;"
} : {
  name: "axwgli-Menu",
  styles: "right:0;;label:Menu;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0JXIiwiZmlsZSI6Ik1lbnUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcbmltcG9ydCB7IGNvbXBvc2UsIGRlZmF1bHRUbywgcHJvcCB9IGZyb20gJy4uLy4uL3V0aWxzL2ZwJ1xuXG5jb25zdCBNZW51ID0gc3R5bGVkLnVsYFxuICBkaXNwbGF5OiAkeyh7IG9wZW4gfSkgPT4gKG9wZW4gPyAnYmxvY2snIDogJ25vbmUnKX07XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAxMDAlO1xuICB6LWluZGV4OiAxMDAwO1xuICBtaW4td2lkdGg6IDEwcmVtO1xuICBsaXN0LXN0eWxlOiBub25lO1xuICBtYXJnaW46ICR7c3BhY2VyKDEpfSAwO1xuICBwYWRkaW5nOiAke3NwYWNlcigxKX0gMDtcbiAgY29sb3I6ICR7Y29sb3IoJ2JsYWNrJyl9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgbWF4LWhlaWdodDogJHtjb21wb3NlKGRlZmF1bHRUbygnMjc1cHgnKSwgcHJvcCgnbWF4SGVpZ2h0JykpfTtcbiAgb3ZlcmZsb3cteTogYXV0bztcbiAgbGluZS1oZWlnaHQ6ICR7Y29tcG9zZShkZWZhdWx0VG8oJzI0cHgnKSwgcHJvcCgnbGluZUhlaWdodCcpKX07XG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3NoYWRvdygnZGlzdGFudCcpfTtcblxuICAkeyh7IGFsaWduIH0pID0+XG4gICAgYWxpZ24gPT09ICdyaWdodCdcbiAgICAgID8gY3NzYFxuICAgICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICBgXG4gICAgICA6IGNzc2BcbiAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICBgfTtcblxuICAkeyh7IHdpZHRoIH0pID0+XG4gICAgd2lkdGggJiZcbiAgICBjc3NgXG4gICAgICB3aWR0aDogJHt3aWR0aH07XG4gICAgYH07XG5cbiAgLyogSGlkZSB0aGUgbWVudSB3aGVuIHRoZSB0cmlnZ2VyIGlzIGhpZGRlbiAqL1xuICAmW2RhdGEtcG9wcGVyLXJlZmVyZW5jZS1oaWRkZW49J3RydWUnXSB7XG4gICAgb3BhY2l0eTogMDsgLy8gdmlzaWJpbGl0eTogaGlkZGVuIGhhcyBhIHdlaXJkIGxhZywgYW5kIGRpc3BsYXk6IG5vbmUgYnJlYWtzIHBvc2l0aW9uaW5nXG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gIH1cbmBcblxuTWVudS5kaXNwbGF5TmFtZSA9ICdEcm9wZG93bk1lbnUuTWVudSdcblxuZXhwb3J0IGRlZmF1bHQgTWVudVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
};

var _ref2$5 =  true ? {
  name: "dbncir-Menu",
  styles: "left:0;;label:Menu;"
} : {
  name: "dbncir-Menu",
  styles: "left:0;;label:Menu;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMkJXIiwiZmlsZSI6Ik1lbnUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcbmltcG9ydCB7IGNvbXBvc2UsIGRlZmF1bHRUbywgcHJvcCB9IGZyb20gJy4uLy4uL3V0aWxzL2ZwJ1xuXG5jb25zdCBNZW51ID0gc3R5bGVkLnVsYFxuICBkaXNwbGF5OiAkeyh7IG9wZW4gfSkgPT4gKG9wZW4gPyAnYmxvY2snIDogJ25vbmUnKX07XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAxMDAlO1xuICB6LWluZGV4OiAxMDAwO1xuICBtaW4td2lkdGg6IDEwcmVtO1xuICBsaXN0LXN0eWxlOiBub25lO1xuICBtYXJnaW46ICR7c3BhY2VyKDEpfSAwO1xuICBwYWRkaW5nOiAke3NwYWNlcigxKX0gMDtcbiAgY29sb3I6ICR7Y29sb3IoJ2JsYWNrJyl9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgbWF4LWhlaWdodDogJHtjb21wb3NlKGRlZmF1bHRUbygnMjc1cHgnKSwgcHJvcCgnbWF4SGVpZ2h0JykpfTtcbiAgb3ZlcmZsb3cteTogYXV0bztcbiAgbGluZS1oZWlnaHQ6ICR7Y29tcG9zZShkZWZhdWx0VG8oJzI0cHgnKSwgcHJvcCgnbGluZUhlaWdodCcpKX07XG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3NoYWRvdygnZGlzdGFudCcpfTtcblxuICAkeyh7IGFsaWduIH0pID0+XG4gICAgYWxpZ24gPT09ICdyaWdodCdcbiAgICAgID8gY3NzYFxuICAgICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICBgXG4gICAgICA6IGNzc2BcbiAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICBgfTtcblxuICAkeyh7IHdpZHRoIH0pID0+XG4gICAgd2lkdGggJiZcbiAgICBjc3NgXG4gICAgICB3aWR0aDogJHt3aWR0aH07XG4gICAgYH07XG5cbiAgLyogSGlkZSB0aGUgbWVudSB3aGVuIHRoZSB0cmlnZ2VyIGlzIGhpZGRlbiAqL1xuICAmW2RhdGEtcG9wcGVyLXJlZmVyZW5jZS1oaWRkZW49J3RydWUnXSB7XG4gICAgb3BhY2l0eTogMDsgLy8gdmlzaWJpbGl0eTogaGlkZGVuIGhhcyBhIHdlaXJkIGxhZywgYW5kIGRpc3BsYXk6IG5vbmUgYnJlYWtzIHBvc2l0aW9uaW5nXG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gIH1cbmBcblxuTWVudS5kaXNwbGF5TmFtZSA9ICdEcm9wZG93bk1lbnUuTWVudSdcblxuZXhwb3J0IGRlZmF1bHQgTWVudVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
};

var Menu$1 = createStyled("ul", {
  target: "en3gjji0",
  label: "Menu"
})("display:", function (_ref3) {
  var open = _ref3.open;
  return open ? 'block' : 'none';
}, ";position:absolute;top:100%;z-index:1000;min-width:10rem;list-style:none;margin:", spacer(1), " 0;padding:", spacer(1), " 0;color:", color('black'), ";background-color:", color('white'), ";max-height:", recompose.compose(defaultTo('275px'), prop('maxHeight')), ";overflow-y:auto;line-height:", recompose.compose(defaultTo('24px'), prop('lineHeight')), ";", borderRadius('default'), ";", shadow('distant'), ";", function (_ref4) {
  var align = _ref4.align;
  return align === 'right' ? _ref$a : _ref2$5;
}, ";", function (_ref5) {
  var width = _ref5.width;
  return width && /*#__PURE__*/core.css("width:", width, ";;label:Menu;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBaUNPIiwiZmlsZSI6Ik1lbnUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcbmltcG9ydCB7IGNvbXBvc2UsIGRlZmF1bHRUbywgcHJvcCB9IGZyb20gJy4uLy4uL3V0aWxzL2ZwJ1xuXG5jb25zdCBNZW51ID0gc3R5bGVkLnVsYFxuICBkaXNwbGF5OiAkeyh7IG9wZW4gfSkgPT4gKG9wZW4gPyAnYmxvY2snIDogJ25vbmUnKX07XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAxMDAlO1xuICB6LWluZGV4OiAxMDAwO1xuICBtaW4td2lkdGg6IDEwcmVtO1xuICBsaXN0LXN0eWxlOiBub25lO1xuICBtYXJnaW46ICR7c3BhY2VyKDEpfSAwO1xuICBwYWRkaW5nOiAke3NwYWNlcigxKX0gMDtcbiAgY29sb3I6ICR7Y29sb3IoJ2JsYWNrJyl9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgbWF4LWhlaWdodDogJHtjb21wb3NlKGRlZmF1bHRUbygnMjc1cHgnKSwgcHJvcCgnbWF4SGVpZ2h0JykpfTtcbiAgb3ZlcmZsb3cteTogYXV0bztcbiAgbGluZS1oZWlnaHQ6ICR7Y29tcG9zZShkZWZhdWx0VG8oJzI0cHgnKSwgcHJvcCgnbGluZUhlaWdodCcpKX07XG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3NoYWRvdygnZGlzdGFudCcpfTtcblxuICAkeyh7IGFsaWduIH0pID0+XG4gICAgYWxpZ24gPT09ICdyaWdodCdcbiAgICAgID8gY3NzYFxuICAgICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICBgXG4gICAgICA6IGNzc2BcbiAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICBgfTtcblxuICAkeyh7IHdpZHRoIH0pID0+XG4gICAgd2lkdGggJiZcbiAgICBjc3NgXG4gICAgICB3aWR0aDogJHt3aWR0aH07XG4gICAgYH07XG5cbiAgLyogSGlkZSB0aGUgbWVudSB3aGVuIHRoZSB0cmlnZ2VyIGlzIGhpZGRlbiAqL1xuICAmW2RhdGEtcG9wcGVyLXJlZmVyZW5jZS1oaWRkZW49J3RydWUnXSB7XG4gICAgb3BhY2l0eTogMDsgLy8gdmlzaWJpbGl0eTogaGlkZGVuIGhhcyBhIHdlaXJkIGxhZywgYW5kIGRpc3BsYXk6IG5vbmUgYnJlYWtzIHBvc2l0aW9uaW5nXG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gIH1cbmBcblxuTWVudS5kaXNwbGF5TmFtZSA9ICdEcm9wZG93bk1lbnUuTWVudSdcblxuZXhwb3J0IGRlZmF1bHQgTWVudVxuIl19 */"));
}, ";&[data-popper-reference-hidden='true']{opacity:0;pointer-events:none;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lbnUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS3NCIiwiZmlsZSI6Ik1lbnUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcbmltcG9ydCB7IGNvbXBvc2UsIGRlZmF1bHRUbywgcHJvcCB9IGZyb20gJy4uLy4uL3V0aWxzL2ZwJ1xuXG5jb25zdCBNZW51ID0gc3R5bGVkLnVsYFxuICBkaXNwbGF5OiAkeyh7IG9wZW4gfSkgPT4gKG9wZW4gPyAnYmxvY2snIDogJ25vbmUnKX07XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAxMDAlO1xuICB6LWluZGV4OiAxMDAwO1xuICBtaW4td2lkdGg6IDEwcmVtO1xuICBsaXN0LXN0eWxlOiBub25lO1xuICBtYXJnaW46ICR7c3BhY2VyKDEpfSAwO1xuICBwYWRkaW5nOiAke3NwYWNlcigxKX0gMDtcbiAgY29sb3I6ICR7Y29sb3IoJ2JsYWNrJyl9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgbWF4LWhlaWdodDogJHtjb21wb3NlKGRlZmF1bHRUbygnMjc1cHgnKSwgcHJvcCgnbWF4SGVpZ2h0JykpfTtcbiAgb3ZlcmZsb3cteTogYXV0bztcbiAgbGluZS1oZWlnaHQ6ICR7Y29tcG9zZShkZWZhdWx0VG8oJzI0cHgnKSwgcHJvcCgnbGluZUhlaWdodCcpKX07XG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3NoYWRvdygnZGlzdGFudCcpfTtcblxuICAkeyh7IGFsaWduIH0pID0+XG4gICAgYWxpZ24gPT09ICdyaWdodCdcbiAgICAgID8gY3NzYFxuICAgICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICBgXG4gICAgICA6IGNzc2BcbiAgICAgICAgICBsZWZ0OiAwO1xuICAgICAgICBgfTtcblxuICAkeyh7IHdpZHRoIH0pID0+XG4gICAgd2lkdGggJiZcbiAgICBjc3NgXG4gICAgICB3aWR0aDogJHt3aWR0aH07XG4gICAgYH07XG5cbiAgLyogSGlkZSB0aGUgbWVudSB3aGVuIHRoZSB0cmlnZ2VyIGlzIGhpZGRlbiAqL1xuICAmW2RhdGEtcG9wcGVyLXJlZmVyZW5jZS1oaWRkZW49J3RydWUnXSB7XG4gICAgb3BhY2l0eTogMDsgLy8gdmlzaWJpbGl0eTogaGlkZGVuIGhhcyBhIHdlaXJkIGxhZywgYW5kIGRpc3BsYXk6IG5vbmUgYnJlYWtzIHBvc2l0aW9uaW5nXG4gICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gIH1cbmBcblxuTWVudS5kaXNwbGF5TmFtZSA9ICdEcm9wZG93bk1lbnUuTWVudSdcblxuZXhwb3J0IGRlZmF1bHQgTWVudVxuIl19 */"));

Menu$1.displayName = 'DropdownMenu.Menu';

var Section$1 = createStyled("div", {
  target: "e17rzm3e0",
  label: "Section"
})("&:not(:last-of-type){margin-bottom:", spacer(1), ";padding-bottom:", spacer(1), ";border-bottom:1px solid ", color('paleGrey'), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY3Rpb24uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRzBCIiwiZmlsZSI6IlNlY3Rpb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNvbG9yLCBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IFNlY3Rpb24gPSBzdHlsZWQuZGl2YFxuICAmOm5vdCg6bGFzdC1vZi10eXBlKSB7XG4gICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoMSl9O1xuICAgIHBhZGRpbmctYm90dG9tOiAke3NwYWNlcigxKX07XG4gICAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICR7Y29sb3IoJ3BhbGVHcmV5Jyl9O1xuICB9XG5gXG5cblNlY3Rpb24uZGlzcGxheU5hbWUgPSAnRHJvcGRvd25NZW51LlNlY3Rpb24nXG5cbmV4cG9ydCBkZWZhdWx0IFNlY3Rpb25cbiJdfQ== */"));

Section$1.displayName = 'DropdownMenu.Section';

function DropdownMenu(_ref) {
  var align = _ref.align,
      children = _ref.children,
      lineHeight = _ref.lineHeight,
      maxHeight = _ref.maxHeight,
      trigger = _ref.trigger,
      width = _ref.width,
      popperOptions = _ref.popperOptions,
      controlledOpen = _ref.open,
      onToggle = _ref.onToggle;
  var isControlled = controlledOpen !== undefined;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var toggle = React.useCallback(function () {
    if (isControlled) {
      if (onToggle) {
        onToggle(!controlledOpen);
      }
    } else {
      setOpen(!open);
    }
  }, [isControlled, onToggle, controlledOpen, open]);
  var menuRoot = React.useMemo(popperOptions ? function () {
    return getRoot('menu');
  } : function () {}, []); // useState instead of useRef, so popper initializes when its set

  var _useState3 = React.useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      menuRef = _useState4[0],
      setMenuRef = _useState4[1];

  var _useState5 = React.useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      triggerRef = _useState6[0],
      setTriggerRef = _useState6[1];

  var _usePopper = reactPopper.usePopper(triggerRef, menuRef, popperOptions ? popperOptions : {}),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update;

  var trueOpen = isControlled ? controlledOpen : open;
  React.useLayoutEffect(function () {
    update && update(); // Ensure position is updated

    var maybeClose = function maybeClose(evt) {
      if (trueOpen && !menuRef.contains(evt.target)) {
        toggle();
      }
    };

    document.addEventListener('click', maybeClose);
    return function () {
      return document.removeEventListener('click', maybeClose);
    };
  }, [trueOpen, menuRef]);
  var triggerEl = popperOptions ? trigger(toggle, setTriggerRef, trueOpen) : trigger(toggle, trueOpen);
  var popperProps = popperOptions ? _objectSpread2({
    style: styles.popper
  }, attributes.popper) : {};
  var menu = /*#__PURE__*/React__default['default'].createElement(Menu$1, _extends({
    align: align,
    width: width,
    open: trueOpen,
    maxHeight: maxHeight,
    lineHeight: lineHeight,
    ref: setMenuRef
  }, popperProps), children);
  return /*#__PURE__*/React__default['default'].createElement(Container$7, null, triggerEl, popperOptions ? /*#__PURE__*/reactDom.createPortal(menu, menuRoot) : menu);
}

DropdownMenu.Item = Item$2;
DropdownMenu.Section = Section$1;
DropdownMenu.propTypes = {
  align: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node,
  maxHeight: PropTypes__default['default'].oneOf([PropTypes__default['default'].string, PropTypes__default['default'].number]),
  trigger: PropTypes__default['default'].func,
  width: PropTypes__default['default'].oneOf([PropTypes__default['default'].string, PropTypes__default['default'].number]),
  popperOptions: PropTypes__default['default'].shape({
    placement: PropTypes__default['default'].string,
    modifiers: PropTypes__default['default'].arrayOf(PropTypes__default['default'].object),
    strategy: PropTypes__default['default'].string,
    onFirstUpdate: PropTypes__default['default'].func
  }),
  open: PropTypes__default['default'].bool,
  onToggle: PropTypes__default['default'].func
};

var Carets = function Carets(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'carets' : _ref$title,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 24' : _ref$viewBox,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '1.5rem' : _ref$size,
      props = _objectWithoutProperties(_ref, ["title", "viewBox", "size"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, _extends({
    viewBox: viewBox,
    size: size
  }, props), /*#__PURE__*/React__default['default'].createElement("title", null, title), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M7.72833 6.99652L10.315 9.58318C10.575 9.84318 11.0017 9.83652 11.2617 9.58318C11.5217 9.32318 11.5217 8.90318 11.2617 8.64318L8.20167 5.58318C7.94167 5.32318 7.52167 5.32318 7.26167 5.58318L4.20167 8.64318C3.94167 8.90318 3.94167 9.32318 4.20167 9.58318C4.46167 9.84318 4.88167 9.84318 5.14167 9.58318L7.72833 6.99652ZM7.72833 16.5565L5.14167 13.9698C4.88167 13.7098 4.455 13.7165 4.195 13.9698C3.935 14.2298 3.935 14.6498 4.195 14.9098L7.255 17.9698C7.515 18.2298 7.935 18.2298 8.195 17.9698L11.255 14.9098C11.515 14.6498 11.515 14.2298 11.255 13.9698C10.995 13.7098 10.575 13.7098 10.315 13.9698L7.72833 16.5565Z"
  }));
};

var Divider = createStyled("div", {
  target: "e1k2pysd0",
  label: "Divider"
})("margin:0.25em 0;border-bottom:1px solid ", color('paleGrey'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRpdmlkZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRzBCIiwiZmlsZSI6IkRpdmlkZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNvbG9yIH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBEaXZpZGVyID0gc3R5bGVkLmRpdmBcbiAgbWFyZ2luOiAwLjI1ZW0gMDtcbiAgYm9yZGVyLWJvdHRvbTogMXB4IHNvbGlkICR7Y29sb3IoJ3BhbGVHcmV5Jyl9O1xuYFxuXG5EaXZpZGVyLmRpc3BsYXlOYW1lID0gJ0dsb2JhbEhlYWRlci5Ecm9wZG93bk1lbnUuRGl2aWRlcidcblxuZXhwb3J0IGRlZmF1bHQgRGl2aWRlclxuIl19 */"));

Divider.displayName = 'GlobalHeader.DropdownMenu.Divider';

function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var baseCss =  true ? {
  name: "1fu7jr6-baseCss",
  styles: "display:flex;align-items:center;justify-content:space-between;padding:0.75em 1em;font-size:0.875em;;label:baseCss;"
} : {
  name: "1fu7jr6-baseCss",
  styles: "display:flex;align-items:center;justify-content:space-between;padding:0.75em 1em;font-size:0.875em;;label:baseCss;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBS21CIiwiZmlsZSI6Ikl0ZW0uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyB0cmFuc3BhcmVudGl6ZSB9IGZyb20gJy4uLy4uLy4uL3N0eWxlcydcblxuY29uc3QgYmFzZUNzcyA9IGNzc2BcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBwYWRkaW5nOiAwLjc1ZW0gMWVtO1xuICBmb250LXNpemU6IDAuODc1ZW07XG5gXG5cbmNvbnN0IExpbmsgPSBzdHlsZWQuYWBcbiAgJHtiYXNlQ3NzfTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuXG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ3NpbHZlcicsIDAuMyl9O1xuICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgfVxuYFxuXG5jb25zdCBTdHlsZWRJdGVtID0gc3R5bGVkLmxpYFxuICAke2Jhc2VDc3N9O1xuYFxuXG5jb25zdCBJdGVtID0gcHJvcHMgPT5cbiAgcHJvcHMudG8gPyAoXG4gICAgPGxpPlxuICAgICAgPExpbmsgaHJlZj17cHJvcHMudG99IHsuLi5wcm9wc30gLz5cbiAgICA8L2xpPlxuICApIDogKFxuICAgIDxTdHlsZWRJdGVtIHsuLi5wcm9wc30gLz5cbiAgKVxuXG5JdGVtLmRpc3BsYXlOYW1lID0gJ0dsb2JhbEhlYWRlci5Ecm9wZG93bk1lbnUuSXRlbSdcblxuZXhwb3J0IGRlZmF1bHQgSXRlbVxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
};

var Link = createStyled("a", {
  target: "e1xhc6pn0",
  label: "Link"
})(baseCss, ";cursor:pointer;&:hover{background-color:", transparentize('silver', 0.3), ";text-decoration:none;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYXFCIiwiZmlsZSI6Ikl0ZW0uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyB0cmFuc3BhcmVudGl6ZSB9IGZyb20gJy4uLy4uLy4uL3N0eWxlcydcblxuY29uc3QgYmFzZUNzcyA9IGNzc2BcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBwYWRkaW5nOiAwLjc1ZW0gMWVtO1xuICBmb250LXNpemU6IDAuODc1ZW07XG5gXG5cbmNvbnN0IExpbmsgPSBzdHlsZWQuYWBcbiAgJHtiYXNlQ3NzfTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuXG4gICY6aG92ZXIge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ3NpbHZlcicsIDAuMyl9O1xuICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgfVxuYFxuXG5jb25zdCBTdHlsZWRJdGVtID0gc3R5bGVkLmxpYFxuICAke2Jhc2VDc3N9O1xuYFxuXG5jb25zdCBJdGVtID0gcHJvcHMgPT5cbiAgcHJvcHMudG8gPyAoXG4gICAgPGxpPlxuICAgICAgPExpbmsgaHJlZj17cHJvcHMudG99IHsuLi5wcm9wc30gLz5cbiAgICA8L2xpPlxuICApIDogKFxuICAgIDxTdHlsZWRJdGVtIHsuLi5wcm9wc30gLz5cbiAgKVxuXG5JdGVtLmRpc3BsYXlOYW1lID0gJ0dsb2JhbEhlYWRlci5Ecm9wZG93bk1lbnUuSXRlbSdcblxuZXhwb3J0IGRlZmF1bHQgSXRlbVxuIl19 */"));

var StyledItem = createStyled("li", {
  target: "e1xhc6pn1",
  label: "StyledItem"
})(baseCss, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUI0QiIsImZpbGUiOiJJdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUgfSBmcm9tICcuLi8uLi8uLi9zdHlsZXMnXG5cbmNvbnN0IGJhc2VDc3MgPSBjc3NgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgcGFkZGluZzogMC43NWVtIDFlbTtcbiAgZm9udC1zaXplOiAwLjg3NWVtO1xuYFxuXG5jb25zdCBMaW5rID0gc3R5bGVkLmFgXG4gICR7YmFzZUNzc307XG4gIGN1cnNvcjogcG9pbnRlcjtcblxuICAmOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdzaWx2ZXInLCAwLjMpfTtcbiAgICB0ZXh0LWRlY29yYXRpb246IG5vbmU7XG4gIH1cbmBcblxuY29uc3QgU3R5bGVkSXRlbSA9IHN0eWxlZC5saWBcbiAgJHtiYXNlQ3NzfTtcbmBcblxuY29uc3QgSXRlbSA9IHByb3BzID0+XG4gIHByb3BzLnRvID8gKFxuICAgIDxsaT5cbiAgICAgIDxMaW5rIGhyZWY9e3Byb3BzLnRvfSB7Li4ucHJvcHN9IC8+XG4gICAgPC9saT5cbiAgKSA6IChcbiAgICA8U3R5bGVkSXRlbSB7Li4ucHJvcHN9IC8+XG4gIClcblxuSXRlbS5kaXNwbGF5TmFtZSA9ICdHbG9iYWxIZWFkZXIuRHJvcGRvd25NZW51Lkl0ZW0nXG5cbmV4cG9ydCBkZWZhdWx0IEl0ZW1cbiJdfQ== */"));

var Item$3 = function Item(props) {
  return props.to ? /*#__PURE__*/React__default['default'].createElement("li", null, /*#__PURE__*/React__default['default'].createElement(Link, _extends({
    href: props.to
  }, props))) : /*#__PURE__*/React__default['default'].createElement(StyledItem, props);
};

Item$3.displayName = 'GlobalHeader.DropdownMenu.Item';

function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$b =  true ? {
  name: "1ahm8w6-PlaceholderButton",
  styles: "background:rgba(0,0,0,0.04);border:1px solid #e4e8eb;border-radius:4px;;label:PlaceholderButton;"
} : {
  name: "1ahm8w6-PlaceholderButton",
  styles: "background:rgba(0,0,0,0.04);border:1px solid #e4e8eb;border-radius:4px;;label:PlaceholderButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
};

var PlaceholderButton = createStyled("button", {
  target: "e10fdl10",
  label: "PlaceholderButton"
})("font-size:1em;display:flex;align-items:center;height:3.25em;padding:0.5em;border:0;box-sizing:border-box;background:", color('white'), ";min-width:8.25em;max-width:16.25em;border:1px solid transparent;cursor:pointer;outline:0;", function (_ref2) {
  var open = _ref2.open;
  return open ? _ref$b : '';
},  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var ChevronsContainer = createStyled("div", {
  target: "e10fdl11",
  label: "ChevronsContainer"
})( true ? {
  name: "mhgpyg",
  styles: "display:flex;flex-direction:column;margin-left:0.5em;"
} : {
  name: "mhgpyg",
  styles: "display:flex;flex-direction:column;margin-left:0.5em;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});

var Chevrons = function Chevrons() {
  return /*#__PURE__*/React__default['default'].createElement(ChevronsContainer, null, /*#__PURE__*/React__default['default'].createElement(Carets, null));
};

var ButtonLabel = createStyled("span", {
  target: "e10fdl12",
  label: "ButtonLabel"
})( true ? {
  name: "mtbf91",
  styles: "font-size:0.875em;font-weight:500;flex:1;text-align:left;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"
} : {
  name: "mtbf91",
  styles: "font-size:0.875em;font-weight:500;flex:1;text-align:left;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});

var Image$1 = createStyled("img", {
  target: "e10fdl13",
  label: "Image"
})( true ? {
  name: "1l4k18e",
  styles: "width:2em;max-height:2em;margin-right:0.5em;"
} : {
  name: "1l4k18e",
  styles: "width:2em;max-height:2em;margin-right:0.5em;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});

var GlobalHeaderDropdownMenu = function GlobalHeaderDropdownMenu(_ref3) {
  var children = _ref3.children,
      placeholder = _ref3.placeholder,
      width = _ref3.width,
      align = _ref3.align,
      imageSrc = _ref3.imageSrc,
      renderTrigger = _ref3.renderTrigger,
      maxHeight = _ref3.maxHeight,
      lineHeight = _ref3.lineHeight;
  return /*#__PURE__*/React__default['default'].createElement(DropdownMenu, {
    align: align,
    width: width,
    maxHeight: maxHeight,
    lineHeight: lineHeight,
    trigger: function trigger(toggle, open) {
      return renderTrigger ? renderTrigger({
        toggle: toggle,
        open: open
      }) : /*#__PURE__*/React__default['default'].createElement(PlaceholderButton, {
        open: open,
        onClick: toggle
      }, /*#__PURE__*/React__default['default'].createElement(Image$1, {
        src: imageSrc
      }), /*#__PURE__*/React__default['default'].createElement(ButtonLabel, null, placeholder), /*#__PURE__*/React__default['default'].createElement(Chevrons, null));
    }
  }, children);
};

GlobalHeaderDropdownMenu.Divider = Divider;
GlobalHeaderDropdownMenu.Item = Item$3;
GlobalHeaderDropdownMenu.Image = Image$1;
GlobalHeaderDropdownMenu.PlaceholderButton = PlaceholderButton;
GlobalHeaderDropdownMenu.ButtonLabel = ButtonLabel;
GlobalHeaderDropdownMenu.Chevrons = Chevrons;

var Avatar$1 = createStyled("div", {
  target: "elwuy6j0",
  label: "Avatar"
})("display:flex;justify-content:center;align-items:center;border-radius:50%;width:2em;height:2em;background-color:", color('slate'), ";color:", color('cadet'), ";img{width:100%;pointer-events:none;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkF2YXRhci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHeUIiLCJmaWxlIjoiQXZhdGFyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjb2xvciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgQXZhdGFyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgd2lkdGg6IDJlbTtcbiAgaGVpZ2h0OiAyZW07XG4gIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3NsYXRlJyl9O1xuICBjb2xvcjogJHtjb2xvcignY2FkZXQnKX07XG5cbiAgaW1nIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgfVxuYFxuXG5BdmF0YXIuZGlzcGxheU5hbWUgPSAnR2xvYmFsSGVhZGVyLkF2YXRhcidcblxuZXhwb3J0IGRlZmF1bHQgQXZhdGFyXG4iXX0= */"));

Avatar$1.displayName = 'GlobalHeader.Avatar';

function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var GlobalHeader = createStyled("nav", {
  target: "e19u03go0",
  label: "GlobalHeader"
})("display:flex;justify-content:center;align-items:center;width:100%;padding:0.375em;box-sizing:border-box;height:4.375em;color:", color('ink'), ";background-color:", color('white'), ";border-top:2px solid ", color('brandGreen'), ";border-bottom:1px solid ", color('silver'), ";", function (_ref) {
  var _ref$baseFontSize = _ref.baseFontSize,
      baseFontSize = _ref$baseFontSize === void 0 ? '16px' : _ref$baseFontSize;
  return /*#__PURE__*/core.css("font-size:", baseFontSize, ";;label:GlobalHeader;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
}, ";", function (_ref2) {
  var borderTopColor = _ref2.borderTopColor;
  return borderTopColor ? /*#__PURE__*/core.css("border-top-color:", borderTopColor, ";;label:GlobalHeader;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")) : '';
}, ";", function (_ref3) {
  var borderBottomColor = _ref3.borderBottomColor;
  return borderBottomColor ? /*#__PURE__*/core.css("border-bottom-color:", borderBottomColor, ";;label:GlobalHeader;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")) : '';
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Main = createStyled("div", {
  target: "e19u03go1",
  label: "Main"
})( true ? {
  name: "1n3p764",
  styles: "flex:1;min-width:0;display:flex;align-items:center;height:2.5em;"
} : {
  name: "1n3p764",
  styles: "flex:1;min-width:0;display:flex;align-items:center;height:2.5em;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});

var Side = createStyled("div", {
  target: "e19u03go2",
  label: "Side"
})( true ? {
  name: "j212vf",
  styles: "display:flex;flex-direction:row;align-items:center;justify-content:center;height:2.5em;"
} : {
  name: "j212vf",
  styles: "display:flex;flex-direction:row;align-items:center;justify-content:center;height:2.5em;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});

GlobalHeader.Logo = Logo;
GlobalHeader.Main = Main;
GlobalHeader.Side = Side;
GlobalHeader.NavItem = NavItem;
GlobalHeader.NavItemButton = NavItemButton;
GlobalHeader.DropdownMenu = GlobalHeaderDropdownMenu;
GlobalHeader.Avatar = Avatar$1;

var userNameColor = function userNameColor(_ref) {
  var fontColor = _ref.fontColor;
  return /*#__PURE__*/core.css("color:", transparentize(fontColor, 0.5), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVzZXJOYW1lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUk0QyIsImZpbGUiOiJVc2VyTmFtZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHNwYWNlciwgdHJhbnNwYXJlbnRpemUsIHR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHVzZXJOYW1lQ29sb3IgPSAoeyBmb250Q29sb3IgfSkgPT4gY3NzYFxuICBjb2xvcjogJHt0cmFuc3BhcmVudGl6ZShmb250Q29sb3IsIDAuNSl9O1xuYFxuXG5jb25zdCBVc2VyTmFtZSA9IHN0eWxlZC5zcGFuYFxuICBtYXJnaW4tbGVmdDogJHtzcGFjZXIoMil9O1xuICAke3R5cG9ncmFwaHkoJ2JvZHkxJyl9O1xuICAke3VzZXJOYW1lQ29sb3J9O1xuYFxuXG5Vc2VyTmFtZS5kaXNwbGF5TmFtZSA9ICdIZWFkZXJBdmF0YXIuVXNlck5hbWUnXG5cbmV4cG9ydCBkZWZhdWx0IFVzZXJOYW1lXG4iXX0= */"));
};

var UserName = createStyled("span", {
  target: "e17wgi270",
  label: "UserName"
})("margin-left:", spacer(2), ";", typography('body1'), ";", userNameColor, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVzZXJOYW1lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVE0QiIsImZpbGUiOiJVc2VyTmFtZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHNwYWNlciwgdHJhbnNwYXJlbnRpemUsIHR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHVzZXJOYW1lQ29sb3IgPSAoeyBmb250Q29sb3IgfSkgPT4gY3NzYFxuICBjb2xvcjogJHt0cmFuc3BhcmVudGl6ZShmb250Q29sb3IsIDAuNSl9O1xuYFxuXG5jb25zdCBVc2VyTmFtZSA9IHN0eWxlZC5zcGFuYFxuICBtYXJnaW4tbGVmdDogJHtzcGFjZXIoMil9O1xuICAke3R5cG9ncmFwaHkoJ2JvZHkxJyl9O1xuICAke3VzZXJOYW1lQ29sb3J9O1xuYFxuXG5Vc2VyTmFtZS5kaXNwbGF5TmFtZSA9ICdIZWFkZXJBdmF0YXIuVXNlck5hbWUnXG5cbmV4cG9ydCBkZWZhdWx0IFVzZXJOYW1lXG4iXX0= */"));

UserName.displayName = 'HeaderAvatar.UserName';

var AvatarButton = /*#__PURE__*/createStyled(Button, {
  target: "e1q84wsz0",
  label: "AvatarButton"
})("display:flex;justify-content:center;align-items:center;background:none;padding:0;border:none;&::after{content:'';color:", color('cadet'), ";margin-left:0.625rem;width:0;height:0;vertical-align:0.255em;border-top:0.3em solid;border-right:0.3em solid transparent;border-bottom:0;border-left:0.3em solid transparent;}&:hover{", UserName, "{color:", color('offWhite'), ";}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLbUMiLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgQnV0dG9uIGZyb20gJy4uL0J1dHRvbidcbmltcG9ydCBVc2VyTmFtZSBmcm9tICcuL1VzZXJOYW1lJ1xuaW1wb3J0IHsgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IEF2YXRhckJ1dHRvbiA9IHN0eWxlZChCdXR0b24pYFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgYmFja2dyb3VuZDogbm9uZTtcbiAgcGFkZGluZzogMDtcbiAgYm9yZGVyOiBub25lO1xuXG4gICY6OmFmdGVyIHtcbiAgICBjb250ZW50OiAnJztcbiAgICBjb2xvcjogJHtjb2xvcignY2FkZXQnKX07XG4gICAgbWFyZ2luLWxlZnQ6IDAuNjI1cmVtO1xuICAgIHdpZHRoOiAwO1xuICAgIGhlaWdodDogMDtcbiAgICB2ZXJ0aWNhbC1hbGlnbjogMC4yNTVlbTtcbiAgICBib3JkZXItdG9wOiAwLjNlbSBzb2xpZDtcbiAgICBib3JkZXItcmlnaHQ6IDAuM2VtIHNvbGlkIHRyYW5zcGFyZW50O1xuICAgIGJvcmRlci1ib3R0b206IDA7XG4gICAgYm9yZGVyLWxlZnQ6IDAuM2VtIHNvbGlkIHRyYW5zcGFyZW50O1xuICB9XG5cbiAgJjpob3ZlciB7XG4gICAgJHtVc2VyTmFtZX0ge1xuICAgICAgY29sb3I6ICR7Y29sb3IoJ29mZldoaXRlJyl9O1xuICAgIH1cbiAgfVxuYFxuXG5BdmF0YXJCdXR0b24uZGlzcGxheU5hbWUgPSAnSGVhZGVyQXZhdGFyLkJ1dHRvbidcblxuZXhwb3J0IGRlZmF1bHQgQXZhdGFyQnV0dG9uXG4iXX0= */"));

AvatarButton.displayName = 'HeaderAvatar.Button';

var HeaderAvatar = function HeaderAvatar(_ref) {
  var align = _ref.align,
      children = _ref.children,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      email = _ref.email,
      hideUserName = _ref.hideUserName,
      avatarUrl = _ref.avatarUrl,
      fontColor = _ref.fontColor;
  return /*#__PURE__*/React__default['default'].createElement(DropdownMenu, {
    align: align,
    trigger: function trigger(toggle) {
      return /*#__PURE__*/React__default['default'].createElement(AvatarButton, {
        onClick: toggle
      }, /*#__PURE__*/React__default['default'].createElement(Avatar, {
        firstName: firstName,
        lastName: lastName,
        email: email,
        avatarUrl: avatarUrl
      }), !hideUserName && /*#__PURE__*/React__default['default'].createElement(UserName, {
        fontColor: fontColor
      }, "".concat(firstName, " ").concat(lastName).trim()));
    }
  }, children);
};

HeaderAvatar.MenuItem = DropdownMenu.Item;
HeaderAvatar.MenuSection = DropdownMenu.Section;
HeaderAvatar.propTypes = {
  align: PropTypes__default['default'].string,
  children: PropTypes__default['default'].node,
  firstName: PropTypes__default['default'].string,
  lastName: PropTypes__default['default'].string,
  hideUserName: PropTypes__default['default'].bool,
  avatarUrl: PropTypes__default['default'].string,
  fontColor: PropTypes__default['default'].string
};
HeaderAvatar.defaultProps = {
  align: 'left',
  firstName: '',
  lastName: '',
  hideUserName: false,
  avatarUrl: '',
  fontColor: 'offWhite'
};

var breakpointAt = function breakpointAt(size) {
  invariant__default['default'](size, "No breakpoint exists for '".concat(size, "'"));
  return BREAKPOINTS[size];
};

var MediaQuery = function MediaQuery(_ref) {
  var above = _ref.above,
      below = _ref.below,
      children = _ref.children,
      render = _ref.render;
  var query = {};

  if (above) {
    query.minWidth = breakpointAt(above);
  }

  if (below) {
    query.maxWidth = breakpointAt(below);
  }

  return /*#__PURE__*/React__default['default'].createElement(Media__default['default'], {
    query: query,
    children: children,
    render: render
  });
};

MediaQuery.propTypes = {
  above: PropTypes__default['default'].oneOf(Object.keys(BREAKPOINTS)),
  below: PropTypes__default['default'].oneOf(Object.keys(BREAKPOINTS)),
  children: PropTypes__default['default'].func,
  render: PropTypes__default['default'].func
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$c =  true ? {
  name: "r2ff5g",
  styles: "visibility:visible;opacity:1;"
} : {
  name: "r2ff5g",
  styles: "visibility:visible;opacity:1;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFnQiIsImZpbGUiOiJCYWNrZHJvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBhbmltYXRpb25TdGF0ZSA9ICh7IGFuaW1hdGlvblN0YXRlIH0pID0+IHtcbiAgc3dpdGNoIChhbmltYXRpb25TdGF0ZSkge1xuICAgIGNhc2UgJ2VudGVyaW5nJzpcbiAgICBjYXNlICdlbnRlcmVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IHZpc2libGU7XG4gICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICBgXG4gICAgY2FzZSAnZXhpdGluZyc6XG4gICAgY2FzZSAnZXhpdGVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgb3BhY2l0eTogMDtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgIC8vIGRvIG5vdGhpbmdcbiAgfVxufVxuXG5jb25zdCBCYWNrZHJvcCA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICBiYWNrZ3JvdW5kOiAke3RyYW5zcGFyZW50aXplKCdwZXd0ZXInLCAwLjYpfTtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3M7XG4gIHotaW5kZXg6IDEwNDk7XG5cbiAgJHthbmltYXRpb25TdGF0ZX07XG5gXG5cbkJhY2tkcm9wLmRpc3BsYXlOYW1lID0gJ01vZGFsLkJhY2tkcm9wJ1xuXG5leHBvcnQgZGVmYXVsdCBCYWNrZHJvcFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
};

var _ref2$6 =  true ? {
  name: "ge94et",
  styles: "visibility:hidden;opacity:0;"
} : {
  name: "ge94et",
  styles: "visibility:hidden;opacity:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNnQiIsImZpbGUiOiJCYWNrZHJvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBhbmltYXRpb25TdGF0ZSA9ICh7IGFuaW1hdGlvblN0YXRlIH0pID0+IHtcbiAgc3dpdGNoIChhbmltYXRpb25TdGF0ZSkge1xuICAgIGNhc2UgJ2VudGVyaW5nJzpcbiAgICBjYXNlICdlbnRlcmVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IHZpc2libGU7XG4gICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICBgXG4gICAgY2FzZSAnZXhpdGluZyc6XG4gICAgY2FzZSAnZXhpdGVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgb3BhY2l0eTogMDtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgIC8vIGRvIG5vdGhpbmdcbiAgfVxufVxuXG5jb25zdCBCYWNrZHJvcCA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICBiYWNrZ3JvdW5kOiAke3RyYW5zcGFyZW50aXplKCdwZXd0ZXInLCAwLjYpfTtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3M7XG4gIHotaW5kZXg6IDEwNDk7XG5cbiAgJHthbmltYXRpb25TdGF0ZX07XG5gXG5cbkJhY2tkcm9wLmRpc3BsYXlOYW1lID0gJ01vZGFsLkJhY2tkcm9wJ1xuXG5leHBvcnQgZGVmYXVsdCBCYWNrZHJvcFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
};

var animationState = function animationState(_ref3) {
  var animationState = _ref3.animationState;

  switch (animationState) {
    case 'entering':
    case 'entered':
      return _ref$c;

    case 'exiting':
    case 'exited':
      return _ref2$6;

  }
};

var Backdrop$1 = createStyled("div", {
  target: "e1uy2bqx0",
  label: "Backdrop"
})("position:fixed;top:0;left:0;right:0;bottom:0;background:", transparentize('pewter', 0.6), ";transition:all 0.3s;z-index:1049;", animationState, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVCMkIiLCJmaWxlIjoiQmFja2Ryb3AuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyB0cmFuc3BhcmVudGl6ZSB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgYW5pbWF0aW9uU3RhdGUgPSAoeyBhbmltYXRpb25TdGF0ZSB9KSA9PiB7XG4gIHN3aXRjaCAoYW5pbWF0aW9uU3RhdGUpIHtcbiAgICBjYXNlICdlbnRlcmluZyc6XG4gICAgY2FzZSAnZW50ZXJlZCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgICAgICBvcGFjaXR5OiAxO1xuICAgICAgYFxuICAgIGNhc2UgJ2V4aXRpbmcnOlxuICAgIGNhc2UgJ2V4aXRlZCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB2aXNpYmlsaXR5OiBoaWRkZW47XG4gICAgICAgIG9wYWNpdHk6IDA7XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAvLyBkbyBub3RoaW5nXG4gIH1cbn1cblxuY29uc3QgQmFja2Ryb3AgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgYmFja2dyb3VuZDogJHt0cmFuc3BhcmVudGl6ZSgncGV3dGVyJywgMC42KX07XG4gIHRyYW5zaXRpb246IGFsbCAwLjNzO1xuICB6LWluZGV4OiAxMDQ5O1xuXG4gICR7YW5pbWF0aW9uU3RhdGV9O1xuYFxuXG5CYWNrZHJvcC5kaXNwbGF5TmFtZSA9ICdNb2RhbC5CYWNrZHJvcCdcblxuZXhwb3J0IGRlZmF1bHQgQmFja2Ryb3BcbiJdfQ== */"));

Backdrop$1.displayName = 'Modal.Backdrop';

var Body$1 = createStyled("div", {
  target: "e2k4l6j0",
  label: "Body"
})("padding-left:", spacer(6), ";padding-right:", spacer(6), ";flex:1;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJvZHkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3VCIiwiZmlsZSI6IkJvZHkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgQm9keSA9IHN0eWxlZC5kaXZgXG4gIHBhZGRpbmctbGVmdDogJHtzcGFjZXIoNil9O1xuICBwYWRkaW5nLXJpZ2h0OiAke3NwYWNlcig2KX07XG4gIGZsZXg6IDE7XG5gXG5cbkJvZHkuZGlzcGxheU5hbWUgPSAnTW9kYWwuQm9keSdcblxuZXhwb3J0IGRlZmF1bHQgQm9keVxuIl19 */"));

Body$1.displayName = 'Modal.Body';

var _createContext = /*#__PURE__*/React.createContext(),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;

var CancelButton$1 = function CancelButton(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement(Consumer, null, function (_ref2) {
    var onClose = _ref2.onClose;
    return /*#__PURE__*/React__default['default'].createElement(Button, {
      kind: "ghost",
      type: "button",
      onClick: onClose
    }, children);
  });
};

CancelButton$1.defaultProps = {
  children: 'Cancel'
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$d =  true ? {
  name: "8l3sia",
  styles: "visiblity:visible;opacity:1;transform:scale(1);"
} : {
  name: "8l3sia",
  styles: "visiblity:visible;opacity:1;transform:scale(1);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPZ0IiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5jb25zdCBhbmltYXRpb25TdGF0ZSA9ICh7IGFuaW1hdGlvblN0YXRlIH0pID0+IHtcbiAgc3dpdGNoIChhbmltYXRpb25TdGF0ZSkge1xuICAgIGNhc2UgJ2VudGVyaW5nJzpcbiAgICBjYXNlICdlbnRlcmVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2libGl0eTogdmlzaWJsZTtcbiAgICAgICAgb3BhY2l0eTogMTtcbiAgICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxKTtcbiAgICAgIGBcbiAgICBjYXNlICdleGl0aW5nJzpcbiAgICBjYXNlICdleGl0ZWQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICAgICAgICBvcGFjaXR5OiAwO1xuICAgICAgICB0cmFuc2Zvcm06IHNjYWxlKDEuMTUpO1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICB6LWluZGV4OiAxMDUwO1xuICBvdmVyZmxvdy14OiBoaWRkZW47XG4gIG92ZXJmbG93LXk6IGF1dG87XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB0cmFuc2l0aW9uOiBhbGwgMC4zcztcblxuICAke2FuaW1hdGlvblN0YXRlfTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ01vZGFsLkNvbnRhaW5lcidcblxuZXhwb3J0IGRlZmF1bHQgQ29udGFpbmVyXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
};

var _ref2$7 =  true ? {
  name: "19mr2x1",
  styles: "visibility:hidden;opacity:0;transform:scale(1.15);"
} : {
  name: "19mr2x1",
  styles: "visibility:hidden;opacity:0;transform:scale(1.15);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjZ0IiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5jb25zdCBhbmltYXRpb25TdGF0ZSA9ICh7IGFuaW1hdGlvblN0YXRlIH0pID0+IHtcbiAgc3dpdGNoIChhbmltYXRpb25TdGF0ZSkge1xuICAgIGNhc2UgJ2VudGVyaW5nJzpcbiAgICBjYXNlICdlbnRlcmVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2libGl0eTogdmlzaWJsZTtcbiAgICAgICAgb3BhY2l0eTogMTtcbiAgICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxKTtcbiAgICAgIGBcbiAgICBjYXNlICdleGl0aW5nJzpcbiAgICBjYXNlICdleGl0ZWQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICAgICAgICBvcGFjaXR5OiAwO1xuICAgICAgICB0cmFuc2Zvcm06IHNjYWxlKDEuMTUpO1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICB6LWluZGV4OiAxMDUwO1xuICBvdmVyZmxvdy14OiBoaWRkZW47XG4gIG92ZXJmbG93LXk6IGF1dG87XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB0cmFuc2l0aW9uOiBhbGwgMC4zcztcblxuICAke2FuaW1hdGlvblN0YXRlfTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ01vZGFsLkNvbnRhaW5lcidcblxuZXhwb3J0IGRlZmF1bHQgQ29udGFpbmVyXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
};

var animationState$1 = function animationState(_ref3) {
  var animationState = _ref3.animationState;

  switch (animationState) {
    case 'entering':
    case 'entered':
      return _ref$d;

    case 'exiting':
    case 'exited':
      return _ref2$7;
  }
};

var Container$8 = createStyled("div", {
  target: "eeb19m80",
  label: "Container"
})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1050;overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center;transition:all 0.3s;", animationState$1, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQjRCIiwiZmlsZSI6IkNvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcblxuY29uc3QgYW5pbWF0aW9uU3RhdGUgPSAoeyBhbmltYXRpb25TdGF0ZSB9KSA9PiB7XG4gIHN3aXRjaCAoYW5pbWF0aW9uU3RhdGUpIHtcbiAgICBjYXNlICdlbnRlcmluZyc6XG4gICAgY2FzZSAnZW50ZXJlZCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB2aXNpYmxpdHk6IHZpc2libGU7XG4gICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICAgIHRyYW5zZm9ybTogc2NhbGUoMSk7XG4gICAgICBgXG4gICAgY2FzZSAnZXhpdGluZyc6XG4gICAgY2FzZSAnZXhpdGVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgb3BhY2l0eTogMDtcbiAgICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxLjE1KTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgei1pbmRleDogMTA1MDtcbiAgb3ZlcmZsb3cteDogaGlkZGVuO1xuICBvdmVyZmxvdy15OiBhdXRvO1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3M7XG5cbiAgJHthbmltYXRpb25TdGF0ZX07XG5gXG5cbkNvbnRhaW5lci5kaXNwbGF5TmFtZSA9ICdNb2RhbC5Db250YWluZXInXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */"));

Container$8.displayName = 'Modal.Container';

function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$e =  true ? {
  name: "v2kfba",
  styles: "height:100%;width:100%;"
} : {
  name: "v2kfba",
  styles: "height:100%;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT2dCIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnZnVsbHNjcmVlbic6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgYFxuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIG1hcmdpbi10b3A6ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgd2lkdGg6IDcyMHB4O1xuICAgICAgICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA0ODBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBraW5kID0gKHsga2luZCB9KSA9PlxuICBraW5kID09PSAnZ2hvc3QnICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xuICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgYm94LXNoYWRvdzogdW5zZXQ7XG4gIGBcblxuY29uc3QgQ29udGVudCA9IHN0eWxlZC5kaXZgXG4gIGJhY2tncm91bmQ6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBtYXgtd2lkdGg6IDEwMCU7XG5cbiAgJHtzaGFkb3coJ3JhaXNlZCcpfTtcbiAgJHtzaXplfTtcbiAgJHtraW5kfTtcbmBcblxuQ29udGVudC5kaXNwbGF5TmFtZSA9ICdNb2RhbC5Db250ZW50J1xuXG5leHBvcnQgZGVmYXVsdCBDb250ZW50XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
};

var size$a = function size(_ref3) {
  var size = _ref3.size,
      theme = _ref3.theme;

  switch (size) {
    case 'fullscreen':
      return _ref$e;

    case 'lg':
      return /*#__PURE__*/core.css("margin-top:", spacer(5, {
        theme: theme
      }), ";margin-bottom:", spacer(5, {
        theme: theme
      }), ";width:720px;", borderRadius('default', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWWdCIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnZnVsbHNjcmVlbic6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgYFxuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIG1hcmdpbi10b3A6ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgd2lkdGg6IDcyMHB4O1xuICAgICAgICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA0ODBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBraW5kID0gKHsga2luZCB9KSA9PlxuICBraW5kID09PSAnZ2hvc3QnICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xuICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgYm94LXNoYWRvdzogdW5zZXQ7XG4gIGBcblxuY29uc3QgQ29udGVudCA9IHN0eWxlZC5kaXZgXG4gIGJhY2tncm91bmQ6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBtYXgtd2lkdGg6IDEwMCU7XG5cbiAgJHtzaGFkb3coJ3JhaXNlZCcpfTtcbiAgJHtzaXplfTtcbiAgJHtraW5kfTtcbmBcblxuQ29udGVudC5kaXNwbGF5TmFtZSA9ICdNb2RhbC5Db250ZW50J1xuXG5leHBvcnQgZGVmYXVsdCBDb250ZW50XG4iXX0= */"));

    default:
      return /*#__PURE__*/core.css("margin-top:", spacer(5, {
        theme: theme
      }), ";margin-bottom:", spacer(5, {
        theme: theme
      }), ";width:480px;", borderRadius('default', {
        theme: theme
      }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJnQiIsImZpbGUiOiJDb250ZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgYm9yZGVyUmFkaXVzLCBjb2xvciwgc2hhZG93LCBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2Z1bGxzY3JlZW4nOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGBcbiAgICBjYXNlICdsZyc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA3MjBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgbWFyZ2luLXRvcDogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICB3aWR0aDogNDgwcHg7XG4gICAgICAgICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0JywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gIH1cbn1cblxuY29uc3Qga2luZCA9ICh7IGtpbmQgfSkgPT5cbiAga2luZCA9PT0gJ2dob3N0JyAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZDogbm9uZTtcbiAgICBib3JkZXItY29sb3I6IHRyYW5zcGFyZW50O1xuICAgIGJveC1zaGFkb3c6IHVuc2V0O1xuICBgXG5cbmNvbnN0IENvbnRlbnQgPSBzdHlsZWQuZGl2YFxuICBiYWNrZ3JvdW5kOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuXG4gICR7c2hhZG93KCdyYWlzZWQnKX07XG4gICR7c2l6ZX07XG4gICR7a2luZH07XG5gXG5cbkNvbnRlbnQuZGlzcGxheU5hbWUgPSAnTW9kYWwuQ29udGVudCdcblxuZXhwb3J0IGRlZmF1bHQgQ29udGVudFxuIl19 */"));
  }
};

var _ref2$8 =  true ? {
  name: "1uwx7m9",
  styles: "background:none;border-color:transparent;box-shadow:unset;"
} : {
  name: "1uwx7m9",
  styles: "background:none;border-color:transparent;box-shadow:unset;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBOEJLIiwiZmlsZSI6IkNvbnRlbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyBib3JkZXJSYWRpdXMsIGNvbG9yLCBzaGFkb3csIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgc2l6ZSA9ICh7IHNpemUsIHRoZW1lIH0pID0+IHtcbiAgc3dpdGNoIChzaXplKSB7XG4gICAgY2FzZSAnZnVsbHNjcmVlbic6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBoZWlnaHQ6IDEwMCU7XG4gICAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgYFxuICAgIGNhc2UgJ2xnJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIG1hcmdpbi10b3A6ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgd2lkdGg6IDcyMHB4O1xuICAgICAgICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcsIHsgdGhlbWUgfSl9O1xuICAgICAgYFxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA0ODBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBraW5kID0gKHsga2luZCB9KSA9PlxuICBraW5kID09PSAnZ2hvc3QnICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kOiBub25lO1xuICAgIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgYm94LXNoYWRvdzogdW5zZXQ7XG4gIGBcblxuY29uc3QgQ29udGVudCA9IHN0eWxlZC5kaXZgXG4gIGJhY2tncm91bmQ6ICR7Y29sb3IoJ3doaXRlJyl9O1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBtYXgtd2lkdGg6IDEwMCU7XG5cbiAgJHtzaGFkb3coJ3JhaXNlZCcpfTtcbiAgJHtzaXplfTtcbiAgJHtraW5kfTtcbmBcblxuQ29udGVudC5kaXNwbGF5TmFtZSA9ICdNb2RhbC5Db250ZW50J1xuXG5leHBvcnQgZGVmYXVsdCBDb250ZW50XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
};

var kind$5 = function kind(_ref4) {
  var kind = _ref4.kind;
  return kind === 'ghost' && _ref2$8;
};

var Content$2 = createStyled("div", {
  target: "e1kmc53z0",
  label: "Content"
})("background:", color('white'), ";display:flex;flex-direction:column;max-width:100%;", shadow('raised'), ";", size$a, ";", kind$5, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRlbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBb0MwQiIsImZpbGUiOiJDb250ZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgYm9yZGVyUmFkaXVzLCBjb2xvciwgc2hhZG93LCBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IHNpemUgPSAoeyBzaXplLCB0aGVtZSB9KSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ2Z1bGxzY3JlZW4nOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgaGVpZ2h0OiAxMDAlO1xuICAgICAgICB3aWR0aDogMTAwJTtcbiAgICAgIGBcbiAgICBjYXNlICdsZyc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBtYXJnaW4tdG9wOiAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIHdpZHRoOiA3MjBweDtcbiAgICAgICAgJHtib3JkZXJSYWRpdXMoJ2RlZmF1bHQnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgbWFyZ2luLXRvcDogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICAgICAgICB3aWR0aDogNDgwcHg7XG4gICAgICAgICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0JywgeyB0aGVtZSB9KX07XG4gICAgICBgXG4gIH1cbn1cblxuY29uc3Qga2luZCA9ICh7IGtpbmQgfSkgPT5cbiAga2luZCA9PT0gJ2dob3N0JyAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZDogbm9uZTtcbiAgICBib3JkZXItY29sb3I6IHRyYW5zcGFyZW50O1xuICAgIGJveC1zaGFkb3c6IHVuc2V0O1xuICBgXG5cbmNvbnN0IENvbnRlbnQgPSBzdHlsZWQuZGl2YFxuICBiYWNrZ3JvdW5kOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgbWF4LXdpZHRoOiAxMDAlO1xuXG4gICR7c2hhZG93KCdyYWlzZWQnKX07XG4gICR7c2l6ZX07XG4gICR7a2luZH07XG5gXG5cbkNvbnRlbnQuZGlzcGxheU5hbWUgPSAnTW9kYWwuQ29udGVudCdcblxuZXhwb3J0IGRlZmF1bHQgQ29udGVudFxuIl19 */"));

Content$2.displayName = 'Modal.Content';

var Footer$1 = createStyled("footer", {
  target: "e1vcz2id0",
  label: "Footer"
})("display:flex;justify-content:flex-end;", padding('md'), ";", Button, " + ", Button, "{margin-left:", spacer(2), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvb3Rlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJNEIiLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgQnV0dG9uIGZyb20gJy4uL0J1dHRvbidcbmltcG9ydCB7IHBhZGRpbmcsIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgRm9vdGVyID0gc3R5bGVkLmZvb3RlcmBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LWVuZDtcbiAgJHtwYWRkaW5nKCdtZCcpfTtcblxuICAke0J1dHRvbn0gKyAke0J1dHRvbn0ge1xuICAgIG1hcmdpbi1sZWZ0OiAke3NwYWNlcigyKX07XG4gIH1cbmBcblxuRm9vdGVyLmRpc3BsYXlOYW1lID0gJ01vZGFsLkZvb3RlcidcblxuZXhwb3J0IGRlZmF1bHQgRm9vdGVyXG4iXX0= */"));

Footer$1.displayName = 'Modal.Footer';

var Container$9 = createStyled("header", {
  target: "e145eatt0",
  label: "Container"
})("display:flex;justify-content:space-between;align-items:center;> h3:first-of-type{flex:1;margin-bottom:0;}", padding('md'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNK0IiLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IENsb3NlQnV0dG9uIGZyb20gJy4uL0Nsb3NlQnV0dG9uJ1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBDb25zdW1lciB9IGZyb20gJy4uLy4uL2NvbnRleHRzL01vZGFsJ1xuaW1wb3J0IHsgcGFkZGluZyB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmhlYWRlcmBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gID4gaDM6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgZmxleDogMTtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuICB9XG5cbiAgJHtwYWRkaW5nKCdtZCcpfTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ01vZGFsLkhlYWRlci5Db250YWluZXInXG5cbmNvbnN0IEhlYWRlciA9ICh7IGNoaWxkcmVuIH0pID0+IChcbiAgPENvbnN1bWVyPlxuICAgIHsoeyBkaXNtaXNzYWJsZSwgb25DbG9zZSB9KSA9PiAoXG4gICAgICA8Q29udGFpbmVyPlxuICAgICAgICB7Y2hpbGRyZW59XG4gICAgICAgIHtkaXNtaXNzYWJsZSAmJiA8Q2xvc2VCdXR0b24gb25DbGljaz17b25DbG9zZX0gLz59XG4gICAgICA8L0NvbnRhaW5lcj5cbiAgICApfVxuICA8L0NvbnN1bWVyPlxuKVxuXG5IZWFkZXIuZGlzcGxheU5hbWUgPSAnTW9kYWwuSGVhZGVyJ1xuXG5leHBvcnQgZGVmYXVsdCBIZWFkZXJcbiJdfQ== */"));

Container$9.displayName = 'Modal.Header.Container';

var Header$1 = function Header(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement(Consumer, null, function (_ref2) {
    var dismissable = _ref2.dismissable,
        onClose = _ref2.onClose;
    return /*#__PURE__*/React__default['default'].createElement(Container$9, null, children, dismissable && /*#__PURE__*/React__default['default'].createElement(CloseButton, {
      onClick: onClose
    }));
  });
};

Header$1.displayName = 'Modal.Header';

var Title$2 = function Title(props) {
  return /*#__PURE__*/React__default['default'].createElement("h3", props);
};

Title$2.displayName = 'Modal.Title';

var ESC = 27;

function _EMOTION_STRINGIFIED_CSS_ERROR__$t() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var blurBodyStyle =  true ? {
  name: "mzeehs-blurBodyStyle",
  styles: "body > *:not(#modal-root){filter:blur(3px);};label:blurBodyStyle;"
} : {
  name: "mzeehs-blurBodyStyle",
  styles: "body > *:not(#modal-root){filter:blur(3px);};label:blurBodyStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$t
};

var Modal = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this);

    _defineProperty$1(_assertThisInitialized(_this), "container", document.createElement('div'));

    _defineProperty$1(_assertThisInitialized(_this), "modalRoot", document.getElementById('modal-root'));

    _defineProperty$1(_assertThisInitialized(_this), "freezeScrolling", function () {
      _this.initialBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    });

    _defineProperty$1(_assertThisInitialized(_this), "resetScrolling", function () {
      document.body.style.overflow = _this.initialBodyOverflow;
    });

    _defineProperty$1(_assertThisInitialized(_this), "listenForKeydown", function () {
      var _this$props = _this.props,
          dismissable = _this$props.dismissable,
          open = _this$props.open;
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleKeydown", function (e) {
      var _this$props2 = _this.props,
          dismissable = _this$props2.dismissable,
          open = _this$props2.open,
          onClose = _this$props2.onClose;

      if (!dismissable || !open) {
        return;
      }

      switch (e.keyCode) {
        case ESC:
          onClose();

      }
    });

    if (false) {
      warning__default['default'](false, '`Modal` is deprecated. Prefer `ModalV2` for new modals.');
      invariant__default['default'](_this.modalRoot, 'This app does not contain a modal root. Follow the steps at ' + 'https://invent.focusvision.com/Portland/stylist#portal-roots to add one ' + 'to your app.');
    }

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.modalRoot.appendChild(this.container);
      document.addEventListener('keydown', this.handleKeydown);

      if (this.props.open) {
        this.freezeScrolling();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevOpen = _ref.open;
      var open = this.props.open;

      if (!prevOpen && open) {
        this.freezeScrolling();
      }

      if (prevOpen && !open) {
        this.resetScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.modalRoot.removeChild(this.container);
      this.resetScrolling();
      document.removeEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          dismissable = _this$props3.dismissable,
          children = _this$props3.children,
          onClose = _this$props3.onClose,
          open = _this$props3.open,
          size = _this$props3.size,
          kind = _this$props3.kind,
          blurBackground = _this$props3.blurBackground;
      return /*#__PURE__*/reactDom.createPortal( /*#__PURE__*/React__default['default'].createElement(Provider, {
        value: {
          dismissable: dismissable,
          onClose: onClose
        }
      }, /*#__PURE__*/React__default['default'].createElement(Transition__default['default'], {
        "in": open,
        timeout: 300
      }, function (state) {
        return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, open && blurBackground && /*#__PURE__*/React__default['default'].createElement(core.Global, {
          styles: blurBodyStyle
        }), /*#__PURE__*/React__default['default'].createElement(Backdrop$1, {
          animationState: state
        }), /*#__PURE__*/React__default['default'].createElement(Container$8, {
          animationState: state,
          onClick: dismissable ? onClose : null
        }, /*#__PURE__*/React__default['default'].createElement(Content$2, {
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          size: size,
          kind: kind
        }, children)));
      })), this.container);
    }
  }]);

  return Modal;
}(React.Component);

_defineProperty$1(Modal, "Body", Body$1);

_defineProperty$1(Modal, "CancelButton", CancelButton$1);

_defineProperty$1(Modal, "Footer", Footer$1);

_defineProperty$1(Modal, "Header", Header$1);

_defineProperty$1(Modal, "Title", Title$2);

_defineProperty$1(Modal, "propTypes", {
  dismissable: PropTypes__default['default'].bool.isRequired,
  onClose: PropTypes__default['default'].func.isRequired,
  open: PropTypes__default['default'].bool.isRequired,
  size: PropTypes__default['default'].oneOf(['lg', 'fullscreen'])
});

_defineProperty$1(Modal, "defaultProps", {
  dismissable: true
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$u() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$f =  true ? {
  name: "r2ff5g",
  styles: "visibility:visible;opacity:1;"
} : {
  name: "r2ff5g",
  styles: "visibility:visible;opacity:1;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFnQiIsImZpbGUiOiJCYWNrZHJvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBhbmltYXRpb25TdGF0ZSA9ICh7IGFuaW1hdGlvblN0YXRlIH0pID0+IHtcbiAgc3dpdGNoIChhbmltYXRpb25TdGF0ZSkge1xuICAgIGNhc2UgJ2VudGVyaW5nJzpcbiAgICBjYXNlICdlbnRlcmVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IHZpc2libGU7XG4gICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICBgXG4gICAgY2FzZSAnZXhpdGluZyc6XG4gICAgY2FzZSAnZXhpdGVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgb3BhY2l0eTogMDtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgIC8vIGRvIG5vdGhpbmdcbiAgfVxufVxuXG5jb25zdCBCYWNrZHJvcCA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICBiYWNrZ3JvdW5kOiAke3RyYW5zcGFyZW50aXplKCdwZXd0ZXInLCAwLjYpfTtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3M7XG4gIHotaW5kZXg6IDEwNDk7XG5cbiAgJHthbmltYXRpb25TdGF0ZX07XG5gXG5cbkJhY2tkcm9wLmRpc3BsYXlOYW1lID0gJ01vZGFsLkJhY2tkcm9wJ1xuXG5leHBvcnQgZGVmYXVsdCBCYWNrZHJvcFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
};

var _ref2$9 =  true ? {
  name: "ge94et",
  styles: "visibility:hidden;opacity:0;"
} : {
  name: "ge94et",
  styles: "visibility:hidden;opacity:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNnQiIsImZpbGUiOiJCYWNrZHJvcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHRyYW5zcGFyZW50aXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBhbmltYXRpb25TdGF0ZSA9ICh7IGFuaW1hdGlvblN0YXRlIH0pID0+IHtcbiAgc3dpdGNoIChhbmltYXRpb25TdGF0ZSkge1xuICAgIGNhc2UgJ2VudGVyaW5nJzpcbiAgICBjYXNlICdlbnRlcmVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IHZpc2libGU7XG4gICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICBgXG4gICAgY2FzZSAnZXhpdGluZyc6XG4gICAgY2FzZSAnZXhpdGVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgb3BhY2l0eTogMDtcbiAgICAgIGBcbiAgICBkZWZhdWx0OlxuICAgIC8vIGRvIG5vdGhpbmdcbiAgfVxufVxuXG5jb25zdCBCYWNrZHJvcCA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICBiYWNrZ3JvdW5kOiAke3RyYW5zcGFyZW50aXplKCdwZXd0ZXInLCAwLjYpfTtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3M7XG4gIHotaW5kZXg6IDEwNDk7XG5cbiAgJHthbmltYXRpb25TdGF0ZX07XG5gXG5cbkJhY2tkcm9wLmRpc3BsYXlOYW1lID0gJ01vZGFsLkJhY2tkcm9wJ1xuXG5leHBvcnQgZGVmYXVsdCBCYWNrZHJvcFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$u
};

var animationState$2 = function animationState(_ref3) {
  var animationState = _ref3.animationState;

  switch (animationState) {
    case 'entering':
    case 'entered':
      return _ref$f;

    case 'exiting':
    case 'exited':
      return _ref2$9;

  }
};

var Backdrop$2 = createStyled("div", {
  target: "e1l9lze30",
  label: "Backdrop"
})("position:fixed;top:0;left:0;right:0;bottom:0;background:", transparentize('pewter', 0.6), ";transition:all 0.3s;z-index:1049;", animationState$2, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhY2tkcm9wLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVCMkIiLCJmaWxlIjoiQmFja2Ryb3AuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgeyB0cmFuc3BhcmVudGl6ZSB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgYW5pbWF0aW9uU3RhdGUgPSAoeyBhbmltYXRpb25TdGF0ZSB9KSA9PiB7XG4gIHN3aXRjaCAoYW5pbWF0aW9uU3RhdGUpIHtcbiAgICBjYXNlICdlbnRlcmluZyc6XG4gICAgY2FzZSAnZW50ZXJlZCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB2aXNpYmlsaXR5OiB2aXNpYmxlO1xuICAgICAgICBvcGFjaXR5OiAxO1xuICAgICAgYFxuICAgIGNhc2UgJ2V4aXRpbmcnOlxuICAgIGNhc2UgJ2V4aXRlZCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB2aXNpYmlsaXR5OiBoaWRkZW47XG4gICAgICAgIG9wYWNpdHk6IDA7XG4gICAgICBgXG4gICAgZGVmYXVsdDpcbiAgICAvLyBkbyBub3RoaW5nXG4gIH1cbn1cblxuY29uc3QgQmFja2Ryb3AgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgYmFja2dyb3VuZDogJHt0cmFuc3BhcmVudGl6ZSgncGV3dGVyJywgMC42KX07XG4gIHRyYW5zaXRpb246IGFsbCAwLjNzO1xuICB6LWluZGV4OiAxMDQ5O1xuXG4gICR7YW5pbWF0aW9uU3RhdGV9O1xuYFxuXG5CYWNrZHJvcC5kaXNwbGF5TmFtZSA9ICdNb2RhbC5CYWNrZHJvcCdcblxuZXhwb3J0IGRlZmF1bHQgQmFja2Ryb3BcbiJdfQ== */"));

Backdrop$2.displayName = 'Modal.Backdrop';

function _EMOTION_STRINGIFIED_CSS_ERROR__$v() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$g =  true ? {
  name: "8l3sia",
  styles: "visiblity:visible;opacity:1;transform:scale(1);"
} : {
  name: "8l3sia",
  styles: "visiblity:visible;opacity:1;transform:scale(1);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPZ0IiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5jb25zdCBhbmltYXRpb25TdGF0ZSA9ICh7IGFuaW1hdGlvblN0YXRlIH0pID0+IHtcbiAgc3dpdGNoIChhbmltYXRpb25TdGF0ZSkge1xuICAgIGNhc2UgJ2VudGVyaW5nJzpcbiAgICBjYXNlICdlbnRlcmVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2libGl0eTogdmlzaWJsZTtcbiAgICAgICAgb3BhY2l0eTogMTtcbiAgICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxKTtcbiAgICAgIGBcbiAgICBjYXNlICdleGl0aW5nJzpcbiAgICBjYXNlICdleGl0ZWQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICAgICAgICBvcGFjaXR5OiAwO1xuICAgICAgICB0cmFuc2Zvcm06IHNjYWxlKDEuMTUpO1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICB6LWluZGV4OiAxMDUwO1xuICBvdmVyZmxvdy14OiBoaWRkZW47XG4gIG92ZXJmbG93LXk6IGF1dG87XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB0cmFuc2l0aW9uOiBhbGwgMC4zcztcblxuICAke2FuaW1hdGlvblN0YXRlfTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ01vZGFsLkNvbnRhaW5lcidcblxuZXhwb3J0IGRlZmF1bHQgQ29udGFpbmVyXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
};

var _ref2$a =  true ? {
  name: "19mr2x1",
  styles: "visibility:hidden;opacity:0;transform:scale(1.15);"
} : {
  name: "19mr2x1",
  styles: "visibility:hidden;opacity:0;transform:scale(1.15);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjZ0IiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5jb25zdCBhbmltYXRpb25TdGF0ZSA9ICh7IGFuaW1hdGlvblN0YXRlIH0pID0+IHtcbiAgc3dpdGNoIChhbmltYXRpb25TdGF0ZSkge1xuICAgIGNhc2UgJ2VudGVyaW5nJzpcbiAgICBjYXNlICdlbnRlcmVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2libGl0eTogdmlzaWJsZTtcbiAgICAgICAgb3BhY2l0eTogMTtcbiAgICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxKTtcbiAgICAgIGBcbiAgICBjYXNlICdleGl0aW5nJzpcbiAgICBjYXNlICdleGl0ZWQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdmlzaWJpbGl0eTogaGlkZGVuO1xuICAgICAgICBvcGFjaXR5OiAwO1xuICAgICAgICB0cmFuc2Zvcm06IHNjYWxlKDEuMTUpO1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbiAgYm90dG9tOiAwO1xuICB6LWluZGV4OiAxMDUwO1xuICBvdmVyZmxvdy14OiBoaWRkZW47XG4gIG92ZXJmbG93LXk6IGF1dG87XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB0cmFuc2l0aW9uOiBhbGwgMC4zcztcblxuICAke2FuaW1hdGlvblN0YXRlfTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ01vZGFsLkNvbnRhaW5lcidcblxuZXhwb3J0IGRlZmF1bHQgQ29udGFpbmVyXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$v
};

var animationState$3 = function animationState(_ref3) {
  var animationState = _ref3.animationState;

  switch (animationState) {
    case 'entering':
    case 'entered':
      return _ref$g;

    case 'exiting':
    case 'exited':
      return _ref2$a;
  }
};

var Container$a = createStyled("div", {
  target: "enuadwn0",
  label: "Container"
})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1050;overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center;transition:all 0.3s;", animationState$3, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFzQjRCIiwiZmlsZSI6IkNvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcblxuY29uc3QgYW5pbWF0aW9uU3RhdGUgPSAoeyBhbmltYXRpb25TdGF0ZSB9KSA9PiB7XG4gIHN3aXRjaCAoYW5pbWF0aW9uU3RhdGUpIHtcbiAgICBjYXNlICdlbnRlcmluZyc6XG4gICAgY2FzZSAnZW50ZXJlZCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB2aXNpYmxpdHk6IHZpc2libGU7XG4gICAgICAgIG9wYWNpdHk6IDE7XG4gICAgICAgIHRyYW5zZm9ybTogc2NhbGUoMSk7XG4gICAgICBgXG4gICAgY2FzZSAnZXhpdGluZyc6XG4gICAgY2FzZSAnZXhpdGVkJzpcbiAgICAgIHJldHVybiBjc3NgXG4gICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgICAgb3BhY2l0eTogMDtcbiAgICAgICAgdHJhbnNmb3JtOiBzY2FsZSgxLjE1KTtcbiAgICAgIGBcbiAgfVxufVxuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcbiAgcmlnaHQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgei1pbmRleDogMTA1MDtcbiAgb3ZlcmZsb3cteDogaGlkZGVuO1xuICBvdmVyZmxvdy15OiBhdXRvO1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3M7XG5cbiAgJHthbmltYXRpb25TdGF0ZX07XG5gXG5cbkNvbnRhaW5lci5kaXNwbGF5TmFtZSA9ICdNb2RhbC5Db250YWluZXInXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */"));

Container$a.displayName = 'Modal.Container';

var noop = (function () {});

function _EMOTION_STRINGIFIED_CSS_ERROR__$w() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var blurBodyStyle$1 =  true ? {
  name: "mzeehs-blurBodyStyle",
  styles: "body > *:not(#modal-root){filter:blur(3px);};label:blurBodyStyle;"
} : {
  name: "mzeehs-blurBodyStyle",
  styles: "body > *:not(#modal-root){filter:blur(3px);};label:blurBodyStyle;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVd5QiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDb21wb25lbnQsIEZyYWdtZW50LCBjcmVhdGVDb250ZXh0IH0gZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBHbG9iYWwsIGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQgQmFja2Ryb3AgZnJvbSAnLi9CYWNrZHJvcCdcbmltcG9ydCBDb250YWluZXIgZnJvbSAnLi9Db250YWluZXInXG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnXG5pbXBvcnQgVHJhbnNpdGlvbiBmcm9tICdyZWFjdC10cmFuc2l0aW9uLWdyb3VwL1RyYW5zaXRpb24nXG5pbXBvcnQgaW52YXJpYW50IGZyb20gJ2ludmFyaWFudCdcbmltcG9ydCB7IGNyZWF0ZVBvcnRhbCB9IGZyb20gJ3JlYWN0LWRvbSdcbmltcG9ydCB7IEVTQyB9IGZyb20gJy4uLy4uL3V0aWxzL2tleUNvZGVzJ1xuaW1wb3J0IG5vb3AgZnJvbSAnLi4vLi4vdXRpbHMvbm9vcCdcblxuY29uc3QgYmx1ckJvZHlTdHlsZSA9IGNzc2BcbiAgYm9keSA+ICo6bm90KCNtb2RhbC1yb290KSB7XG4gICAgZmlsdGVyOiBibHVyKDNweCk7XG4gIH1cbmBcblxuY2xhc3MgTW9kYWwgZXh0ZW5kcyBDb21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIGRpc21pc3NhYmxlOiBQcm9wVHlwZXMuYm9vbC5pc1JlcXVpcmVkLFxuICAgIG9uRGlzbWlzczogUHJvcFR5cGVzLmZ1bmNcbiAgfVxuXG4gIHN0YXRpYyBkZWZhdWx0UHJvcHMgPSB7XG4gICAgZGlzbWlzc2FibGU6IHRydWUsXG4gICAgb25EaXNtaXNzOiBub29wXG4gIH1cblxuICBzdGF0ZSA9IHsgb3BlbjogZmFsc2UsIHRyYW5zaXRpb25pbmc6IGZhbHNlIH1cblxuICBzaG93ID0gKCkgPT4gdGhpcy5zZXRTdGF0ZSh7IG9wZW46IHRydWUgfSlcbiAgaGlkZSA9ICgpID0+IHRoaXMuc2V0U3RhdGUoeyBvcGVuOiBmYWxzZSB9KVxuICBzZXRUcmFuc2l0aW9uaW5nID0gdHJhbnNpdGlvbmluZyA9PiB0aGlzLnNldFN0YXRlKHsgdHJhbnNpdGlvbmluZyB9KVxuXG4gIGNvbnRhaW5lciA9IGRvY3VtZW50LmNyZWF0ZUVsZW1lbnQoJ2RpdicpXG4gIG1vZGFsUm9vdCA9IGRvY3VtZW50LmdldEVsZW1lbnRCeUlkKCdtb2RhbC1yb290JylcblxuICBjb25zdHJ1Y3RvcigpIHtcbiAgICBzdXBlcigpXG5cbiAgICBpZiAocHJvY2Vzcy5lbnYuTk9ERV9FTlYgIT09ICdwcm9kdWN0aW9uJykge1xuICAgICAgaW52YXJpYW50KFxuICAgICAgICB0aGlzLm1vZGFsUm9vdCxcbiAgICAgICAgJ1RoaXMgYXBwIGRvZXMgbm90IGNvbnRhaW4gYSBtb2RhbCByb290LiBGb2xsb3cgdGhlIHN0ZXBzIGF0ICcgK1xuICAgICAgICAgICdodHRwczovL2ludmVudC5mb2N1c3Zpc2lvbi5jb20vUG9ydGxhbmQvc3R5bGlzdCNwb3J0YWwtcm9vdHMgdG8gYWRkIG9uZSAnICtcbiAgICAgICAgICAndG8geW91ciBhcHAuJ1xuICAgICAgKVxuICAgIH1cbiAgfVxuXG4gIGNvbXBvbmVudERpZE1vdW50KCkge1xuICAgIHRoaXMubW9kYWxSb290LmFwcGVuZENoaWxkKHRoaXMuY29udGFpbmVyKVxuXG4gICAgZG9jdW1lbnQuYWRkRXZlbnRMaXN0ZW5lcigna2V5ZG93bicsIHRoaXMuaGFuZGxlS2V5ZG93bilcblxuICAgIGlmICh0aGlzLnByb3BzLm9wZW4pIHtcbiAgICAgIHRoaXMuZnJlZXplU2Nyb2xsaW5nKClcbiAgICB9XG4gIH1cblxuICBjb21wb25lbnREaWRVcGRhdGUoX3ByZXZQcm9wcywgeyBvcGVuOiBwcmV2T3BlbiB9KSB7XG4gICAgY29uc3QgeyBvcGVuIH0gPSB0aGlzLnN0YXRlXG5cbiAgICBpZiAoIXByZXZPcGVuICYmIG9wZW4pIHtcbiAgICAgIHRoaXMuZnJlZXplU2Nyb2xsaW5nKClcbiAgICB9XG5cbiAgICBpZiAocHJldk9wZW4gJiYgIW9wZW4pIHtcbiAgICAgIHRoaXMucmVzZXRTY3JvbGxpbmcoKVxuICAgIH1cbiAgfVxuXG4gIGNvbXBvbmVudFdpbGxVbm1vdW50KCkge1xuICAgIHRoaXMubW9kYWxSb290LnJlbW92ZUNoaWxkKHRoaXMuY29udGFpbmVyKVxuICAgIHRoaXMucmVzZXRTY3JvbGxpbmcoKVxuXG4gICAgZG9jdW1lbnQucmVtb3ZlRXZlbnRMaXN0ZW5lcigna2V5ZG93bicsIHRoaXMuaGFuZGxlS2V5ZG93bilcbiAgfVxuXG4gIGZyZWV6ZVNjcm9sbGluZyA9ICgpID0+IHtcbiAgICB0aGlzLmluaXRpYWxCb2R5T3ZlcmZsb3cgPSBkb2N1bWVudC5ib2R5LnN0eWxlLm92ZXJmbG93XG4gICAgZG9jdW1lbnQuYm9keS5zdHlsZS5vdmVyZmxvdyA9ICdoaWRkZW4nXG4gIH1cblxuICByZXNldFNjcm9sbGluZyA9ICgpID0+IHtcbiAgICBkb2N1bWVudC5ib2R5LnN0eWxlLm92ZXJmbG93ID0gdGhpcy5pbml0aWFsQm9keU92ZXJmbG93XG4gIH1cblxuICBoYW5kbGVLZXlkb3duID0gZSA9PiB7XG4gICAgY29uc3QgeyBkaXNtaXNzYWJsZSB9ID0gdGhpcy5wcm9wc1xuICAgIGNvbnN0IHsgb3BlbiB9ID0gdGhpcy5zdGF0ZVxuXG4gICAgaWYgKCFkaXNtaXNzYWJsZSB8fCAhb3Blbikge1xuICAgICAgcmV0dXJuXG4gICAgfVxuXG4gICAgc3dpdGNoIChlLmtleUNvZGUpIHtcbiAgICAgIGNhc2UgRVNDOlxuICAgICAgICB0aGlzLmhpZGUoKVxuICAgICAgICB0aGlzLnByb3BzLm9uRGlzbWlzcyAmJiB0aGlzLnByb3BzLm9uRGlzbWlzcygpXG4gICAgICBkZWZhdWx0OlxuICAgICAgLy8gZG8gbm90aGluZ1xuICAgIH1cbiAgfVxuXG4gIHJlbmRlclBvcnRhbCgpIHtcbiAgICBjb25zdCB7IGRpc21pc3NhYmxlLCByZW5kZXIsIGxhenlSZW5kZXIsIGJsdXJCYWNrZ3JvdW5kIH0gPSB0aGlzLnByb3BzXG4gICAgY29uc3QgeyBvcGVuLCB0cmFuc2l0aW9uaW5nIH0gPSB0aGlzLnN0YXRlXG4gICAgY29uc3Qgc2hvdWxkUmVuZGVyID0gIWxhenlSZW5kZXIgfHwgb3BlbiB8fCB0cmFuc2l0aW9uaW5nXG5cbiAgICByZXR1cm4gY3JlYXRlUG9ydGFsKFxuICAgICAgPFRyYW5zaXRpb25cbiAgICAgICAgaW49e29wZW59XG4gICAgICAgIHRpbWVvdXQ9ezMwMH1cbiAgICAgICAgb25FbnRlcj17KCkgPT4gdGhpcy5zZXRUcmFuc2l0aW9uaW5nKHRydWUpfVxuICAgICAgICBvbkV4aXRlZD17KCkgPT4gdGhpcy5zZXRUcmFuc2l0aW9uaW5nKGZhbHNlKX1cbiAgICAgID5cbiAgICAgICAge3N0YXRlID0+IChcbiAgICAgICAgICA8RnJhZ21lbnQ+XG4gICAgICAgICAgICB7b3BlbiAmJiBibHVyQmFja2dyb3VuZCAmJiA8R2xvYmFsIHN0eWxlcz17Ymx1ckJvZHlTdHlsZX0gLz59XG4gICAgICAgICAgICA8QmFja2Ryb3AgYW5pbWF0aW9uU3RhdGU9e3N0YXRlfSAvPlxuICAgICAgICAgICAgPENvbnRhaW5lclxuICAgICAgICAgICAgICBhbmltYXRpb25TdGF0ZT17c3RhdGV9XG4gICAgICAgICAgICAgIG9uQ2xpY2s9e1xuICAgICAgICAgICAgICAgIGRpc21pc3NhYmxlXG4gICAgICAgICAgICAgICAgICA/ICgpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgICB0aGlzLmhpZGUoKVxuICAgICAgICAgICAgICAgICAgICAgIHRoaXMucHJvcHMub25EaXNtaXNzICYmIHRoaXMucHJvcHMub25EaXNtaXNzKClcbiAgICAgICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAgICAgOiBudWxsXG4gICAgICAgICAgICAgIH1cbiAgICAgICAgICAgID5cbiAgICAgICAgICAgICAge3Nob3VsZFJlbmRlciAmJiByZW5kZXIoeyBoaWRlOiB0aGlzLmhpZGUgfSl9XG4gICAgICAgICAgICA8L0NvbnRhaW5lcj5cbiAgICAgICAgICA8L0ZyYWdtZW50PlxuICAgICAgICApfVxuICAgICAgPC9UcmFuc2l0aW9uPixcbiAgICAgIHRoaXMuY29udGFpbmVyXG4gICAgKVxuICB9XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgY2hpbGRyZW4gfSA9IHRoaXMucHJvcHNcbiAgICBjb25zdCB7IG9wZW4gfSA9IHRoaXMuc3RhdGVcblxuICAgIHJldHVybiAoXG4gICAgICA8RnJhZ21lbnQ+XG4gICAgICAgIHt0aGlzLnJlbmRlclBvcnRhbCgpfVxuICAgICAgICB7Y2hpbGRyZW4oeyBzaG93OiB0aGlzLnNob3csIG9wZW4gfSl9XG4gICAgICA8L0ZyYWdtZW50PlxuICAgIClcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBNb2RhbFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$w
};

var Modal$1 = /*#__PURE__*/function (_Component) {
  _inherits(Modal, _Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this);

    _defineProperty$1(_assertThisInitialized(_this), "state", {
      open: false,
      transitioning: false
    });

    _defineProperty$1(_assertThisInitialized(_this), "show", function () {
      return _this.setState({
        open: true
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "hide", function () {
      return _this.setState({
        open: false
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "setTransitioning", function (transitioning) {
      return _this.setState({
        transitioning: transitioning
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "container", document.createElement('div'));

    _defineProperty$1(_assertThisInitialized(_this), "modalRoot", document.getElementById('modal-root'));

    _defineProperty$1(_assertThisInitialized(_this), "freezeScrolling", function () {
      _this.initialBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    });

    _defineProperty$1(_assertThisInitialized(_this), "resetScrolling", function () {
      document.body.style.overflow = _this.initialBodyOverflow;
    });

    _defineProperty$1(_assertThisInitialized(_this), "handleKeydown", function (e) {
      var dismissable = _this.props.dismissable;
      var open = _this.state.open;

      if (!dismissable || !open) {
        return;
      }

      switch (e.keyCode) {
        case ESC:
          _this.hide();

          _this.props.onDismiss && _this.props.onDismiss();

      }
    });

    if (false) {
      invariant__default['default'](_this.modalRoot, 'This app does not contain a modal root. Follow the steps at ' + 'https://invent.focusvision.com/Portland/stylist#portal-roots to add one ' + 'to your app.');
    }

    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.modalRoot.appendChild(this.container);
      document.addEventListener('keydown', this.handleKeydown);

      if (this.props.open) {
        this.freezeScrolling();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, _ref) {
      var prevOpen = _ref.open;
      var open = this.state.open;

      if (!prevOpen && open) {
        this.freezeScrolling();
      }

      if (prevOpen && !open) {
        this.resetScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.modalRoot.removeChild(this.container);
      this.resetScrolling();
      document.removeEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: "renderPortal",
    value: function renderPortal() {
      var _this2 = this;

      var _this$props = this.props,
          dismissable = _this$props.dismissable,
          render = _this$props.render,
          lazyRender = _this$props.lazyRender,
          blurBackground = _this$props.blurBackground;
      var _this$state = this.state,
          open = _this$state.open,
          transitioning = _this$state.transitioning;
      var shouldRender = !lazyRender || open || transitioning;
      return /*#__PURE__*/reactDom.createPortal( /*#__PURE__*/React__default['default'].createElement(Transition__default['default'], {
        "in": open,
        timeout: 300,
        onEnter: function onEnter() {
          return _this2.setTransitioning(true);
        },
        onExited: function onExited() {
          return _this2.setTransitioning(false);
        }
      }, function (state) {
        return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, open && blurBackground && /*#__PURE__*/React__default['default'].createElement(core.Global, {
          styles: blurBodyStyle$1
        }), /*#__PURE__*/React__default['default'].createElement(Backdrop$2, {
          animationState: state
        }), /*#__PURE__*/React__default['default'].createElement(Container$a, {
          animationState: state,
          onClick: dismissable ? function () {
            _this2.hide();

            _this2.props.onDismiss && _this2.props.onDismiss();
          } : null
        }, shouldRender && render({
          hide: _this2.hide
        })));
      }), this.container);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var open = this.state.open;
      return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, this.renderPortal(), children({
        show: this.show,
        open: open
      }));
    }
  }]);

  return Modal;
}(React.Component);

_defineProperty$1(Modal$1, "propTypes", {
  dismissable: PropTypes__default['default'].bool.isRequired,
  onDismiss: PropTypes__default['default'].func
});

_defineProperty$1(Modal$1, "defaultProps", {
  dismissable: true,
  onDismiss: noop
});

var Container$b = createStyled("div", {
  target: "eamnbua0",
  label: "Container"
})("position:fixed;z-index:1200;display:flex;flex-direction:column-reverse;flex-flow:column-reverse;top:", spacer(4), ";right:", spacer(5), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgei1pbmRleDogMTIwMDtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbi1yZXZlcnNlO1xuICBmbGV4LWZsb3c6IGNvbHVtbi1yZXZlcnNlO1xuXG4gIHRvcDogJHtzcGFjZXIoNCl9O1xuICByaWdodDogJHtzcGFjZXIoNSl9O1xuYFxuXG5Db250YWluZXIuZGlzcGxheU5hbWUgPSAnTm90aWZpY2F0aW9ucy5Db250YWluZXInXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */"));

Container$b.displayName = 'Notifications.Container';

var Close = /*#__PURE__*/createStyled(CloseButton, {
  target: "e1hnkbds0",
  label: "Close"
})("margin-left:", spacer(2), ";margin-right:", spacer(2), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNsb3NlQnV0dG9uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlpQyIsImZpbGUiOiJDbG9zZUJ1dHRvbi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IENsb3NlQnV0dG9uIGZyb20gJy4uLy4uL0Nsb3NlQnV0dG9uJ1xuaW1wb3J0IHsgc3BhY2VyIH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBDbG9zZSA9IHN0eWxlZChDbG9zZUJ1dHRvbilgXG4gIG1hcmdpbi1sZWZ0OiAke3NwYWNlcigyKX07XG4gIG1hcmdpbi1yaWdodDogJHtzcGFjZXIoMil9O1xuYFxuXG5DbG9zZS5kaXNwbGF5TmFtZSA9ICdOb3RpZmljYXRpb24uQ2xvc2VCdXR0b24nXG5cbmV4cG9ydCBkZWZhdWx0IENsb3NlXG4iXX0= */"));

Close.displayName = 'Notification.CloseButton';

var Container$c = createStyled("div", {
  target: "e464qrf0",
  label: "Container"
})("color:", color('black'), ";background:", color('white'), ";width:375px;display:flex;align-items:center;overflow:hidden;", borderRadius('default'), ";", shadow('raised'), ";", typography('body2'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjb2xvciwgYm9yZGVyUmFkaXVzLCBzaGFkb3csIHR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi8uLi9zdHlsZXMnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGNvbG9yOiAke2NvbG9yKCdibGFjaycpfTtcbiAgYmFja2dyb3VuZDogJHtjb2xvcignd2hpdGUnKX07XG4gIHdpZHRoOiAzNzVweDtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgb3ZlcmZsb3c6IGhpZGRlbjtcblxuICAke2JvcmRlclJhZGl1cygnZGVmYXVsdCcpfTtcbiAgJHtzaGFkb3coJ3JhaXNlZCcpfTtcbiAgJHt0eXBvZ3JhcGh5KCdib2R5MicpfTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ05vdGlmaWNhdGlvbi5Db250YWluZXInXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */"));

Container$c.displayName = 'Notification.Container';

var ICON_SIZE = '1.75rem';
var PADDING_SIZE = 'xs';

var IconContainer = createStyled("div", {
  target: "eice3zl0",
  label: "IconContainer"
})(padding(PADDING_SIZE), ";padding-right:0;svg{vertical-align:middle;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb25Db250YWluZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSWdDIiwiZmlsZSI6Ikljb25Db250YWluZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IHBhZGRpbmcgfSBmcm9tICcuLi8uLi8uLi9zdHlsZXMnXG5pbXBvcnQgeyBQQURESU5HX1NJWkUgfSBmcm9tICcuL2NvbnN0YW50cydcblxuY29uc3QgSWNvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gICR7cGFkZGluZyhQQURESU5HX1NJWkUpfTtcblxuICBwYWRkaW5nLXJpZ2h0OiAwO1xuXG4gIHN2ZyB7XG4gICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgfVxuYFxuXG5JY29uQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ05vdGlmaWNhdGlvbi5JY29uQ29udGFpbmVyJ1xuXG5leHBvcnQgZGVmYXVsdCBJY29uQ29udGFpbmVyXG4iXX0= */"));

IconContainer.displayName = 'Notification.IconContainer';

var Icon$2 = function Icon(_ref) {
  var kind = _ref.kind,
      renderIcon = _ref.renderIcon;
  var props = {
    width: ICON_SIZE,
    height: ICON_SIZE
  };

  if (typeof renderIcon === 'function') {
    return /*#__PURE__*/React__default['default'].createElement(IconContainer, null, renderIcon(props));
  }

  switch (kind) {
    case 'success':
      return /*#__PURE__*/React__default['default'].createElement(IconContainer, null, /*#__PURE__*/React__default['default'].createElement(CheckCircle, _extends({}, props, {
        color: "brandGreen"
      })));

    case 'warning':
      return /*#__PURE__*/React__default['default'].createElement(IconContainer, null, /*#__PURE__*/React__default['default'].createElement(AlertTriangle, _extends({}, props, {
        color: "orange"
      })));

    case 'info':
      return /*#__PURE__*/React__default['default'].createElement(IconContainer, null, /*#__PURE__*/React__default['default'].createElement(Info, _extends({}, props, {
        color: "blue"
      })));

    case 'danger':
      return /*#__PURE__*/React__default['default'].createElement(IconContainer, null, /*#__PURE__*/React__default['default'].createElement(AlertCircle, _extends({}, props, {
        color: "red"
      })));

    default:
      return null;
  }
};

Icon$2.displayName = 'Notification.Icon';

var Message$1 = createStyled("div", {
  target: "e16vh4rn0",
  label: "Message"
})("flex:1;", padding('xs'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1lc3NhZ2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRzBCIiwiZmlsZSI6Ik1lc3NhZ2UuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IHBhZGRpbmcgfSBmcm9tICcuLi8uLi8uLi9zdHlsZXMnXG5cbmNvbnN0IE1lc3NhZ2UgPSBzdHlsZWQuZGl2YFxuICBmbGV4OiAxO1xuICAke3BhZGRpbmcoJ3hzJyl9O1xuYFxuXG5NZXNzYWdlLmRpc3BsYXlOYW1lID0gJ05vdGlmaWNhdGlvbi5NZXNzYWdlJ1xuXG5leHBvcnQgZGVmYXVsdCBNZXNzYWdlXG4iXX0= */"));

Message$1.displayName = 'Notification.Message';

var NOTIFY = 'NOTIFY';
var REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
var id = 1;

var generateId = function generateId() {
  return String(id++);
};

var notify = function notify(type, message) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: NOTIFY,
    payload: _objectSpread2({
      type: type,
      message: message,
      sticky: false,
      timeout: 3000,
      dismissable: true,
      id: generateId(),
      onClick: function onClick() {},
      onClose: function onClose() {}
    }, options)
  };
};
var removeNotification = function removeNotification(id) {
  return {
    type: REMOVE_NOTIFICATION,
    payload: {
      id: id
    }
  };
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case NOTIFY:
      return [].concat(_toConsumableArray(state), [action.payload]);

    case REMOVE_NOTIFICATION:
      return state.filter(function (notification) {
        return notification.id !== action.payload.id;
      });

    default:
      return state;
  }
};

var NotificationsContext = /*#__PURE__*/React.createContext({
  notifications: [],
  dispatch: function dispatch() {},
  notify: noop,
  removeNotification: noop
});
var NotificationsProvider = function NotificationsProvider(_ref) {
  var children = _ref.children;

  var _useReducer = React.useReducer(reducer, []),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      notifications = _useReducer2[0],
      dispatch = _useReducer2[1];

  var notifyCallback = React.useCallback(function () {
    var action = notify.apply(void 0, arguments);
    dispatch(action);
    return action.payload.id;
  }, []);
  var removeNotificationCallback = React.useCallback(function (id) {
    return dispatch(removeNotification(id));
  }, []);
  return /*#__PURE__*/React__default['default'].createElement(NotificationsContext.Provider, {
    value: {
      notify: notifyCallback,
      removeNotification: removeNotificationCallback,
      notifications: notifications
    }
  }, children);
};

var withNotifier = function withNotifier(Component) {
  return function (props) {
    var value = React.useContext(NotificationsContext);
    return /*#__PURE__*/React__default['default'].createElement(Component, _extends({}, props, value));
  };
};

var Notification = function Notification(_ref) {
  var notification = _ref.notification,
      removeNotification = _ref.removeNotification,
      style = _ref.style;

  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];

  React.useEffect(function () {
    if (!notification.sticky) {
      scheduleHide();
    }

    return function () {
      cancelHide();
      notification.onClose(notification);
    };
  }, []);

  var scheduleHide = function scheduleHide() {
    setTimer(setTimeout(remove, notification.timeout));
  };

  var cancelHide = function cancelHide() {
    clearTimeout(timer);
  };

  var handleOnClick = function handleOnClick() {
    notification.onClick(notification);
  };

  var handleDismiss = function handleDismiss(e) {
    e.stopPropagation();
    remove();
  };

  var remove = function remove() {
    removeNotification(notification.id);
  };

  return /*#__PURE__*/React__default['default'].createElement(Container$c, {
    onMouseOver: cancelHide,
    onMouseOut: notification.sticky ? null : scheduleHide,
    onClick: handleOnClick,
    style: {
      minHeight: style.minHeight,
      marginBottom: "".concat(style.spacing, "rem"),
      opacity: style.opacity,
      transform: "translate3d(".concat(style.translate, "%, 0, 0) scaleY(").concat(style.scaleY, ")")
    }
  }, /*#__PURE__*/React__default['default'].createElement(Icon$2, {
    kind: notification.type,
    renderIcon: notification.renderIcon
  }), /*#__PURE__*/React__default['default'].createElement(Message$1, null, notification.message), notification.dismissable && /*#__PURE__*/React__default['default'].createElement(Close, {
    onClick: handleDismiss
  }));
};

var Notification$1 = withNotifier(Notification);

var springConfig = {
  stiffness: 120,
  damping: 15
};

var Notifications = function Notifications() {
  var _useContext = React.useContext(NotificationsContext),
      notifications = _useContext.notifications;

  return /*#__PURE__*/React__default['default'].createElement(reactMotion.TransitionMotion, {
    styles: notifications.map(function (notification) {
      return {
        key: notification.id,
        data: notification,
        style: {
          spacing: reactMotion.spring(1, springConfig),
          minHeight: reactMotion.spring(56, springConfig),
          scaleY: reactMotion.spring(1, springConfig),
          translate: reactMotion.spring(0, springConfig),
          opacity: reactMotion.spring(1)
        }
      };
    }),
    willEnter: function willEnter() {
      return {
        spacing: 0,
        minHeight: 0,
        scaleY: 0,
        opacity: 0,
        translate: 100
      };
    },
    willLeave: function willLeave() {
      return {
        spacing: reactMotion.spring(0, springConfig),
        minHeight: reactMotion.spring(0),
        scaleY: reactMotion.spring(0),
        opacity: reactMotion.spring(0),
        translate: reactMotion.spring(100, springConfig)
      };
    }
  }, function (styles) {
    return /*#__PURE__*/React__default['default'].createElement(Container$b, null, styles.map(function (_ref) {
      var key = _ref.key,
          data = _ref.data,
          style = _ref.style;
      return /*#__PURE__*/React__default['default'].createElement(Notification$1, {
        key: key,
        notification: data,
        style: style
      });
    }));
  });
};

var visibility = function visibility(_ref) {
  var open = _ref.open;
  return /*#__PURE__*/core.css("visibility:", open ? 'visible' : 'hidden', ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJSyIsImZpbGUiOiJDb250YWluZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5cbmNvbnN0IHZpc2liaWxpdHkgPSAoeyBvcGVuIH0pID0+XG4gIGNzc2BcbiAgICB2aXNpYmlsaXR5OiAke29wZW4gPyAndmlzaWJsZScgOiAnaGlkZGVuJ307XG4gIGBcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5cbiAgbWF4LXdpZHRoOiAxMDAlO1xuICB6LWluZGV4OiAxMDIwO1xuICAke3Zpc2liaWxpdHl9O1xuYFxuXG5Db250YWluZXIuZGlzcGxheU5hbWUgPSAnUG9wb3Zlci5Db250YWluZXInXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */"));
};

var Container$d = createStyled("div", {
  target: "efmjqc70",
  label: "Container"
})("display:flex;justify-content:center;align-items:center;max-width:100%;z-index:1020;", visibility, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5jb25zdCB2aXNpYmlsaXR5ID0gKHsgb3BlbiB9KSA9PlxuICBjc3NgXG4gICAgdmlzaWJpbGl0eTogJHtvcGVuID8gJ3Zpc2libGUnIDogJ2hpZGRlbid9O1xuICBgXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gIG1heC13aWR0aDogMTAwJTtcbiAgei1pbmRleDogMTAyMDtcbiAgJHt2aXNpYmlsaXR5fTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ1BvcG92ZXIuQ29udGFpbmVyJ1xuXG5leHBvcnQgZGVmYXVsdCBDb250YWluZXJcbiJdfQ== */"));

Container$d.displayName = 'Popover.Container';

function _EMOTION_STRINGIFIED_CSS_ERROR__$x() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Wrapper = createStyled("div", {
  target: "e1pyxqpy0",
  label: "Wrapper"
})( true ? {
  name: "79elbk",
  styles: "position:relative;"
} : {
  name: "79elbk",
  styles: "position:relative;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIldyYXBwZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTBCIiwiZmlsZSI6IldyYXBwZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuY29uc3QgV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbmBcblxuV3JhcHBlci5kaXNwbGF5TmFtZSA9ICdQb3BvdmVyLldyYXBwZXInXG5cbmV4cG9ydCBkZWZhdWx0IFdyYXBwZXJcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$x
});

Wrapper.displayName = 'Popover.Wrapper';

var Popover = /*#__PURE__*/function (_Component) {
  _inherits(Popover, _Component);

  var _super = _createSuper(Popover);

  function Popover(props) {
    var _this;

    _classCallCheck(this, Popover);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized(_this), "state", {
      open: false
    });

    _defineProperty$1(_assertThisInitialized(_this), "popoverRoot", document.getElementById('popover-root'));

    _defineProperty$1(_assertThisInitialized(_this), "show", function () {
      return _this.setState({
        open: true
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "hide", function () {
      return _this.setState({
        open: false
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "toggle", function () {
      return _this.setState({
        open: !_this.state.open
      });
    });

    if (false) {
      invariant__default['default'](_this.popoverRoot, 'This app does not contain a popover root. Follow the steps at ' + 'https://invent.focusvision.com/Portland/stylist#popovers to add ' + 'one to your app.');
    }

    return _this;
  }

  _createClass(Popover, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          placement = _this$props.placement,
          wrapperClassName = _this$props.wrapperClassName,
          children = _this$props.children;
      var open = this.state.open;
      var popover = /*#__PURE__*/React__default['default'].createElement(reactPopper.Popper, {
        placement: placement
      }, function (_ref) {
        var ref = _ref.ref,
            placement = _ref.placement,
            style = _ref.style;
        return /*#__PURE__*/React__default['default'].createElement(Container$d, {
          ref: ref,
          style: style,
          "data-placement": placement,
          open: open
        }, _this2.props.render({
          hide: _this2.hide
        }));
      });
      var reference = /*#__PURE__*/React__default['default'].createElement(reactPopper.Reference, null, function (_ref2) {
        var ref = _ref2.ref;
        return children({
          ref: ref,
          hide: _this2.hide,
          show: _this2.show,
          toggle: _this2.toggle
        });
      });
      return /*#__PURE__*/React__default['default'].createElement(reactPopper.Manager, null, /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, reference, /*#__PURE__*/reactDom.createPortal(popover, this.popoverRoot)));
    }
  }]);

  return Popover;
}(React.Component);

_defineProperty$1(Popover, "defaultProps", {
  placement: 'top',
  render: noop
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$y() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var RadioButtonHidden = recompose.withProps({
  type: 'radio'
})(createStyled("input", {
  target: "erw3h5h0",
  label: "RadioButtonHidden"
})( true ? {
  name: "sxypit",
  styles: "position:absolute;opacity:0;z-index:-1;"
} : {
  name: "sxypit",
  styles: "position:absolute;opacity:0;z-index:-1;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJhZGlvQnV0dG9uSGlkZGVuLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUtlIiwiZmlsZSI6IlJhZGlvQnV0dG9uSGlkZGVuLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnXG5cbmNvbnN0IFJhZGlvQnV0dG9uSGlkZGVuID0gd2l0aFByb3BzKHtcbiAgdHlwZTogJ3JhZGlvJ1xufSkoc3R5bGVkLmlucHV0YFxuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIG9wYWNpdHk6IDA7XG4gIHotaW5kZXg6IC0xO1xuYClcblxuZXhwb3J0IGRlZmF1bHQgUmFkaW9CdXR0b25IaWRkZW5cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$y
}));

var radioButtonBackgroundColor = function radioButtonBackgroundColor(_ref) {
  var checked = _ref.checked,
      disabled = _ref.disabled,
      dark = _ref.dark;

  if (disabled) {
    return dark ? 'transparent' : 'offWhite';
  }

  return dark ? 'transparent' : 'white';
};

var radioButtonBorderColor = function radioButtonBorderColor(_ref2) {
  var checked = _ref2.checked,
      disabled = _ref2.disabled,
      valid = _ref2.valid,
      dark = _ref2.dark;

  if (disabled) {
    return dark ? 'pewter' : 'silver';
  } else if (!valid) {
    return 'red';
  }

  return checked ? 'brandGreen' : 'cadet';
};

var hoverBorderColor = function hoverBorderColor(_ref3) {
  var disabled = _ref3.disabled,
      valid = _ref3.valid,
      dark = _ref3.dark;

  if (disabled) {
    return dark ? 'pewter' : 'silver';
  } else if (!valid) {
    return 'red';
  } else {
    return 'brandGreen';
  }
};

var findColor$1 = function findColor(props) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (key) {
    return key;
  };
  var colorKey = fn(props);

  if (colorKey) {
    return color(colorKey)({
      theme: props.theme
    });
  }

  return 'transparent';
};

var RadioButtonDisplay = createStyled("div", {
  target: "ek0vkco0",
  label: "RadioButtonDisplay"
})("background-color:", function (props) {
  return findColor$1(props, radioButtonBackgroundColor);
}, ";border:solid 0.0675rem ", function (props) {
  return findColor$1(props, radioButtonBorderColor);
}, ";border-radius:50%;height:", spacer(4), ";width:", spacer(4), ";display:inline-block;margin-right:", spacer(3), ";margin-left:-1px;vertical-align:middle;&:hover{border-color:", function (props) {
  return findColor$1(props, hoverBorderColor);
}, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$z() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Label$3 = createStyled("label", {
  target: "ee4pue30",
  label: "Label"
})("display:grid;grid-auto-flow:column;grid-template-columns:auto 1fr;align-items:center;justify-items:start;cursor:", function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var LabelText$1 = createStyled("span", {
  target: "ee4pue31",
  label: "LabelText"
})("margin-bottom:0;color:", function (_ref2) {
  var disabled = _ref2.disabled,
      dark = _ref2.dark;
  return disabled ? dark ? color('slate') : transparentize('slate', 0.5) : dark ? color('silver') : color('slate');
}, ";vertical-align:middle;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var RadioButtonContainer = createStyled("div", {
  target: "ee4pue32",
  label: "RadioButtonContainer"
})( true ? {
  name: "79elbk",
  styles: "position:relative;"
} : {
  name: "79elbk",
  styles: "position:relative;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$z
});

var fillColor = function fillColor(disabled, dark) {
  return !disabled ? 'brandGreen' : dark ? 'pewter' : 'silver';
};

var RadioButton = function RadioButton(_ref3) {
  var checked = _ref3.checked,
      label = _ref3.label,
      disabled = _ref3.disabled,
      valid = _ref3.valid,
      id = _ref3.id,
      theme = _ref3.theme,
      dark = _ref3.dark,
      rest = _objectWithoutProperties(_ref3, ["checked", "label", "disabled", "valid", "id", "theme", "dark"]);

  return /*#__PURE__*/React__default['default'].createElement(RadioButtonContainer, null, /*#__PURE__*/React__default['default'].createElement(RadioButtonHidden, _extends({
    checked: checked,
    disabled: disabled,
    id: id
  }, rest)), /*#__PURE__*/React__default['default'].createElement(Label$3, {
    disabled: disabled,
    htmlFor: id
  }, /*#__PURE__*/React__default['default'].createElement(RadioButtonDisplay, {
    checked: checked,
    disabled: disabled,
    valid: valid,
    dark: dark
  }, /*#__PURE__*/React__default['default'].createElement("svg", {
    viewBox: "-10 -10 20 20"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    fill: "none"
  }, checked && /*#__PURE__*/React__default['default'].createElement("circle", {
    r: "6",
    fill: color(fillColor(disabled, dark))({
      theme: theme
    })
  })))), /*#__PURE__*/React__default['default'].createElement(LabelText$1, {
    dark: dark,
    disabled: disabled
  }, label)));
};

RadioButton.propTypes = {
  checked: PropTypes__default['default'].bool,
  disabled: PropTypes__default['default'].bool,
  label: PropTypes__default['default'].node,
  valid: PropTypes__default['default'].bool,
  id: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func
};
RadioButton.defaultProps = {
  onChange: function onChange() {},
  checked: false,
  disabled: false,
  valid: true
};
var index$2 = emotionTheming.withTheme(RadioButton);

var Row = createStyled("section", {
  target: "e1vvijyc0",
  label: "Row"
})("width:100%;display:flex;flex-direction:column;align-items:center;@supports (display:grid){display:grid;justify-items:center;justify-content:unset;align-items:unset;grid-auto-flow:row;grid-gap:", spacer(4), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvdy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHMEIiLCJmaWxlIjoiUm93LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBzcGFjZXIgfSBmcm9tICcuLi9zdHlsZXMnXG5cbmNvbnN0IFJvdyA9IHN0eWxlZC5zZWN0aW9uYFxuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICBAc3VwcG9ydHMgKGRpc3BsYXk6IGdyaWQpIHtcbiAgICBkaXNwbGF5OiBncmlkO1xuICAgIGp1c3RpZnktaXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHVuc2V0O1xuICAgIGFsaWduLWl0ZW1zOiB1bnNldDtcbiAgICBncmlkLWF1dG8tZmxvdzogcm93O1xuICAgIGdyaWQtZ2FwOiAke3NwYWNlcig0KX07XG4gIH1cbmBcblxuZXhwb3J0IGRlZmF1bHQgUm93XG4iXX0= */"));

var deletable = function deletable(_ref) {
  var deletable = _ref.deletable,
      theme = _ref.theme;
  return deletable && /*#__PURE__*/core.css("padding-right:", spacer(2, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var selectable = function selectable(_ref2) {
  var selectable = _ref2.selectable,
      selected = _ref2.selected,
      theme = _ref2.theme;
  return selectable ? /*#__PURE__*/core.css("cursor:pointer;color:", color(selected ? 'white' : 'slate', {
    theme: theme
  }), ";background-color:", color(selected ? 'slate' : 'paleGrey', {
    theme: theme
  }), ";&:hover{background-color:", !selected && transparentize('brandGreen', 0.25, {
    theme: theme
  }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")) : /*#__PURE__*/core.css("color:", color('slate', {
    theme: theme
  }), ";background-color:", color('paleGrey', {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var Container$e = createStyled("span", {
  target: "ewocyl40",
  label: "Container"
})("display:inline-block;border-radius:2rem;padding:", spacer(1), " ", spacer(3), ";transition:margin-right 0.3s ease 0s;", typography('body1Medium'), ";", selectable, ";", deletable, ";&.stylist-tag:not(:last-of-type){margin-right:", spacer(2), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var InnerContainer = createStyled("div", {
  target: "ewocyl41",
  label: "InnerContainer"
})("display:flex;flex-direction:justify-content;align-items:center;button{margin-left:", spacer(1), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Tag = function Tag(_ref3) {
  var children = _ref3.children,
      deletable = _ref3.deletable,
      id = _ref3.id,
      selectable = _ref3.selectable,
      selected = _ref3.selected,
      onDelete = _ref3.onDelete,
      onSelect = _ref3.onSelect;
  return /*#__PURE__*/React__default['default'].createElement(Container$e, {
    className: "stylist-tag",
    deletable: deletable,
    selectable: selectable,
    selected: selected,
    onClick: selectable ? function () {
      return onSelect(id);
    } : null
  }, /*#__PURE__*/React__default['default'].createElement(InnerContainer, null, children, deletable && /*#__PURE__*/React__default['default'].createElement(CloseButton, {
    size: "1rem",
    onClick: function onClick() {
      return onDelete(id);
    }
  })));
};

// https://wapp-fvuatlivestyleguide-cus-tst.azurewebsites.net/01-style.html#01-colors
var brand = {
  // primary
  brandGreen: '#00cc52',
  lightBrandGreen: '#5ae070',
  lighterBrandGreen: '#82eb7f',
  brandMain: '#FF00FF',
  //greys
  ink: '#00253B',
  slate: '#3e5467',
  pewter: '#627585',
  cadet: '#8394a3',
  silver: '#cbd2d6',
  paleGrey: '#e4e8eb',
  offWhite: '#F7F9FA',
  white: '#fff',
  black: '#2e3033',
  // system
  green: '#39a84c',
  lightGreen: '#CEF5D4',
  red: '#f5496c',
  lightRed: '#FFDBE2',
  darkRed: '#F21945',
  orange: '#e07a04',
  lightOrange: '#FFEAD1',
  blue: '#428fdb',
  lightBlue: '#D4E7FA',
  royalBlue: '#62a1f3',
  // secondary
  darkPurple: '#5641cc',
  purple: '#725ee0',
  ocean: '#1B73B3',
  forest: '#1A825F',
  darkOcean: '#07558c',
  // gradients
  greenGradient: {
    start: '#00c753',
    end: '#00d4e8'
  },
  blueGradient: {
    start: '#00d4e8',
    end: '#786ce9'
  },
  purpleGradient: {
    start: '#a379ff',
    end: '#786ce9'
  },
  bluePinkGradient: {
    start: '#3023ae',
    end: '#c86dd7'
  }
};

// https://wapp-fvuatlivestyleguide-cus-tst.azurewebsites.net/01-style.html#02-border-radius
var borderRadius$1 = {
  sm: '2px',
  "default": '4px',
  lg: '6px'
};

// https://wapp-fvuatlivestyleguide-cus-tst.azurewebsites.net/01-style.html#07-typography
var base = '16px';
var font = {
  base: base,
  lineHeight: {
    xxxl: polished.rem('64px', base),
    xxl: polished.rem('48px', base),
    xl: polished.rem('36px', base),
    l: polished.rem('30px', base),
    m: polished.rem('24px', base),
    s: polished.rem('22px', base),
    xs: polished.rem('20px', base),
    xxs: polished.rem('17px', base),
    xxxs: polished.rem('15px', base)
  },
  size: {
    xxxl: polished.rem('48px', base),
    xxl: polished.rem('36px', base),
    xl: polished.rem('28px', base),
    l: polished.rem('22px', base),
    m: polished.rem('18px', base),
    s: polished.rem('16px', base),
    xs: polished.rem('14px', base),
    xxs: polished.rem('12px', base),
    xxxs: polished.rem('11px', base)
  },
  weight: {
    regular: 400,
    medium: 500,
    bold: 700,
    black: 900
  }
};

// https://wapp-fvuatlivestyleguide-cus-tst.azurewebsites.net/01-style.html#05-shadow
var shadow$1 = {
  subtle: '0 1px 3px 0 rgba(22, 38, 59, 0.08)',
  close: '0 2px 6px 0 rgba(22, 38, 59, 0.14)',
  raised: '0 3px 8px 0 rgba(22, 38, 59, 0.2)',
  distant: '0 4px 12px 0 rgba(22, 38, 59, 0.28)'
};

// https://wapp-fvuatlivestyleguide-cus-tst.azurewebsites.net/01-style.html#06-spacing
var size$b = {
  spacer1: polished.rem('4px', font.base),
  spacer2: polished.rem('8px', font.base),
  spacer3: polished.rem('14px', font.base),
  spacer4: polished.rem('20px', font.base),
  spacer5: polished.rem('28px', font.base),
  spacer6: polished.rem('36px', font.base),
  spacer7: polished.rem('48px', font.base),
  spacer8: polished.rem('60px', font.base)
};
var spacing = {
  size: size$b,
  xxxs: {
    x: size$b.spacer2,
    y: size$b.spacer1
  },
  xxs: {
    x: size$b.spacer3,
    y: size$b.spacer2
  },
  xs: {
    x: size$b.spacer4,
    y: size$b.spacer3
  },
  sm: {
    x: size$b.spacer5,
    y: size$b.spacer4
  },
  md: {
    x: size$b.spacer6,
    y: size$b.spacer5
  },
  lg: {
    x: size$b.spacer7,
    y: size$b.spacer6
  },
  xl: {
    x: size$b.spacer8,
    y: size$b.spacer7
  }
};

// https://wapp-fvuatlivestyleguide-cus-tst.azurewebsites.net/01-style.html#07-typography
var lineHeight = font.lineHeight,
    size$c = font.size,
    weight = font.weight;
var typography$1 = {
  headline3: {
    lineHeight: lineHeight.xxxl,
    fontSize: size$c.xxxl,
    fontWeight: weight.regular
  },
  headline2: {
    lineHeight: lineHeight.xxl,
    fontSize: size$c.xxl,
    fontWeight: weight.regular
  },
  headline1: {
    lineHeight: lineHeight.xl,
    fontSize: size$c.xl,
    fontWeight: weight.medium
  },
  title3: {
    lineHeight: lineHeight.l,
    fontSize: size$c.l,
    fontWeight: weight.medium
  },
  title2: {
    lineHeight: lineHeight.m,
    fontSize: size$c.m,
    fontWeight: weight.bold
  },
  title1: {
    lineHeight: lineHeight.s,
    fontSize: size$c.s,
    fontWeight: weight.bold
  },
  subheading3: {
    lineHeight: lineHeight.xs,
    fontSize: size$c.xs,
    fontWeight: weight.black,
    textTransform: 'uppercase',
    letterSpacing: '0.8px'
  },
  subheading2: {
    lineHeight: lineHeight.xxs,
    fontSize: size$c.xxs,
    fontWeight: weight.black,
    textTransform: 'uppercase',
    letterSpacing: '0.8px'
  },
  subheading1: {
    lineHeight: lineHeight.xxxs,
    fontSize: size$c.xxxs,
    fontWeight: weight.black,
    textTransform: 'uppercase',
    letterSpacing: '0.8px'
  },
  body4: {
    lineHeight: lineHeight.m,
    fontSize: size$c.m,
    fontWeight: weight.regular
  },
  body4Medium: {
    lineHeight: lineHeight.m,
    fontSize: size$c.m,
    fontWeight: weight.medium
  },
  body3: {
    lineHeight: lineHeight.s,
    fontSize: size$c.s,
    fontWeight: weight.regular
  },
  body3Medium: {
    lineHeight: lineHeight.s,
    fontSize: size$c.s,
    fontWeight: weight.medium
  },
  body2: {
    lineHeight: lineHeight.xs,
    fontSize: size$c.xs,
    fontWeight: weight.regular
  },
  body2Medium: {
    lineHeight: lineHeight.xs,
    fontSize: size$c.xs,
    fontWeight: weight.medium
  },
  body1: {
    lineHeight: lineHeight.xxs,
    fontSize: size$c.xxs,
    fontWeight: weight.regular
  },
  body1Medium: {
    lineHeight: lineHeight.xxs,
    fontSize: size$c.xxs,
    fontWeight: weight.medium
  },
  numeral6: {
    lineHeight: lineHeight.xxxl,
    fontSize: size$c.xxxl,
    fontWeight: weight.regular
  },
  numeral5: {
    lineHeight: lineHeight.xxl,
    fontSize: size$c.xxl,
    fontWeight: weight.regular
  },
  numeral4: {
    lineHeight: lineHeight.xl,
    fontSize: size$c.xl,
    fontWeight: weight.regular
  },
  numeral3: {
    lineHeight: lineHeight.l,
    fontSize: size$c.l,
    fontWeight: weight.medium
  },
  numeral2: {
    lineHeight: lineHeight.m,
    fontSize: size$c.m,
    fontWeight: weight.medium
  },
  numeral1: {
    lineHeight: lineHeight.s,
    fontSize: size$c.s,
    fontWeight: weight.medium
  }
};

var theme = {
  fvStyle: {
    borderRadius: borderRadius$1,
    brand: brand,
    font: font,
    shadow: shadow$1,
    spacing: spacing,
    typography: typography$1
  }
};

var Theme = function Theme(_ref) {
  var children = _ref.children,
      include = _ref.include;
  return /*#__PURE__*/React__default['default'].createElement(emotionTheming.ThemeProvider, {
    theme: _objectSpread2(_objectSpread2({}, include), theme)
  }, children);
};

var recolorButton = function recolorButton(_ref) {
  var colorName = _ref.colorName,
      theme = _ref.theme;
  var buttonColor = color(colorName, {
    theme: theme
  });
  return /*#__PURE__*/core.css("button{background-color:", buttonColor, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var backgroundColor = function backgroundColor(_ref2) {
  var colorName = _ref2.colorName,
      transparency = _ref2.transparency,
      theme = _ref2.theme;
  return transparentize(colorName, transparency, {
    theme: theme
  });
};

var position = function position(_ref3) {
  var position = _ref3.position,
      theme = _ref3.theme,
      colorName = _ref3.colorName;
  var borderColor = transparentize(colorName, 0.85, {
    theme: theme
  });
  var solidColor = color(colorName, {
    theme: theme
  });

  switch (position) {
    case 'bottom':
      return /*#__PURE__*/core.css("&::after{left:50%;bottom:100%;transform:translateX(-50%);border-bottom-color:", borderColor, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    case 'top':
      return /*#__PURE__*/core.css("&::after{left:50%;top:100%;transform:translateX(-50%);border-top-color:", borderColor, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    case 'left':
      return /*#__PURE__*/core.css("&::after{top:50%;left:100%;transform:translateY(-50%);border-left-color:", borderColor, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    case 'right':
      return /*#__PURE__*/core.css("&::after{top:50%;right:100%;transform:translateY(-50%);border-right-color:", borderColor, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF3RGdCIiwiZmlsZSI6IkNvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIGNvbG9yLFxuICBib3JkZXJSYWRpdXMsXG4gIHBhZGRpbmcsXG4gIHRyYW5zcGFyZW50aXplLFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgcmVjb2xvckJ1dHRvbiA9ICh7IGNvbG9yTmFtZSwgdGhlbWUgfSkgPT4ge1xuICBjb25zdCBidXR0b25Db2xvciA9IGNvbG9yKGNvbG9yTmFtZSwgeyB0aGVtZSB9KVxuICByZXR1cm4gY3NzYFxuICAgIGJ1dHRvbiB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2J1dHRvbkNvbG9yfTtcbiAgICB9XG4gIGBcbn1cblxuY29uc3QgYmFja2dyb3VuZENvbG9yID0gKHsgY29sb3JOYW1lLCB0cmFuc3BhcmVuY3ksIHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHRyYW5zcGFyZW50aXplKGNvbG9yTmFtZSwgdHJhbnNwYXJlbmN5LCB7IHRoZW1lIH0pXG59XG5cbmNvbnN0IHBvc2l0aW9uID0gKHsgcG9zaXRpb24sIHRoZW1lLCBjb2xvck5hbWUgfSkgPT4ge1xuICBjb25zdCBib3JkZXJDb2xvciA9IHRyYW5zcGFyZW50aXplKGNvbG9yTmFtZSwgMC44NSwgeyB0aGVtZSB9KVxuICBjb25zdCBzb2xpZENvbG9yID0gY29sb3IoY29sb3JOYW1lLCB7IHRoZW1lIH0pXG5cbiAgc3dpdGNoIChwb3NpdGlvbikge1xuICAgIGNhc2UgJ2JvdHRvbSc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgbGVmdDogNTAlO1xuICAgICAgICAgIGJvdHRvbTogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHtib3JkZXJDb2xvcn07XG4gICAgICAgIH1cbiAgICAgIGBcbiAgICBjYXNlICd0b3AnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIGxlZnQ6IDUwJTtcbiAgICAgICAgICB0b3A6IDEwMCU7XG4gICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpO1xuICAgICAgICAgIGJvcmRlci10b3AtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAnbGVmdCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgdG9wOiA1MCU7XG4gICAgICAgICAgbGVmdDogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWxlZnQtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAncmlnaHQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIHRvcDogNTAlO1xuICAgICAgICAgIHJpZ2h0OiAxMDAlO1xuICAgICAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcbiAgICAgICAgICBib3JkZXItcmlnaHQtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAnYm90dG9tLWxlZnQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIGxlZnQ6IDkwJTtcbiAgICAgICAgICBib3R0b206IDEwMCU7XG4gICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpO1xuICAgICAgICAgIGJvcmRlci1ib3R0b20tY29sb3I6ICR7c29saWRDb2xvcn07XG4gICAgICAgIH1cbiAgICAgIGBcblxuICAgIGNhc2UgJ2JvdHRvbS1yaWdodCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgbGVmdDogMTAlO1xuICAgICAgICAgIGJvdHRvbTogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHtzb2xpZENvbG9yfTtcbiAgICAgICAgfVxuICAgICAgYFxuXG4gICAgZGVmYXVsdDpcbiAgICAvLyBkbyBub3RoaW5nXG4gIH1cbn1cblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9pbnRlci1ldmVudHM6ICR7KHsgb3BlbiB9KSA9PiAob3BlbiA/ICdhdXRvJyA6ICdub25lJyl9O1xuICB0cmFuc2l0aW9uOiBhbGwgMC4ycyBlYXNlLW91dDtcbiAgbWF4LXdpZHRoOiAkeyh7IHdpZGUgfSkgPT4gKHdpZGUgPyAnMzI1cHgnIDogJzI1MHB4Jyl9O1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBvcGFjaXR5OiAkeyh7IG9wZW4gfSkgPT4gKG9wZW4gPyAwLjggOiAwKX07XG4gIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgYmFja2dyb3VuZDogJHtiYWNrZ3JvdW5kQ29sb3J9O1xuICB6LWluZGV4OiAxMDIwO1xuICAkeyh7IHBvcnRhbCB9KSA9PiAhcG9ydGFsICYmICd3aGl0ZS1zcGFjZTogbm93cmFwOyd9O1xuXG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3BhZGRpbmcoJ3h4cycpfTtcbiAgJHt0eXBvZ3JhcGh5KCdib2R5MicpfTtcblxuICAmOjphZnRlciB7XG4gICAgY29udGVudDogJyc7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGJvcmRlcjogNXB4IHNvbGlkIHRyYW5zcGFyZW50O1xuICB9XG5cbiAgJHtyZWNvbG9yQnV0dG9ufTtcblxuICAke3Bvc2l0aW9ufTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ1Rvb2x0aXAuQ29udGFpbmVyJ1xuXG5leHBvcnQgZGVmYXVsdCBDb250YWluZXJcbiJdfQ== */"));

    case 'bottom-left':
      return /*#__PURE__*/core.css("&::after{left:90%;bottom:100%;transform:translateX(-50%);border-bottom-color:", solidColor, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

    case 'bottom-right':
      return /*#__PURE__*/core.css("&::after{left:10%;bottom:100%;transform:translateX(-50%);border-bottom-color:", solidColor, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEyRWdCIiwiZmlsZSI6IkNvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIGNvbG9yLFxuICBib3JkZXJSYWRpdXMsXG4gIHBhZGRpbmcsXG4gIHRyYW5zcGFyZW50aXplLFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgcmVjb2xvckJ1dHRvbiA9ICh7IGNvbG9yTmFtZSwgdGhlbWUgfSkgPT4ge1xuICBjb25zdCBidXR0b25Db2xvciA9IGNvbG9yKGNvbG9yTmFtZSwgeyB0aGVtZSB9KVxuICByZXR1cm4gY3NzYFxuICAgIGJ1dHRvbiB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2J1dHRvbkNvbG9yfTtcbiAgICB9XG4gIGBcbn1cblxuY29uc3QgYmFja2dyb3VuZENvbG9yID0gKHsgY29sb3JOYW1lLCB0cmFuc3BhcmVuY3ksIHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHRyYW5zcGFyZW50aXplKGNvbG9yTmFtZSwgdHJhbnNwYXJlbmN5LCB7IHRoZW1lIH0pXG59XG5cbmNvbnN0IHBvc2l0aW9uID0gKHsgcG9zaXRpb24sIHRoZW1lLCBjb2xvck5hbWUgfSkgPT4ge1xuICBjb25zdCBib3JkZXJDb2xvciA9IHRyYW5zcGFyZW50aXplKGNvbG9yTmFtZSwgMC44NSwgeyB0aGVtZSB9KVxuICBjb25zdCBzb2xpZENvbG9yID0gY29sb3IoY29sb3JOYW1lLCB7IHRoZW1lIH0pXG5cbiAgc3dpdGNoIChwb3NpdGlvbikge1xuICAgIGNhc2UgJ2JvdHRvbSc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgbGVmdDogNTAlO1xuICAgICAgICAgIGJvdHRvbTogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHtib3JkZXJDb2xvcn07XG4gICAgICAgIH1cbiAgICAgIGBcbiAgICBjYXNlICd0b3AnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIGxlZnQ6IDUwJTtcbiAgICAgICAgICB0b3A6IDEwMCU7XG4gICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpO1xuICAgICAgICAgIGJvcmRlci10b3AtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAnbGVmdCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgdG9wOiA1MCU7XG4gICAgICAgICAgbGVmdDogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWxlZnQtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAncmlnaHQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIHRvcDogNTAlO1xuICAgICAgICAgIHJpZ2h0OiAxMDAlO1xuICAgICAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcbiAgICAgICAgICBib3JkZXItcmlnaHQtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAnYm90dG9tLWxlZnQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIGxlZnQ6IDkwJTtcbiAgICAgICAgICBib3R0b206IDEwMCU7XG4gICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpO1xuICAgICAgICAgIGJvcmRlci1ib3R0b20tY29sb3I6ICR7c29saWRDb2xvcn07XG4gICAgICAgIH1cbiAgICAgIGBcblxuICAgIGNhc2UgJ2JvdHRvbS1yaWdodCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgbGVmdDogMTAlO1xuICAgICAgICAgIGJvdHRvbTogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHtzb2xpZENvbG9yfTtcbiAgICAgICAgfVxuICAgICAgYFxuXG4gICAgZGVmYXVsdDpcbiAgICAvLyBkbyBub3RoaW5nXG4gIH1cbn1cblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9pbnRlci1ldmVudHM6ICR7KHsgb3BlbiB9KSA9PiAob3BlbiA/ICdhdXRvJyA6ICdub25lJyl9O1xuICB0cmFuc2l0aW9uOiBhbGwgMC4ycyBlYXNlLW91dDtcbiAgbWF4LXdpZHRoOiAkeyh7IHdpZGUgfSkgPT4gKHdpZGUgPyAnMzI1cHgnIDogJzI1MHB4Jyl9O1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBvcGFjaXR5OiAkeyh7IG9wZW4gfSkgPT4gKG9wZW4gPyAwLjggOiAwKX07XG4gIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgYmFja2dyb3VuZDogJHtiYWNrZ3JvdW5kQ29sb3J9O1xuICB6LWluZGV4OiAxMDIwO1xuICAkeyh7IHBvcnRhbCB9KSA9PiAhcG9ydGFsICYmICd3aGl0ZS1zcGFjZTogbm93cmFwOyd9O1xuXG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3BhZGRpbmcoJ3h4cycpfTtcbiAgJHt0eXBvZ3JhcGh5KCdib2R5MicpfTtcblxuICAmOjphZnRlciB7XG4gICAgY29udGVudDogJyc7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGJvcmRlcjogNXB4IHNvbGlkIHRyYW5zcGFyZW50O1xuICB9XG5cbiAgJHtyZWNvbG9yQnV0dG9ufTtcblxuICAke3Bvc2l0aW9ufTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ1Rvb2x0aXAuQ29udGFpbmVyJ1xuXG5leHBvcnQgZGVmYXVsdCBDb250YWluZXJcbiJdfQ== */"));

  }
};

var Container$f = createStyled("div", {
  target: "efhrsw50",
  label: "Container"
})("pointer-events:", function (_ref4) {
  var open = _ref4.open;
  return open ? 'auto' : 'none';
}, ";transition:all 0.2s ease-out;max-width:", function (_ref5) {
  var wide = _ref5.wide;
  return wide ? '325px' : '250px';
}, ";text-align:left;opacity:", function (_ref6) {
  var open = _ref6.open;
  return open ? 0.8 : 0;
}, ";color:", color('white'), ";background:", backgroundColor, ";z-index:1020;", function (_ref7) {
  var portal = _ref7.portal;
  return !portal && 'white-space: nowrap;';
}, ";", borderRadius('default'), ";", padding('xxs'), ";", typography('body2'), ";&::after{content:'';position:absolute;border:5px solid transparent;}", recolorButton, ";", position, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5RjRCIiwiZmlsZSI6IkNvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIGNvbG9yLFxuICBib3JkZXJSYWRpdXMsXG4gIHBhZGRpbmcsXG4gIHRyYW5zcGFyZW50aXplLFxuICB0eXBvZ3JhcGh5XG59IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgcmVjb2xvckJ1dHRvbiA9ICh7IGNvbG9yTmFtZSwgdGhlbWUgfSkgPT4ge1xuICBjb25zdCBidXR0b25Db2xvciA9IGNvbG9yKGNvbG9yTmFtZSwgeyB0aGVtZSB9KVxuICByZXR1cm4gY3NzYFxuICAgIGJ1dHRvbiB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2J1dHRvbkNvbG9yfTtcbiAgICB9XG4gIGBcbn1cblxuY29uc3QgYmFja2dyb3VuZENvbG9yID0gKHsgY29sb3JOYW1lLCB0cmFuc3BhcmVuY3ksIHRoZW1lIH0pID0+IHtcbiAgcmV0dXJuIHRyYW5zcGFyZW50aXplKGNvbG9yTmFtZSwgdHJhbnNwYXJlbmN5LCB7IHRoZW1lIH0pXG59XG5cbmNvbnN0IHBvc2l0aW9uID0gKHsgcG9zaXRpb24sIHRoZW1lLCBjb2xvck5hbWUgfSkgPT4ge1xuICBjb25zdCBib3JkZXJDb2xvciA9IHRyYW5zcGFyZW50aXplKGNvbG9yTmFtZSwgMC44NSwgeyB0aGVtZSB9KVxuICBjb25zdCBzb2xpZENvbG9yID0gY29sb3IoY29sb3JOYW1lLCB7IHRoZW1lIH0pXG5cbiAgc3dpdGNoIChwb3NpdGlvbikge1xuICAgIGNhc2UgJ2JvdHRvbSc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgbGVmdDogNTAlO1xuICAgICAgICAgIGJvdHRvbTogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHtib3JkZXJDb2xvcn07XG4gICAgICAgIH1cbiAgICAgIGBcbiAgICBjYXNlICd0b3AnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIGxlZnQ6IDUwJTtcbiAgICAgICAgICB0b3A6IDEwMCU7XG4gICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpO1xuICAgICAgICAgIGJvcmRlci10b3AtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAnbGVmdCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgdG9wOiA1MCU7XG4gICAgICAgICAgbGVmdDogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWxlZnQtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAncmlnaHQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIHRvcDogNTAlO1xuICAgICAgICAgIHJpZ2h0OiAxMDAlO1xuICAgICAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNTAlKTtcbiAgICAgICAgICBib3JkZXItcmlnaHQtY29sb3I6ICR7Ym9yZGVyQ29sb3J9O1xuICAgICAgICB9XG4gICAgICBgXG4gICAgY2FzZSAnYm90dG9tLWxlZnQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgJjo6YWZ0ZXIge1xuICAgICAgICAgIGxlZnQ6IDkwJTtcbiAgICAgICAgICBib3R0b206IDEwMCU7XG4gICAgICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVYKC01MCUpO1xuICAgICAgICAgIGJvcmRlci1ib3R0b20tY29sb3I6ICR7c29saWRDb2xvcn07XG4gICAgICAgIH1cbiAgICAgIGBcblxuICAgIGNhc2UgJ2JvdHRvbS1yaWdodCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICAmOjphZnRlciB7XG4gICAgICAgICAgbGVmdDogMTAlO1xuICAgICAgICAgIGJvdHRvbTogMTAwJTtcbiAgICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVgoLTUwJSk7XG4gICAgICAgICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHtzb2xpZENvbG9yfTtcbiAgICAgICAgfVxuICAgICAgYFxuXG4gICAgZGVmYXVsdDpcbiAgICAvLyBkbyBub3RoaW5nXG4gIH1cbn1cblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgcG9pbnRlci1ldmVudHM6ICR7KHsgb3BlbiB9KSA9PiAob3BlbiA/ICdhdXRvJyA6ICdub25lJyl9O1xuICB0cmFuc2l0aW9uOiBhbGwgMC4ycyBlYXNlLW91dDtcbiAgbWF4LXdpZHRoOiAkeyh7IHdpZGUgfSkgPT4gKHdpZGUgPyAnMzI1cHgnIDogJzI1MHB4Jyl9O1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBvcGFjaXR5OiAkeyh7IG9wZW4gfSkgPT4gKG9wZW4gPyAwLjggOiAwKX07XG4gIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgYmFja2dyb3VuZDogJHtiYWNrZ3JvdW5kQ29sb3J9O1xuICB6LWluZGV4OiAxMDIwO1xuICAkeyh7IHBvcnRhbCB9KSA9PiAhcG9ydGFsICYmICd3aGl0ZS1zcGFjZTogbm93cmFwOyd9O1xuXG4gICR7Ym9yZGVyUmFkaXVzKCdkZWZhdWx0Jyl9O1xuICAke3BhZGRpbmcoJ3h4cycpfTtcbiAgJHt0eXBvZ3JhcGh5KCdib2R5MicpfTtcblxuICAmOjphZnRlciB7XG4gICAgY29udGVudDogJyc7XG4gICAgcG9zaXRpb246IGFic29sdXRlO1xuICAgIGJvcmRlcjogNXB4IHNvbGlkIHRyYW5zcGFyZW50O1xuICB9XG5cbiAgJHtyZWNvbG9yQnV0dG9ufTtcblxuICAke3Bvc2l0aW9ufTtcbmBcblxuQ29udGFpbmVyLmRpc3BsYXlOYW1lID0gJ1Rvb2x0aXAuQ29udGFpbmVyJ1xuXG5leHBvcnQgZGVmYXVsdCBDb250YWluZXJcbiJdfQ== */"));

Container$f.displayName = 'Tooltip.Container';

var Title$3 = createStyled("div", {
  target: "e71juu70",
  label: "Title"
})("margin-bottom:", spacer(1), ";color:", color('white'), ";", typography('body2Medium'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRpdGxlLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUd3QiIsImZpbGUiOiJUaXRsZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY29sb3IsIHNwYWNlciwgdHlwb2dyYXBoeSB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgVGl0bGUgPSBzdHlsZWQuZGl2YFxuICBtYXJnaW4tYm90dG9tOiAke3NwYWNlcigxKX07XG4gIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcblxuICAke3R5cG9ncmFwaHkoJ2JvZHkyTWVkaXVtJyl9O1xuYFxuXG5UaXRsZS5kaXNwbGF5TmFtZSA9ICdUb29sdGlwLlRpdGxlJ1xuXG5leHBvcnQgZGVmYXVsdCBUaXRsZVxuIl19 */"));

Title$3.displayName = 'Tooltip.Title';

function _EMOTION_STRINGIFIED_CSS_ERROR__$A() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Wrapper$1 = createStyled("div", {
  target: "e1ha8v9x0",
  label: "Wrapper"
})( true ? {
  name: "79elbk",
  styles: "position:relative;"
} : {
  name: "79elbk",
  styles: "position:relative;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIldyYXBwZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRTBCIiwiZmlsZSI6IldyYXBwZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuY29uc3QgV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbmBcblxuV3JhcHBlci5kaXNwbGF5TmFtZSA9ICdUb29sdGlwLldyYXBwZXInXG5cbmV4cG9ydCBkZWZhdWx0IFdyYXBwZXJcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$A
});

Wrapper$1.displayName = 'Tooltip.Wrapper';

var OFFSET = 12;
var placements = {
  'bottom-left': 'bottom-end',
  'bottom-right': 'bottom-start'
};

var getRoot$1 = function getRoot() {
  var root = document.getElementById('tooltip-root');

  if (false) {
    invariant__default['default'](root, 'This app does not contain a menu root. Follow the steps at ' + 'https://invent.focusvision.com/Portland/stylist#portal-roots to add one ' + 'to your app.');
  }

  return root;
};

var renderTooltip = function renderTooltip() {
  if (false) {
    warning__default['default'](false, 'Tooltip: `renderTooltip` is deprecated and will result in a no-op. ' + 'You must attach a `ref` to the trigger element. Please see the ' + 'upgrade instructions in the release documentation. \n' + 'https://invent.focusvision.com/Portland/stylist/releases');
  }

  return null;
};

var Tooltip = function Tooltip(_ref) {
  var _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top' : _ref$position,
      _ref$containerOpenOnH = _ref.containerOpenOnHover,
      containerOpenOnHover = _ref$containerOpenOnH === void 0 ? false : _ref$containerOpenOnH,
      _ref$wide = _ref.wide,
      wide = _ref$wide === void 0 ? false : _ref$wide,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'black' : _ref$color,
      _ref$transparency = _ref.transparency,
      transparency = _ref$transparency === void 0 ? 0.85 : _ref$transparency,
      render = _ref.render,
      portal = _ref.portal,
      label = _ref.label,
      title = _ref.title,
      wrapperClassName = _ref.wrapperClassName,
      className = _ref.className;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = React.useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      forceUpdate = _useState4[1];

  var timer = React.useRef(null);
  var containerHoverOver = React.useRef(null);
  var tooltipRoot = getRoot$1();
  var popperElement = React.useRef(null);
  var referenceElement = React.useRef(null);
  var modifiers = React.useMemo(function () {
    return [{
      name: 'preventOverflow',
      enabled: false
    }, {
      name: 'hide',
      enabled: false
    }, {
      name: 'offset',
      options: {
        offset: function offset() {
          return [0, OFFSET];
        }
      }
    }];
  }, []);

  var _usePopper = reactPopper.usePopper(referenceElement.current, popperElement.current, {
    placement: placements[position] || position,
    modifiers: modifiers
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes;

  var show = function show() {
    timer.current = setTimeout(function () {
      setOpen(true);
    }, delay);
  };

  var hide = function hide() {
    clearTimeout(timer.current);
    setTimeout(function () {
      containerOpenOnHover && containerHoverOver.current ? null : setOpen(false);
    }, containerOpenOnHover ? 200 : 0);
  };

  var containerEnter = function containerEnter() {
    if (open && containerOpenOnHover) {
      containerHoverOver.current = true;
      setOpen(true);
    }
  };

  var containerOut = function containerOut() {
    if (containerOpenOnHover) {
      containerHoverOver.current = false;
      setOpen(false);
    }
  };

  React.useLayoutEffect(function () {
    forceUpdate(new Date().getTime());
    return function () {
      return clearTimeout(timer.current);
    };
  }, []);
  var tooltip = /*#__PURE__*/React__default['default'].createElement(Container$f, _extends({
    open: open,
    wide: wide,
    ref: popperElement,
    portal: portal,
    colorName: color,
    transparency: transparency,
    position: position,
    className: className,
    onMouseEnter: containerEnter,
    onMouseLeave: containerOut,
    style: styles.popper
  }, attributes.popper), title && /*#__PURE__*/React__default['default'].createElement(Title$3, null, title), label);
  var reference = render({
    hide: hide,
    show: show,
    ref: referenceElement,
    renderTooltip: renderTooltip
  });
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, portal ? /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, reference, /*#__PURE__*/reactDom.createPortal(tooltip, tooltipRoot)) : /*#__PURE__*/React__default['default'].createElement(Wrapper$1, {
    className: wrapperClassName
  }, reference, tooltip));
};

Tooltip.propTypes = {
  position: PropTypes__default['default'].string,
  delay: PropTypes__default['default'].number,
  containerOpenOnHover: PropTypes__default['default'].bool,
  wide: PropTypes__default['default'].bool,
  color: PropTypes__default['default'].string,
  transparency: PropTypes__default['default'].number,
  render: PropTypes__default['default'].func,
  portal: PropTypes__default['default'].bool,
  label: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].element]),
  title: PropTypes__default['default'].string,
  wrapperClassName: PropTypes__default['default'].string,
  className: PropTypes__default['default'].string
};

var global = (function (styles) {
  return /*#__PURE__*/React__default['default'].createElement(core.Global, {
    styles: /*#__PURE__*/core.css("html{box-sizing:border-box;font-size:", theme.fvStyle.font.base, ";-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;}*,*:before,*:after{box-sizing:inherit;}body{font-family:'Roboto',sans-serif;color:", color('black', {
      theme: theme
    }), ";", typography('body2', {
      theme: theme
    }), ";}a{text-decoration:none;color:currentColor;transition:all 0.1s ease-in-out;touch-action:manipulation;}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:", spacer(2, {
      theme: theme
    }), ";}h1{", typography('headline3', {
      theme: theme
    }), ";}h2{", typography('headline2', {
      theme: theme
    }), ";}h3{", typography('headline1', {
      theme: theme
    }), ";}h4{", typography('title3', {
      theme: theme
    }), ";}h5{", typography('title2', {
      theme: theme
    }), ";}h6{", typography('title1', {
      theme: theme
    }), ";}strong{", fontWeight('bold', {
      theme: theme
    }), ";}p{margin-top:0;margin-bottom:", spacer(2, {
      theme: theme
    }), ";}label{color:", color('pewter', {
      theme: theme
    }), ";margin-bottom:", spacer(2, {
      theme: theme
    }), ";touch-action:manipulation;", typography('body1Medium', {
      theme: theme
    }), ";}", styles && styles(theme), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
  });
});

var grid = function grid(_ref) {
  var grid = _ref.grid;
  return grid && /*#__PURE__*/core.css("grid:", grid, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridArea = function gridArea(_ref2) {
  var gridArea = _ref2.gridArea;
  return gridArea && /*#__PURE__*/core.css("grid-area:", gridArea, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridGap = function gridGap(_ref3) {
  var gridGap = _ref3.gridGap;
  return gridGap && /*#__PURE__*/core.css("grid-gap:", gridGap, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridRow = function gridRow(_ref4) {
  var gridRow = _ref4.gridRow;
  return gridRow && /*#__PURE__*/core.css("grid-row:", gridRow, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkdyaWQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBdUJLIiwiZmlsZSI6IkdyaWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5cbmNvbnN0IGdyaWQgPSAoeyBncmlkIH0pID0+XG4gIGdyaWQgJiZcbiAgY3NzYFxuICAgIGdyaWQ6ICR7Z3JpZH07XG4gIGBcblxuY29uc3QgZ3JpZEFyZWEgPSAoeyBncmlkQXJlYSB9KSA9PlxuICBncmlkQXJlYSAmJlxuICBjc3NgXG4gICAgZ3JpZC1hcmVhOiAke2dyaWRBcmVhfTtcbiAgYFxuXG5jb25zdCBncmlkR2FwID0gKHsgZ3JpZEdhcCB9KSA9PlxuICBncmlkR2FwICYmXG4gIGNzc2BcbiAgICBncmlkLWdhcDogJHtncmlkR2FwfTtcbiAgYFxuXG5jb25zdCBncmlkUm93ID0gKHsgZ3JpZFJvdyB9KSA9PlxuICBncmlkUm93ICYmXG4gIGNzc2BcbiAgICBncmlkLXJvdzogJHtncmlkUm93fTtcbiAgYFxuXG5jb25zdCBncmlkQ29sdW1uID0gKHsgZ3JpZENvbHVtbiB9KSA9PlxuICBncmlkQ29sdW1uICYmXG4gIGNzc2BcbiAgICBncmlkLWNvbHVtbjogJHtncmlkQ29sdW1ufTtcbiAgYFxuXG5jb25zdCBncmlkVGVtcGxhdGUgPSAoeyBncmlkVGVtcGxhdGUgfSkgPT5cbiAgZ3JpZFRlbXBsYXRlICYmXG4gIGNzc2BcbiAgICBncmlkLXRlbXBsYXRlOiAke2dyaWRUZW1wbGF0ZX07XG4gIGBcblxuY29uc3QgZ3JpZFRlbXBsYXRlQ29sdW1ucyA9ICh7IGdyaWRUZW1wbGF0ZUNvbHVtbnMgfSkgPT5cbiAgZ3JpZFRlbXBsYXRlQ29sdW1ucyAmJlxuICBjc3NgXG4gICAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAke2dyaWRUZW1wbGF0ZUNvbHVtbnN9O1xuICBgXG5cbmNvbnN0IGdyaWRUZW1wbGF0ZVJvd3MgPSAoeyBncmlkVGVtcGxhdGVSb3dzIH0pID0+XG4gIGdyaWRUZW1wbGF0ZVJvd3MgJiZcbiAgY3NzYFxuICAgIGdyaWQtdGVtcGxhdGUtcm93czogJHtncmlkVGVtcGxhdGVSb3dzfTtcbiAgYFxuXG5jb25zdCBncmlkQXV0b0Zsb3cgPSAoeyBncmlkQXV0b0Zsb3cgfSkgPT5cbiAgZ3JpZEF1dG9GbG93ICYmXG4gIGNzc2BcbiAgICBncmlkLWF1dG8tZmxvdzogJHtncmlkQXV0b0Zsb3d9O1xuICBgXG5cbmNvbnN0IGdyaWRBdXRvUm93cyA9ICh7IGdyaWRBdXRvUm93cyB9KSA9PlxuICBncmlkQXV0b1Jvd3MgJiZcbiAgY3NzYFxuICAgIGdyaWQtYXV0by1yb3dzOiAke2dyaWRBdXRvUm93c307XG4gIGBcblxuY29uc3QgZ3JpZEF1dG9Db2x1bW5zID0gKHsgZ3JpZEF1dG9Db2x1bW5zIH0pID0+XG4gIGdyaWRBdXRvQ29sdW1ucyAmJlxuICBjc3NgXG4gICAgZ3JpZC1hdXRvLWNvbHVtbnM6ICR7Z3JpZEF1dG9Db2x1bW5zfTtcbiAgYFxuXG4vLyBBbGlnbm1lbnRcblxuY29uc3QganVzdGlmeUl0ZW1zID0gKHsganVzdGlmeUl0ZW1zIH0pID0+XG4gIGp1c3RpZnlJdGVtcyAmJlxuICBjc3NgXG4gICAganVzdGlmeS1pdGVtczogJHtqdXN0aWZ5SXRlbXN9O1xuICBgXG5cbmNvbnN0IGp1c3RpZnlDb250ZW50ID0gKHsganVzdGlmeUNvbnRlbnQgfSkgPT5cbiAganVzdGlmeUNvbnRlbnQgJiZcbiAgY3NzYFxuICAgIGp1c3RpZnktY29udGVudDogJHtqdXN0aWZ5Q29udGVudH07XG4gIGBcblxuY29uc3QgYWxpZ25JdGVtcyA9ICh7IGFsaWduSXRlbXMgfSkgPT5cbiAgYWxpZ25JdGVtcyAmJlxuICBjc3NgXG4gICAgYWxpZ24taXRlbXM6ICR7YWxpZ25JdGVtc307XG4gIGBcblxuY29uc3QgYWxpZ25Db250ZW50ID0gKHsgYWxpZ25Db250ZW50IH0pID0+XG4gIGFsaWduQ29udGVudCAmJlxuICBjc3NgXG4gICAgYWxpZ24tY29udGVudDogJHthbGlnbkNvbnRlbnR9O1xuICBgXG5cbmNvbnN0IEdyaWQgPSBzdHlsZWQuZGl2YFxuICBkaXNwbGF5OiBncmlkO1xuICAke2dyaWR9O1xuICAke2dyaWRBcmVhfTtcbiAgJHtncmlkR2FwfTtcbiAgJHtncmlkVGVtcGxhdGV9O1xuICAke2dyaWRUZW1wbGF0ZUNvbHVtbnN9O1xuICAke2dyaWRUZW1wbGF0ZVJvd3N9O1xuICAke2dyaWRSb3d9O1xuICAke2dyaWRDb2x1bW59O1xuICAke2dyaWRBdXRvRmxvd307XG4gICR7Z3JpZEF1dG9Db2x1bW5zfTtcbiAgJHtncmlkQXV0b1Jvd3N9O1xuICAke2p1c3RpZnlJdGVtc307XG4gICR7anVzdGlmeUNvbnRlbnR9O1xuICAke2FsaWduSXRlbXN9O1xuICAke2FsaWduQ29udGVudH07XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEdyaWRcbiJdfQ== */"));
};

var gridColumn = function gridColumn(_ref5) {
  var gridColumn = _ref5.gridColumn;
  return gridColumn && /*#__PURE__*/core.css("grid-column:", gridColumn, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridTemplate = function gridTemplate(_ref6) {
  var gridTemplate = _ref6.gridTemplate;
  return gridTemplate && /*#__PURE__*/core.css("grid-template:", gridTemplate, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridTemplateColumns = function gridTemplateColumns(_ref7) {
  var gridTemplateColumns = _ref7.gridTemplateColumns;
  return gridTemplateColumns && /*#__PURE__*/core.css("grid-template-columns:", gridTemplateColumns, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridTemplateRows = function gridTemplateRows(_ref8) {
  var gridTemplateRows = _ref8.gridTemplateRows;
  return gridTemplateRows && /*#__PURE__*/core.css("grid-template-rows:", gridTemplateRows, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridAutoFlow = function gridAutoFlow(_ref9) {
  var gridAutoFlow = _ref9.gridAutoFlow;
  return gridAutoFlow && /*#__PURE__*/core.css("grid-auto-flow:", gridAutoFlow, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridAutoRows = function gridAutoRows(_ref10) {
  var gridAutoRows = _ref10.gridAutoRows;
  return gridAutoRows && /*#__PURE__*/core.css("grid-auto-rows:", gridAutoRows, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var gridAutoColumns = function gridAutoColumns(_ref11) {
  var gridAutoColumns = _ref11.gridAutoColumns;
  return gridAutoColumns && /*#__PURE__*/core.css("grid-auto-columns:", gridAutoColumns, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
}; // Alignment


var justifyItems = function justifyItems(_ref12) {
  var justifyItems = _ref12.justifyItems;
  return justifyItems && /*#__PURE__*/core.css("justify-items:", justifyItems, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var justifyContent = function justifyContent(_ref13) {
  var justifyContent = _ref13.justifyContent;
  return justifyContent && /*#__PURE__*/core.css("justify-content:", justifyContent, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var alignItems = function alignItems(_ref14) {
  var alignItems = _ref14.alignItems;
  return alignItems && /*#__PURE__*/core.css("align-items:", alignItems, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var alignContent = function alignContent(_ref15) {
  var alignContent = _ref15.alignContent;
  return alignContent && /*#__PURE__*/core.css("align-content:", alignContent, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var Grid = createStyled("div", {
  target: "e1y8n9000",
  label: "Grid"
})("display:grid;", grid, ";", gridArea, ";", gridGap, ";", gridTemplate, ";", gridTemplateColumns, ";", gridTemplateRows, ";", gridRow, ";", gridColumn, ";", gridAutoFlow, ";", gridAutoColumns, ";", gridAutoRows, ";", justifyItems, ";", justifyContent, ";", alignItems, ";", alignContent, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$B() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var NavContainer = createStyled("div", {
  target: "ewpxmvw0",
  label: "NavContainer"
})("display:flex;justify-content:center;width:100%;", function (_ref) {
  var theme = _ref.theme,
      dark = _ref.dark;
  return /*#__PURE__*/core.css("background-color:", color(dark ? 'ink' : 'white', {
    theme: theme
  }), ";a:not(", ItemLink, "){&,&:hover{color:", color(dark ? 'white' : 'ink', {
    theme: theme
  }), ";}};label:NavContainer;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Nav = createStyled("nav", {
  target: "ewpxmvw1",
  label: "Nav"
})("display:flex;align-items:center;padding-left:", spacer(4), ";padding-right:", spacer(4), ";height:70px;", responsiveContainer, ";@supports (display:grid){display:grid;grid-template-columns:auto 1fr;grid-template-rows:70px;height:auto;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var NavItem$1 = createStyled("div", {
  target: "ewpxmvw2",
  label: "NavItem"
})( true ? {
  name: "4mjo1p",
  styles: "&:nth-of-type(2){display:flex;justify-content:flex-end;flex:1;}@supports (display:grid){&:nth-of-type(2){display:grid;justify-content:end;grid-auto-flow:column;}}"
} : {
  name: "4mjo1p",
  styles: "&:nth-of-type(2){display:flex;justify-content:flex-end;flex:1;}@supports (display:grid){&:nth-of-type(2){display:grid;justify-content:end;grid-auto-flow:column;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$B
});

var Navbar = function Navbar(_ref2) {
  var children = _ref2.children,
      dark = _ref2.dark,
      fluid = _ref2.fluid,
      homeRoute = _ref2.homeRoute;
  return /*#__PURE__*/React__default['default'].createElement(NavContainer, {
    dark: dark
  }, /*#__PURE__*/React__default['default'].createElement(Nav, {
    fluid: fluid
  }, /*#__PURE__*/React__default['default'].createElement(NavItem$1, null, /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Link, {
    to: homeRoute
  }, /*#__PURE__*/React__default['default'].createElement(ForstaLogo, {
    size: "sm",
    dark: dark
  }))), /*#__PURE__*/React__default['default'].createElement(NavItem$1, null, children)));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$C() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Container$g = createStyled("ul", {
  target: "ecsw2jx0",
  label: "Container"
})( true ? {
  name: "dlxhph",
  styles: "border-bottom:0;display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none;"
} : {
  name: "dlxhph",
  styles: "border-bottom:0;display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHMkIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyB0eXBvZ3JhcGh5IH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBDb250YWluZXIgPSBzdHlsZWQudWxgXG4gIGJvcmRlci1ib3R0b206IDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgcGFkZGluZy1sZWZ0OiAwO1xuICBtYXJnaW4tYm90dG9tOiAwO1xuICBsaXN0LXN0eWxlOiBub25lO1xuYFxuXG5Db250YWluZXIuZGlzcGxheU5hbWUgPSAnVGFicy5Db250YWluZXInXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$C
});

Container$g.displayName = 'Tabs.Container';

var TabContainer = createStyled("li", {
  target: "ermi7160",
  label: "TabContainer"
})("padding:0 ", spacer(4), ";&:first-of-type{padding-left:0;}&:last-of-type{padding-right:0;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHOEIiLCJmaWxlIjoiVGFiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IFRhYkNvbnRhaW5lciA9IHN0eWxlZC5saWBcbiAgcGFkZGluZzogMCAke3NwYWNlcig0KX07XG5cbiAgJjpmaXJzdC1vZi10eXBlIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDA7XG4gIH1cblxuICAmOmxhc3Qtb2YtdHlwZSB7XG4gICAgcGFkZGluZy1yaWdodDogMDtcbiAgfVxuYFxuXG5leHBvcnQgZGVmYXVsdCBUYWJDb250YWluZXJcbiJdfQ== */"));

var activeCss$1 = function activeCss(_ref) {
  var dark = _ref.dark,
      theme = _ref.theme;
  return "\n  && {\n    color: ".concat(color(dark ? 'white' : 'ink', {
    theme: theme
  }), ";\n    border-bottom-color: ").concat(color('brandGreen', {
    theme: theme
  }), ";\n    &:hover {\n      border-bottom-color: ").concat(transparentize('brandGreen', 0, {
    theme: theme
  }), ";\n    }\n  }\n");
};

var StyledNavLink = /*#__PURE__*/createStyled(reactRouterDom.NavLink, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "dark";
  },
  target: "et7fef20",
  label: "StyledNavLink"
})("color:", function (_ref2) {
  var dark = _ref2.dark;
  return dark ? transparentize('offWhite', 0.5) : color('pewter');
}, ";padding:", spacer(2), " 0;border-bottom:2px solid transparent;display:block;cursor:pointer;transition:all 0.1s ease-in-out;", typography('subheading2'), ";&:hover{color:", function (_ref3) {
  var dark = _ref3.dark;
  return color(dark ? 'white' : 'ink');
}, ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYk5hdkxpbmsuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJFIiwiZmlsZSI6IlRhYk5hdkxpbmsuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IENsYXNzTmFtZXMgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgd2l0aFRoZW1lIH0gZnJvbSAnZW1vdGlvbi10aGVtaW5nJ1xuaW1wb3J0IHsgY29sb3IsIHNwYWNlciwgdHJhbnNwYXJlbnRpemUsIHR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5pbXBvcnQgeyBOYXZMaW5rIH0gZnJvbSAncmVhY3Qtcm91dGVyLWRvbSdcblxuY29uc3QgYWN0aXZlQ3NzID0gKHsgZGFyaywgdGhlbWUgfSkgPT4gYFxuICAmJiB7XG4gICAgY29sb3I6ICR7Y29sb3IoZGFyayA/ICd3aGl0ZScgOiAnaW5rJywgeyB0aGVtZSB9KX07XG4gICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHtjb2xvcignYnJhbmRHcmVlbicsIHsgdGhlbWUgfSl9O1xuICAgICY6aG92ZXIge1xuICAgICAgYm9yZGVyLWJvdHRvbS1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYnJhbmRHcmVlbicsIDAsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgfVxuYFxuXG5jb25zdCBTdHlsZWROYXZMaW5rID0gc3R5bGVkKE5hdkxpbmssIHtcbiAgc2hvdWxkRm9yd2FyZFByb3A6IHByb3AgPT4gcHJvcCAhPT0gXCJkYXJrXCJcbn0pYFxuICBjb2xvcjogJHsoeyBkYXJrIH0pID0+XG4gICAgZGFyayA/IHRyYW5zcGFyZW50aXplKCdvZmZXaGl0ZScsIDAuNSkgOiBjb2xvcigncGV3dGVyJyl9O1xuICBwYWRkaW5nOiAke3NwYWNlcigyKX0gMDtcbiAgYm9yZGVyLWJvdHRvbTogMnB4IHNvbGlkIHRyYW5zcGFyZW50O1xuICBkaXNwbGF5OiBibG9jaztcbiAgY3Vyc29yOiBwb2ludGVyO1xuICB0cmFuc2l0aW9uOiBhbGwgMC4xcyBlYXNlLWluLW91dDtcblxuICAke3R5cG9ncmFwaHkoJ3N1YmhlYWRpbmcyJyl9O1xuXG4gICY6aG92ZXIge1xuICAgIGNvbG9yOiAkeyh7IGRhcmsgfSkgPT4gY29sb3IoZGFyayA/ICd3aGl0ZScgOiAnaW5rJyl9O1xuICB9XG5gXG5cbmNvbnN0IFRhYnNOYXZMaW5rID0gKHsgZGFyaywgdGhlbWUsIC4uLnJlc3QgfSkgPT4gKFxuICA8Q2xhc3NOYW1lcz5cbiAgICB7KHsgY3NzIH0pID0+IChcbiAgICAgIDxTdHlsZWROYXZMaW5rIGFjdGl2ZUNsYXNzTmFtZT17Y3NzKGFjdGl2ZUNzcyh7IGRhcmssIHRoZW1lIH0pKX0gZGFyaz17ZGFya30gey4uLnJlc3R9IC8+XG4gICAgKX1cbiAgPC9DbGFzc05hbWVzPlxuKVxuXG5leHBvcnQgZGVmYXVsdCB3aXRoVGhlbWUoVGFic05hdkxpbmspXG4iXX0= */"));

var TabsNavLink = function TabsNavLink(_ref4) {
  var dark = _ref4.dark,
      theme = _ref4.theme,
      rest = _objectWithoutProperties(_ref4, ["dark", "theme"]);

  return /*#__PURE__*/React__default['default'].createElement(core.ClassNames, null, function (_ref5) {
    var css = _ref5.css;
    return /*#__PURE__*/React__default['default'].createElement(StyledNavLink, _extends({
      activeClassName: css(activeCss$1({
        dark: dark,
        theme: theme
      })),
      dark: dark
    }, rest));
  });
};

var TabNavLink = emotionTheming.withTheme(TabsNavLink);

var Caret$2 = /*#__PURE__*/createStyled(Caret, {
  target: "ew2dkgs0",
  label: "Caret"
})("margin-left:", spacer(1), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRyb3Bkb3duSXRlbS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRK0IiLCJmaWxlIjoiRHJvcGRvd25JdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENoaWxkcmVuIH0gZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCBDYXJldEljb24gZnJvbSAnLi4vaWNvbnMvQ2FyZXQnXG5pbXBvcnQgRHJvcGRvd25NZW51IGZyb20gJy4uL0Ryb3Bkb3duTWVudSdcbmltcG9ydCBUYWJDb250YWluZXIgZnJvbSAnLi9UYWJDb250YWluZXInXG5pbXBvcnQgVGFiTmF2TGluayBmcm9tICcuL1RhYk5hdkxpbmsnXG5pbXBvcnQgeyBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IENhcmV0ID0gc3R5bGVkKENhcmV0SWNvbilgXG4gIG1hcmdpbi1sZWZ0OiAke3NwYWNlcigxKX07XG5gXG5cbmNvbnN0IGlzQWN0aXZlID0gY2hpbGRyZW4gPT4gKG1hdGNoLCBsb2NhdGlvbikgPT5cbiAgQ2hpbGRyZW4udG9BcnJheShjaGlsZHJlbilcbiAgICAuZmlsdGVyKEJvb2xlYW4pXG4gICAgLnNvbWUoKHsgcHJvcHMgfSkgPT4gcHJvcHMudG8gPT09IGxvY2F0aW9uLnBhdGhuYW1lKVxuXG5jb25zdCBEcm9wZG93bkl0ZW0gPSAoeyBjaGlsZHJlbiwgZGFyaywgdGV4dCwgLi4ucHJvcHMgfSkgPT4gKFxuICA8VGFiQ29udGFpbmVyPlxuICAgIDxEcm9wZG93bk1lbnVcbiAgICAgIHsuLi5wcm9wc31cbiAgICAgIHRyaWdnZXI9e3RvZ2dsZSA9PiAoXG4gICAgICAgIDxUYWJOYXZMaW5rXG4gICAgICAgICAgdG89XCJcIlxuICAgICAgICAgIGRhcms9e2Rhcmt9XG4gICAgICAgICAgb25DbGljaz17ZSA9PiB7XG4gICAgICAgICAgICBlLnByZXZlbnREZWZhdWx0KClcbiAgICAgICAgICAgIHRvZ2dsZSgpXG4gICAgICAgICAgfX1cbiAgICAgICAgICBpc0FjdGl2ZT17aXNBY3RpdmUoY2hpbGRyZW4pfVxuICAgICAgICA+XG4gICAgICAgICAge3RleHR9XG4gICAgICAgICAgPENhcmV0IHNpemU9XCIwLjVyZW1cIiAvPlxuICAgICAgICA8L1RhYk5hdkxpbms+XG4gICAgICApfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbn1cbiAgICA8L0Ryb3Bkb3duTWVudT5cbiAgPC9UYWJDb250YWluZXI+XG4pXG5cbmV4cG9ydCBkZWZhdWx0IERyb3Bkb3duSXRlbVxuIl19 */"));

var isActive = function isActive(children) {
  return function (match, location) {
    return React.Children.toArray(children).filter(Boolean).some(function (_ref) {
      var props = _ref.props;
      return props.to === location.pathname;
    });
  };
};

var DropdownItem = function DropdownItem(_ref2) {
  var children = _ref2.children,
      dark = _ref2.dark,
      text = _ref2.text,
      props = _objectWithoutProperties(_ref2, ["children", "dark", "text"]);

  return /*#__PURE__*/React__default['default'].createElement(TabContainer, null, /*#__PURE__*/React__default['default'].createElement(DropdownMenu, _extends({}, props, {
    trigger: function trigger(toggle) {
      return /*#__PURE__*/React__default['default'].createElement(TabNavLink, {
        to: "",
        dark: dark,
        onClick: function onClick(e) {
          e.preventDefault();
          toggle();
        },
        isActive: isActive(children)
      }, text, /*#__PURE__*/React__default['default'].createElement(Caret$2, {
        size: "0.5rem"
      }));
    }
  }), children));
};

var TabsItem = function TabsItem(_ref) {
  var children = _ref.children,
      dark = _ref.dark,
      props = _objectWithoutProperties(_ref, ["children", "dark"]);

  return /*#__PURE__*/React__default['default'].createElement(TabContainer, null, /*#__PURE__*/React__default['default'].createElement(TabNavLink, _extends({}, props, {
    dark: dark
  }), children));
};

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      dark = _ref.dark,
      props = _objectWithoutProperties(_ref, ["children", "dark"]);

  return /*#__PURE__*/React__default['default'].createElement(Container$g, props, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
      dark: dark
    }) : child;
  }));
};

Tabs.Item = TabsItem;
Tabs.DropdownItem = DropdownItem;

var Col = recompose.defaultProps({
  gridAutoRows: 'min-content',
  gridAutoFlow: 'row'
})(Grid);

var withClass = (function (klassName) {
  return withProps__default['default'](function (_ref) {
    var className = _ref.className;
    return {
      className: "".concat(className || '', " ").concat(klassName)
    };
  });
});

var StyledRow = /*#__PURE__*/createStyled(Row, {
  target: "e1men3s90",
  label: "StyledRow"
})("background-color:", function (_ref) {
  var dark = _ref.dark;
  return color(dark ? 'ink' : 'white');
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWE2QiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHdpdGhUaGVtZSB9IGZyb20gJ2Vtb3Rpb24tdGhlbWluZydcbmltcG9ydCBDb250YWluZXIgZnJvbSAnLi4vQ29udGFpbmVyJ1xuaW1wb3J0IFJvdyBmcm9tICcuLi9Sb3cnXG5pbXBvcnQgVGFicyBmcm9tICcuLi9UYWJzJ1xuaW1wb3J0IHsgQ29sIH0gZnJvbSAnLi4vR3JpZHMnXG5pbXBvcnQgeyBjb2xvciwgc3BhY2VyLCB0eXBvZ3JhcGh5IH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuaW1wb3J0IHsgTmF2TGluayB9IGZyb20gJ3JlYWN0LXJvdXRlci1kb20nXG5pbXBvcnQgeyBjb21wb3NlLCB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnXG5pbXBvcnQgd2l0aENsYXNzIGZyb20gJy4uLy4uL3V0aWxzL3dpdGhDbGFzcydcblxuY29uc3QgU3R5bGVkUm93ID0gc3R5bGVkKFJvdylgXG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgZGFyayB9KSA9PiBjb2xvcihkYXJrID8gJ2luaycgOiAnd2hpdGUnKX07XG5gXG5cbmNvbnN0IE5hdmJhclNlY29uZGFyeSA9ICh7IGNoaWxkcmVuLCBmbHVpZCwgZGFyaywgLi4ucmVzdCB9KSA9PiAoXG4gIDxTdHlsZWRSb3cgZGFyaz17ZGFya30gey4uLnJlc3R9PlxuICAgIDxDb250YWluZXIgZmx1aWQ9e2ZsdWlkfT5cbiAgICAgIDxDb2wgZ3JpZEF1dG9GbG93PVwiY29sdW1uXCI+XG4gICAgICAgIDxuYXY+XG4gICAgICAgICAgPFRhYnMgZGFyaz17ZGFya30+e2NoaWxkcmVufTwvVGFicz5cbiAgICAgICAgPC9uYXY+XG4gICAgICA8L0NvbD5cbiAgICA8L0NvbnRhaW5lcj5cbiAgPC9TdHlsZWRSb3c+XG4pXG5cbk5hdmJhclNlY29uZGFyeS5OYXZJdGVtID0gVGFicy5JdGVtXG5OYXZiYXJTZWNvbmRhcnkuRHJvcGRvd25JdGVtID0gVGFicy5Ecm9wZG93bkl0ZW1cblxuZXhwb3J0IGRlZmF1bHQgTmF2YmFyU2Vjb25kYXJ5XG4iXX0= */"));

var NavbarSecondary = function NavbarSecondary(_ref2) {
  var children = _ref2.children,
      fluid = _ref2.fluid,
      dark = _ref2.dark,
      rest = _objectWithoutProperties(_ref2, ["children", "fluid", "dark"]);

  return /*#__PURE__*/React__default['default'].createElement(StyledRow, _extends({
    dark: dark
  }, rest), /*#__PURE__*/React__default['default'].createElement(Container$3, {
    fluid: fluid
  }, /*#__PURE__*/React__default['default'].createElement(Col, {
    gridAutoFlow: "column"
  }, /*#__PURE__*/React__default['default'].createElement("nav", null, /*#__PURE__*/React__default['default'].createElement(Tabs, {
    dark: dark
  }, children)))));
};

NavbarSecondary.NavItem = Tabs.Item;
NavbarSecondary.DropdownItem = Tabs.DropdownItem;

var Header$2 = /*#__PURE__*/createStyled('div', {
  target: "egsom8c0",
  label: "Header"
})(padding('xs'), ";h6{margin-bottom:0;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJNEIiLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBwYWRkaW5nIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBIZWFkZXIgPSBzdHlsZWQoJ2RpdicpYFxuICAke3BhZGRpbmcoJ3hzJyl9O1xuXG4gIGg2IHtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuICB9XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEhlYWRlclxuIl19 */"));

var withPadding = function withPadding(_ref) {
  var theme = _ref.theme,
      pad = _ref.pad;
  return pad && /*#__PURE__*/core.css(padding('xs', {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0siLCJmaWxlIjoiSXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHBhZGRpbmcsIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgd2l0aFBhZGRpbmcgPSAoeyB0aGVtZSwgcGFkIH0pID0+XG4gIHBhZCAmJlxuICBjc3NgXG4gICAgJHtwYWRkaW5nKCd4cycsIHsgdGhlbWUgfSl9O1xuICBgXG5cbmNvbnN0IHdpdGhQYWRkaW5nWSA9ICh7IHRoZW1lLCBwYWRZIH0pID0+XG4gIHBhZFkgJiZcbiAgY3NzYFxuICAgIHBhZGRpbmctdG9wOiAke3NwYWNlcigzLCB7IHRoZW1lIH0pfTtcbiAgICBwYWRkaW5nLWJvdHRvbTogJHtzcGFjZXIoMywgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgSXRlbSA9IHN0eWxlZCgnZGl2JylgXG4gICR7d2l0aFBhZGRpbmd9O1xuICAke3dpdGhQYWRkaW5nWX07XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEl0ZW1cbiJdfQ== */"));
};

var withPaddingY = function withPaddingY(_ref2) {
  var theme = _ref2.theme,
      padY = _ref2.padY;
  return padY && /*#__PURE__*/core.css("padding-top:", spacer(3, {
    theme: theme
  }), ";padding-bottom:", spacer(3, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYUsiLCJmaWxlIjoiSXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7IHBhZGRpbmcsIHNwYWNlciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3Qgd2l0aFBhZGRpbmcgPSAoeyB0aGVtZSwgcGFkIH0pID0+XG4gIHBhZCAmJlxuICBjc3NgXG4gICAgJHtwYWRkaW5nKCd4cycsIHsgdGhlbWUgfSl9O1xuICBgXG5cbmNvbnN0IHdpdGhQYWRkaW5nWSA9ICh7IHRoZW1lLCBwYWRZIH0pID0+XG4gIHBhZFkgJiZcbiAgY3NzYFxuICAgIHBhZGRpbmctdG9wOiAke3NwYWNlcigzLCB7IHRoZW1lIH0pfTtcbiAgICBwYWRkaW5nLWJvdHRvbTogJHtzcGFjZXIoMywgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgSXRlbSA9IHN0eWxlZCgnZGl2JylgXG4gICR7d2l0aFBhZGRpbmd9O1xuICAke3dpdGhQYWRkaW5nWX07XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEl0ZW1cbiJdfQ== */"));
};

var Item$4 = /*#__PURE__*/createStyled('div', {
  target: "e7agfjs0",
  label: "Item"
})(withPadding, ";", withPaddingY, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkl0ZW0uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0IwQiIsImZpbGUiOiJJdGVtLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgcGFkZGluZywgc3BhY2VyIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCB3aXRoUGFkZGluZyA9ICh7IHRoZW1lLCBwYWQgfSkgPT5cbiAgcGFkICYmXG4gIGNzc2BcbiAgICAke3BhZGRpbmcoJ3hzJywgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3Qgd2l0aFBhZGRpbmdZID0gKHsgdGhlbWUsIHBhZFkgfSkgPT5cbiAgcGFkWSAmJlxuICBjc3NgXG4gICAgcGFkZGluZy10b3A6ICR7c3BhY2VyKDMsIHsgdGhlbWUgfSl9O1xuICAgIHBhZGRpbmctYm90dG9tOiAke3NwYWNlcigzLCB7IHRoZW1lIH0pfTtcbiAgYFxuXG5jb25zdCBJdGVtID0gc3R5bGVkKCdkaXYnKWBcbiAgJHt3aXRoUGFkZGluZ307XG4gICR7d2l0aFBhZGRpbmdZfTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgSXRlbVxuIl19 */"));

var Empty = /*#__PURE__*/createStyled(Item$4, {
  target: "eiajbqa0",
  label: "Empty"
})("text-align:center;color:", color('cadet'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkVtcHR5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUkwQiIsImZpbGUiOiJFbXB0eS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IEl0ZW0gZnJvbSAnLi9JdGVtJ1xuaW1wb3J0IHsgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IEVtcHR5ID0gc3R5bGVkKEl0ZW0pYFxuICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIGNvbG9yOiAke2NvbG9yKCdjYWRldCcpfTtcbmBcblxuZXhwb3J0IGRlZmF1bHQgRW1wdHlcbiJdfQ== */"));

var Footer$2 = /*#__PURE__*/createStyled('div', {
  target: "ervq2v60",
  label: "Footer"
})(padding('xs'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZvb3Rlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJNEIiLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBwYWRkaW5nIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBGb290ZXIgPSBzdHlsZWQoJ2RpdicpYFxuICAke3BhZGRpbmcoJ3hzJyl9O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBGb290ZXJcbiJdfQ== */"));

var dividers = function dividers(_ref) {
  var dividers = _ref.dividers,
      theme = _ref.theme;
  return dividers && /*#__PURE__*/core.css(".box-item + .box-item,.box-header + .box-item,.box-item + .box-footer{border-top:1px solid ", color('paleGrey', {
    theme: theme
  }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWlCSyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIGNvbG9yLFxuICBzaGFkb3csXG4gIHNwYWNlcixcbiAgYm9yZGVyUmFkaXVzLFxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5pbXBvcnQgd2l0aENsYXNzIGZyb20gJy4uLy4uL3V0aWxzL3dpdGhDbGFzcydcbmltcG9ydCBIZWFkZXIgZnJvbSAnLi9IZWFkZXInXG5pbXBvcnQgSXRlbSBmcm9tICcuL0l0ZW0nXG5pbXBvcnQgRW1wdHkgZnJvbSAnLi9FbXB0eSdcbmltcG9ydCBGb290ZXIgZnJvbSAnLi9Gb290ZXInXG5cbmNvbnN0IGRpdmlkZXJzID0gKHsgZGl2aWRlcnMsIHRoZW1lIH0pID0+XG4gIGRpdmlkZXJzICYmXG4gIGNzc2BcbiAgICAuYm94LWl0ZW0gKyAuYm94LWl0ZW0sXG4gICAgLmJveC1oZWFkZXIgKyAuYm94LWl0ZW0sXG4gICAgLmJveC1pdGVtICsgLmJveC1mb290ZXIge1xuICAgICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICR7Y29sb3IoJ3BhbGVHcmV5JywgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgXG5cbmNvbnN0IGdob3N0ID0gKHsgZ2hvc3QsIHRoZW1lIH0pID0+XG4gICFnaG9zdCAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZDogJHtjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAke3NoYWRvdygnc3VidGxlJywgeyB0aGVtZSB9KX07XG4gICAgJHtib3JkZXJSYWRpdXMoJ3NtJywgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgZGFyayA9ICh7IGRhcmssIHRoZW1lIH0pID0+XG4gIGRhcmsgJiZcbiAgY3NzYFxuICAgIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScsIHsgdGhlbWUgfSl9O1xuXG4gICAgLmJveC1pdGVtICsgLmJveC1pdGVtLFxuICAgIC5ib3gtaGVhZGVyICsgLmJveC1pdGVtLFxuICAgIC5ib3gtaXRlbSArIC5ib3gtZm9vdGVyIHtcbiAgICAgIGJvcmRlci10b3AtY29sb3I6ICR7Y29sb3IoJ3Bld3RlcicsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYFxuXG5jb25zdCBCb3ggPSBzdHlsZWQoJ2RpdicpYFxuICAmICsgJiB7XG4gICAgbWFyZ2luLXRvcDogJHtzcGFjZXIoJ3NtJyl9O1xuICB9XG5cbiAgJHtnaG9zdH07XG4gICR7ZGl2aWRlcnN9O1xuICAke2Rhcmt9O1xuYFxuXG5Cb3guSGVhZGVyID0gd2l0aENsYXNzKCdib3gtaGVhZGVyJykoSGVhZGVyKVxuQm94Lkl0ZW0gPSB3aXRoQ2xhc3MoJ2JveC1pdGVtJykoSXRlbSlcbkJveC5FbXB0eSA9IHdpdGhDbGFzcygnYm94LWl0ZW0nKShFbXB0eSlcbkJveC5Gb290ZXIgPSB3aXRoQ2xhc3MoJ2JveC1mb290ZXInKShGb290ZXIpXG5cbmV4cG9ydCBkZWZhdWx0IEJveFxuIl19 */"));
};

var ghost = function ghost(_ref2) {
  var ghost = _ref2.ghost,
      theme = _ref2.theme;
  return !ghost && /*#__PURE__*/core.css("background:", color('white', {
    theme: theme
  }), ";", shadow('subtle', {
    theme: theme
  }), ";", borderRadius('sm', {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTJCSyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIGNvbG9yLFxuICBzaGFkb3csXG4gIHNwYWNlcixcbiAgYm9yZGVyUmFkaXVzLFxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5pbXBvcnQgd2l0aENsYXNzIGZyb20gJy4uLy4uL3V0aWxzL3dpdGhDbGFzcydcbmltcG9ydCBIZWFkZXIgZnJvbSAnLi9IZWFkZXInXG5pbXBvcnQgSXRlbSBmcm9tICcuL0l0ZW0nXG5pbXBvcnQgRW1wdHkgZnJvbSAnLi9FbXB0eSdcbmltcG9ydCBGb290ZXIgZnJvbSAnLi9Gb290ZXInXG5cbmNvbnN0IGRpdmlkZXJzID0gKHsgZGl2aWRlcnMsIHRoZW1lIH0pID0+XG4gIGRpdmlkZXJzICYmXG4gIGNzc2BcbiAgICAuYm94LWl0ZW0gKyAuYm94LWl0ZW0sXG4gICAgLmJveC1oZWFkZXIgKyAuYm94LWl0ZW0sXG4gICAgLmJveC1pdGVtICsgLmJveC1mb290ZXIge1xuICAgICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICR7Y29sb3IoJ3BhbGVHcmV5JywgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgXG5cbmNvbnN0IGdob3N0ID0gKHsgZ2hvc3QsIHRoZW1lIH0pID0+XG4gICFnaG9zdCAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZDogJHtjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAke3NoYWRvdygnc3VidGxlJywgeyB0aGVtZSB9KX07XG4gICAgJHtib3JkZXJSYWRpdXMoJ3NtJywgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgZGFyayA9ICh7IGRhcmssIHRoZW1lIH0pID0+XG4gIGRhcmsgJiZcbiAgY3NzYFxuICAgIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScsIHsgdGhlbWUgfSl9O1xuXG4gICAgLmJveC1pdGVtICsgLmJveC1pdGVtLFxuICAgIC5ib3gtaGVhZGVyICsgLmJveC1pdGVtLFxuICAgIC5ib3gtaXRlbSArIC5ib3gtZm9vdGVyIHtcbiAgICAgIGJvcmRlci10b3AtY29sb3I6ICR7Y29sb3IoJ3Bld3RlcicsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYFxuXG5jb25zdCBCb3ggPSBzdHlsZWQoJ2RpdicpYFxuICAmICsgJiB7XG4gICAgbWFyZ2luLXRvcDogJHtzcGFjZXIoJ3NtJyl9O1xuICB9XG5cbiAgJHtnaG9zdH07XG4gICR7ZGl2aWRlcnN9O1xuICAke2Rhcmt9O1xuYFxuXG5Cb3guSGVhZGVyID0gd2l0aENsYXNzKCdib3gtaGVhZGVyJykoSGVhZGVyKVxuQm94Lkl0ZW0gPSB3aXRoQ2xhc3MoJ2JveC1pdGVtJykoSXRlbSlcbkJveC5FbXB0eSA9IHdpdGhDbGFzcygnYm94LWl0ZW0nKShFbXB0eSlcbkJveC5Gb290ZXIgPSB3aXRoQ2xhc3MoJ2JveC1mb290ZXInKShGb290ZXIpXG5cbmV4cG9ydCBkZWZhdWx0IEJveFxuIl19 */"));
};

var dark = function dark(_ref3) {
  var dark = _ref3.dark,
      theme = _ref3.theme;
  return dark && /*#__PURE__*/core.css("color:", color('white', {
    theme: theme
  }), ";.box-item + .box-item,.box-header + .box-item,.box-item + .box-footer{border-top-color:", color('pewter', {
    theme: theme
  }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW1DSyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcbmltcG9ydCB7XG4gIGNvbG9yLFxuICBzaGFkb3csXG4gIHNwYWNlcixcbiAgYm9yZGVyUmFkaXVzLFxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5pbXBvcnQgd2l0aENsYXNzIGZyb20gJy4uLy4uL3V0aWxzL3dpdGhDbGFzcydcbmltcG9ydCBIZWFkZXIgZnJvbSAnLi9IZWFkZXInXG5pbXBvcnQgSXRlbSBmcm9tICcuL0l0ZW0nXG5pbXBvcnQgRW1wdHkgZnJvbSAnLi9FbXB0eSdcbmltcG9ydCBGb290ZXIgZnJvbSAnLi9Gb290ZXInXG5cbmNvbnN0IGRpdmlkZXJzID0gKHsgZGl2aWRlcnMsIHRoZW1lIH0pID0+XG4gIGRpdmlkZXJzICYmXG4gIGNzc2BcbiAgICAuYm94LWl0ZW0gKyAuYm94LWl0ZW0sXG4gICAgLmJveC1oZWFkZXIgKyAuYm94LWl0ZW0sXG4gICAgLmJveC1pdGVtICsgLmJveC1mb290ZXIge1xuICAgICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICR7Y29sb3IoJ3BhbGVHcmV5JywgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgXG5cbmNvbnN0IGdob3N0ID0gKHsgZ2hvc3QsIHRoZW1lIH0pID0+XG4gICFnaG9zdCAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZDogJHtjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICAke3NoYWRvdygnc3VidGxlJywgeyB0aGVtZSB9KX07XG4gICAgJHtib3JkZXJSYWRpdXMoJ3NtJywgeyB0aGVtZSB9KX07XG4gIGBcblxuY29uc3QgZGFyayA9ICh7IGRhcmssIHRoZW1lIH0pID0+XG4gIGRhcmsgJiZcbiAgY3NzYFxuICAgIGNvbG9yOiAke2NvbG9yKCd3aGl0ZScsIHsgdGhlbWUgfSl9O1xuXG4gICAgLmJveC1pdGVtICsgLmJveC1pdGVtLFxuICAgIC5ib3gtaGVhZGVyICsgLmJveC1pdGVtLFxuICAgIC5ib3gtaXRlbSArIC5ib3gtZm9vdGVyIHtcbiAgICAgIGJvcmRlci10b3AtY29sb3I6ICR7Y29sb3IoJ3Bld3RlcicsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYFxuXG5jb25zdCBCb3ggPSBzdHlsZWQoJ2RpdicpYFxuICAmICsgJiB7XG4gICAgbWFyZ2luLXRvcDogJHtzcGFjZXIoJ3NtJyl9O1xuICB9XG5cbiAgJHtnaG9zdH07XG4gICR7ZGl2aWRlcnN9O1xuICAke2Rhcmt9O1xuYFxuXG5Cb3guSGVhZGVyID0gd2l0aENsYXNzKCdib3gtaGVhZGVyJykoSGVhZGVyKVxuQm94Lkl0ZW0gPSB3aXRoQ2xhc3MoJ2JveC1pdGVtJykoSXRlbSlcbkJveC5FbXB0eSA9IHdpdGhDbGFzcygnYm94LWl0ZW0nKShFbXB0eSlcbkJveC5Gb290ZXIgPSB3aXRoQ2xhc3MoJ2JveC1mb290ZXInKShGb290ZXIpXG5cbmV4cG9ydCBkZWZhdWx0IEJveFxuIl19 */"));
};

var Box = /*#__PURE__*/createStyled('div', {
  target: "eevfmbf0",
  label: "Box"
})("& + &{margin-top:", spacer('sm'), ";}", ghost, ";", dividers, ";", dark, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTZDeUIiLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQge1xuICBjb2xvcixcbiAgc2hhZG93LFxuICBzcGFjZXIsXG4gIGJvcmRlclJhZGl1cyxcbn0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuaW1wb3J0IHdpdGhDbGFzcyBmcm9tICcuLi8uLi91dGlscy93aXRoQ2xhc3MnXG5pbXBvcnQgSGVhZGVyIGZyb20gJy4vSGVhZGVyJ1xuaW1wb3J0IEl0ZW0gZnJvbSAnLi9JdGVtJ1xuaW1wb3J0IEVtcHR5IGZyb20gJy4vRW1wdHknXG5pbXBvcnQgRm9vdGVyIGZyb20gJy4vRm9vdGVyJ1xuXG5jb25zdCBkaXZpZGVycyA9ICh7IGRpdmlkZXJzLCB0aGVtZSB9KSA9PlxuICBkaXZpZGVycyAmJlxuICBjc3NgXG4gICAgLmJveC1pdGVtICsgLmJveC1pdGVtLFxuICAgIC5ib3gtaGVhZGVyICsgLmJveC1pdGVtLFxuICAgIC5ib3gtaXRlbSArIC5ib3gtZm9vdGVyIHtcbiAgICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCAke2NvbG9yKCdwYWxlR3JleScsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYFxuXG5jb25zdCBnaG9zdCA9ICh7IGdob3N0LCB0aGVtZSB9KSA9PlxuICAhZ2hvc3QgJiZcbiAgY3NzYFxuICAgIGJhY2tncm91bmQ6ICR7Y29sb3IoJ3doaXRlJywgeyB0aGVtZSB9KX07XG4gICAgJHtzaGFkb3coJ3N1YnRsZScsIHsgdGhlbWUgfSl9O1xuICAgICR7Ym9yZGVyUmFkaXVzKCdzbScsIHsgdGhlbWUgfSl9O1xuICBgXG5cbmNvbnN0IGRhcmsgPSAoeyBkYXJrLCB0aGVtZSB9KSA9PlxuICBkYXJrICYmXG4gIGNzc2BcbiAgICBjb2xvcjogJHtjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcblxuICAgIC5ib3gtaXRlbSArIC5ib3gtaXRlbSxcbiAgICAuYm94LWhlYWRlciArIC5ib3gtaXRlbSxcbiAgICAuYm94LWl0ZW0gKyAuYm94LWZvb3RlciB7XG4gICAgICBib3JkZXItdG9wLWNvbG9yOiAke2NvbG9yKCdwZXd0ZXInLCB7IHRoZW1lIH0pfTtcbiAgICB9XG4gIGBcblxuY29uc3QgQm94ID0gc3R5bGVkKCdkaXYnKWBcbiAgJiArICYge1xuICAgIG1hcmdpbi10b3A6ICR7c3BhY2VyKCdzbScpfTtcbiAgfVxuXG4gICR7Z2hvc3R9O1xuICAke2RpdmlkZXJzfTtcbiAgJHtkYXJrfTtcbmBcblxuQm94LkhlYWRlciA9IHdpdGhDbGFzcygnYm94LWhlYWRlcicpKEhlYWRlcilcbkJveC5JdGVtID0gd2l0aENsYXNzKCdib3gtaXRlbScpKEl0ZW0pXG5Cb3guRW1wdHkgPSB3aXRoQ2xhc3MoJ2JveC1pdGVtJykoRW1wdHkpXG5Cb3guRm9vdGVyID0gd2l0aENsYXNzKCdib3gtZm9vdGVyJykoRm9vdGVyKVxuXG5leHBvcnQgZGVmYXVsdCBCb3hcbiJdfQ== */"));

Box.Header = withClass('box-header')(Header$2);
Box.Item = withClass('box-item')(Item$4);
Box.Empty = withClass('box-item')(Empty);
Box.Footer = withClass('box-footer')(Footer$2);

var Column = function Column(props) {
  throw new Error('Column should never render. You may be using this outside of a <Table /> component.');
};

var Row$1 = function Row(props) {
  throw new Error('Row should never render. You may be using this outside of a <Table /> component.');
};

Row$1.defaultProps = {
  collapsible: false
};

var commonStyles = function commonStyles(_ref) {
  var onClick = _ref.onClick,
      theme = _ref.theme;
  return /*#__PURE__*/core.css("border-collapse:collapse;width:100%;max-width:100%;thead{th{color:", color('slate', {
    theme: theme
  }), ";border:none;}}tbody{background-color:", color('white', {
    theme: theme
  }), ";tr{transition:all 0.3s ease 0s;", onClick ? '&:hover { cursor: pointer; }' : '', ";}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var simple = function simple(_ref2) {
  var theme = _ref2.theme,
      rest = _objectWithoutProperties(_ref2, ["theme"]);

  return /*#__PURE__*/core.css(commonStyles(_objectSpread2({
    theme: theme
  }, rest)), ";", shadow('subtle', {
    theme: theme
  }), ";th{text-align:inherit;}thead{background-color:", color('paleGrey', {
    theme: theme
  }), ";th{", typography('body2Medium', {
    theme: theme
  }), ";", padding('xxs', {
    theme: theme
  }), ";&:first-of-type{padding-left:", spacer(4, {
    theme: theme
  }), ";}}}tbody{tr{&:hover{background-color:", transparentize('brandGreen', 0.15, {
    theme: theme
  }), ";}&:first-of-type td{padding-top:", spacer(3, {
    theme: theme
  }), ";}&:last-of-type td{padding-bottom:", spacer(3, {
    theme: theme
  }), ";}}td{color:", color('slate', {
    theme: theme
  }), ";", typography('body2Medium', {
    theme: theme
  }), ";", padding('xxs', {
    theme: theme
  }), ";&:first-of-type{padding-left:", spacer(4, {
    theme: theme
  }), ";}&:not(:last-of-type){border-right:1px solid ", color('paleGrey', {
    theme: theme
  }), ";}}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var multiline = function multiline(_ref3) {
  var theme = _ref3.theme,
      rest = _objectWithoutProperties(_ref3, ["theme"]);

  return /*#__PURE__*/core.css(commonStyles(_objectSpread2({
    theme: theme
  }, rest)), ";margin-bottom:", spacer(4, {
    theme: theme
  }), ";background-color:transparent;thead{background-color:transparent;th{position:relative;padding:", spacer(3, {
    theme: theme
  }), " ", spacer(5, {
    theme: theme
  }), ";vertical-align:bottom;", fontSize('xxs', {
    theme: theme
  }), ";", fontWeight('medium', {
    theme: theme
  }), ";}}tbody{", shadow('subtle', {
    theme: theme
  }), ";tr{&:not(:last-of-type){border-bottom:1px solid ", color('paleGrey', {
    theme: theme
  }), ";}&:hover{", shadow('raised', {
    theme: theme
  }), ";background-color:transparent;}}td{&:first-of-type{padding-left:", spacer(5, {
    theme: theme
  }), ";display:flex;align-items:center;}position:relative;", fontSize('xs', {
    theme: theme
  }), ";", fontWeight('regular', {
    theme: theme
  }), ";height:79px;padding:0 ", spacer(3.5, {
    theme: theme
  }), ";border:none;vertical-align:middle;}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var flatCellPadding = function flatCellPadding(theme) {
  return /*#__PURE__*/core.css("padding:", spacer(3, {
    theme: theme
  }), ";&:first-of-type{padding-left:", spacer(5, {
    theme: theme
  }), ";}&:last-of-type{padding-right:", spacer(5, {
    theme: theme
  }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFnSW9DIiwiZmlsZSI6InN0eWxlcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5pbXBvcnQge1xuICBjb2xvcixcbiAgZm9udFNpemUsXG4gIGZvbnRXZWlnaHQsXG4gIHBhZGRpbmcsXG4gIHNoYWRvdyxcbiAgc3BhY2VyLFxuICB0cmFuc3BhcmVudGl6ZSxcbiAgdHlwb2dyYXBoeVxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IGNvbW1vblN0eWxlcyA9ICh7IG9uQ2xpY2ssIHRoZW1lIH0pID0+IGNzc2BcbiAgYm9yZGVyLWNvbGxhcHNlOiBjb2xsYXBzZTtcbiAgd2lkdGg6IDEwMCU7XG4gIG1heC13aWR0aDogMTAwJTtcbiAgdGhlYWQge1xuICAgIHRoIHtcbiAgICAgIGNvbG9yOiAke2NvbG9yKCdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgYm9yZGVyOiBub25lO1xuICAgIH1cbiAgfVxuICB0Ym9keSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcignd2hpdGUnLCB7IHRoZW1lIH0pfTtcbiAgICB0ciB7XG4gICAgICB0cmFuc2l0aW9uOiBhbGwgMC4zcyBlYXNlIDBzO1xuICAgICAgJHtvbkNsaWNrID8gJyY6aG92ZXIgeyBjdXJzb3I6IHBvaW50ZXI7IH0nIDogJyd9O1xuICAgIH1cbiAgfVxuYFxuXG5jb25zdCBzaW1wbGUgPSAoeyB0aGVtZSwgLi4ucmVzdCB9KSA9PiBjc3NgXG4gICR7Y29tbW9uU3R5bGVzKHsgdGhlbWUsIC4uLnJlc3QgfSl9O1xuXG4gICR7c2hhZG93KCdzdWJ0bGUnLCB7IHRoZW1lIH0pfTtcbiAgdGgge1xuICAgIHRleHQtYWxpZ246IGluaGVyaXQ7XG4gIH1cbiAgdGhlYWQge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3IoJ3BhbGVHcmV5JywgeyB0aGVtZSB9KX07XG5cbiAgICB0aCB7XG4gICAgICAke3R5cG9ncmFwaHkoJ2JvZHkyTWVkaXVtJywgeyB0aGVtZSB9KX07XG4gICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuXG4gICAgICAmOmZpcnN0LW9mLXR5cGUge1xuICAgICAgICBwYWRkaW5nLWxlZnQ6ICR7c3BhY2VyKDQsIHsgdGhlbWUgfSl9O1xuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIHRib2R5IHtcbiAgICB0ciB7XG4gICAgICAmOmhvdmVyIHtcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYnJhbmRHcmVlbicsIDAuMTUsIHsgdGhlbWUgfSl9O1xuICAgICAgfVxuXG4gICAgICAmOmZpcnN0LW9mLXR5cGUgdGQge1xuICAgICAgICBwYWRkaW5nLXRvcDogJHtzcGFjZXIoMywgeyB0aGVtZSB9KX07XG4gICAgICB9XG5cbiAgICAgICY6bGFzdC1vZi10eXBlIHRkIHtcbiAgICAgICAgcGFkZGluZy1ib3R0b206ICR7c3BhY2VyKDMsIHsgdGhlbWUgfSl9O1xuICAgICAgfVxuICAgIH1cblxuICAgIHRkIHtcbiAgICAgIGNvbG9yOiAke2NvbG9yKCdzbGF0ZScsIHsgdGhlbWUgfSl9O1xuXG4gICAgICAke3R5cG9ncmFwaHkoJ2JvZHkyTWVkaXVtJywgeyB0aGVtZSB9KX07XG4gICAgICAke3BhZGRpbmcoJ3h4cycsIHsgdGhlbWUgfSl9O1xuXG4gICAgICAmOmZpcnN0LW9mLXR5cGUge1xuICAgICAgICBwYWRkaW5nLWxlZnQ6ICR7c3BhY2VyKDQsIHsgdGhlbWUgfSl9O1xuICAgICAgfVxuXG4gICAgICAmOm5vdCg6bGFzdC1vZi10eXBlKSB7XG4gICAgICAgIGJvcmRlci1yaWdodDogMXB4IHNvbGlkICR7Y29sb3IoJ3BhbGVHcmV5JywgeyB0aGVtZSB9KX07XG4gICAgICB9XG4gICAgfVxuICB9XG5gXG5cbmNvbnN0IG11bHRpbGluZSA9ICh7IHRoZW1lLCAuLi5yZXN0IH0pID0+IGNzc2BcbiAgJHtjb21tb25TdHlsZXMoeyB0aGVtZSwgLi4ucmVzdCB9KX07XG5cbiAgbWFyZ2luLWJvdHRvbTogJHtzcGFjZXIoNCwgeyB0aGVtZSB9KX07XG4gIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuXG4gIHRoZWFkIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbiAgICB0aCB7XG4gICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICBwYWRkaW5nOiAke3NwYWNlcigzLCB7IHRoZW1lIH0pfSAke3NwYWNlcig1LCB7IHRoZW1lIH0pfTtcbiAgICAgIHZlcnRpY2FsLWFsaWduOiBib3R0b207XG4gICAgICAke2ZvbnRTaXplKCd4eHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICR7Zm9udFdlaWdodCgnbWVkaXVtJywgeyB0aGVtZSB9KX07XG4gICAgfVxuICB9XG5cbiAgdGJvZHkge1xuICAgICR7c2hhZG93KCdzdWJ0bGUnLCB7IHRoZW1lIH0pfTtcbiAgICB0ciB7XG4gICAgICAmOm5vdCg6bGFzdC1vZi10eXBlKSB7XG4gICAgICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAke2NvbG9yKCdwYWxlR3JleScsIHsgdGhlbWUgfSl9O1xuICAgICAgfVxuICAgICAgJjpob3ZlciB7XG4gICAgICAgICR7c2hhZG93KCdyYWlzZWQnLCB7IHRoZW1lIH0pfTtcbiAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgICB9XG4gICAgfVxuICAgIHRkIHtcbiAgICAgICY6Zmlyc3Qtb2YtdHlwZSB7XG4gICAgICAgIHBhZGRpbmctbGVmdDogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICB9XG4gICAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgICAke2ZvbnRTaXplKCd4cycsIHsgdGhlbWUgfSl9O1xuICAgICAgJHtmb250V2VpZ2h0KCdyZWd1bGFyJywgeyB0aGVtZSB9KX07XG4gICAgICBoZWlnaHQ6IDc5cHg7XG4gICAgICBwYWRkaW5nOiAwICR7c3BhY2VyKDMuNSwgeyB0aGVtZSB9KX07XG4gICAgICBib3JkZXI6IG5vbmU7XG4gICAgICB2ZXJ0aWNhbC1hbGlnbjogbWlkZGxlO1xuICAgIH1cbiAgfVxuYFxuXG5jb25zdCBmbGF0Q2VsbFBhZGRpbmcgPSB0aGVtZSA9PiBjc3NgXG4gIHBhZGRpbmc6ICR7c3BhY2VyKDMsIHsgdGhlbWUgfSl9O1xuICAmOmZpcnN0LW9mLXR5cGUge1xuICAgIHBhZGRpbmctbGVmdDogJHtzcGFjZXIoNSwgeyB0aGVtZSB9KX07XG4gIH1cbiAgJjpsYXN0LW9mLXR5cGUge1xuICAgIHBhZGRpbmctcmlnaHQ6ICR7c3BhY2VyKDUsIHsgdGhlbWUgfSl9O1xuICB9XG5gXG5cbmNvbnN0IGZsYXQgPSAoeyB0aGVtZSwgLi4ucmVzdCB9KSA9PiBjc3NgXG4gICR7Y29tbW9uU3R5bGVzKHsgdGhlbWUsIC4uLnJlc3QgfSl9O1xuXG4gIG1hcmdpbi1ib3R0b206ICR7c3BhY2VyKDQsIHsgdGhlbWUgfSl9O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcblxuICB0aGVhZCB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgdGgge1xuICAgICAgdGV4dC1hbGlnbjogaW5oZXJpdDtcbiAgICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICAgICR7ZmxhdENlbGxQYWRkaW5nKHRoZW1lKX07XG4gICAgICB2ZXJ0aWNhbC1hbGlnbjogYm90dG9tO1xuICAgICAgJHtmb250U2l6ZSgncycsIHsgdGhlbWUgfSl9O1xuICAgICAgJHtmb250V2VpZ2h0KCdib2R5JywgeyB0aGVtZSB9KX07XG4gICAgfVxuICB9XG5cbiAgdGJvZHkge1xuICAgIGJvcmRlcjogMXB4IHNvbGlkICR7Y29sb3IoJ3BhbGVHcmV5JywgeyB0aGVtZSB9KX07XG4gICAgdHIge1xuICAgICAgJjpub3QoOmxhc3Qtb2YtdHlwZSkge1xuICAgICAgICBib3JkZXItYm90dG9tOiAxcHggc29saWQgJHtjb2xvcigncGFsZUdyZXknLCB7IHRoZW1lIH0pfTtcbiAgICAgIH1cbiAgICAgICY6aG92ZXIge1xuICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCdvZmZXaGl0ZScsIHsgdGhlbWUgfSl9O1xuICAgICAgfVxuICAgIH1cbiAgICB0ZCB7XG4gICAgICAke2ZsYXRDZWxsUGFkZGluZyh0aGVtZSl9O1xuICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgJHtmb250U2l6ZSgneHMnLCB7IHRoZW1lIH0pfTtcbiAgICAgICR7Zm9udFdlaWdodCgncmVndWxhcicsIHsgdGhlbWUgfSl9O1xuICAgICAgaGVpZ2h0OiA2MHB4O1xuICAgICAgYm9yZGVyOiBub25lO1xuICAgICAgdmVydGljYWwtYWxpZ246IG1pZGRsZTtcbiAgICB9XG4gIH1cbmBcblxuZXhwb3J0IHsgZmxhdCwgc2ltcGxlLCBtdWx0aWxpbmUgfVxuIl19 */"));
};

var flat = function flat(_ref4) {
  var theme = _ref4.theme,
      rest = _objectWithoutProperties(_ref4, ["theme"]);

  return /*#__PURE__*/core.css(commonStyles(_objectSpread2({
    theme: theme
  }, rest)), ";margin-bottom:", spacer(4, {
    theme: theme
  }), ";background-color:transparent;thead{background-color:transparent;th{text-align:inherit;position:relative;", flatCellPadding(theme), ";vertical-align:bottom;", fontSize('s', {
    theme: theme
  }), ";", fontWeight('body', {
    theme: theme
  }), ";}}tbody{border:1px solid ", color('paleGrey', {
    theme: theme
  }), ";tr{&:not(:last-of-type){border-bottom:1px solid ", color('paleGrey', {
    theme: theme
  }), ";}&:hover{background-color:", color('offWhite', {
    theme: theme
  }), ";}}td{", flatCellPadding(theme), ";position:relative;", fontSize('xs', {
    theme: theme
  }), ";", fontWeight('regular', {
    theme: theme
  }), ";height:60px;border:none;vertical-align:middle;}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var TR = createStyled("tr", {
  target: "eetllz20",
  label: "TR"
})(function (_ref) {
  var collapsible = _ref.collapsible,
      expanded = _ref.expanded,
      theme = _ref.theme;
  return collapsible && /*#__PURE__*/core.css(shadow('close', {
    theme: theme
  }), ";display:", expanded ? 'table-row' : 'none', ";;label:TR;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXNCTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBDaGlsZHJlbiwgQ29tcG9uZW50LCBGcmFnbWVudCB9IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IEJ1dHRvbiBmcm9tICcuLi9CdXR0b24nXG5pbXBvcnQgQ2hldnJvbiBmcm9tICcuLi9pY29ucy9DaGV2cm9uJ1xuaW1wb3J0IENvbHVtbiBmcm9tICcuL0NvbHVtbidcbmltcG9ydCBSb3cgZnJvbSAnLi9Sb3cnXG5pbXBvcnQge1xuICBjb2xvcixcbiAgZm9udFNpemUsXG4gIGZvbnRXZWlnaHQsXG4gIHRyYW5zcGFyZW50aXplLFxuICBwYWRkaW5nLFxuICBzaGFkb3csXG4gIHNwYWNlcixcbiAgdHlwb2dyYXBoeVxufSBmcm9tICcuLi8uLi9zdHlsZXMnXG5pbXBvcnQgeyBmbGF0LCBzaW1wbGUsIG11bHRpbGluZSB9IGZyb20gJy4vc3R5bGVzJ1xuXG5jb25zdCBUUiA9IHN0eWxlZC50cmBcbiAgJHsoeyBjb2xsYXBzaWJsZSwgZXhwYW5kZWQsIHRoZW1lIH0pID0+XG4gICAgY29sbGFwc2libGUgJiZcbiAgICBjc3NgXG4gICAgICAke3NoYWRvdygnY2xvc2UnLCB7IHRoZW1lIH0pfTtcbiAgICAgIGRpc3BsYXk6ICR7ZXhwYW5kZWQgPyAndGFibGUtcm93JyA6ICdub25lJ307XG4gICAgYH07XG5gXG5cbmNvbnN0IFREID0gc3R5bGVkLnRkYFxuICAke3Byb3BzID0+XG4gICAgcHJvcHMud2lkdGggJiZcbiAgICBjc3NgXG4gICAgICB3aWR0aDogJHtwcm9wcy53aWR0aH1weDtcbiAgICBgfTtcbmBcblxuY29uc3QgU3R5bGVkVGFibGUgPSBzdHlsZWQudGFibGVgXG4gICR7KHsgdHlwZSwgLi4ucmVzdCB9KSA9PlxuICAgICh0eXBlID09PSAnbXVsdGknID8gbXVsdGlsaW5lIDogdHlwZSA9PT0gJ2ZsYXQnID8gZmxhdCA6IHNpbXBsZSkocmVzdCl9O1xuYFxuXG5jb25zdCBmaXJzdENoaWxkID0gY2hpbGRyZW4gPT4gQ2hpbGRyZW4udG9BcnJheShjaGlsZHJlbilbMF1cbmNvbnN0IG5lc3RlZENoaWxkcmVuID0gKHsgcHJvcHMgfSkgPT4gcHJvcHMuY2hpbGRyZW5cbmNvbnN0IGlzQ29sbGFwc2libGUgPSBjaGlsZHJlbiA9PlxuICBDaGlsZHJlbi50b0FycmF5KGNoaWxkcmVuKS5zb21lKCh7IHByb3BzIH0pID0+IHByb3BzLmNvbGxhcHNpYmxlKVxuY29uc3Qgbm9ybWFsaXplZERhdGEgPSBkYXRhID0+IHtcbiAgcmV0dXJuIHR5cGVvZiBkYXRhID09PSAnYm9vbGVhbicgPyBkYXRhLnRvU3RyaW5nKCkgOiBkYXRhXG59XG5cbmNsYXNzIFRhYmxlIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgc3RhdGljIENvbHVtbiA9IENvbHVtblxuICBzdGF0aWMgUm93ID0gUm93XG5cbiAgc3RhdGUgPSB7XG4gICAgZXhwYW5kZWRSb3dzOiBbXVxuICB9XG5cbiAgc3RhdGljIGRlZmF1bHRQcm9wcyA9IHtcbiAgICBvbkNsaWNrOiBudWxsXG4gIH1cblxuICB0b2dnbGUgPSBpZHggPT4ge1xuICAgIHRoaXMuc2V0U3RhdGUoKHsgZXhwYW5kZWRSb3dzIH0pID0+ICh7XG4gICAgICBleHBhbmRlZFJvd3M6IGV4cGFuZGVkUm93cy5pbmNsdWRlcyhpZHgpXG4gICAgICAgID8gZXhwYW5kZWRSb3dzLmZpbHRlcihpID0+IGkgIT09IGlkeClcbiAgICAgICAgOiBbLi4uZXhwYW5kZWRSb3dzLCBpZHhdXG4gICAgfSkpXG4gIH1cblxuICByZW5kZXJDb2x1bW5zID0gKGNvbHVtbnMsIGRhdGEpID0+IHtcbiAgICByZXR1cm4gQ2hpbGRyZW4ubWFwKGNvbHVtbnMsICh7IHByb3BzOiB7IHJlbmRlciwgZGF0YUtleSwgLi4ucmVzdCB9IH0pID0+IChcbiAgICAgIDxURCBrZXk9e2RhdGFLZXl9IHsuLi5yZXN0fT5cbiAgICAgICAge3JlbmRlciA/IHJlbmRlcihkYXRhKSA6IG5vcm1hbGl6ZWREYXRhKGRhdGFbZGF0YUtleV0pfVxuICAgICAgPC9URD5cbiAgICApKVxuICB9XG5cbiAgcmVuZGVyKCkge1xuICAgIGNvbnN0IHsgY2hpbGRyZW4sIGRhdGEsIHR5cGUsIC4uLnJlc3QgfSA9IHRoaXMucHJvcHNcbiAgICBjb25zdCB7IGV4cGFuZGVkUm93cyB9ID0gdGhpcy5zdGF0ZVxuICAgIGNvbnN0IGNvbGxhcHNpYmxlID0gaXNDb2xsYXBzaWJsZShjaGlsZHJlbilcbiAgICBjb25zdCByb3dzID0gQ2hpbGRyZW4udG9BcnJheShjaGlsZHJlbilcbiAgICBjb25zdCByZWd1bGFyUm93cyA9IHJvd3MuZmlsdGVyKGNoaWxkID0+ICFjaGlsZC5wcm9wcy5jb2xsYXBzaWJsZSlcbiAgICBjb25zdCBjb2xsYXBzaWJsZVJvd3MgPSByb3dzLmZpbHRlcihjaGlsZCA9PiBjaGlsZC5wcm9wcy5jb2xsYXBzaWJsZSlcblxuICAgIHJldHVybiAoXG4gICAgICA8U3R5bGVkVGFibGUgdHlwZT17dHlwZX0gey4uLnJlc3R9PlxuICAgICAgICA8dGhlYWQ+XG4gICAgICAgICAgPHRyPlxuICAgICAgICAgICAge0NoaWxkcmVuLm1hcChuZXN0ZWRDaGlsZHJlbihmaXJzdENoaWxkKGNoaWxkcmVuKSksICh7IHByb3BzIH0pID0+IChcbiAgICAgICAgICAgICAgPHRoIGtleT17cHJvcHMuZGF0YUtleX0+e3Byb3BzLmxhYmVsfTwvdGg+XG4gICAgICAgICAgICApKX1cbiAgICAgICAgICAgIHtjb2xsYXBzaWJsZSAmJiA8dGggLz59XG4gICAgICAgICAgPC90cj5cbiAgICAgICAgPC90aGVhZD5cbiAgICAgICAgPHRib2R5PlxuICAgICAgICAgIHtkYXRhLm1hcCgocm93LCBpZHgpID0+IChcbiAgICAgICAgICAgIDxGcmFnbWVudCBrZXk9e2BmcmFnbWVudC1yb3ctJHtpZHh9YH0+XG4gICAgICAgICAgICAgIHtyZWd1bGFyUm93cy5tYXAoKHsgcHJvcHMgfSkgPT4gKFxuICAgICAgICAgICAgICAgIDxUUlxuICAgICAgICAgICAgICAgICAga2V5PXtgcm93OiR7aWR4fWB9XG4gICAgICAgICAgICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgICAgICAgICAgICBvbkNsaWNrPXtlID0+IHByb3BzLm9uQ2xpY2sgJiYgcHJvcHMub25DbGljayhlLCByb3cpfVxuICAgICAgICAgICAgICAgID5cbiAgICAgICAgICAgICAgICAgIHt0aGlzLnJlbmRlckNvbHVtbnMocHJvcHMuY2hpbGRyZW4sIHJvdyl9XG4gICAgICAgICAgICAgICAgICB7Y29sbGFwc2libGUgJiYgKFxuICAgICAgICAgICAgICAgICAgICA8VEQgd2lkdGg9ezUwfT5cbiAgICAgICAgICAgICAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICAgICAgICAgICAgICBraW5kPVwidXRpbGl0eVwiXG4gICAgICAgICAgICAgICAgICAgICAgICBzaXplPVwic21cIlxuICAgICAgICAgICAgICAgICAgICAgICAgb25DbGljaz17KCkgPT4gdGhpcy50b2dnbGUoaWR4KX1cbiAgICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgICAgICA8Q2hldnJvblxuICAgICAgICAgICAgICAgICAgICAgICAgICBzaXplPVwiMS4yNXJlbVwiXG4gICAgICAgICAgICAgICAgICAgICAgICAgIGRpcmVjdGlvbj17ZXhwYW5kZWRSb3dzLmluY2x1ZGVzKGlkeCkgPyAndXAnIDogJ2Rvd24nfVxuICAgICAgICAgICAgICAgICAgICAgICAgLz5cbiAgICAgICAgICAgICAgICAgICAgICA8L0J1dHRvbj5cbiAgICAgICAgICAgICAgICAgICAgPC9URD5cbiAgICAgICAgICAgICAgICAgICl9XG4gICAgICAgICAgICAgICAgPC9UUj5cbiAgICAgICAgICAgICAgKSl9XG4gICAgICAgICAgICAgIHtjb2xsYXBzaWJsZVJvd3MubWFwKCh7IHByb3BzIH0pID0+IChcbiAgICAgICAgICAgICAgICA8VFJcbiAgICAgICAgICAgICAgICAgIGtleT17YGNvbGxhcHNpYmxlOiR7aWR4fWB9XG4gICAgICAgICAgICAgICAgICBleHBhbmRlZD17ZXhwYW5kZWRSb3dzLmluY2x1ZGVzKGlkeCl9XG4gICAgICAgICAgICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgICAgICAgICAgPlxuICAgICAgICAgICAgICAgICAge3RoaXMucmVuZGVyQ29sdW1ucyhwcm9wcy5jaGlsZHJlbiwgcm93KX1cbiAgICAgICAgICAgICAgICA8L1RSPlxuICAgICAgICAgICAgICApKX1cbiAgICAgICAgICAgIDwvRnJhZ21lbnQ+XG4gICAgICAgICAgKSl9XG4gICAgICAgIDwvdGJvZHk+XG4gICAgICA8L1N0eWxlZFRhYmxlPlxuICAgIClcbiAgfVxufVxuXG5leHBvcnQgZGVmYXVsdCBUYWJsZVxuIl19 */"));
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var TD = createStyled("td", {
  target: "eetllz21",
  label: "TD"
})(function (props) {
  return props.width && /*#__PURE__*/core.css("width:", props.width, "px;;label:TD;" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var StyledTable = createStyled("table", {
  target: "eetllz22",
  label: "StyledTable"
})(function (_ref2) {
  var type = _ref2.type,
      rest = _objectWithoutProperties(_ref2, ["type"]);

  return (type === 'multi' ? multiline : type === 'flat' ? flat : simple)(rest);
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var firstChild = function firstChild(children) {
  return React.Children.toArray(children)[0];
};

var nestedChildren = function nestedChildren(_ref3) {
  var props = _ref3.props;
  return props.children;
};

var isCollapsible = function isCollapsible(children) {
  return React.Children.toArray(children).some(function (_ref4) {
    var props = _ref4.props;
    return props.collapsible;
  });
};

var normalizedData = function normalizedData(data) {
  return typeof data === 'boolean' ? data.toString() : data;
};

var Table = /*#__PURE__*/function (_Component) {
  _inherits(Table, _Component);

  var _super = _createSuper(Table);

  function Table() {
    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized(_this), "state", {
      expandedRows: []
    });

    _defineProperty$1(_assertThisInitialized(_this), "toggle", function (idx) {
      _this.setState(function (_ref5) {
        var expandedRows = _ref5.expandedRows;
        return {
          expandedRows: expandedRows.includes(idx) ? expandedRows.filter(function (i) {
            return i !== idx;
          }) : [].concat(_toConsumableArray(expandedRows), [idx])
        };
      });
    });

    _defineProperty$1(_assertThisInitialized(_this), "renderColumns", function (columns, data) {
      return React.Children.map(columns, function (_ref6) {
        var _ref6$props = _ref6.props,
            render = _ref6$props.render,
            dataKey = _ref6$props.dataKey,
            rest = _objectWithoutProperties(_ref6$props, ["render", "dataKey"]);

        return /*#__PURE__*/React__default['default'].createElement(TD, _extends({
          key: dataKey
        }, rest), render ? render(data) : normalizedData(data[dataKey]));
      });
    });

    return _this;
  }

  _createClass(Table, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          data = _this$props.data,
          type = _this$props.type,
          rest = _objectWithoutProperties(_this$props, ["children", "data", "type"]);

      var expandedRows = this.state.expandedRows;
      var collapsible = isCollapsible(children);
      var rows = React.Children.toArray(children);
      var regularRows = rows.filter(function (child) {
        return !child.props.collapsible;
      });
      var collapsibleRows = rows.filter(function (child) {
        return child.props.collapsible;
      });
      return /*#__PURE__*/React__default['default'].createElement(StyledTable, _extends({
        type: type
      }, rest), /*#__PURE__*/React__default['default'].createElement("thead", null, /*#__PURE__*/React__default['default'].createElement("tr", null, React.Children.map(nestedChildren(firstChild(children)), function (_ref7) {
        var props = _ref7.props;
        return /*#__PURE__*/React__default['default'].createElement("th", {
          key: props.dataKey
        }, props.label);
      }), collapsible && /*#__PURE__*/React__default['default'].createElement("th", null))), /*#__PURE__*/React__default['default'].createElement("tbody", null, data.map(function (row, idx) {
        return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
          key: "fragment-row-".concat(idx)
        }, regularRows.map(function (_ref8) {
          var props = _ref8.props;
          return /*#__PURE__*/React__default['default'].createElement(TR, _extends({
            key: "row:".concat(idx)
          }, props, {
            onClick: function onClick(e) {
              return props.onClick && props.onClick(e, row);
            }
          }), _this2.renderColumns(props.children, row), collapsible && /*#__PURE__*/React__default['default'].createElement(TD, {
            width: 50
          }, /*#__PURE__*/React__default['default'].createElement(Button, {
            kind: "utility",
            size: "sm",
            onClick: function onClick() {
              return _this2.toggle(idx);
            }
          }, /*#__PURE__*/React__default['default'].createElement(Chevron, {
            size: "1.25rem",
            direction: expandedRows.includes(idx) ? 'up' : 'down'
          }))));
        }), collapsibleRows.map(function (_ref9) {
          var props = _ref9.props;
          return /*#__PURE__*/React__default['default'].createElement(TR, _extends({
            key: "collapsible:".concat(idx),
            expanded: expandedRows.includes(idx)
          }, props), _this2.renderColumns(props.children, row));
        }));
      })));
    }
  }]);

  return Table;
}(React.Component);

_defineProperty$1(Table, "Column", Column);

_defineProperty$1(Table, "Row", Row$1);

_defineProperty$1(Table, "defaultProps", {
  onClick: null
});

var LayoutWithStandardHeader = recompose.withProps({
  gridTemplateRows: "auto 1fr auto",
  gridAutoFlow: 'row'
})( /*#__PURE__*/createStyled(Grid, {
  target: "eeawkwg0",
  label: "LayoutWithStandardHeader"
})("min-height:100vh;background:", color('offWhite'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxheW91dFdpdGhTdGFuZGFyZEhlYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZZSIsImZpbGUiOiJMYXlvdXRXaXRoU3RhbmRhcmRIZWFkZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCBHcmlkIGZyb20gJy4uLy4uL2NvbXBvbmVudHMvR3JpZCdcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcydcbmltcG9ydCB7IHdpdGhQcm9wcyB9IGZyb20gJ3JlY29tcG9zZSdcbmltcG9ydCB7IGNvbG9yIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuaW1wb3J0IE5hdmJhciBmcm9tICcuLi8uLi9jb21wb25lbnRzL05hdmJhcidcbmltcG9ydCBOYXZiYXJTZWNvbmRhcnkgZnJvbSAnLi4vLi4vY29tcG9uZW50cy9OYXZiYXJTZWNvbmRhcnknXG5cbmNvbnN0IExheW91dFdpdGhTdGFuZGFyZEhlYWRlciA9IHdpdGhQcm9wcyh7XG4gIGdyaWRUZW1wbGF0ZVJvd3M6IGBhdXRvIDFmciBhdXRvYCxcbiAgZ3JpZEF1dG9GbG93OiAncm93J1xufSkoc3R5bGVkKEdyaWQpYFxuICBtaW4taGVpZ2h0OiAxMDB2aDtcbiAgYmFja2dyb3VuZDogJHtjb2xvcignb2ZmV2hpdGUnKX07XG5gKVxuXG5jb25zdCBGb290ZXIgPSBzdHlsZWQuZm9vdGVyYFxuICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lLCAuLi5wcm9wcyB9KSA9PlxuICAgIGNvbG9yKHByb3BzLmRhcmsgPyAnaW5rJyA6ICdvZmZXaGl0ZScpKHsgdGhlbWUsIC4uLnByb3BzIH0pfTtcbmBcblxuRm9vdGVyLnByb3BUeXBlcyA9IHtcbiAgZGFyazogUHJvcFR5cGVzLmJvb2xcbn1cblxuTGF5b3V0V2l0aFN0YW5kYXJkSGVhZGVyLkhlYWRlciA9IE5hdmJhclxuTGF5b3V0V2l0aFN0YW5kYXJkSGVhZGVyLk1haW4gPSAoeyBjaGlsZHJlbiwgLi4ucHJvcHMgfSkgPT4gKFxuICA8bWFpbiB7Li4ucHJvcHN9PntjaGlsZHJlbn08L21haW4+XG4pXG5MYXlvdXRXaXRoU3RhbmRhcmRIZWFkZXIuRm9vdGVyID0gKHsgY2hpbGRyZW4sIC4uLnByb3BzIH0pID0+IChcbiAgPEZvb3RlciB7Li4ucHJvcHN9PntjaGlsZHJlbn08L0Zvb3Rlcj5cbilcbkxheW91dFdpdGhTdGFuZGFyZEhlYWRlci5TZWNvbmRhcnlIZWFkZXIgPSBOYXZiYXJTZWNvbmRhcnlcblxuZXhwb3J0IGRlZmF1bHQgTGF5b3V0V2l0aFN0YW5kYXJkSGVhZGVyXG4iXX0= */")));

var Footer$3 = createStyled("footer", {
  target: "eeawkwg1",
  label: "Footer"
})("background:", function (_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  return color(props.dark ? 'ink' : 'offWhite')(_objectSpread2({
    theme: theme
  }, props));
}, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxheW91dFdpdGhTdGFuZGFyZEhlYWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFpQjRCIiwiZmlsZSI6IkxheW91dFdpdGhTdGFuZGFyZEhlYWRlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IEdyaWQgZnJvbSAnLi4vLi4vY29tcG9uZW50cy9HcmlkJ1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IHsgd2l0aFByb3BzIH0gZnJvbSAncmVjb21wb3NlJ1xuaW1wb3J0IHsgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5pbXBvcnQgTmF2YmFyIGZyb20gJy4uLy4uL2NvbXBvbmVudHMvTmF2YmFyJ1xuaW1wb3J0IE5hdmJhclNlY29uZGFyeSBmcm9tICcuLi8uLi9jb21wb25lbnRzL05hdmJhclNlY29uZGFyeSdcblxuY29uc3QgTGF5b3V0V2l0aFN0YW5kYXJkSGVhZGVyID0gd2l0aFByb3BzKHtcbiAgZ3JpZFRlbXBsYXRlUm93czogYGF1dG8gMWZyIGF1dG9gLFxuICBncmlkQXV0b0Zsb3c6ICdyb3cnXG59KShzdHlsZWQoR3JpZClgXG4gIG1pbi1oZWlnaHQ6IDEwMHZoO1xuICBiYWNrZ3JvdW5kOiAke2NvbG9yKCdvZmZXaGl0ZScpfTtcbmApXG5cbmNvbnN0IEZvb3RlciA9IHN0eWxlZC5mb290ZXJgXG4gIGJhY2tncm91bmQ6ICR7KHsgdGhlbWUsIC4uLnByb3BzIH0pID0+XG4gICAgY29sb3IocHJvcHMuZGFyayA/ICdpbmsnIDogJ29mZldoaXRlJykoeyB0aGVtZSwgLi4ucHJvcHMgfSl9O1xuYFxuXG5Gb290ZXIucHJvcFR5cGVzID0ge1xuICBkYXJrOiBQcm9wVHlwZXMuYm9vbFxufVxuXG5MYXlvdXRXaXRoU3RhbmRhcmRIZWFkZXIuSGVhZGVyID0gTmF2YmFyXG5MYXlvdXRXaXRoU3RhbmRhcmRIZWFkZXIuTWFpbiA9ICh7IGNoaWxkcmVuLCAuLi5wcm9wcyB9KSA9PiAoXG4gIDxtYWluIHsuLi5wcm9wc30+e2NoaWxkcmVufTwvbWFpbj5cbilcbkxheW91dFdpdGhTdGFuZGFyZEhlYWRlci5Gb290ZXIgPSAoeyBjaGlsZHJlbiwgLi4ucHJvcHMgfSkgPT4gKFxuICA8Rm9vdGVyIHsuLi5wcm9wc30+e2NoaWxkcmVufTwvRm9vdGVyPlxuKVxuTGF5b3V0V2l0aFN0YW5kYXJkSGVhZGVyLlNlY29uZGFyeUhlYWRlciA9IE5hdmJhclNlY29uZGFyeVxuXG5leHBvcnQgZGVmYXVsdCBMYXlvdXRXaXRoU3RhbmRhcmRIZWFkZXJcbiJdfQ== */"));

Footer$3.propTypes = {
  dark: PropTypes__default['default'].bool
};
LayoutWithStandardHeader.Header = Navbar;

LayoutWithStandardHeader.Main = function (_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement("main", props, children);
};

LayoutWithStandardHeader.Footer = function (_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement(Footer$3, props, children);
};

LayoutWithStandardHeader.SecondaryHeader = NavbarSecondary;

var LayoutSidebar = /*#__PURE__*/createStyled(Grid, {
  target: "ej97ng70",
  label: "LayoutSidebar"
})("grid-template-columns:", function (_ref) {
  var _ref$sidebarWidth = _ref.sidebarWidth,
      sidebarWidth = _ref$sidebarWidth === void 0 ? '200px' : _ref$sidebarWidth;
  return sidebarWidth;
}, " 1fr;grid-auto-flow:column;grid-column-gap:", spacer(4), ";padding:", spacer(4), ";background:", color('offWhite'), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxheW91dFNpZGViYXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT2tDIiwiZmlsZSI6IkxheW91dFNpZGViYXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCBHcmlkIGZyb20gJy4uLy4uL2NvbXBvbmVudHMvR3JpZCdcbmltcG9ydCB7IGNvbG9yLCBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5pbXBvcnQgTmF2YmFyIGZyb20gJy4uLy4uL2NvbXBvbmVudHMvTmF2YmFyJ1xuaW1wb3J0IE5hdmJhclNlY29uZGFyeSBmcm9tICcuLi8uLi9jb21wb25lbnRzL05hdmJhclNlY29uZGFyeSdcblxuY29uc3QgTGF5b3V0U2lkZWJhciA9IHN0eWxlZChHcmlkKWBcbiAgZ3JpZC10ZW1wbGF0ZS1jb2x1bW5zOiAkeyh7IHNpZGViYXJXaWR0aCA9ICcyMDBweCcgfSkgPT4gc2lkZWJhcldpZHRofSAxZnI7XG4gIGdyaWQtYXV0by1mbG93OiBjb2x1bW47XG4gIGdyaWQtY29sdW1uLWdhcDogJHtzcGFjZXIoNCl9O1xuICBwYWRkaW5nOiAke3NwYWNlcig0KX07XG4gIGJhY2tncm91bmQ6ICR7Y29sb3IoJ29mZldoaXRlJyl9O1xuYFxuXG5MYXlvdXRTaWRlYmFyLkNvbnRlbnQgPSAoeyBjaGlsZHJlbiwgLi4ucmVzdCB9KSA9PiAoXG4gIDxkaXYgey4uLnJlc3R9PntjaGlsZHJlbn08L2Rpdj5cbilcbkxheW91dFNpZGViYXIuU2lkZWJhciA9ICh7IGNoaWxkcmVuLCAuLi5yZXN0IH0pID0+IChcbiAgPGRpdiB7Li4ucmVzdH0+e2NoaWxkcmVufTwvZGl2PlxuKVxuXG5leHBvcnQgZGVmYXVsdCBMYXlvdXRTaWRlYmFyXG4iXX0= */"));

LayoutSidebar.Content = function (_ref2) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement("div", rest, children);
};

LayoutSidebar.Sidebar = function (_ref3) {
  var children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement("div", rest, children);
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$D() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Svg$1 = createStyled("svg", {
  target: "ehuab110",
  label: "Svg"
})( true ? {
  name: "9y6172",
  styles: "user-select:none;"
} : {
  name: "9y6172",
  styles: "user-select:none;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN2Zy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHc0IiLCJmaWxlIjoiU3ZnLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyB3aXRoUHJvcHMgfSBmcm9tICdyZWNvbXBvc2UnXG5cbmNvbnN0IFN2ZyA9IHN0eWxlZC5zdmdgXG4gIHVzZXItc2VsZWN0OiBub25lO1xuYFxuXG5leHBvcnQgZGVmYXVsdCB3aXRoUHJvcHMoeyB4bWxuczogJ2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJyB9KShTdmcpXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$D
});

var Svg$2 = recompose.withProps({
  xmlns: 'http://www.w3.org/2000/svg'
})(Svg$1);

var DiagonalDividerVertical = function DiagonalDividerVertical(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["theme"]);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends({
    viewBox: "0 0 115 801",
    preserveAspectRatio: "none"
  }, props), /*#__PURE__*/React__default['default'].createElement("title", null, "brand diagonal"), /*#__PURE__*/React__default['default'].createElement("rect", {
    fill: color('white', {
      theme: theme
    }),
    width: "104.6",
    height: "801"
  }), /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    id: "greenGradient",
    gradientUnits: "userSpaceOnUse",
    x1: "25.8617",
    y1: "-249.8779",
    x2: "158.2286",
    y2: "432.3206",
    gradientTransform: "matrix(1 0 0 1 0 130)"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "0",
    stopColor: gradientStart('green', {
      theme: theme
    })
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "1",
    stopColor: gradientEnd('green', {
      theme: theme
    })
  })), /*#__PURE__*/React__default['default'].createElement("polygon", {
    fill: "url(#greenGradient)",
    points: "0,0 64.6,419.3 115,0 "
  }), /*#__PURE__*/React__default['default'].createElement("polygon", {
    fill: color('ink', {
      theme: theme
    }),
    points: "115,0 64.6,419.3 18.7,801 115,801 "
  }));
};

var DiagonalDivider = emotionTheming.withTheme(DiagonalDividerVertical);

var Header$3 = createStyled("header", {
  target: "e1cfxynd0",
  label: "Header"
})("display:flex;align-items:center;padding-left:", spacer(4), ";padding-right:", spacer(4), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Main$1 = createStyled("main", {
  target: "e1cfxynd1",
  label: "Main"
})("display:flex;justify-content:center;align-items:center;width:100%;padding-left:", spacer(4), ";padding-right:", spacer(4), ";>:first-of-type{width:400px;}@supports (display:grid){display:grid;justify-content:center;align-content:center;align-items:unset;grid-template-columns:400px;width:auto;>:first-of-type{width:auto;}", mediaDn('sm'), "{grid-template-columns:1fr;}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var StyledLayoutWithVertical = createStyled("div", {
  target: "e1cfxynd2",
  label: "StyledLayoutWithVertical"
})("display:flex;height:100vh;background:", color('white'), ";@supports (display:grid){display:grid;grid-template-columns:1fr;grid-auto-flow:column;", mediaUp('lg'), "{grid-template-columns:repeat(2,1fr);}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Left = createStyled("div", {
  target: "e1cfxynd3",
  label: "Left"
})("display:flex;flex-direction:column;width:100%;header{height:70px;}main{flex:1;}", mediaUp('lg'), "{width:50%;}@supports (display:grid){display:grid;grid-template-rows:70px 1fr;header{height:auto;}main{align-self:center;}", mediaUp('lg'), "{width:100%;}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Right = createStyled("div", {
  target: "e1cfxynd4",
  label: "Right"
})("width:50%;background:", color('ink'), ";position:relative;> svg{position:absolute;display:block;left:0;height:100%;width:80px;}@supports (display:grid){width:auto;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var LayoutWithVertical = function LayoutWithVertical(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement(MediaQuery, {
    above: "lg"
  }, function (matches) {
    return /*#__PURE__*/React__default['default'].createElement(StyledLayoutWithVertical, props, /*#__PURE__*/React__default['default'].createElement(Left, null, children), matches && /*#__PURE__*/React__default['default'].createElement(Right, null, /*#__PURE__*/React__default['default'].createElement(DiagonalDivider, null)));
  });
};

LayoutWithVertical.Header = Header$3;
LayoutWithVertical.Main = Main$1;

LayoutWithVertical.Footer = function (props) {
  return /*#__PURE__*/React__default['default'].createElement("footer", props);
};

var DiagonalDividerHorizontal = function DiagonalDividerHorizontal(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/React__default['default'].createElement(Svg$2, {
    viewBox: "0 0 1280 156",
    preserveAspectRatio: "none"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: color('ink', {
      theme: theme
    }),
    d: "M0 0v80h1280V0z"
  }), /*#__PURE__*/React__default['default'].createElement("linearGradient", {
    id: "greenGradient",
    gradientUnits: "userSpaceOnUse",
    y1: "81",
    x2: "1280",
    y2: "81",
    gradientTransform: "matrix(1 0 0 -1 0 156)"
  }, /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "0",
    stopColor: gradientEnd('green', {
      theme: theme
    })
  }), /*#__PURE__*/React__default['default'].createElement("stop", {
    offset: "1",
    stopColor: gradientStart('green', {
      theme: theme
    })
  })), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "url(#greenGradient)",
    d: "M1280 0L0 148v2h1280z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: color('white', {
      theme: theme
    }),
    d: "M0 0l1280 148v8H0z"
  }));
};

var DiagonalDividerHorizontal$1 = emotionTheming.withTheme(DiagonalDividerHorizontal);

function _EMOTION_STRINGIFIED_CSS_ERROR__$E() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var _ref$h =  true ? {
  name: "hu0xcq",
  styles: "bottom:0;left:0;transform:translate(-50%,50%);"
} : {
  name: "hu0xcq",
  styles: "bottom:0;left:0;transform:translate(-50%,50%);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};

var _ref2$b =  true ? {
  name: "1p8meti",
  styles: "bottom:0;right:0;transform:translate(50%,50%);"
} : {
  name: "1p8meti",
  styles: "bottom:0;right:0;transform:translate(50%,50%);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIldpdGhCYWRnZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjZ0IiLCJmaWxlIjoiV2l0aEJhZGdlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuaW1wb3J0IHsgY29sb3IsIGZvbnRTaXplLCBmb250V2VpZ2h0IH0gZnJvbSAnLi4vc3R5bGVzJ1xuXG5leHBvcnQgY29uc3QgZGlhZ29uYWxQb3NpdGlvbmluZyA9ICh7IHBvc2l0aW9uID0gJ3RvcC1yaWdodCcgfSkgPT4ge1xuICBzd2l0Y2ggKHBvc2l0aW9uKSB7XG4gICAgY2FzZSAnYm90dG9tLWxlZnQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgYm90dG9tOiAwO1xuICAgICAgICBsZWZ0OiAwO1xuICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCA1MCUpO1xuICAgICAgYFxuICAgIGNhc2UgJ2JvdHRvbS1yaWdodCc6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICBib3R0b206IDA7XG4gICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSg1MCUsIDUwJSk7XG4gICAgICBgXG4gICAgY2FzZSAndG9wLWxlZnQnOlxuICAgICAgcmV0dXJuIGNzc2BcbiAgICAgICAgdG9wOiAwO1xuICAgICAgICBsZWZ0OiAwO1xuICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSgtNTAlLCAtNTAlKTtcbiAgICAgIGBcbiAgICBjYXNlICd0b3AtcmlnaHQnOlxuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gY3NzYFxuICAgICAgICB0b3A6IDA7XG4gICAgICAgIHJpZ2h0OiAwO1xuICAgICAgICB0cmFuc2Zvcm06IHRyYW5zbGF0ZSg1MCUsIC01MCUpO1xuICAgICAgYFxuICB9XG59XG5cbmNvbnN0IEJhZGdlV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcblxuICAke2RpYWdvbmFsUG9zaXRpb25pbmd9O1xuYFxuXG5jb25zdCBiYWRnZU9wdGlvbnMgPSAoe1xuICB0aGVtZSxcbiAgZmlsbCA9ICdyZWQnLFxuICBiYWNrZ3JvdW5kID0gJ3doaXRlJyxcbiAgY29sb3I6IHRleHRDb2xvciA9ICd3aGl0ZSdcbn0pID0+IGNzc2BcbiAgY29sb3I6ICR7Y29sb3IodGV4dENvbG9yLCB7IHRoZW1lIH0pfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcihmaWxsLCB7IHRoZW1lIH0pfTtcbiAgYm9yZGVyLWNvbG9yOiAke2NvbG9yKGJhY2tncm91bmQsIHsgdGhlbWUgfSl9O1xuYFxuXG5jb25zdCBCYWRnZSA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW5ldGVyO1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYm9yZGVyLXdpZHRoOiAycHg7XG4gIGJvcmRlci1zdHlsZTogc29saWQ7XG4gIGJvcmRlci1yYWRpdXM6IDUwJTtcbiAgYm94LXNpemluZzogY29udGVudC1ib3g7XG4gIHdpZHRoOiAwLjRyZW07XG4gIGhlaWdodDogMC40cmVtO1xuICAke2ZvbnRTaXplKCd4cycpfTtcbiAgJHtmb250V2VpZ2h0KCdib2xkJyl9O1xuICAke2JhZGdlT3B0aW9uc307XG5gXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuYFxuXG5jb25zdCBXaXRoQmFkZ2UgPSAoe1xuICBjaGlsZHJlbixcbiAgb24gPSB0cnVlLFxuICBwb3NpdGlvbiA9ICd0b3AtcmlnaHQnLFxuICBiYWRnZVN0eWxlXG59KSA9PiAoXG4gIDxDb250YWluZXI+XG4gICAge2NoaWxkcmVufVxuICAgIDxCYWRnZVdyYXBwZXIgcG9zaXRpb249e3Bvc2l0aW9ufT5cbiAgICAgIHtvbiAmJiA8QmFkZ2Ugc3R5bGU9e2JhZGdlU3R5bGV9IC8+fVxuICAgIDwvQmFkZ2VXcmFwcGVyPlxuICA8L0NvbnRhaW5lcj5cbilcblxuZXhwb3J0IGRlZmF1bHQgV2l0aEJhZGdlXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};

var _ref3$2 =  true ? {
  name: "1t40x28",
  styles: "top:0;left:0;transform:translate(-50%,-50%);"
} : {
  name: "1t40x28",
  styles: "top:0;left:0;transform:translate(-50%,-50%);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};

var _ref4$1 =  true ? {
  name: "46kkzh",
  styles: "top:0;right:0;transform:translate(50%,-50%);"
} : {
  name: "46kkzh",
  styles: "top:0;right:0;transform:translate(50%,-50%);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
};

var diagonalPositioning = function diagonalPositioning(_ref5) {
  var _ref5$position = _ref5.position,
      position = _ref5$position === void 0 ? 'top-right' : _ref5$position;

  switch (position) {
    case 'bottom-left':
      return _ref$h;

    case 'bottom-right':
      return _ref2$b;

    case 'top-left':
      return _ref3$2;

    case 'top-right':
    default:
      return _ref4$1;
  }
};

var BadgeWrapper = createStyled("div", {
  target: "e4k0a9k0",
  label: "BadgeWrapper"
})("position:absolute;", diagonalPositioning, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var badgeOptions = function badgeOptions(_ref6) {
  var theme = _ref6.theme,
      _ref6$fill = _ref6.fill,
      fill = _ref6$fill === void 0 ? 'red' : _ref6$fill,
      _ref6$background = _ref6.background,
      background = _ref6$background === void 0 ? 'white' : _ref6$background,
      _ref6$color = _ref6.color,
      textColor = _ref6$color === void 0 ? 'white' : _ref6$color;
  return /*#__PURE__*/core.css("color:", color(textColor, {
    theme: theme
  }), ";background-color:", color(fill, {
    theme: theme
  }), ";border-color:", color(background, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var Badge$1 = createStyled("div", {
  target: "e4k0a9k1",
  label: "Badge"
})("display:flex;align-items:ceneter;justify-content:center;border-width:2px;border-style:solid;border-radius:50%;box-sizing:content-box;width:0.4rem;height:0.4rem;", fontSize('xs'), ";", fontWeight('bold'), ";", badgeOptions, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var Container$h = createStyled("div", {
  target: "e4k0a9k2",
  label: "Container"
})( true ? {
  name: "1gomreu",
  styles: "position:relative;display:inline-block;"
} : {
  name: "1gomreu",
  styles: "position:relative;display:inline-block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$E
});

var WithBadge = function WithBadge(_ref7) {
  var children = _ref7.children,
      _ref7$on = _ref7.on,
      on = _ref7$on === void 0 ? true : _ref7$on,
      _ref7$position = _ref7.position,
      position = _ref7$position === void 0 ? 'top-right' : _ref7$position,
      badgeStyle = _ref7.badgeStyle;
  return /*#__PURE__*/React__default['default'].createElement(Container$h, null, children, /*#__PURE__*/React__default['default'].createElement(BadgeWrapper, {
    position: position
  }, on && /*#__PURE__*/React__default['default'].createElement(Badge$1, {
    style: badgeStyle
  })));
};

var Body$2 = createStyled("tbody", {
  target: "euimo9d0",
  label: "Body"
})("&&{background-color:", color('white'), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJvZHkuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXlCIiwiZmlsZSI6IkJvZHkuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuaW1wb3J0IHsgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IEJvZHkgPSBzdHlsZWQudGJvZHlgXG4gICYmIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9yKCd3aGl0ZScpfTtcbiAgfVxuYFxuXG5leHBvcnQgZGVmYXVsdCBCb2R5XG4iXX0= */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$F() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var highlightedStyle = function highlightedStyle(_ref2) {
  var _ref2$highlighted = _ref2.highlighted,
      highlighted = _ref2$highlighted === void 0 ? false : _ref2$highlighted,
      theme = _ref2.theme;
  return highlighted && /*#__PURE__*/core.css("background-color:", transparentize('black', 0.07, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var highlightOnHoverStyle = function highlightOnHoverStyle(_ref3) {
  var _ref3$highlightOnHove = _ref3.highlightOnHover,
      highlightOnHover = _ref3$highlightOnHove === void 0 ? false : _ref3$highlightOnHove,
      theme = _ref3.theme;
  return highlightOnHover && /*#__PURE__*/core.css("&:hover{", highlightedStyle({
    highlighted: true,
    theme: theme
  }), "}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var vertPadding = {
  "default": 2,
  compact: 1,
  comfortable: 3
};

var paddingStyle = function paddingStyle(_ref4) {
  var _ref4$spacing = _ref4.spacing,
      spacing = _ref4$spacing === void 0 ? 'default' : _ref4$spacing,
      theme = _ref4.theme;
  var y = spacer(vertPadding[spacing], {
    theme: theme
  });
  var x = spacer(3, {
    theme: theme
  });
  return /*#__PURE__*/core.css("padding:", y, " ", x, ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var _ref$i =  true ? {
  name: "y8yffq",
  styles: "hyphens:auto;"
} : {
  name: "y8yffq",
  styles: "hyphens:auto;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$F
};

var hyphensStyle = function hyphensStyle(_ref5) {
  var hyphens = _ref5.hyphens;
  return hyphens && _ref$i;
};

var Cell = createStyled("td", {
  target: "e194s5c20",
  label: "Cell"
})("&&{", fontWeight('regular'), " text-align:", function (_ref6) {
  var _ref6$textAlign = _ref6.textAlign,
      textAlign = _ref6$textAlign === void 0 ? 'left' : _ref6$textAlign;
  return textAlign;
}, ";", highlightedStyle, " ", paddingStyle, " ", highlightOnHoverStyle, " ", hyphensStyle, "}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

Cell.propTypes = {
  highlightOnHover: PropTypes__default['default'].bool,
  highlighted: PropTypes__default['default'].bool,
  noBorder: PropTypes__default['default'].bool,
  hyphens: PropTypes__default['default'].bool,
  textAlign: PropTypes__default['default'].oneOf(['left', 'center', 'right']),
  spacing: PropTypes__default['default'].oneOf(['default', 'compact', 'comfortable']),
  children: PropTypes__default['default'].node
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$G() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Container$i = createStyled("div", {
  target: "e1wfxndb0",
  label: "Container"
})( true ? {
  name: "17xotax",
  styles: "&&{width:100%;overflow-x:auto;}"
} : {
  name: "17xotax",
  styles: "&&{width:100%;overflow-x:auto;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhaW5lci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEIiLCJmaWxlIjoiQ29udGFpbmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gICYmIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgICBvdmVyZmxvdy14OiBhdXRvO1xuICB9XG5gXG5cbmV4cG9ydCBkZWZhdWx0IENvbnRhaW5lclxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$G
});

var borderStyle = function borderStyle(_ref) {
  var _ref$noBorder = _ref.noBorder,
      noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder,
      theme = _ref.theme;
  return /*#__PURE__*/core.css("border-width:1px 1px 0 1px;border-style:solid;border-color:", noBorder ? 'transparent' : color('silver', {
    theme: theme
  }), ";tbody > &:last-child{border-bottom-width:1px;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvdy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSyIsImZpbGUiOiJSb3cuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL2NvcmUnXG5cbmltcG9ydCB7IHRyYW5zcGFyZW50aXplLCBjb2xvciB9IGZyb20gJy4uLy4uL3N0eWxlcydcblxuY29uc3QgYm9yZGVyU3R5bGUgPSAoeyBub0JvcmRlciA9IGZhbHNlLCB0aGVtZSB9KSA9PlxuICBjc3NgXG4gICAgYm9yZGVyLXdpZHRoOiAxcHggMXB4IDAgMXB4O1xuICAgIGJvcmRlci1zdHlsZTogc29saWQ7XG4gICAgYm9yZGVyLWNvbG9yOiAke25vQm9yZGVyID8gJ3RyYW5zcGFyZW50JyA6IGNvbG9yKCdzaWx2ZXInLCB7IHRoZW1lIH0pfTtcblxuICAgIHRib2R5ID4gJjpsYXN0LWNoaWxkIHtcbiAgICAgIGJvcmRlci1ib3R0b20td2lkdGg6IDFweDtcbiAgICB9XG4gIGBcblxuY29uc3Qgc2VsZWN0YWJsZVN0eWxlID0gKHsgc2VsZWN0YWJsZSA9IGZhbHNlLCB0aGVtZSB9KSA9PlxuICBzZWxlY3RhYmxlICYmXG4gIGNzc2BcbiAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgJjpob3ZlciB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdibGFjaycsIDAuMDcsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYFxuXG5jb25zdCBzZWxlY3RlZFN0eWxlID0gKHsgc2VsZWN0ZWQgPSBmYWxzZSwgdGhlbWUgfSkgPT5cbiAgc2VsZWN0ZWQgJiZcbiAgY3NzYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JsdWUnLCAwLjIsIHsgdGhlbWUgfSl9O1xuXG4gICAgJjpob3ZlciB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdibHVlJywgMC4zLCB7IHRoZW1lIH0pfTtcbiAgICB9XG4gIGBcblxuY29uc3QgUm93ID0gc3R5bGVkLnRyYFxuICAmJiB7XG4gICAgJHtzZWxlY3RhYmxlU3R5bGV9XG4gICAgJHtzZWxlY3RlZFN0eWxlfVxuICAgICR7Ym9yZGVyU3R5bGV9XG4gIH1cbmBcblxuZXhwb3J0IGRlZmF1bHQgUm93XG4iXX0= */"));
};

var selectableStyle = function selectableStyle(_ref2) {
  var _ref2$selectable = _ref2.selectable,
      selectable = _ref2$selectable === void 0 ? false : _ref2$selectable,
      theme = _ref2.theme;
  return selectable && /*#__PURE__*/core.css("cursor:pointer;&:hover{background-color:", transparentize('black', 0.07, {
    theme: theme
  }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvdy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQksiLCJmaWxlIjoiUm93LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5pbXBvcnQgeyB0cmFuc3BhcmVudGl6ZSwgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IGJvcmRlclN0eWxlID0gKHsgbm9Cb3JkZXIgPSBmYWxzZSwgdGhlbWUgfSkgPT5cbiAgY3NzYFxuICAgIGJvcmRlci13aWR0aDogMXB4IDFweCAwIDFweDtcbiAgICBib3JkZXItc3R5bGU6IHNvbGlkO1xuICAgIGJvcmRlci1jb2xvcjogJHtub0JvcmRlciA/ICd0cmFuc3BhcmVudCcgOiBjb2xvcignc2lsdmVyJywgeyB0aGVtZSB9KX07XG5cbiAgICB0Ym9keSA+ICY6bGFzdC1jaGlsZCB7XG4gICAgICBib3JkZXItYm90dG9tLXdpZHRoOiAxcHg7XG4gICAgfVxuICBgXG5cbmNvbnN0IHNlbGVjdGFibGVTdHlsZSA9ICh7IHNlbGVjdGFibGUgPSBmYWxzZSwgdGhlbWUgfSkgPT5cbiAgc2VsZWN0YWJsZSAmJlxuICBjc3NgXG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICY6aG92ZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYmxhY2snLCAwLjA3LCB7IHRoZW1lIH0pfTtcbiAgICB9XG4gIGBcblxuY29uc3Qgc2VsZWN0ZWRTdHlsZSA9ICh7IHNlbGVjdGVkID0gZmFsc2UsIHRoZW1lIH0pID0+XG4gIHNlbGVjdGVkICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdibHVlJywgMC4yLCB7IHRoZW1lIH0pfTtcblxuICAgICY6aG92ZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYmx1ZScsIDAuMywgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgXG5cbmNvbnN0IFJvdyA9IHN0eWxlZC50cmBcbiAgJiYge1xuICAgICR7c2VsZWN0YWJsZVN0eWxlfVxuICAgICR7c2VsZWN0ZWRTdHlsZX1cbiAgICAke2JvcmRlclN0eWxlfVxuICB9XG5gXG5cbmV4cG9ydCBkZWZhdWx0IFJvd1xuIl19 */"));
};

var selectedStyle = function selectedStyle(_ref3) {
  var _ref3$selected = _ref3.selected,
      selected = _ref3$selected === void 0 ? false : _ref3$selected,
      theme = _ref3.theme;
  return selected && /*#__PURE__*/core.css("background-color:", transparentize('blue', 0.2, {
    theme: theme
  }), ";&:hover{background-color:", transparentize('blue', 0.3, {
    theme: theme
  }), ";}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvdy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEyQksiLCJmaWxlIjoiUm93LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9jb3JlJ1xuXG5pbXBvcnQgeyB0cmFuc3BhcmVudGl6ZSwgY29sb3IgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmNvbnN0IGJvcmRlclN0eWxlID0gKHsgbm9Cb3JkZXIgPSBmYWxzZSwgdGhlbWUgfSkgPT5cbiAgY3NzYFxuICAgIGJvcmRlci13aWR0aDogMXB4IDFweCAwIDFweDtcbiAgICBib3JkZXItc3R5bGU6IHNvbGlkO1xuICAgIGJvcmRlci1jb2xvcjogJHtub0JvcmRlciA/ICd0cmFuc3BhcmVudCcgOiBjb2xvcignc2lsdmVyJywgeyB0aGVtZSB9KX07XG5cbiAgICB0Ym9keSA+ICY6bGFzdC1jaGlsZCB7XG4gICAgICBib3JkZXItYm90dG9tLXdpZHRoOiAxcHg7XG4gICAgfVxuICBgXG5cbmNvbnN0IHNlbGVjdGFibGVTdHlsZSA9ICh7IHNlbGVjdGFibGUgPSBmYWxzZSwgdGhlbWUgfSkgPT5cbiAgc2VsZWN0YWJsZSAmJlxuICBjc3NgXG4gICAgY3Vyc29yOiBwb2ludGVyO1xuICAgICY6aG92ZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYmxhY2snLCAwLjA3LCB7IHRoZW1lIH0pfTtcbiAgICB9XG4gIGBcblxuY29uc3Qgc2VsZWN0ZWRTdHlsZSA9ICh7IHNlbGVjdGVkID0gZmFsc2UsIHRoZW1lIH0pID0+XG4gIHNlbGVjdGVkICYmXG4gIGNzc2BcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdibHVlJywgMC4yLCB7IHRoZW1lIH0pfTtcblxuICAgICY6aG92ZXIge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYmx1ZScsIDAuMywgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgXG5cbmNvbnN0IFJvdyA9IHN0eWxlZC50cmBcbiAgJiYge1xuICAgICR7c2VsZWN0YWJsZVN0eWxlfVxuICAgICR7c2VsZWN0ZWRTdHlsZX1cbiAgICAke2JvcmRlclN0eWxlfVxuICB9XG5gXG5cbmV4cG9ydCBkZWZhdWx0IFJvd1xuIl19 */"));
};

var Row$2 = createStyled("tr", {
  target: "egcnfba0",
  label: "Row"
})("&&{", selectableStyle, " ", selectedStyle, " ", borderStyle, "}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvdy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFtQ3FCIiwiZmlsZSI6IlJvdy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSdcblxuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUsIGNvbG9yIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBib3JkZXJTdHlsZSA9ICh7IG5vQm9yZGVyID0gZmFsc2UsIHRoZW1lIH0pID0+XG4gIGNzc2BcbiAgICBib3JkZXItd2lkdGg6IDFweCAxcHggMCAxcHg7XG4gICAgYm9yZGVyLXN0eWxlOiBzb2xpZDtcbiAgICBib3JkZXItY29sb3I6ICR7bm9Cb3JkZXIgPyAndHJhbnNwYXJlbnQnIDogY29sb3IoJ3NpbHZlcicsIHsgdGhlbWUgfSl9O1xuXG4gICAgdGJvZHkgPiAmOmxhc3QtY2hpbGQge1xuICAgICAgYm9yZGVyLWJvdHRvbS13aWR0aDogMXB4O1xuICAgIH1cbiAgYFxuXG5jb25zdCBzZWxlY3RhYmxlU3R5bGUgPSAoeyBzZWxlY3RhYmxlID0gZmFsc2UsIHRoZW1lIH0pID0+XG4gIHNlbGVjdGFibGUgJiZcbiAgY3NzYFxuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICAmOmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JsYWNrJywgMC4wNywgeyB0aGVtZSB9KX07XG4gICAgfVxuICBgXG5cbmNvbnN0IHNlbGVjdGVkU3R5bGUgPSAoeyBzZWxlY3RlZCA9IGZhbHNlLCB0aGVtZSB9KSA9PlxuICBzZWxlY3RlZCAmJlxuICBjc3NgXG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHt0cmFuc3BhcmVudGl6ZSgnYmx1ZScsIDAuMiwgeyB0aGVtZSB9KX07XG5cbiAgICAmOmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7dHJhbnNwYXJlbnRpemUoJ2JsdWUnLCAwLjMsIHsgdGhlbWUgfSl9O1xuICAgIH1cbiAgYFxuXG5jb25zdCBSb3cgPSBzdHlsZWQudHJgXG4gICYmIHtcbiAgICAke3NlbGVjdGFibGVTdHlsZX1cbiAgICAke3NlbGVjdGVkU3R5bGV9XG4gICAgJHtib3JkZXJTdHlsZX1cbiAgfVxuYFxuXG5leHBvcnQgZGVmYXVsdCBSb3dcbiJdfQ== */"));

var FlexedDiv = createStyled("div", {
  target: "e14dj0bu0",
  label: "FlexedDiv"
})("&&{display:flex;& > div{display:flex;align-items:center;flex:1;& > * + *{margin-left:", spacer(2), ";}}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var FootCell = /*#__PURE__*/createStyled(Cell, {
  target: "e14dj0bu1",
  label: "FootCell"
})("&&{padding:", spacer(2), " 0;}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var defaultPaginatedRenderResultCounts = function defaultPaginatedRenderResultCounts(_ref) {
  var pageStartRow = _ref.pageStartRow,
      pageEndRow = _ref.pageEndRow,
      totalNumRows = _ref.totalNumRows;
  return "Showing ".concat(pageStartRow, "\u2013").concat(pageEndRow, " of ").concat(totalNumRows);
};

var defaultRenderResultCounts = function defaultRenderResultCounts(_ref2) {
  var totalNumRows = _ref2.totalNumRows;
  return "Showing ".concat(totalNumRows, " records");
};

var defaultRenderPageNavigationText = function defaultRenderPageNavigationText(_ref3) {
  var currentPage = _ref3.currentPage,
      pageCount = _ref3.pageCount;
  return "\n  ".concat(currentPage, " of ").concat(pageCount, "\n");
};

var defaultRenderPageJumpToText = function defaultRenderPageJumpToText() {
  return 'Go to page:';
};

var defaultRenderPageJumpToButtonText = function defaultRenderPageJumpToButtonText() {
  return 'Go';
};

function Foot(props) {
  var _useState = React.useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      gotoPageValue = _useState2[0],
      setGotoPageValue = _useState2[1];

  var numCols = props.numCols,
      _props$totalNumRows = props.totalNumRows,
      totalNumRows = _props$totalNumRows === void 0 ? 0 : _props$totalNumRows,
      _props$pageIndex = props.pageIndex,
      pageIndex = _props$pageIndex === void 0 ? 0 : _props$pageIndex,
      _props$pageSize = props.pageSize,
      pageSize = _props$pageSize === void 0 ? 0 : _props$pageSize,
      _props$pageCount = props.pageCount,
      pageCount = _props$pageCount === void 0 ? 0 : _props$pageCount,
      _props$gotoPage = props.gotoPage,
      gotoPage = _props$gotoPage === void 0 ? function () {} : _props$gotoPage,
      _props$canPreviousPag = props.canPreviousPage,
      canPreviousPage = _props$canPreviousPag === void 0 ? false : _props$canPreviousPag,
      _props$previousPage = props.previousPage,
      previousPage = _props$previousPage === void 0 ? function () {} : _props$previousPage,
      _props$canNextPage = props.canNextPage,
      canNextPage = _props$canNextPage === void 0 ? false : _props$canNextPage,
      _props$nextPage = props.nextPage,
      nextPage = _props$nextPage === void 0 ? function () {} : _props$nextPage,
      _props$renderResultCo = props.renderResultCounts,
      renderResultCounts = _props$renderResultCo === void 0 ? pageCount > 0 ? defaultPaginatedRenderResultCounts : defaultRenderResultCounts : _props$renderResultCo,
      _props$renderPageNavi = props.renderPageNavigationText,
      renderPageNavigationText = _props$renderPageNavi === void 0 ? defaultRenderPageNavigationText : _props$renderPageNavi,
      _props$renderPageJump = props.renderPageJumpToText,
      renderPageJumpToText = _props$renderPageJump === void 0 ? defaultRenderPageJumpToText : _props$renderPageJump,
      _props$renderPageJump2 = props.renderPageJumpToButtonText,
      renderPageJumpToButtonText = _props$renderPageJump2 === void 0 ? defaultRenderPageJumpToButtonText : _props$renderPageJump2,
      rest = _objectWithoutProperties(props, ["numCols", "totalNumRows", "pageIndex", "pageSize", "pageCount", "gotoPage", "canPreviousPage", "previousPage", "canNextPage", "nextPage", "renderResultCounts", "renderPageNavigationText", "renderPageJumpToText", "renderPageJumpToButtonText"]); // Anything with "index" is 0-based numbered
  // User input or display text is 1-based


  var pageStartRow = pageIndex * pageSize + 1;
  var pageEndRow = Math.min(pageStartRow + pageSize - 1, totalNumRows);

  var handleInputChange = function handleInputChange(e) {
    setGotoPageValue(e.target.value === '' ? undefined : Math.floor(e.target.value));
  };

  var callGotoPage = function callGotoPage() {
    var maxIndex = pageCount - 1;
    var newIndex = gotoPageValue - 1;
    var clampedIndex = Math.min(maxIndex, Math.max(0, newIndex));
    setGotoPageValue(clampedIndex + 1);
    gotoPage(clampedIndex);
  };

  var maybeRenderPagination = function maybeRenderPagination() {
    if (pageCount <= 0) return null;
    return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React__default['default'].createElement(Button, {
      kind: "ghost",
      onClick: previousPage,
      disabled: !canPreviousPage
    }, /*#__PURE__*/React__default['default'].createElement(Chevron, {
      size: "s",
      direction: "left"
    })), /*#__PURE__*/React__default['default'].createElement("div", null, renderPageNavigationText({
      currentPage: pageIndex + 1,
      pageCount: pageCount
    })), /*#__PURE__*/React__default['default'].createElement(Button, {
      kind: "ghost",
      onClick: nextPage,
      disabled: !canNextPage
    }, /*#__PURE__*/React__default['default'].createElement(Chevron, {
      size: "s",
      direction: "right"
    }))), /*#__PURE__*/React__default['default'].createElement("div", {
      style: {
        justifyContent: 'flex-end'
      }
    }, /*#__PURE__*/React__default['default'].createElement("div", null, renderPageJumpToText()), /*#__PURE__*/React__default['default'].createElement(Input$1, {
      min: "0",
      max: pageCount,
      type: "number",
      value: gotoPageValue,
      onChange: handleInputChange,
      onKeyPress: function onKeyPress(e) {
        return e.key === 'Enter' && callGotoPage();
      }
    }), /*#__PURE__*/React__default['default'].createElement(Button, {
      kind: "utility",
      onClick: callGotoPage
    }, renderPageJumpToButtonText(), ' ', /*#__PURE__*/React__default['default'].createElement(Chevron, {
      size: "s",
      direction: "right"
    }))));
  };

  return /*#__PURE__*/React__default['default'].createElement("tfoot", rest, /*#__PURE__*/React__default['default'].createElement(Row$2, {
    noBorder: true
  }, /*#__PURE__*/React__default['default'].createElement(FootCell, {
    colSpan: numCols
  }, /*#__PURE__*/React__default['default'].createElement(FlexedDiv, null, /*#__PURE__*/React__default['default'].createElement("div", null, renderResultCounts({
    pageStartRow: pageStartRow,
    pageEndRow: pageEndRow,
    totalNumRows: totalNumRows
  })), maybeRenderPagination()))));
}

Foot.propTypes = {
  numCols: PropTypes__default['default'].number,
  totalNumRows: PropTypes__default['default'].number,
  // Page info
  pageCount: PropTypes__default['default'].number,
  canPreviousPage: PropTypes__default['default'].bool,
  canNextPage: PropTypes__default['default'].bool,
  pageIndex: PropTypes__default['default'].number,
  pageSize: PropTypes__default['default'].number,
  // Page actions
  gotoPage: PropTypes__default['default'].func,
  previousPage: PropTypes__default['default'].func,
  nextPage: PropTypes__default['default'].func,
  // Below render props are useful for overriding the default text for translations
  renderResultCounts: PropTypes__default['default'].func,
  renderPageNavigationText: PropTypes__default['default'].func,
  renderPageJumpToText: PropTypes__default['default'].func,
  renderPageJumpToButtonText: PropTypes__default['default'].func
};

var Head = createStyled("thead", {
  target: "e1hmyn6e0",
  label: "Head"
})("background-color:", transparentize('black', 0.07), ";", fontSize('xxs'),  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlYWQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSXlCIiwiZmlsZSI6IkhlYWQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuaW1wb3J0IHsgdHJhbnNwYXJlbnRpemUsIGZvbnRTaXplIH0gZnJvbSAnLi4vLi4vc3R5bGVzJ1xuXG5jb25zdCBIZWFkID0gc3R5bGVkLnRoZWFkYFxuICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RyYW5zcGFyZW50aXplKCdibGFjaycsIDAuMDcpfTtcbiAgJHtmb250U2l6ZSgneHhzJyl9XG5gXG5cbmV4cG9ydCBkZWZhdWx0IEhlYWRcbiJdfQ== */");

var AscendingSortPath = function AscendingSortPath(props) {
  return /*#__PURE__*/React__default['default'].createElement("path", _extends({}, props, {
    d: "M4,5H1.5C1.1,5,0.9,4.5,1.1,4.2l1.1-1.3l1.4-1.7C3.8,1,4.2,1,4.4,1.2l1.4,1.7l1.1,1.3C7.1,4.5,6.9,5,6.5,5H4z"
  }));
};

var DescendingSortPath = function DescendingSortPath(props) {
  return /*#__PURE__*/React__default['default'].createElement("path", _extends({}, props, {
    d: "M4,7h2.5c0.4,0,0.7,0.5,0.4,0.8L5.8,9.1l-1.4,1.7c-0.2,0.2-0.6,0.2-0.8,0L2.2,9.1L1.1,7.8C0.9,7.5,1.1,7,1.5,7H4z"
  }));
};

var UnsortedPath = function UnsortedPath(props) {
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(DescendingSortPath, props), /*#__PURE__*/React__default['default'].createElement(AscendingSortPath, props));
};

var getViewBox = {
  asc: '0 0 8 8',
  desc: '0 4 8 12',
  unsorted: '0 0 8 12'
};

var SortIconV2 = function SortIconV2(_ref) {
  var sort = _ref.sort,
      fill = _ref.fill,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 's' : _ref$size,
      props = _objectWithoutProperties(_ref, ["sort", "fill", "size"]);

  return /*#__PURE__*/React__default['default'].createElement(SVGIconV2, _extends({}, props, {
    size: size,
    viewBox: getViewBox[sort] || getViewBox['unsorted']
  }), sort === 'asc' ? /*#__PURE__*/React__default['default'].createElement(AscendingSortPath, {
    fill: fill || '#626263'
  }) : sort === 'desc' ? /*#__PURE__*/React__default['default'].createElement(DescendingSortPath, {
    fill: fill || '#626263'
  }) : /*#__PURE__*/React__default['default'].createElement(UnsortedPath, {
    fill: fill || '#c9cbcc'
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$H() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var SortLabel = /*#__PURE__*/createStyled(SortIconV2, {
  target: "e1f90yas0",
  label: "SortLabel"
})( true ? {
  name: "14bp983",
  styles: "&&{flex-shrink:0;}"
} : {
  name: "14bp983",
  styles: "&&{flex-shrink:0;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNvcnRMYWJlbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNb0MiLCJmaWxlIjoiU29ydExhYmVsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5pbXBvcnQgeyBzcGFjZXIgfSBmcm9tICcuLi8uLi9zdHlsZXMnXG5cbmltcG9ydCBTb3J0SWNvblYyIGZyb20gJy4uL2ljb25zVjIvU29ydEljb25WMidcblxuY29uc3QgU29ydExhYmVsID0gc3R5bGVkKFNvcnRJY29uVjIpYFxuJiYge1xuICAgIGZsZXgtc2hyaW5rOiAwO1xufVxuYFxuXG5leHBvcnQgZGVmYXVsdCBTb3J0TGFiZWxcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$H
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$I() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var sortLabelCss = function sortLabelCss(_ref) {
  var textAlign = _ref.textAlign,
      theme = _ref.theme;
  return textAlign === 'right' ? /*#__PURE__*/core.css("padding-right:", spacer(2, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")) : /*#__PURE__*/core.css("padding-left:", spacer(2, {
    theme: theme
  }), ";" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
};

var Cell$1 = /*#__PURE__*/createStyled(Cell, {
  target: "e31n2as0",
  label: "Cell"
})("&&{", fontWeight('medium'), " color:#626262;display:inline-flex;", SortLabel, "{", sortLabelCss, "}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var CellTextWrapper = createStyled("div", {
  target: "e31n2as1",
  label: "CellTextWrapper"
})( true ? {
  name: "9n0386",
  styles: "&&{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
} : {
  name: "9n0386",
  styles: "&&{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$I
});

function HeadCell(props) {
  var _props$isSorted = props.isSorted,
      isSorted = _props$isSorted === void 0 ? false : _props$isSorted,
      _props$isSortedDesc = props.isSortedDesc,
      isSortedDesc = _props$isSortedDesc === void 0 ? false : _props$isSortedDesc,
      _props$canSort = props.canSort,
      canSort = _props$canSort === void 0 ? false : _props$canSort,
      _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      rest = _objectWithoutProperties(props, ["isSorted", "isSortedDesc", "canSort", "children"]);

  var maybeRenderSortLabel = function maybeRenderSortLabel() {
    if (!canSort) return null;
    return /*#__PURE__*/React__default['default'].createElement(SortLabel, {
      sort: isSorted ? isSortedDesc ? 'desc' : 'asc' : false
    });
  };

  var alignedRight = rest.textAlign === 'right';
  return /*#__PURE__*/React__default['default'].createElement(Cell$1, _extends({
    highlightOnHover: canSort,
    highlighted: isSorted
  }, rest, {
    as: "th"
  }), alignedRight && maybeRenderSortLabel(), /*#__PURE__*/React__default['default'].createElement(CellTextWrapper, null, children), !alignedRight && maybeRenderSortLabel());
}

HeadCell.propTypes = _objectSpread2(_objectSpread2({}, Cell$1.propTypes), {}, {
  isSorted: PropTypes__default['default'].bool,
  isSortedDesc: PropTypes__default['default'].bool,
  canSort: PropTypes__default['default'].bool
});

function RowSpacer(_ref) {
  var _ref$numRows = _ref.numRows,
      numRows = _ref$numRows === void 0 ? 0 : _ref$numRows,
      _ref$numCols = _ref.numCols,
      numCols = _ref$numCols === void 0 ? 0 : _ref$numCols,
      rest = _objectWithoutProperties(_ref, ["numRows", "numCols"]);

  var blankRows = [];

  for (var i = 0; i < numRows; i++) {
    blankRows.push( /*#__PURE__*/React__default['default'].createElement(Row$2, {
      key: i,
      style: i !== numRows - 1 ? {
        borderBottomColor: 'transparent'
      } : {}
    }, /*#__PURE__*/React__default['default'].createElement(Cell, _extends({}, rest, {
      colSpan: numCols
    }), "\xA0")));
  }

  return blankRows;
}

RowSpacer.propTypes = _objectSpread2(_objectSpread2({}, Cell.propTypes), {}, {
  numRows: PropTypes__default['default'].number,
  numCols: PropTypes__default['default'].number
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$J() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ToolbarContainer = createStyled("div", {
  target: "e6z8btn0",
  label: "ToolbarContainer"
})( true ? {
  name: "1lekzkb",
  styles: "display:flex;align-items:center;justify-content:space-between;"
} : {
  name: "1lekzkb",
  styles: "display:flex;align-items:center;justify-content:space-between;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$J
});

var ToolbarButtons = createStyled("div", {
  target: "e6z8btn1",
  label: "ToolbarButtons"
})("background-color:#2473db;button{background:0;border:0;padding:", spacer(2), " ", spacer(3), ";color:white;", fontSize('xs'), " &:hover{background-color:rgba(255,255,255,0.1);cursor:pointer;}&:focus,&:active{outline:0;}&.focus-visible{outline:1;}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var defaultPaginatedRenderResultCounts$1 = function defaultPaginatedRenderResultCounts(_ref) {
  var pageStartRow = _ref.pageStartRow,
      pageEndRow = _ref.pageEndRow,
      totalNumRows = _ref.totalNumRows;
  return "Showing ".concat(pageStartRow, "\u2013").concat(pageEndRow, " of ").concat(totalNumRows);
};

var defaultRenderResultCounts$1 = function defaultRenderResultCounts(_ref2) {
  var totalNumRows = _ref2.totalNumRows;
  return "Showing ".concat(totalNumRows, " records");
};

function Toolbar(_ref3) {
  var _ref3$buttonContent = _ref3.buttonContent,
      buttonContent = _ref3$buttonContent === void 0 ? 'DEFAULT' : _ref3$buttonContent,
      _ref3$buttonOnClick = _ref3.buttonOnClick,
      buttonOnClick = _ref3$buttonOnClick === void 0 ? function () {} : _ref3$buttonOnClick,
      _ref3$pageIndex = _ref3.pageIndex,
      pageIndex = _ref3$pageIndex === void 0 ? 0 : _ref3$pageIndex,
      _ref3$pageSize = _ref3.pageSize,
      pageSize = _ref3$pageSize === void 0 ? 0 : _ref3$pageSize,
      _ref3$pageCount = _ref3.pageCount,
      pageCount = _ref3$pageCount === void 0 ? 0 : _ref3$pageCount,
      _ref3$totalNumRows = _ref3.totalNumRows,
      totalNumRows = _ref3$totalNumRows === void 0 ? 0 : _ref3$totalNumRows,
      _ref3$renderResultCou = _ref3.renderResultCounts,
      renderResultCounts = _ref3$renderResultCou === void 0 ? pageCount > 0 ? defaultPaginatedRenderResultCounts$1 : defaultRenderResultCounts$1 : _ref3$renderResultCou;
  var pageStartRow = pageIndex * pageSize + 1;
  var pageEndRow = Math.min(pageStartRow + pageSize - 1, totalNumRows);
  return /*#__PURE__*/React__default['default'].createElement(ToolbarContainer, null, renderResultCounts({
    pageStartRow: pageStartRow,
    pageEndRow: pageEndRow,
    totalNumRows: totalNumRows
  }), /*#__PURE__*/React__default['default'].createElement(ToolbarButtons, null, /*#__PURE__*/React__default['default'].createElement("button", {
    onClick: buttonOnClick
  }, buttonContent)));
}

Toolbar.propTypes = {
  buttonContent: PropTypes__default['default'].string,
  buttonOnClick: PropTypes__default['default'].func,
  pageIndex: PropTypes__default['default'].number,
  pageSize: PropTypes__default['default'].number,
  pageCount: PropTypes__default['default'].number,
  totalNumRows: PropTypes__default['default'].number,
  renderResultCounts: PropTypes__default['default'].func
};

var COLUMN_ID = 'SELECTION';
var COLUMN_WIDTH = 50;

var reducer$1 = function reducer(newState, action) {
  if (action.type === 'deselectAllRows') {
    return _objectSpread2(_objectSpread2({}, newState), {}, {
      selectedRowIds: {}
    });
  }

  return newState;
};
/**
 * Adds onClick handler to each row to support selection
 */


function addEntireRowSelectionProps(props, _ref) {
  var instance = _ref.instance,
      row = _ref.row;
  var toggleRowSelected = row.toggleRowSelected;
  var dispatch = instance.dispatch;
  return [_objectSpread2(_objectSpread2({}, props), {}, {
    onClick: function onClick() {
      dispatch({
        type: 'deselectAllRows'
      });
      toggleRowSelected();
    }
  })];
}
/**
 * Changes the default behavior to single select
 */


function adaptGetToggleRowSelectedProps(props, _ref2) {
  var instance = _ref2.instance;

  var wrappedOnChange = props.onChange,
      rest = _objectWithoutProperties(props, ["onChange"]);

  var toggleAllRowsSelected = instance.toggleAllRowsSelected;
  return [_objectSpread2(_objectSpread2({}, rest), {}, {
    onChange: function onChange(e) {
      dispatch({
        type: 'deselectAllRows'
      });
      wrappedOnChange(e);
    }
  })];
}

function getHeaderProps(props, _ref3) {
  var column = _ref3.column;

  if (column.id === COLUMN_ID) {
    return [props, {
      style: {
        maxWidth: COLUMN_WIDTH,
        width: COLUMN_WIDTH
      }
    }];
  }

  return [props];
}

function getCellProps(props, _ref4) {
  var cell = _ref4.cell;

  if (cell.column.id === COLUMN_ID) {
    return [props, {
      style: {
        textAlign: 'right',
        maxWidth: COLUMN_WIDTH,
        width: COLUMN_WIDTH
      }
    }];
  }

  return [props];
}
/**
 * Adds the selection column to the table
 */


function prependSelectionColumn(columns) {
  return [{
    id: COLUMN_ID,
    Cell: function Cell(_ref5) {
      var row = _ref5.row;

      var _row$getToggleRowSele = row.getToggleRowSelectedProps(),
          _ = _row$getToggleRowSele.indeterminate,
          rest = _objectWithoutProperties(_row$getToggleRowSele, ["indeterminate"]);

      return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("input", _extends({
        type: "radio"
      }, rest)));
    }
  }].concat(_toConsumableArray(columns));
}

function useRowSingleSelect(hooks) {
  // Extend the default row select plugin functionality
  reactTable.useRowSelect(hooks);
  hooks.getRowProps.push(addEntireRowSelectionProps);
  hooks.getToggleRowSelectedProps.push(adaptGetToggleRowSelectedProps);
  hooks.getHeaderProps.push(getHeaderProps);
  hooks.getCellProps.push(getCellProps);
  hooks.visibleColumns.push(prependSelectionColumn);
  hooks.stateReducers.push(reducer$1);
}

useRowSingleSelect.pluginName = reactTable.useRowSelect.pluginName;

var COLUMN_ID$1 = 'ACTION_MENU';
var COLUMN_WIDTH$1 = 70;
/**
 * Aligns the menu to the right and fixes its width
 */

function getHeaderProps$1(props, _ref) {
  var column = _ref.column;

  if (column.id === COLUMN_ID$1) {
    return [props, {
      style: {
        maxWidth: COLUMN_WIDTH$1,
        width: COLUMN_WIDTH$1
      }
    }];
  }

  return [props];
}

function getCellProps$1(props, _ref2) {
  var cell = _ref2.cell;

  if (cell.column.id === COLUMN_ID$1) {
    return [props, {
      style: {
        textAlign: 'right',
        maxWidth: COLUMN_WIDTH$1,
        width: COLUMN_WIDTH$1
      }
    }];
  }

  return [props];
}
/**
 * Adds the menu column to the table
 */


function appendActionMenuColumn(columns, _ref3) {
  var instance = _ref3.instance;
  var _instance$actionMenuI = instance.actionMenuItems,
      actionMenuItems = _instance$actionMenuI === void 0 ? [] : _instance$actionMenuI;
  return [].concat(_toConsumableArray(columns), [{
    id: COLUMN_ID$1,
    maxWidth: 70,
    Cell: function Cell(_ref4) {
      var row = _ref4.row;

      var _useState = React.useState(false),
          _useState2 = _slicedToArray(_useState, 2),
          open = _useState2[0],
          setOpen = _useState2[1];

      return /*#__PURE__*/React__default['default'].createElement(DropdownMenu, {
        open: open,
        onToggle: setOpen,
        popperOptions: {
          placement: 'bottom-end',
          modifiers: [{
            name: 'eventListeners',
            enabled: open
          }]
        },
        trigger: function trigger(toggle, ref, open) {
          return /*#__PURE__*/React__default['default'].createElement(Button, {
            size: "sm",
            kind: open ? 'utility' : 'ghost',
            ref: ref,
            onClick: toggle
          }, /*#__PURE__*/React__default['default'].createElement(More, null));
        }
      }, actionMenuItems.map(function (_ref5, i) {
        var text = _ref5.text,
            handler = _ref5.handler;
        return /*#__PURE__*/React__default['default'].createElement(DropdownMenu.Item, {
          key: i,
          onClick: function onClick() {
            return handler(row);
          }
        }, text);
      }));
    }
  }]);
}

function useActionMenu(hooks) {
  hooks.getCellProps.push(getCellProps$1);
  hooks.getHeaderProps.push(getHeaderProps$1);
  hooks.visibleColumns.push(appendActionMenuColumn);
}

useActionMenu.pluginName = 'useActionMenu';

function _EMOTION_STRINGIFIED_CSS_ERROR__$K() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var TableV2 = createStyled("table", {
  target: "ejhl7w10",
  label: "TableV2"
})( true ? {
  name: "1f2zpi4",
  styles: "&&{width:100%;border-spacing:0;border-collapse:collapse;}"
} : {
  name: "1f2zpi4",
  styles: "&&{width:100%;border-spacing:0;border-collapse:collapse;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$K
});

TableV2.Body = Body$2;
TableV2.Cell = Cell;
TableV2.Container = Container$i;
TableV2.Foot = Foot;
TableV2.Head = Head;
TableV2.HeadCell = HeadCell;
TableV2.Row = Row$2;
TableV2.RowSpacer = RowSpacer;
TableV2.SortLabel = SortLabel;
TableV2.Toolbar = Toolbar;
TableV2.useTable = reactTable.useTable;
TableV2.useFilters = reactTable.useFilters;
TableV2.useGlobalFilter = reactTable.useGlobalFilter;
TableV2.useSortBy = reactTable.useSortBy;
TableV2.usePagination = reactTable.usePagination;
TableV2.useRowState = reactTable.useRowState;
TableV2.useRowSingleSelect = useRowSingleSelect;
TableV2.useActionMenu = useActionMenu;
TableV2.useFlexLayout = reactTable.useFlexLayout;
TableV2.useBlockLayout = reactTable.useBlockLayout;
TableV2.useAbsoluteLayout = reactTable.useAbsoluteLayout;

function _EMOTION_STRINGIFIED_CSS_ERROR__$L() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Truncated = createStyled("span", {
  target: "eep1e2a0",
  label: "Truncated"
})( true ? {
  name: "o3idik",
  styles: "&&{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
} : {
  name: "o3idik",
  styles: "&&{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$L
});

var Container$j = /*#__PURE__*/createStyled(Input$1, {
  target: "eep1e2a1",
  label: "Container"
})("&&{cursor:text;padding:0;&:focus-within{border-color:", color('brandGreen'), ";}&.disabled{border-color:", color('paleGrey'), ";background-color:", color('offWhite'), ";cursor:not-allowed;}& > div{pointer-events:none;max-width:100%;", padding('xxs'), ";input{background:transparent;font-size:inherit;line-height:inherit;outline:0;border:0;padding:0;max-width:100%;}}&& .stylist-tag{vertical-align:top;transform:translateY(25%);margin:0 0 ", spacer(1), " ", spacer(1), ";max-width:98%;}}" + ( true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function TagInput(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var _useState = React.useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var inputEl = React.useRef(null);
  var containerEl = React.useRef(null); // Focus input when container itself is clicked

  var handleContainerClick = function handleContainerClick(e) {
    if (e.target === containerEl.current) {
      var _inputEl$current;

      (_inputEl$current = inputEl.current) === null || _inputEl$current === void 0 ? void 0 : _inputEl$current.focus();
    }
  };

  var handleInputChange = function handleInputChange(e) {
    if (e.target.value.includes(',')) {
      if (!value.includes(e.target.value)) {
        // Deal with multiple commas too if something was pasted
        onChange([].concat(_toConsumableArray(value), _toConsumableArray(e.target.value.split(',').filter(Boolean))));
      }

      setInputValue('');
    } else {
      setInputValue(e.target.value);
    }
  }; // Add/remove tags via input


  var handleInputKeyDown = function handleInputKeyDown(e) {
    if (e.key === 'Enter' && inputValue.length) {
      if (!value.includes(inputValue)) {
        onChange([].concat(_toConsumableArray(value), [inputValue])); // Append
      }

      setInputValue('');
    } else if (e.key === 'Backspace' && !inputValue.length && value.length) {
      onChange(value.slice(0, value.length - 1)); // Pop
    }
  }; // Remove tag via button


  var handleTagDelete = function handleTagDelete(tag) {
    return onChange(value.filter(function (t) {
      return t !== tag;
    }));
  }; // Convert inputValue to pill when clicking outside the input


  var handleClickOutside = function handleClickOutside(e) {
    if (containerEl.current && inputValue.length) {
      if (!value.includes(inputValue)) {
        onChange([].concat(_toConsumableArray(value), [inputValue])); // Append
      }

      setInputValue('');
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(Container$j, {
    as: "div",
    onClick: handleContainerClick,
    ref: containerEl,
    className: disabled ? 'disabled' : ''
  }, value.map(function (tag) {
    return /*#__PURE__*/React__default['default'].createElement(Tag, {
      key: tag,
      id: tag,
      deletable: !disabled,
      onDelete: handleTagDelete
    }, /*#__PURE__*/React__default['default'].createElement(Truncated, null, tag));
  }), /*#__PURE__*/React__default['default'].createElement(AutosizeInput__default['default'], {
    inputRef: function inputRef(ref) {
      return inputEl.current = ref;
    },
    value: inputValue,
    placeholder: value !== null && value !== void 0 && value.length ? '' : placeholder,
    onChange: handleInputChange,
    onKeyDown: handleInputKeyDown,
    disabled: disabled,
    onBlur: handleClickOutside
  }));
}

var required = function required(prop) {
  throw new Error("Missing required prop `".concat(prop, "`"));
};

var createStaticDataSource = function createStaticDataSource(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? required('items') : _ref$items,
      _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? required('filter') : _ref$filter;
  return function (_ref2) {
    var children = _ref2.children,
        inputValue = _ref2.inputValue;
    return children({
      loading: false,
      items: items.filter(function (item) {
        return !inputValue || filter(item, inputValue);
      })
    });
  };
};

var useNotifications = function useNotifications() {
  return React.useContext(NotificationsContext);
};

Object.defineProperty(exports, 'useCombobox', {
  enumerable: true,
  get: function () {
    return Downshift.useCombobox;
  }
});
Object.defineProperty(exports, 'useMultipleSelection', {
  enumerable: true,
  get: function () {
    return Downshift.useMultipleSelection;
  }
});
Object.defineProperty(exports, 'useSelect', {
  enumerable: true,
  get: function () {
    return Downshift.useSelect;
  }
});
Object.defineProperty(exports, 'withTheme', {
  enumerable: true,
  get: function () {
    return emotionTheming.withTheme;
  }
});
Object.defineProperty(exports, 'usePopper', {
  enumerable: true,
  get: function () {
    return reactPopper.usePopper;
  }
});
exports.Alert = Alert;
exports.AlertCircleIcon = AlertCircle;
exports.AlertCircleIconV2 = AlertCircleV2;
exports.AlertTriangleIcon = AlertTriangle;
exports.AppSelectIconV2 = AppSelect;
exports.ArchiveIcon = Archive;
exports.ArrowIcon = Arrow;
exports.Autocomplete = Autocomplete;
exports.Avatar = Avatar;
exports.Badge = Badge;
exports.BellFillIcon = BellFill;
exports.BellIcon = Bell;
exports.BookmarkIcon = Bookmark;
exports.Box = Box;
exports.Button = Button;
exports.ButtonLink = ButtonLink;
exports.CalendarIcon = Calendar;
exports.CancelIcon = Cancel;
exports.CaretIcon = Caret;
exports.ChatIcon = Chat;
exports.CheckCircleIcon = CheckCircle;
exports.CheckIcon = Check;
exports.Checkbox = Checkbox$1;
exports.ChevronIcon = Chevron;
exports.ChevronV2 = Chevron$1;
exports.CloseButton = CloseButton;
exports.Code = Code;
exports.Col = Col;
exports.Container = Container$3;
exports.CookieBanner = CookieBanner;
exports.DefaultCookiePolicy = DefaultCookiePolicy;
exports.DiagonalDividerHorizontal = DiagonalDividerHorizontal$1;
exports.DiagonalDividerVertical = DiagonalDivider;
exports.Dialog = Dialog;
exports.DigitalDiariesLogo = DigitalDiariesLogo;
exports.DigitalInterviewsLogo = DigitalInterviewsLogo;
exports.DiscIcon = Disc;
exports.DownloadIcon = Download;
exports.Drawer = Drawer;
exports.Dropdown = Dropdown;
exports.DropdownMenu = DropdownMenu;
exports.EditIcon = Edit;
exports.ExternalButtonLink = ExternalButtonLink;
exports.ExternalLinkIcon = ExternalLink;
exports.ExternalLinkIconV2 = ExternalLinkIconV2;
exports.FeatherSVG = FeatherSVG;
exports.FileIcon = File;
exports.FilePlusIcon = FilePlus;
exports.Form = index$1;
exports.ForstaLogo = ForstaLogo;
exports.GlobalHeader = GlobalHeader;
exports.Grid = Grid;
exports.HamburgerIcon = Hamburger;
exports.HashIcon = Hash;
exports.HeaderAvatar = HeaderAvatar;
exports.HelpIcon = Help;
exports.HelpIconV2 = HelpIconV2;
exports.HomeIcon = Home;
exports.ImageIcon = Image;
exports.InfoIcon = Info;
exports.Input = Input$1;
exports.InterVuLogo = InterVuLogo;
exports.LayoutSidebar = LayoutSidebar;
exports.LayoutWithStandardHeader = LayoutWithStandardHeader;
exports.LayoutWithVertical = LayoutWithVertical;
exports.ListBox = ListBox;
exports.LiveVideoLogo = LiveVideoLogo;
exports.Loader = Loader$1;
exports.LockIcon = Lock;
exports.MaximizeIcon = Maximize;
exports.MediaQuery = MediaQuery;
exports.MinimizeIcon = Minimize;
exports.Modal = Modal;
exports.ModalV2 = Modal$1;
exports.MoreIcon = More;
exports.Navbar = Navbar;
exports.NavbarSecondary = NavbarSecondary;
exports.Notifications = Notifications;
exports.NotificationsProvider = NotificationsProvider;
exports.PanelManagementLogo = PanelManagementLogo;
exports.PlayIcon = Play;
exports.PlusIcon = Plus;
exports.Popover = Popover;
exports.QuestionMarkCircleIcon = QuestionMarkCircleIcon;
exports.RadioButton = index$2;
exports.RefreshIcon = Refresh;
exports.RotateIcon = Rotate;
exports.Row = Row;
exports.SaveIcon = Save;
exports.SearchIcon = Search;
exports.SecondaryLink = SecondaryLink;
exports.SettingsIcon = Settings;
exports.ShareIcon = Share;
exports.SlashIcon = Slash;
exports.SortIcon = Sort;
exports.StarIcon = Star;
exports.SurveysLogo = SurveysLogo;
exports.SwitchInput = SwitchInput;
exports.Table = Table;
exports.TableV2 = TableV2;
exports.Tabs = Tabs;
exports.Tag = Tag;
exports.TagInput = TagInput;
exports.Textarea = Textarea;
exports.Theme = Theme;
exports.ThumbIcon = Thumb;
exports.Tooltip = Tooltip;
exports.TrashIcon = Trash;
exports.UploadIcon = Upload;
exports.Uploader = Uploader$1;
exports.UserIcon = User;
exports.UserPlusIcon = UserPlus;
exports.UsersIcon = Users;
exports.VIStreamlineLogo = VIStreamlineLogo;
exports.VideoInsightsLegacyLogo = VideoInsightsLegacyLogo;
exports.VideoInsightsLogo = VideoInsightsLogo;
exports.WithBadge = WithBadge;
exports.borderBottomLeftRadius = borderBottomLeftRadius;
exports.borderBottomRightRadius = borderBottomRightRadius;
exports.borderRadius = borderRadius;
exports.borderTopLeftRadius = borderTopLeftRadius;
exports.borderTopRightRadius = borderTopRightRadius;
exports.color = color;
exports.createStaticDataSource = createStaticDataSource;
exports.fontSize = fontSize;
exports.fontWeight = fontWeight;
exports.global = global;
exports.gradientEnd = gradientEnd;
exports.gradientStart = gradientStart;
exports.margin = margin;
exports.mediaDn = mediaDn;
exports.mediaUp = mediaUp;
exports.padding = padding;
exports.rem = rem;
exports.responsiveContainer = responsiveContainer;
exports.shadow = shadow;
exports.spacer = spacer;
exports.theme = theme;
exports.transparentize = transparentize;
exports.typography = typography;
exports.useNotifications = useNotifications;
exports.withNotifier = withNotifier;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(141);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(153);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__createBinding"] = __createBinding;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldGet"] = __classPrivateFieldGet;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldSet"] = __classPrivateFieldSet;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  trim: trim
};


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(352);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(310),
    getValue = __webpack_require__(313);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return top; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return right; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return basePlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return end; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clippingParents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return viewport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return popper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return reference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return variationPlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return placements; });
/* unused harmony export beforeRead */
/* unused harmony export read */
/* unused harmony export afterRead */
/* unused harmony export beforeMain */
/* unused harmony export main */
/* unused harmony export afterMain */
/* unused harmony export beforeWrite */
/* unused harmony export write */
/* unused harmony export afterWrite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return modifierPhases; });
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(431);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAPIBaseURL = buildAPIBaseURL;
exports.buildBaseURL = buildBaseURL;

var _appConstants = __webpack_require__(38);

var _environmentConstants = __webpack_require__(96);

function buildAPIBaseURL(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var result = '';
  var defaultOptions = {
    urlPrefix: _appConstants.API.COMMON,
    companyPrefix: true,
    format: '.json',
    fullURL: false,
    urlParams: {
      token: _environmentConstants.API_KEY
    }
  };

  options = Object.assign({}, defaultOptions, options);

  if (options.fullURL) {
    result += window.location.protocol + '//' + window.location.host;
  }

  result += options.urlPrefix + '/';

  if (options.prefix) {
    result += options.prefix + '/';
  }

  if (options.companyPrefix) {
    result += 'companies/' + Tru.Stores.reduxStore.getState().company.id;
    if (url.length > 0) {
      result += '/';
    }
  }

  result += url;

  if (options.format) {
    result += options.format;
  }

  if (options.urlParams) {
    result += '?' + $.param(options.urlParams);
  }

  return result;
}

function buildBaseURL(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = Object.assign({}, options, {
    urlPrefix: _appConstants.API.BASE,
    format: '',
    urlParams: null
  });

  return buildAPIBaseURL(url, options);
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53),
    getRawTag = __webpack_require__(289),
    objectToString = __webpack_require__(290);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isHTMLElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isShadowRoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(58);


function isElement(node) {
  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}



/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAlerts = clearAlerts;
exports.createAlert = createAlert;
exports.removeAlert = removeAlert;
var CLEAR_ALERTS = exports.CLEAR_ALERTS = 'CLEAR_ALERTS';
var CREATE_ALERT = exports.CREATE_ALERT = 'CREATE_ALERT';
var REMOVE_ALERT = exports.REMOVE_ALERT = 'REMOVE_ALERT';

function clearAlerts(scope) {
  return {
    type: CLEAR_ALERTS,
    scope: scope
  };
}

function createAlert(alert) {
  return {
    type: CREATE_ALERT,
    alert: alert
  };
}

function removeAlert(alert) {
  return {
    type: REMOVE_ALERT,
    alert: alert
  };
}

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(279);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icon = (_temp = _class = function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['name', 'className']);

      var classes = (0, _classnames2.default)('im-icon-' + name, className);

      return _react2.default.createElement('i', Object.assign({ className: classes }, rest));
    }
  }]);

  return Icon;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired
}, _temp);
exports.default = Icon;

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(271);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpgradeLink = exports.TooltipLink = exports.TooltipText = exports.TaxonomyManager = exports.DraggableTypes = exports.BLACKLISTED_DOMAINS = exports.DEFAULT_PER_PAGE = exports.DateTime = exports.Date = exports.KeyCodes = exports.API_RESOURCE_TYPE = exports.API = undefined;

var _environmentConstants = __webpack_require__(96);

var API = exports.API = {
  TOKEN: _environmentConstants.API_KEY,
  BASE: '/r',
  COMPANIES: '/r/companies',
  COMMON: '/r/api/common',
  RESPONSE: 'responses'
};

var API_RESOURCE_TYPE = exports.API_RESOURCE_TYPE = {
  MARKS: 'marks'
};

var KeyCodes = exports.KeyCodes = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

var Date = exports.Date = {
  SHORT: 'M/D/YY',
  MEDIUM: 'MMM D, YYYY',
  LONG: 'MMMM D, YYYY',
  SPECIAL: 'MMMM YYYY'
};

var DateTime = exports.DateTime = {
  MEDIUM: 'MMM D, YYYY h:mma'
};

var DEFAULT_PER_PAGE = exports.DEFAULT_PER_PAGE = 30;

var BLACKLISTED_DOMAINS = exports.BLACKLISTED_DOMAINS = ['gmail.com', 'yahoo.com', 'bing.com', 'aol.com', 'msn.com', 'comcast.net', 'hotmail.com', 'outlook.com'];

var DraggableTypes = exports.DraggableTypes = {
  TAG_LIST_ITEM: 'tagListItem'
};

var TaxonomyManager = exports.TaxonomyManager = {
  CHEVRON_WIDTH: 24,
  ROW_PADDING: 10,
  ROW_WIDTH: 978,
  CHECKBOX_WIDTH: 30,
  TAG_COUNT_WIDTH: 152,
  TAG_ACTIONS_WIDTH: 100
};

var TooltipText = exports.TooltipText = {
  SEARCH: 'Advanced search is available with a subscription. ' + 'It lets you hone in on content based on project ' + "characteristics or any custom tags that you've " + 'defined.',
  DESIGN: 'Adjusting Project Information is available with a subscription.',
  COLLECTION: 'This element can be used with a subscription.',
  WORKSPACE: 'Creating workspaces & reports such as highlight pages and ' + 'playlists are available with a subscription.',
  ANALYZE: 'Analysis tools (video tagging, clipping, and more) are available ' + 'with a subscription.',
  DEFAULT: 'This element can only be used with a subscription.'
};

var TooltipLink = exports.TooltipLink = {
  SEARCH: 'https://support.focusvision.com/Video_Insights/Search/Advanced_Search',
  DESIGN: 'https://support.focusvision.com/Video_Insights/Project_Management/Project_Design',
  COLLECTION: 'https://support.focusvision.com/Video_Insights/Project_Management/003_Collection_Status_Page',
  WORKSPACE: 'https://support.focusvision.com/Video_Insights/Workspaces/Workspaces',
  ANALYZE: 'https://support.focusvision.com/Video_Insights/Project_Management/Analyzing_Videos'
};

var UpgradeLink = exports.UpgradeLink = 'https://support.focusvision.com/Video_Insights/Additional_Information/Upgrade';

/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClassNames", function() { return ClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Global", function() { return Global; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jsx", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__ = __webpack_require__(176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CacheProvider", function() { return __WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeContext", function() { return __WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withEmotionCache", function() { return __WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_utils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_serialize__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_sheet__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_css__ = __webpack_require__(177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return __WEBPACK_IMPORTED_MODULE_7__emotion_css__["a"]; });











var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["e" /* h */].call(props, 'css')) {
    // $FlowFixMe
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = __WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["b" /* E */];
  createElementArgArray[1] = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["d" /* c */])(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global = /* #__PURE__ */Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["f" /* w */])(function (props, cache) {
  if (false) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["c" /* T */].Consumer, null, function (theme) {
      var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])([styles(theme)]);
      return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])([styles]);
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new __WEBPACK_IMPORTED_MODULE_6__emotion_sheet__["a" /* StyleSheet */]({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var keyframes = function keyframes() {
  var insertable = __WEBPACK_IMPORTED_MODULE_7__emotion_css__["a" /* default */].apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Noop = function Noop() {
  return null;
};

var ClassNames = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["f" /* w */])(function (props, context) {
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_element_04d85134_browser_esm_js__["c" /* T */].Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])(args, context.registered);

      {
        Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Noop, null);


    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, possiblyStyleElement, ele);
  });
});




/***/ }),
/* 42 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(83),
    isLength = __webpack_require__(124);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(66);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(109);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(10);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(300),
    listCacheDelete = __webpack_require__(301),
    listCacheGet = __webpack_require__(302),
    listCacheHas = __webpack_require__(303),
    listCacheSet = __webpack_require__(304);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(42);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(322);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindow;
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(15);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(273);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Schema = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.arrayOf = arrayOf;
exports.valuesOf = valuesOf;
exports.unionOf = unionOf;
exports.normalize = normalize;

var _EntitySchema = __webpack_require__(376);

var _EntitySchema2 = _interopRequireDefault(_EntitySchema);

var _IterableSchema = __webpack_require__(377);

var _IterableSchema2 = _interopRequireDefault(_IterableSchema);

var _UnionSchema = __webpack_require__(170);

var _UnionSchema2 = _interopRequireDefault(_UnionSchema);

var _isEqual = __webpack_require__(378);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isObject = __webpack_require__(9);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultAssignEntity(normalized, key, entity) {
  normalized[key] = entity;
}

function visitObject(obj, schema, bag, options, collectionKey) {
  var _options$assignEntity = options.assignEntity,
      assignEntity = _options$assignEntity === undefined ? defaultAssignEntity : _options$assignEntity;


  var defaults = schema && schema.getDefaults && schema.getDefaults();
  var schemaAssignEntity = schema && schema.getAssignEntity && schema.getAssignEntity();
  var normalized = (0, _isObject2.default)(defaults) ? _extends({}, defaults) : {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var resolvedSchema = typeof schema[key] === 'function' ? schema[key].call(null, obj) : schema[key];
      var entity = visit(obj[key], resolvedSchema, bag, options, collectionKey);
      assignEntity.call(null, normalized, key, entity, obj, schema);
      if (schemaAssignEntity) {
        schemaAssignEntity.call(null, normalized, key, entity, obj, schema);
      }
    }
  }
  return normalized;
}

function defaultMapper(iterableSchema, itemSchema, bag, options) {
  return function (obj, key) {
    return visit(obj, itemSchema, bag, options, key);
  };
}

function polymorphicMapper(iterableSchema, itemSchema, bag, options) {
  return function (obj, key) {
    var schemaKey = iterableSchema.getSchemaKey(obj);
    var result = visit(obj, itemSchema[schemaKey], bag, options, key);
    return { id: result, schema: schemaKey };
  };
}

function visitIterable(obj, iterableSchema, bag, options) {
  var itemSchema = iterableSchema.getItemSchema();
  var curriedItemMapper = defaultMapper(iterableSchema, itemSchema, bag, options);

  if (Array.isArray(obj)) {
    return obj.map(curriedItemMapper);
  } else {
    return Object.keys(obj).reduce(function (objMap, key) {
      objMap[key] = curriedItemMapper(obj[key], key);
      return objMap;
    }, {});
  }
}

function visitUnion(obj, unionSchema, bag, options) {
  var itemSchema = unionSchema.getItemSchema();
  return polymorphicMapper(unionSchema, itemSchema, bag, options)(obj);
}

function defaultMergeIntoEntity(entityA, entityB, entityKey) {
  for (var key in entityB) {
    if (!entityB.hasOwnProperty(key)) {
      continue;
    }

    if (!entityA.hasOwnProperty(key) || (0, _isEqual2.default)(entityA[key], entityB[key])) {
      entityA[key] = entityB[key];
      continue;
    }

    console.warn('When merging two ' + entityKey + ', found unequal data in their "' + key + '" values. Using the earlier value.', entityA[key], entityB[key]);
  }
}

function visitEntity(entity, entitySchema, bag, options, collectionKey) {
  var _options$mergeIntoEnt = options.mergeIntoEntity,
      mergeIntoEntity = _options$mergeIntoEnt === undefined ? defaultMergeIntoEntity : _options$mergeIntoEnt;


  var entityKey = entitySchema.getKey();
  var id = entitySchema.getId(entity, collectionKey);

  if (!bag.hasOwnProperty(entityKey)) {
    bag[entityKey] = {};
  }

  if (!bag[entityKey].hasOwnProperty(id)) {
    bag[entityKey][id] = {};
  }

  var stored = bag[entityKey][id];
  var normalized = visitObject(entity, entitySchema, bag, options, collectionKey);
  mergeIntoEntity(stored, normalized, entityKey);

  return id;
}

function visit(obj, schema, bag, options, collectionKey) {
  if (!(0, _isObject2.default)(obj) || !(0, _isObject2.default)(schema)) {
    return obj;
  }

  if (schema instanceof _EntitySchema2.default) {
    return visitEntity(obj, schema, bag, options, collectionKey);
  } else if (schema instanceof _IterableSchema2.default) {
    return visitIterable(obj, schema, bag, options);
  } else if (schema instanceof _UnionSchema2.default) {
    return visitUnion(obj, schema, bag, options);
  } else {
    return visitObject(obj, schema, bag, options, collectionKey);
  }
}

function normalizeResult(result) {
  if ((0, _isObject2.default)(result) && (0, _isEqual2.default)(Object.keys(result), Object.keys(result).map(function (key) {
    return result[key];
  }))) {
    return Object.keys(result);
  }
  return result;
}

function arrayOf(schema, options) {
  return new _IterableSchema2.default(schema, options);
}

function valuesOf(schema, options) {
  return new _IterableSchema2.default(schema, options);
}

function unionOf(schema, options) {
  return new _UnionSchema2.default(schema, options);
}

exports.Schema = _EntitySchema2.default;
function normalize(obj, schema) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!(0, _isObject2.default)(obj)) {
    throw new Error('Normalize accepts an object or an array as its input.');
  }

  if (!(0, _isObject2.default)(schema) || Array.isArray(schema)) {
    throw new Error('Normalize accepts an object for schema.');
  }

  var bag = {};
  var result = visit(obj, schema, bag, options);

  return {
    entities: bag,
    result: normalizeResult(result)
  };
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(385);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(402);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(192);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(27);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(28);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(440);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(49);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(442);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(27);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(27);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(472);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)(module)))

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(475);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(200);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBasePlacement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(26);

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(32);

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["a" /* isElement */])(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = (_temp = _class = function (_PureComponent) {
  _inherits(Button, _PureComponent);

  function Button(props) {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(Button, [{
    key: 'handleClick',
    value: function handleClick(e) {
      var _props = this.props,
          onClick = _props.onClick,
          preventDefault = _props.preventDefault;

      if (preventDefault) {
        e.preventDefault();
      }

      onClick && onClick(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var sizeClass = void 0;

      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          role = _props2.role,
          size = _props2.size,
          onClick = _props2.onClick,
          preventDefault = _props2.preventDefault,
          Component = _props2.tag,
          attrs = _objectWithoutProperties(_props2, ['children', 'className', 'role', 'size', 'onClick', 'preventDefault', 'tag']);

      if (size) {
        sizeClass = 'qv-button-' + size;
      }

      var roleClass = 'qv-button-' + role;
      var classes = (0, _classnames2.default)('qv-button', sizeClass, roleClass, className);

      return _react2.default.createElement(
        Component,
        Object.assign({
          className: classes,
          onClick: this.handleClick,
          disabled: this.props.disabled
        }, attrs),
        children
      );
    }
  }]);

  return Button;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  preventDefault: _propTypes2.default.bool,
  role: _propTypes2.default.oneOf(['default', 'primary', 'danger', 'create', 'search']).isRequired,
  size: _propTypes2.default.oneOf(['', 'large', 'small']),
  tag: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  role: 'default',
  preventDefault: true,
  disabled: false,
  tag: 'button'
}, _temp);
exports.default = Button;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(10),
    stubFalse = __webpack_require__(294);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)(module)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(31),
    isObject = __webpack_require__(9);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return BrowserRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return HashRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return NavLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useHistory", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useLocation", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useParams", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouteMatch", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["o"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(333);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var isDuplicateNavigation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(context.location) === Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(normalizeToLocation(location));
        var method = replace || isDuplicateNavigation ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["h" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["j" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
    var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;

    if (isActive) {
      className = joinClassnames(className, activeClassName);
      style = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, activeStyle);
    }

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true", "false"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 85 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(145);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(295),
    baseUnary = __webpack_require__(130),
    nodeUtil = __webpack_require__(216);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = I18n;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(25),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeName;
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return round; });
var max = Math.max;
var min = Math.min;
var round = Math.round;

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(27);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = Qualvu.Constants;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(142),
    baseKeysIn = __webpack_require__(330),
    isArrayLike = __webpack_require__(45);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(293),
    isObjectLike = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(142),
    baseKeys = __webpack_require__(258),
    isArrayLike = __webpack_require__(45);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SECTION", function() { return RESET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(445);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(24);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(15);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(454);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(51);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(491);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(66);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(534);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TINY = exports.DEFAULT = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _spinjs = __webpack_require__(631);

var _spinjs2 = _interopRequireDefault(_spinjs);

var _reactDom = __webpack_require__(46);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT = exports.DEFAULT = 'default';
var TINY = exports.TINY = 'tiny';

var sizes = {
  tiny: {
    lines: 10,
    radius: 6,
    width: 2,
    length: 5,
    speed: 1.6,
    trail: 45
  },
  default: {
    lines: 12,
    radius: 11,
    speed: 1.6,
    width: 3,
    trail: 50,
    length: 8
  }
};

var Spinner = (_temp = _class = function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var spinning = this.props.spinning;

      return spinning !== nextProps.spinning;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          size = _props.size,
          spinning = _props.spinning;

      this.spinner = new _spinjs2.default(sizes[size]);

      if (spinning) {
        this.start();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var spinning = this.props.spinning;

      spinning ? this.start() : this.stop();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
      this.spinner = null;
    }
  }, {
    key: 'start',
    value: function start() {
      if (!this.spinner) {
        return;
      }
      this.spinner.spin((0, _reactDom.findDOMNode)(this));
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (!this.spinner) {
        return;
      }
      this.spinner.stop();
    }
  }, {
    key: 'render',
    value: function render() {
      var style = this.props.style;

      var defaultStyle = {
        top: '50%',
        left: '50%',
        position: 'absolute'
      };

      var computedStyle = Object.assign({}, defaultStyle, style);

      return _react2.default.createElement('div', { style: computedStyle });
    }
  }]);

  return Spinner;
}(_react.Component), _class.propTypes = {
  size: _propTypes2.default.oneOf([DEFAULT, TINY]).isRequired,
  spinning: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.object
}, _class.defaultProps = {
  spinning: false,
  size: DEFAULT
}, _temp);
exports.default = Spinner;

/***/ }),
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getComputedStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(58);

function getComputedStyle(element) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element).getComputedStyle(element);
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taniSessions = exports.metaTags = exports.tags = exports.marks = exports.responses = exports.clips = exports.getLiveCookies = undefined;

var _regenerator = __webpack_require__(126);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _axios = __webpack_require__(63);

var _axios2 = _interopRequireDefault(_axios);

var _urlHelper = __webpack_require__(29);

var _appConstants = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getCookieValue = function getCookieValue(key) {
  return document.cookie.replace(new RegExp('(?:(?:^|.*;\\s*)' + key + '\\s*=\\s*([^;]*).*$)|^.*$'), '$1');
};

var jsonApiHeaders = {
  'Content-Type': 'application/vnd.api+json',
  Accept: 'application/vnd.api+json',
  Authorization: 'Bearer ' + getCookieValue('fv_at')
};

var hasFvAtCookie = function hasFvAtCookie() {
  if (getCookieValue('fv_at')) {
    return true;
  } else {
    return false;
  }
};

var getLiveCookies = exports.getLiveCookies = function getLiveCookies(_ref) {
  var jwt = _ref.jwt;
  return (
    // eslint-disable-next-line max-len
    fetch("https://online.focusvision.com/FV.24TruIntegration.WebAPI/api" + '/authentication/secureLogin', {
      headers: {
        'Content-Type': 'text/plain', // prevent preflight OPTIONS request
        Accept: 'application/vnd.api+json',
        Authorization: jwt
      },
      credentials: 'include'
    }).then(function (response) {
      return response.json();
    })
  );
};

var clips = exports.clips = {
  addToWorkspace: function addToWorkspace(clipId, workspaceId) {
    return _axios2.default.post((0, _urlHelper.buildAPIBaseURL)('workspaces/' + workspaceId + '/clips/' + clipId));
  },
  get: function get(id) {
    return _axios2.default.get((0, _urlHelper.buildBaseURL)('modal_info/searches/clip/' + id + '.json'));
  },
  downloadVideoClip: function downloadVideoClip(id) {
    return _axios2.default.get((0, _urlHelper.buildBaseURL)('download_queue/video_clip/' + id + '.json', {
      companyPrefix: false
    }));
  }
};

var responses = exports.responses = {
  addToWorkspace: function addToWorkspace(responseId, workspaceId) {
    return _axios2.default.post((0, _urlHelper.buildAPIBaseURL)('workspaces/' + workspaceId + '/responses/' + responseId));
  },
  toggleObserversViewPiiFlag: function toggleObserversViewPiiFlag(responseId, value) {
    return _axios2.default.put((0, _urlHelper.buildAPIBaseURL)('responses/' + responseId), {
      response: { observers_view_pii_fl: value }
    });
  },
  get: function get(id) {
    return _axios2.default.get((0, _urlHelper.buildBaseURL)('modal_info/searches/response/' + id + '.json'));
  },
  downloadVideo: function downloadVideo(id) {
    return _axios2.default.put((0, _urlHelper.buildBaseURL)('download_queue/video/' + id + '.json', {
      companyPrefix: false
    }));
  }
};

var marks = exports.marks = {
  update: function update(mark) {
    return _axios2.default.put((0, _urlHelper.buildBaseURL)('api/marks/' + mark.id, {
      companyPrefix: false,
      urlPrefix: _appConstants.API.BASE
    }), {
      data: {
        type: _appConstants.API_RESOURCE_TYPE.MARKS,
        id: JSON.stringify(mark.id),
        attributes: {
          text: mark.text,
          seconds_after_start: mark.secondsAfterStart
        }
      }
    }, { headers: jsonApiHeaders });
  },
  remove: function remove(id) {
    return _axios2.default.delete((0, _urlHelper.buildBaseURL)('api/marks/' + id, {
      companyPrefix: false,
      urlPrefix: _appConstants.API.BASE
    }), { headers: jsonApiHeaders });
  },
  add: function add(mark) {
    return _axios2.default.post((0, _urlHelper.buildBaseURL)('api/marks', {
      companyPrefix: false,
      urlPrefix: _appConstants.API.BASE
    }), {
      data: {
        type: _appConstants.API_RESOURCE_TYPE.MARKS,
        attributes: {
          text: mark.text,
          seconds_after_start: mark.secondsAfterStart
        },
        relationships: {
          response: {
            data: {
              type: _appConstants.API.RESPONSE,
              id: mark.responseId
            }
          }
        }
      }
    }, { headers: jsonApiHeaders
      // eslint-disable-next-line arrow-body-style
    }).then(function (data) {
      return data;
    });
  }
};

var tags = exports.tags = {
  create: function create(companyId) {
    var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _axios2.default.post((0, _urlHelper.buildAPIBaseURL)('tags'), {
      tag: attributes
    });
  },
  merge: function merge(companyId, ids) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return _axios2.default.post((0, _urlHelper.buildAPIBaseURL)('tags/merge'), {
      tag: attributes,
      ids: ids
    });
  },
  query: function query(companyId) {
    return _axios2.default.get((0, _urlHelper.buildAPIBaseURL)('companies/' + companyId + '/tags', { companyPrefix: false }));
  },
  remove: function remove(companyId, id) {
    return _axios2.default.delete((0, _urlHelper.buildAPIBaseURL)('tags/' + id));
  },
  removeMultiple: function removeMultiple(companyId, ids) {
    return _axios2.default.delete((0, _urlHelper.buildAPIBaseURL)('tags/destroy_multiple'), {
      params: { ids: ids }
    });
  },
  search: function search(companyId, query) {
    return _axios2.default.get((0, _urlHelper.buildAPIBaseURL)('tags/search'), {
      params: { query: query }
    });
  },
  update: function update(companyId, id) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return _axios2.default.put((0, _urlHelper.buildAPIBaseURL)('tags/' + id), {
      tag: attributes
    });
  }
};

var metaTags = exports.metaTags = {
  create: function create(companyId) {
    var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _axios2.default.post((0, _urlHelper.buildAPIBaseURL)('meta_tags'), {
      meta_tag: attributes
    });
  },
  merge: function merge(companyId, ids) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return _axios2.default.post((0, _urlHelper.buildAPIBaseURL)('meta_tags/merge'), {
      meta_tag: attributes,
      ids: ids
    });
  },
  query: function query(companyId) {
    // Hit taxonomy endpoint until its safe to properly fetch from index action
    //   Index action is currently used when applying meta to objects.
    //   Keep until its safe to merge the two actions
    return _axios2.default.get((0, _urlHelper.buildAPIBaseURL)('companies/' + companyId + '/meta_tags/taxonomy', {
      companyPrefix: false
    }));
  },
  search: function search(companyId, query) {
    return _axios2.default.get((0, _urlHelper.buildAPIBaseURL)('meta_tags/search'), {
      params: { query: query }
    });
  },
  update: function update(companyId, id) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return _axios2.default.put((0, _urlHelper.buildAPIBaseURL)('meta_tags/' + id), {
      meta_tag: attributes
    });
  },
  remove: function remove(companyId, id) {
    return _axios2.default.delete((0, _urlHelper.buildAPIBaseURL)('meta_tags/' + id));
  },
  removeMultiple: function removeMultiple(companyId, ids) {
    return _axios2.default.delete((0, _urlHelper.buildAPIBaseURL)('meta_tags/destroy_multiple'), {
      params: { ids: ids }
    });
  }
};

var taniSessions = exports.taniSessions = {
  fetchTaniSessions: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(taniProjectId) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios2.default.get((0, _urlHelper.buildBaseURL)('api/tani_project_sessions/' + taniProjectId, {
                companyPrefix: false,
                urlPrefix: _appConstants.API.BASE
              }), { headers: jsonApiHeaders });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    function fetchTaniSessions(_x7) {
      return _ref2.apply(this, arguments);
    }

    return fetchTaniSessions;
  }(),
  fetchTaniProject: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(taniProjectId) {
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _axios2.default.get((0, _urlHelper.buildBaseURL)('api/tani_project/' + taniProjectId, {
                companyPrefix: false,
                urlPrefix: _appConstants.API.BASE
              }), { headers: jsonApiHeaders });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    function fetchTaniProject(_x8) {
      return _ref3.apply(this, arguments);
    }

    return fetchTaniProject;
  }()
};

/***/ }),
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(54),
    stackClear = __webpack_require__(305),
    stackDelete = __webpack_require__(306),
    stackGet = __webpack_require__(307),
    stackHas = __webpack_require__(308),
    stackSet = __webpack_require__(309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(314),
    mapCacheDelete = __webpack_require__(321),
    mapCacheGet = __webpack_require__(323),
    mapCacheHas = __webpack_require__(324),
    mapCacheSet = __webpack_require__(325);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(355);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(143);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPEN_MODAL = exports.OPEN_MODAL = 'tru/modals/OPEN_MODAL';
var CLOSE_MODAL = exports.CLOSE_MODAL = 'tru/modals/CLOSE_MODAL';

var openModal = exports.openModal = function openModal(id) {
  return { type: OPEN_MODAL, id: id };
};
var closeModal = exports.closeModal = function closeModal(id) {
  return { type: CLOSE_MODAL, id: id };
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(244),
    baseAssignValue = __webpack_require__(86);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSelectedProjects = exports.toggleProject = exports.fetchAdminProjectsInCompany = exports.fetchProjectsInCompany = exports.TOGGLE_PROJECT = exports.FETCH_PROJECTS_FAILURE = exports.FETCH_PROJECTS_SUCCESS = exports.FETCH_PROJECTS_REQUEST = exports.PROJECT_FAILURE = exports.PROJECT_SUCCESS = exports.PROJECT_REQUEST = exports.CLEAR_SELECTED_PROJECTS = exports.ADD_PROJECT_TO_WORKSPACE_FAILURE = exports.ADD_PROJECT_TO_WORKSPACE_SUCCESS = exports.ADD_PROJECT_TO_WORKSPACE_REQUEST = undefined;
exports.addProjectToWorkspace = addProjectToWorkspace;
exports.fetchProject = fetchProject;
exports.searchProject = searchProject;

var _uniq = __webpack_require__(23);

var _uniq2 = _interopRequireDefault(_uniq);

var _api = __webpack_require__(4);

var _index = __webpack_require__(3);

var _searchActions = __webpack_require__(151);

var _AlertListItem = __webpack_require__(7);

var _urlHelper = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ADD_PROJECT_TO_WORKSPACE_REQUEST = exports.ADD_PROJECT_TO_WORKSPACE_REQUEST = 'ADD_PROJECT_TO_WORKSPACE_REQUEST';
var ADD_PROJECT_TO_WORKSPACE_SUCCESS = exports.ADD_PROJECT_TO_WORKSPACE_SUCCESS = 'ADD_PROJECT_TO_WORKSPACE_SUCCESS';
var ADD_PROJECT_TO_WORKSPACE_FAILURE = exports.ADD_PROJECT_TO_WORKSPACE_FAILURE = 'ADD_PROJECT_TO_WORKSPACE_FAILURE';
var CLEAR_SELECTED_PROJECTS = exports.CLEAR_SELECTED_PROJECTS = 'tru/projects/CLEAR_SELECTED_PROJECTS';
var PROJECT_REQUEST = exports.PROJECT_REQUEST = 'PROJECT_REQUEST';
var PROJECT_SUCCESS = exports.PROJECT_SUCCESS = 'PROJECT_SUCCESS';
var PROJECT_FAILURE = exports.PROJECT_FAILURE = 'PROJECT_FAILURE';
var FETCH_PROJECTS_REQUEST = exports.FETCH_PROJECTS_REQUEST = 'tru/projects/FETCH_PROJECTS_REQUEST';
var FETCH_PROJECTS_SUCCESS = exports.FETCH_PROJECTS_SUCCESS = 'tru/projects/FETCH_PROJECTS_SUCCESS';
var FETCH_PROJECTS_FAILURE = exports.FETCH_PROJECTS_FAILURE = 'tru/projects/FETCH_PROJECTS_FAILURE';
var TOGGLE_PROJECT = exports.TOGGLE_PROJECT = 'tru/projects/TOGGLE_PROJECT';

function addProjectToWorkspace(company, project, workspace) {
  var _ref;

  var workspaceURL = (0, _urlHelper.buildBaseURL)('workspaces/' + workspace.id);
  return _ref = {}, _defineProperty(_ref, ADD_PROJECT_TO_WORKSPACE_SUCCESS, {
    entities: {
      projects: _defineProperty({}, project.id, {
        workspaces: (0, _uniq2.default)([].concat(_toConsumableArray(project.workspaces), [workspace.id]))
      })
    },
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Added to ' + workspace.name + '. <a href="' + workspaceURL + '">View it now!</a>',
      htmlSafe: true
    }
  }), _defineProperty(_ref, _api.CALL_API, {
    types: [ADD_PROJECT_TO_WORKSPACE_REQUEST, ADD_PROJECT_TO_WORKSPACE_SUCCESS, ADD_PROJECT_TO_WORKSPACE_FAILURE],
    endpoint: 'companies/' + company.id + '/workspaces/' + workspace.id + '/projects/' + project.id + '.json',
    requestType: _api.REQUEST_POST,
    schema: _index.NONE
  }), _ref;
}

function fetchProject(company, id) {
  return _defineProperty({}, _api.CALL_API, {
    types: [PROJECT_REQUEST, PROJECT_SUCCESS, PROJECT_FAILURE],
    endpoint: 'companies/' + company.id + '/projects/' + id + '.json',
    requestType: _api.REQUEST_GET,
    schema: _index.PROJECT
  });
}

function searchProject(company, project) {
  return (0, _searchActions.createSearch)(company, {
    filters: [{ projectGroupIds: [project.id] }],
    displayed: [{
      name: 'Project',
      applied: [{ id: project.id, name: project.name, applied: true }]
    }]
  });
}

var fetchProjectsInCompany = exports.fetchProjectsInCompany = function fetchProjectsInCompany(company) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_PROJECTS_REQUEST, FETCH_PROJECTS_SUCCESS, FETCH_PROJECTS_FAILURE],
    endpoint: 'companies/' + company.id + '/projects.json',
    requestType: _api.REQUEST_GET,
    schema: _index.PROJECT_COLLECTION
  });
};

// Implemented as part of "quick and dirty" add user to company interface
//   Rethink when overhauling with a more complete solution
var fetchAdminProjectsInCompany = exports.fetchAdminProjectsInCompany = function fetchAdminProjectsInCompany(company) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_PROJECTS_REQUEST, FETCH_PROJECTS_SUCCESS, FETCH_PROJECTS_FAILURE],
    endpoint: 'admin/companies/' + company.id + '/projects.json',
    requestType: _api.REQUEST_GET,
    schema: _index.PROJECT_COLLECTION
  });
};

var toggleProject = exports.toggleProject = function toggleProject(projectId, selected) {
  return {
    type: TOGGLE_PROJECT,
    projectId: projectId,
    selected: selected
  };
};

var clearSelectedProjects = exports.clearSelectedProjects = function clearSelectedProjects() {
  return { type: CLEAR_SELECTED_PROJECTS };
};

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(133);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(163);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = observable, _ref2;
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(140);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(87);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(292),
    isArguments = __webpack_require__(98),
    isArray = __webpack_require__(17),
    isBuffer = __webpack_require__(82),
    isIndex = __webpack_require__(123),
    isTypedArray = __webpack_require__(89);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(25);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBoundingClientRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_math_js__ = __webpack_require__(93);


function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["b" /* isHTMLElement */])(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = Object(__WEBPACK_IMPORTED_MODULE_1__utils_math_js__["c" /* round */])(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = Object(__WEBPACK_IMPORTED_MODULE_1__utils_math_js__["c" /* round */])(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffsetParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNodeName_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isTableElement_js__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getParentNode_js__ = __webpack_require__(226);







function getTrueOffsetParent(element) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(element) || // https://github.com/popperjs/popper-core/issues/837
  Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = Object(__WEBPACK_IMPORTED_MODULE_5__getParentNode_js__["a" /* default */])(element);

  while (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(currentNode) && ['html', 'body'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(currentNode)) < 0) {
    var css = Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && Object(__WEBPACK_IMPORTED_MODULE_4__isTableElement_js__["a" /* default */])(offsetParent) && Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(offsetParent) === 'html' || Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(offsetParent) === 'body' && Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getVariation;
function getVariation(placement) {
  return placement.split('-')[1];
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detectOverflow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getClippingRect_js__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getDocumentElement_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_getBoundingClientRect_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__computeOffsets_js__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rectToClientRect_js__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_utils_instanceOf_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mergePaddingObject_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__expandToHashMap_js__ = __webpack_require__(643);








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["d" /* clippingParents */] : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["o" /* viewport */] : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = Object(__WEBPACK_IMPORTED_MODULE_7__mergePaddingObject_js__["a" /* default */])(typeof padding !== 'number' ? padding : Object(__WEBPACK_IMPORTED_MODULE_8__expandToHashMap_js__["a" /* default */])(padding, __WEBPACK_IMPORTED_MODULE_5__enums_js__["b" /* basePlacements */]));
  var altContext = elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["j" /* reference */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */];
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getClippingRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__dom_utils_instanceOf_js__["a" /* isElement */])(element) ? element : element.contextElement || Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getDocumentElement_js__["a" /* default */])(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getBoundingClientRect_js__["a" /* default */])(state.elements.reference);
  var popperOffsets = Object(__WEBPACK_IMPORTED_MODULE_3__computeOffsets_js__["a" /* default */])({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = Object(__WEBPACK_IMPORTED_MODULE_4__rectToClientRect_js__["a" /* default */])(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["k" /* right */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(key) >= 0 ? 1 : -1;
      var axis = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCompanies = exports.updateCompany = exports.removeWordCloud = exports.submitWordCloudFailed = exports.submitWordCloudSucceeded = exports.submitWordCloudRequest = exports.createCompany = exports.SUBMIT_WORD_CLOUD_FAILED = exports.SUBMIT_WORD_CLOUD_SUCCEEDED = exports.SUBMIT_WORD_CLOUD_REQUEST = exports.REMOVE_WORD_CLOUD_FAILED = exports.REMOVE_WORD_CLOUD_SUCCEEDED = exports.REMOVE_WORD_CLOUD_REQUEST = exports.UPDATE_COMPANY_FAILED = exports.UPDATE_COMPANY_SUCCEEDED = exports.UPDATE_COMPANY_REQUEST = exports.FETCH_COMPANIES_FAILED = exports.FETCH_COMPANIES_SUCCEEDED = exports.FETCH_COMPANIES_REQUEST = exports.CREATE_COMPANY_FAILED = exports.CREATE_COMPANY_SUCCEEDED = exports.CREATE_COMPANY_REQUEST = undefined;

var _api = __webpack_require__(4);

var _schemas = __webpack_require__(3);

var _AlertListItem = __webpack_require__(7);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CREATE_COMPANY_REQUEST = exports.CREATE_COMPANY_REQUEST = 'tru/companies/CREATE_COMPANY_REQUEST';
var CREATE_COMPANY_SUCCEEDED = exports.CREATE_COMPANY_SUCCEEDED = 'tru/companies/CREATE_COMPANY_SUCCEEDED';
var CREATE_COMPANY_FAILED = exports.CREATE_COMPANY_FAILED = 'tru/companies/CREATE_COMPANY_FAILED';
var FETCH_COMPANIES_REQUEST = exports.FETCH_COMPANIES_REQUEST = 'tru/companies/FETCH_COMPANIES_REQUEST';
var FETCH_COMPANIES_SUCCEEDED = exports.FETCH_COMPANIES_SUCCEEDED = 'tru/companies/FETCH_COMPANIES_SUCCEEDED';
var FETCH_COMPANIES_FAILED = exports.FETCH_COMPANIES_FAILED = 'tru/companies/FETCH_COMPANIES_FAILED';
var UPDATE_COMPANY_REQUEST = exports.UPDATE_COMPANY_REQUEST = 'tru/companies/UPDATE_COMPANY_REQUEST';
var UPDATE_COMPANY_SUCCEEDED = exports.UPDATE_COMPANY_SUCCEEDED = 'tru/companies/UPDATE_COMPANY_SUCCEEDED';
var UPDATE_COMPANY_FAILED = exports.UPDATE_COMPANY_FAILED = 'tru/companies/UPDATE_COMPANY_FAILED';
var REMOVE_WORD_CLOUD_REQUEST = exports.REMOVE_WORD_CLOUD_REQUEST = 'tru/companies/REMOVE_WORD_CLOUD_REQUEST';
var REMOVE_WORD_CLOUD_SUCCEEDED = exports.REMOVE_WORD_CLOUD_SUCCEEDED = 'tru/companies/REMOVE_WORD_CLOUD_SUCCEEDED';
var REMOVE_WORD_CLOUD_FAILED = exports.REMOVE_WORD_CLOUD_FAILED = 'tru/companies/REMOVE_WORD_CLOUD_FAILED';
var SUBMIT_WORD_CLOUD_REQUEST = exports.SUBMIT_WORD_CLOUD_REQUEST = 'tru/companies/SUBMIT_WORD_CLOUD_REQUEST';
var SUBMIT_WORD_CLOUD_SUCCEEDED = exports.SUBMIT_WORD_CLOUD_SUCCEEDED = 'tru/companies/SUBMIT_WORD_CLOUD_SUCCEEDED';
var SUBMIT_WORD_CLOUD_FAILED = exports.SUBMIT_WORD_CLOUD_FAILED = 'tru/companies/SUBMIT_WORD_CLOUD_FAILED';

var createCompany = exports.createCompany = function createCompany(attributes) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, CREATE_COMPANY_FAILED, function (error) {
    return {
      alert: {
        type: _AlertListItem.ERROR,
        message: error.error[0],
        scope: 'createCompanyError'
      }
    };
  }), _defineProperty(_ref, CREATE_COMPANY_SUCCEEDED, {
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Company successfully created',
      scope: 'createCompanySuccess'
    }
  }), _defineProperty(_ref, _api.CALL_API, {
    types: [CREATE_COMPANY_REQUEST, CREATE_COMPANY_SUCCEEDED, CREATE_COMPANY_FAILED],
    endpoint: 'companies.json',
    requestType: _api.REQUEST_POST,
    data: { company: attributes },
    schema: _schemas.COMPANY
  }), _ref;
};

var updateCompanyRequest = function updateCompanyRequest(id, attributes) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, UPDATE_COMPANY_SUCCEEDED, {
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Settings have been updated.'
    }
  }), _defineProperty(_ref2, UPDATE_COMPANY_FAILED, {
    alert: {
      type: _AlertListItem.ERROR,
      message: 'There was a problem updating the company settings. Please try again.'
    }
  }), _defineProperty(_ref2, _api.CALL_API, {
    types: [UPDATE_COMPANY_REQUEST, UPDATE_COMPANY_SUCCEEDED, UPDATE_COMPANY_FAILED],
    endpoint: 'companies/' + id + '.json',
    requestType: _api.REQUEST_PUT,
    data: { company: attributes },
    schema: _schemas.NONE
  }), _ref2;
};

var submitWordCloudRequest = exports.submitWordCloudRequest = function submitWordCloudRequest() {
  return {
    type: SUBMIT_WORD_CLOUD_REQUEST
  };
};

var submitWordCloudSucceeded = exports.submitWordCloudSucceeded = function submitWordCloudSucceeded(wordCloud) {
  return {
    type: SUBMIT_WORD_CLOUD_SUCCEEDED,
    wordCloud: wordCloud
  };
};

var submitWordCloudFailed = exports.submitWordCloudFailed = function submitWordCloudFailed(error) {
  return {
    type: SUBMIT_WORD_CLOUD_FAILED,
    error: error
  };
};

var removeWordCloud = exports.removeWordCloud = function removeWordCloud(company) {
  var _ref3;

  return _ref3 = {}, _defineProperty(_ref3, REMOVE_WORD_CLOUD_FAILED, {
    alert: {
      type: _AlertListItem.ERROR,
      message: 'Word cloud could not be removed. Please try again.'
    }
  }), _defineProperty(_ref3, _api.CALL_API, {
    types: [REMOVE_WORD_CLOUD_REQUEST, REMOVE_WORD_CLOUD_SUCCEEDED, REMOVE_WORD_CLOUD_FAILED],
    endpoint: 'companies/' + company.id + '/word_cloud.json',
    requestType: _api.REQUEST_DELETE,
    schema: _schemas.NONE
  }), _ref3;
};

var updateCompany = exports.updateCompany = function updateCompany(id, attributes) {
  return function (dispatch) {
    return dispatch(updateCompanyRequest(id, attributes)).then(function (action) {
      var name = action.response.name;

      var dropdownOption = document.querySelector('#current-company-name span');
      var companyName = document.querySelector('#current-company-name + .dropdown-menu .bold');

      dropdownOption.innerText = name;
      companyName.innerText = name;
    });
  };
};

var fetchCompanies = exports.fetchCompanies = function fetchCompanies(_ref4) {
  var _ref5;

  var _ref4$page = _ref4.page,
      page = _ref4$page === undefined ? 1 : _ref4$page,
      _ref4$perPage = _ref4.perPage,
      perPage = _ref4$perPage === undefined ? 30 : _ref4$perPage,
      query = _ref4.query;
  return _ref5 = {}, _defineProperty(_ref5, FETCH_COMPANIES_REQUEST, { page: page, query: query }), _defineProperty(_ref5, _api.CALL_API, {
    types: [FETCH_COMPANIES_REQUEST, FETCH_COMPANIES_SUCCEEDED, FETCH_COMPANIES_FAILED],
    endpoint: 'companies.json',
    requestType: _api.REQUEST_GET,
    data: { page: page, perPage: perPage, query: query },
    dataGetter: function dataGetter(data) {
      return data.companies;
    },
    schema: _schemas.COMPANY_COLLECTION
  }), _ref5;
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_RECENT_SEARCHES_FAILURE = exports.FETCH_RECENT_SEARCHES_SUCCESS = exports.FETCH_RECENT_SEARCHES_REQUEST = exports.SEARCH_CREATE_FAILURE = exports.SEARCH_CREATE_SUCCESS = exports.SEARCH_CREATE_REQUEST = undefined;
exports.createSearch = createSearch;
exports.fetchRecentSearches = fetchRecentSearches;

var _api = __webpack_require__(4);

var _index = __webpack_require__(3);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SEARCH_CREATE_REQUEST = exports.SEARCH_CREATE_REQUEST = 'SEARCH_CREATE_REQUEST';
var SEARCH_CREATE_SUCCESS = exports.SEARCH_CREATE_SUCCESS = 'SEARCH_CREATE_SUCCESS';
var SEARCH_CREATE_FAILURE = exports.SEARCH_CREATE_FAILURE = 'SEARCH_CREATE_FAILURE';
var FETCH_RECENT_SEARCHES_REQUEST = exports.FETCH_RECENT_SEARCHES_REQUEST = 'FETCH_RECENT_SEARCHES_REQUEST';
var FETCH_RECENT_SEARCHES_SUCCESS = exports.FETCH_RECENT_SEARCHES_SUCCESS = 'FETCH_RECENT_SEARCHES_SUCCESS';
var FETCH_RECENT_SEARCHES_FAILURE = exports.FETCH_RECENT_SEARCHES_FAILURE = 'FETCH_RECENT_SEARCHES_FAILURE';

function createSearch(company, attrs) {
  return _defineProperty({}, _api.CALL_API, {
    types: [SEARCH_CREATE_REQUEST, SEARCH_CREATE_SUCCESS, SEARCH_CREATE_FAILURE],
    endpoint: 'companies/' + company.id + '/searches.json',
    requestType: _api.REQUEST_POST,
    schema: _index.SEARCH,
    data: {
      search: attrs
    }
  });
}

function fetchRecentSearches(company) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_RECENT_SEARCHES_REQUEST, FETCH_RECENT_SEARCHES_SUCCESS, FETCH_RECENT_SEARCHES_FAILURE],
    endpoint: 'companies/' + company.id + '/searches/recent.json',
    requestType: _api.REQUEST_GET,
    schema: _index.SEARCH_COLLECTION
  });
}

/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(155);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(125),
    setCacheAdd = __webpack_require__(380),
    setCacheHas = __webpack_require__(381);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(10);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(25),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HIGHLIGHT_FAILURE = exports.HIGHLIGHT_SUCCESS = exports.HIGHLIGHT_REQUEST = exports.ADD_HIGHLIGHT_TO_WORKSPACE_FAILURE = exports.ADD_HIGHLIGHT_TO_WORKSPACE_SUCCESS = exports.ADD_HIGHLIGHT_TO_WORKSPACE_REQUEST = undefined;
exports.addHighlightToWorkspace = addHighlightToWorkspace;
exports.fetchHighlight = fetchHighlight;

var _api = __webpack_require__(4);

var _index = __webpack_require__(3);

var _AlertListItem = __webpack_require__(7);

var _uniq = __webpack_require__(23);

var _uniq2 = _interopRequireDefault(_uniq);

var _urlHelper = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ADD_HIGHLIGHT_TO_WORKSPACE_REQUEST = exports.ADD_HIGHLIGHT_TO_WORKSPACE_REQUEST = 'ADD_HIGHLIGHT_TO_WORKSPACE_REQUEST';
var ADD_HIGHLIGHT_TO_WORKSPACE_SUCCESS = exports.ADD_HIGHLIGHT_TO_WORKSPACE_SUCCESS = 'ADD_HIGHLIGHT_TO_WORKSPACE_SUCCESS';
var ADD_HIGHLIGHT_TO_WORKSPACE_FAILURE = exports.ADD_HIGHLIGHT_TO_WORKSPACE_FAILURE = 'ADD_HIGHLIGHT_TO_WORKSPACE_FAILURE';
var HIGHLIGHT_REQUEST = exports.HIGHLIGHT_REQUEST = 'HIGHLIGHT_REQUEST';
var HIGHLIGHT_SUCCESS = exports.HIGHLIGHT_SUCCESS = 'HIGHLIGHT_SUCCESS';
var HIGHLIGHT_FAILURE = exports.HIGHLIGHT_FAILURE = 'HIGHLIGHT_FAILURE';

function addHighlightToWorkspace(company, highlight, workspace) {
  var _ref;

  var workspaceURL = (0, _urlHelper.buildBaseURL)('workspaces/' + workspace.id);

  return _ref = {}, _defineProperty(_ref, ADD_HIGHLIGHT_TO_WORKSPACE_SUCCESS, {
    entities: {
      highlights: _defineProperty({}, highlight.id, {
        workspaces: (0, _uniq2.default)([].concat(_toConsumableArray(highlight.workspaces), [workspace.id]))
      })
    },
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Added to ' + workspace.name + '. <a href="' + workspaceURL + '">View it now!</a>',
      htmlSafe: true
    }
  }), _defineProperty(_ref, _api.CALL_API, {
    types: [ADD_HIGHLIGHT_TO_WORKSPACE_REQUEST, ADD_HIGHLIGHT_TO_WORKSPACE_SUCCESS, ADD_HIGHLIGHT_TO_WORKSPACE_FAILURE],
    endpoint: 'companies/' + company.id + '/workspaces/' + workspace.id + '/highlights/' + highlight.id + '.json',
    requestType: _api.REQUEST_POST,
    schema: _index.NONE
  }), _ref;
}

function fetchHighlight(company, id) {
  return _defineProperty({}, _api.CALL_API, {
    types: [HIGHLIGHT_REQUEST, HIGHLIGHT_SUCCESS, HIGHLIGHT_FAILURE],
    endpoint: 'companies/' + company.id + '/highlights/' + id + '.json',
    requestType: _api.REQUEST_GET,
    schema: _index.HIGHLIGHT
  });
}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPORT_FAILURE = exports.REPORT_SUCCESS = exports.REPORT_REQUEST = exports.ADD_REPORT_TO_WORKSPACE_FAILURE = exports.ADD_REPORT_TO_WORKSPACE_SUCCESS = exports.ADD_REPORT_TO_WORKSPACE_REQUEST = undefined;
exports.fetchReport = fetchReport;
exports.addReportToWorkspace = addReportToWorkspace;

var _api = __webpack_require__(4);

var _index = __webpack_require__(3);

var _AlertListItem = __webpack_require__(7);

var _uniq = __webpack_require__(23);

var _uniq2 = _interopRequireDefault(_uniq);

var _urlHelper = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ADD_REPORT_TO_WORKSPACE_REQUEST = exports.ADD_REPORT_TO_WORKSPACE_REQUEST = 'ADD_REPORT_TO_WORKSPACE_REQUEST';
var ADD_REPORT_TO_WORKSPACE_SUCCESS = exports.ADD_REPORT_TO_WORKSPACE_SUCCESS = 'ADD_REPORT_TO_WORKSPACE_SUCCESS';
var ADD_REPORT_TO_WORKSPACE_FAILURE = exports.ADD_REPORT_TO_WORKSPACE_FAILURE = 'ADD_REPORT_TO_WORKSPACE_FAILURE';
var REPORT_REQUEST = exports.REPORT_REQUEST = 'REPORT_REQUEST';
var REPORT_SUCCESS = exports.REPORT_SUCCESS = 'REPORT_SUCCESS';
var REPORT_FAILURE = exports.REPORT_FAILURE = 'REPORT_FAILURE';

function fetchReport(company, id) {
  return _defineProperty({}, _api.CALL_API, {
    types: [REPORT_REQUEST, REPORT_SUCCESS, REPORT_FAILURE],
    endpoint: 'companies/' + company.id + '/reports/' + id + '.json',
    requestType: _api.REQUEST_GET,
    schema: _index.REPORT
  });
}

function addReportToWorkspace(company, report, workspace) {
  var _ref2;

  var workspaceURL = (0, _urlHelper.buildBaseURL)('workspaces/' + workspace.id);
  return _ref2 = {}, _defineProperty(_ref2, ADD_REPORT_TO_WORKSPACE_SUCCESS, {
    entities: {
      reports: _defineProperty({}, report.id, {
        workspaces: (0, _uniq2.default)([].concat(_toConsumableArray(report.workspaces), [workspace.id]))
      })
    },
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Added to ' + workspace.name + '. <a href="' + workspaceURL + '">View it now!</a>',
      htmlSafe: true
    }
  }), _defineProperty(_ref2, _api.CALL_API, {
    types: [ADD_REPORT_TO_WORKSPACE_REQUEST, ADD_REPORT_TO_WORKSPACE_SUCCESS, ADD_REPORT_TO_WORKSPACE_FAILURE],
    endpoint: 'companies/' + company.id + '/workspaces/' + workspace.id + '/reports/' + report.id + '.json',
    requestType: _api.REQUEST_POST,
    schema: _index.NONE
  }), _ref2;
}

/***/ }),
/* 162 */,
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(280);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14), __webpack_require__(40)(module)))

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(326),
    Map = __webpack_require__(91),
    Promise = __webpack_require__(327),
    Set = __webpack_require__(159),
    WeakMap = __webpack_require__(261),
    baseGetTag = __webpack_require__(31),
    toSource = __webpack_require__(144);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectVendor = exports.selectHideCompleted = exports.selectFilter = exports.selectOrder = exports.selectSort = exports.selectTotalPages = exports.selectPage = exports.selectLoading = exports.selectTranscriptRequests = undefined;

var _redux = __webpack_require__(20);

var _transcriptionTranscriptRequestActions = __webpack_require__(370);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOTAL_PAGES = /page\[number]=(\d+)/i;

var pageFromUrl = function pageFromUrl(url) {
  var decodedUrl = decodeURI(url);
  var results = TOTAL_PAGES.exec(decodedUrl) || [];
  return parseInt(results[1] || 1, 10);
};

var normalizeId = function normalizeId(id) {
  return parseInt(id, 10);
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST:
    case _transcriptionTranscriptRequestActions.RETRY_TRANSCRIPT_REQUEST_REQUEST:
      return true;
    case _transcriptionTranscriptRequestActions.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED:
    case _transcriptionTranscriptRequestActions.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED:
    case _transcriptionTranscriptRequestActions.RETRY_TRANSCRIPT_REQUEST_SUCCEEDED:
    case _transcriptionTranscriptRequestActions.RETRY_TRANSCRIPT_REQUEST_FAILED:
      return false;
    default:
      return state;
  }
};

var byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED:
      return action.data.data.reduce(function (memo, transcriptRequest) {
        return Object.assign({}, memo, _defineProperty({}, normalizeId(transcriptRequest.id), transcriptRequest));
      }, {});
    case _transcriptionTranscriptRequestActions.RETRY_TRANSCRIPT_REQUEST_SUCCEEDED:
      return Object.assign({}, state, _defineProperty({}, normalizeId(action.id), action.data.data));
    default:
      return state;
  }
};

var ids = function ids() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED:
      return action.data.data.map(function (transcriptRequest) {
        return normalizeId(transcriptRequest.id);
      });
    default:
      return state;
  }
};

var filter = function filter() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.CHANGE_FILTER:
      return action.filter === '' ? null : action.filter;
    default:
      return state;
  }
};

var vendor = function vendor() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.CHANGE_VENDOR:
      return action.vendor === '' ? null : action.vendor;
    default:
      return state;
  }
};

var totalPages = function totalPages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED:
      return pageFromUrl(action.data.links.last);
    default:
      return state;
  }
};

var page = function page() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.CHANGE_PAGE:
      return action.page;
    case _transcriptionTranscriptRequestActions.CHANGE_FILTER:
      return 1;
    default:
      return state;
  }
};

var sort = function sort() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.CHANGE_SORT:
      return action.sort;
    case _transcriptionTranscriptRequestActions.CHANGE_FILTER:
      return 'id';
    default:
      return state;
  }
};

var order = function order() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'desc';
  var action = arguments[1];

  switch (action.type) {
    case _transcriptionTranscriptRequestActions.CHANGE_SORT:
      return action.order;
    case _transcriptionTranscriptRequestActions.CHANGE_FILTER:
      return 'desc';
    default:
      return state;
  }
};

var hideCompleted = function hideCompleted() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  if (action.type === _transcriptionTranscriptRequestActions.CHANGE_HIDE_COMPLETED) {
    return action.hideCompleted;
  }
  return state;
};

exports.default = (0, _redux.combineReducers)({
  byId: byId,
  ids: ids,
  filter: filter,
  page: page,
  loading: loading,
  order: order,
  sort: sort,
  totalPages: totalPages,
  hideCompleted: hideCompleted,
  vendor: vendor
});
var selectTranscriptRequests = exports.selectTranscriptRequests = function selectTranscriptRequests(state) {
  return state.ids.map(function (id) {
    return state.byId[id];
  });
};

var selectLoading = exports.selectLoading = function selectLoading(state) {
  return state.loading;
};
var selectPage = exports.selectPage = function selectPage(state) {
  return state.page;
};
var selectTotalPages = exports.selectTotalPages = function selectTotalPages(state) {
  return state.totalPages;
};
var selectSort = exports.selectSort = function selectSort(state) {
  return state.sort;
};
var selectOrder = exports.selectOrder = function selectOrder(state) {
  return state.order;
};
var selectFilter = exports.selectFilter = function selectFilter(state) {
  return state.filter;
};
var selectHideCompleted = exports.selectHideCompleted = function selectHideCompleted(state) {
  return state.hideCompleted;
};
var selectVendor = exports.selectVendor = function selectVendor(state) {
  return state.vendor;
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectFilter = exports.selectOrder = exports.selectSort = exports.selectTotalPages = exports.selectPage = exports.selectLoading = exports.selectStudiesWithTranscriptsOrdered = undefined;

var _redux = __webpack_require__(20);

var _studiesWithTranscriptsOrderedActions = __webpack_require__(371);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOTAL_PAGES = /page\[number]=(\d+)/i;

var pageFromUrl = function pageFromUrl(url) {
  var decodedUrl = decodeURI(url);
  var results = TOTAL_PAGES.exec(decodedUrl) || [];
  return parseInt(results[1] || 1, 10);
};

var normalizeId = function normalizeId(id) {
  return parseInt(id, 10);
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case _studiesWithTranscriptsOrderedActions.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST:
      return true;
    case _studiesWithTranscriptsOrderedActions.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED:
    case _studiesWithTranscriptsOrderedActions.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED:
      return false;
    default:
      return state;
  }
};

var studiesWithProjectById = function studiesWithProjectById(action) {
  var _action$data = action.data,
      data = _action$data.data,
      included = _action$data.included;


  var studies = data.reduce(function (memo, study) {
    var projectId = study.relationships.project.data.id;
    var project = included.find(function (included) {
      return included.id === projectId && included.type === 'projects';
    }) || { attributes: { name: 'Missing Project' } };

    return Object.assign({}, memo, _defineProperty({}, normalizeId(study.id), Object.assign({}, study, { project: project })));
  }, {});

  return studies;
};

var byId = function byId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _studiesWithTranscriptsOrderedActions.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED:
      return studiesWithProjectById(action);

    default:
      return state;
  }
};

var ids = function ids() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _studiesWithTranscriptsOrderedActions.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED:
      return action.data.data.map(function (study) {
        return normalizeId(study.id);
      });
    default:
      return state;
  }
};

var filter = function filter() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case _studiesWithTranscriptsOrderedActions.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER:
      return action.filter === '' ? null : action.filter;
    default:
      return state;
  }
};

var totalPages = function totalPages() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case _studiesWithTranscriptsOrderedActions.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED:
      return pageFromUrl(action.data.links.last);
    default:
      return state;
  }
};

var page = function page() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case _studiesWithTranscriptsOrderedActions.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE:
      return action.page;
    case _studiesWithTranscriptsOrderedActions.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER:
      return 1;
    default:
      return state;
  }
};

var sort = function sort() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id';
  var action = arguments[1];

  switch (action.type) {
    case _studiesWithTranscriptsOrderedActions.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT:
      return action.sort;
    case _studiesWithTranscriptsOrderedActions.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER:
      return 'id';
    default:
      return state;
  }
};

var order = function order() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'desc';
  var action = arguments[1];

  switch (action.type) {
    case _studiesWithTranscriptsOrderedActions.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT:
      return action.order;
    case _studiesWithTranscriptsOrderedActions.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER:
      return 'desc';
    default:
      return state;
  }
};

exports.default = (0, _redux.combineReducers)({
  byId: byId,
  ids: ids,
  filter: filter,
  page: page,
  loading: loading,
  order: order,
  sort: sort,
  totalPages: totalPages
});
var selectStudiesWithTranscriptsOrdered = exports.selectStudiesWithTranscriptsOrdered = function selectStudiesWithTranscriptsOrdered(state) {
  return state.ids.map(function (id) {
    return state.byId[id];
  });
};

var selectLoading = exports.selectLoading = function selectLoading(state) {
  return state.loading;
};
var selectPage = exports.selectPage = function selectPage(state) {
  return state.page;
};
var selectTotalPages = exports.selectTotalPages = function selectTotalPages(state) {
  return state.totalPages;
};
var selectSort = exports.selectSort = function selectSort(state) {
  return state.sort;
};
var selectOrder = exports.selectOrder = function selectOrder(state) {
  return state.order;
};
var selectFilter = exports.selectFilter = function selectFilter(state) {
  return state.filter;
};

/***/ }),
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isObject = __webpack_require__(9);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnionSchema = function () {
  function UnionSchema(itemSchema, options) {
    _classCallCheck(this, UnionSchema);

    if (!(0, _isObject2.default)(itemSchema)) {
      throw new Error('UnionSchema requires item schema to be an object.');
    }

    if (!options || !options.schemaAttribute) {
      throw new Error('UnionSchema requires schemaAttribute option.');
    }

    this._itemSchema = itemSchema;

    var schemaAttribute = options.schemaAttribute;
    this._getSchema = typeof schemaAttribute === 'function' ? schemaAttribute : function (x) {
      return x[schemaAttribute];
    };
  }

  _createClass(UnionSchema, [{
    key: 'getItemSchema',
    value: function getItemSchema() {
      return this._itemSchema;
    }
  }, {
    key: 'getSchemaKey',
    value: function getSchemaKey(item) {
      return this._getSchema(item);
    }
  }]);

  return UnionSchema;
}();

exports.default = UnionSchema;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(156),
    arraySome = __webpack_require__(382),
    cacheHas = __webpack_require__(157);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var buildURL = __webpack_require__(388);
var parseHeaders = __webpack_require__(389);
var transformData = __webpack_require__(173);
var isURLSameOrigin = __webpack_require__(390);
var btoa = window.btoa || __webpack_require__(391);

module.exports = function xhrAdapter(resolve, reject, config) {
  var requestData = config.data;
  var requestHeaders = config.headers;

  if (utils.isFormData(requestData)) {
    delete requestHeaders['Content-Type']; // Let the browser set it
  }

  var request = new XMLHttpRequest();

  // For IE 8/9 CORS support
  // Only supports POST and GET calls and doesn't returns the response headers.
  if (window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
    request = new window.XDomainRequest();
  }

  // HTTP basic authentication
  if (config.auth) {
    var username = config.auth.username || '';
    var password = config.auth.password || '';
    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
  }

  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

  // Set the request timeout in MS
  request.timeout = config.timeout;

  // Listen for ready state
  request.onload = function handleLoad() {
    if (!request) {
      return;
    }
    // Prepare the response
    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
    var responseData = ['text', ''].indexOf(config.responseType || '') !== -1 ? request.responseText : request.response;
    var response = {
      data: transformData(
        responseData,
        responseHeaders,
        config.transformResponse
      ),
      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
      status: request.status === 1223 ? 204 : request.status,
      statusText: request.status === 1223 ? 'No Content' : request.statusText,
      headers: responseHeaders,
      config: config
    };

    // Resolve or reject the Promise based on the status
    ((response.status >= 200 && response.status < 300) ||
     (!('status' in request) && response.responseText) ?
      resolve :
      reject)(response);

    // Clean up request
    request = null;
  };

  // Handle low level network errors
  request.onerror = function handleError() {
    // Real errors are hidden from us by the browser
    // onerror should only fire if it's a network error
    reject(new Error('Network Error'));

    // Clean up request
    request = null;
  };

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.
  if (utils.isStandardBrowserEnv()) {
    var cookies = __webpack_require__(392);

    // Add xsrf header
    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
        cookies.read(config.xsrfCookieName) :
        undefined;

    if (xsrfValue) {
      requestHeaders[config.xsrfHeaderName] = xsrfValue;
    }
  }

  // Add headers to the request
  if ('setRequestHeader' in request) {
    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
        // Remove Content-Type if data is undefined
        delete requestHeaders[key];
      } else {
        // Otherwise add header to the request
        request.setRequestHeader(key, val);
      }
    });
  }

  // Add withCredentials to request if needed
  if (config.withCredentials) {
    request.withCredentials = true;
  }

  // Add responseType to request if needed
  if (config.responseType) {
    try {
      request.responseType = config.responseType;
    } catch (e) {
      if (request.responseType !== 'json') {
        throw e;
      }
    }
  }

  if (utils.isArrayBuffer(requestData)) {
    requestData = new DataView(requestData);
  }

  // Send the request
  request.send(requestData);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(239);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CacheProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Emotion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ThemeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createEmotionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasOwnProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return withEmotionCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_utils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_serialize__ = __webpack_require__(64);






var hasOwnProperty = Object.prototype.hasOwnProperty;

var EmotionCacheContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? Object(__WEBPACK_IMPORTED_MODULE_2__emotion_cache__["a" /* default */])() : null);
var ThemeContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  if (false) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions

  if (false) {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  return newProps;
};

var Noop = function Noop() {
  return null;
};

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(registeredStyles);

  if (false) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(type, newProps);
  var possiblyStyleElement = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Noop, null);


  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef


var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {
  Emotion.displayName = 'EmotionCssPropInternal';
}




/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_serialize__ = __webpack_require__(64);


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__emotion_serialize__["a" /* serializeStyles */])(args);
}

/* harmony default export */ __webpack_exports__["a"] = (css);


/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"],
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"],
    meta: { form: form, sections: sections }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(414);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(187);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(423);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(446);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(71);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(459);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(15);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(74);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(476);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(191);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(193);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer);
  var stateEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(28);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(490);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(24);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(50);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(192);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      if (fields && fields.length) {
        return fields.every(function (field) {
          var fieldInitial = getIn(formState, form + '.initial.' + field);
          var fieldValue = getIn(formState, form + '.values.' + field);
          return deepEqual(fieldInitial, fieldValue);
        });
      }
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(49);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(51);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(186);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(589),
    createAssigner = __webpack_require__(592);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(86),
    eq = __webpack_require__(42);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(31),
    getPrototype = __webpack_require__(127),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 215 */,
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(141);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)(module)))

/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(95),
    overRest = __webpack_require__(248),
    setToString = __webpack_require__(243);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(31),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 220 */,
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CloseButton = (_temp = _class = function (_Component) {
  _inherits(CloseButton, _Component);

  function CloseButton(props) {
    _classCallCheck(this, CloseButton);

    var _this = _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(CloseButton, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.props.onClick(e);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('button', {
        className: 'close',
        dangerouslySetInnerHTML: { __html: '&times;' },
        onClick: this.handleClick
      });
    }
  }]);

  return CloseButton;
}(_react.Component), _class.propTypes = {
  onClick: _propTypes2.default.func.isRequired
}, _temp);
exports.default = CloseButton;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(379),
    isObjectLike = __webpack_require__(21);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(260),
    stubArray = __webpack_require__(242);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(42),
    isArrayLike = __webpack_require__(45),
    isIndex = __webpack_require__(123),
    isObject = __webpack_require__(9);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParentNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNodeName_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instanceOf_js__ = __webpack_require__(32);



function getParentNode(element) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__getNodeName_js__["a" /* default */])(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    Object(__WEBPACK_IMPORTED_MODULE_2__instanceOf_js__["c" /* isShadowRoot */])(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element) // fallback

  );
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = selectEntity;
var emptyEntity = {};

function selectEntity(entities, id) {
  if (!id) {
    return emptyEntity;
  }

  return entities[id] || { id: id };
}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableColumn = (_temp = _class = function (_Component) {
  _inherits(TableColumn, _Component);

  function TableColumn() {
    _classCallCheck(this, TableColumn);

    return _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).apply(this, arguments));
  }

  _createClass(TableColumn, [{
    key: 'render',
    value: function render() {
      if (false) {
        throw new Error('Component <TableColumn /> should never render');
      }

      return null;
    }
  }]);

  return TableColumn;
}(_react.Component), _class.propTypes = {
  align: _propTypes2.default.oneOf(['left', 'right', 'center']),
  cellRenderer: _propTypes2.default.func,
  dataGetter: _propTypes2.default.func,
  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  headerRenderer: _propTypes2.default.func,
  label: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  align: 'left'
}, _temp);
exports.default = TableColumn;

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionTypes", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayInsert", function() { return arrayInsert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMove", function() { return arrayMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayPop", function() { return arrayPop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayPush", function() { return arrayPush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRemove", function() { return arrayRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRemoveAll", function() { return arrayRemoveAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayShift", function() { return arrayShift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySplice", function() { return arraySplice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySwap", function() { return arraySwap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayUnshift", function() { return arrayUnshift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autofill", function() { return autofill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blur", function() { return blur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "change", function() { return change; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearAsyncError", function() { return clearAsyncError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearFields", function() { return clearFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSubmitErrors", function() { return clearSubmitErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroy", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focus", function() { return focus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialize", function() { return initialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerField", function() { return registerField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSection", function() { return resetSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubmitFailed", function() { return setSubmitFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubmitSucceeded", function() { return setSubmitSucceeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startAsyncValidation", function() { return startAsyncValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startSubmit", function() { return startSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopAsyncValidation", function() { return stopAsyncValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopSubmit", function() { return stopSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submit", function() { return submit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return touch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unregisterField", function() { return unregisterField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untouch", function() { return untouch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSyncWarnings", function() { return updateSyncWarnings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldAsyncValidate", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldValidate", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldError", function() { return __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldWarn", function() { return __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_6__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormName__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormName", function() { return __WEBPACK_IMPORTED_MODULE_7__FormName__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSection__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormSection", function() { return __WEBPACK_IMPORTED_MODULE_8__FormSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmissionError__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubmissionError", function() { return __WEBPACK_IMPORTED_MODULE_9__SubmissionError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes__ = __webpack_require__(415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldInputPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldMetaPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldArrayFieldsPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldArrayMetaPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldArrayPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_10__propTypes__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Field__ = __webpack_require__(416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return __WEBPACK_IMPORTED_MODULE_11__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fields__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Fields", function() { return __WEBPACK_IMPORTED_MODULE_12__Fields__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldArray__ = __webpack_require__(486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldArray", function() { return __WEBPACK_IMPORTED_MODULE_13__FieldArray__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValueSelector__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formValueSelector", function() { return __WEBPACK_IMPORTED_MODULE_14__formValueSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formValues__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formValues", function() { return __WEBPACK_IMPORTED_MODULE_15__formValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormError__ = __webpack_require__(510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormError", function() { return __WEBPACK_IMPORTED_MODULE_16__getFormError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormNames__ = __webpack_require__(512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormNames", function() { return __WEBPACK_IMPORTED_MODULE_17__getFormNames__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormValues__ = __webpack_require__(514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormValues", function() { return __WEBPACK_IMPORTED_MODULE_18__getFormValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__ = __webpack_require__(516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormInitialValues", function() { return __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__ = __webpack_require__(518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSyncErrors", function() { return __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormMeta__ = __webpack_require__(520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormMeta", function() { return __WEBPACK_IMPORTED_MODULE_21__getFormMeta__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormAsyncErrors", function() { return __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSyncWarnings", function() { return __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__ = __webpack_require__(526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSubmitErrors", function() { return __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__ = __webpack_require__(528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isAsyncValidating", function() { return __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isDirty__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDirty", function() { return __WEBPACK_IMPORTED_MODULE_26__isDirty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isInvalid__ = __webpack_require__(532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isInvalid", function() { return __WEBPACK_IMPORTED_MODULE_27__isInvalid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isPristine__ = __webpack_require__(535);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isPristine", function() { return __WEBPACK_IMPORTED_MODULE_28__isPristine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValid__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValid", function() { return __WEBPACK_IMPORTED_MODULE_29__isValid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isSubmitting__ = __webpack_require__(537);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSubmitting", function() { return __WEBPACK_IMPORTED_MODULE_30__isSubmitting__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hasSubmitSucceeded", function() { return __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__ = __webpack_require__(541);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hasSubmitFailed", function() { return __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reduxForm__ = __webpack_require__(543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduxForm", function() { return __WEBPACK_IMPORTED_MODULE_33__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducer__ = __webpack_require__(574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return __WEBPACK_IMPORTED_MODULE_34__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__values__ = __webpack_require__(577);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_35__values__["a"]; });










// alias for propTypes


























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearAsyncError = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearAsyncError;
var clearFields = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearFields;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var resetSection = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].resetSection;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;
var updateSyncWarnings = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].updateSyncWarnings;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(158);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */
/***/ (function(module, exports) {

module.exports = moment;

/***/ }),
/* 236 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearSelectedUsers = exports.clearUsers = exports.addUsersToProjects = exports.toggleUser = exports.checkUserExists = exports.removeUserFromCompany = exports.activateUserInCompany = exports.fetchUsers = exports.fetchAdminUsersInCompany = exports.fetchUsersInCompany = exports.sendWelcomeEmail = exports.updateUser = exports.fetchUserInCompany = exports.createUser = exports.UPDATE_USER_FAILED = exports.UPDATE_USER_SUCCEEDED = exports.UPDATE_USER_REQUEST = exports.TOGGLE_USER = exports.TOGGLE_ACTIVATE_USER_FAILED = exports.TOGGLE_ACTIVATE_USER_SUCCEEDED = exports.TOGGLE_ACTIVATE_USER_REQUEST = exports.SEND_WELCOME_EMAIL_FAILED = exports.SEND_WELCOME_EMAIL_SUCCEEDED = exports.SEND_WELCOME_EMAIL_REQUEST = exports.FETCH_USER_FAILED = exports.FETCH_USER_SUCCEEDED = exports.FETCH_USER_REQUEST = exports.FETCH_USERS_FAILED = exports.FETCH_USERS_SUCCEEDED = exports.FETCH_USERS_REQUEST = exports.CREATE_USER_FAILED = exports.CREATE_USER_SUCCEEDED = exports.CREATE_USER_REQUEST = exports.CLEAR_SELECTED_USERS = exports.CLEAR_USERS = exports.CHECK_USER_EXISTS_FAILED = exports.CHECK_USER_EXISTS_SUCCEEDED = exports.CHECK_USER_EXISTS_REQUEST = undefined;

var _api = __webpack_require__(4);

var _schemas = __webpack_require__(3);

var _humps = __webpack_require__(22);

var _AlertListItem = __webpack_require__(7);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CHECK_USER_EXISTS_REQUEST = exports.CHECK_USER_EXISTS_REQUEST = 'tru/users/CHECK_USER_EXISTS_REQUEST';
var CHECK_USER_EXISTS_SUCCEEDED = exports.CHECK_USER_EXISTS_SUCCEEDED = 'tru/users/CHECK_USER_EXISTS_SUCCEEDED';
var CHECK_USER_EXISTS_FAILED = exports.CHECK_USER_EXISTS_FAILED = 'tru/users/CHECK_USER_EXISTS_FAILED';
var CLEAR_USERS = exports.CLEAR_USERS = 'tru/users/CLEAR_USERS';
var CLEAR_SELECTED_USERS = exports.CLEAR_SELECTED_USERS = 'tru/users/CLEAR_SELECTED_USERS';
var CREATE_USER_REQUEST = exports.CREATE_USER_REQUEST = 'tru/users/CREATE_USER_REQUEST';
var CREATE_USER_SUCCEEDED = exports.CREATE_USER_SUCCEEDED = 'tru/users/CREATE_USER_SUCCEEDED';
var CREATE_USER_FAILED = exports.CREATE_USER_FAILED = 'tru/users/CREATE_USER_FAILED';
var FETCH_USERS_REQUEST = exports.FETCH_USERS_REQUEST = 'tru/users/FETCH_USERS_REQUEST';
var FETCH_USERS_SUCCEEDED = exports.FETCH_USERS_SUCCEEDED = 'tru/users/FETCH_USERS_SUCCEEDED';
var FETCH_USERS_FAILED = exports.FETCH_USERS_FAILED = 'tru/users/FETCH_USERS_FAILED';
var FETCH_USER_REQUEST = exports.FETCH_USER_REQUEST = 'tru/users/FETCH_USER_REQUEST';
var FETCH_USER_SUCCEEDED = exports.FETCH_USER_SUCCEEDED = 'tru/users/FETCH_USER_SUCCEEDED';
var FETCH_USER_FAILED = exports.FETCH_USER_FAILED = 'tru/users/FETCH_USER_FAILED';
var SEND_WELCOME_EMAIL_REQUEST = exports.SEND_WELCOME_EMAIL_REQUEST = 'tru/users/SEND_WELCOME_EMAIL_REQUEST';
var SEND_WELCOME_EMAIL_SUCCEEDED = exports.SEND_WELCOME_EMAIL_SUCCEEDED = 'tru/users/SEND_WELCOME_EMAIL_SUCCEEDED';
var SEND_WELCOME_EMAIL_FAILED = exports.SEND_WELCOME_EMAIL_FAILED = 'tru/users/SEND_WELCOME_EMAIL_FAILED';
var TOGGLE_ACTIVATE_USER_REQUEST = exports.TOGGLE_ACTIVATE_USER_REQUEST = 'tru/users/TOGGLE_ACTIVATE_USER_REQUEST';
var TOGGLE_ACTIVATE_USER_SUCCEEDED = exports.TOGGLE_ACTIVATE_USER_SUCCEEDED = 'tru/users/TOGGLE_ACTIVATE_USER_SUCCEEDED';
var TOGGLE_ACTIVATE_USER_FAILED = exports.TOGGLE_ACTIVATE_USER_FAILED = 'tru/users/TOGGLE_ACTIVATE_USER_FAILED';
var TOGGLE_USER = exports.TOGGLE_USER = 'tru/users/TOGGLE_USER';
var UPDATE_USER_REQUEST = exports.UPDATE_USER_REQUEST = 'tru/users/UPDATE_USER_REQUEST';
var UPDATE_USER_SUCCEEDED = exports.UPDATE_USER_SUCCEEDED = 'tru/users/UPDATE_USER_SUCCEEDED';
var UPDATE_USER_FAILED = exports.UPDATE_USER_FAILED = 'tru/users/UPDATE_USER_FAILED';

var createUser = exports.createUser = function createUser(company, user) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, CREATE_USER_SUCCEEDED, {
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'User successfully created'
    },
    location: '/users/managed'
  }), _defineProperty(_ref, CREATE_USER_FAILED, {
    alert: {
      type: _AlertListItem.ERROR,
      message: 'There was a problem creating the user. Please try again'
    }
  }), _defineProperty(_ref, _api.CALL_API, {
    types: [CREATE_USER_REQUEST, CREATE_USER_SUCCEEDED, CREATE_USER_FAILED],
    endpoint: 'companies/' + company.id + '/users.json',
    requestType: _api.REQUEST_POST,
    schema: _schemas.USER,
    data: { user: user }
  }), _ref;
};

var fetchUserInCompany = exports.fetchUserInCompany = function fetchUserInCompany(company, id) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_USER_REQUEST, FETCH_USER_SUCCEEDED, FETCH_USER_FAILED],
    requestType: _api.REQUEST_GET,
    endpoint: 'companies/' + company.id + '/users/' + id + '.json',
    schema: _schemas.USER
  });
};

var updateUser = exports.updateUser = function updateUser(company, user) {
  var _ref3;

  return _ref3 = {}, _defineProperty(_ref3, UPDATE_USER_SUCCEEDED, {
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'User successfully updated'
    }
  }), _defineProperty(_ref3, _api.CALL_API, {
    types: [UPDATE_USER_REQUEST, UPDATE_USER_SUCCEEDED, UPDATE_USER_FAILED],
    endpoint: 'companies/' + company.id + '/users/' + user.id + '.json',
    requestType: _api.REQUEST_PUT,
    schema: _schemas.USER,
    data: { user: user }
  }), _ref3;
};

var sendWelcomeEmail = exports.sendWelcomeEmail = function sendWelcomeEmail(company, user) {
  var _ref4;

  return _ref4 = {}, _defineProperty(_ref4, SEND_WELCOME_EMAIL_SUCCEEDED, {
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Welcome email sent to ' + user.email
    }
  }), _defineProperty(_ref4, SEND_WELCOME_EMAIL_FAILED, {
    alert: {
      type: _AlertListItem.ERROR,
      message: 'There was an error processing your request'
    }
  }), _defineProperty(_ref4, _api.CALL_API, {
    types: [SEND_WELCOME_EMAIL_REQUEST, SEND_WELCOME_EMAIL_SUCCEEDED, SEND_WELCOME_EMAIL_FAILED],
    endpoint: 'companies/' + company.id + '/users/' + user.id + '/send_welcome_notification.json',
    requestType: _api.REQUEST_POST,
    schema: _schemas.NONE
  }), _ref4;
};

var fetchUsersInCompany = exports.fetchUsersInCompany = function fetchUsersInCompany(company) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref5.type,
      _ref5$page = _ref5.page,
      page = _ref5$page === undefined ? 1 : _ref5$page,
      _ref5$perPage = _ref5.perPage,
      perPage = _ref5$perPage === undefined ? 30 : _ref5$perPage,
      query = _ref5.query,
      _ref5$sort = _ref5.sort,
      sort = _ref5$sort === undefined ? 'firstName' : _ref5$sort,
      _ref5$order = _ref5.order,
      order = _ref5$order === undefined ? 'asc' : _ref5$order;

  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_USERS_REQUEST, FETCH_USERS_SUCCEEDED, FETCH_USERS_FAILED],
    endpoint: 'companies/' + company.id + '/users/' + type + '.json',
    requestType: _api.REQUEST_GET,
    data: {
      order: order,
      page: page,
      perPage: perPage,
      query: query,
      sort: (0, _humps.decamelize)(sort)
    },
    dataGetter: function dataGetter(data) {
      return data.users;
    },
    schema: _schemas.USER_COLLECTION
  });
};

// Implemented as part of "quick and dirty" add user to company interface
//   Rethink when overhauling with a more complete solution
var fetchAdminUsersInCompany = exports.fetchAdminUsersInCompany = function fetchAdminUsersInCompany(company) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_USERS_REQUEST, FETCH_USERS_SUCCEEDED, FETCH_USERS_FAILED],
    endpoint: 'admin/companies/' + company.id + '/users.json',
    requestType: _api.REQUEST_GET,
    dataGetter: function dataGetter(data) {
      return data.users;
    },
    schema: _schemas.USER_COLLECTION
  });
};

var fetchUsers = exports.fetchUsers = function fetchUsers(_ref8) {
  var _ref9;

  var _ref8$page = _ref8.page,
      page = _ref8$page === undefined ? 1 : _ref8$page,
      _ref8$perPage = _ref8.perPage,
      perPage = _ref8$perPage === undefined ? 30 : _ref8$perPage,
      query = _ref8.query;
  return _ref9 = {}, _defineProperty(_ref9, FETCH_USERS_REQUEST, { page: page, query: query }), _defineProperty(_ref9, _api.CALL_API, {
    types: [FETCH_USERS_REQUEST, FETCH_USERS_SUCCEEDED, FETCH_USERS_FAILED],
    endpoint: 'users.json',
    requestType: _api.REQUEST_GET,
    data: { page: page, perPage: perPage, query: query },
    dataGetter: function dataGetter(data) {
      return data.users;
    },
    schema: _schemas.USER_COLLECTION
  }), _ref9;
};

var activateUserInCompany = exports.activateUserInCompany = function activateUserInCompany(company, user) {
  var _ref10;

  return _ref10 = {}, _defineProperty(_ref10, TOGGLE_ACTIVATE_USER_SUCCEEDED, {
    entities: {
      users: _defineProperty({}, user.id, {
        userCompany: { deleteFl: false }
      })
    },
    alert: {
      type: _AlertListItem.SUCCESS,
      message: user.email + I18n.t(' has been activated.')
    }
  }), _defineProperty(_ref10, TOGGLE_ACTIVATE_USER_FAILED, {
    alert: {
      type: _AlertListItem.ERROR,
      message: 'There was an error processing your request'
    }
  }), _defineProperty(_ref10, _api.CALL_API, {
    types: [TOGGLE_ACTIVATE_USER_REQUEST, TOGGLE_ACTIVATE_USER_SUCCEEDED, TOGGLE_ACTIVATE_USER_FAILED],
    endpoint: 'companies/' + company.id + '/users/' + user.id + '/activate.json',
    requestType: _api.REQUEST_PUT,
    schema: _schemas.NONE
  }), _ref10;
};

var removeUserFromCompany = exports.removeUserFromCompany = function removeUserFromCompany(company, user) {
  var _ref11;

  return _ref11 = {}, _defineProperty(_ref11, TOGGLE_ACTIVATE_USER_SUCCEEDED, {
    entities: {
      users: _defineProperty({}, user.id, {
        userCompany: { deleteFl: true }
      })
    },
    alert: {
      type: _AlertListItem.SUCCESS,
      message: user.email + I18n.t(' has been deactivated.')
    }
  }), _defineProperty(_ref11, TOGGLE_ACTIVATE_USER_FAILED, {
    alert: {
      type: _AlertListItem.ERROR,
      message: 'There was an error processing your request'
    }
  }), _defineProperty(_ref11, _api.CALL_API, {
    types: [TOGGLE_ACTIVATE_USER_REQUEST, TOGGLE_ACTIVATE_USER_SUCCEEDED, TOGGLE_ACTIVATE_USER_FAILED],
    endpoint: 'companies/' + company.id + '/users/' + user.id + '.json',
    requestType: _api.REQUEST_DELETE,
    schema: _schemas.NONE
  }), _ref11;
};

var checkUserExists = exports.checkUserExists = function checkUserExists(company, email) {
  var _ref13;

  return _ref13 = {}, _defineProperty(_ref13, CHECK_USER_EXISTS_SUCCEEDED, {
    location: function location(_ref12) {
      var _ref12$response = _ref12.response,
          existsInCompany = _ref12$response.existsInCompany,
          user = _ref12$response.user;

      if (existsInCompany) {
        return '/users/' + user.id + '/edit';
      }
      return false;
    }
  }), _defineProperty(_ref13, _api.CALL_API, {
    types: [CHECK_USER_EXISTS_REQUEST, CHECK_USER_EXISTS_SUCCEEDED, CHECK_USER_EXISTS_FAILED],
    endpoint: 'companies/' + company.id + '/users/exists.json',
    requestType: _api.REQUEST_GET,
    data: { email: email },
    dataGetter: function dataGetter(response) {
      return response.user;
    },
    schema: _schemas.USER
  }), _ref13;
};

var toggleUser = exports.toggleUser = function toggleUser(userId, selected) {
  return {
    type: TOGGLE_USER,
    userId: userId,
    selected: selected
  };
};

// Implemented as part of "quick and dirty" add user to company interface
//   Rethink when overhauling with a more complete solution
var addUsersToProjects = exports.addUsersToProjects = function addUsersToProjects(userIds, projectIds, roleId) {
  return _defineProperty({
    ADD_USERS_TO_PROJECT_FAILED: {
      alert: {
        type: _AlertListItem.ERROR,
        message: 'Failed to add users to projects. You may have forgotten to ' + 'select users or select projects'
      }
    },
    ADD_USERS_TO_PROJECT_SUCCESS: {
      alert: {
        type: _AlertListItem.SUCCESS,
        message: 'You have successfully requested the addition of ' + (userIds.length + ' user(s) to ' + projectIds.length + ' project(s). Be ') + 'aware that this may take up to an hour to add all users depending ' + 'on how many were selected'
      }
    }
  }, _api.CALL_API, {
    types: ['ADD_USERS_TO_PROJECT_REQUEST', 'ADD_USERS_TO_PROJECT_SUCCESS', 'ADD_USERS_TO_PROJECT_FAILED'],
    endpoint: 'admin/user_role_projects.json',
    requestType: _api.REQUEST_POST,
    data: { userIds: userIds, projectIds: projectIds, roleId: roleId },
    schema: _schemas.NONE
  });
};

var clearUsers = exports.clearUsers = function clearUsers() {
  return { type: CLEAR_USERS };
};
var clearSelectedUsers = exports.clearSelectedUsers = function clearSelectedUsers() {
  return { type: CLEAR_SELECTED_USERS };
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(291);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (weakMemoize);


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(217),
    isArray = __webpack_require__(17);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(328),
    shortOut = __webpack_require__(262);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(86),
    eq = __webpack_require__(42);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(259),
    baseIsNaN = __webpack_require__(297),
    strictIndexOf = __webpack_require__(298);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(241),
    getSymbols = __webpack_require__(223),
    keys = __webpack_require__(100);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(249);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEREGISTER_VIDEO_PLAYER = exports.DEREGISTER_VIDEO_PLAYER = 'tru/DEREGISTER_VIDEO_PLAYER';
var REGISTER_VIDEO_PLAYER = exports.REGISTER_VIDEO_PLAYER = 'tru/REGISTER_VIDEO_PLAYER';
var PLAY = exports.PLAY = 'tru/PLAY';
var PAUSE = exports.PAUSE = 'tru/PAUSE';

var registerVideoPlayer = exports.registerVideoPlayer = function registerVideoPlayer(id) {
  return {
    type: REGISTER_VIDEO_PLAYER,
    id: id
  };
};

var deregisterVideoPlayer = exports.deregisterVideoPlayer = function deregisterVideoPlayer(id) {
  return {
    type: DEREGISTER_VIDEO_PLAYER,
    id: id
  };
};

var play = exports.play = function play(id) {
  return {
    type: PLAY,
    id: id
  };
};

var pause = exports.pause = function pause(id) {
  return {
    type: PAUSE,
    id: id
  };
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(10);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)(module)))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(231);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(240),
    getPrototype = __webpack_require__(127),
    isPrototype = __webpack_require__(85);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(45),
    isObjectLike = __webpack_require__(21);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(85),
    nativeKeys = __webpack_require__(296);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 259 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(25),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 262 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(219);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasPermission = exports.hasPermission = function hasPermission(permissions, operation, object) {
  if (!permissions || !object || !operation) {
    return false;
  }

  var permission = permissions[object];

  if (!permission) {
    return false;
  }

  return permission.indexOf(operation) !== -1;
};

var hasPermissionWithPermissions = exports.hasPermissionWithPermissions = function hasPermissionWithPermissions(permissions) {
  return function (operation, object) {
    return hasPermission(permissions, operation, object);
  };
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(399);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(246);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchRoles = exports.FETCH_ROLES_FAILED = exports.FETCH_ROLES_SUCCEEDED = exports.FETCH_ROLES_REQUEST = undefined;

var _api = __webpack_require__(4);

var _schemas = __webpack_require__(3);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FETCH_ROLES_REQUEST = exports.FETCH_ROLES_REQUEST = 'tru/roles/FETCH_ROLES_REQUEST';
var FETCH_ROLES_SUCCEEDED = exports.FETCH_ROLES_SUCCEEDED = 'tru/roles/FETCH_ROLES_SUCCEEDED';
var FETCH_ROLES_FAILED = exports.FETCH_ROLES_FAILED = 'tru/roles/FETCH_ROLES_FAILED';

var fetchRoles = exports.fetchRoles = function fetchRoles(type) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_ROLES_REQUEST, FETCH_ROLES_SUCCEEDED, FETCH_ROLES_FAILED],
    endpoint: 'roles/' + type + '.json',
    requestType: _api.REQUEST_GET,
    schema: _schemas.ROLE_COLLECTION
  });
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_SELECT_RESULT = exports.TOGGLE_EXPAND_RESULT = exports.TOGGLE_ALL_SELECTED_RESULTS = exports.TOGGLE_ALL_RESULTS = exports.SEARCH_RESULT_DELETE_FAILURE = exports.SEARCH_RESULT_DELETE_SUCCESS = exports.SEARCH_RESULT_DELETE_REQUEST = exports.SEARCH_RESULT_UPDATE_FAILURE = exports.SEARCH_RESULT_UPDATE_SUCCESS = exports.SEARCH_RESULT_UPDATE_REQUEST = exports.SEARCH_RESULT_UPDATE_ATTRIBUTES = exports.SEARCH_RESULT_UNFAVORITE_FAILURE = exports.SEARCH_RESULT_UNFAVORITE_SUCCESS = exports.SEARCH_RESULT_UNFAVORITE_REQUEST = exports.SEARCH_RESULT_FAVORITE_FAILURE = exports.SEARCH_RESULT_FAVORITE_SUCCESS = exports.SEARCH_RESULT_FAVORITE_REQUEST = exports.SEARCH_RESULTS_FAILURE = exports.SEARCH_RESULTS_SUCCESS = exports.SEARCH_RESULTS_REQUEST = exports.CHANGE_SELECTED_VIEW = undefined;
exports.changeSelectedView = changeSelectedView;
exports.fetchSearchResults = fetchSearchResults;
exports.deleteResult = deleteResult;
exports.favoriteResult = favoriteResult;
exports.unfavoriteResult = unfavoriteResult;
exports.toggleExpandResult = toggleExpandResult;
exports.toggleAllResults = toggleAllResults;
exports.toggleAllSelectedResults = toggleAllSelectedResults;
exports.toggleSelectResult = toggleSelectResult;
exports.updateResult = updateResult;
exports.updateResultAttributes = updateResultAttributes;

var _api = __webpack_require__(4);

var _index = __webpack_require__(3);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CHANGE_SELECTED_VIEW = exports.CHANGE_SELECTED_VIEW = 'CHANGE_SELECTED_VIEW';
var SEARCH_RESULTS_REQUEST = exports.SEARCH_RESULTS_REQUEST = 'SEARCH_RESULTS_REQUEST';
var SEARCH_RESULTS_SUCCESS = exports.SEARCH_RESULTS_SUCCESS = 'SEARCH_RESULTS_SUCCESS';
var SEARCH_RESULTS_FAILURE = exports.SEARCH_RESULTS_FAILURE = 'SEARCH_RESULTS_FAILURE';
var SEARCH_RESULT_FAVORITE_REQUEST = exports.SEARCH_RESULT_FAVORITE_REQUEST = 'SEARCH_RESULT_FAVORITE_REQUEST';
var SEARCH_RESULT_FAVORITE_SUCCESS = exports.SEARCH_RESULT_FAVORITE_SUCCESS = 'SEARCH_RESULT_FAVORITE_SUCCESS';
var SEARCH_RESULT_FAVORITE_FAILURE = exports.SEARCH_RESULT_FAVORITE_FAILURE = 'SEARCH_RESULT_FAVORITE_FAILURE';
var SEARCH_RESULT_UNFAVORITE_REQUEST = exports.SEARCH_RESULT_UNFAVORITE_REQUEST = 'SEARCH_RESULT_UNFAVORITE_REQUEST';
var SEARCH_RESULT_UNFAVORITE_SUCCESS = exports.SEARCH_RESULT_UNFAVORITE_SUCCESS = 'SEARCH_RESULT_UNFAVORITE_SUCCESS';
var SEARCH_RESULT_UNFAVORITE_FAILURE = exports.SEARCH_RESULT_UNFAVORITE_FAILURE = 'SEARCH_RESULT_UNFAVORITE_FAILURE';
var SEARCH_RESULT_UPDATE_ATTRIBUTES = exports.SEARCH_RESULT_UPDATE_ATTRIBUTES = 'SEARCH_RESULT_UPDATE_ATTRIBUTES';
var SEARCH_RESULT_UPDATE_REQUEST = exports.SEARCH_RESULT_UPDATE_REQUEST = 'SEARCH_RESULT_UPDATE_REQUEST';
var SEARCH_RESULT_UPDATE_SUCCESS = exports.SEARCH_RESULT_UPDATE_SUCCESS = 'SEARCH_RESULT_UPDATE_SUCCESS';
var SEARCH_RESULT_UPDATE_FAILURE = exports.SEARCH_RESULT_UPDATE_FAILURE = 'SEARCH_RESULT_UPDATE_FAILURE';
var SEARCH_RESULT_DELETE_REQUEST = exports.SEARCH_RESULT_DELETE_REQUEST = 'SEARCH_RESULT_DELETE_REQUEST';
var SEARCH_RESULT_DELETE_SUCCESS = exports.SEARCH_RESULT_DELETE_SUCCESS = 'SEARCH_RESULT_DELETE_SUCCESS';
var SEARCH_RESULT_DELETE_FAILURE = exports.SEARCH_RESULT_DELETE_FAILURE = 'SEARCH_RESULT_DELETE_FAILURE';
var TOGGLE_ALL_RESULTS = exports.TOGGLE_ALL_RESULTS = 'TOGGLE_ALL_RESULTS';
var TOGGLE_ALL_SELECTED_RESULTS = exports.TOGGLE_ALL_SELECTED_RESULTS = 'TOGGLE_ALL_SELECTED_RESULTS';
var TOGGLE_EXPAND_RESULT = exports.TOGGLE_EXPAND_RESULT = 'TOGGLE_EXPAND_RESULT';
var TOGGLE_SELECT_RESULT = exports.TOGGLE_SELECT_RESULT = 'TOGGLE_SELECT_RESULT';

function changeSelectedView(view) {
  return {
    type: CHANGE_SELECTED_VIEW,
    view: view
  };
}

function fetchSearchResults(company, searchUrl) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return _defineProperty({}, _api.CALL_API, {
    types: [SEARCH_RESULTS_REQUEST, SEARCH_RESULTS_SUCCESS, SEARCH_RESULTS_FAILURE],
    endpoint: 'companies/' + company.id + '/searches/' + searchUrl + '/results.json',
    requestType: _api.REQUEST_GET,
    schema: _index.NONE,
    data: params
  });
}

function deleteResult(result) {
  return _defineProperty({
    result: result
  }, _api.CALL_API, {
    types: [SEARCH_RESULT_DELETE_REQUEST, SEARCH_RESULT_DELETE_SUCCESS, SEARCH_RESULT_DELETE_FAILURE],
    endpoint: result.url + '.json',
    requestType: _api.REQUEST_DELETE,
    schema: _index.NONE
  });
}

function favoriteResult(result) {
  return _defineProperty({
    result: result
  }, _api.CALL_API, {
    types: [SEARCH_RESULT_FAVORITE_REQUEST, SEARCH_RESULT_FAVORITE_SUCCESS, SEARCH_RESULT_FAVORITE_FAILURE],
    endpoint: result.url + '/favorite.json',
    requestType: _api.REQUEST_PUT,
    schema: _index.NONE
  });
}

function unfavoriteResult(result) {
  return _defineProperty({
    result: result
  }, _api.CALL_API, {
    types: [SEARCH_RESULT_UNFAVORITE_REQUEST, SEARCH_RESULT_UNFAVORITE_SUCCESS, SEARCH_RESULT_UNFAVORITE_FAILURE],
    endpoint: result.url + '/favorite.json',
    requestType: _api.REQUEST_DELETE,
    schema: _index.NONE
  });
}

function toggleExpandResult(result) {
  return {
    type: TOGGLE_EXPAND_RESULT,
    result: result
  };
}

function toggleAllResults(expanded) {
  return {
    type: TOGGLE_ALL_RESULTS,
    expanded: expanded
  };
}

function toggleAllSelectedResults(selected) {
  return {
    type: TOGGLE_ALL_SELECTED_RESULTS,
    selected: selected
  };
}

function toggleSelectResult(result) {
  return {
    type: TOGGLE_SELECT_RESULT,
    result: result
  };
}

function updateResult(result, data) {
  return _defineProperty({
    result: result,
    data: data
  }, _api.CALL_API, {
    types: [SEARCH_RESULT_UPDATE_REQUEST, SEARCH_RESULT_UPDATE_SUCCESS, SEARCH_RESULT_UPDATE_FAILURE],
    endpoint: result.url + '.json',
    requestType: _api.REQUEST_PUT,
    schema: _index.NONE,
    data: data
  });
}

function updateResultAttributes(result, attributes) {
  return {
    type: SEARCH_RESULT_UPDATE_ATTRIBUTES,
    result: result,
    attributes: attributes
  };
}

/***/ }),
/* 269 */,
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(87);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(61);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(287);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(139);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(59);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(137);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(138);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(139);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(140);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(288);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(87);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(31),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(31),
    isLength = __webpack_require__(124),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(143);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 297 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOCUMENT_SESSION_FAILURE = exports.DOCUMENT_SESSION_SUCCESS = exports.DOCUMENT_SESSION_REQUEST = undefined;
exports.fetchDocumentSessionIfNeeded = fetchDocumentSessionIfNeeded;

var _api = __webpack_require__(4);

var _index = __webpack_require__(3);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DOCUMENT_SESSION_REQUEST = exports.DOCUMENT_SESSION_REQUEST = 'DOCUMENT_SESSION_REQUEST';
var DOCUMENT_SESSION_SUCCESS = exports.DOCUMENT_SESSION_SUCCESS = 'DOCUMENT_SESSION_SUCCESS';
var DOCUMENT_SESSION_FAILURE = exports.DOCUMENT_SESSION_FAILURE = 'DOCUMENT_SESSION_FAILURE';

function fetchDocumentSession(company, document) {
  return _defineProperty({
    document: document
  }, _api.CALL_API, {
    types: [DOCUMENT_SESSION_REQUEST, DOCUMENT_SESSION_SUCCESS, DOCUMENT_SESSION_FAILURE],
    endpoint: 'companies/' + company.id + '/content_assets/' + document.id + '/box_view_sessions',
    requestType: _api.REQUEST_GET,
    schema: _index.NONE
  });
}

function shouldFetchDocumentSession(state, document) {
  return state[document.id] == null;
}

function fetchDocumentSessionIfNeeded(company, document) {
  return function (dispatch, getState) {
    if (shouldFetchDocumentSession(getState().documentSessions, document)) {
      return dispatch(fetchDocumentSession(company, document));
    } else {
      Promise.resolve();
    }
  };
}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(55);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(55);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(55);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(55);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(54);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 308 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(54),
    Map = __webpack_require__(91),
    MapCache = __webpack_require__(125);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(83),
    isMasked = __webpack_require__(311),
    isObject = __webpack_require__(9),
    toSource = __webpack_require__(144);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(312);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(10);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(315),
    ListCache = __webpack_require__(54),
    Map = __webpack_require__(91);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(316),
    hashDelete = __webpack_require__(317),
    hashGet = __webpack_require__(318),
    hashHas = __webpack_require__(319),
    hashSet = __webpack_require__(320);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(56);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(56);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(56);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(56);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(57);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(57);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(57);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(57);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(25),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(25),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(329),
    defineProperty = __webpack_require__(145),
    identity = __webpack_require__(95);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9),
    isPrototype = __webpack_require__(85),
    nativeKeysIn = __webpack_require__(331);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKSPACE_CREATE_FAILURE = exports.WORKSPACE_CREATE_SUCCESS = exports.WORKSPACE_CREATE_REQUEST = exports.WORKSPACES_FAILURE = exports.WORKSPACES_SUCCESS = exports.WORKSPACES_REQUEST = undefined;
exports.createWorkspace = createWorkspace;
exports.fetchWorkspacesIfNeeded = fetchWorkspacesIfNeeded;

var _api = __webpack_require__(4);

var _index = __webpack_require__(3);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WORKSPACES_REQUEST = exports.WORKSPACES_REQUEST = 'WORKSPACES_REQUEST';
var WORKSPACES_SUCCESS = exports.WORKSPACES_SUCCESS = 'WORKSPACES_SUCCESS';
var WORKSPACES_FAILURE = exports.WORKSPACES_FAILURE = 'WORKSPACES_FAILURE';
var WORKSPACE_CREATE_REQUEST = exports.WORKSPACE_CREATE_REQUEST = 'WORKSPACE_CREATE_REQUEST';
var WORKSPACE_CREATE_SUCCESS = exports.WORKSPACE_CREATE_SUCCESS = 'WORKSPACE_CREATE_SUCCESS';
var WORKSPACE_CREATE_FAILURE = exports.WORKSPACE_CREATE_FAILURE = 'WORKSPACE_CREATE_FAILURE';

function createWorkspace(company, attrs) {
  return _defineProperty({}, _api.CALL_API, {
    types: [WORKSPACE_CREATE_REQUEST, WORKSPACE_CREATE_SUCCESS, WORKSPACE_CREATE_FAILURE],
    endpoint: 'companies/' + company.id + '/workspaces.json',
    requestType: _api.REQUEST_POST,
    schema: _index.WORKSPACE,
    data: {
      workspace: attrs
    }
  });
}

function fetchWorkspaces(company) {
  return _defineProperty({}, _api.CALL_API, {
    types: [WORKSPACES_REQUEST, WORKSPACES_SUCCESS, WORKSPACES_FAILURE],
    endpoint: 'companies/' + company.id + '/workspaces.json',
    requestType: _api.REQUEST_GET,
    schema: _index.WORKSPACE_COLLECTION
  });
}

function shouldFetchWorkspaces(state) {
  var workspaces = state.workspaces;


  if (workspaces.isFetching) {
    return false;
  } else if (workspaces.items.length === 0) {
    return true;
  } else {
    return false;
  }
}

function fetchWorkspacesIfNeeded(company) {
  return function (dispatch, getState) {
    if (shouldFetchWorkspaces(getState())) {
      return dispatch(fetchWorkspaces(company));
    } else {
      Promise.resolve();
    }
  };
}

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}




/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ManagerReferenceNodeSetterContext; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Manager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    return function () {
      setReferenceNode(null);
    };
  }, [setReferenceNode]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
    value: setReferenceNode
  }, children));
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return safeInvoke; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__ = __webpack_require__(32);

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__["b" /* isHTMLElement */])(element) || !Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__["a" /* default */])(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__["b" /* isHTMLElement */])(element) || !Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__["a" /* default */])(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLayoutRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(146);
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMainAxisFromPlacement;
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapToStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getOffsetParent_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getDocumentElement_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getBasePlacement_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math_js__ = __webpack_require__(93);







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(x * dpr) / dpr || 0,
    y: Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];
  var sideY = __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */];
  var win = window;

  if (adaptive) {
    var offsetParent = Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getOffsetParent_js__["a" /* default */])(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__["a" /* default */])(popper)) {
      offsetParent = Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getDocumentElement_js__["a" /* default */])(popper);

      if (Object(__WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__["a" /* default */])(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] || (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */] || placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */]) && variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["e" /* end */]) {
      sideY = __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */];
      var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */] || (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] || placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */]) && variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["e" /* end */]) {
      sideX = __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];
      var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: Object(__WEBPACK_IMPORTED_MODULE_5__utils_getBasePlacement_js__["a" /* default */])(state.placement),
    variation: Object(__WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__["a" /* default */])(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getWindow_js__ = __webpack_require__(58);
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getWindow_js__["a" /* default */])(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScrollBarX;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScroll_js__ = __webpack_require__(342);



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element)).left + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScroll_js__["a" /* default */])(element).scrollLeft;
}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(58);

function getWindowScroll(node) {
  var win = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getComputedStyle_js__ = __webpack_require__(118);

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = Object(__WEBPACK_IMPORTED_MODULE_0__getComputedStyle_js__["a" /* default */])(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_computeOffsets_js__ = __webpack_require__(647);


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_computeOffsets_js__["a" /* default */])({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = popperGenerator;
/* unused harmony export createPopper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getCompositeRect_js__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_orderModifiers_js__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce_js__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_validateModifiers_js__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_uniqueBy_js__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getBasePlacement_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mergeByName_js__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_detectOverflow_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dom_utils_instanceOf_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums_js__ = __webpack_require__(26);
/* unused harmony reexport detectOverflow */














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: Object(__WEBPACK_IMPORTED_MODULE_12__dom_utils_instanceOf_js__["a" /* isElement */])(reference) ? Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(reference) : reference.contextElement ? Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(reference.contextElement) : [],
          popper: Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = Object(__WEBPACK_IMPORTED_MODULE_5__utils_orderModifiers_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_mergeByName_js__["a" /* default */])([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getCompositeRect_js__["a" /* default */])(reference, Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__["a" /* default */])(popper), state.options.strategy === 'fixed'),
          popper: Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__["a" /* default */])(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce_js__["a" /* default */])(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(404);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(784)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(156),
    arrayIncludes = __webpack_require__(266),
    arrayIncludesWith = __webpack_require__(353),
    cacheHas = __webpack_require__(157),
    createSet = __webpack_require__(405),
    setToArray = __webpack_require__(99);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(689);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Table = (_temp = _class = function (_Component) {
  _inherits(Table, _Component);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.renderHeader = _this.renderHeader.bind(_this);
    _this.renderRow = _this.renderRow.bind(_this);
    return _this;
  }

  _createClass(Table, [{
    key: 'renderHeader',
    value: function renderHeader(tableColumn) {
      if (!tableColumn) {
        return;
      }

      var _tableColumn$props = tableColumn.props,
          align = _tableColumn$props.align,
          dataKey = _tableColumn$props.dataKey,
          headerRenderer = _tableColumn$props.headerRenderer,
          label = _tableColumn$props.label,
          width = _tableColumn$props.width;

      var style = {
        textAlign: align
      };
      if (width) {
        style.width = width;
      }

      return _react2.default.createElement(
        'th',
        { key: dataKey, style: style },
        headerRenderer ? headerRenderer(label, dataKey) : I18n.t(label)
      );
    }
  }, {
    key: 'renderColumn',
    value: function renderColumn(rowData, tableColumn, index) {
      if (!tableColumn) {
        return;
      }

      var _tableColumn$props2 = tableColumn.props,
          align = _tableColumn$props2.align,
          dataGetter = _tableColumn$props2.dataGetter,
          cellRenderer = _tableColumn$props2.cellRenderer,
          dataKey = _tableColumn$props2.dataKey;

      var cellData = dataGetter ? dataGetter(rowData, dataKey, index) : rowData[dataKey];

      return _react2.default.createElement(
        'td',
        { key: dataKey, style: { textAlign: align } },
        cellRenderer ? cellRenderer(cellData, rowData, dataKey, index) : cellData
      );
    }
  }, {
    key: 'renderRow',
    value: function renderRow(rowData, index) {
      var _this2 = this;

      var children = this.props.children;


      return _react2.default.createElement(
        'tr',
        { key: index },
        _react.Children.map(children, function (column) {
          return _this2.renderColumn(rowData, column, index);
        })
      );
    }
  }, {
    key: 'renderRows',
    value: function renderRows() {
      var _this3 = this;

      var _props = this.props,
          data = _props.data,
          rowRenderer = _props.rowRenderer;


      return data.map(function (rowData, index) {
        return rowRenderer ? rowRenderer(rowData, _this3.renderRow(rowData, index), index) : _this3.renderRow(rowData, index);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          striped = _props2.striped,
          wrapInTbody = _props2.wrapInTbody;

      var classes = (0, _classnames2.default)('table', className, {
        'table-striped': striped
      });

      return _react2.default.createElement(
        'table',
        { className: classes },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react.Children.map(children, this.renderHeader)
          )
        ),
        wrapInTbody && _react2.default.createElement(
          'tbody',
          null,
          this.renderRows()
        ),
        !wrapInTbody && this.renderRows()
      );
    }
  }]);

  return Table;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  data: _propTypes2.default.array.isRequired,
  rowRenderer: _propTypes2.default.func,
  striped: _propTypes2.default.bool,
  wrapInTbody: _propTypes2.default.bool
}, _class.defaultProps = {
  striped: true,
  wrapInTbody: true
}, _temp);
exports.default = Table;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeLogo = exports.updateLogoFailed = exports.updateLogoSucceeded = exports.updateLogoRequest = exports.updateBranding = exports.fetchBranding = exports.UPDATE_LOGO_FAILED = exports.UPDATE_LOGO_SUCCEEDED = exports.UPDATE_LOGO_REQUEST = exports.UPDATE_BRANDING_FAILED = exports.UPDATE_BRANDING_SUCCEEDED = exports.UPDATE_BRANDING_REQUEST = exports.FETCH_BRANDING_FAILED = exports.FETCH_BRANDING_SUCCEEDED = exports.FETCH_BRANDING_REQUEST = undefined;

var _selectEntity = __webpack_require__(228);

var _selectEntity2 = _interopRequireDefault(_selectEntity);

var _alertActions = __webpack_require__(33);

var _api = __webpack_require__(4);

var _schemas = __webpack_require__(3);

var _AlertListItem = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FETCH_BRANDING_REQUEST = exports.FETCH_BRANDING_REQUEST = 'tru/brandings/FETCH_BRANDING_REQUEST';
var FETCH_BRANDING_SUCCEEDED = exports.FETCH_BRANDING_SUCCEEDED = 'tru/brandings/FETCH_BRANDING_SUCCEEDED';
var FETCH_BRANDING_FAILED = exports.FETCH_BRANDING_FAILED = 'tru/brandings/FETCH_BRANDING_FAILED';
var UPDATE_BRANDING_REQUEST = exports.UPDATE_BRANDING_REQUEST = 'tru/brandings/UPDATE_BRANDING_REQUEST';
var UPDATE_BRANDING_SUCCEEDED = exports.UPDATE_BRANDING_SUCCEEDED = 'tru/brandings/UPDATE_BRANDING_SUCCEEDED';
var UPDATE_BRANDING_FAILED = exports.UPDATE_BRANDING_FAILED = 'tru/brandings/UPDATE_BRANDING_FAILED';
var UPDATE_LOGO_REQUEST = exports.UPDATE_LOGO_REQUEST = 'tru/brandings/UPDATE_LOGO_REQUEST';
var UPDATE_LOGO_SUCCEEDED = exports.UPDATE_LOGO_SUCCEEDED = 'tru/brandings/UPDATE_LOGO_SUCCEEDED';
var UPDATE_LOGO_FAILED = exports.UPDATE_LOGO_FAILED = 'tru/brandings/UPDATE_LOGO_FAILED';

var fetchBranding = exports.fetchBranding = function fetchBranding(company, id) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_BRANDING_REQUEST, FETCH_BRANDING_SUCCEEDED, FETCH_BRANDING_FAILED],
    endpoint: 'companies/' + company.id + '/brandings/' + id + '.json',
    requestType: _api.REQUEST_GET,
    schema: _schemas.BRANDING
  });
};

var updateBrandingRequest = function updateBrandingRequest(company, id, attributes) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, UPDATE_BRANDING_SUCCEEDED, {
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Branding has been updated'
    }
  }), _defineProperty(_ref2, _api.CALL_API, {
    types: [UPDATE_BRANDING_REQUEST, UPDATE_BRANDING_SUCCEEDED, UPDATE_BRANDING_FAILED],
    endpoint: 'companies/' + company.id + '/brandings/' + id + '.json',
    requestType: _api.REQUEST_PUT,
    schema: _schemas.BRANDING,
    data: { branding: attributes }
  }), _ref2;
};

var handleUpdateError = function handleUpdateError(error, dispatch) {
  var message = void 0;
  switch (error.status) {
    case 400:
      message = 'Domain name has already been taken';
      break;
    default:
      message = 'There was a problem updating the branding. Please try again.';
  }

  dispatch((0, _alertActions.createAlert)({ type: _AlertListItem.ERROR, message: message }));
};

var shouldReloadDomain = function shouldReloadDomain(branding, currentUser) {
  return currentUser.branding.id === branding.id && currentUser.branding.domainName !== branding.domainName;
};
var handleUpdateSuccess = function handleUpdateSuccess(branding, currentUser) {
  if (shouldReloadDomain(branding, currentUser)) {
    window.location = 'https://' + branding.domainName + window.location.pathname + window.location.hash;
  }
};

var handlePostUpdate = function handlePostUpdate(action, dispatch, getState) {
  if (action.error) {
    handleUpdateError(action.error, dispatch);
  } else {
    var response = action.response;

    var branding = (0, _selectEntity2.default)(response.entities.brandings, response.result);

    handleUpdateSuccess(branding, getState().currentUser);
  }
};

var updateBranding = exports.updateBranding = function updateBranding(company, id, attributes) {
  return function (dispatch, getState) {
    return dispatch(updateBrandingRequest(company, id, attributes)).then(function (action) {
      return handlePostUpdate(action, dispatch, getState);
    });
  };
};

var replaceLogo = function replaceLogo(image) {
  $('.logo').find('img').attr('src', image.logo);
};

var updateLogoRequest = exports.updateLogoRequest = function updateLogoRequest() {
  return { type: UPDATE_LOGO_REQUEST };
};
var updateLogoSucceeded = exports.updateLogoSucceeded = function updateLogoSucceeded(branding) {
  replaceLogo(branding.image);

  return {
    type: UPDATE_LOGO_SUCCEEDED,
    entities: {
      brandings: _defineProperty({}, branding.id, { image: branding.image })
    }
  };
};

var updateLogoFailed = exports.updateLogoFailed = function updateLogoFailed() {
  return {
    type: UPDATE_LOGO_FAILED,
    alert: {
      type: _AlertListItem.ERROR,
      message: 'There was a problem updating the logo. Please try again.'
    }
  };
};

var removeLogoRequest = function removeLogoRequest(company, id) {
  return _defineProperty({}, _api.CALL_API, {
    types: [UPDATE_LOGO_REQUEST, UPDATE_LOGO_SUCCEEDED, UPDATE_LOGO_FAILED],
    endpoint: 'companies/' + company.id + '/brandings/' + id + '/remove_image.json',
    requestType: _api.REQUEST_PUT,
    schema: _schemas.BRANDING
  });
};

var removeLogo = exports.removeLogo = function removeLogo(company, id) {
  return function (dispatch) {
    return dispatch(removeLogoRequest(company, id)).then(function (action) {
      replaceLogo(action.response.entities.brandings[id].image);
    });
  };
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeEmailDomain = exports.createEmailDomain = exports.fetchEmailDomains = exports.REMOVE_EMAIL_DOMAIN_FAILED = exports.REMOVE_EMAIL_DOMAIN_SUCCEEDED = exports.REMOVE_EMAIL_DOMAIN_REQUEST = exports.FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED = exports.FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED = exports.FETCH_EMAIL_DOMAIN_USERS_COUNT_REQUEST = exports.FETCH_EMAIL_DOMAINS_FAILED = exports.FETCH_EMAIL_DOMAINS_SUCCEEDED = exports.FETCH_EMAIL_DOMAINS_REQUEST = exports.CREATE_EMAIL_DOMAIN_CANCELLED = exports.CREATE_EMAIL_DOMAIN_FAILED = exports.CREATE_EMAIL_DOMAIN_SUCCEEDED = exports.CREATE_EMAIL_DOMAIN_REQUEST = undefined;

var _api = __webpack_require__(4);

var _AlertListItem = __webpack_require__(7);

var _schemas = __webpack_require__(3);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CREATE_EMAIL_DOMAIN_REQUEST = exports.CREATE_EMAIL_DOMAIN_REQUEST = 'tru/emailDomains/CREATE_EMAIL_DOMAIN_REQUEST';
var CREATE_EMAIL_DOMAIN_SUCCEEDED = exports.CREATE_EMAIL_DOMAIN_SUCCEEDED = 'tru/emailDomains/CREATE_EMAIL_DOMAIN_SUCCEEDED';
var CREATE_EMAIL_DOMAIN_FAILED = exports.CREATE_EMAIL_DOMAIN_FAILED = 'tru/emailDomains/CREATE_EMAIL_DOMAIN_FAILED';
var CREATE_EMAIL_DOMAIN_CANCELLED = exports.CREATE_EMAIL_DOMAIN_CANCELLED = 'tru/emailDomains/CREATE_EMAIL_DOMAIN_CANCELLED';
var FETCH_EMAIL_DOMAINS_REQUEST = exports.FETCH_EMAIL_DOMAINS_REQUEST = 'tru/emailDomains/FETCH_EMAIL_DOMAINS_REQUEST';
var FETCH_EMAIL_DOMAINS_SUCCEEDED = exports.FETCH_EMAIL_DOMAINS_SUCCEEDED = 'tru/emailDomains/FETCH_EMAIL_DOMAINS_SUCCEEDED';
var FETCH_EMAIL_DOMAINS_FAILED = exports.FETCH_EMAIL_DOMAINS_FAILED = 'tru/emailDomains/FETCH_EMAIL_DOMAINS_FAILED';
var FETCH_EMAIL_DOMAIN_USERS_COUNT_REQUEST = exports.FETCH_EMAIL_DOMAIN_USERS_COUNT_REQUEST = 'tru/emailDomains/FETCH_EMAIL_DOMAIN_USERS_COUNT_REQUEST';
var FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED = exports.FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED = 'tru/emailDomains/FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED';
var FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED = exports.FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED = 'tru/emailDomains/FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED';
var REMOVE_EMAIL_DOMAIN_REQUEST = exports.REMOVE_EMAIL_DOMAIN_REQUEST = 'tru/emailDomains/REMOVE_EMAIL_DOMAIN_REQUEST';
var REMOVE_EMAIL_DOMAIN_SUCCEEDED = exports.REMOVE_EMAIL_DOMAIN_SUCCEEDED = 'tru/emailDomains/REMOVE_EMAIL_DOMAIN_SUCCEEDED';
var REMOVE_EMAIL_DOMAIN_FAILED = exports.REMOVE_EMAIL_DOMAIN_FAILED = 'tru/emailDomains/REMOVE_EMAIL_DOMAIN_FAILED';

var fetchEmailDomainUsersCount = function fetchEmailDomainUsersCount(company, domainName) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_EMAIL_DOMAIN_USERS_COUNT_REQUEST, FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED, FETCH_EMAIL_DOMAINS_FAILED],
    endpoint: 'companies/' + company.id + '/email_domains/user_email_domain_count.json',
    requestType: _api.REQUEST_GET,
    data: { domainName: domainName },
    schema: _schemas.NONE
  });
};

var fetchEmailDomains = exports.fetchEmailDomains = function fetchEmailDomains(company) {
  return _defineProperty({}, _api.CALL_API, {
    types: [FETCH_EMAIL_DOMAINS_REQUEST, FETCH_EMAIL_DOMAINS_SUCCEEDED, FETCH_EMAIL_DOMAINS_FAILED],
    endpoint: 'companies/' + company.id + '/email_domains.json',
    requestType: _api.REQUEST_GET,
    schema: _schemas.EMAIL_DOMAIN_COLLECTION
  });
};

var createEmailDomainRequest = function createEmailDomainRequest(company, emailDomain) {
  return _defineProperty({}, _api.CALL_API, {
    types: [CREATE_EMAIL_DOMAIN_REQUEST, CREATE_EMAIL_DOMAIN_SUCCEEDED, CREATE_EMAIL_DOMAIN_FAILED],
    endpoint: 'companies/' + company.id + '/email_domains.json',
    requestType: _api.REQUEST_POST,
    schema: _schemas.EMAIL_DOMAIN,
    data: { emailDomain: emailDomain }
  });
};

var confirmCreationOfEmailDomain = function confirmCreationOfEmailDomain(emailDomain, count) {
  var message = 'Adding ' + emailDomain.domainName + ' would add ' + (count + ' new users to your list of managed ') + ('users. Do you want to add ' + emailDomain.domainName + '?');

  return confirm(message);
};

var createEmailDomain = exports.createEmailDomain = function createEmailDomain(company, emailDomain) {
  return function (dispatch) {
    return new Promise(function (resolve, reject) {
      dispatch(fetchEmailDomainUsersCount(company, emailDomain.domainName)).then(function (_ref4) {
        var count = _ref4.response.count;

        if (confirmCreationOfEmailDomain(emailDomain, count)) {
          resolve(dispatch(createEmailDomainRequest(company, emailDomain)));
        } else {
          reject(dispatch({ type: CREATE_EMAIL_DOMAIN_CANCELLED }));
        }
      });
    });
  };
};

var removeEmailDomain = exports.removeEmailDomain = function removeEmailDomain(company, emailDomain) {
  var _ref5;

  return _ref5 = {}, _defineProperty(_ref5, REMOVE_EMAIL_DOMAIN_SUCCEEDED, { emailDomain: emailDomain }), _defineProperty(_ref5, REMOVE_EMAIL_DOMAIN_FAILED, {
    alert: {
      type: _AlertListItem.ERROR,
      message: 'Unable to delete ' + emailDomain.domainName + '. Please try again later.'
    }
  }), _defineProperty(_ref5, _api.CALL_API, {
    types: [REMOVE_EMAIL_DOMAIN_REQUEST, REMOVE_EMAIL_DOMAIN_SUCCEEDED, REMOVE_EMAIL_DOMAIN_FAILED],
    endpoint: 'companies/' + company.id + '/email_domains/' + emailDomain.id + '.json',
    requestType: _api.REQUEST_DELETE,
    schema: _schemas.NONE
  }), _ref5;
};

/***/ }),
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _escapeRegexString = __webpack_require__(986);

var _escapeRegexString2 = _interopRequireDefault(_escapeRegexString);

var _immutable = __webpack_require__(681);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KeywordHighlight = (_temp = _class = function (_PureComponent) {
  _inherits(KeywordHighlight, _PureComponent);

  function KeywordHighlight() {
    _classCallCheck(this, KeywordHighlight);

    return _possibleConstructorReturn(this, (KeywordHighlight.__proto__ || Object.getPrototypeOf(KeywordHighlight)).apply(this, arguments));
  }

  _createClass(KeywordHighlight, [{
    key: 'getHighlights',
    value: function getHighlights() {
      var _props = this.props,
          caseSensitive = _props.caseSensitive,
          match = _props.match,
          _props$text = _props.text,
          text = _props$text === undefined ? '' : _props$text;
      var tokens = this.props.tokens;


      if (!text || text.trim().length === 0) {
        return '';
      }

      if (match && match.length) {
        tokens = [match];
      }

      if (!tokens) {
        return text;
      }

      var matchOptions = 'g';
      if (!caseSensitive) {
        matchOptions += 'i';
      }

      return tokens.reduce(function (memo, token) {
        var substring = new RegExp('(\\b' + (0, _escapeRegexString2.default)(token) + '\\b)', matchOptions);
        return memo.replace(substring, '<span class="highlight">$1</span>');
      }, text);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var content = this.getHighlights().trim();

      if (!content) {
        return children || null;
      }

      return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.getHighlights() } });
    }
  }]);

  return KeywordHighlight;
}(_react.PureComponent), _class.propTypes = {
  caseSensitive: _propTypes2.default.bool,
  children: _propTypes2.default.element,
  match: _propTypes2.default.string,
  text: _propTypes2.default.string,
  tokens: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.instanceOf(_immutable.List)])
}, _class.defaultProps = {
  match: '',
  caseSensitive: false
}, _temp);
exports.default = KeywordHighlight;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _alert = __webpack_require__(407);

var _alert2 = _interopRequireDefault(_alert);

var _api = __webpack_require__(4);

var _api2 = _interopRequireDefault(_api);

var _reduxLogger = __webpack_require__(408);

var _history = __webpack_require__(364);

var _history2 = _interopRequireDefault(_history);

var _location = __webpack_require__(409);

var _location2 = _interopRequireDefault(_location);

var _index = __webpack_require__(410);

var _index2 = _interopRequireDefault(_index);

var _reduxThunk = __webpack_require__(611);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRouterRedux = __webpack_require__(117);

var _redux = __webpack_require__(20);

var _reduxDevtoolsExtension = __webpack_require__(612);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var middlewares = [_reduxThunk2.default, _api2.default, _alert2.default, _location2.default, (0, _reactRouterRedux.routerMiddleware)(_history2.default)];

if (false) {
  middlewares = [].concat(_toConsumableArray(middlewares), [(0, _reduxLogger.createLogger)({
    collapsed: true,
    duration: true,
    timestamp: false
  })]);
}

function configureStore(initialState) {
  return (0, _redux.createStore)(_index2.default, initialState, (0, _reduxDevtoolsExtension.composeWithDevTools)(_redux.applyMiddleware.apply(undefined, _toConsumableArray(middlewares))));
}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRouter = __webpack_require__(406);

exports.default = _reactRouter.hashHistory;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchArchivedStudies = exports.FETCH_ARCHIVED_STUDIES_FAILED = exports.FETCH_ARCHIVED_STUDIES_SUCCEEDED = exports.FETCH_ARCHIVED_STUDIES_REQUEST = undefined;

var _api = __webpack_require__(4);

var _schemas = __webpack_require__(3);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FETCH_ARCHIVED_STUDIES_REQUEST = exports.FETCH_ARCHIVED_STUDIES_REQUEST = 'tru/archivedStudies/FETCH_ARCHIVED_STUDIES_REQUEST';
var FETCH_ARCHIVED_STUDIES_SUCCEEDED = exports.FETCH_ARCHIVED_STUDIES_SUCCEEDED = 'tru/archivedStudies/FETCH_ARCHIVED_STUDIES_SUCCEEDED';
var FETCH_ARCHIVED_STUDIES_FAILED = exports.FETCH_ARCHIVED_STUDIES_FAILED = 'tru/archivedStudies/FETCH_ARCHIVED_STUDIES_FAILED';

var fetchArchivedStudies = exports.fetchArchivedStudies = function fetchArchivedStudies(_ref) {
  var _ref2;

  var _ref$page = _ref.page,
      page = _ref$page === undefined ? 1 : _ref$page,
      _ref$perPage = _ref.perPage,
      perPage = _ref$perPage === undefined ? 30 : _ref$perPage,
      _ref$sort = _ref.sort,
      sort = _ref$sort === undefined ? 'date' : _ref$sort,
      _ref$order = _ref.order,
      order = _ref$order === undefined ? 'desc' : _ref$order,
      query = _ref.query;
  return _ref2 = {}, _defineProperty(_ref2, FETCH_ARCHIVED_STUDIES_REQUEST, { page: page, query: query }), _defineProperty(_ref2, _api.CALL_API, {
    types: [FETCH_ARCHIVED_STUDIES_REQUEST, FETCH_ARCHIVED_STUDIES_SUCCEEDED, FETCH_ARCHIVED_STUDIES_FAILED],
    endpoint: 'archived_studies.json',
    requestType: _api.REQUEST_GET,
    data: { page: page, perPage: perPage, order: order, sort: sort, query: query },
    dataGetter: function dataGetter(data) {
      return data.archivedStudies;
    },
    schema: _schemas.ARCHIVED_STUDY_COLLECTION
  }), _ref2;
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUnarchiveStudyRequest = exports.CREATE_UNARCHIVE_STUDY_REQUEST_FAILED = exports.CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED = exports.CREATE_UNARCHIVE_STUDY_REQUEST_REQUEST = undefined;

var _api = __webpack_require__(4);

var _schemas = __webpack_require__(3);

var _AlertListItem = __webpack_require__(7);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CREATE_UNARCHIVE_STUDY_REQUEST_REQUEST = exports.CREATE_UNARCHIVE_STUDY_REQUEST_REQUEST = 'tru/unarchiveStudyRequests/CREATE_UNARCHIVE_STUDY_REQUEST_REQUEST';
var CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED = exports.CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED = 'tru/unarchivedStudyRequests/CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED';
var CREATE_UNARCHIVE_STUDY_REQUEST_FAILED = exports.CREATE_UNARCHIVE_STUDY_REQUEST_FAILED = 'tru/unarchivedStudyRequests/CREATE_UNARCHIVE_STUDY_REQUEST_FAILED';

var createUnarchiveStudyRequest = exports.createUnarchiveStudyRequest = function createUnarchiveStudyRequest(archivedStudyId) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, CREATE_UNARCHIVE_STUDY_REQUEST_FAILED, function (error) {
    return {
      alert: {
        type: _AlertListItem.ERROR,
        message: error.error[0],
        scope: 'createUnarchiveStudyRequestError'
      }
    };
  }), _defineProperty(_ref, CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED, {
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Study scheduled for unarchiving',
      scope: 'createUnarchiveStudyRequestSuccess'
    }
  }), _defineProperty(_ref, _api.CALL_API, {
    types: [CREATE_UNARCHIVE_STUDY_REQUEST_REQUEST, CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED, CREATE_UNARCHIVE_STUDY_REQUEST_FAILED],
    endpoint: 'unarchive_study_requests.json',
    requestType: _api.REQUEST_POST,
    data: { archivedStudyId: archivedStudyId },
    dataGetter: function dataGetter(data) {
      return data.unarchiveStudyRequest;
    },
    schema: _schemas.UNARCHIVE_STUDY_REQUEST
  }), _ref;
};

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BOX_TRANSCRIPT_PRODUCTS_FAILURE = exports.BOX_TRANSCRIPT_PRODUCTS_SUCCESS = exports.BOX_TRANSCRIPT_PRODUCTS_REQUEST = exports.GENERATE_WORK_FOLDER_FAILURE = exports.GENERATE_WORK_FOLDER_SUCCESS = exports.GENERATE_WORK_FOLDER_REQUEST = undefined;
exports.fetchBoxTranscriptProducts = fetchBoxTranscriptProducts;
exports.generateWorkFolder = generateWorkFolder;

var _api = __webpack_require__(4);

var _index = __webpack_require__(3);

var _AlertListItem = __webpack_require__(7);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GENERATE_WORK_FOLDER_REQUEST = exports.GENERATE_WORK_FOLDER_REQUEST = 'GENERATE_WORK_FOLDER_REQUEST';
var GENERATE_WORK_FOLDER_SUCCESS = exports.GENERATE_WORK_FOLDER_SUCCESS = 'GENERATE_WORK_FOLDER_SUCCESS';
var GENERATE_WORK_FOLDER_FAILURE = exports.GENERATE_WORK_FOLDER_FAILURE = 'GENERATE_WORK_FOLDER_FAILURE';
var BOX_TRANSCRIPT_PRODUCTS_REQUEST = exports.BOX_TRANSCRIPT_PRODUCTS_REQUEST = 'BOX_TRANSCRIPT_PRODUCTS_REQUEST';
var BOX_TRANSCRIPT_PRODUCTS_SUCCESS = exports.BOX_TRANSCRIPT_PRODUCTS_SUCCESS = 'BOX_TRANSCRIPT_PRODUCTS_SUCCESS';
var BOX_TRANSCRIPT_PRODUCTS_FAILURE = exports.BOX_TRANSCRIPT_PRODUCTS_FAILURE = 'BOX_TRANSCRIPT_PRODUCTS_FAILURE';

function fetchBoxTranscriptProducts() {
  return _defineProperty({}, _api.CALL_API, {
    types: [BOX_TRANSCRIPT_PRODUCTS_REQUEST, BOX_TRANSCRIPT_PRODUCTS_SUCCESS, BOX_TRANSCRIPT_PRODUCTS_FAILURE],
    endpoint: 'box_transcript_products.json',
    requestType: _api.REQUEST_GET,
    schema: _index.BOX_TRANSCRIPT_PRODUCT_COLLECTION
  });
}

function generateWorkFolder(boxTranscriptProduct) {
  var _ref2;

  return _ref2 = {
    idsGenerating: boxTranscriptProduct.id
  }, _defineProperty(_ref2, GENERATE_WORK_FOLDER_FAILURE, {
    alert: {
      type: _AlertListItem.ERROR,
      message: 'Failed Generating Box Folder'
    }
  }), _defineProperty(_ref2, GENERATE_WORK_FOLDER_SUCCESS, {
    entities: {
      boxTranscriptProducts: _defineProperty({}, boxTranscriptProduct.id, {
        name: boxTranscriptProduct.name,
        fileCount: boxTranscriptProduct.fileCount
      })
    },
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Generating Box Folder for ' + boxTranscriptProduct.name
    }
  }), _defineProperty(_ref2, _api.CALL_API, {
    types: [GENERATE_WORK_FOLDER_REQUEST, GENERATE_WORK_FOLDER_SUCCESS, GENERATE_WORK_FOLDER_FAILURE],
    endpoint: 'box_transcript_products/' + boxTranscriptProduct.id + '/generate_work_folder',
    requestType: _api.REQUEST_POST,
    schema: _index.BOX_TRANSCRIPT_PRODUCT
  }), _ref2;
}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToWorkspace = exports.downloadClip = exports.fetchClip = exports.FETCH_CLIP_FAILURE = exports.FETCH_CLIP_SUCCESS = exports.FETCH_CLIP_REQUEST = exports.DOWNLOAD_CLIP_FAILURE = exports.DOWNLOAD_CLIP_SUCCESS = exports.DOWNLOAD_CLIP_REQUEST = exports.ADD_CLIP_TO_WORKSPACE_FAILURE = exports.ADD_CLIP_TO_WORKSPACE_SUCCESS = exports.ADD_CLIP_TO_WORKSPACE_REQUEST = undefined;

var _i18n = __webpack_require__(90);

var _i18n2 = _interopRequireDefault(_i18n);

var _uniq = __webpack_require__(23);

var _uniq2 = _interopRequireDefault(_uniq);

var _api = __webpack_require__(4);

var _AlertListItem = __webpack_require__(7);

var _api2 = __webpack_require__(119);

var _urlHelper = __webpack_require__(29);

var _humps = __webpack_require__(22);

var _alertActions = __webpack_require__(33);

var _normalizr = __webpack_require__(62);

var _schemas = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ADD_CLIP_TO_WORKSPACE_REQUEST = exports.ADD_CLIP_TO_WORKSPACE_REQUEST = 'tru/ADD_CLIP_TO_WORKSPACE_REQUEST';
var ADD_CLIP_TO_WORKSPACE_SUCCESS = exports.ADD_CLIP_TO_WORKSPACE_SUCCESS = 'tru/ADD_CLIP_TO_WORKSPACE_SUCCESS';
var ADD_CLIP_TO_WORKSPACE_FAILURE = exports.ADD_CLIP_TO_WORKSPACE_FAILURE = 'tru/ADD_CLIP_TO_WORKSPACE_FAILURE';
var DOWNLOAD_CLIP_REQUEST = exports.DOWNLOAD_CLIP_REQUEST = 'tru/DOWNLOAD_CLIP_REQUEST';
var DOWNLOAD_CLIP_SUCCESS = exports.DOWNLOAD_CLIP_SUCCESS = 'tru/DOWNLOAD_CLIP_SUCCESS';
var DOWNLOAD_CLIP_FAILURE = exports.DOWNLOAD_CLIP_FAILURE = 'tru/DOWNLOAD_CLIP_FAILURE';
var FETCH_CLIP_REQUEST = exports.FETCH_CLIP_REQUEST = 'tru/FETCH_CLIP_REQUEST';
var FETCH_CLIP_SUCCESS = exports.FETCH_CLIP_SUCCESS = 'tru/FETCH_CLIP_SUCCESS';
var FETCH_CLIP_FAILURE = exports.FETCH_CLIP_FAILURE = 'tru/FETCH_CLIP_FAILURE';

var requestClip = function requestClip(id) {
  return {
    type: FETCH_CLIP_REQUEST,
    id: id
  };
};

var receiveClip = function receiveClip(data, _ref) {
  var entities = _ref.entities;
  return {
    type: FETCH_CLIP_SUCCESS,
    data: data,
    entities: entities
  };
};

var receiveClipFailed = function receiveClipFailed(errors) {
  return {
    type: FETCH_CLIP_FAILURE,
    errors: errors
  };
};

var fetchClip = exports.fetchClip = function fetchClip(id) {
  return function (dispatch) {
    dispatch(requestClip(id));

    return _api2.clips.get(id).then(function (_ref2) {
      var data = _ref2.data;
      return dispatch(receiveClip((0, _humps.camelizeKeys)(data), (0, _normalizr.normalize)(data, _schemas.CLIP)));
    }, function (error) {
      return dispatch(receiveClipFailed(error));
    });
  };
};

var requestDownloadClip = function requestDownloadClip() {
  return { type: DOWNLOAD_CLIP_REQUEST };
};
var downloadClipSucceeded = function downloadClipSucceeded() {
  return { type: DOWNLOAD_CLIP_SUCCESS };
};
var downloadClipFailed = function downloadClipFailed() {
  return { type: DOWNLOAD_CLIP_FAILURE };
};

var downloadClip = exports.downloadClip = function downloadClip(id) {
  return function (dispatch) {
    dispatch(requestDownloadClip());

    return _api2.clips.downloadVideoClip(id).then(function () {
      dispatch(downloadClipSucceeded());
      dispatch((0, _alertActions.createAlert)({
        type: _AlertListItem.SUCCESS,
        message:
        // eslint-disable-next-line
        _i18n2.default.t('Successfully added your download to the queue. You can download it by navigating to the ') + '<a href="/r/downloads">' + _i18n2.default.t('downloads page') + '</a>',
        htmlSafe: true
      }));
    }, function () {
      dispatch(downloadClipFailed());
      dispatch((0, _alertActions.createAlert)({
        type: _AlertListItem.ERROR,
        message: 'There was a problem adding your download to the queue. ' + 'Please try again'
      }));
    });
  };
};

var addToWorkspace = exports.addToWorkspace = function addToWorkspace(company, clip, workspace) {
  var _ref3;

  var workspaceURL = (0, _urlHelper.buildBaseURL)('workspaces/' + workspace.id);

  return _ref3 = {}, _defineProperty(_ref3, ADD_CLIP_TO_WORKSPACE_SUCCESS, {
    entities: {
      clips: _defineProperty({}, clip.id, {
        workspaces: (0, _uniq2.default)([].concat(_toConsumableArray(clip.workspaces.map(function (workspace) {
          return workspace.id;
        })), [workspace.id]))
      })
    },
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Added to ' + workspace.name + '.           <a href="' + workspaceURL + '">View it now!</a>',
      htmlSafe: true
    }
  }), _defineProperty(_ref3, _api.CALL_API, {
    types: [ADD_CLIP_TO_WORKSPACE_REQUEST, ADD_CLIP_TO_WORKSPACE_SUCCESS, ADD_CLIP_TO_WORKSPACE_FAILURE],
    // eslint-disable-next-line max-len
    endpoint: 'companies/' + company.id + '/workspaces/' + workspace.id + '/clips/' + clip.id + '.json',
    requestType: _api.REQUEST_POST,
    schema: _schemas.NONE
  }), _ref3;
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToWorkspace = exports.clearResponse = exports.toggleObserversViewPii = exports.fetchResponse = exports.ADD_RESPONSE_TO_WORKSPACE_FAILURE = exports.ADD_RESPONSE_TO_WORKSPACE_SUCCESS = exports.ADD_RESPONSE_TO_WORKSPACE_REQUEST = exports.TOGGLE_OBSERVERS_VIEW_PII = exports.RESPONSE_FAILURE = exports.RESPONSE_SUCCESS = exports.RESPONSE_REQUEST = exports.CLEAR_RESPONSE = undefined;

var _uniq = __webpack_require__(23);

var _uniq2 = _interopRequireDefault(_uniq);

var _api = __webpack_require__(4);

var _api2 = __webpack_require__(119);

var _AlertListItem = __webpack_require__(7);

var _urlHelper = __webpack_require__(29);

var _humps = __webpack_require__(22);

var _alertActions = __webpack_require__(33);

var _normalizr = __webpack_require__(62);

var _schemas = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var CLEAR_RESPONSE = exports.CLEAR_RESPONSE = 'tru/CLEAR_RESPONSE';
var RESPONSE_REQUEST = exports.RESPONSE_REQUEST = 'tru/RESPONSE_REQUEST';
var RESPONSE_SUCCESS = exports.RESPONSE_SUCCESS = 'tru/RESPONSE_SUCCESS';
var RESPONSE_FAILURE = exports.RESPONSE_FAILURE = 'tru/RESPONSE_FAILURE';
var TOGGLE_OBSERVERS_VIEW_PII = exports.TOGGLE_OBSERVERS_VIEW_PII = 'tru/TOGGLE_OBSERVERS_VIEW_PII';
var ADD_RESPONSE_TO_WORKSPACE_REQUEST = exports.ADD_RESPONSE_TO_WORKSPACE_REQUEST = 'tru/ADD_RESPONSE_TO_WORKSPACE_REQUEST';
var ADD_RESPONSE_TO_WORKSPACE_SUCCESS = exports.ADD_RESPONSE_TO_WORKSPACE_SUCCESS = 'tru/ADD_RESPONSE_TO_WORKSPACE_SUCCESS';
var ADD_RESPONSE_TO_WORKSPACE_FAILURE = exports.ADD_RESPONSE_TO_WORKSPACE_FAILURE = 'tru/ADD_RESPONSE_TO_WORKSPACE_FAILURE';

var requestResponse = function requestResponse(id) {
  return {
    type: RESPONSE_REQUEST,
    id: id
  };
};

var receiveResponse = function receiveResponse(data, _ref) {
  var entities = _ref.entities;
  return {
    type: RESPONSE_SUCCESS,
    data: data,
    entities: entities
  };
};

var receiveResponseFailed = function receiveResponseFailed(errors) {
  return {
    type: RESPONSE_FAILURE,
    errors: errors
  };
};

var fetchResponse = exports.fetchResponse = function fetchResponse(id) {
  return function (dispatch) {
    dispatch(requestResponse(id));

    return _api2.responses.get(id).then(function (_ref2) {
      var data = _ref2.data;
      return dispatch(receiveResponse((0, _humps.camelizeKeys)(data), (0, _normalizr.normalize)(data, _schemas.RESPONSE)));
    }, function (error) {
      return dispatch(receiveResponseFailed(error));
    });
  };
};

var toggleObserversViewPii = exports.toggleObserversViewPii = function toggleObserversViewPii(id, value) {
  return function (dispatch) {
    return _api2.responses.toggleObserversViewPiiFlag(id, value).then(function () {
      var message = void 0;

      if (value) {
        message = "Enabled. Observers will be able to view this response's video";
      } else {
        message = 'Disabled. Observers in this project will only receive audio for ' + 'this response';
      }

      dispatch({ type: TOGGLE_OBSERVERS_VIEW_PII, id: id, value: value });
      dispatch((0, _alertActions.createAlert)({ type: _AlertListItem.SUCCESS, message: message }));
    }).catch(function () {
      dispatch((0, _alertActions.createAlert)({
        type: _AlertListItem.ERROR,
        message: 'There was a problem updating the response'
      }));
    });
  };
};

var clearResponse = exports.clearResponse = function clearResponse(id) {
  return {
    type: CLEAR_RESPONSE,
    id: id
  };
};

var addToWorkspace = exports.addToWorkspace = function addToWorkspace(company, response, workspace) {
  var _ref3;

  var workspaceURL = (0, _urlHelper.buildBaseURL)('workspaces/' + workspace.id);

  return _ref3 = {}, _defineProperty(_ref3, ADD_RESPONSE_TO_WORKSPACE_SUCCESS, {
    entities: {
      responses: _defineProperty({}, response.id, {
        workspaces: (0, _uniq2.default)([].concat(_toConsumableArray(response.workspaces.map(function (workspace) {
          return workspace.id;
        })), [workspace.id]))
      })
    },
    alert: {
      type: _AlertListItem.SUCCESS,
      message: 'Added to ' + workspace.name + '.' + ('<a href="' + workspaceURL + '">View it now!</a>'),
      htmlSafe: true
    }
  }), _defineProperty(_ref3, _api.CALL_API, {
    types: [ADD_RESPONSE_TO_WORKSPACE_REQUEST, ADD_RESPONSE_TO_WORKSPACE_SUCCESS, ADD_RESPONSE_TO_WORKSPACE_FAILURE],
    // eslint-disable-next-line max-len
    endpoint: 'companies/' + company.id + '/workspaces/' + workspace.id + '/responses/' + response.id + '.json',
    requestType: _api.REQUEST_POST,
    schema: _schemas.NONE
  }), _ref3;
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retryTranscriptRequest = exports.retryFailed = exports.retrySucceeded = exports.retryRequest = exports.fetchTranscriptRequests = exports.changeHideCompleted = exports.changeVendor = exports.changeFilter = exports.changeSort = exports.changePage = exports.CHANGE_VENDOR = exports.CHANGE_HIDE_COMPLETED = exports.CHANGE_SORT = exports.CHANGE_PAGE = exports.CHANGE_ORDER = exports.CHANGE_FILTER = exports.RETRY_TRANSCRIPT_REQUEST_FAILED = exports.RETRY_TRANSCRIPT_REQUEST_SUCCEEDED = exports.RETRY_TRANSCRIPT_REQUEST_REQUEST = exports.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED = exports.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED = exports.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST = undefined;

var _axios = __webpack_require__(63);

var _axios2 = _interopRequireDefault(_axios);

var _humps = __webpack_require__(22);

var _transcriptionTranscriptRequests = __webpack_require__(167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST = exports.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST = 'transcrition/FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST';
var FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED = exports.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED = 'transcrition/FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED';
var FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED = exports.FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED = 'transcrition/FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED';
var RETRY_TRANSCRIPT_REQUEST_REQUEST = exports.RETRY_TRANSCRIPT_REQUEST_REQUEST = 'transcription/RETRY_TRANSCRIPT_REQUEST_REQUEST';
var RETRY_TRANSCRIPT_REQUEST_SUCCEEDED = exports.RETRY_TRANSCRIPT_REQUEST_SUCCEEDED = 'transcription/RETRY_TRANSCRIPT_REQUEST_SUCCEEDED';
var RETRY_TRANSCRIPT_REQUEST_FAILED = exports.RETRY_TRANSCRIPT_REQUEST_FAILED = 'transcription/RETRY_TRANSCRIPT_REQUEST_FAILED';
var CHANGE_FILTER = exports.CHANGE_FILTER = 'transcription/CHANGE_FILTER';
var CHANGE_ORDER = exports.CHANGE_ORDER = 'transcription/CHANGE_ORDER';
var CHANGE_PAGE = exports.CHANGE_PAGE = 'transcription/CHANGE_PAGE';
var CHANGE_SORT = exports.CHANGE_SORT = 'transcription/CHANGE_SORT';
var CHANGE_HIDE_COMPLETED = exports.CHANGE_HIDE_COMPLETED = 'transcription/CHANGE_HIDE_COMPLETED';
var CHANGE_VENDOR = exports.CHANGE_VENDOR = 'transcription/CHANGE_VENDOR';

var fetchRequest = function fetchRequest() {
  return {
    type: FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST
  };
};

var fetchSucceeded = function fetchSucceeded(data) {
  return {
    type: FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED,
    data: data
  };
};

var fetchError = function fetchError(error) {
  return {
    type: FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED,
    error: error
  };
};

var changePage = exports.changePage = function changePage(page) {
  return function (dispatch) {
    dispatch({ type: CHANGE_PAGE, page: page });

    return dispatch(fetchTranscriptRequests());
  };
};

var changeSort = exports.changeSort = function changeSort(sort, order) {
  return function (dispatch) {
    dispatch({ type: CHANGE_SORT, sort: sort, order: order });

    return dispatch(fetchTranscriptRequests());
  };
};

var changeFilter = exports.changeFilter = function changeFilter(filter) {
  return function (dispatch) {
    dispatch({ type: CHANGE_FILTER, filter: filter });

    return dispatch(fetchTranscriptRequests());
  };
};

var changeVendor = exports.changeVendor = function changeVendor(vendor) {
  return function (dispatch) {
    dispatch({ type: CHANGE_VENDOR, vendor: vendor });

    return dispatch(fetchTranscriptRequests());
  };
};

var changeHideCompleted = exports.changeHideCompleted = function changeHideCompleted(hideCompleted) {
  return function (dispatch) {
    dispatch({ type: CHANGE_HIDE_COMPLETED, hideCompleted: hideCompleted });

    return dispatch(fetchTranscriptRequests());
  };
};

var fetchTranscriptRequests = exports.fetchTranscriptRequests = function fetchTranscriptRequests() {
  return function (dispatch, getState) {
    dispatch(fetchRequest());

    var state = getState().transcriptionTranscriptRequests;
    var hideCompleted = (0, _transcriptionTranscriptRequests.selectHideCompleted)(state);
    var sort = (0, _humps.decamelize)((0, _transcriptionTranscriptRequests.selectSort)(state));

    if ((0, _transcriptionTranscriptRequests.selectOrder)(state) === 'desc') {
      sort = '-' + sort;
    }

    var params = {
      'page[number]': (0, _transcriptionTranscriptRequests.selectPage)(state),
      'filter[name_or_video_url]': (0, _transcriptionTranscriptRequests.selectFilter)(state),
      'filter[vendor_id]': (0, _transcriptionTranscriptRequests.selectVendor)(state),
      sort: sort
    };

    if (hideCompleted) {
      params = Object.assign({}, params, { 'filter[incomplete]': 'true' });
    }

    return _axios2.default.get('/r/api/transcript_requests', {
      params: params,
      headers: {
        Accept: 'application/vnd.api+json',
        Authorization: 'Bearer ' + getState().transcriptionKey
      }
    }).then(function (_ref) {
      var data = _ref.data;
      return dispatch(fetchSucceeded((0, _humps.camelizeKeys)(data)));
    }, function (error) {
      return dispatch(fetchError(error));
    });
  };
};

var retryRequest = exports.retryRequest = function retryRequest(transcriptRequest) {
  return {
    type: RETRY_TRANSCRIPT_REQUEST_REQUEST,
    transcriptRequest: transcriptRequest
  };
};

var retrySucceeded = exports.retrySucceeded = function retrySucceeded(id, data) {
  return {
    type: RETRY_TRANSCRIPT_REQUEST_SUCCEEDED,
    alert: {
      type: 'SUCCESS',
      message: 'Transcript request ' + id + ' requeued for transcription'
    },
    id: id,
    data: data
  };
};

var retryFailed = exports.retryFailed = function retryFailed(id, error) {
  return {
    type: RETRY_TRANSCRIPT_REQUEST_FAILED,
    alert: {
      type: 'ERROR',
      message: 'Could not retry transcript request ' + id + '.'
    },
    id: id,
    error: error
  };
};

var retryTranscriptRequest = exports.retryTranscriptRequest = function retryTranscriptRequest(transcriptRequest) {
  return function (dispatch, getState) {
    var id = transcriptRequest.id;

    dispatch(retryRequest(transcriptRequest));

    return _axios2.default.patch('/r/api/transcript_requests/' + id + '/retry', {}, {
      headers: {
        Accept: 'application/vnd.api+json',
        Authorization: 'Bearer ' + getState().transcriptionKey,
        'Content-Type': 'application/vnd.api+json'
      }
    }).then(function (_ref2) {
      var data = _ref2.data;
      return dispatch(retrySucceeded(id, (0, _humps.camelizeKeys)(data)));
    }, function (error) {
      return dispatch(retryFailed(id, error));
    });
  };
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchStudiesWithTranscriptsOrdered = exports.changeFilter = exports.changeSort = exports.changePage = exports.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT = exports.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE = exports.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_ORDER = exports.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER = exports.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED = exports.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED = exports.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST = undefined;

var _axios = __webpack_require__(63);

var _axios2 = _interopRequireDefault(_axios);

var _humps = __webpack_require__(22);

var _studiesWithTranscriptsOrdered = __webpack_require__(168);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST = exports.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST = 'transcription/FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST';
var FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED = exports.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED = 'transcription/FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED';
var FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED = exports.FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED = 'transcription/FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED';

var CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER = exports.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER = 'transcription/CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER';
var CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_ORDER = exports.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_ORDER = 'transcription/CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_ORDER';
var CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE = exports.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE = 'transcription/CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE';
var CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT = exports.CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT = 'transcription/CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT';

var fetchRequest = function fetchRequest() {
  return {
    type: FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_REQUEST
  };
};

var fetchSucceeded = function fetchSucceeded(data) {
  return {
    type: FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_SUCCEEDED,
    data: data
  };
};

var fetchError = function fetchError(error) {
  return {
    type: FETCH_STUDIES_WITH_TRANSCRIPTS_ORDERED_FAILED,
    error: error
  };
};

var changePage = exports.changePage = function changePage(page) {
  return function (dispatch) {
    dispatch({ type: CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_PAGE, page: page });

    return dispatch(fetchStudiesWithTranscriptsOrdered());
  };
};

var changeSort = exports.changeSort = function changeSort(sort, order) {
  return function (dispatch) {
    dispatch({ type: CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_SORT, sort: sort, order: order });

    return dispatch(fetchStudiesWithTranscriptsOrdered());
  };
};

var changeFilter = exports.changeFilter = function changeFilter(filter) {
  return function (dispatch) {
    dispatch({ type: CHANGE_STUDIES_WITH_TRANSCRIPTS_ORDERED_FILTER, filter: filter });

    return dispatch(fetchStudiesWithTranscriptsOrdered());
  };
};

var fetchStudiesWithTranscriptsOrdered = exports.fetchStudiesWithTranscriptsOrdered = function fetchStudiesWithTranscriptsOrdered() {
  return function (dispatch, getState) {
    dispatch(fetchRequest());

    var state = getState().studiesWithTranscriptsOrdered;
    var sort = (0, _humps.decamelize)((0, _studiesWithTranscriptsOrdered.selectSort)(state));

    if ((0, _studiesWithTranscriptsOrdered.selectOrder)(state) === 'desc') {
      sort = '-' + sort;
    }

    return _axios2.default.get('/r/api/studies', {
      params: {
        include: 'project',
        'page[number]': (0, _studiesWithTranscriptsOrdered.selectPage)(state),
        'filter[with_transcription]': true,
        'filter[without_videos]': true,
        'filter[study_or_project_name]': (0, _studiesWithTranscriptsOrdered.selectFilter)(state),
        sort: sort
      },
      headers: {
        Accept: 'application/vnd.api+json',
        Authorization: 'Bearer ' + getAccessToken()
      }
    }).then(function (_ref) {
      var data = _ref.data;
      return dispatch(fetchSucceeded((0, _humps.camelizeKeys)(data)));
    }, function (error) {
      return dispatch(fetchError(error));
    });
  };
};

var getCookieValue = function getCookieValue(key) {
  return document.cookie.replace(new RegExp('(?:(?:^|.*;\\s*)' + key + '\\s*=\\s*([^;]*).*$)|^.*$'), '$1');
};

var getAccessToken = function getAccessToken() {
  return getCookieValue('fv_at');
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValue = undefined;

var _taniSessionsActions = __webpack_require__(373);

var initialValue = exports.initialValue = {
  allTaniSessions: {},
  allTaniProjects: {}
};

var taniState = function taniState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case _taniSessionsActions.TANI_SESSIONS:
      var newSession = Object.assign({}, state.allTaniSessions, payload);
      return Object.assign({}, state, { allTaniSessions: newSession });
    case _taniSessionsActions.TANI_PROJECTS:
      var projectSession = Object.assign({}, state.allTaniProjects, payload);
      return Object.assign({}, state, { allTaniProjects: projectSession });
    default:
      return state;
  }
};

exports.default = taniState;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TANI_SESSIONS = exports.TANI_SESSIONS = 'tru/TANI_SESSIONS';
var TANI_PROJECTS = exports.TANI_PROJECTS = 'tru/TANI_PROJECT';

var setTaniSessionsActions = exports.setTaniSessionsActions = function setTaniSessionsActions(payload) {
  return {
    type: TANI_SESSIONS,
    payload: payload
  };
};

var setTaniProjectsActions = exports.setTaniProjectsActions = function setTaniProjectsActions(payload) {
  return {
    type: TANI_PROJECTS,
    payload: payload
  };
};

/***/ }),
/* 374 */,
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _reactRedux = __webpack_require__(6);

var _alertActions = __webpack_require__(33);

var _AlertList = __webpack_require__(626);

var _AlertList2 = _interopRequireDefault(_AlertList);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertListContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, { clearAlerts: _alertActions.clearAlerts, removeAlert: _alertActions.removeAlert }), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(AlertListContainer, _Component);

  function AlertListContainer() {
    _classCallCheck(this, AlertListContainer);

    return _possibleConstructorReturn(this, (AlertListContainer.__proto__ || Object.getPrototypeOf(AlertListContainer)).apply(this, arguments));
  }

  _createClass(AlertListContainer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props = this.props,
          clearAlerts = _props.clearAlerts,
          clearOnUnmount = _props.clearOnUnmount;

      if (clearOnUnmount) {
        clearAlerts();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          removeAlert = _props2.removeAlert,
          scope = _props2.scope;
      var alerts = this.props.alerts;


      if (scope) {
        alerts = alerts.filter(function (alert) {
          return alert.scope === scope;
        });
      }

      return _react2.default.createElement(_AlertList2.default, { alerts: alerts, onCloseClick: removeAlert });
    }
  }]);

  return AlertListContainer;
}(_react.Component), _class2.propTypes = {
  alerts: _propTypes2.default.array.isRequired,
  clearAlerts: _propTypes2.default.func.isRequired,
  clearOnUnmount: _propTypes2.default.bool,
  removeAlert: _propTypes2.default.func.isRequired,
  scope: _propTypes2.default.string
}, _temp)) || _class);
exports.default = AlertListContainer;


function mapStateToProps(state) {
  return {
    alerts: state.alerts
  };
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EntitySchema = function () {
  function EntitySchema(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, EntitySchema);

    if (!key || typeof key !== 'string') {
      throw new Error('A string non-empty key is required');
    }

    this._key = key;
    this._assignEntity = options.assignEntity;

    var idAttribute = options.idAttribute || 'id';
    this._getId = typeof idAttribute === 'function' ? idAttribute : function (x) {
      return x[idAttribute];
    };
    this._idAttribute = idAttribute;
    this._meta = options.meta;
    this._defaults = options.defaults;
  }

  _createClass(EntitySchema, [{
    key: 'getAssignEntity',
    value: function getAssignEntity() {
      return this._assignEntity;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return this._key;
    }
  }, {
    key: 'getId',
    value: function getId(entity, key) {
      return this._getId(entity, key);
    }
  }, {
    key: 'getIdAttribute',
    value: function getIdAttribute() {
      return this._idAttribute;
    }
  }, {
    key: 'getMeta',
    value: function getMeta(prop) {
      if (!prop || typeof prop !== 'string') {
        throw new Error('A string non-empty property name is required');
      }
      return this._meta && this._meta[prop];
    }
  }, {
    key: 'getDefaults',
    value: function getDefaults() {
      return this._defaults;
    }
  }, {
    key: 'define',
    value: function define(nestedSchema) {
      for (var key in nestedSchema) {
        if (nestedSchema.hasOwnProperty(key)) {
          this[key] = nestedSchema[key];
        }
      }
    }
  }]);

  return EntitySchema;
}();

exports.default = EntitySchema;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isObject = __webpack_require__(9);

var _isObject2 = _interopRequireDefault(_isObject);

var _UnionSchema = __webpack_require__(170);

var _UnionSchema2 = _interopRequireDefault(_UnionSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArraySchema = function () {
  function ArraySchema(itemSchema) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ArraySchema);

    if (!(0, _isObject2.default)(itemSchema)) {
      throw new Error('ArraySchema requires item schema to be an object.');
    }

    if (options.schemaAttribute) {
      var schemaAttribute = options.schemaAttribute;
      this._itemSchema = new _UnionSchema2.default(itemSchema, { schemaAttribute: schemaAttribute });
    } else {
      this._itemSchema = itemSchema;
    }
  }

  _createClass(ArraySchema, [{
    key: 'getItemSchema',
    value: function getItemSchema() {
      return this._itemSchema;
    }
  }]);

  return ArraySchema;
}();

exports.default = ArraySchema;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(222);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(121),
    equalArrays = __webpack_require__(171),
    equalByTag = __webpack_require__(383),
    equalObjects = __webpack_require__(384),
    getTag = __webpack_require__(165),
    isArray = __webpack_require__(17),
    isBuffer = __webpack_require__(82),
    isTypedArray = __webpack_require__(89);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 382 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53),
    Uint8Array = __webpack_require__(158),
    eq = __webpack_require__(42),
    equalArrays = __webpack_require__(171),
    mapToArray = __webpack_require__(361),
    setToArray = __webpack_require__(99);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(247);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(386);
var utils = __webpack_require__(18);
var dispatchRequest = __webpack_require__(387);
var InterceptorManager = __webpack_require__(393);
var isAbsoluteURL = __webpack_require__(394);
var combineURLs = __webpack_require__(395);
var bind = __webpack_require__(396);
var transformData = __webpack_require__(173);

function Axios(defaultConfig) {
  this.defaults = utils.merge({}, defaultConfig);
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Don't allow overriding defaults.withCredentials
  config.withCredentials = config.withCredentials || this.defaults.withCredentials;

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

var defaultInstance = new Axios(defaults);
var axios = module.exports = bind(Axios.prototype.request, defaultInstance);

axios.create = function create(defaultConfig) {
  return new Axios(defaultConfig);
};

// Expose defaults
axios.defaults = defaultInstance.defaults;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(397);

// Expose interceptors
axios.interceptors = defaultInstance.interceptors;

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
  axios[method] = bind(Axios.prototype[method], defaultInstance);
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
  axios[method] = bind(Axios.prototype[method], defaultInstance);
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

module.exports = {
  transformRequest: [function transformResponseJSON(data, headers) {
    if (utils.isFormData(data)) {
      return data;
    }
    if (utils.isArrayBuffer(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isObject(data) && !utils.isFile(data) && !utils.isBlob(data)) {
      // Set application/json if no Content-Type has been specified
      if (!utils.isUndefined(headers)) {
        utils.forEach(headers, function processContentTypeHeader(val, key) {
          if (key.toLowerCase() === 'content-type') {
            headers['Content-Type'] = val;
          }
        });

        if (utils.isUndefined(headers['Content-Type'])) {
          headers['Content-Type'] = 'application/json;charset=utf-8';
        }
      }
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponseJSON(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    },
    patch: utils.merge(DEFAULT_CONTENT_TYPE),
    post: utils.merge(DEFAULT_CONTENT_TYPE),
    put: utils.merge(DEFAULT_CONTENT_TYPE)
  },

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN'
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/**
 * Dispatch a request to the server using whichever adapter
 * is supported by the current environment.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  return new Promise(function executor(resolve, reject) {
    try {
      var adapter;

      if (typeof config.adapter === 'function') {
        // For custom adapter support
        adapter = config.adapter;
      } else if (typeof XMLHttpRequest !== 'undefined') {
        // For browsers use XHR adapter
        adapter = __webpack_require__(172);
      } else if (typeof process !== 'undefined') {
        // For node use HTTP adapter
        adapter = __webpack_require__(172);
      }

      if (typeof adapter === 'function') {
        adapter(resolve, reject, config);
      }
    } catch (e) {
      reject(e);
    }
  });
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};



/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}
InvalidCharacterError.prototype = new Error;
InvalidCharacterError.prototype.code = 5;
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new InvalidCharacterError('INVALID_CHARACTER_ERR: DOM Exception 5');
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 399 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmur2);


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_is_prop_valid__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_core__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_utils__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_serialize__ = __webpack_require__(64);







var testOmitPropsOnStringTag = __WEBPACK_IMPORTED_MODULE_2__emotion_is_prop_valid__["default"];

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Noop = function Noop() {
  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var identifierName;
  var shouldForwardProp;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
      options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["withEmotionCache"])(function (props, context, ref) {
      return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["ThemeContext"].Consumer, null, function (theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = theme;
        }

        if (typeof props.className === 'string') {
          className = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["a" /* getRegisteredStyles */])(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])(styles.concat(classInterpolations), context.registered, mergedProps);
        var rules = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(context, serialized, typeof finalTag === 'string');
        className += context.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref || props.innerRef;

        if (false) {
          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
        }

        var ele = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(finalTag, newProps);
        var possiblyStyleElement = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Noop, null);


        return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, possiblyStyleElement, ele);
      });
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createStyled);


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(159),
    noop = __webpack_require__(354),
    setToArray = __webpack_require__(99);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 406 */,
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = alertMiddleware;

var _alertActions = __webpack_require__(33);

function canCreateAlert(action) {
  return action.alert && action.type !== _alertActions.CREATE_ALERT && action.type !== _alertActions.REMOVE_ALERT;
}

function alertMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      var result = next(action);

      if (canCreateAlert(action)) {
        dispatch((0, _alertActions.createAlert)(action.alert));
      }

      return result;
    };
  };
}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = locationMiddleware;

var _reactRouterRedux = __webpack_require__(117);

function locationMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      var result = next(action);

      if (action.location) {
        var location = typeof action.location === 'function' ? action.location(result) : action.location;

        if (location !== false) {
          dispatch((0, _reactRouterRedux.push)(location));
        }
      }

      return result;
    };
  };
}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(20);

var _reduxForm = __webpack_require__(230);

var _alerts = __webpack_require__(579);

var _alerts2 = _interopRequireDefault(_alerts);

var _archivedStudies = __webpack_require__(580);

var _archivedStudies2 = _interopRequireDefault(_archivedStudies);

var _boxTranscriptProducts = __webpack_require__(581);

var _boxTranscriptProducts2 = _interopRequireDefault(_boxTranscriptProducts);

var _brandings = __webpack_require__(582);

var _brandings2 = _interopRequireDefault(_brandings);

var _clips = __webpack_require__(583);

var _clips2 = _interopRequireDefault(_clips);

var _companies = __webpack_require__(584);

var _companies2 = _interopRequireDefault(_companies);

var _company = __webpack_require__(585);

var _company2 = _interopRequireDefault(_company);

var _companyRoles = __webpack_require__(586);

var _companyRoles2 = _interopRequireDefault(_companyRoles);

var _currentUser = __webpack_require__(587);

var _currentUser2 = _interopRequireDefault(_currentUser);

var _documentSessions = __webpack_require__(588);

var _documentSessions2 = _interopRequireDefault(_documentSessions);

var _emailDomains = __webpack_require__(593);

var _emailDomains2 = _interopRequireDefault(_emailDomains);

var _entities = __webpack_require__(594);

var _entities2 = _interopRequireDefault(_entities);

var _features = __webpack_require__(595);

var _features2 = _interopRequireDefault(_features);

var _highlights = __webpack_require__(596);

var _highlights2 = _interopRequireDefault(_highlights);

var _modals = __webpack_require__(597);

var _modals2 = _interopRequireDefault(_modals);

var _permissions = __webpack_require__(598);

var _permissions2 = _interopRequireDefault(_permissions);

var _projects = __webpack_require__(599);

var _projects2 = _interopRequireDefault(_projects);

var _reports = __webpack_require__(600);

var _reports2 = _interopRequireDefault(_reports);

var _responses = __webpack_require__(601);

var _responses2 = _interopRequireDefault(_responses);

var _roles = __webpack_require__(602);

var _roles2 = _interopRequireDefault(_roles);

var _reactRouterRedux = __webpack_require__(117);

var _searches = __webpack_require__(603);

var _searches2 = _interopRequireDefault(_searches);

var _searchResults = __webpack_require__(604);

var _searchResults2 = _interopRequireDefault(_searchResults);

var _studyPermissions = __webpack_require__(606);

var _studyPermissions2 = _interopRequireDefault(_studyPermissions);

var _transcriptionKey = __webpack_require__(607);

var _transcriptionKey2 = _interopRequireDefault(_transcriptionKey);

var _transcriptionTranscriptRequests = __webpack_require__(167);

var _transcriptionTranscriptRequests2 = _interopRequireDefault(_transcriptionTranscriptRequests);

var _studiesWithTranscriptsOrdered = __webpack_require__(168);

var _studiesWithTranscriptsOrdered2 = _interopRequireDefault(_studiesWithTranscriptsOrdered);

var _users = __webpack_require__(608);

var _users2 = _interopRequireDefault(_users);

var _workspaces = __webpack_require__(609);

var _workspaces2 = _interopRequireDefault(_workspaces);

var _videoPlayers = __webpack_require__(610);

var _videoPlayers2 = _interopRequireDefault(_videoPlayers);

var _taniState = __webpack_require__(372);

var _taniState2 = _interopRequireDefault(_taniState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  alerts: _alerts2.default,
  archivedStudies: _archivedStudies2.default,
  boxTranscriptProducts: _boxTranscriptProducts2.default,
  brandings: _brandings2.default,
  clips: _clips2.default,
  companies: _companies2.default,
  company: _company2.default,
  companyRoles: _companyRoles2.default,
  currentUser: _currentUser2.default,
  documentSessions: _documentSessions2.default,
  entities: _entities2.default,
  emailDomains: _emailDomains2.default,
  features: _features2.default,
  form: _reduxForm.reducer,
  highlights: _highlights2.default,
  modals: _modals2.default,
  permissions: _permissions2.default,
  projects: _projects2.default,
  responses: _responses2.default,
  reports: _reports2.default,
  roles: _roles2.default,
  routing: _reactRouterRedux.routerReducer,
  searches: _searches2.default,
  searchResults: _searchResults2.default,
  studiesWithTranscriptsOrdered: _studiesWithTranscriptsOrdered2.default,
  studyPermissions: _studyPermissions2.default,
  transcriptionKey: _transcriptionKey2.default,
  transcriptionTranscriptRequests: _transcriptionTranscriptRequests2.default,
  users: _users2.default,
  workspaces: _workspaces2.default,
  videoPlayers: _videoPlayers2.default,
  taniState: _taniState2.default
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Form);
/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);




var FormName = function FormName(_ref, _ref2) {
  var children = _ref.children;
  var _reduxForm = _ref2._reduxForm;
  return children({ form: _reduxForm && _reduxForm.form });
};
FormName.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (FormName);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (FormSection);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return formPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fieldInputPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fieldMetaPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fieldArrayMetaPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fieldArrayFieldsPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fieldPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fieldArrayPropTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  clearFields: func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (formPropTypes);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedField__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__structure_plain__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    immutableProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Field);
  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(187);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            immutableProps = _props.immutableProps,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop', 'immutableProps']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(186);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(65);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(424);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(103);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(105);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(435);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(67);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(191);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(430);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(15);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(67);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(67);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(67);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(69);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(69);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(69);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(69);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(70);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(70);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(70);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(70);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(66);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(65);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(74);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(68);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(103);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(457);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(462);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(464);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(107);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(13);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(469);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(27);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(27);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(153);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)(module)))

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(155);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(15);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(15);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(15);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(15);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(65);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFields__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_prefixName__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      var error = validateNameProp(props.names);
      if (error) {
        throw error;
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Fields);
  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_React$Component) {
    _inherits(ConnectedFields, _React$Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = this.saveRef;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(FieldArray);
  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(2);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_React$Component) {
    _inherits(ConnectedFieldArray, _React$Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(107);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(500);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(203);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(71);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(107);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(50);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(204);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(499);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(50);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(50);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(204);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      splice: arraySplice,
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(48);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__["a" /* default */])(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])(_this2._valuesMap, function (path) {
                return getIn(values, Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(_this2.context, path));
              });
            };
            this.Component = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);

              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(71);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(74);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsAsyncValidating);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(206);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return !isPristine.apply(undefined, [state].concat(_toConsumableArray(fields)));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(113);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__asyncValidation__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generateValidator__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handleSubmit__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_isValid__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__structure_plain__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__ = __webpack_require__(573);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_6_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _this.saveRef = function (ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldErrorOverridden = shouldError !== __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */];

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldWarnOverridden = shouldWarn !== __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */];

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                immutableProps = _props9.immutableProps,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                keepValues = _props9.keepValues,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'immutableProps', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'keepValues', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              ;propsToPass.ref = this.saveRef;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
        immutableProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
        initialValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["connect"])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["bindActionCreators"])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(ReduxForm);
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(559);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(208);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(554);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(15);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)(module)))

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(550);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(195);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(75);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(24);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(27);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(209);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(76);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(49);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(558);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(567);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(563);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(562);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(566);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(112);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(24);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(210);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(2);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(183);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)(module)))

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(2);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (path.startsWith('values')) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;

    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */])(shouldDelete);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref4) {
    var field = _ref4.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref7) {
    var field = _ref7.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref8) {
    var field = _ref8.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref15) {
    var field = _ref15.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"], function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref17) {
    var field = _ref17.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"], function (state, _ref20) {
    var sections = _ref20.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref21) {
    var field = _ref21.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref23) {
    var payload = _ref23.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref25) {
    var fields = _ref25.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref27) {
    var fields = _ref27.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(65);



function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;


  return function () {
    var shouldDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDeleteDefault;

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);
          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }
      return result;
    };

    return deleteInWithCleanUp;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = alerts;

var _alertActions = __webpack_require__(33);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function alerts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _alertActions.CLEAR_ALERTS:
      if (action.scope) {
        return state.filter(function (alert) {
          return alert.scope !== action.scope;
        });
      }

      return [];
    case _alertActions.CREATE_ALERT:
      return [].concat(_toConsumableArray(state), [action.alert]);
    case _alertActions.REMOVE_ALERT:
      var idx = state.indexOf(action.alert);
      return [].concat(_toConsumableArray(state.slice(0, idx)), _toConsumableArray(state.slice(idx + 1)));
    default:
      return state;
  }
}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _archivedStudyActions = __webpack_require__(365);

var _unarchiveStudyRequestActions = __webpack_require__(366);

var initialState = {
  items: [],
  page: 1,
  totalPages: 0,
  isLoading: true,
  query: '',
  order: 'desc',
  sort: 'date'
};

var archivedStudies = function archivedStudies() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var response = action.response;

  switch (action.type) {
    case _archivedStudyActions.FETCH_ARCHIVED_STUDIES_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        page: action.page || 1,
        query: action.query || ''
      });
    case _archivedStudyActions.FETCH_ARCHIVED_STUDIES_SUCCEEDED:
      return Object.assign({}, state, {
        isLoading: false,
        totalPages: response.meta.totalPages,
        sort: response.meta.sort,
        order: response.meta.order,
        items: response.archivedStudies
      });
    case _archivedStudyActions.FETCH_ARCHIVED_STUDIES_FAILED:
      return Object.assign({}, state, { isLoading: false });
    case _unarchiveStudyRequestActions.CREATE_UNARCHIVE_STUDY_REQUEST_SUCCEEDED:
      return Object.assign({}, state, {
        items: state.items.map(function (archivedStudy) {
          if (archivedStudy.id !== response.unarchiveStudyRequest.archivedStudyId) {
            return archivedStudy;
          }
          return Object.assign({}, archivedStudy, { unarchivingStatus: 'new' });
        })
      });
    default:
      return state;
  }
};

exports.default = archivedStudies;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = boxTranscriptProducts;

var _boxTranscriptProductActions = __webpack_require__(367);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  isFetching: false,
  items: [],
  idsGenerating: []
};

function boxTranscriptProducts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _boxTranscriptProductActions.BOX_TRANSCRIPT_PRODUCTS_REQUEST:
      return Object.assign({}, state, { isFetching: true });
    case _boxTranscriptProductActions.BOX_TRANSCRIPT_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.response.result
      });
    case _boxTranscriptProductActions.BOX_TRANSCRIPT_PRODUCTS_FAILURE:
    case _boxTranscriptProductActions.GENERATE_WORK_FOLDER_FAILURE:
      return Object.assign({}, state, { isFetching: false });
    case _boxTranscriptProductActions.GENERATE_WORK_FOLDER_REQUEST:
      return Object.assign({}, state, {
        idsGenerating: [].concat(_toConsumableArray(state.idsGenerating), [action.idsGenerating]),
        isFetching: true
      });
    case _boxTranscriptProductActions.GENERATE_WORK_FOLDER_SUCCESS:
      var idx = state.idsGenerating.indexOf(action.idsGenerating);
      return Object.assign({}, state, {
        isFetching: false,
        idsGenerating: [].concat(_toConsumableArray(state.idsGenerating.slice(0, idx)), _toConsumableArray(state.idsGenerating.slice(idx + 1)))
      });
    default:
      return state;
  }
}

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = brandings;

var _brandingActions = __webpack_require__(357);

var _uniq = __webpack_require__(23);

var _uniq2 = _interopRequireDefault(_uniq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  ids: [],
  isLoading: null,
  isUploadingImage: false
};

function brandings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _brandingActions.FETCH_BRANDING_REQUEST:
      return Object.assign({}, state, { isLoading: true });
    case _brandingActions.FETCH_BRANDING_FAILED:
      return Object.assign({}, state, { isLoading: false });
    case _brandingActions.FETCH_BRANDING_SUCCEEDED:
      return Object.assign({}, state, {
        isLoading: false,
        ids: (0, _uniq2.default)([].concat(_toConsumableArray(state.ids), [action.response.result]))
      });
    case _brandingActions.UPDATE_LOGO_REQUEST:
      return Object.assign({}, state, { isUploadingImage: true });
    case _brandingActions.UPDATE_LOGO_SUCCEEDED:
    case _brandingActions.UPDATE_LOGO_FAILED:
      return Object.assign({}, state, { isUploadingImage: false });
    default:
      return state;
  }
}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ClipActions = __webpack_require__(368);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  loading: false,
  requestingDownload: false,
  clips: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _ClipActions.DOWNLOAD_CLIP_REQUEST:
      return Object.assign({}, state, {
        requestingDownload: true
      });
    case _ClipActions.DOWNLOAD_CLIP_SUCCESS:
    case _ClipActions.DOWNLOAD_CLIP_FAILURE:
      return Object.assign({}, state, {
        requestingDownload: false
      });
    case _ClipActions.FETCH_CLIP_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        errors: null
      });
    case _ClipActions.FETCH_CLIP_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        clips: _defineProperty({}, action.data.id, action.data)
      });
    case _ClipActions.FETCH_CLIP_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.errors
      });
    default:
      return state;
  }
};

exports.default = reducer;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _companyActions = __webpack_require__(150);

var initialState = {
  ids: [],
  page: 1,
  totalPages: 0,
  isLoading: false,
  query: ''
};

var companies = function companies() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _companyActions.FETCH_COMPANIES_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        page: action.page || 1,
        query: action.query || ''
      });
    case _companyActions.FETCH_COMPANIES_SUCCEEDED:
      var response = action.response;


      return Object.assign({}, state, {
        isLoading: false,
        totalPages: response.meta.totalPages,
        ids: response.result
      });
    case _companyActions.FETCH_COMPANIES_FAILED:
      return Object.assign({}, state, { isLoading: false });
    default:
      return state;
  }
};

exports.default = companies;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = company;

var _companyActions = __webpack_require__(150);

var initialState = {
  id: null,
  submittingWordCloud: false
};

function company() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _companyActions.UPDATE_COMPANY_SUCCEEDED:
      return Object.assign({}, state, action.response);
    case _companyActions.REMOVE_WORD_CLOUD_SUCCEEDED:
      return Object.assign({}, state, {
        submittingWordCloud: false,
        wordCloud: {}
      });
    case _companyActions.REMOVE_WORD_CLOUD_REQUEST:
    case _companyActions.SUBMIT_WORD_CLOUD_REQUEST:
      return Object.assign({}, state, { submittingWordCloud: true });
    case _companyActions.SUBMIT_WORD_CLOUD_SUCCEEDED:
      return Object.assign({}, state, {
        wordCloud: action.wordCloud,
        submittingWordCloud: false
      });
    case _companyActions.REMOVE_WORD_CLOUD_FAILED:
    case _companyActions.SUBMIT_WORD_CLOUD_FAILED:
      return Object.assign({}, state, { submittingWordCloud: false });
    default:
      return state;
  }
}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (state) {
  return state || {};
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = currentUser;
function currentUser() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return state;
}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = documentSessions;

var _documentActions = __webpack_require__(299);

var _merge4 = __webpack_require__(211);

var _merge5 = _interopRequireDefault(_merge4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function documentSessions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _documentActions.DOCUMENT_SESSION_REQUEST:
      return (0, _merge5.default)({}, state, _defineProperty({}, action.document.id, {
        isFetching: true,
        sessionId: null
      }));
    case _documentActions.DOCUMENT_SESSION_SUCCESS:
      return (0, _merge5.default)({}, state, _defineProperty({}, action.document.id, {
        isFetching: false,
        sessionId: action.response.sessionId
      }));
    case _documentActions.DOCUMENT_SESSION_FAILURE:
      return (0, _merge5.default)({}, state, _defineProperty({}, action.document.id, {
        isFetching: false,
        sessionId: null
      }));
    default:
      return state;
  }
}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(121),
    assignMergeValue = __webpack_require__(212),
    baseFor = __webpack_require__(238),
    baseMergeDeep = __webpack_require__(590),
    isObject = __webpack_require__(9),
    keysIn = __webpack_require__(97),
    safeGet = __webpack_require__(214);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(212),
    cloneBuffer = __webpack_require__(251),
    cloneTypedArray = __webpack_require__(252),
    copyArray = __webpack_require__(236),
    initCloneObject = __webpack_require__(253),
    isArguments = __webpack_require__(98),
    isArray = __webpack_require__(17),
    isArrayLikeObject = __webpack_require__(254),
    isBuffer = __webpack_require__(82),
    isFunction = __webpack_require__(83),
    isObject = __webpack_require__(9),
    isPlainObject = __webpack_require__(213),
    isTypedArray = __webpack_require__(89),
    safeGet = __webpack_require__(214),
    toPlainObject = __webpack_require__(591);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(129),
    keysIn = __webpack_require__(97);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(218),
    isIterateeCall = __webpack_require__(224);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = emailDomains;

var _emailDomainActions = __webpack_require__(358);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  ids: [],
  isLoading: false
};

function emailDomains() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _emailDomainActions.CREATE_EMAIL_DOMAIN_REQUEST:
      return Object.assign({}, state, { isLoading: true });
    case _emailDomainActions.CREATE_EMAIL_DOMAIN_SUCCEEDED:
      return Object.assign({}, state, {
        isLoading: false,
        ids: [].concat(_toConsumableArray(state.ids), [action.response.result])
      });
    case _emailDomainActions.FETCH_EMAIL_DOMAINS_REQUEST:
      return Object.assign({}, state, { isLoading: true, ids: [] });
    case _emailDomainActions.FETCH_EMAIL_DOMAINS_SUCCEEDED:
      return Object.assign({}, state, { isLoading: false, ids: action.response.result });
    case _emailDomainActions.REMOVE_EMAIL_DOMAIN_REQUEST:
      return Object.assign({}, state, { isLoading: true });
    case _emailDomainActions.REMOVE_EMAIL_DOMAIN_SUCCEEDED:
      var idx = state.ids.indexOf(action.emailDomain.id);
      return Object.assign({}, state, {
        isLoading: false,
        ids: [].concat(_toConsumableArray(state.ids.slice(0, idx)), _toConsumableArray(state.ids.slice(idx + 1)))
      });
    case _emailDomainActions.FETCH_EMAIL_DOMAIN_USERS_COUNT_SUCCEEDED:
    case _emailDomainActions.CREATE_EMAIL_DOMAIN_FAILED:
    case _emailDomainActions.CREATE_EMAIL_DOMAIN_CANCELLED:
    case _emailDomainActions.FETCH_EMAIL_DOMAIN_USERS_COUNT_FAILED:
    case _emailDomainActions.FETCH_EMAIL_DOMAINS_FAILED:
    case _emailDomainActions.REMOVE_EMAIL_DOMAIN_FAILED:
      return Object.assign({}, state, { isLoading: false });
    default:
      return state;
  }
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = entities;

var _merge = __webpack_require__(211);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  boxTranscriptProducts: {},
  brandings: {},
  clips: {},
  countries: {},
  emailDomains: {},
  highlights: {},
  metaTags: {},
  projects: {},
  reports: {},
  responses: {},
  roles: {},
  searches: {},
  tags: {},
  users: {},
  workspaces: {}
};

function entities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.response && action.response.entities) {
    return (0, _merge2.default)({}, state, action.response.entities);
  } else if (action.entities) {
    return (0, _merge2.default)({}, state, action.entities);
  }

  return state;
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var features = function features() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  return state;
};

exports.default = features;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = highlights;

var _highlightActions = __webpack_require__(160);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  isFetching: false,
  items: []
};

function highlights() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _highlightActions.HIGHLIGHT_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case _highlightActions.HIGHLIGHT_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: [].concat(_toConsumableArray(state.items), [action.response.result])
      });
    case _highlightActions.HIGHLIGHT_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modals;

var _modalActions = __webpack_require__(128);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function modals() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _modalActions.OPEN_MODAL:
      return Object.assign({}, state, _defineProperty({}, action.id, true));
    case _modalActions.CLOSE_MODAL:
      return Object.assign({}, state, _defineProperty({}, action.id, false));
    default:
      return state;
  }
}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = permissions;
function permissions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return state;
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = projects;

var _projectActions = __webpack_require__(132);

var _uniq = __webpack_require__(23);

var _uniq2 = _interopRequireDefault(_uniq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  isFetching: false,
  items: [],
  selectedProjects: []
};

function projects() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _projectActions.CLEAR_SELECTED_PROJECTS:
      return Object.assign({}, state, { selectedProjects: [] });
    case _projectActions.PROJECT_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case _projectActions.PROJECT_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: [].concat(_toConsumableArray(state.items), [action.response.result])
      });
    case _projectActions.PROJECT_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    case _projectActions.FETCH_PROJECTS_REQUEST:
      return Object.assign({}, state, { isFetching: true, items: [] });
    case _projectActions.FETCH_PROJECTS_SUCCESS:
      return Object.assign({}, state, { isFetching: false, items: action.response.result });
    case _projectActions.FETCH_PROJECTS_FAILURE:
      return Object.assign({}, state, { isFetching: false });
    case _projectActions.TOGGLE_PROJECT:
      if (action.selected) {
        return Object.assign({}, state, {
          selectedProjects: (0, _uniq2.default)([].concat(_toConsumableArray(state.selectedProjects), [action.projectId]))
        });
      }

      var idx = state.selectedProjects.indexOf(action.projectId);

      if (idx === -1) {
        return state;
      }

      return Object.assign({}, state, {
        selectedProjects: [].concat(_toConsumableArray(state.selectedProjects.slice(0, idx)), _toConsumableArray(state.selectedProjects.slice(idx + 1)))
      });
    default:
      return state;
  }
}

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reports;

var _reportActions = __webpack_require__(161);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  isFetching: false,
  items: []
};

function reports() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _reportActions.REPORT_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });
    case _reportActions.REPORT_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: [].concat(_toConsumableArray(state.items), [action.response.result])
      });
    case _reportActions.REPORT_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _responseActions = __webpack_require__(369);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  loading: false,
  responses: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _responseActions.RESPONSE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        errors: null
      });
    case _responseActions.RESPONSE_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        responses: _defineProperty({}, action.data.id, action.data)
      });
    case _responseActions.RESPONSE_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.errors
      });
    case _responseActions.CLEAR_RESPONSE:
      {
        var responses = state.responses;
        // eslint-disable-next-line no-unused-vars

        var removedResponse = responses[action.id.toString()],
            rest = _objectWithoutProperties(responses, [action.id.toString()]);

        return Object.assign({}, state, {
          responses: rest
        });
      }
    case _responseActions.TOGGLE_OBSERVERS_VIEW_PII:
      {
        var _responses2 = state.responses;

        var response = _responses2[action.id],
            _rest = _objectWithoutProperties(_responses2, [action.id]);

        return Object.assign({}, state, {
          responses: Object.assign({}, _rest, _defineProperty({}, action.id, Object.assign({}, response, {
            observersViewPiiFl: action.value
          })))
        });
      }
    default:
      return state;
  }
};

exports.default = reducer;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = roles;

var _roleActions = __webpack_require__(267);

var initialState = {
  ids: [],
  isLoading: false
};

function roles() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _roleActions.FETCH_ROLES_REQUEST:
      return Object.assign({}, state, { isLoading: true });
    case _roleActions.FETCH_ROLES_SUCCEEDED:
      return Object.assign({}, state, { isLoading: false, ids: action.response.result });
    case _roleActions.FETCH_ROLES_FAILED:
      return Object.assign({}, state, { isLoading: false });
    default:
      return state;
  }
}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searches;

var _searchActions = __webpack_require__(151);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  isSaving: false,
  ids: []
};

function searches() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _searchActions.SEARCH_CREATE_REQUEST:
      return Object.assign({}, state, {
        isSaving: true
      });
    case _searchActions.SEARCH_CREATE_SUCCESS:
      return Object.assign({}, state, {
        isSaving: false,
        ids: [].concat(_toConsumableArray(state.ids), [action.response.result])
      });
    case _searchActions.SEARCH_CREATE_FAILURE:
      return Object.assign({}, state, {
        isSaving: false
      });
    case _searchActions.FETCH_RECENT_SEARCHES_SUCCESS:
      return Object.assign({}, state, {
        ids: action.response.result
      });
    default:
      return state;
  }
}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searchResults;

var _searchResultActions = __webpack_require__(268);

var _reduxHelpers = __webpack_require__(605);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialCounts = {
  all: 0,
  projects: 0,
  files: 0,
  highlights: 0,
  playlists: 0,
  clips: 0,
  responses: 0
};

function counts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCounts;
  var action = arguments[1];

  switch (action.type) {
    case _searchResultActions.SEARCH_RESULTS_SUCCESS:
      var _counts = action.response.counts;


      return Object.assign({}, state, {
        all: _counts.all,
        projects: _counts.projects,
        files: _counts.projectDocuments,
        highlights: _counts.highlights,
        playlists: _counts.playlists,
        clips: _counts.videoClips,
        responses: _counts.responses
      });
    default:
      return state;
  }
}

var initialState = {
  allExpanded: false,
  allSelected: false,
  counts: counts(undefined, {}),
  currentPage: 1,
  isFetching: false,
  results: [],
  selectedView: 'list',
  totalPages: 1
};

function searchResults() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _searchResultActions.CHANGE_SELECTED_VIEW:
      return Object.assign({}, state, {
        selectedView: action.view
      });
    case _searchResultActions.TOGGLE_ALL_RESULTS:
      return Object.assign({}, state, {
        allExpanded: action.expanded,
        results: state.results.map(function (result) {
          return Object.assign({}, result, { expanded: action.expanded });
        })
      });
    case _searchResultActions.TOGGLE_ALL_SELECTED_RESULTS:
      return Object.assign({}, state, {
        allSelected: action.selected,
        results: state.results.map(function (result) {
          return Object.assign({}, result, { selected: action.selected });
        })
      });
    case _searchResultActions.TOGGLE_EXPAND_RESULT:
      return Object.assign({}, state, {
        allExpanded: action.result.expanded ? false : state.allExpanded,
        results: (0, _reduxHelpers.updateObjectInCollection)(state.results, action.result.id, {
          expanded: !action.result.expanded
        })
      });
    case _searchResultActions.TOGGLE_SELECT_RESULT:
      return Object.assign({}, state, {
        allSelected: action.result.selected ? false : state.allSelected,
        results: (0, _reduxHelpers.updateObjectInCollection)(state.results, action.result.id, {
          selected: !action.result.selected
        })
      });
    case _searchResultActions.SEARCH_RESULT_FAVORITE_SUCCESS:
      return Object.assign({}, state, {
        results: (0, _reduxHelpers.updateObjectInCollection)(state.results, action.result.id, {
          favoriteFl: true
        })
      });
    case _searchResultActions.SEARCH_RESULT_UNFAVORITE_SUCCESS:
      return Object.assign({}, state, {
        results: (0, _reduxHelpers.updateObjectInCollection)(state.results, action.result.id, {
          favoriteFl: false
        })
      });
    case _searchResultActions.SEARCH_RESULTS_REQUEST:
      return Object.assign({}, state, {
        counts: counts(state.counts, action),
        currentPage: 1,
        results: [],
        isFetching: true
      });
    case _searchResultActions.SEARCH_RESULTS_SUCCESS:
      var _action$response = action.response,
          results = _action$response.results,
          totalPages = _action$response.totalPages;


      return Object.assign({}, state, {
        totalPages: totalPages,
        results: results,
        counts: counts(state.counts, action),
        allExpanded: false,
        allSelected: false,
        isFetching: false
      });
    case _searchResultActions.SEARCH_RESULT_DELETE_SUCCESS:
      var idx = state.results.indexOf(action.result);

      return Object.assign({}, state, {
        results: [].concat(_toConsumableArray(state.results.slice(0, idx)), _toConsumableArray(state.results.slice(idx + 1)))
      });
    case _searchResultActions.SEARCH_RESULT_UPDATE_ATTRIBUTES:
      return Object.assign({}, state, {
        results: (0, _reduxHelpers.updateObjectInCollection)(state.results, action.result.id, action.attributes)
      });
    case _searchResultActions.SEARCH_RESULT_UPDATE_REQUEST:
      return Object.assign({}, state, {
        results: (0, _reduxHelpers.updateObjectInCollection)(state.results, action.result.id, {
          saving: true
        })
      });
    case _searchResultActions.SEARCH_RESULT_UPDATE_SUCCESS:
      var values = Object.keys(action.data).map(function (key) {
        return action.data[key];
      });

      return Object.assign({}, state, {
        results: (0, _reduxHelpers.updateObjectInCollection)(state.results, action.result.id, Object.assign({}, values[0], {
          saving: false
        }))
      });
    case _searchResultActions.SEARCH_RESULT_UPDATE_FAILURE:
      return Object.assign({}, state, {
        results: (0, _reduxHelpers.updateObjectInCollection)(state.results, action.result.id, {
          saving: false
        })
      });
    case _searchResultActions.SEARCH_RESULTS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });
    default:
      return state;
  }
}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateObjectInCollection = updateObjectInCollection;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function updateObjectInCollection(collection, id, attributes) {
  var idx = collection.findIndex(function (item) {
    return item.id === id;
  });

  if (idx === -1) {
    return collection;
  }

  return [].concat(_toConsumableArray(collection.slice(0, idx)), [Object.assign({}, collection[idx], attributes)], _toConsumableArray(collection.slice(idx + 1)));
}

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = studyPermissions;
function studyPermissions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return state;
}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var transcriptionKey = function transcriptionKey() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  return state;
};

exports.default = transcriptionKey;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userActions = __webpack_require__(237);

var _uniq = __webpack_require__(23);

var _uniq2 = _interopRequireDefault(_uniq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  ids: [],
  existingUserId: null,
  page: 1,
  totalPages: 0,
  selectedUsers: [],
  sendingWelcomeEmail: false,
  isLoading: false,
  query: ''
};

var users = function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _userActions.CLEAR_USERS:
      return Object.assign({}, state, { ids: [] });
    case _userActions.CLEAR_SELECTED_USERS:
      return Object.assign({}, state, { selectedUsers: [] });
    case _userActions.TOGGLE_USER:
      if (action.selected) {
        return Object.assign({}, state, {
          selectedUsers: (0, _uniq2.default)([].concat(_toConsumableArray(state.selectedUsers), [action.userId]))
        });
      }

      var idx = state.selectedUsers.indexOf(action.userId);

      if (idx === -1) {
        return state;
      }

      return Object.assign({}, state, {
        selectedUsers: [].concat(_toConsumableArray(state.selectedUsers.slice(0, idx)), _toConsumableArray(state.selectedUsers.slice(idx + 1)))
      });
    case _userActions.FETCH_USERS_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        page: action.page || 1,
        query: action.query || ''
      });
    case _userActions.CHECK_USER_EXISTS_REQUEST:
    case _userActions.TOGGLE_ACTIVATE_USER_REQUEST:
    case _userActions.FETCH_USER_REQUEST:
      return Object.assign({}, state, { isLoading: true });
    case _userActions.FETCH_USERS_SUCCEEDED:
      var response = action.response;


      return Object.assign({}, state, {
        isLoading: false,
        totalPages: response.meta && response.meta.totalPages || 1,
        ids: response.result
      });
    case _userActions.CHECK_USER_EXISTS_SUCCEEDED:
      var result = action.response.result;

      return Object.assign({}, state, { isLoading: false, existingUserId: result });
    case _userActions.CHECK_USER_EXISTS_FAILED:
    case _userActions.FETCH_USERS_FAILED:
    case _userActions.FETCH_USER_FAILED:
    case _userActions.FETCH_USER_SUCCEEDED:
    case _userActions.TOGGLE_ACTIVATE_USER_SUCCEEDED:
    case _userActions.TOGGLE_ACTIVATE_USER_FAILED:
      return Object.assign({}, state, { isLoading: false });
    case _userActions.SEND_WELCOME_EMAIL_REQUEST:
      return Object.assign({}, state, { sendingWelcomeEmail: true });
    case _userActions.SEND_WELCOME_EMAIL_FAILED:
    case _userActions.SEND_WELCOME_EMAIL_SUCCEEDED:
      return Object.assign({}, state, { sendingWelcomeEmail: false });
    default:
      return state;
  }
};

exports.default = users;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = workspaces;

var _workspaceActions = __webpack_require__(332);

var _highlightActions = __webpack_require__(160);

var _projectActions = __webpack_require__(132);

var _reportActions = __webpack_require__(161);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  isFetching: false,
  isSaving: false,
  items: []
};

function workspaces() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _workspaceActions.WORKSPACES_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _workspaceActions.WORKSPACES_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.response.result
      });

    case _workspaceActions.WORKSPACES_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      });

    case _workspaceActions.WORKSPACE_CREATE_REQUEST:
    case _projectActions.ADD_PROJECT_TO_WORKSPACE_REQUEST:
    case _reportActions.ADD_REPORT_TO_WORKSPACE_REQUEST:
    case _highlightActions.ADD_HIGHLIGHT_TO_WORKSPACE_REQUEST:
      return Object.assign({}, state, {
        isSaving: true
      });

    case _workspaceActions.WORKSPACE_CREATE_SUCCESS:
      return Object.assign({}, state, {
        isSaving: false,
        items: [].concat(_toConsumableArray(state.items), [action.response.result])
      });

    case _projectActions.ADD_PROJECT_TO_WORKSPACE_SUCCESS:
    case _reportActions.ADD_REPORT_TO_WORKSPACE_SUCCESS:
    case _highlightActions.ADD_HIGHLIGHT_TO_WORKSPACE_SUCCESS:
      return Object.assign({}, state, {
        isSaving: false
      });

    case _workspaceActions.WORKSPACE_CREATE_FAILURE:
    case _projectActions.ADD_PROJECT_TO_WORKSPACE_FAILURE:
    case _reportActions.ADD_REPORT_TO_WORKSPACE_FAILURE:
    case _highlightActions.ADD_HIGHLIGHT_TO_WORKSPACE_FAILURE:
      return Object.assign({}, state, {
        isSaving: false
      });

    default:
      return state;
  }
}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _videoPlayerActions = __webpack_require__(250);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var videoPlayer = function videoPlayer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _videoPlayerActions.PAUSE:
    case _videoPlayerActions.REGISTER_VIDEO_PLAYER:
      return {
        paused: true
      };
    case _videoPlayerActions.PLAY:
      return {
        paused: false
      };
    default:
      return state;
  }
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _videoPlayerActions.DEREGISTER_VIDEO_PLAYER:
      var deletedPlayer = state[action.id],
          rest = _objectWithoutProperties(state, [action.id]);

      return rest;
    case _videoPlayerActions.REGISTER_VIDEO_PLAYER:
      return Object.assign({}, state, _defineProperty({}, action.id, videoPlayer(undefined, action)));
    case _videoPlayerActions.PLAY:
    case _videoPlayerActions.PAUSE:
      return Object.assign({}, state, _defineProperty({}, action.id, videoPlayer(state[action.id], action)));
    default:
      return state;
  }
};

exports.default = reducer;

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["default"] = (thunk);

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(20).compose;

exports.__esModule = true;
exports.composeWithDevTools =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

exports.devToolsEnhancer =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "caches", function() { return caches; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(655);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 618 */,
/* 619 */,
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(17),
    isKey = __webpack_require__(632),
    stringToPath = __webpack_require__(834),
    toString = __webpack_require__(670);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = selectList;
function selectList(items, ids) {
  if (!ids) {
    return [];
  }

  return ids.map(function (id) {
    return items[id];
  });
}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderComponent = function renderComponent(Component) {
  return function (props, element) {
    return (0, _reactDom.render)(_react2.default.createElement(Component, props), element);
  };
};

exports.default = renderComponent;

/***/ }),
/* 624 */,
/* 625 */,
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _AlertListItem = __webpack_require__(7);

var _AlertListItem2 = _interopRequireDefault(_AlertListItem);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertList = (_temp = _class = function (_Component) {
  _inherits(AlertList, _Component);

  function AlertList() {
    _classCallCheck(this, AlertList);

    return _possibleConstructorReturn(this, (AlertList.__proto__ || Object.getPrototypeOf(AlertList)).apply(this, arguments));
  }

  _createClass(AlertList, [{
    key: 'renderAlert',
    value: function renderAlert(alert, index) {
      var onCloseClick = this.props.onCloseClick;

      return _react2.default.createElement(_AlertListItem2.default, { key: index, alert: alert, onCloseClick: onCloseClick });
    }
  }, {
    key: 'render',
    value: function render() {
      var alerts = this.props.alerts;

      return _react2.default.createElement(
        'div',
        null,
        alerts.map(this.renderAlert, this)
      );
    }
  }]);

  return AlertList;
}(_react.Component), _class.defaultProps = {
  onCloseClick: function onCloseClick() {}
}, _class.propTypes = {
  alerts: _propTypes2.default.array.isRequired,
  onCloseClick: _propTypes2.default.func
}, _temp);
exports.default = AlertList;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(621),
    toKey = __webpack_require__(263);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _emotion = __webpack_require__(617);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _PaginatorPage = __webpack_require__(675);

var _PaginatorPage2 = _interopRequireDefault(_PaginatorPage);

var _PaginatorPageGap = __webpack_require__(676);

var _PaginatorPageGap2 = _interopRequireDefault(_PaginatorPageGap);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _underscore = __webpack_require__(164);

var _underscore2 = _interopRequireDefault(_underscore);

var _appConstants = __webpack_require__(38);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styled = __webpack_require__(5);

var _styled2 = _interopRequireDefault(_styled);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = /*#__PURE__*/(0, _styled2.default)('span', {
  target: 'ew79huv0'
})({
  fontSize: 14,
  fontStyle: 'italic',
  fontWeight: 'bold',
  marginLeft: 10,
  marginRight: 10,
  verticalAlign: 'middle'
});

var Paginator = (_temp = _class = function (_PureComponent) {
  _inherits(Paginator, _PureComponent);

  function Paginator(props) {
    _classCallCheck(this, Paginator);

    var _this = _possibleConstructorReturn(this, (Paginator.__proto__ || Object.getPrototypeOf(Paginator)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Paginator, [{
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      var totalPages = this.props.totalPages;


      if (e.which === _appConstants.KeyCodes.ENTER) {
        var page = parseInt(e.target.value, 10);

        if (page > 0 && page <= totalPages) {
          this.selectPage(page);
          this.input.value = '';
          this.input.blur();
        }
      }
    }
  }, {
    key: 'renderPage',
    value: function renderPage(page) {
      var _this2 = this;

      return _react2.default.createElement(_PaginatorPage2.default, {
        key: page,
        page: page,
        selected: false,
        onClick: function onClick() {
          return _this2.selectPage(page);
        }
      });
    }
  }, {
    key: 'selectPage',
    value: function selectPage(page) {
      if (page !== this.props.page) {
        this.props.onChange(page);
      }
    }
  }, {
    key: 'leadingPageNumbers',
    value: function leadingPageNumbers() {
      var _props = this.props,
          leadingPages = _props.leadingPages,
          page = _props.page;

      return _underscore2.default.last(_underscore2.default.range(1, page), leadingPages);
    }
  }, {
    key: 'trailingPageNumbers',
    value: function trailingPageNumbers() {
      var _props2 = this.props,
          page = _props2.page,
          totalPages = _props2.totalPages,
          trailingPages = _props2.trailingPages;

      return _underscore2.default.first(_underscore2.default.range(page + 1, totalPages), trailingPages);
    }
  }, {
    key: 'renderLeadingGap',
    value: function renderLeadingGap() {
      var leadingPages = this.props.leadingPages;

      if (this.leadingPageNumbers()[0] > leadingPages - 1) {
        return _react2.default.createElement(_PaginatorPageGap2.default, null);
      }
    }
  }, {
    key: 'renderTrailingGap',
    value: function renderTrailingGap() {
      var _props3 = this.props,
          totalPages = _props3.totalPages,
          trailingPages = _props3.trailingPages;

      if (this.trailingPageNumbers()[0] < totalPages - trailingPages) {
        return _react2.default.createElement(_PaginatorPageGap2.default, null);
      }
    }
  }, {
    key: 'renderFirstPage',
    value: function renderFirstPage() {
      var page = this.props.page;

      if (page !== 1 && this.leadingPageNumbers()[0] !== 1) {
        return this.renderPage(1);
      }
    }
  }, {
    key: 'renderLastPage',
    value: function renderLastPage() {
      var _props4 = this.props,
          page = _props4.page,
          totalPages = _props4.totalPages;


      if (page !== totalPages) {
        return this.renderPage(totalPages);
      }
    }
  }, {
    key: 'renderPrevious',
    value: function renderPrevious() {
      var page = this.props.page;

      var visibility = void 0;

      var onClick = this.selectPage.bind(this, page - 1);

      if (page === 1) {
        visibility = 'hidden';
        onClick = function onClick() {}; // noop
      }

      return _react2.default.createElement(
        'span',
        { 'data-qv-pagination': 'prev page' },
        _react2.default.createElement(
          'a',
          { onClick: onClick, style: { visibility: visibility } },
          _react2.default.createElement(_Icon2.default, { name: 'chevron-left' })
        )
      );
    }
  }, {
    key: 'renderNext',
    value: function renderNext() {
      var _props5 = this.props,
          page = _props5.page,
          totalPages = _props5.totalPages;

      var visibility = void 0;

      var onClick = this.selectPage.bind(this, page + 1);

      if (page === totalPages) {
        visibility = 'hidden';
        onClick = function onClick() {}; // noop
      }

      return _react2.default.createElement(
        'span',
        { 'data-qv-pagination': 'next page' },
        _react2.default.createElement(
          'a',
          { onClick: onClick, style: { visibility: visibility } },
          _react2.default.createElement(_Icon2.default, { name: 'chevron-right' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props6 = this.props,
          allowInput = _props6.allowInput,
          className = _props6.className,
          page = _props6.page,
          style = _props6.style,
          totalPages = _props6.totalPages;


      if (totalPages <= 1) {
        return _react2.default.createElement('nav', { 'data-qv-pagination': '' });
      }

      var classes = (0, _classnames2.default)('pagination', className);

      return _react2.default.createElement(
        'nav',
        { 'data-qv-pagination': classes, style: style },
        this.renderPrevious(),
        this.renderFirstPage(),
        this.renderLeadingGap(),
        this.leadingPageNumbers().map(this.renderPage, this),
        _react2.default.createElement(_PaginatorPage2.default, { selected: true, page: page }),
        this.trailingPageNumbers().map(this.renderPage, this),
        this.renderTrailingGap(),
        this.renderLastPage(),
        this.renderNext(),
        allowInput && _react2.default.createElement(
          Label,
          null,
          I18n.t('Go to page:')
        ),
        allowInput && _react2.default.createElement('input', {
          ref: function ref(input) {
            _this3.input = input;
          },
          type: 'text',
          onKeyUp: this.handleKeyUp,
          className: /*#__PURE__*/(0, _emotion.css)('width:55px !important;height:24px !important;border-radius:2px !important;')
        })
      );
    }
  }]);

  return Paginator;
}(_react.PureComponent), _class.propTypes = {
  allowInput: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  leadingPages: _propTypes2.default.number,
  onChange: _propTypes2.default.func.isRequired,
  page: _propTypes2.default.number.isRequired,
  style: _propTypes2.default.object,
  totalPages: _propTypes2.default.number.isRequired,
  trailingPages: _propTypes2.default.number
}, _class.defaultProps = {
  allowInput: false,
  leadingPages: 3,
  page: 1,
  totalPages: 1,
  trailingPages: 3
}, _temp);
exports.default = Paginator;

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 630 */,
/* 631 */
/***/ (function(module, exports) {

module.exports = Spinner;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(17),
    isSymbol = __webpack_require__(219);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _hasPermission = __webpack_require__(264);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PermissionGuard = (_temp = _class = function (_Component) {
  _inherits(PermissionGuard, _Component);

  function PermissionGuard() {
    _classCallCheck(this, PermissionGuard);

    return _possibleConstructorReturn(this, (PermissionGuard.__proto__ || Object.getPrototypeOf(PermissionGuard)).apply(this, arguments));
  }

  _createClass(PermissionGuard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          permissions = _props.permissions,
          object = _props.object,
          operation = _props.operation;


      if (permissions == null) {
        return null;
      }

      return (0, _hasPermission.hasPermission)(permissions, operation, object) ? children : null;
    }
  }]);

  return PermissionGuard;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  object: _propTypes2.default.string.isRequired,
  operation: _propTypes2.default.string.isRequired,
  permissions: _propTypes2.default.object
}, _class.defaultProps = {
  permissions: {}
}, _temp);
exports.default = PermissionGuard;

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MemoryRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Prompt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StaticRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Switch; });
/* unused harmony export __HistoryContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return context; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return generatePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return matchPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return useHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return useLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return useParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return useRouteMatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return withRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var historyContext = /*#__PURE__*/createNamedContext("Router-History");

var context = /*#__PURE__*/createNamedContext("Router");

/**
 * The public API for putting history on context.
 */

var Router = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
      this._isMounted = false;
      this._pendingLocation = null;
    }
  };

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && isEmptyChildren(children)) {
        children = null;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(historyContext);
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(333);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePopper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popperjs_core__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(335);




var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"]({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        setState({
          styles: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* fromEntries */])(elements.map(function (element) {
            return [element, state.styles[element] || {}];
          })),
          attributes: Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* fromEntries */])(elements.map(function (element) {
            return [element, state.attributes[element]];
          }))
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* useIsomorphicLayoutEffect */])(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* useIsomorphicLayoutEffect */])(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || __WEBPACK_IMPORTED_MODULE_1__popperjs_core__["a" /* createPopper */];
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyStyles_js__ = __webpack_require__(336);
/* unused harmony reexport applyStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrow_js__ = __webpack_require__(638);
/* unused harmony reexport arrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__computeStyles_js__ = __webpack_require__(339);
/* unused harmony reexport computeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventListeners_js__ = __webpack_require__(340);
/* unused harmony reexport eventListeners */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flip_js__ = __webpack_require__(644);
/* unused harmony reexport flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hide_js__ = __webpack_require__(648);
/* unused harmony reexport hide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__offset_js__ = __webpack_require__(649);
/* unused harmony reexport offset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__popperOffsets_js__ = __webpack_require__(344);
/* unused harmony reexport popperOffsets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__preventOverflow_js__ = __webpack_require__(650);
/* unused harmony reexport preventOverflow */










/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_contains_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getMainAxisFromPlacement_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_within_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mergePaddingObject_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_expandToHashMap_js__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dom_utils_instanceOf_js__ = __webpack_require__(32);









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return Object(__WEBPACK_IMPORTED_MODULE_6__utils_mergePaddingObject_js__["a" /* default */])(typeof padding !== 'number' ? padding : Object(__WEBPACK_IMPORTED_MODULE_7__utils_expandToHashMap_js__["a" /* default */])(padding, __WEBPACK_IMPORTED_MODULE_8__enums_js__["b" /* basePlacements */]));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__["a" /* default */])(state.placement);
  var axis = Object(__WEBPACK_IMPORTED_MODULE_4__utils_getMainAxisFromPlacement_js__["a" /* default */])(basePlacement);
  var isVertical = [__WEBPACK_IMPORTED_MODULE_8__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_8__enums_js__["k" /* right */]].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__["a" /* default */])(arrowElement);
  var minProp = axis === 'y' ? __WEBPACK_IMPORTED_MODULE_8__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_8__enums_js__["f" /* left */];
  var maxProp = axis === 'y' ? __WEBPACK_IMPORTED_MODULE_8__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_8__enums_js__["k" /* right */];
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__["a" /* default */])(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = Object(__WEBPACK_IMPORTED_MODULE_5__utils_within_js__["a" /* within */])(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_contains_js__["a" /* default */])(state.elements.popper, arrowElement)) {
    if (false) {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(32);

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["c" /* isShadowRoot */])(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = within;
/* harmony export (immutable) */ __webpack_exports__["b"] = withinMaxClamp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(93);

function within(min, value, max) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* max */])(min, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["b" /* min */])(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergePaddingObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getFreshSideObject_js__ = __webpack_require__(642);

function mergePaddingObject(paddingObject) {
  return Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0__getFreshSideObject_js__["a" /* default */])(), paddingObject);
}

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFreshSideObject;
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expandToHashMap;
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_detectOverflow_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_computeAutoPlacement_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__ = __webpack_require__(148);






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["a" /* auto */]) {
    return [];
  }

  var oppositePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(placement);
  return [Object(__WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__["a" /* default */])(placement), oppositePlacement, Object(__WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__["a" /* default */])(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["a" /* auto */] ? Object(__WEBPACK_IMPORTED_MODULE_4__utils_computeAutoPlacement_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement);

    var isStartVariation = Object(__WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["l" /* start */];
    var isVertical = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = Object(__WEBPACK_IMPORTED_MODULE_3__utils_detectOverflow_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["k" /* right */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["f" /* left */] : isStartVariation ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */];

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(mainVariationSide);
    }

    var altVariationSide = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listScrollParents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getScrollParent_js__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getParentNode_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindow_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isScrollParent_js__ = __webpack_require__(343);




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = Object(__WEBPACK_IMPORTED_MODULE_0__getScrollParent_js__["a" /* default */])(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = Object(__WEBPACK_IMPORTED_MODULE_2__getWindow_js__["a" /* default */])(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], Object(__WEBPACK_IMPORTED_MODULE_3__isScrollParent_js__["a" /* default */])(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(Object(__WEBPACK_IMPORTED_MODULE_1__getParentNode_js__["a" /* default */])(target)));
}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rectToClientRect;
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeOffsets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBasePlacement_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVariation_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getMainAxisFromPlacement_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_js__ = __webpack_require__(26);




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? Object(__WEBPACK_IMPORTED_MODULE_0__getBasePlacement_js__["a" /* default */])(placement) : null;
  var variation = placement ? Object(__WEBPACK_IMPORTED_MODULE_1__getVariation_js__["a" /* default */])(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["m" /* top */]:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["c" /* bottom */]:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["k" /* right */]:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["f" /* left */]:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? Object(__WEBPACK_IMPORTED_MODULE_2__getMainAxisFromPlacement_js__["a" /* default */])(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case __WEBPACK_IMPORTED_MODULE_3__enums_js__["l" /* start */]:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__enums_js__["e" /* end */]:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__ = __webpack_require__(149);



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [__WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */]].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__["a" /* default */])(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__["a" /* default */])(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distanceAndSkiddingToXY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(26);

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__["a" /* default */])(placement);
  var invertDistance = [__WEBPACK_IMPORTED_MODULE_1__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_1__enums_js__["m" /* top */]].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [__WEBPACK_IMPORTED_MODULE_1__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_1__enums_js__["k" /* right */]].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = __WEBPACK_IMPORTED_MODULE_1__enums_js__["h" /* placements */].reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getMainAxisFromPlacement_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getAltAxis_js__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_within_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_utils_getLayoutRect_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_utils_getOffsetParent_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getVariation_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getFreshSideObject_js__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_math_js__ = __webpack_require__(93);












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = Object(__WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__["a" /* default */])(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(state.placement);
  var variation = Object(__WEBPACK_IMPORTED_MODULE_8__utils_getVariation_js__["a" /* default */])(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = Object(__WEBPACK_IMPORTED_MODULE_2__utils_getMainAxisFromPlacement_js__["a" /* default */])(basePlacement);
  var altAxis = Object(__WEBPACK_IMPORTED_MODULE_3__utils_getAltAxis_js__["a" /* default */])(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];
    var altSide = mainAxis === 'y' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["l" /* start */] ? referenceRect[len] : popperRect[len];
    var maxLen = variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["l" /* start */] ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? Object(__WEBPACK_IMPORTED_MODULE_5__dom_utils_getLayoutRect_js__["a" /* default */])(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : Object(__WEBPACK_IMPORTED_MODULE_9__utils_getFreshSideObject_js__["a" /* default */])();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && Object(__WEBPACK_IMPORTED_MODULE_6__dom_utils_getOffsetParent_js__["a" /* default */])(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(tether ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_math_js__["b" /* min */])(min, tetherMin) : min, offset, tether ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_math_js__["a" /* max */])(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];

    var _altSide = mainAxis === 'x' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [__WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */]].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["b" /* withinMaxClamp */])(_tetherMin, _offset, _tetherMax) : Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPopper */
/* unused harmony export defaultModifiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPopper_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__ = __webpack_require__(336);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */





var defaultModifiers = [__WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__["a" /* default */]];
var createPopper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__createPopper_js__["a" /* popperGenerator */])({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(773);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(774);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useTheme", function() { return useTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return withTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_core__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {
      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
    }

    return mergedTheme;
  }

  if (false) {
    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
  }

  return _objectSpread({}, outerTheme, {}, theme);
};

var createCacheWithTheme = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (outerTheme) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (theme) {
    return getTheme(outerTheme, theme);
  });
});

var ThemeProvider = function ThemeProvider(props) {
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["ThemeContext"].Consumer, null, function (theme) {
    if (props.theme !== theme) {
      theme = createCacheWithTheme(theme)(props.theme);
    }

    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["ThemeContext"].Provider, {
      value: theme
    }, props.children);
  });
};

// should we change this to be forwardRef/withCSSContext style so it doesn't merge with props?
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["ThemeContext"].Consumer, null, function (theme) {
      return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Component, Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: theme,
        ref: ref
      }, props));
    });
  }; // $FlowFixMe


  var WithTheme = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component);
}

function useTheme() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["ThemeContext"]);
}




/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MONTH_YEAR = exports.LONG_DATE = exports.MEDIUM_DATE = exports.SHORT_DATE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _moment = __webpack_require__(235);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SHORT_DATE = exports.SHORT_DATE = 'M/D/YY';
var MEDIUM_DATE = exports.MEDIUM_DATE = 'MMM D, YYYY';
var LONG_DATE = exports.LONG_DATE = 'MMMM D, YYYY';
var MONTH_YEAR = exports.MONTH_YEAR = 'MMMM YYYY';

var DateDisplay = (_temp = _class = function (_Component) {
  _inherits(DateDisplay, _Component);

  function DateDisplay() {
    _classCallCheck(this, DateDisplay);

    return _possibleConstructorReturn(this, (DateDisplay.__proto__ || Object.getPrototypeOf(DateDisplay)).apply(this, arguments));
  }

  _createClass(DateDisplay, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          date = _props.date,
          format = _props.format;

      return date !== nextProps.date || format !== nextProps.format;
    }
  }, {
    key: 'formatDate',
    value: function formatDate() {
      var _props2 = this.props,
          date = _props2.date,
          format = _props2.format;

      var parsedDate = (0, _moment2.default)(date);

      if (!parsedDate) {
        return null;
      }

      return parsedDate.format(format);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        this.formatDate()
      );
    }
  }]);

  return DateDisplay;
}(_react.Component), _class.propTypes = {
  date: _propTypes2.default.string,
  format: _propTypes2.default.string
}, _class.defaultProps = {
  format: MEDIUM_DATE
}, _temp);
exports.default = DateDisplay;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(706);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 671 */,
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(898),
    baseMatchesProperty = __webpack_require__(901),
    identity = __webpack_require__(95),
    isArray = __webpack_require__(17),
    property = __webpack_require__(904);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 673 */,
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabPanel = (_temp = _class = function (_PureComponent) {
  _inherits(TabPanel, _PureComponent);

  function TabPanel(props) {
    _classCallCheck(this, TabPanel);

    var _this = _possibleConstructorReturn(this, (TabPanel.__proto__ || Object.getPrototypeOf(TabPanel)).call(this, props));

    _this.triggerActivate = _this.triggerActivate.bind(_this);
    return _this;
  }

  _createClass(TabPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(this.triggerActivate);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.triggerActivate(prevProps);
    }
  }, {
    key: 'triggerActivate',
    value: function triggerActivate() {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.hasActivated(prevProps) && this.props.onActivate) {
        this.props.onActivate();
      }
    }
  }, {
    key: 'hasActivated',
    value: function hasActivated(prevProps) {
      return this.props.isActive && this.props.isActive !== prevProps.isActive;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isActive = _props.isActive,
          onlyRenderOnActive = _props.onlyRenderOnActive;

      var classes = (0, _classnames2.default)({
        'is-hidden': !isActive
      });

      if (!isActive && onlyRenderOnActive) {
        return null;
      }

      return _react2.default.createElement(
        'article',
        { className: classes },
        children
      );
    }
  }]);

  return TabPanel;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes2.default.node.isRequired,
  href: _propTypes2.default.string,
  isActive: _propTypes2.default.bool,
  onActivate: _propTypes2.default.func,
  onlyRenderOnActive: _propTypes2.default.bool.isRequired,
  title: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  onlyRenderOnActive: false
}, _temp);
exports.default = TabPanel;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = __webpack_require__(88);

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginatorPage = (_temp = _class = function (_PureComponent) {
  _inherits(PaginatorPage, _PureComponent);

  function PaginatorPage(props) {
    _classCallCheck(this, PaginatorPage);

    var _this = _possibleConstructorReturn(this, (PaginatorPage.__proto__ || Object.getPrototypeOf(PaginatorPage)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(PaginatorPage, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.props.onClick(e);
    }
  }, {
    key: 'renderPageNumber',
    value: function renderPageNumber() {
      var _props = this.props,
          selected = _props.selected,
          page = _props.page;


      if (selected) {
        return page;
      } else {
        return _react2.default.createElement(
          'a',
          { onClick: this.handleClick },
          page
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var selected = this.props.selected;

      var classes = (0, _classnames2.default)('page', {
        current: selected
      });

      return _react2.default.createElement(
        'span',
        { 'data-qv-pagination': classes },
        this.renderPageNumber()
      );
    }
  }]);

  return PaginatorPage;
}(_react.PureComponent), _class.propTypes = {
  onClick: _propTypes2.default.func,
  page: _propTypes2.default.number.isRequired,
  selected: _propTypes2.default.bool.isRequired
}, _class.defaultProps = {
  onClick: _noop2.default
}, _temp);
exports.default = PaginatorPage;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginatorPageGap = function (_Component) {
  _inherits(PaginatorPageGap, _Component);

  function PaginatorPageGap() {
    _classCallCheck(this, PaginatorPageGap);

    return _possibleConstructorReturn(this, (PaginatorPageGap.__proto__ || Object.getPrototypeOf(PaginatorPageGap)).apply(this, arguments));
  }

  _createClass(PaginatorPageGap, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "span",
        { "data-qv-pagination": "page gap" },
        "..."
      );
    }
  }]);

  return PaginatorPageGap;
}(_react.Component);

exports.default = PaginatorPageGap;

/***/ }),
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayTile = (_temp = _class = function (_Component) {
  _inherits(OverlayTile, _Component);

  function OverlayTile() {
    _classCallCheck(this, OverlayTile);

    return _possibleConstructorReturn(this, (OverlayTile.__proto__ || Object.getPrototypeOf(OverlayTile)).apply(this, arguments));
  }

  _createClass(OverlayTile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          count = _props.count,
          style = _props.style;

      var classes = (0, _classnames2.default)('overlay-tile', className);

      return _react2.default.createElement(
        'div',
        { className: classes, style: style },
        count != null && _react2.default.createElement(
          'div',
          { className: 'object-count right' },
          count
        ),
        children
      );
    }
  }]);

  return OverlayTile;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  count: _propTypes2.default.number,
  style: _propTypes2.default.object
}, _temp);
exports.default = OverlayTile;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayTileHeading = (_temp = _class = function (_PureComponent) {
  _inherits(OverlayTileHeading, _PureComponent);

  function OverlayTileHeading() {
    _classCallCheck(this, OverlayTileHeading);

    return _possibleConstructorReturn(this, (OverlayTileHeading.__proto__ || Object.getPrototypeOf(OverlayTileHeading)).apply(this, arguments));
  }

  _createClass(OverlayTileHeading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          title = _props.title;


      return _react2.default.createElement(
        'div',
        { className: 'editor-section-title' },
        icon && _react2.default.createElement(_Icon2.default, { name: this.props.icon }),
        I18n.t(title)
      );
    }
  }]);

  return OverlayTileHeading;
}(_react.PureComponent), _class.propTypes = {
  icon: _propTypes2.default.string,
  title: _propTypes2.default.string
}, _temp);
exports.default = OverlayTileHeading;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _TabItem = __webpack_require__(908);

var _TabItem2 = _interopRequireDefault(_TabItem);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabList = (_temp = _class = function (_Component) {
  _inherits(TabList, _Component);

  function TabList(props) {
    _classCallCheck(this, TabList);

    var _this = _possibleConstructorReturn(this, (TabList.__proto__ || Object.getPrototypeOf(TabList)).call(this, props));

    _this.state = {
      tabActive: _this.props.tabActive
    };
    return _this;
  }

  _createClass(TabList, [{
    key: 'isActive',
    value: function isActive(child, tabNumber) {
      var location = this.props.location;
      var href = child.props.href;


      if (location && href) {
        return href === location.pathname;
      }

      return this.state.tabActive === tabNumber;
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          location = _props.location;

      var items = this.getChildren();

      if (process.NODE_ENV !== 'production') {
        if (!children) {
          throw new Error('TabList must contain at least one TabPanel');
        }

        if (items.some(function (item) {
          return item.href;
        }) && !location) {
          throw new Error('TabList must include location to use with routing');
        }
      }

      return items.map(function (child, index) {
        return _react2.default.createElement(_TabItem2.default, {
          key: index,
          onSelect: function onSelect() {
            return !child.href && _this2.changeTab(index + 1);
          },
          isSelected: _this2.isActive(child, index + 1),
          title: child.props.title,
          href: child.props.href
        });
      });
    }
  }, {
    key: 'changeTab',
    value: function changeTab(activeTab) {
      this.setState({ tabActive: activeTab });
    }
  }, {
    key: 'renderPanels',
    value: function renderPanels() {
      var _this3 = this;

      var index = 0;
      return _react.Children.map(this.getChildren(), function (child) {
        index += 1;
        return (0, _react.cloneElement)(child, {
          isActive: _this3.isActive(child, index)
        });
      });
    }
  }, {
    key: 'getChildren',
    value: function getChildren() {
      if (Array.isArray(this.props.children)) {
        return this.props.children.filter(function (item) {
          return item;
        });
      } else {
        return [this.props.children];
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'nav',
          { className: 'qv-tabs' },
          this.renderTabs()
        ),
        this.renderPanels()
      );
    }
  }]);

  return TabList;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]).isRequired,
  location: _propTypes2.default.object,
  tabActive: _propTypes2.default.number
}, _class.defaultProps = {
  tabActive: 1
}, _temp);
exports.default = TabList;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 685 */,
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(708),
    isObject = __webpack_require__(9),
    isSymbol = __webpack_require__(219);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 687 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

/***/ }),
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(710),
    createBaseEach = __webpack_require__(892);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(217),
    isFlattenable = __webpack_require__(837);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Button = __webpack_require__(81);

var _Button2 = _interopRequireDefault(_Button);

var _overridden = __webpack_require__(794);

var _overridden2 = _interopRequireDefault(_overridden);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SaveButton = (_temp = _class = function (_Component) {
  _inherits(SaveButton, _Component);

  function SaveButton() {
    _classCallCheck(this, SaveButton);

    return _possibleConstructorReturn(this, (SaveButton.__proto__ || Object.getPrototypeOf(SaveButton)).apply(this, arguments));
  }

  _createClass(SaveButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          role = _props.role,
          attrs = _objectWithoutProperties(_props, ['children', 'role']);

      return _react2.default.createElement(
        _Button2.default,
        Object.assign({ role: 'primary' }, attrs),
        children || I18n.t('Save')
      );
    }
  }]);

  return SaveButton;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func.isRequired,
  role: _overridden2.default
}, _temp);
exports.default = SaveButton;

/***/ }),
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53),
    arrayMap = __webpack_require__(257),
    isArray = __webpack_require__(17),
    isSymbol = __webpack_require__(219);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(686);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(709);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 709 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(238),
    keys = __webpack_require__(100);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _noop = __webpack_require__(88);

var _noop2 = _interopRequireDefault(_noop);

var _shallowEqual = __webpack_require__(620);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _defaults = __webpack_require__(985);

var _defaults2 = _interopRequireDefault(_defaults);

var _forEach = __webpack_require__(857);

var _forEach2 = _interopRequireDefault(_forEach);

var _isFunction = __webpack_require__(83);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Video = (_temp = _class = function (_Component) {
  _inherits(Video, _Component);

  function Video(props) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));

    _this.updatePlugin = _this.updatePlugin.bind(_this);
    return _this;
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          onReady = _props.onReady,
          listeners = _props.listeners;


      this.player = window.videojs(this.videoEl, this.getOptions());
      this.player.ready(onReady);

      this.videoEl.addEventListener('contextmenu', function (e) {
        e.preventDefault();
      }, false);

      (0, _forEach2.default)(listeners, function (fn, name) {
        return _this2.player.on(name, fn);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var plugins = nextProps.plugins,
          src = nextProps.src,
          options = nextProps.options,
          listeners = nextProps.listeners;


      if (plugins) {
        (0, _forEach2.default)(plugins, this.updatePlugin);
      }
      if (src && !(0, _shallowEqual2.default)(src, this.props.src)) {
        this.updateSrc(src);
      }
      if (options && !(0, _shallowEqual2.default)(options, this.props.options)) {
        this.updateOptions(options);
      }
      if (listeners && !(0, _shallowEqual2.default)(listeners, this.props.listeners)) {
        this.updateListeners(listeners);
      }
      if (options && options.autoplay != null) {
        this.player.autoplay(options.autoplay);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.player.off();
      this.player.pause();

      try {
        this.player.dispose();
      } catch (e) {
        if (false) {
          console.log('player disposed with error ' + e);
        }
      }
    }
  }, {
    key: 'getValue',
    value: function getValue(name) {
      var value = this.player[name];
      return (0, _isFunction2.default)(value) ? value.call(this.player) : value;
    }
  }, {
    key: 'currentTime',
    value: function currentTime(seconds) {
      return this.player.currentTime(seconds);
    }
  }, {
    key: 'play',
    value: function play() {
      this.player.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.player.pause();
    }
  }, {
    key: 'updatePlugin',
    value: function updatePlugin(options, name) {
      if (!(0, _shallowEqual2.default)(this.props.plugins[name], options)) {
        this.player[name](options);
      }
    }
  }, {
    key: 'updateSrc',
    value: function updateSrc(src) {
      this.player.quality(src);
    }
  }, {
    key: 'updateOptions',
    value: function updateOptions(options) {
      this.player.options(options);
    }
  }, {
    key: 'updateListeners',
    value: function updateListeners(listeners) {
      var _this3 = this;

      (0, _forEach2.default)(listeners, function (fn, name) {
        if (_this3.props.listeners != null && _this3.props.listeners[name] !== fn) {
          if (_this3.props.listeners != null && _this3.props.listeners[name]) {
            _this3.player.off(name, _this3.props.listeners[name]);
          }
          _this3.player.on(name, fn);
        }
      });
    }
  }, {
    key: 'getControls',
    value: function getControls() {
      var controlBar = this.props.controlBar;


      if (!controlBar) {
        return {};
      }

      return {
        controlBar: {
          children: controlBar
        }
      };
    }
  }, {
    key: 'getPlugins',
    value: function getPlugins() {
      return Object.assign({}, this.props.plugins, {
        quality: this.props.src
      });
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      return (0, _defaults2.default)({}, this.props.options, {
        controls: true,
        preload: 'metadata',
        plugins: this.getPlugins()
      }, this.getControls());
    }
  }, {
    key: 'getVideoRestrictedMessage',
    value: function getVideoRestrictedMessage() {
      return _react2.default.createElement(
        'div',
        { className: 'vjs-qualvu-skin vjs-video-restricted-overlay' },
        _react2.default.createElement(
          'div',
          { className: 'vjs-qualvu-skin vjs-video-restricted-overlay-title' },
          _react2.default.createElement('div', { className: 'vjs-qualvu-skin vjs-video-restricted-icon' }),
          _react2.default.createElement(
            'h3',
            null,
            'Video disabled'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Due to security regulations this video has been disabled.',
          _react2.default.createElement('br', null),
          'Only the audio track is currently available.'
        )
      );
    }
  }, {
    key: 'addClosedCaption',
    value: function addClosedCaption() {
      if (this.props.captionSource) {
        return _react2.default.createElement('track', {
          'default': true,
          kind: 'captions',
          label: 'English',
          src: this.props.captionSource,
          srcLang: 'en'
        });
      }
    }
  }, {
    key: 'audioMode',
    value: function audioMode() {
      return (/\.mp3($|\?)/.test(this.props.src.sd)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          alwaysShowControls = _props2.alwaysShowControls,
          height = _props2.height,
          width = _props2.width;

      var classes = (0, _classnames2.default)('video-js', 'vjs-qualvu-skin', {
        'vjs-controls-always': alwaysShowControls,
        'vjs-video-restricted': this.audioMode()
      });

      return _react2.default.createElement(
        'div',
        { style: { height: height, position: 'relative' } },
        _react2.default.createElement(
          'video',
          {
            ref: function ref(_ref) {
              return _this4.videoEl = _ref;
            },
            className: classes,
            width: width,
            height: height,
            crossOrigin: 'anonymous'
          },
          _react2.default.createElement('source', { type: this.audioMode() ? 'audio/mp3' : 'video/mp4' }),
          this.addClosedCaption()
        ),
        this.audioMode() && this.getVideoRestrictedMessage()
      );
    }
  }]);

  return Video;
}(_react.Component), _class.propTypes = {
  alwaysShowControls: _propTypes2.default.bool,
  captionSource: _propTypes2.default.string,
  controlBar: _propTypes2.default.object,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  listeners: _propTypes2.default.object,
  onReady: _propTypes2.default.func,
  options: _propTypes2.default.object,
  plugins: _propTypes2.default.object,
  src: _propTypes2.default.shape({
    hd: _propTypes2.default.string,
    sd: _propTypes2.default.string
  }).isRequired,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _class.defaultProps = {
  alwaysShowControls: false,
  onReady: _noop2.default
}, _temp);
exports.default = Video;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = searchTokenize;

var _getDisplayName = __webpack_require__(688);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _shallowEqual = __webpack_require__(620);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _selectSearchHighlights = __webpack_require__(713);

var _selectSearchHighlights2 = _interopRequireDefault(_selectSearchHighlights);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function searchTokenize(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    _inherits(SearchTokenize, _React$Component);

    function SearchTokenize() {
      _classCallCheck(this, SearchTokenize);

      return _possibleConstructorReturn(this, (SearchTokenize.__proto__ || Object.getPrototypeOf(SearchTokenize)).apply(this, arguments));
    }

    _createClass(SearchTokenize, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return !(0, _shallowEqual2.default)(this.props, nextProps);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            _props$searchHighligh = _props.searchHighlights,
            searchHighlights = _props$searchHighligh === undefined ? [] : _props$searchHighligh,
            searchHighlightField = _props.searchHighlightField,
            props = _objectWithoutProperties(_props, ['searchHighlights', 'searchHighlightField']);

        searchHighlights = (0, _selectSearchHighlights2.default)(searchHighlights, searchHighlightField);

        var tokens = searchHighlights.reduce(function (memo, highlight) {
          return memo.concat(highlight.tokens);
        }, []);

        return _react2.default.createElement(Component, Object.assign({ tokens: tokens }, props));
      }
    }]);

    return SearchTokenize;
  }(_react2.default.Component), _class.displayName = 'SearchTokenize(' + (0, _getDisplayName2.default)(Component) + ')', _class.propTypes = {
    searchHighlightField: _propTypes2.default.string,
    searchHighlights: _propTypes2.default.array
  }, _temp;
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = selectSearchHighlights;

var _humps = __webpack_require__(22);

function selectSearchHighlights(highlights, field) {
  if (!highlights) {
    return [];
  }

  if (!field) {
    return highlights;
  }

  return highlights.filter(function (highlight) {
    return (0, _humps.camelize)(highlight.fieldName || '') === field;
  });
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 715 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(627);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (factory());
}(this, (function () { 'use strict';

  /**
   * Applies the :focus-visible polyfill at the given scope.
   * A scope in this case is either the top-level Document or a Shadow Root.
   *
   * @param {(Document|ShadowRoot)} scope
   * @see https://github.com/WICG/focus-visible
   */
  function applyFocusVisiblePolyfill(scope) {
    var hadKeyboardEvent = true;
    var hadFocusVisibleRecently = false;
    var hadFocusVisibleRecentlyTimeout = null;

    var inputTypesAllowlist = {
      text: true,
      search: true,
      url: true,
      tel: true,
      email: true,
      password: true,
      number: true,
      date: true,
      month: true,
      week: true,
      time: true,
      datetime: true,
      'datetime-local': true
    };

    /**
     * Helper function for legacy browsers and iframes which sometimes focus
     * elements like document, body, and non-interactive SVG.
     * @param {Element} el
     */
    function isValidFocusTarget(el) {
      if (
        el &&
        el !== document &&
        el.nodeName !== 'HTML' &&
        el.nodeName !== 'BODY' &&
        'classList' in el &&
        'contains' in el.classList
      ) {
        return true;
      }
      return false;
    }

    /**
     * Computes whether the given element should automatically trigger the
     * `focus-visible` class being added, i.e. whether it should always match
     * `:focus-visible` when focused.
     * @param {Element} el
     * @return {boolean}
     */
    function focusTriggersKeyboardModality(el) {
      var type = el.type;
      var tagName = el.tagName;

      if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
        return true;
      }

      if (tagName === 'TEXTAREA' && !el.readOnly) {
        return true;
      }

      if (el.isContentEditable) {
        return true;
      }

      return false;
    }

    /**
     * Add the `focus-visible` class to the given element if it was not added by
     * the author.
     * @param {Element} el
     */
    function addFocusVisibleClass(el) {
      if (el.classList.contains('focus-visible')) {
        return;
      }
      el.classList.add('focus-visible');
      el.setAttribute('data-focus-visible-added', '');
    }

    /**
     * Remove the `focus-visible` class from the given element if it was not
     * originally added by the author.
     * @param {Element} el
     */
    function removeFocusVisibleClass(el) {
      if (!el.hasAttribute('data-focus-visible-added')) {
        return;
      }
      el.classList.remove('focus-visible');
      el.removeAttribute('data-focus-visible-added');
    }

    /**
     * If the most recent user interaction was via the keyboard;
     * and the key press did not include a meta, alt/option, or control key;
     * then the modality is keyboard. Otherwise, the modality is not keyboard.
     * Apply `focus-visible` to any current active element and keep track
     * of our keyboard modality state with `hadKeyboardEvent`.
     * @param {KeyboardEvent} e
     */
    function onKeyDown(e) {
      if (e.metaKey || e.altKey || e.ctrlKey) {
        return;
      }

      if (isValidFocusTarget(scope.activeElement)) {
        addFocusVisibleClass(scope.activeElement);
      }

      hadKeyboardEvent = true;
    }

    /**
     * If at any point a user clicks with a pointing device, ensure that we change
     * the modality away from keyboard.
     * This avoids the situation where a user presses a key on an already focused
     * element, and then clicks on a different element, focusing it with a
     * pointing device, while we still think we're in keyboard modality.
     * @param {Event} e
     */
    function onPointerDown(e) {
      hadKeyboardEvent = false;
    }

    /**
     * On `focus`, add the `focus-visible` class to the target if:
     * - the target received focus as a result of keyboard navigation, or
     * - the event target is an element that will likely require interaction
     *   via the keyboard (e.g. a text box)
     * @param {Event} e
     */
    function onFocus(e) {
      // Prevent IE from focusing the document or HTML element.
      if (!isValidFocusTarget(e.target)) {
        return;
      }

      if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
        addFocusVisibleClass(e.target);
      }
    }

    /**
     * On `blur`, remove the `focus-visible` class from the target.
     * @param {Event} e
     */
    function onBlur(e) {
      if (!isValidFocusTarget(e.target)) {
        return;
      }

      if (
        e.target.classList.contains('focus-visible') ||
        e.target.hasAttribute('data-focus-visible-added')
      ) {
        // To detect a tab/window switch, we look for a blur event followed
        // rapidly by a visibility change.
        // If we don't see a visibility change within 100ms, it's probably a
        // regular focus change.
        hadFocusVisibleRecently = true;
        window.clearTimeout(hadFocusVisibleRecentlyTimeout);
        hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
          hadFocusVisibleRecently = false;
        }, 100);
        removeFocusVisibleClass(e.target);
      }
    }

    /**
     * If the user changes tabs, keep track of whether or not the previously
     * focused element had .focus-visible.
     * @param {Event} e
     */
    function onVisibilityChange(e) {
      if (document.visibilityState === 'hidden') {
        // If the tab becomes active again, the browser will handle calling focus
        // on the element (Safari actually calls it twice).
        // If this tab change caused a blur on an element with focus-visible,
        // re-apply the class when the user switches back to the tab.
        if (hadFocusVisibleRecently) {
          hadKeyboardEvent = true;
        }
        addInitialPointerMoveListeners();
      }
    }

    /**
     * Add a group of listeners to detect usage of any pointing devices.
     * These listeners will be added when the polyfill first loads, and anytime
     * the window is blurred, so that they are active when the window regains
     * focus.
     */
    function addInitialPointerMoveListeners() {
      document.addEventListener('mousemove', onInitialPointerMove);
      document.addEventListener('mousedown', onInitialPointerMove);
      document.addEventListener('mouseup', onInitialPointerMove);
      document.addEventListener('pointermove', onInitialPointerMove);
      document.addEventListener('pointerdown', onInitialPointerMove);
      document.addEventListener('pointerup', onInitialPointerMove);
      document.addEventListener('touchmove', onInitialPointerMove);
      document.addEventListener('touchstart', onInitialPointerMove);
      document.addEventListener('touchend', onInitialPointerMove);
    }

    function removeInitialPointerMoveListeners() {
      document.removeEventListener('mousemove', onInitialPointerMove);
      document.removeEventListener('mousedown', onInitialPointerMove);
      document.removeEventListener('mouseup', onInitialPointerMove);
      document.removeEventListener('pointermove', onInitialPointerMove);
      document.removeEventListener('pointerdown', onInitialPointerMove);
      document.removeEventListener('pointerup', onInitialPointerMove);
      document.removeEventListener('touchmove', onInitialPointerMove);
      document.removeEventListener('touchstart', onInitialPointerMove);
      document.removeEventListener('touchend', onInitialPointerMove);
    }

    /**
     * When the polfyill first loads, assume the user is in keyboard modality.
     * If any event is received from a pointing device (e.g. mouse, pointer,
     * touch), turn off keyboard modality.
     * This accounts for situations where focus enters the page from the URL bar.
     * @param {Event} e
     */
    function onInitialPointerMove(e) {
      // Work around a Safari quirk that fires a mousemove on <html> whenever the
      // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
      if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
        return;
      }

      hadKeyboardEvent = false;
      removeInitialPointerMoveListeners();
    }

    // For some kinds of state, we are interested in changes at the global scope
    // only. For example, global pointer input, global key presses and global
    // visibility change should affect the state at every scope:
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('mousedown', onPointerDown, true);
    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('touchstart', onPointerDown, true);
    document.addEventListener('visibilitychange', onVisibilityChange, true);

    addInitialPointerMoveListeners();

    // For focus and blur, we specifically care about state changes in the local
    // scope. This is because focus / blur events that originate from within a
    // shadow root are not re-dispatched from the host element if it was already
    // the active element in its own scope:
    scope.addEventListener('focus', onFocus, true);
    scope.addEventListener('blur', onBlur, true);

    // We detect that a node is a ShadowRoot by ensuring that it is a
    // DocumentFragment and also has a host property. This check covers native
    // implementation and polyfill implementation transparently. If we only cared
    // about the native implementation, we could just check if the scope was
    // an instance of a ShadowRoot.
    if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
      // Since a ShadowRoot is a special kind of DocumentFragment, it does not
      // have a root element to add a class to. So, we add this attribute to the
      // host element instead:
      scope.host.setAttribute('data-js-focus-visible', '');
    } else if (scope.nodeType === Node.DOCUMENT_NODE) {
      document.documentElement.classList.add('js-focus-visible');
      document.documentElement.setAttribute('data-js-focus-visible', '');
    }
  }

  // It is important to wrap all references to global window and document in
  // these checks to support server-side rendering use cases
  // @see https://github.com/WICG/focus-visible/issues/199
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // Make the polyfill helper globally available. This can be used as a signal
    // to interested libraries that wish to coordinate with the polyfill for e.g.,
    // applying the polyfill to a shadow root:
    window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

    // Notify interested libraries of the polyfill's presence, in case the
    // polyfill was loaded lazily:
    var event;

    try {
      event = new CustomEvent('focus-visible-polyfill-ready');
    } catch (error) {
      // IE11 does not support using CustomEvent as a constructor directly:
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
    }

    window.dispatchEvent(event);
  }

  if (typeof document !== 'undefined') {
    // Apply the polyfill to the global document, so that no JavaScript
    // coordination is required to use the polyfill in the top-level document:
    applyFocusVisiblePolyfill(document);
  }

})));


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adjustHue", function() { return curriedAdjustHue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animation", function() { return animation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgroundImages", function() { return backgroundImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backgrounds", function() { return backgrounds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderColor", function() { return borderColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderRadius", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderStyle", function() { return borderStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "borderWidth", function() { return borderWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buttons", function() { return buttons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearFix", function() { return clearFix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "complement", function() { return complement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darken", function() { return curriedDarken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "desaturate", function() { return curriedDesaturate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "directionalProperty", function() { return directionalProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ellipsis", function() { return ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "em", function() { return em; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fontFace", function() { return fontFace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLuminance", function() { return getLuminance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grayscale", function() { return grayscale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return invert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideText", function() { return hideText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideVisually", function() { return hideVisually; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hiDPI", function() { return hiDPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hsl", function() { return hsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hsla", function() { return hsla; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lighten", function() { return curriedLighten; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "margin", function() { return margin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mix", function() { return curriedMix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modularScale", function() { return modularScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalize", function() { return normalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "opacify", function() { return curriedOpacify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "padding", function() { return padding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseToHsl", function() { return parseToHsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseToRgb", function() { return parseToRgb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "placeholder", function() { return placeholder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "position", function() { return position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "radialGradient", function() { return radialGradient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readableColor", function() { return curriedReadableColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rem", function() { return rem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retinaImage", function() { return retinaImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rgb", function() { return rgb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rgba", function() { return rgba; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saturate", function() { return curriedSaturate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selection", function() { return selection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHue", function() { return curriedSetHue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLightness", function() { return curriedSetLightness; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaturation", function() { return curriedSetSaturation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shade", function() { return curriedShade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "size", function() { return size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stripUnit", function() { return stripUnit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textInputs", function() { return textInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timingFunctions", function() { return timingFunctions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tint", function() { return curriedTint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toColorString", function() { return toColorString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transitions", function() { return transitions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transparentize", function() { return curriedTransparentize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triangle", function() { return triangle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wordWrap", function() { return wordWrap; });
//      

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

//      
var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');
  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return '' + acc + capitalizeString(val);
    });
  }
  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
  return property === joinedProperty ? '' + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};
  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }
  return styles;
}

/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function directionalProperty(property) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === undefined ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === undefined ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === undefined ? secondValue : _values$3;

  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

//      

function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

//      

/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

//      

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */
var pxtoFactory = function pxtoFactory(to) {
  return function (pxval) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';

    var newPxval = pxval;
    var newBase = base;
    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
      }
      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
      }
      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    if (typeof newBase === 'string') {
      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    return '' + newPxval / newBase + to;
  };
};

//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/pxtoFactory('em');

//      

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4

  /** */

  /**
   * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables, see below.
   * @example
   * // Styles as object usage
   * const styles = {
   *    // Increment two steps up the default scale
   *   'fontSize': modularScale(2)
   * }
   *
   * // styled-components usage
   * const div = styled.div`
   *    // Increment two steps up the default scale
   *   fontSize: ${modularScale(2)}
   * `
   *
   * // CSS in JS Output
   *
   * element {
   *   'fontSize': '1.77689em'
   * }
   */
};function modularScale(steps) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }
  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? ratioNames[ratio] : ratio;

  if (typeof realBase === 'string') {
    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
  }

  return realBase * Math.pow(realRatio, steps) + 'em';
}

//      

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem = /*#__PURE__*/pxtoFactory('rem');

//      

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */

function clearFix() {
  var _ref;

  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';

  var pseudoSelector = parent + '::after';
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

//      

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */

function ellipsis() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

//      

/** */

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return 'url("' + fontFilePath + '.' + format + '")';
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return 'local("' + font + '")';
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }
  return fontReferences.join(', ');
}

/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */

function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange;

  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }
  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }
  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight
    }

    // Removes undefined fields for cleaner css object.
  };return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

//      

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */

function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

//      

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */

function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

//      

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */

function hiDPI() {
  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



























var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var _opinionatedRules;
var _abbrTitle;
var _unopinionatedRules;

//      
var opinionatedRules = (_opinionatedRules = {
  html: {
    fontFamily: 'sans-serif'
  },

  body: {
    margin: '0'
  }

}, _opinionatedRules['a:active,\n  a:hover'] = {
  outlineWidth: '0'
}, _opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  fontFamily: 'sans-serif',
  fontSize: '100%',
  lineHeight: '1.15'
}, _opinionatedRules);

var unopinionatedRules = (_unopinionatedRules = {
  html: {
    lineHeight: '1.15',
    textSizeAdjust: '100%'
  }

}, _unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
  display: 'block'
}, _unopinionatedRules.h1 = {
  fontSize: '2em',
  margin: '0.67em 0'
}, _unopinionatedRules['figcaption,\n  figure,\n  main'] = {
  display: 'block'
}, _unopinionatedRules.figure = {
  margin: '1em 40px'
}, _unopinionatedRules.hr = {
  boxSizing: 'content-box',
  height: '0',
  overflow: 'visible'
}, _unopinionatedRules.pre = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.a = {
  'background-color': 'transparent',
  '-webkit-text-decoration-skip': 'objects'
}, _unopinionatedRules['abbr[title]'] = (_abbrTitle = {
  borderBottom: 'none',
  textDecoration: 'underline'
}, _abbrTitle['textDecoration'] = 'underline dotted', _abbrTitle), _unopinionatedRules['b,\n  strong'] = {
  fontWeight: 'inherit'
}, _unopinionatedRules['code,\n  kbd,\n  samp'] = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.dfn = {
  fontStyle: 'italic'
}, _unopinionatedRules.mark = {
  backgroundColor: '#ff0',
  color: '#000'
}, _unopinionatedRules.small = {
  fontSize: '80%'
}, _unopinionatedRules['sub,\n  sup'] = {
  fontSize: '75%',
  lineHeight: '0',
  position: 'relative',
  verticalAlign: 'baseline'
}, _unopinionatedRules.sub = {
  bottom: '-0.25em'
}, _unopinionatedRules.sup = {
  top: '-0.5em'
}, _unopinionatedRules['audio,\n  video'] = {
  display: 'inline-block'
}, _unopinionatedRules['audio:not([controls])'] = {
  display: 'none',
  height: '0'
}, _unopinionatedRules.img = {
  borderStyle: 'none'
}, _unopinionatedRules['svg:not(:root)'] = {
  overflow: 'hidden'
}, _unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  margin: '0'
}, _unopinionatedRules['button,\n  input'] = {
  overflow: 'visible'
}, _unopinionatedRules['button,\n  select'] = {
  textTransform: 'none'
}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
  '-webkit-appearance': 'button'
}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
  borderStyle: 'none',
  padding: '0'
}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
  outline: '1px dotted ButtonText'
}, _unopinionatedRules.fieldset = {
  border: '1px solid #c0c0c0',
  margin: '0 2px',
  padding: '0.35em 0.625em 0.75em'
}, _unopinionatedRules.legend = {
  boxSizing: 'border-box',
  color: 'inherit',
  display: 'table',
  maxWidth: '100%',
  padding: '0',
  whiteSpace: 'normal'
}, _unopinionatedRules.progress = {
  display: 'inline-block',
  verticalAlign: 'baseline'
}, _unopinionatedRules.textarea = {
  overflow: 'auto'
}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
  boxSizing: 'border-box',
  padding: '0'
}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
  height: 'auto'
}, _unopinionatedRules['[type="search"]'] = {
  '-webkit-appearance': 'textfield',
  outlineOffset: '-2px'
}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
  '-webkit-appearance': 'none'
}, _unopinionatedRules['::-webkit-file-upload-button'] = {
  '-webkit-appearance': 'button',
  font: 'inherit'
}, _unopinionatedRules['details,\n  menu'] = {
  display: 'block'
}, _unopinionatedRules.summary = {
  display: 'list-item'
}, _unopinionatedRules.canvas = {
  display: 'inline-block'
}, _unopinionatedRules.template = {
  display: 'none'
}, _unopinionatedRules['[hidden]'] = {
  display: 'none'
}, _unopinionatedRules);

function mergeRules(baseRules, additionalRules) {
  var mergedRules = _extends({}, baseRules);
  Object.keys(additionalRules).forEach(function (key) {
    if (mergedRules[key]) {
      mergedRules[key] = _extends({}, mergedRules[key], additionalRules[key]);
    } else {
      mergedRules[key] = _extends({}, additionalRules[key]);
    }
  });
  return mergedRules;
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize(excludeOpinionated) {
  if (excludeOpinionated) return unopinionatedRules;
  return mergeRules(unopinionatedRules, opinionatedRules);
}

//      

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */

function placeholder(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';

  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
}

var _templateObject = /*#__PURE__*/ taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);

//      

/** */

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';
  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];
    // Adds leading coma if properties preceed color-stops
    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // Only adds substitution if it is defined
    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
  }
  return template.trim();
}

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */

function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }
  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
  };
}

//      

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize) {
  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';

  var _ref;

  var retinaFilename = arguments[3];
  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  }
  // Replace the dot at the beginning of the passed extension if one exists
  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;

  return _ref = {
    backgroundImage: 'url(' + filename + '.' + ext + ')'
  }, _ref[hiDPI()] = {
    backgroundImage: 'url(' + rFilename + ')',
    backgroundSize: backgroundSize
  }, _ref;
}

//      

/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */

function selection(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
}

//      

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',

  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',

  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

  /** */

  /**
   * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
   *
   * @example
   * // Styles as object usage
   * const styles = {
   *   'transitionTimingFunction': timingFunctions('easeInQuad')
   * }
   *
   * // styled-components usage
   *  const div = styled.div`
   *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
   * `
   *
   * // CSS as JS Output
   *
   * 'div': {
   *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
   * }
   */

};function timingFunctions(timingFunction) {
  return functionsMap[timingFunction];
}

//      

/** */

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
    case 'left':
      return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
    case 'bottom':
      return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
    case 'right':
      return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
  }
};

// needed for border-color
var reverseDirection = {
  left: 'Right',
  right: 'Left',
  top: 'Bottom',
  bottom: 'Top'

  /**
   * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
   *
   * @example
   * // Styles as object usage
   *
   * const styles = {
   *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
   * }
   *
   *
   * // styled-components usage
   * const div = styled.div`
   *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
   *
   *
   * // CSS as JS Output
   *
   * div: {
   *  'borderColor': 'transparent',
   *  'borderLeftColor': 'red !important',
   *  'borderStyle': 'solid',
   *  'borderWidth': '50px 0 50px 100px',
   *  'height': '0',
   *  'width': '0',
   * }
   */

};function triangle(_ref) {
  var _ref2;

  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;

  var unitlessHeight = parseFloat(height);
  var unitlessWidth = parseFloat(width);
  if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  return _ref2 = {
    borderColor: backgroundColor,
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
    borderStyle: 'solid'
  }, _ref2['border' + reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}

//      

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */

function wordWrap() {
  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

//      


function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness) {
  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));

  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

//      
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'

  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */
};function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
}

//      
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt('' + rgbMatched[1], 10),
      green: parseInt('' + rgbMatched[2], 10),
      blue: parseInt('' + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor);
  if (rgbaMatched) {
    return {
      red: parseInt('' + rgbaMatched[1], 10),
      green: parseInt('' + rgbaMatched[2], 10),
      blue: parseInt('' + rgbaMatched[3], 10),
      alpha: parseFloat('' + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt('' + hslMatched[1], 10);
    var saturation = parseInt('' + hslMatched[2], 10) / 100;
    var lightness = parseInt('' + hslMatched[3], 10) / 100;
    var rgbColorString = 'rgb(' + hslToRgb(hue, saturation, lightness) + ')';
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
    }
    return {
      red: parseInt('' + hslRgbMatched[1], 10),
      green: parseInt('' + hslRgbMatched[2], 10),
      blue: parseInt('' + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor);
  if (hslaMatched) {
    var _hue = parseInt('' + hslaMatched[1], 10);
    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
    var _rgbColorString = 'rgb(' + hslToRgb(_hue, _saturation, _lightness) + ')';
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
    }
    return {
      red: parseInt('' + _hslRgbMatched[1], 10),
      green: parseInt('' + _hslRgbMatched[2], 10),
      blue: parseInt('' + _hslRgbMatched[3], 10),
      alpha: parseFloat('' + hslaMatched[4])
    };
  }
  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

//      


function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;

  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return { hue: 0, saturation: 0, lightness: lightness };
    }
  }

  var hue = void 0;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return { hue: hue, saturation: saturation, lightness: lightness };
}

//      

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

//      

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};

//      
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue('#' + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue('#' + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

//      
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : 'rgba(' + hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

//      
var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);

  throw new Error(errMsg);
}

//      

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js


// eslint-disable-next-line no-unused-vars


// eslint-disable-next-line no-unused-vars

// eslint-disable-next-line no-redeclare


function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

//      

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */
function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + degree) % 360
  }));
}

var curriedAdjustHue = /*#__PURE__*/curry(adjustHue);

//      

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

//      

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

//      

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */
function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - amount)
  }));
}

var curriedDarken = /*#__PURE__*/curry(darken);

//      

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */
function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - amount)
  }));
}

var curriedDesaturate = /*#__PURE__*/curry(desaturate);

//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */
function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

//      

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function grayscale(color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

//      

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */
function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

//      

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + amount)
  }));
}

var curriedLighten = /*#__PURE__*/curry(lighten);

//      

/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  var color = arguments[1];
  var otherColor = arguments[2];

  var parsedColor1 = parseToRgb(color);
  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1

    // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  });var alphaDelta = color1.alpha - color2.alpha;
  var x = weight * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;

  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
  };

  return rgba(mixedColor);
}

var curriedMix = /*#__PURE__*/curry(mix);

//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */
function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedOpacify = /*#__PURE__*/curry(opacify);

//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

var curriedReadableColor = /*#__PURE__*/curry(readableColor);

//      

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */
function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + amount)
  }));
}

var curriedSaturate = /*#__PURE__*/curry(saturate);

//      

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */
function setHue(hue, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    hue: hue
  }));
}

var curriedSetHue = /*#__PURE__*/curry(setHue);

//      

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */
function setLightness(lightness, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: lightness
  }));
}

var curriedSetLightness = /*#__PURE__*/curry(setLightness);

//      

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */
function setSaturation(saturation, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: saturation
  }));
}

var curriedSetSaturation = /*#__PURE__*/curry(setSaturation);

//      

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(0, 0, 0)');
}

var curriedShade = /*#__PURE__*/curry(shade);

//      

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(255, 255, 255)');
}

var curriedTint = /*#__PURE__*/curry(tint);

//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */
function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedTransparentize = /*#__PURE__*/curry(transparentize);

//      

/** */

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);
  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }
  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }
    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');

  return {
    animation: code
  };
}

//      

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */

function backgroundImages() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

//      

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */

function borderColor() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderColor'].concat(values));
}

//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */

function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);
  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }
  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */

function borderStyle() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderStyle'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderWidth'].concat(values));
}

//      


function generateSelectors(template, state) {
  var stateSuffix = state ? ':' + state : '';
  return template(stateSuffix);
}

/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */
function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];
  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }
    selectors.push(generateSelectors(template, states[i]));
  }
  selectors = selectors.join(',');
  return selectors;
}

//      
var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}

/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */

function buttons() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */

function margin() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['margin'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function padding() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['padding'].concat(values));
}

//      
var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];

/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(positionKeyword) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return _extends({
      position: positionKeyword
    }, directionalProperty.apply(undefined, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value
    return directionalProperty.apply(undefined, ['', firstValue].concat(values));
  }
}

//      

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */

function size(height) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;

  return {
    height: height,
    width: width
  };
}

//      
var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}

/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */

function textInputs() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

//      

/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */

function transitions() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    transition: properties.join(', ')
  };
}

//      
// Helpers
// Mixins
// Color
// Shorthands




/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(163);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["default"]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Downshift$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetIdCounter", function() { return resetIdCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useCombobox", function() { return useCombobox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useMultipleSelection", function() { return useMultipleSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useSelect", function() { return useSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_compute_scroll_into_view__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tslib__ = __webpack_require__(726);










var idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */

function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}

function noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */


function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }

  var actions = Object(__WEBPACK_IMPORTED_MODULE_7_compute_scroll_into_view__["a" /* default */])(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */


function isOrContainsNode(parent, child, environment) {
  var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
  return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */


function debounce(fn, time) {
  var timeoutId;

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }

  wrapper.cancel = cancel;
  return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */


function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}

function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */


function generateId() {
  return String(idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */


function resetIdCounter() {
  idCounter = 0;
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */


function getA11yStatusMessage$1(_ref2) {
  var isOpen = _ref2.isOpen,
      resultCount = _ref2.resultCount,
      previousResultCount = _ref2.previousResultCount;

  if (!isOpen) {
    return '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */


function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ?
  /* istanbul ignore next (preact) */
  arg[0] : arg;

  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */


function isDOMElement(element) {


  return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */


function getElementProps(element) {

  return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */


function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */

function pickState(state) {
  if (state === void 0) {
    state = {};
  }

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */


function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    prevState[key] = isControlledProp(props, key) ? props[key] : state[key];
    return prevState;
  }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */


function isControlledProp(props, key) {
  return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */


function normalizeArrowKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */


function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */


function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }

  if (itemCount === 0) {
    return -1;
  }

  var itemsLastIndex = itemCount - 1;

  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }

  var newIndex = baseIndex + moveAmount;

  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }

  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);

  if (nonDisabledNewIndex === -1) {
    return baseIndex >= itemCount ? -1 : baseIndex;
  }

  return nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */


function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);

  if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) {
    return baseIndex;
  }

  if (moveAmount > 0) {
    for (var index = baseIndex + 1; index < itemCount; index++) {
      if (!getItemNodeFromIndex(index).hasAttribute('disabled')) {
        return index;
      }
    }
  } else {
    for (var _index = baseIndex - 1; _index >= 0; _index--) {
      if (!getItemNodeFromIndex(_index).hasAttribute('disabled')) {
        return _index;
      }
    }
  }

  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }

  return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */


function targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }

  return downshiftElements.some(function (contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target, environment) || checkActiveElement && isOrContainsNode(contextNode, environment.document.activeElement, environment));
  });
} // eslint-disable-next-line import/no-mutable-exports


var validateControlledUnchanged = noop;
/* istanbul ignore next */

if (false) {
  validateControlledUnchanged = function validateControlledUnchanged(state, prevProps, nextProps) {
    var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
    Object.keys(state).forEach(function (propKey) {
      if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
      } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
        // eslint-disable-next-line no-console
        console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
      }
    });
  };
}

var cleanupStatus = debounce(function (documentProp) {
  getStatusDiv(documentProp).textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */

function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);

  if (!status) {
    return;
  }

  div.textContent = status;
  cleanupStatus(documentProp);
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */


function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }

  var statusDiv = documentProp.getElementById('a11y-status-message');

  if (statusDiv) {
    return statusDiv;
  }

  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

var unknown =  false ? '__autocomplete_unknown__' : 0;
var mouseUp =  false ? '__autocomplete_mouseup__' : 1;
var itemMouseEnter =  false ? '__autocomplete_item_mouseenter__' : 2;
var keyDownArrowUp =  false ? '__autocomplete_keydown_arrow_up__' : 3;
var keyDownArrowDown =  false ? '__autocomplete_keydown_arrow_down__' : 4;
var keyDownEscape =  false ? '__autocomplete_keydown_escape__' : 5;
var keyDownEnter =  false ? '__autocomplete_keydown_enter__' : 6;
var keyDownHome =  false ? '__autocomplete_keydown_home__' : 7;
var keyDownEnd =  false ? '__autocomplete_keydown_end__' : 8;
var clickItem =  false ? '__autocomplete_click_item__' : 9;
var blurInput =  false ? '__autocomplete_blur_input__' : 10;
var changeInput =  false ? '__autocomplete_change_input__' : 11;
var keyDownSpaceButton =  false ? '__autocomplete_keydown_space_button__' : 12;
var clickButton =  false ? '__autocomplete_click_button__' : 13;
var blurButton =  false ? '__autocomplete_blur_button__' : 14;
var controlledPropUpdatedSelectedItem =  false ? '__autocomplete_controlled_prop_updated_selected_item__' : 15;
var touchEnd =  false ? '__autocomplete_touchend__' : 16;

var stateChangeTypes$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unknown: unknown,
  mouseUp: mouseUp,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowUp: keyDownArrowUp,
  keyDownArrowDown: keyDownArrowDown,
  keyDownEscape: keyDownEscape,
  keyDownEnter: keyDownEnter,
  keyDownHome: keyDownHome,
  keyDownEnd: keyDownEnd,
  clickItem: clickItem,
  blurInput: blurInput,
  changeInput: changeInput,
  keyDownSpaceButton: keyDownSpaceButton,
  clickButton: clickButton,
  blurButton: blurButton,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  touchEnd: touchEnd
});

var _excluded$4 = ["refKey", "ref"],
    _excluded2$3 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
    _excluded3$2 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
    _excluded4$1 = ["refKey", "ref"],
    _excluded5$1 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"];

var Downshift = /*#__PURE__*/function () {
  var Downshift = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Downshift, _Component);

    function Downshift(_props) {
      var _this;

      _this = _Component.call(this, _props) || this; // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided

      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";

      _this.getItemId = _this.props.getItemId || function (index) {
        return _this.id + "-item-" + index;
      };

      _this.input = null;
      _this.items = [];
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];

      _this.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);

        _this.timeoutIds.push(id);
      };

      _this.setItemCount = function (count) {
        _this.itemCount = count;
      };

      _this.unsetItemCount = function () {
        _this.itemCount = null;
      };

      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }

        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };

      _this.clearSelection = function (cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };

      _this.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };

      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];

        if (item == null) {
          return;
        }

        _this.selectItem(item, otherStateToSet, cb);
      };

      _this.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };

      _this.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.

        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this.props.onInputValueChange(stateToSet.inputValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.getStateAndHelpers(), stateToSet));
        }

        return _this.setState(function (state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.

          newStateToSet = _this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called

          isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState

          var nextState = {}; // this is just used to tell whether the state changed

          var nextFullState = {}; // we need to call on change if the outside world is controlling any of our state
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection

          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }

          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            } // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.


            if (key === 'type') {
              return;
            }

            nextFullState[key] = newStateToSet[key]; // if it's coming from props, then we don't care to set it internally

            if (!isControlledProp(_this.props, key)) {
              nextState[key] = newStateToSet[key];
            }
          }); // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.

          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this.props.onInputValueChange(newStateToSet.inputValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.getStateAndHelpers(), newStateToSet));
          }

          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.

          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;

          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }

          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }

          if (onChangeArg !== undefined) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          } // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.


          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };

      _this.rootRef = function (node) {
        return _this._rootNode = node;
      };

      _this.getRootProps = function (_temp, _temp2) {
        var _extends2;

        var _ref = _temp === void 0 ? {} : _temp,
            _ref$refKey = _ref.refKey,
            refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
            ref = _ref.ref,
            rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, _excluded$4);

        var _ref2 = _temp2 === void 0 ? {} : _temp2,
            _ref2$suppressRefErro = _ref2.suppressRefError,
            suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

        // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;

        var _this$getState = _this.getState(),
            isOpen = _this$getState.isOpen;

        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
      };

      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();

              if (itemCount > 0) {
                var _this2$getState = _this2.getState(),
                    highlightedIndex = _this2$getState.highlightedIndex;

                var nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function (index) {
                  return _this2.getItemNodeFromIndex(index);
                });

                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();

              if (itemCount > 0) {
                var _this3$getState = _this3.getState(),
                    highlightedIndex = _this3$getState.highlightedIndex;

                var nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function (index) {
                  return _this3.getItemNodeFromIndex(index);
                });

                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          if (event.which === 229) {
            return;
          }

          var _this$getState2 = this.getState(),
              isOpen = _this$getState2.isOpen,
              highlightedIndex = _this$getState2.highlightedIndex;

          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);

            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }

            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ''
          }));
        }
      };
      _this.buttonKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.keyDownHandlers, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          var _this4 = this;

          var _this$getState3 = this.getState(),
              isOpen = _this$getState3.isOpen;

          if (!isOpen) {
            return;
          }

          event.preventDefault();
          var itemCount = this.getItemCount();

          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting downwards from 0 if that's disabled.


          var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function (index) {
            return _this4.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this5 = this;

          var _this$getState4 = this.getState(),
              isOpen = _this$getState4.isOpen;

          if (!isOpen) {
            return;
          }

          event.preventDefault();
          var itemCount = this.getItemCount();

          if (itemCount <= 0 || !isOpen) {
            return;
          } // get next non-disabled starting upwards from last index if that's disabled.


          var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function (index) {
            return _this5.getItemNodeFromIndex(index);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });

      _this.getToggleButtonProps = function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
            onClick = _ref3.onClick;
            _ref3.onPress;
            var onKeyDown = _ref3.onKeyDown,
            onKeyUp = _ref3.onKeyUp,
            onBlur = _ref3.onBlur,
            rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, _excluded2$3);

        var _this$getState5 = _this.getState(),
            isOpen = _this$getState5.isOpen;

        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers, rest);
      };

      _this.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };

      _this.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), event);
        }
      };

      _this.buttonHandleClick = function (event) {
        event.preventDefault(); // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.

        /* istanbul ignore if (can't reasonably test this) */

        if (_this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        } // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.


        if (false) {
          _this.toggleMenu({
            type: clickButton
          });
        } else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };

      _this.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element

        _this.internalSetTimeout(function () {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
            _this.reset({
              type: blurButton
            });
          }
        });
      };

      _this.getLabelProps = function (props) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };

      _this.getInputProps = function (_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4,
            onKeyDown = _ref4.onKeyDown,
            onBlur = _ref4.onBlur,
            onChange = _ref4.onChange,
            onInput = _ref4.onInput;
            _ref4.onChangeText;
            var rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref4, _excluded3$2);

        var onChangeKey;
        var eventHandlers = {};
        /* istanbul ignore next (preact) */

        {
          onChangeKey = 'onChange';
        }

        var _this$getState6 = _this.getState(),
            inputValue = _this$getState6.inputValue,
            isOpen = _this$getState6.isOpen,
            highlightedIndex = _this$getState6.highlightedIndex;

        if (!rest.disabled) {
          var _eventHandlers;

          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          'aria-controls': isOpen ? _this.menuId : null,
          'aria-labelledby': _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, rest);
      };

      _this.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), event);
        }
      };

      _this.inputHandleChange = function (event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };

      _this.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this.internalSetTimeout(function () {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);

          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };

      _this.menuRef = function (node) {
        _this._menuNode = node;
      };

      _this.getMenuProps = function (_temp5, _temp6) {
        var _extends3;

        var _ref5 = _temp5 === void 0 ? {} : _temp5,
            _ref5$refKey = _ref5.refKey,
            refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
            ref = _ref5.ref,
            props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref5, _excluded4$1);

        var _ref6 = _temp6 === void 0 ? {} : _temp6,
            _ref6$suppressRefErro = _ref6.suppressRefError,
            suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;

        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };

      _this.getItemProps = function (_temp7) {
        var _enabledEventHandlers;

        var _ref7 = _temp7 === void 0 ? {} : _temp7,
            onMouseMove = _ref7.onMouseMove,
            onMouseDown = _ref7.onMouseDown,
            onClick = _ref7.onClick;
            _ref7.onPress;
            var index = _ref7.index,
            _ref7$item = _ref7.item,
            item = _ref7$item === void 0 ?  true ?
        /* istanbul ignore next */
        undefined : requiredProp('getItemProps', 'item') : _ref7$item,
            rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref7, _excluded5$1);

        if (index === undefined) {
          _this.items.push(item);

          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }

        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }

            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            }); // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor


            _this.avoidScrolling = true;

            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers); // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items

        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers, rest);
      };

      _this.clearItems = function () {
        _this.items = [];
      };

      _this.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref8) {
          var selectedItem = _ref8.selectedItem;
          return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };

      _this.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref9) {
          var isOpen = _ref9.isOpen;
          return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, otherStateToSet);
        }, function () {
          var _this$getState7 = _this.getState(),
              isOpen = _this$getState7.isOpen,
              highlightedIndex = _this$getState7.highlightedIndex;

          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }

          cbToCb(cb)();
        });
      };

      _this.openMenu = function (cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };

      _this.closeMenu = function (cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };

      _this.updateStatus = debounce(function () {
        var state = _this.getState();

        var item = _this.items[state.highlightedIndex];

        var resultCount = _this.getItemCount();

        var status = _this.props.getA11yStatusMessage(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));

        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);

      var _this$props = _this.props,
          defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
          _this$props$initialHi = _this$props.initialHighlightedIndex,
          _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
          defaultIsOpen = _this$props.defaultIsOpen,
          _this$props$initialIs = _this$props.initialIsOpen,
          _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
          _this$props$initialIn = _this$props.initialInputValue,
          _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn,
          _this$props$initialSe = _this$props.initialSelectedItem,
          _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;

      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });

      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }

      _this.state = _state;
      return _this;
    }

    var _proto = Downshift.prototype;

    /**
     * Clear all running timeouts
     */
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }
    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */
    ;

    _proto.getState = function getState$1(stateToMerge) {
      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }

      return getState(stateToMerge, this.props);
    };

    _proto.getItemCount = function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      var itemCount = this.items.length;

      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        itemCount = this.props.itemCount;
      }

      return itemCount;
    };

    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment.document.getElementById(this.getItemId(index));
    };

    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      /* istanbul ignore else (react-native) */
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };

    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var _this6 = this;

      var itemCount = this.getItemCount();

      var _this$getState8 = this.getState(),
          highlightedIndex = _this$getState8.highlightedIndex;

      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function (index) {
          return _this6.getItemNodeFromIndex(index);
        });
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };

    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState9 = this.getState(),
          highlightedIndex = _this$getState9.highlightedIndex,
          inputValue = _this$getState9.inputValue,
          selectedItem = _this$getState9.selectedItem,
          isOpen = _this$getState9.isOpen;

      var itemToString = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps,
          getToggleButtonProps = this.getToggleButtonProps,
          getLabelProps = this.getLabelProps,
          getMenuProps = this.getMenuProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount,
          setState = this.internalSetState;
      return {
        // prop getters
        getRootProps: getRootProps,
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,
        setState: setState,
        // props
        itemToString: itemToString,
        // derived
        id: id,
        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    } //////////////////////////// ROOT
    ;

    _proto.componentDidMount = function componentDidMount() {
      var _this7 = this;

      /* istanbul ignore if (react-native) */
      if (false) {
        validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
      }
      /* istanbul ignore if (react-native) */


      {
        // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.
        var onMouseDown = function onMouseDown() {
          _this7.isMouseDown = true;
        };

        var onMouseUp = function onMouseUp(event) {
          _this7.isMouseDown = false; // if the target element or the activeElement is within a downshift node
          // then we don't want to reset downshift

          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment);

          if (!contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: mouseUp
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        }; // Touching an element in iOS gives focus and hover states, but touching out of
        // the element will remove hover, and persist the focus state, resulting in the
        // blur event not being triggered.
        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
        // If the user taps outside of Downshift, the component should be reset,
        // but not if the user is swiping


        var onTouchStart = function onTouchStart() {
          _this7.isTouchMove = false;
        };

        var onTouchMove = function onTouchMove() {
          _this7.isTouchMove = true;
        };

        var onTouchEnd = function onTouchEnd(event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment, false);

          if (!_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: touchEnd
            }, function () {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };

        var environment = this.props.environment;
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);

        this.cleanup = function () {
          _this7.internalClearTimeouts();

          _this7.updateStatus.cancel();

          environment.removeEventListener('mousedown', onMouseDown);
          environment.removeEventListener('mouseup', onMouseUp);
          environment.removeEventListener('touchstart', onTouchStart);
          environment.removeEventListener('touchmove', onTouchMove);
          environment.removeEventListener('touchend', onTouchEnd);
        };
      }
    };

    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
          currentHighlightedIndex = _ref10.highlightedIndex;

      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
          prevHighlightedIndex = _ref11.highlightedIndex;

      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
      return scrollWhenOpen || scrollWhenNavigating;
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (false) {
        validateControlledUnchanged(this.state, prevProps, this.props);
        /* istanbul ignore if (react-native) */

        if (this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
          validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
        }
      }

      if (isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }

      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }
      /* istanbul ignore else (react-native) */


      {
        this.updateStatus();
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    };

    _proto.render = function render() {
      var children = unwrapArray(this.props.children, noop); // because the items are rerendered every time we call the children
      // we clear this out each render and it will be populated again as
      // getItemProps is called.

      this.clearItems(); // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.

      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps

      this.getMenuProps.called = false;
      this.getMenuProps.refKey = undefined;
      this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps

      this.getLabelProps.called = false; // and something similar for getInputProps

      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));

      if (!element) {
        return null;
      }

      if (this.getRootProps.called || this.props.suppressRefError) {
        if (false) {
          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
        }

        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(element, this.getRootProps(getElementProps(element)));
      }
      /* istanbul ignore else */


      if (false) {
        // they didn't apply the root props, but they need to
        // otherwise we can't query around the autocomplete
        throw new Error('downshift: If you return a non-DOM element, you must apply the getRootProps function');
      }
      /* istanbul ignore next */


      return undefined;
    };

    return Downshift;
  }(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage$1,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
      }

      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment:
    /* istanbul ignore next (ssr) */
    typeof window === 'undefined' ? {} : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes$3;
  return Downshift;
}();

 false ? Downshift.propTypes = {
  children: PropTypes.func,
  defaultHighlightedIndex: PropTypes.number,
  defaultIsOpen: PropTypes.bool,
  initialHighlightedIndex: PropTypes.number,
  initialSelectedItem: PropTypes.any,
  initialInputValue: PropTypes.string,
  initialIsOpen: PropTypes.bool,
  getA11yStatusMessage: PropTypes.func,
  itemToString: PropTypes.func,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onStateChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  onUserAction: PropTypes.func,
  onOuterClick: PropTypes.func,
  selectedItemChanged: PropTypes.func,
  stateReducer: PropTypes.func,
  itemCount: PropTypes.number,
  id: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  }),
  suppressRefError: PropTypes.bool,
  scrollIntoView: PropTypes.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components

  /* eslint-disable react/no-unused-prop-types */
  selectedItem: PropTypes.any,
  isOpen: PropTypes.bool,
  inputValue: PropTypes.string,
  highlightedIndex: PropTypes.number,
  labelId: PropTypes.string,
  inputId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func
  /* eslint-enable react/no-unused-prop-types */

} : void 0;
var Downshift$1 = Downshift;

function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;

  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
  }
}

function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);

  if (isComposite && !refKeySpecified && !Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isForwardRef"])(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isForwardRef"])(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
  }
}

var _excluded$3 = ["isInitialMount", "highlightedIndex", "items", "environment"];
var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ''
};

function callOnChangeProps(action, state, newState) {
  var props = action.props,
      type = action.type;
  var changes = {};
  Object.keys(state).forEach(function (key) {
    invokeOnChangeHandler(key, action, state, newState);

    if (newState[key] !== state[key]) {
      changes[key] = newState[key];
    }
  });

  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: type
    }, changes));
  }
}

function invokeOnChangeHandler(key, action, state, newState) {
  var props = action.props,
      type = action.type;
  var handler = "on" + capitalizeString(key) + "Change";

  if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) {
    props[handler](Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: type
    }, newState));
  }
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */


function stateReducer(s, a) {
  return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem,
      itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : '';
}
/**
 * Debounced call for updating the a11y message.
 */


var updateA11yStatus = debounce(function (getA11yMessage, document) {
  setStatus(getA11yMessage(), document);
}, 200); // istanbul ignore next

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_5_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"];

function useElementIds(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? "downshift-" + generateId() : _ref$id,
      labelId = _ref.labelId,
      menuId = _ref.menuId,
      getItemId = _ref.getItemId,
      toggleButtonId = _ref.toggleButtonId,
      inputId = _ref.inputId;
  var elementIdsRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])({
    labelId: labelId || id + "-label",
    menuId: menuId || id + "-menu",
    getItemId: getItemId || function (index) {
      return id + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || id + "-toggle-button",
    inputId: inputId || id + "-input"
  });
  return elementIdsRef.current;
}

function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }

  if (items.length === 0) {
    return -1;
  }

  return items.indexOf(item);
}

function itemToString(item) {
  return item ? String(item) : '';
}

function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}

function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}

function useLatestRef(val) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(val); // technically this is not "concurrent mode safe" because we're manipulating
  // the value during render (so it's not idempotent). However, the places this
  // hook is used is to support memoizing callbacks which will be called
  // *during* render, so we need the latest values *during* render.
  // If not for this, then we'd probably want to use useLayoutEffect instead.

  ref.current = val;
  return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */


function useEnhancedReducer(reducer, initialState, props) {
  var prevStateRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var actionRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var enhancedReducer = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (state, action) {
    actionRef.current = action;
    state = getState(state, action.props);
    var changes = reducer(state, action);
    var newState = action.props.stateReducer(state, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, action, {
      changes: changes
    }));
    return newState;
  }, [reducer]);

  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useReducer"])(enhancedReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var propsRef = useLatestRef(props);
  var dispatchWithProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (action) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      props: propsRef.current
    }, action));
  }, [propsRef]);
  var action = actionRef.current;
  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (action && prevStateRef.current && prevStateRef.current !== state) {
      callOnChangeProps(action, getState(prevStateRef.current, action.props), state);
    }

    prevStateRef.current = state;
  }, [state, props, action]);
  return [state, dispatchWithProps];
}
/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */


function useControlledReducer$1(reducer, initialState, props) {
  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
      state = _useEnhancedReducer[0],
      dispatch = _useEnhancedReducer[1];

  return [getState(state, props), dispatch];
}

var defaultProps$3 = {
  itemToString: itemToString,
  stateReducer: stateReducer,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  circularNavigation: false,
  environment:
  /* istanbul ignore next (ssr) */
  typeof window === 'undefined' ? {} : window
};

function getDefaultValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }

  var defaultPropKey = "default" + capitalizeString(propKey);

  if (defaultPropKey in props) {
    return props[defaultPropKey];
  }

  return defaultStateValues[propKey];
}

function getInitialValue$1(props, propKey, defaultStateValues) {
  if (defaultStateValues === void 0) {
    defaultStateValues = dropdownDefaultStateValues;
  }

  if (propKey in props) {
    return props[propKey];
  }

  var initialPropKey = "initial" + capitalizeString(propKey);

  if (initialPropKey in props) {
    return props[initialPropKey];
  }

  return getDefaultValue$1(props, propKey, defaultStateValues);
}

function getInitialState$2(props) {
  var selectedItem = getInitialValue$1(props, 'selectedItem');
  var isOpen = getInitialValue$1(props, 'isOpen');
  var highlightedIndex = getInitialValue$1(props, 'highlightedIndex');
  var inputValue = getInitialValue$1(props, 'inputValue');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

function getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
  var items = props.items,
      initialHighlightedIndex = props.initialHighlightedIndex,
      defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
      highlightedIndex = state.highlightedIndex;

  if (items.length === 0) {
    return -1;
  } // initialHighlightedIndex will give value to highlightedIndex on initial state only.


  if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }

  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }

  if (selectedItem) {
    if (offset === 0) {
      return items.indexOf(selectedItem);
    }

    return getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
  }

  if (offset === 0) {
    return -1;
  }

  return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */


function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])({
    isMouseDown: false,
    isTouchMove: false
  });
  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    // The same strategy for checking if a click occurred inside or outside downsift
    // as in downshift.js.
    var onMouseDown = function onMouseDown() {
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    };

    var onMouseUp = function onMouseUp(event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;

      if (isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment)) {
        handleBlur();
      }
    };

    var onTouchStart = function onTouchStart() {
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    };

    var onTouchMove = function onTouchMove() {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    };

    var onTouchEnd = function onTouchEnd(event) {
      if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function (ref) {
        return ref.current;
      }), environment, false)) {
        handleBlur();
      }
    };

    environment.addEventListener('mousedown', onMouseDown);
    environment.addEventListener('mouseup', onMouseUp);
    environment.addEventListener('touchstart', onTouchStart);
    environment.addEventListener('touchmove', onTouchMove);
    environment.addEventListener('touchend', onTouchEnd);
    return function cleanup() {
      environment.removeEventListener('mousedown', onMouseDown);
      environment.removeEventListener('mouseup', onMouseUp);
      environment.removeEventListener('touchstart', onTouchStart);
      environment.removeEventListener('touchmove', onTouchMove);
      environment.removeEventListener('touchend', onTouchEnd);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, environment]);
  return mouseAndTouchTrackersRef;
}
/* istanbul ignore next */
// eslint-disable-next-line import/no-mutable-exports


var useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
  return noop;
};
/**
 * Custom hook that checks if getter props are called correctly.
 *
 * @param  {...any} propKeys Getter prop names to be handled.
 * @returns {Function} Setter function called inside getter props to set call information.
 */

/* istanbul ignore next */


if (false) {
  useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
    var isInitialMountRef = useRef(true);

    for (var _len = arguments.length, propKeys = new Array(_len), _key = 0; _key < _len; _key++) {
      propKeys[_key] = arguments[_key];
    }

    var getterPropsCalledRef = useRef(propKeys.reduce(function (acc, propKey) {
      acc[propKey] = {};
      return acc;
    }, {}));
    useEffect(function () {
      Object.keys(getterPropsCalledRef.current).forEach(function (propKey) {
        var propCallInfo = getterPropsCalledRef.current[propKey];

        if (isInitialMountRef.current) {
          if (!Object.keys(propCallInfo).length) {
            // eslint-disable-next-line no-console
            console.error("downshift: You forgot to call the " + propKey + " getter function on your component / element.");
            return;
          }
        }

        var suppressRefError = propCallInfo.suppressRefError,
            refKey = propCallInfo.refKey,
            elementRef = propCallInfo.elementRef;

        if ((!elementRef || !elementRef.current) && !suppressRefError) {
          // eslint-disable-next-line no-console
          console.error("downshift: The ref prop \"" + refKey + "\" from " + propKey + " was not applied correctly on your element.");
        }
      });
      isInitialMountRef.current = false;
    });
    var setGetterPropCallInfo = useCallback(function (propKey, suppressRefError, refKey, elementRef) {
      getterPropsCalledRef.current[propKey] = {
        suppressRefError: suppressRefError,
        refKey: refKey,
        elementRef: elementRef
      };
    }, []);
    return setGetterPropCallInfo;
  };
}

function useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
  var isInitialMount = _ref2.isInitialMount,
      highlightedIndex = _ref2.highlightedIndex,
      items = _ref2.items,
      environment = _ref2.environment,
      rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, _excluded$3);

  // Sets a11y status message on changes in state.
  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (isInitialMount || false) {
      return;
    }

    updateA11yStatus(function () {
      return getA11yMessage(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        highlightedIndex: highlightedIndex,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length
      }, rest));
    }, environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);
}

function useScrollIntoView(_ref3) {
  var highlightedIndex = _ref3.highlightedIndex,
      isOpen = _ref3.isOpen,
      itemRefs = _ref3.itemRefs,
      getItemNodeFromIndex = _ref3.getItemNodeFromIndex,
      menuElement = _ref3.menuElement,
      scrollIntoViewProp = _ref3.scrollIntoView;
  // used not to scroll on highlight by mouse.
  var shouldScrollRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true); // Scroll on highlighted item if change comes from keyboard.

  useIsomorphicLayoutEffect(function () {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }

    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]);
  return shouldScrollRef;
} // eslint-disable-next-line import/no-mutable-exports


var useControlPropsValidator = noop;
/* istanbul ignore next */

if (false) {
  useControlPropsValidator = function useControlPropsValidator(_ref4) {
    var isInitialMount = _ref4.isInitialMount,
        props = _ref4.props,
        state = _ref4.state;
    // used for checking when props are moving from controlled to uncontrolled.
    var prevPropsRef = useRef(props);
    useEffect(function () {
      if (isInitialMount) {
        return;
      }

      validateControlledUnchanged(state, prevPropsRef.current, props);
      prevPropsRef.current = props;
    }, [state, props, isInitialMount]);
  };
}

/* eslint-disable complexity */

function downshiftCommonReducer(state, action, stateChangeTypes) {
  var type = action.type,
      props = action.props;
  var changes;

  switch (type) {
    case stateChangeTypes.ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case stateChangeTypes.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;

    case stateChangeTypes.ToggleButtonClick:
    case stateChangeTypes.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case stateChangeTypes.FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case stateChangeTypes.FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;

    case stateChangeTypes.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case stateChangeTypes.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;

    case stateChangeTypes.FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        isOpen: getDefaultValue$1(props, 'isOpen'),
        selectedItem: getDefaultValue$1(props, 'selectedItem'),
        inputValue: getDefaultValue$1(props, 'inputValue')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, changes);
}
/* eslint-enable complexity */

function getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, getItemNodeFromIndex = _a.getItemNodeFromIndex;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for (var index = 0; index < items.length; index++) {
        var offsetIndex = (index + highlightedIndex + 1) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined &&
            itemToString(item)
                .toLowerCase()
                .startsWith(lowerCasedKeysSoFar)) {
            var element = getItemNodeFromIndex(offsetIndex);
            if (!(element === null || element === void 0 ? void 0 : element.hasAttribute('disabled'))) {
                return offsetIndex;
            }
        }
    }
    return highlightedIndex;
}
var propTypes$2 = {
    items: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
    itemToString: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    getA11yStatusMessage: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    getA11ySelectionMessage: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    circularNavigation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    highlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    defaultHighlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    initialHighlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    defaultIsOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    initialIsOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
    selectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    initialSelectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    defaultSelectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    labelId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    menuId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    getItemId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    toggleButtonId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    stateReducer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onSelectedItemChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onHighlightedIndexChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onStateChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    onIsOpenChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    environment: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
        addEventListener: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
        removeEventListener: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
        document: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
            getElementById: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
            activeElement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
            body: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
        })
    })
};
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */
function getA11yStatusMessage(_a) {
    var isOpen = _a.isOpen, resultCount = _a.resultCount, previousResultCount = _a.previousResultCount;
    if (!isOpen) {
        return '';
    }
    if (!resultCount) {
        return 'No results are available.';
    }
    if (resultCount !== previousResultCount) {
        return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.";
    }
    return '';
}
var defaultProps$2 = Object(__WEBPACK_IMPORTED_MODULE_8_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_8_tslib__["a" /* __assign */])({}, defaultProps$3), { getA11yStatusMessage: getA11yStatusMessage });
// eslint-disable-next-line import/no-mutable-exports
var validatePropTypes$2 = noop;
/* istanbul ignore next */
if (false) {
    validatePropTypes$2 = function (options, caller) {
        PropTypes.checkPropTypes(propTypes$2, options, 'prop', caller.name);
    };
}

var MenuKeyDownArrowDown =  false ? '__menu_keydown_arrow_down__' : 0;
var MenuKeyDownArrowUp =  false ? '__menu_keydown_arrow_up__' : 1;
var MenuKeyDownEscape =  false ? '__menu_keydown_escape__' : 2;
var MenuKeyDownHome =  false ? '__menu_keydown_home__' : 3;
var MenuKeyDownEnd =  false ? '__menu_keydown_end__' : 4;
var MenuKeyDownEnter =  false ? '__menu_keydown_enter__' : 5;
var MenuKeyDownSpaceButton =  false ? '__menu_keydown_space_button__' : 6;
var MenuKeyDownCharacter =  false ? '__menu_keydown_character__' : 7;
var MenuBlur =  false ? '__menu_blur__' : 8;
var MenuMouseLeave$1 =  false ? '__menu_mouse_leave__' : 9;
var ItemMouseMove$1 =  false ? '__item_mouse_move__' : 10;
var ItemClick$1 =  false ? '__item_click__' : 11;
var ToggleButtonClick$1 =  false ? '__togglebutton_click__' : 12;
var ToggleButtonKeyDownArrowDown =  false ? '__togglebutton_keydown_arrow_down__' : 13;
var ToggleButtonKeyDownArrowUp =  false ? '__togglebutton_keydown_arrow_up__' : 14;
var ToggleButtonKeyDownCharacter =  false ? '__togglebutton_keydown_character__' : 15;
var FunctionToggleMenu$1 =  false ? '__function_toggle_menu__' : 16;
var FunctionOpenMenu$1 =  false ? '__function_open_menu__' : 17;
var FunctionCloseMenu$1 =  false ? '__function_close_menu__' : 18;
var FunctionSetHighlightedIndex$1 =  false ? '__function_set_highlighted_index__' : 19;
var FunctionSelectItem$1 =  false ? '__function_select_item__' : 20;
var FunctionSetInputValue$1 =  false ? '__function_set_input_value__' : 21;
var FunctionReset$2 =  false ? '__function_reset__' : 22;

var stateChangeTypes$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MenuKeyDownArrowDown: MenuKeyDownArrowDown,
  MenuKeyDownArrowUp: MenuKeyDownArrowUp,
  MenuKeyDownEscape: MenuKeyDownEscape,
  MenuKeyDownHome: MenuKeyDownHome,
  MenuKeyDownEnd: MenuKeyDownEnd,
  MenuKeyDownEnter: MenuKeyDownEnter,
  MenuKeyDownSpaceButton: MenuKeyDownSpaceButton,
  MenuKeyDownCharacter: MenuKeyDownCharacter,
  MenuBlur: MenuBlur,
  MenuMouseLeave: MenuMouseLeave$1,
  ItemMouseMove: ItemMouseMove$1,
  ItemClick: ItemClick$1,
  ToggleButtonClick: ToggleButtonClick$1,
  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
  FunctionToggleMenu: FunctionToggleMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetInputValue: FunctionSetInputValue$1,
  FunctionReset: FunctionReset$2
});

/* eslint-disable complexity */

function downshiftSelectReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        selectedItem: props.items[action.index]
      };
      break;

    case ToggleButtonKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var inputValue = "" + state.inputValue + lowercasedKey;
        var itemIndex = getItemIndexByCharacterKey({
          keysSoFar: inputValue,
          highlightedIndex: state.selectedItem ? props.items.indexOf(state.selectedItem) : -1,
          items: props.items,
          itemToString: props.itemToString,
          getItemNodeFromIndex: action.getItemNodeFromIndex
        });
        changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          inputValue: inputValue
        }, itemIndex >= 0 && {
          selectedItem: props.items[itemIndex]
        });
      }
      break;

    case ToggleButtonKeyDownArrowDown:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
        isOpen: true
      };
      break;

    case ToggleButtonKeyDownArrowUp:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
        isOpen: true
      };
      break;

    case MenuKeyDownEnter:
    case MenuKeyDownSpaceButton:
      changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex')
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;

    case MenuKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case MenuKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case MenuKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuBlur:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownCharacter:
      {
        var _lowercasedKey = action.key;

        var _inputValue = "" + state.inputValue + _lowercasedKey;

        var highlightedIndex = getItemIndexByCharacterKey({
          keysSoFar: _inputValue,
          highlightedIndex: state.highlightedIndex,
          items: props.items,
          itemToString: props.itemToString,
          getItemNodeFromIndex: action.getItemNodeFromIndex
        });
        changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          inputValue: _inputValue
        }, highlightedIndex >= 0 && {
          highlightedIndex: highlightedIndex
        });
      }
      break;

    case MenuKeyDownArrowDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;

    case MenuKeyDownArrowUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;

    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem
      };
      break;

    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$2);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, changes);
}
/* eslint-enable complexity */

var _excluded$2 = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"],
    _excluded2$2 = ["onClick", "onKeyDown", "refKey", "ref"],
    _excluded3$1 = ["item", "index", "onMouseMove", "onClick", "refKey", "ref"];
useSelect.stateChangeTypes = stateChangeTypes$2;

function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  validatePropTypes$2(userProps, useSelect); // Props defaults and destructuring.

  var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps$2, userProps);

  var items = props.items,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment,
      initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      itemToString = props.itemToString,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      getA11yStatusMessage = props.getA11yStatusMessage; // Initial state depending on controlled props.

  var initialState = getInitialState$2(props);

  var _useControlledReducer = useControlledReducer$1(downshiftSelectReducer, initialState, props),
      state = _useControlledReducer[0],
      dispatch = _useControlledReducer[1];

  var isOpen = state.isOpen,
      highlightedIndex = state.highlightedIndex,
      selectedItem = state.selectedItem,
      inputValue = state.inputValue; // Element efs.

  var toggleButtonRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var menuRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var itemRefs = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])({}); // used not to trigger menu blur action in some scenarios.

  var shouldBlurRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true); // used to keep the inputValue clearTimeout object between renders.

  var clearTimeoutRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null); // prevent id re-generation between renders.

  var elementIds = useElementIds(props); // used to keep track of how many items we had on previous cycle.

  var previousResultCountRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  var isInitialMountRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true); // utility callback to get item element.

  var latest = useLatestRef({
    state: state,
    props: props
  }); // Some utils.

  var getItemNodeFromIndex = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]); // Effects.
  // Sets a11y status message on changes in state.

  useA11yMessageSetter(getA11yStatusMessage, [isOpen, highlightedIndex, inputValue, items], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Sets a11y status message on changes in selectedItem.

  useA11yMessageSetter(getA11ySelectionMessage, [selectedItem], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Scroll on highlighted item if change comes from keyboard.

  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  }); // Sets cleanup for the keysSoFar callback, debounded after 500ms.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    // init the clean function here as we need access to dispatch.
    clearTimeoutRef.current = debounce(function (outerDispatch) {
      outerDispatch({
        type: FunctionSetInputValue$1,
        inputValue: ''
      });
    }, 500); // Cancel any pending debounced calls on mount

    return function () {
      clearTimeoutRef.current.cancel();
    };
  }, []); // Invokes the keysSoFar callback set up above.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (!inputValue) {
      return;
    }

    clearTimeoutRef.current(dispatch);
  }, [dispatch, inputValue]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  });
  /* Controls the focus on the menu or the toggle button. */

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    // Don't focus menu on first render.
    if (isInitialMountRef.current) {
      // Unless it was initialised as open.
      if ((initialIsOpen || defaultIsOpen || isOpen) && menuRef.current) {
        menuRef.current.focus();
      }

      return;
    } // Focus menu on open.


    if (isOpen) {
      // istanbul ignore else
      if (menuRef.current) {
        menuRef.current.focus();
      }

      return;
    } // Focus toggleButton on close, but not if it was closed with (Shift+)Tab.


    if (environment.document.activeElement === menuRef.current) {
      // istanbul ignore else
      if (toggleButtonRef.current) {
        shouldBlurRef.current = false;
        toggleButtonRef.current.focus();
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]);
  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (isInitialMountRef.current) {
      return;
    }

    previousResultCountRef.current = items.length;
  }); // Add mouse/touch events to document.

  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: MenuBlur
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getMenuProps', 'getToggleButtonProps'); // Make initial ref false.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    isInitialMountRef.current = false;
  }, []); // Reset itemRefs on close.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]); // Event handler functions.

  var toggleButtonKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowDown,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: ToggleButtonKeyDownArrowUp,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      }
    };
  }, [dispatch, getItemNodeFromIndex]);
  var menuKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownArrowDown,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownArrowUp,
          getItemNodeFromIndex: getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      Home: function Home(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        dispatch({
          type: MenuKeyDownEscape
        });
      },
      Enter: function Enter(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownEnter
        });
      },
      ' ': function _(event) {
        event.preventDefault();
        dispatch({
          type: MenuKeyDownSpaceButton
        });
      }
    };
  }, [dispatch, getItemNodeFromIndex]); // Action functions.

  var toggleMenu = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionToggleMenu$1
    });
  }, [dispatch]);
  var closeMenu = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionCloseMenu$1
    });
  }, [dispatch]);
  var openMenu = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionOpenMenu$1
    });
  }, [dispatch]);
  var setHighlightedIndex = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex$1,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem$1,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var reset = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionReset$2
    });
  }, [dispatch]);
  var setInputValue = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue$1,
      inputValue: newInputValue
    });
  }, [dispatch]); // Getter functions.

  var getLabelProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (labelProps) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      id: elementIds.labelId,
      htmlFor: elementIds.toggleButtonId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp, _temp2) {
    var _extends2;

    var _ref = _temp === void 0 ? {} : _temp,
        onMouseLeave = _ref.onMouseLeave,
        _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
        onKeyDown = _ref.onKeyDown,
        onBlur = _ref.onBlur,
        ref = _ref.ref,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, _excluded$2);

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$suppressRefErro = _ref2.suppressRefError,
        suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

    var latestState = latest.current.state;

    var menuHandleKeyDown = function menuHandleKeyDown(event) {
      var key = normalizeArrowKey(event);

      if (key && menuKeyDownHandlers[key]) {
        menuKeyDownHandlers[key](event);
      } else if (isAcceptedCharacterKey(key)) {
        dispatch({
          type: MenuKeyDownCharacter,
          key: key,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };

    var menuHandleBlur = function menuHandleBlur() {
      // if the blur was a result of selection, we don't trigger this action.
      if (shouldBlurRef.current === false) {
        shouldBlurRef.current = true;
        return;
      }

      var shouldBlur = !mouseAndTouchTrackersRef.current.isMouseDown;
      /* istanbul ignore else */

      if (shouldBlur) {
        dispatch({
          type: MenuBlur
        });
      }
    };

    var menuHandleMouseLeave = function menuHandleMouseLeave() {
      dispatch({
        type: MenuMouseLeave$1
      });
    };

    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = elementIds.labelId, _extends2.tabIndex = -1, _extends2), latestState.isOpen && latestState.highlightedIndex > -1 && {
      'aria-activedescendant': elementIds.getItemId(latestState.highlightedIndex)
    }, {
      onMouseLeave: callAllEventHandlers(onMouseLeave, menuHandleMouseLeave),
      onKeyDown: callAllEventHandlers(onKeyDown, menuHandleKeyDown),
      onBlur: callAllEventHandlers(onBlur, menuHandleBlur)
    }, rest);
  }, [dispatch, latest, menuKeyDownHandlers, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds, getItemNodeFromIndex]);
  var getToggleButtonProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp3, _temp4) {
    var _extends3;

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        onClick = _ref3.onClick,
        onKeyDown = _ref3.onKeyDown,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
        ref = _ref3.ref,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, _excluded2$2);

    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        _ref4$suppressRefErro = _ref4.suppressRefError,
        suppressRefError = _ref4$suppressRefErro === void 0 ? false : _ref4$suppressRefErro;

    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick$1
      });
    };

    var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown(event) {
      var key = normalizeArrowKey(event);

      if (key && toggleButtonKeyDownHandlers[key]) {
        toggleButtonKeyDownHandlers[key](event);
      } else if (isAcceptedCharacterKey(key)) {
        dispatch({
          type: ToggleButtonKeyDownCharacter,
          key: key,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };

    var toggleProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends3.id = elementIds.toggleButtonId, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-expanded'] = latest.current.state.isOpen, _extends3['aria-labelledby'] = elementIds.labelId + " " + elementIds.toggleButtonId, _extends3), rest);

    if (!rest.disabled) {
      toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
      toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
    }

    setGetterPropCallInfo('getToggleButtonProps', suppressRefError, refKey, toggleButtonRef);
    return toggleProps;
  }, [dispatch, latest, toggleButtonKeyDownHandlers, setGetterPropCallInfo, elementIds, getItemNodeFromIndex]);
  var getItemProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp5) {
    var _extends4;

    var _ref5 = _temp5 === void 0 ? {} : _temp5,
        item = _ref5.item,
        index = _ref5.index,
        onMouseMove = _ref5.onMouseMove,
        onClick = _ref5.onClick,
        _ref5$refKey = _ref5.refKey,
        refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
        ref = _ref5.ref,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref5, _excluded3$1);

    var _latest$current = latest.current,
        latestState = _latest$current.state,
        latestProps = _latest$current.props;

    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (index === latestState.highlightedIndex) {
        return;
      }

      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove$1,
        index: index
      });
    };

    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick$1,
        index: index
      });
    };

    var itemIndex = getItemIndex(index, item, latestProps.items);

    if (itemIndex < 0) {
      throw new Error('Pass either item or item index in getItemProps!');
    }

    var itemProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends4 = {
      role: 'option',
      'aria-selected': "" + (itemIndex === latestState.highlightedIndex),
      id: elementIds.getItemId(itemIndex)
    }, _extends4[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
      }
    }), _extends4), rest);

    if (!rest.disabled) {
      itemProps.onMouseMove = callAllEventHandlers(onMouseMove, itemHandleMouseMove);
      itemProps.onClick = callAllEventHandlers(onClick, itemHandleClick);
    }

    return itemProps;
  }, [dispatch, latest, shouldScrollRef, elementIds]);
  return {
    // prop getters.
    getToggleButtonProps: getToggleButtonProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getItemProps: getItemProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    selectItem: selectItem,
    reset: reset,
    setInputValue: setInputValue,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

var InputKeyDownArrowDown =  false ? '__input_keydown_arrow_down__' : 0;
var InputKeyDownArrowUp =  false ? '__input_keydown_arrow_up__' : 1;
var InputKeyDownEscape =  false ? '__input_keydown_escape__' : 2;
var InputKeyDownHome =  false ? '__input_keydown_home__' : 3;
var InputKeyDownEnd =  false ? '__input_keydown_end__' : 4;
var InputKeyDownEnter =  false ? '__input_keydown_enter__' : 5;
var InputChange =  false ? '__input_change__' : 6;
var InputBlur =  false ? '__input_blur__' : 7;
var MenuMouseLeave =  false ? '__menu_mouse_leave__' : 8;
var ItemMouseMove =  false ? '__item_mouse_move__' : 9;
var ItemClick =  false ? '__item_click__' : 10;
var ToggleButtonClick =  false ? '__togglebutton_click__' : 11;
var FunctionToggleMenu =  false ? '__function_toggle_menu__' : 12;
var FunctionOpenMenu =  false ? '__function_open_menu__' : 13;
var FunctionCloseMenu =  false ? '__function_close_menu__' : 14;
var FunctionSetHighlightedIndex =  false ? '__function_set_highlighted_index__' : 15;
var FunctionSelectItem =  false ? '__function_select_item__' : 16;
var FunctionSetInputValue =  false ? '__function_set_input_value__' : 17;
var FunctionReset$1 =  false ? '__function_reset__' : 18;
var ControlledPropUpdatedSelectedItem =  false ? '__controlled_prop_updated_selected_item__' : 19;

var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: InputKeyDownArrowDown,
  InputKeyDownArrowUp: InputKeyDownArrowUp,
  InputKeyDownEscape: InputKeyDownEscape,
  InputKeyDownHome: InputKeyDownHome,
  InputKeyDownEnd: InputKeyDownEnd,
  InputKeyDownEnter: InputKeyDownEnter,
  InputChange: InputChange,
  InputBlur: InputBlur,
  MenuMouseLeave: MenuMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  ToggleButtonClick: ToggleButtonClick,
  FunctionToggleMenu: FunctionToggleMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSelectItem: FunctionSelectItem,
  FunctionSetInputValue: FunctionSetInputValue,
  FunctionReset: FunctionReset$1,
  ControlledPropUpdatedSelectedItem: ControlledPropUpdatedSelectedItem
});

function getInitialState$1(props) {
  var initialState = getInitialState$2(props);
  var selectedItem = initialState.selectedItem;
  var inputValue = initialState.inputValue;

  if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) {
    inputValue = props.itemToString(selectedItem);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, initialState, {
    inputValue: inputValue
  });
}

var propTypes$1 = {
  items: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  itemToString: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  getA11yStatusMessage: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  getA11ySelectionMessage: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  circularNavigation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  highlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  defaultHighlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  initialHighlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  defaultIsOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  initialIsOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  selectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  initialSelectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  defaultSelectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  inputValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  defaultInputValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  initialInputValue: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  labelId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  menuId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  getItemId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  inputId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  toggleButtonId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  stateReducer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onSelectedItemChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onHighlightedIndexChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onIsOpenChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onInputValueChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  environment: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    addEventListener: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    removeEventListener: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    document: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
      getElementById: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
      activeElement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
      body: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
    })
  })
};
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */

function useControlledReducer(reducer, initialState, props) {
  var previousSelectedItemRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();

  var _useEnhancedReducer = useEnhancedReducer(reducer, initialState, props),
      state = _useEnhancedReducer[0],
      dispatch = _useEnhancedReducer[1]; // ToDo: if needed, make same approach as selectedItemChanged from Downshift.


  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (isControlledProp(props, 'selectedItem')) {
      if (previousSelectedItemRef.current !== props.selectedItem) {
        dispatch({
          type: ControlledPropUpdatedSelectedItem,
          inputValue: props.itemToString(props.selectedItem)
        });
      }

      previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    }
  });
  return [getState(state, props), dispatch];
} // eslint-disable-next-line import/no-mutable-exports


var validatePropTypes$1 = noop;
/* istanbul ignore next */

if (false) {
  validatePropTypes$1 = function validatePropTypes(options, caller) {
    PropTypes.checkPropTypes(propTypes$1, options, 'prop', caller.name);
  };
}

var defaultProps$1 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps$3, {
  getA11yStatusMessage: getA11yStatusMessage$1,
  circularNavigation: true
});

/* eslint-disable complexity */

function downshiftUseComboboxReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemClick:
      changes = {
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;

    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }

      break;

    case InputKeyDownArrowUp:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }

      break;

    case InputKeyDownEnter:
      changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.isOpen && state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        isOpen: getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;

    case InputKeyDownEscape:
      changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        isOpen: false,
        highlightedIndex: -1
      }, !state.isOpen && {
        selectedItem: null,
        inputValue: ''
      });
      break;

    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;

    case InputBlur:
      changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && action.selectItem && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;

    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultValue$1(props, 'highlightedIndex'),
        inputValue: action.inputValue
      };
      break;

    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;

    case ControlledPropUpdatedSelectedItem:
      changes = {
        inputValue: action.inputValue
      };
      break;

    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$1);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, changes);
}
/* eslint-enable complexity */

var _excluded$1 = ["onMouseLeave", "refKey", "ref"],
    _excluded2$1 = ["item", "index", "refKey", "ref", "onMouseMove", "onClick", "onPress"],
    _excluded3 = ["onClick", "onPress", "refKey", "ref"],
    _excluded4 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"],
    _excluded5 = ["refKey", "ref"];
useCombobox.stateChangeTypes = stateChangeTypes$1;

function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  validatePropTypes$1(userProps, useCombobox); // Props defaults and destructuring.

  var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps$1, userProps);

  var initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      items = props.items,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment,
      getA11yStatusMessage = props.getA11yStatusMessage,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      itemToString = props.itemToString; // Initial state depending on controlled props.

  var initialState = getInitialState$1(props);

  var _useControlledReducer = useControlledReducer(downshiftUseComboboxReducer, initialState, props),
      state = _useControlledReducer[0],
      dispatch = _useControlledReducer[1];

  var isOpen = state.isOpen,
      highlightedIndex = state.highlightedIndex,
      selectedItem = state.selectedItem,
      inputValue = state.inputValue; // Element refs.

  var menuRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var itemRefs = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])({});
  var inputRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var toggleButtonRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var comboboxRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var isInitialMountRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true); // prevent id re-generation between renders.

  var elementIds = useElementIds(props); // used to keep track of how many items we had on previous cycle.

  var previousResultCountRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(); // utility callback to get item element.

  var latest = useLatestRef({
    state: state,
    props: props
  });
  var getItemNodeFromIndex = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (index) {
    return itemRefs.current[elementIds.getItemId(index)];
  }, [elementIds]); // Effects.
  // Sets a11y status message on changes in state.

  useA11yMessageSetter(getA11yStatusMessage, [isOpen, highlightedIndex, inputValue, items], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Sets a11y status message on changes in selectedItem.

  useA11yMessageSetter(getA11ySelectionMessage, [selectedItem], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items: items,
    environment: environment,
    itemToString: itemToString
  }, state)); // Scroll on highlighted item if change comes from keyboard.

  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    itemRefs: itemRefs,
    scrollIntoView: scrollIntoView,
    getItemNodeFromIndex: getItemNodeFromIndex
  });
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  }); // Focus the input on first render if required.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    var focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;

    if (focusOnOpen && inputRef.current) {
      inputRef.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (isInitialMountRef.current) {
      return;
    }

    previousResultCountRef.current = items.length;
  }); // Add mouse/touch events to document.

  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [comboboxRef, menuRef, toggleButtonRef], environment, function () {
    dispatch({
      type: InputBlur,
      selectItem: false
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getInputProps', 'getComboboxProps', 'getMenuProps'); // Make initial ref false.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    isInitialMountRef.current = false;
  }, []); // Reset itemRefs on close.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);
  /* Event handler functions */

  var inputKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowDown,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch({
          type: InputKeyDownArrowUp,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Home: function Home(event) {
        if (!latest.current.state.isOpen) {
          return;
        }

        event.preventDefault();
        dispatch({
          type: InputKeyDownHome,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      End: function End(event) {
        if (!latest.current.state.isOpen) {
          return;
        }

        event.preventDefault();
        dispatch({
          type: InputKeyDownEnd,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        var latestState = latest.current.state;

        if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
          dispatch({
            type: InputKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        var latestState = latest.current.state; // if closed or no highlighted index, do nothing.

        if (!latestState.isOpen || latestState.highlightedIndex < 0 || event.which === 229 // if IME composing, wait for next Enter keydown event.
        ) {
          return;
        }

        event.preventDefault();
        dispatch({
          type: InputKeyDownEnter,
          getItemNodeFromIndex: getItemNodeFromIndex
        });
      }
    };
  }, [dispatch, latest, getItemNodeFromIndex]); // Getter props.

  var getLabelProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (labelProps) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      id: elementIds.labelId,
      htmlFor: elementIds.inputId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp, _temp2) {
    var _extends2;

    var _ref = _temp === void 0 ? {} : _temp,
        onMouseLeave = _ref.onMouseLeave,
        _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
        ref = _ref.ref,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, _excluded$1);

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$suppressRefErro = _ref2.suppressRefError,
        suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

    setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, function () {
      dispatch({
        type: MenuMouseLeave
      });
    }), _extends2), rest);
  }, [dispatch, setGetterPropCallInfo, elementIds]);
  var getItemProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp3) {
    var _extends3, _ref4;

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        item = _ref3.item,
        index = _ref3.index,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
        ref = _ref3.ref,
        onMouseMove = _ref3.onMouseMove,
        onClick = _ref3.onClick;
        _ref3.onPress;
        var rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, _excluded2$1);

    var _latest$current = latest.current,
        latestProps = _latest$current.props,
        latestState = _latest$current.state;
    var itemIndex = getItemIndex(index, item, latestProps.items);

    if (itemIndex < 0) {
      throw new Error('Pass either item or item index in getItemProps!');
    }

    var onSelectKey = 'onClick';
    var customClickHandler = onClick;

    var itemHandleMouseMove = function itemHandleMouseMove() {
      if (index === latestState.highlightedIndex) {
        return;
      }

      shouldScrollRef.current = false;
      dispatch({
        type: ItemMouseMove,
        index: index
      });
    };

    var itemHandleClick = function itemHandleClick() {
      dispatch({
        type: ItemClick,
        index: index
      });

      if (inputRef.current) {
        inputRef.current.focus();
      }
    };

    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
      }
    }), _extends3.role = 'option', _extends3['aria-selected'] = "" + (itemIndex === latestState.highlightedIndex), _extends3.id = elementIds.getItemId(itemIndex), _extends3), !rest.disabled && (_ref4 = {
      onMouseMove: callAllEventHandlers(onMouseMove, itemHandleMouseMove)
    }, _ref4[onSelectKey] = callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), rest);
  }, [dispatch, latest, shouldScrollRef, elementIds]);
  var getToggleButtonProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp4) {
    var _extends4;

    var _ref5 = _temp4 === void 0 ? {} : _temp4,
        onClick = _ref5.onClick;
        _ref5.onPress;
        var _ref5$refKey = _ref5.refKey,
        refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
        ref = _ref5.ref,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref5, _excluded3);

    var toggleButtonHandleClick = function toggleButtonHandleClick() {
      dispatch({
        type: ToggleButtonClick
      });

      if (!latest.current.state.isOpen && inputRef.current) {
        inputRef.current.focus();
      }
    };

    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, {
      onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
    }), rest);
  }, [dispatch, latest, elementIds]);
  var getInputProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp5, _temp6) {
    var _extends5;

    var _ref6 = _temp5 === void 0 ? {} : _temp5,
        onKeyDown = _ref6.onKeyDown,
        onChange = _ref6.onChange,
        onInput = _ref6.onInput,
        onBlur = _ref6.onBlur;
        _ref6.onChangeText;
        var _ref6$refKey = _ref6.refKey,
        refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey,
        ref = _ref6.ref,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref6, _excluded4);

    var _ref7 = _temp6 === void 0 ? {} : _temp6,
        _ref7$suppressRefErro = _ref7.suppressRefError,
        suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;

    setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
    var latestState = latest.current.state;

    var inputHandleKeyDown = function inputHandleKeyDown(event) {
      var key = normalizeArrowKey(event);

      if (key && inputKeyDownHandlers[key]) {
        inputKeyDownHandlers[key](event);
      }
    };

    var inputHandleChange = function inputHandleChange(event) {
      dispatch({
        type: InputChange,
        inputValue: event.target.value
      });
    };

    var inputHandleBlur = function inputHandleBlur() {
      /* istanbul ignore else */
      if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
        dispatch({
          type: InputBlur,
          selectItem: true
        });
      }
    };
    /* istanbul ignore next (preact) */


    var onChangeKey = 'onChange';
    var eventHandlers = {};

    if (!rest.disabled) {
      var _eventHandlers;

      eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function (inputNode) {
      inputRef.current = inputNode;
    }), _extends5.id = elementIds.inputId, _extends5['aria-autocomplete'] = 'list', _extends5['aria-controls'] = elementIds.menuId, _extends5), latestState.isOpen && latestState.highlightedIndex > -1 && {
      'aria-activedescendant': elementIds.getItemId(latestState.highlightedIndex)
    }, {
      'aria-labelledby': elementIds.labelId,
      // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
      // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
      autoComplete: 'off',
      value: latestState.inputValue
    }, eventHandlers, rest);
  }, [dispatch, inputKeyDownHandlers, latest, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds]);
  var getComboboxProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp7, _temp8) {
    var _extends6;

    var _ref8 = _temp7 === void 0 ? {} : _temp7,
        _ref8$refKey = _ref8.refKey,
        refKey = _ref8$refKey === void 0 ? 'ref' : _ref8$refKey,
        ref = _ref8.ref,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref8, _excluded5);

    var _ref9 = _temp8 === void 0 ? {} : _temp8,
        _ref9$suppressRefErro = _ref9.suppressRefError,
        suppressRefError = _ref9$suppressRefErro === void 0 ? false : _ref9$suppressRefErro;

    setGetterPropCallInfo('getComboboxProps', suppressRefError, refKey, comboboxRef);
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends6 = {}, _extends6[refKey] = handleRefs(ref, function (comboboxNode) {
      comboboxRef.current = comboboxNode;
    }), _extends6.role = 'combobox', _extends6['aria-haspopup'] = 'listbox', _extends6['aria-owns'] = elementIds.menuId, _extends6['aria-expanded'] = latest.current.state.isOpen, _extends6), rest);
  }, [latest, setGetterPropCallInfo, elementIds]); // returns

  var toggleMenu = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionToggleMenu
    });
  }, [dispatch]);
  var closeMenu = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionCloseMenu
    });
  }, [dispatch]);
  var openMenu = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionOpenMenu
    });
  }, [dispatch]);
  var setHighlightedIndex = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (newHighlightedIndex) {
    dispatch({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch]);
  var selectItem = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (newSelectedItem) {
    dispatch({
      type: FunctionSelectItem,
      selectedItem: newSelectedItem
    });
  }, [dispatch]);
  var setInputValue = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (newInputValue) {
    dispatch({
      type: FunctionSetInputValue,
      inputValue: newInputValue
    });
  }, [dispatch]);
  var reset = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionReset$1
    });
  }, [dispatch]);
  return {
    // prop getters.
    getItemProps: getItemProps,
    getLabelProps: getLabelProps,
    getMenuProps: getMenuProps,
    getInputProps: getInputProps,
    getComboboxProps: getComboboxProps,
    getToggleButtonProps: getToggleButtonProps,
    // actions.
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    setHighlightedIndex: setHighlightedIndex,
    setInputValue: setInputValue,
    selectItem: selectItem,
    reset: reset,
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    inputValue: inputValue
  };
}

var defaultStateValues = {
  activeIndex: -1,
  selectedItems: []
};
/**
 * Returns the initial value for a state key in the following order:
 * 1. controlled prop, 2. initial prop, 3. default prop, 4. default
 * value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */

function getInitialValue(props, propKey) {
  return getInitialValue$1(props, propKey, defaultStateValues);
}
/**
 * Returns the default value for a state key in the following order:
 * 1. controlled prop, 2. default prop, 3. default value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */


function getDefaultValue(props, propKey) {
  return getDefaultValue$1(props, propKey, defaultStateValues);
}
/**
 * Gets the initial state based on the provided props. It uses initial, default
 * and controlled props related to state in order to compute the initial value.
 *
 * @param {Object} props Props passed to the hook.
 * @returns {Object} The initial state.
 */


function getInitialState(props) {
  var activeIndex = getInitialValue(props, 'activeIndex');
  var selectedItems = getInitialValue(props, 'selectedItems');
  return {
    activeIndex: activeIndex,
    selectedItems: selectedItems
  };
}
/**
 * Returns true if dropdown keydown operation is permitted. Should not be
 * allowed on keydown with modifier keys (ctrl, alt, shift, meta), on
 * input element with text content that is either highlighted or selection
 * cursor is not at the starting position.
 *
 * @param {KeyboardEvent} event The event from keydown.
 * @returns {boolean} Whether the operation is allowed.
 */


function isKeyDownOperationPermitted(event) {
  if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
    return false;
  }

  var element = event.target;

  if (element instanceof HTMLInputElement && // if element is a text input
  element.value !== '' && (element.selectionStart !== 0 || element.selectionEnd !== 0)) {
    return false;
  }

  return true;
}
/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */


function getA11yRemovalMessage(selectionParameters) {
  var removedSelectedItem = selectionParameters.removedSelectedItem,
      itemToStringLocal = selectionParameters.itemToString;
  return itemToStringLocal(removedSelectedItem) + " has been removed.";
}

var propTypes = {
  selectedItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  initialSelectedItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  defaultSelectedItems: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array,
  itemToString: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  getA11yRemovalMessage: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  stateReducer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  initialActiveIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  onActiveIndexChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onSelectedItemsChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  keyNavigationNext: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  keyNavigationPrevious: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  environment: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    addEventListener: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    removeEventListener: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    document: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
      getElementById: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
      activeElement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
      body: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
    })
  })
};
var defaultProps = {
  itemToString: defaultProps$3.itemToString,
  stateReducer: defaultProps$3.stateReducer,
  environment: defaultProps$3.environment,
  getA11yRemovalMessage: getA11yRemovalMessage,
  keyNavigationNext: 'ArrowRight',
  keyNavigationPrevious: 'ArrowLeft'
}; // eslint-disable-next-line import/no-mutable-exports

var validatePropTypes = noop;
/* istanbul ignore next */

if (false) {
  validatePropTypes = function validatePropTypes(options, caller) {
    PropTypes.checkPropTypes(propTypes, options, 'prop', caller.name);
  };
}

var SelectedItemClick =  false ? '__selected_item_click__' : 0;
var SelectedItemKeyDownDelete =  false ? '__selected_item_keydown_delete__' : 1;
var SelectedItemKeyDownBackspace =  false ? '__selected_item_keydown_backspace__' : 2;
var SelectedItemKeyDownNavigationNext =  false ? '__selected_item_keydown_navigation_next__' : 3;
var SelectedItemKeyDownNavigationPrevious =  false ? '__selected_item_keydown_navigation_previous__' : 4;
var DropdownKeyDownNavigationPrevious =  false ? '__dropdown_keydown_navigation_previous__' : 5;
var DropdownKeyDownBackspace =  false ? '__dropdown_keydown_backspace__' : 6;
var DropdownClick =  false ? '__dropdown_click__' : 7;
var FunctionAddSelectedItem =  false ? '__function_add_selected_item__' : 8;
var FunctionRemoveSelectedItem =  false ? '__function_remove_selected_item__' : 9;
var FunctionSetSelectedItems =  false ? '__function_set_selected_items__' : 10;
var FunctionSetActiveIndex =  false ? '__function_set_active_index__' : 11;
var FunctionReset =  false ? '__function_reset__' : 12;

var stateChangeTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SelectedItemClick: SelectedItemClick,
  SelectedItemKeyDownDelete: SelectedItemKeyDownDelete,
  SelectedItemKeyDownBackspace: SelectedItemKeyDownBackspace,
  SelectedItemKeyDownNavigationNext: SelectedItemKeyDownNavigationNext,
  SelectedItemKeyDownNavigationPrevious: SelectedItemKeyDownNavigationPrevious,
  DropdownKeyDownNavigationPrevious: DropdownKeyDownNavigationPrevious,
  DropdownKeyDownBackspace: DropdownKeyDownBackspace,
  DropdownClick: DropdownClick,
  FunctionAddSelectedItem: FunctionAddSelectedItem,
  FunctionRemoveSelectedItem: FunctionRemoveSelectedItem,
  FunctionSetSelectedItems: FunctionSetSelectedItems,
  FunctionSetActiveIndex: FunctionSetActiveIndex,
  FunctionReset: FunctionReset
});

/* eslint-disable complexity */

function downshiftMultipleSelectionReducer(state, action) {
  var type = action.type,
      index = action.index,
      props = action.props,
      selectedItem = action.selectedItem;
  var activeIndex = state.activeIndex,
      selectedItems = state.selectedItems;
  var changes;

  switch (type) {
    case SelectedItemClick:
      changes = {
        activeIndex: index
      };
      break;

    case SelectedItemKeyDownNavigationPrevious:
      changes = {
        activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
      };
      break;

    case SelectedItemKeyDownNavigationNext:
      changes = {
        activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
      };
      break;

    case SelectedItemKeyDownBackspace:
    case SelectedItemKeyDownDelete:
      {
        var newActiveIndex = activeIndex;

        if (selectedItems.length === 1) {
          newActiveIndex = -1;
        } else if (activeIndex === selectedItems.length - 1) {
          newActiveIndex = selectedItems.length - 2;
        }

        changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
        }, {
          activeIndex: newActiveIndex
        });
        break;
      }

    case DropdownKeyDownNavigationPrevious:
      changes = {
        activeIndex: selectedItems.length - 1
      };
      break;

    case DropdownKeyDownBackspace:
      changes = {
        selectedItems: selectedItems.slice(0, selectedItems.length - 1)
      };
      break;

    case FunctionAddSelectedItem:
      changes = {
        selectedItems: [].concat(selectedItems, [selectedItem])
      };
      break;

    case DropdownClick:
      changes = {
        activeIndex: -1
      };
      break;

    case FunctionRemoveSelectedItem:
      {
        var _newActiveIndex = activeIndex;
        var selectedItemIndex = selectedItems.indexOf(selectedItem);

        if (selectedItems.length === 1) {
          _newActiveIndex = -1;
        } else if (selectedItemIndex === selectedItems.length - 1) {
          _newActiveIndex = selectedItems.length - 2;
        }

        changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1))
        }, {
          activeIndex: _newActiveIndex
        });
        break;
      }

    case FunctionSetSelectedItems:
      {
        var newSelectedItems = action.selectedItems;
        changes = {
          selectedItems: newSelectedItems
        };
        break;
      }

    case FunctionSetActiveIndex:
      {
        var _newActiveIndex2 = action.activeIndex;
        changes = {
          activeIndex: _newActiveIndex2
        };
        break;
      }

    case FunctionReset:
      changes = {
        activeIndex: getDefaultValue(props, 'activeIndex'),
        selectedItems: getDefaultValue(props, 'selectedItems')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, changes);
}

var _excluded = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"],
    _excluded2 = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
useMultipleSelection.stateChangeTypes = stateChangeTypes;

function useMultipleSelection(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  validatePropTypes(userProps, useMultipleSelection); // Props defaults and destructuring.

  var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps, userProps);

  var getA11yRemovalMessage = props.getA11yRemovalMessage,
      itemToString = props.itemToString,
      environment = props.environment,
      keyNavigationNext = props.keyNavigationNext,
      keyNavigationPrevious = props.keyNavigationPrevious; // Reducer init.

  var _useControlledReducer = useControlledReducer$1(downshiftMultipleSelectionReducer, getInitialState(props), props),
      state = _useControlledReducer[0],
      dispatch = _useControlledReducer[1];

  var activeIndex = state.activeIndex,
      selectedItems = state.selectedItems; // Refs.

  var isInitialMountRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true);
  var dropdownRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var previousSelectedItemsRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(selectedItems);
  var selectedItemRefs = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  selectedItemRefs.current = [];
  var latest = useLatestRef({
    state: state,
    props: props
  }); // Effects.

  /* Sets a11y status message on changes in selectedItem. */

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (isInitialMountRef.current) {
      return;
    }

    if (selectedItems.length < previousSelectedItemsRef.current.length) {
      var removedSelectedItem = previousSelectedItemsRef.current.find(function (item) {
        return selectedItems.indexOf(item) < 0;
      });
      setStatus(getA11yRemovalMessage({
        itemToString: itemToString,
        resultCount: selectedItems.length,
        removedSelectedItem: removedSelectedItem,
        activeIndex: activeIndex,
        activeSelectedItem: selectedItems[activeIndex]
      }), environment.document);
    }

    previousSelectedItemsRef.current = selectedItems; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems.length]); // Sets focus on active item.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (isInitialMountRef.current) {
      return;
    }

    if (activeIndex === -1 && dropdownRef.current) {
      dropdownRef.current.focus();
    } else if (selectedItemRefs.current[activeIndex]) {
      selectedItemRefs.current[activeIndex].focus();
    }
  }, [activeIndex]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props: props,
    state: state
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker('getDropdownProps'); // Make initial ref false.

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    isInitialMountRef.current = false;
  }, []); // Event handler functions.

  var selectedItemKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    var _ref;

    return _ref = {}, _ref[keyNavigationPrevious] = function () {
      dispatch({
        type: SelectedItemKeyDownNavigationPrevious
      });
    }, _ref[keyNavigationNext] = function () {
      dispatch({
        type: SelectedItemKeyDownNavigationNext
      });
    }, _ref.Delete = function Delete() {
      dispatch({
        type: SelectedItemKeyDownDelete
      });
    }, _ref.Backspace = function Backspace() {
      dispatch({
        type: SelectedItemKeyDownBackspace
      });
    }, _ref;
  }, [dispatch, keyNavigationNext, keyNavigationPrevious]);
  var dropdownKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useMemo"])(function () {
    var _ref2;

    return _ref2 = {}, _ref2[keyNavigationPrevious] = function (event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch({
          type: DropdownKeyDownNavigationPrevious
        });
      }
    }, _ref2.Backspace = function Backspace(event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch({
          type: DropdownKeyDownBackspace
        });
      }
    }, _ref2;
  }, [dispatch, keyNavigationPrevious]); // Getter props.

  var getSelectedItemProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp) {
    var _extends2;

    var _ref3 = _temp === void 0 ? {} : _temp,
        _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
        ref = _ref3.ref,
        onClick = _ref3.onClick,
        onKeyDown = _ref3.onKeyDown,
        selectedItem = _ref3.selectedItem,
        index = _ref3.index,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, _excluded);

    var latestState = latest.current.state;
    var itemIndex = getItemIndex(index, selectedItem, latestState.selectedItems);

    if (itemIndex < 0) {
      throw new Error('Pass either selectedItem or index in getSelectedItemProps!');
    }

    var selectedItemHandleClick = function selectedItemHandleClick() {
      dispatch({
        type: SelectedItemClick,
        index: index
      });
    };

    var selectedItemHandleKeyDown = function selectedItemHandleKeyDown(event) {
      var key = normalizeArrowKey(event);

      if (key && selectedItemKeyDownHandlers[key]) {
        selectedItemKeyDownHandlers[key](event);
      }
    };

    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (selectedItemNode) {
      if (selectedItemNode) {
        selectedItemRefs.current.push(selectedItemNode);
      }
    }), _extends2.tabIndex = index === latestState.activeIndex ? 0 : -1, _extends2.onClick = callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
  }, [dispatch, latest, selectedItemKeyDownHandlers]);
  var getDropdownProps = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (_temp2, _temp3) {
    var _extends3;

    var _ref4 = _temp2 === void 0 ? {} : _temp2,
        _ref4$refKey = _ref4.refKey,
        refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
        ref = _ref4.ref,
        onKeyDown = _ref4.onKeyDown,
        onClick = _ref4.onClick,
        _ref4$preventKeyActio = _ref4.preventKeyAction,
        preventKeyAction = _ref4$preventKeyActio === void 0 ? false : _ref4$preventKeyActio,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref4, _excluded2);

    var _ref5 = _temp3 === void 0 ? {} : _temp3,
        _ref5$suppressRefErro = _ref5.suppressRefError,
        suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;

    setGetterPropCallInfo('getDropdownProps', suppressRefError, refKey, dropdownRef);

    var dropdownHandleKeyDown = function dropdownHandleKeyDown(event) {
      var key = normalizeArrowKey(event);

      if (key && dropdownKeyDownHandlers[key]) {
        dropdownKeyDownHandlers[key](event);
      }
    };

    var dropdownHandleClick = function dropdownHandleClick() {
      dispatch({
        type: DropdownClick
      });
    };

    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (dropdownNode) {
      if (dropdownNode) {
        dropdownRef.current = dropdownNode;
      }
    }), _extends3), !preventKeyAction && {
      onKeyDown: callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
      onClick: callAllEventHandlers(onClick, dropdownHandleClick)
    }, rest);
  }, [dispatch, dropdownKeyDownHandlers, setGetterPropCallInfo]); // returns

  var addSelectedItem = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (selectedItem) {
    dispatch({
      type: FunctionAddSelectedItem,
      selectedItem: selectedItem
    });
  }, [dispatch]);
  var removeSelectedItem = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (selectedItem) {
    dispatch({
      type: FunctionRemoveSelectedItem,
      selectedItem: selectedItem
    });
  }, [dispatch]);
  var setSelectedItems = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (newSelectedItems) {
    dispatch({
      type: FunctionSetSelectedItems,
      selectedItems: newSelectedItems
    });
  }, [dispatch]);
  var setActiveIndex = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (newActiveIndex) {
    dispatch({
      type: FunctionSetActiveIndex,
      activeIndex: newActiveIndex
    });
  }, [dispatch]);
  var reset = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function () {
    dispatch({
      type: FunctionReset
    });
  }, [dispatch]);
  return {
    getSelectedItemProps: getSelectedItemProps,
    getDropdownProps: getDropdownProps,
    addSelectedItem: addSelectedItem,
    removeSelectedItem: removeSelectedItem,
    setSelectedItems: setSelectedItems,
    setActiveIndex: setActiveIndex,
    reset: reset,
    selectedItems: selectedItems,
    activeIndex: activeIndex
  };
}




/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(724);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}/* harmony default export */ __webpack_exports__["a"] = (function(e,i){var o=window,l=i.scrollMode,d=i.block,u=i.inline,h=i.boundary,a=i.skipOverflowHiddenElements,c="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var f=document.scrollingElement||document.documentElement,s=[],p=e;t(p)&&c(p);){if((p=p.parentElement)===f){s.push(p);break}null!=p&&p===document.body&&n(p)&&!n(document.documentElement)||null!=p&&n(p,a)&&s.push(p)}for(var m=o.visualViewport?o.visualViewport.width:innerWidth,g=o.visualViewport?o.visualViewport.height:innerHeight,w=window.scrollX||pageXOffset,v=window.scrollY||pageYOffset,W=e.getBoundingClientRect(),b=W.height,H=W.width,y=W.top,E=W.right,M=W.bottom,V=W.left,x="start"===d||"nearest"===d?y:"end"===d?M:y+b/2,I="center"===u?V+H/2:"end"===u?E:V,C=[],T=0;T<s.length;T++){var k=s[T],B=k.getBoundingClientRect(),D=B.height,O=B.width,R=B.top,X=B.right,Y=B.bottom,L=B.left;if("if-needed"===l&&y>=0&&V>=0&&M<=g&&E<=m&&y>=R&&M<=Y&&V>=L&&E<=X)return C;var S=getComputedStyle(k),j=parseInt(S.borderLeftWidth,10),q=parseInt(S.borderTopWidth,10),z=parseInt(S.borderRightWidth,10),A=parseInt(S.borderBottomWidth,10),F=0,G=0,J="offsetWidth"in k?k.offsetWidth-k.clientWidth-j-z:0,K="offsetHeight"in k?k.offsetHeight-k.clientHeight-q-A:0;if(f===k)F="start"===d?x:"end"===d?x-g:"nearest"===d?r(v,v+g,g,q,A,v+x,v+x+b,b):x-g/2,G="start"===u?I:"center"===u?I-m/2:"end"===u?I-m:r(w,w+m,m,j,z,w+I,w+I+H,H),F=Math.max(0,F+v),G=Math.max(0,G+w);else{F="start"===d?x-R-q:"end"===d?x-Y+A+K:"nearest"===d?r(R,Y,D,q,A+K,x,x+b,b):x-(R+D/2)+K/2,G="start"===u?I-L-j:"center"===u?I-(L+O/2)+J/2:"end"===u?I-X+z+J:r(L,X,O,j,z+J,I,I+H,H);var N=k.scrollLeft,P=k.scrollTop;x+=P-(F=Math.max(0,Math.min(P+F,k.scrollHeight-D+K))),I+=N-(G=Math.max(0,Math.min(N+G,k.scrollWidth-O+J)))}C.push({el:k,top:F,left:G})}return C});
//# sourceMappingURL=index.module.js.map


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(61);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(225);





var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

function getUniqueId() {
  var key = '__global_unique_id__';
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + getUniqueId() + '__';

  var Provider = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_Component2) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(732)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(61);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usePopper__ = __webpack_require__(636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reference", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "usePopper", function() { return __WEBPACK_IMPORTED_MODULE_3__usePopper__["a"]; });
// Public components




 // Public types

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usePopper__ = __webpack_require__(636);





var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__Manager__["b" /* ManagerReferenceNodeContext */]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* setRef */])(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = Object(__WEBPACK_IMPORTED_MODULE_3__usePopper__["a" /* usePopper */])(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* unwrapArray */])(children)(childrenProps);
}

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_index_js__ = __webpack_require__(637);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPopper_js__ = __webpack_require__(345);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */
/* unused harmony reexport createPopperBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popper_js__ = __webpack_require__(755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__popper_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popper_lite_js__ = __webpack_require__(651);
/* unused harmony reexport createPopperLite */

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTableElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNodeName_js__ = __webpack_require__(92);

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_0__getNodeName_js__["a" /* default */])(element)) >= 0;
}

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOppositePlacement;
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOppositeVariationPlacement;
var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getClippingRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getViewportRect_js__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDocumentRect_js__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listScrollParents_js__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getOffsetParent_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getComputedStyle_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__instanceOf_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getBoundingClientRect_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getParentNode_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contains_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getNodeName_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_math_js__ = __webpack_require__(93);















function getInnerBoundingClientRect(element) {
  var rect = Object(__WEBPACK_IMPORTED_MODULE_8__getBoundingClientRect_js__["a" /* default */])(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === __WEBPACK_IMPORTED_MODULE_0__enums_js__["o" /* viewport */] ? Object(__WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getViewportRect_js__["a" /* default */])(element)) : Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clippingParent) ? getInnerBoundingClientRect(clippingParent) : Object(__WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__getDocumentRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__["a" /* default */])(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = Object(__WEBPACK_IMPORTED_MODULE_3__listScrollParents_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__getParentNode_js__["a" /* default */])(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_6__getComputedStyle_js__["a" /* default */])(element).position) >= 0;
  var clipperElement = canEscapeClipping && Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["b" /* isHTMLElement */])(element) ? Object(__WEBPACK_IMPORTED_MODULE_4__getOffsetParent_js__["a" /* default */])(element) : element;

  if (!Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clippingParent) && Object(__WEBPACK_IMPORTED_MODULE_10__contains_js__["a" /* default */])(clippingParent, clipperElement) && Object(__WEBPACK_IMPORTED_MODULE_11__getNodeName_js__["a" /* default */])(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["a" /* max */])(rect.top, accRect.top);
    accRect.right = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["b" /* min */])(rect.right, accRect.right);
    accRect.bottom = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["b" /* min */])(rect.bottom, accRect.bottom);
    accRect.left = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["a" /* max */])(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getViewportRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__ = __webpack_require__(341);



function getViewportRect(element) {
  var win = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element);
  var html = Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__["a" /* default */])(element),
    y: y
  };
}

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getDocumentElement_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getComputedStyle_js__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getWindowScroll_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math_js__ = __webpack_require__(93);




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = Object(__WEBPACK_IMPORTED_MODULE_0__getDocumentElement_js__["a" /* default */])(element);
  var winScroll = Object(__WEBPACK_IMPORTED_MODULE_3__getWindowScroll_js__["a" /* default */])(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__["a" /* default */])(element);
  var y = -winScroll.scrollTop;

  if (Object(__WEBPACK_IMPORTED_MODULE_1__getComputedStyle_js__["a" /* default */])(body || html).direction === 'rtl') {
    x += Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getParentNode_js__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isScrollParent_js__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNodeName_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(32);




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_2__getNodeName_js__["a" /* default */])(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(node) && Object(__WEBPACK_IMPORTED_MODULE_1__isScrollParent_js__["a" /* default */])(node)) {
    return node;
  }

  return getScrollParent(Object(__WEBPACK_IMPORTED_MODULE_0__getParentNode_js__["a" /* default */])(node));
}

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeAutoPlacement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getVariation_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detectOverflow_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getBasePlacement_js__ = __webpack_require__(78);




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? __WEBPACK_IMPORTED_MODULE_1__enums_js__["h" /* placements */] : _options$allowedAutoP;
  var variation = Object(__WEBPACK_IMPORTED_MODULE_0__getVariation_js__["a" /* default */])(placement);
  var placements = variation ? flipVariations ? __WEBPACK_IMPORTED_MODULE_1__enums_js__["n" /* variationPlacements */] : __WEBPACK_IMPORTED_MODULE_1__enums_js__["n" /* variationPlacements */].filter(function (placement) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getVariation_js__["a" /* default */])(placement) === variation;
  }) : __WEBPACK_IMPORTED_MODULE_1__enums_js__["b" /* basePlacements */];
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = Object(__WEBPACK_IMPORTED_MODULE_2__detectOverflow_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[Object(__WEBPACK_IMPORTED_MODULE_3__getBasePlacement_js__["a" /* default */])(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAltAxis;
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCompositeRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNodeScroll_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNodeName_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getWindowScrollBarX_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isScrollParent_js__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math_js__ = __webpack_require__(93);









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(rect.width) / element.offsetWidth || 1;
  var scaleY = Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent);
  var offsetParentIsScaled = Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent) && isElementScaled(offsetParent);
  var documentElement = Object(__WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__["a" /* default */])(offsetParent);
  var rect = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__getNodeName_js__["a" /* default */])(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    Object(__WEBPACK_IMPORTED_MODULE_6__isScrollParent_js__["a" /* default */])(documentElement)) {
      scroll = Object(__WEBPACK_IMPORTED_MODULE_1__getNodeScroll_js__["a" /* default */])(offsetParent);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent)) {
      offsets = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = Object(__WEBPACK_IMPORTED_MODULE_4__getWindowScrollBarX_js__["a" /* default */])(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindowScroll_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getWindow_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instanceOf_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getHTMLElementScroll_js__ = __webpack_require__(748);




function getNodeScroll(node) {
  if (node === Object(__WEBPACK_IMPORTED_MODULE_1__getWindow_js__["a" /* default */])(node) || !Object(__WEBPACK_IMPORTED_MODULE_2__instanceOf_js__["b" /* isHTMLElement */])(node)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getWindowScroll_js__["a" /* default */])(node);
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_3__getHTMLElementScroll_js__["a" /* default */])(node);
  }
}

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHTMLElementScroll;
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = orderModifiers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(26);
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return __WEBPACK_IMPORTED_MODULE_0__enums_js__["g" /* modifierPhases */].reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_js__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(26);


var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (__WEBPACK_IMPORTED_MODULE_1__enums_js__["g" /* modifierPhases */].indexOf(modifier.phase) < 0) {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + __WEBPACK_IMPORTED_MODULE_1__enums_js__["g" /* modifierPhases */].join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeByName;
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPopper; });
/* unused harmony export defaultModifiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPopper_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modifiers_offset_js__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modifiers_flip_js__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modifiers_preventOverflow_js__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modifiers_arrow_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modifiers_hide_js__ = __webpack_require__(648);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__popper_lite_js__ = __webpack_require__(651);
/* unused harmony reexport createPopperLite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modifiers_index_js__ = __webpack_require__(637);
/* unused harmony namespace reexport */










var defaultModifiers = [__WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modifiers_offset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modifiers_flip_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modifiers_preventOverflow_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modifiers_arrow_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__modifiers_hide_js__["a" /* default */]];
var createPopper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__createPopper_js__["a" /* popperGenerator */])({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 756 */
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Manager__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(335);




function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_2__Manager__["c" /* ManagerReferenceNodeSetterContext */]);
  var refHandler = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (node) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* setRef */])(innerRef, node);
    Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* safeInvoke */])(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* setRef */])(innerRef, null);
    };
  });
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    __WEBPACK_IMPORTED_MODULE_1_warning___default()(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* unwrapArray */])(children)({
    ref: refHandler
  });
}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Formik", function() { return Formik; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yupToFormErrors", function() { return yupToFormErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateYupSchema", function() { return validateYupSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return Field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withFormik", function() { return withFormik; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "move", function() { return move; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "swap", function() { return swap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insert", function() { return insert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FieldArray", function() { return FieldArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIn", function() { return getIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setIn", function() { return setIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNestedObjectValues", function() { return setNestedObjectValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInteger", function() { return isInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return isNaN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmptyChildren", function() { return isEmptyChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActiveElement", function() { return getActiveElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FastField", function() { return FastField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormikProvider", function() { return FormikProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormikConsumer", function() { return FormikConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return connect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_context__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_clonedeep__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_clonedeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_topath__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_topath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_topath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_fast_compare__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_deepmerge__ = __webpack_require__(767);










var _a;
var FormikProvider = (_a = __WEBPACK_IMPORTED_MODULE_3_create_react_context___default()({}), _a.Provider), FormikConsumer = _a.Consumer;
function connect(Comp) {
    var C = function (props) { return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(FormikConsumer, null, function (formik) { return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Comp, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, props, { formik: formik })); })); };
    C.WrappedComponent = Comp;
    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Comp);
}

function getIn(obj, key, def, p) {
    if (p === void 0) { p = 0; }
    var path = __WEBPACK_IMPORTED_MODULE_5_lodash_topath___default()(key);
    while (obj && p < path.length) {
        obj = obj[path[p++]];
    }
    return obj === undefined ? def : obj;
}
function setIn(obj, path, value) {
    var res = {};
    var resVal = res;
    var i = 0;
    var pathArray = __WEBPACK_IMPORTED_MODULE_5_lodash_topath___default()(path);
    for (; i < pathArray.length - 1; i++) {
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (resVal[currentPath]) {
            resVal = resVal[currentPath];
        }
        else if (currentObj) {
            resVal = resVal[currentPath] = __WEBPACK_IMPORTED_MODULE_4_lodash_clonedeep___default()(currentObj);
        }
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] =
                isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    }
    resVal[pathArray[i]] = value;
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, obj, res);
}
function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) { visited = new WeakMap(); }
    if (response === void 0) { response = {}; }
    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
        var k = _a[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true);
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        }
        else {
            response[k] = value;
        }
    }
    return response;
}
var isFunction = function (obj) {
    return typeof obj === 'function';
};
var isObject = function (obj) {
    return obj !== null && typeof obj === 'object';
};
var isInteger = function (obj) {
    return String(Math.floor(Number(obj))) === obj;
};
var isString = function (obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
var isNaN = function (obj) { return obj !== obj; };
var isEmptyChildren = function (children) {
    return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children) === 0;
};
var isPromise = function (value) {
    return isObject(value) && isFunction(value.then);
};
function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') {
        return null;
    }
    try {
        return doc.activeElement || doc.body;
    }
    catch (e) {
        return doc.body;
    }
}

var Formik = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(Formik, _super);
    function Formik(props) {
        var _this = _super.call(this, props) || this;
        _this.hcCache = {};
        _this.hbCache = {};
        _this.registerField = function (name, fns) {
            _this.fields[name] = fns;
        };
        _this.unregisterField = function (name) {
            delete _this.fields[name];
        };
        _this.setErrors = function (errors) {
            _this.setState({ errors: errors });
        };
        _this.setTouched = function (touched) {
            _this.setState({ touched: touched }, function () {
                if (_this.props.validateOnBlur) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.setValues = function (values) {
            _this.setState({ values: values }, function () {
                if (_this.props.validateOnChange) {
                    _this.runValidations(values);
                }
            });
        };
        _this.setStatus = function (status) {
            _this.setState({ status: status });
        };
        _this.setError = function (error) {
            if (false) {
                console.warn("Warning: Formik's setError(error) is deprecated and may be removed in future releases. Please use Formik's setStatus(status) instead. It works identically. For more info see https://github.com/jaredpalmer/formik#setstatus-status-any--void");
            }
            _this.setState({ error: error });
        };
        _this.setSubmitting = function (isSubmitting) {
            _this.setState({ isSubmitting: isSubmitting });
        };
        _this.validateField = function (field) {
            _this.setState({ isValidating: true });
            _this.runSingleFieldLevelValidation(field, getIn(_this.state.values, field)).then(function (error) {
                if (!!error && _this.didMount) {
                    _this.setState({
                        errors: setIn(_this.state.errors, field, error),
                        isValidating: false,
                    });
                }
            });
        };
        _this.runSingleFieldLevelValidation = function (field, value) {
            return new Promise(function (resolve) { return resolve(_this.fields[field].validate(value)); });
        };
        _this.runValidationSchema = function (values) {
            return new Promise(function (resolve) {
                var validationSchema = _this.props.validationSchema;
                var schema = isFunction(validationSchema)
                    ? validationSchema()
                    : validationSchema;
                validateYupSchema(values, schema).then(function () {
                    resolve({});
                }, function (err) {
                    resolve(yupToFormErrors(err));
                });
            });
        };
        _this.runValidations = function (values) {
            if (values === void 0) { values = _this.state.values; }
            _this.setState({ isValidating: true });
            return Promise.all([
                _this.runFieldLevelValidations(values),
                _this.props.validationSchema ? _this.runValidationSchema(values) : {},
                _this.props.validate ? _this.runValidateHandler(values) : {},
            ]).then(function (_a) {
                var fieldErrors = _a[0], schemaErrors = _a[1], handlerErrors = _a[2];
                var combinedErrors = __WEBPACK_IMPORTED_MODULE_8_deepmerge__["a" /* default */].all([
                    fieldErrors,
                    schemaErrors,
                    handlerErrors,
                ]);
                if (_this.didMount) {
                    _this.setState({ isValidating: false, errors: combinedErrors });
                }
                return combinedErrors;
            });
        };
        _this.handleChange = function (eventOrPath) {
            var executeChange = function (eventOrTextValue, maybePath) {
                var field = maybePath;
                var val = eventOrTextValue;
                var parsed;
                if (!isString(eventOrTextValue)) {
                    if (eventOrTextValue.persist) {
                        eventOrTextValue.persist();
                    }
                    var _a = eventOrTextValue.target, type = _a.type, name_1 = _a.name, id = _a.id, value = _a.value, checked = _a.checked, outerHTML = _a.outerHTML;
                    field = maybePath ? maybePath : name_1 ? name_1 : id;
                    if (!field && "production" !== 'production') {
                        warnAboutMissingIdentifier({
                            htmlContent: outerHTML,
                            documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
                            handlerName: 'handleChange',
                        });
                    }
                    val = /number|range/.test(type)
                        ? ((parsed = parseFloat(value)), isNaN(parsed) ? '' : parsed)
                        : /checkbox/.test(type) ? checked : value;
                }
                if (field) {
                    _this.setState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { values: setIn(prevState.values, field, val) })); });
                    if (_this.props.validateOnChange) {
                        _this.runValidations(setIn(_this.state.values, field, val));
                    }
                }
            };
            if (isString(eventOrPath)) {
                return isFunction(_this.hcCache[eventOrPath])
                    ? _this.hcCache[eventOrPath]
                    : (_this.hcCache[eventOrPath] = function (event) {
                        return executeChange(event, eventOrPath);
                    });
            }
            else {
                executeChange(eventOrPath);
            }
        };
        _this.setFieldValue = function (field, value, shouldValidate) {
            if (shouldValidate === void 0) { shouldValidate = true; }
            _this.setState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { values: setIn(prevState.values, field, value) })); }, function () {
                if (_this.props.validateOnChange && shouldValidate) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.handleSubmit = function (e) {
            if (e && e.preventDefault) {
                e.preventDefault();
            }
            if (false) {
                var activeElement = getActiveElement();
                if (activeElement !== null &&
                    activeElement instanceof HTMLButtonElement) {
                    warning(!!(activeElement.attributes &&
                        activeElement.attributes.getNamedItem('type')), 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.');
                }
            }
            _this.submitForm();
        };
        _this.submitForm = function () {
            _this.setState(function (prevState) { return ({
                touched: setNestedObjectValues(prevState.values, true),
                isSubmitting: true,
                submitCount: prevState.submitCount + 1,
            }); });
            return _this.runValidations().then(function (combinedErrors) {
                var isValid = Object.keys(combinedErrors).length === 0;
                if (isValid) {
                    _this.executeSubmit();
                }
                else {
                    _this.setState({ isSubmitting: false });
                }
            });
        };
        _this.executeSubmit = function () {
            _this.props.onSubmit(_this.state.values, _this.getFormikActions());
        };
        _this.handleBlur = function (eventOrString) {
            var executeBlur = function (e, path) {
                if (e.persist) {
                    e.persist();
                }
                var _a = e.target, name = _a.name, id = _a.id, outerHTML = _a.outerHTML;
                var field = path ? path : name ? name : id;
                if (!field && "production" !== 'production') {
                    warnAboutMissingIdentifier({
                        htmlContent: outerHTML,
                        documentationAnchorLink: 'handleblur-e-any--void',
                        handlerName: 'handleBlur',
                    });
                }
                _this.setState(function (prevState) { return ({
                    touched: setIn(prevState.touched, field, true),
                }); });
                if (_this.props.validateOnBlur) {
                    _this.runValidations(_this.state.values);
                }
            };
            if (isString(eventOrString)) {
                return isFunction(_this.hbCache[eventOrString])
                    ? _this.hbCache[eventOrString]
                    : (_this.hbCache[eventOrString] = function (event) {
                        return executeBlur(event, eventOrString);
                    });
            }
            else {
                executeBlur(eventOrString);
            }
        };
        _this.setFieldTouched = function (field, touched, shouldValidate) {
            if (touched === void 0) { touched = true; }
            if (shouldValidate === void 0) { shouldValidate = true; }
            _this.setState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { touched: setIn(prevState.touched, field, touched) })); }, function () {
                if (_this.props.validateOnBlur && shouldValidate) {
                    _this.runValidations(_this.state.values);
                }
            });
        };
        _this.setFieldError = function (field, message) {
            _this.setState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { errors: setIn(prevState.errors, field, message) })); });
        };
        _this.resetForm = function (nextValues) {
            var values = nextValues ? nextValues : _this.props.initialValues;
            _this.initialValues = values;
            _this.setState({
                isSubmitting: false,
                isValidating: false,
                errors: {},
                touched: {},
                error: undefined,
                status: undefined,
                values: values,
                submitCount: 0,
            });
        };
        _this.handleReset = function () {
            if (_this.props.onReset) {
                var maybePromisedOnReset = _this.props.onReset(_this.state.values, _this.getFormikActions());
                if (isPromise(maybePromisedOnReset)) {
                    maybePromisedOnReset.then(_this.resetForm);
                }
                else {
                    _this.resetForm();
                }
            }
            else {
                _this.resetForm();
            }
        };
        _this.setFormikState = function (s, callback) {
            return _this.setState(s, callback);
        };
        _this.getFormikActions = function () {
            return {
                resetForm: _this.resetForm,
                submitForm: _this.submitForm,
                validateForm: _this.runValidations,
                validateField: _this.validateField,
                setError: _this.setError,
                setErrors: _this.setErrors,
                setFieldError: _this.setFieldError,
                setFieldTouched: _this.setFieldTouched,
                setFieldValue: _this.setFieldValue,
                setStatus: _this.setStatus,
                setSubmitting: _this.setSubmitting,
                setTouched: _this.setTouched,
                setValues: _this.setValues,
                setFormikState: _this.setFormikState,
            };
        };
        _this.getFormikComputedProps = function () {
            var isInitialValid = _this.props.isInitialValid;
            var dirty = !__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(_this.initialValues, _this.state.values);
            return {
                dirty: dirty,
                isValid: dirty
                    ? _this.state.errors && Object.keys(_this.state.errors).length === 0
                    : isInitialValid !== false && isFunction(isInitialValid)
                        ? isInitialValid(_this.props)
                        : isInitialValid,
                initialValues: _this.initialValues,
            };
        };
        _this.getFormikBag = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, _this.state, _this.getFormikActions(), _this.getFormikComputedProps(), { registerField: _this.registerField, unregisterField: _this.unregisterField, handleBlur: _this.handleBlur, handleChange: _this.handleChange, handleReset: _this.handleReset, handleSubmit: _this.handleSubmit, validateOnChange: _this.props.validateOnChange, validateOnBlur: _this.props.validateOnBlur });
        };
        _this.getFormikContext = function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, _this.getFormikBag(), { validationSchema: _this.props.validationSchema, validate: _this.props.validate });
        };
        _this.state = {
            values: props.initialValues || {},
            errors: {},
            touched: {},
            isSubmitting: false,
            isValidating: false,
            submitCount: 0,
        };
        _this.didMount = false;
        _this.fields = {};
        _this.initialValues = props.initialValues || {};
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(props.component && props.render), 'You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(props.component && props.children && !isEmptyChildren(props.children)), 'You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(props.render && props.children && !isEmptyChildren(props.children)), 'You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
        return _this;
    }
    Formik.prototype.componentDidMount = function () {
        this.didMount = true;
    };
    Formik.prototype.componentWillUnmount = function () {
        this.didMount = false;
    };
    Formik.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.enableReinitialize &&
            !__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(prevProps.initialValues, this.props.initialValues)) {
            this.initialValues = this.props.initialValues;
            this.resetForm(this.props.initialValues);
        }
    };
    Formik.prototype.runFieldLevelValidations = function (values) {
        var _this = this;
        var fieldKeysWithValidation = Object.keys(this.fields).filter(function (f) {
            return _this.fields &&
                _this.fields[f] &&
                _this.fields[f].validate &&
                isFunction(_this.fields[f].validate);
        });
        var fieldValidations = fieldKeysWithValidation.length > 0
            ? fieldKeysWithValidation.map(function (f) {
                return _this.runSingleFieldLevelValidation(f, getIn(values, f)).then(function (x) { return x; }, function (e) { return e; });
            })
            : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')];
        return Promise.all(fieldValidations).then(function (fieldErrorsList) {
            return fieldErrorsList.reduce(function (prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
                    return prev;
                }
                if (!!curr) {
                    prev = setIn(prev, fieldKeysWithValidation[index], curr);
                }
                return prev;
            }, {});
        });
    };
    Formik.prototype.runValidateHandler = function (values) {
        var _this = this;
        return new Promise(function (resolve) {
            var maybePromisedErrors = _this.props.validate(values);
            if (maybePromisedErrors === undefined) {
                resolve({});
            }
            else if (isPromise(maybePromisedErrors)) {
                maybePromisedErrors.then(function () {
                    resolve({});
                }, function (errors) {
                    resolve(errors);
                });
            }
            else {
                resolve(maybePromisedErrors);
            }
        });
    };
    Formik.prototype.render = function () {
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children;
        var props = this.getFormikBag();
        var ctx = this.getFormikContext();
        return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(FormikProvider, { value: ctx }, component
            ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, props)
            : render
                ? render(props)
                : children
                    ? typeof children === 'function'
                        ? children(props)
                        : !isEmptyChildren(children)
                            ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children)
                            : null
                    : null));
    };
    Formik.defaultProps = {
        validateOnChange: true,
        validateOnBlur: true,
        isInitialValid: false,
        enableReinitialize: false,
    };
    return Formik;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
function warnAboutMissingIdentifier(_a) {
    var htmlContent = _a.htmlContent, documentationAnchorLink = _a.documentationAnchorLink, handlerName = _a.handlerName;
    console.error("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n\n    " + htmlContent + "\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}
function yupToFormErrors(yupError) {
    var errors = {};
    for (var _i = 0, _a = yupError.inner; _i < _a.length; _i++) {
        var err = _a[_i];
        if (!errors[err.path]) {
            errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) { sync = false; }
    if (context === void 0) { context = {}; }
    var validateData = {};
    for (var k in values) {
        if (values.hasOwnProperty(k)) {
            var key = String(k);
            validateData[key] = values[key] !== '' ? values[key] : undefined;
        }
    }
    return schema[sync ? 'validateSync' : 'validate'](validateData, {
        abortEarly: false,
        context: context,
    });
}

var FieldInner = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FieldInner, _super);
    function FieldInner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            var _a = _this.props.formik, handleChange = _a.handleChange, validateOnChange = _a.validateOnChange;
            handleChange(e);
            if (!!validateOnChange && !!_this.props.validate) {
                _this.runFieldValidations(e.target.value);
            }
        };
        _this.handleBlur = function (e) {
            var _a = _this.props.formik, handleBlur = _a.handleBlur, validateOnBlur = _a.validateOnBlur;
            handleBlur(e);
            if (!!validateOnBlur && !!_this.props.validate) {
                _this.runFieldValidations(e.target.value);
            }
        };
        _this.runFieldValidations = function (value) {
            var setFieldError = _this.props.formik.setFieldError;
            var _a = _this.props, name = _a.name, validate = _a.validate;
            var maybePromise = validate(value);
            if (isPromise(maybePromise)) {
                maybePromise.then(function () { return setFieldError(name, undefined); }, function (error) { return setFieldError(name, error); });
            }
            else {
                setFieldError(name, maybePromise);
            }
        };
        var render = props.render, children = props.children, component = props.component, formik = props.formik;
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(component && render), 'You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(component && children && isFunction(children)), 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(render && children && !isEmptyChildren(children)), 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored');
        formik.registerField(props.name, {
            validate: props.validate,
        });
        return _this;
    }
    FieldInner.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate,
            });
        }
        if (this.props.validate !== prevProps.validate) {
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate,
            });
        }
    };
    FieldInner.prototype.componentWillUnmount = function () {
        this.props.formik.unregisterField(this.props.name);
    };
    FieldInner.prototype.render = function () {
        var _a = this.props, validate = _a.validate, name = _a.name, render = _a.render, children = _a.children, _b = _a.component, component = _b === void 0 ? 'input' : _b, formik = _a.formik, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(_a, ["validate", "name", "render", "children", "component", "formik"]);
        var _validate = formik.validate, _validationSchema = formik.validationSchema, restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(formik, ["validate", "validationSchema"]);
        var field = {
            value: props.type === 'radio' || props.type === 'checkbox'
                ? props.value
                : getIn(formik.values, name),
            name: name,
            onChange: validate ? this.handleChange : formik.handleChange,
            onBlur: validate ? this.handleBlur : formik.handleBlur,
        };
        var bag = { field: field, form: restOfFormik };
        if (render) {
            return render(bag);
        }
        if (isFunction(children)) {
            return children(bag);
        }
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(props, ["innerRef"]);
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ ref: innerRef }, field, rest, { children: children }));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, bag, props, { children: children }));
    };
    return FieldInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var Field = connect(FieldInner);

var Form = connect(function (_a) {
    var handleSubmit = _a.formik.handleSubmit, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(_a, ["formik"]);
    return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])("form", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ onSubmit: handleSubmit }, props)));
});
Form.displayName = 'Form';

function withFormik(_a) {
    var _b = _a.mapPropsToValues, mapPropsToValues = _b === void 0 ? function (vanillaProps) {
        var val = {};
        for (var k in vanillaProps) {
            if (vanillaProps.hasOwnProperty(k) &&
                typeof vanillaProps[k] !== 'function') {
                val[k] = vanillaProps[k];
            }
        }
        return val;
    } : _b, config = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(_a, ["mapPropsToValues"]);
    return function createFormik(Component$$1) {
        var componentDisplayName = Component$$1.displayName ||
            Component$$1.name ||
            (Component$$1.constructor && Component$$1.constructor.name) ||
            'Component';
        var C = (function (_super) {
            Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(C, _super);
            function C() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.validate = function (values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function () {
                    return isFunction(config.validationSchema)
                        ? config.validationSchema(_this.props)
                        : config.validationSchema;
                };
                _this.handleSubmit = function (values, actions) {
                    return config.handleSubmit(values, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, actions, { props: _this.props }));
                };
                _this.renderFormComponent = function (formikProps) {
                    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Component$$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, _this.props, formikProps));
                };
                return _this;
            }
            C.prototype.render = function () {
                return (Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Formik, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.props, config, { validate: config.validate && this.validate, validationSchema: config.validationSchema && this.validationSchema, initialValues: mapPropsToValues(this.props), onSubmit: this.handleSubmit, render: this.renderFormComponent })));
            };
            C.displayName = "WithFormik(" + componentDisplayName + ")";
            return C;
        }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
        return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component$$1);
    };
}

var move = function (array, from, to) {
    var copy = (array || []).slice();
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function (array, indexA, indexB) {
    var copy = (array || []).slice();
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function (array, index, value) {
    var copy = (array || []).slice();
    copy.splice(index, 0, value);
    return copy;
};
var replace = function (array, index, value) {
    var copy = (array || []).slice();
    copy[index] = value;
    return copy;
};
var FieldArrayInner = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FieldArrayInner, _super);
    function FieldArrayInner(props) {
        var _this = _super.call(this, props) || this;
        _this.updateArrayField = function (fn, alterTouched, alterErrors) {
            var _a = _this.props, name = _a.name, validateOnChange = _a.validateOnChange, _b = _a.formik, setFormikState = _b.setFormikState, validateForm = _b.validateForm, values = _b.values, touched = _b.touched, errors = _b.errors;
            setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { values: setIn(prevState.values, name, fn(getIn(values, name))), errors: alterErrors
                    ? setIn(prevState.errors, name, fn(getIn(errors, name)))
                    : prevState.errors, touched: alterTouched
                    ? setIn(prevState.touched, name, fn(getIn(touched, name)))
                    : prevState.touched })); }, function () {
                if (validateOnChange) {
                    validateForm();
                }
            });
        };
        _this.push = function (value) {
            return _this.updateArrayField(function (array) { return (array || []).concat([value]); }, false, false);
        };
        _this.handlePush = function (value) { return function () { return _this.push(value); }; };
        _this.swap = function (indexA, indexB) {
            return _this.updateArrayField(function (array) { return swap(array, indexA, indexB); }, false, false);
        };
        _this.handleSwap = function (indexA, indexB) { return function () {
            return _this.swap(indexA, indexB);
        }; };
        _this.move = function (from, to) {
            return _this.updateArrayField(function (array) { return move(array, from, to); }, false, false);
        };
        _this.handleMove = function (from, to) { return function () { return _this.move(from, to); }; };
        _this.insert = function (index, value) {
            return _this.updateArrayField(function (array) { return insert(array, index, value); }, false, false);
        };
        _this.handleInsert = function (index, value) { return function () { return _this.insert(index, value); }; };
        _this.replace = function (index, value) {
            return _this.updateArrayField(function (array) { return replace(array, index, value); }, false, false);
        };
        _this.handleReplace = function (index, value) { return function () {
            return _this.replace(index, value);
        }; };
        _this.unshift = function (value) {
            var arr = [];
            _this.updateArrayField(function (array) {
                arr = array ? [value].concat(array) : [value];
                return arr;
            }, false, false);
            return arr.length;
        };
        _this.handleUnshift = function (value) { return function () { return _this.unshift(value); }; };
        _this.handleRemove = function (index) { return function () { return _this.remove(index); }; };
        _this.handlePop = function () { return function () { return _this.pop(); }; };
        _this.remove = _this.remove.bind(_this);
        _this.pop = _this.pop.bind(_this);
        return _this;
    }
    FieldArrayInner.prototype.remove = function (index) {
        var result;
        this.updateArrayField(function (array) {
            var copy = array ? array.slice() : [];
            if (!result) {
                result = copy[index];
            }
            if (isFunction(copy.splice)) {
                copy.splice(index, 1);
            }
            return copy;
        }, true, true);
        return result;
    };
    FieldArrayInner.prototype.pop = function () {
        var result;
        this.updateArrayField(function (array) {
            var tmp = array;
            if (!result) {
                result = tmp && tmp.pop && tmp.pop();
            }
            return tmp;
        }, true, true);
        return result;
    };
    FieldArrayInner.prototype.render = function () {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove,
        };
        var _a = this.props, component = _a.component, render = _a.render, children = _a.children, name = _a.name, _b = _a.formik, _validate = _b.validate, _validationSchema = _b.validationSchema, restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(_b, ["validate", "validationSchema"]);
        var props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, arrayHelpers, { form: restOfFormik, name: name });
        return component
            ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, props)
            : render
                ? render(props)
                : children
                    ? typeof children === 'function'
                        ? children(props)
                        : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children) : null
                    : null;
    };
    FieldArrayInner.defaultProps = {
        validateOnChange: true,
    };
    return FieldArrayInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var FieldArray = connect(FieldArrayInner);

function isEqualExceptForKey(a, b, path) {
    return __WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(setIn(a, path, undefined), setIn(b, path, undefined));
}
var FastFieldInner = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(FastFieldInner, _super);
    function FastFieldInner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (e) {
            e.persist();
            var _a = _this.props.formik, validateOnChange = _a.validateOnChange, validate = _a.validate, values = _a.values, validationSchema = _a.validationSchema, errors = _a.errors, setFormikState = _a.setFormikState;
            var _b = e.target, type = _b.type, value = _b.value, checked = _b.checked;
            var val = /number|range/.test(type)
                ? parseFloat(value)
                : /checkbox/.test(type) ? checked : value;
            if (validateOnChange) {
                if (_this.props.validate) {
                    var maybePromise = _this.props.validate(value);
                    if (isPromise(maybePromise)) {
                        _this.setState({ value: val });
                        maybePromise.then(function () { return _this.setState({ error: undefined }); }, function (error) { return _this.setState({ error: error }); });
                    }
                    else {
                        _this.setState({ value: val, error: maybePromise });
                    }
                }
                else if (validate) {
                    var maybePromise_1 = validate(setIn(values, _this.props.name, val));
                    if (isPromise(maybePromise_1)) {
                        _this.setState({ value: val });
                        maybePromise_1.then(function () { return _this.setState({ error: undefined }); }, function (error) {
                            if (isEqualExceptForKey(maybePromise_1, errors, _this.props.name)) {
                                _this.setState({ error: getIn(error, _this.props.name) });
                            }
                            else {
                                setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { errors: error })); });
                            }
                        });
                    }
                    else {
                        if (isEqualExceptForKey(maybePromise_1, errors, _this.props.name)) {
                            _this.setState({
                                value: val,
                                error: getIn(maybePromise_1, _this.props.name),
                            });
                        }
                        else {
                            _this.setState({
                                value: val,
                            });
                            setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { errors: maybePromise_1 })); });
                        }
                    }
                }
                else if (validationSchema) {
                    var schema = isFunction(validationSchema)
                        ? validationSchema()
                        : validationSchema;
                    var mergedValues = setIn(values, _this.props.name, val);
                    try {
                        validateYupSchema(mergedValues, schema, true);
                        _this.setState({
                            value: val,
                            error: undefined,
                        });
                    }
                    catch (e) {
                        if (e.name === 'ValidationError') {
                            _this.setState({
                                value: val,
                                error: getIn(yupToFormErrors(e), _this.props.name),
                            });
                        }
                        else {
                            _this.setState({
                                value: val,
                            });
                            validateYupSchema(mergedValues, schema).then(function () { return _this.setState({ error: undefined }); }, function (err) {
                                return _this.setState(function (s) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, s, { error: getIn(yupToFormErrors(err), _this.props.name) })); });
                            });
                        }
                    }
                }
                else {
                    _this.setState({ value: val });
                }
            }
            else {
                _this.setState({ value: val });
            }
        };
        _this.handleBlur = function () {
            var _a = _this.props.formik, validateOnBlur = _a.validateOnBlur, setFormikState = _a.setFormikState;
            var _b = _this.props, name = _b.name, validate = _b.validate;
            if (validateOnBlur && validate) {
                var maybePromise_2 = validate(_this.state.value);
                if (isPromise(maybePromise_2)) {
                    maybePromise_2.then(function () {
                        return setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, undefined), touched: setIn(prevState.touched, name, true) })); });
                    }, function (error) {
                        return setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, error), touched: setIn(prevState.touched, name, true) })); });
                    });
                }
                else {
                    setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, maybePromise_2), touched: setIn(prevState.touched, name, true) })); });
                }
            }
            else {
                setFormikState(function (prevState) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prevState, { errors: setIn(prevState.errors, name, _this.state.error), values: setIn(prevState.values, name, _this.state.value), touched: setIn(prevState.touched, name, true) })); });
            }
        };
        _this.state = {
            value: getIn(props.formik.values, props.name),
            error: getIn(props.formik.errors, props.name),
        };
        var render = props.render, children = props.children, component = props.component, formik = props.formik;
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(component && render), 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(props.component && children && isFunction(children)), 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.');
        __WEBPACK_IMPORTED_MODULE_7_warning___default()(!(render && children && !isEmptyChildren(children)), 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored');
        formik.registerField(props.name, {
            validate: props.validate,
        });
        return _this;
    }
    FastFieldInner.prototype.componentDidUpdate = function (prevProps, _state) {
        var nextFieldValue = getIn(this.props.formik.values, this.props.name);
        var nextFieldError = getIn(this.props.formik.errors, this.props.name);
        var prevFieldValue = getIn(prevProps.formik.values, prevProps.name);
        var prevFieldError = getIn(prevProps.formik.errors, prevProps.name);
        if (!__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(nextFieldValue, prevFieldValue)) {
            this.setState({ value: nextFieldValue });
        }
        if (!__WEBPACK_IMPORTED_MODULE_6_react_fast_compare___default()(nextFieldError, prevFieldError)) {
            this.setState({ error: nextFieldError });
        }
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate,
            });
        }
        if (this.props.validate !== prevProps.validate) {
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate,
            });
        }
    };
    FastFieldInner.prototype.componentWillUnmount = function () {
        this.props.formik.unregisterField(this.props.name);
    };
    FastFieldInner.prototype.render = function () {
        var _a = this.props, validate = _a.validate, name = _a.name, render = _a.render, children = _a.children, _b = _a.component, component = _b === void 0 ? 'input' : _b, formik = _a.formik, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(_a, ["validate", "name", "render", "children", "component", "formik"]);
        var _validate = formik.validate, _validationSchema = formik.validationSchema, restOfFormik = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(formik, ["validate", "validationSchema"]);
        var field = {
            value: props.type === 'radio' || props.type === 'checkbox'
                ? props.value
                : this.state.value,
            name: name,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
        };
        var bag = {
            field: field,
            form: restOfFormik,
            meta: { touched: getIn(formik.touched, name), error: this.state.error },
        };
        if (render) {
            return render(bag);
        }
        if (isFunction(children)) {
            return children(bag);
        }
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(props, ["innerRef"]);
            return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ ref: innerRef }, field, rest, { children: children }));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, bag, props, { children: children }));
    };
    return FastFieldInner;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
var FastField = connect(FastFieldInner);


//# sourceMappingURL=formik.esm.js.map


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(761);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(698);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(762);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(763);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(60)(module)))

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
}

module.exports = toPath;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  if (a === b) return true;

  var arrA = isArray(a)
    , arrB = isArray(b)
    , i
    , length
    , key;

  if (arrA && arrB) {
    length = a.length;
    if (length != b.length) return false;
    for (i = 0; i < length; i++)
      if (!equal(a[i], b[i])) return false;
    return true;
  }

  if (arrA != arrB) return false;

  var dateA = a instanceof Date
    , dateB = b instanceof Date;
  if (dateA != dateB) return false;
  if (dateA && dateB) return a.getTime() == b.getTime();

  var regexpA = a instanceof RegExp
    , regexpB = b instanceof RegExp;
  if (regexpA != regexpB) return false;
  if (regexpA && regexpB) return a.toString() == b.toString();

  if (a instanceof Object && b instanceof Object) {
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = 0; i < length; i++)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = 0; i < length; i++) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof && a._store) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }

    return true;
  }

  return false;
}

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["a"] = (deepmerge_1);


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(771);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (false) {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* isIeOrEdge */])()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["g" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element

      var acceptedFiles = props.acceptedFiles,
          preventDropOnDocument = props.preventDropOnDocument,
          disablePreview = props.disablePreview,
          disableClick = props.disableClick,
          onDropAccepted = props.onDropAccepted,
          onDropRejected = props.onDropRejected,
          onFileDialogCancel = props.onFileDialogCancel,
          maxSize = props.maxSize,
          minSize = props.minSize,
          getDataTransferItems = props.getDataTransferItems,
          divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)]),

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */]
};

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["e"] = isIeOrEdge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e})},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r)},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p)};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return!0},r(14),r(34)},function(t,n,r){r(15),t.exports=r(2).Array.some},function(t,n,r){"use strict";var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}})},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return"value"in r&&(t[n]=r.value),t}},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t}},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a})},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)}},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return!0;case 5:return h;case 6:return _;case 2:w.push(h)}else if(s)return!1;return p?-1:a||s?s:w}}},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==e(t)?t.split(""):Object(t)}},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))}},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)}},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n}},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return"Array"==e(t)}},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})}},function(t,n,r){"use strict";var e=r(4);t.exports=function(t,n){return!!t&&e(function(){n?t.call(null,function(){},1):t.call(null)})}},function(t,n,r){r(35),t.exports=r(2).String.endsWith},function(t,n,r){"use strict";var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}})},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return!0}}]);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _wrapDisplayName = __webpack_require__(652);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _setDisplayName = __webpack_require__(653);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _mapProps = __webpack_require__(775);

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  var hoc = (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

exports.default = withProps;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(653);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(652);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

exports.default = mapProps;

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_json2mq__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_json2mq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_json2mq__);









var MediaQueryListener =
/*#__PURE__*/
function () {
  function MediaQueryListener(targetWindow, query, listener) {
    var _this = this;

    this.nativeMediaQueryList = targetWindow.matchMedia(query);
    this.active = true; // Safari doesn't clear up listener with removeListener
    // when the listener is already waiting in the event queue.
    // Having an active flag to make sure the listener is not called
    // after we removeListener.

    this.cancellableListener = function () {
      _this.matches = _this.nativeMediaQueryList.matches;

      if (_this.active) {
        listener.apply(void 0, arguments);
      }
    };

    this.nativeMediaQueryList.addListener(this.cancellableListener);
    this.matches = this.nativeMediaQueryList.matches;
  }

  var _proto = MediaQueryListener.prototype;

  _proto.cancel = function cancel() {
    this.active = false;
    this.nativeMediaQueryList.removeListener(this.cancellableListener);
  };

  return MediaQueryListener;
}();

var queryType = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired)]);
/**
 * Conditionally renders based on whether or not a media query matches.
 */

var Media =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Media, _React$Component);

  function Media(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "queries", []);

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getMatches", function () {
      var result = _this.queries.reduce(function (acc, _ref) {
        var _extends2;

        var name = _ref.name,
            mqListener = _ref.mqListener;
        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, acc, (_extends2 = {}, _extends2[name] = mqListener.matches, _extends2));
      }, {}); // return result;


      return unwrapSingleQuery(result);
    });

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "updateMatches", function () {
      var newMatches = _this.getMatches();

      _this.setState(function () {
        return {
          matches: newMatches
        };
      }, _this.onChange);
    });

    !(!(!props.query && !props.queries) || props.query && props.queries) ?  false ? invariant(false, '<Media> must be supplied with either "query" or "queries"') : __WEBPACK_IMPORTED_MODULE_6_invariant___default()(false) : void 0;
    !(props.defaultMatches === undefined || !props.query || typeof props.defaultMatches === "boolean") ?  false ? invariant(false, "<Media> when query is set, defaultMatches must be a boolean, received " + typeof props.defaultMatches) : __WEBPACK_IMPORTED_MODULE_6_invariant___default()(false) : void 0;
    !(props.defaultMatches === undefined || !props.queries || typeof props.defaultMatches === "object") ?  false ? invariant(false, "<Media> when queries is set, defaultMatches must be a object of booleans, received " + typeof props.defaultMatches) : __WEBPACK_IMPORTED_MODULE_6_invariant___default()(false) : void 0;

    if (typeof window !== "object") {
      // In case we're rendering on the server, apply the default matches
      var matches;

      if (props.defaultMatches !== undefined) {
        matches = props.defaultMatches;
      } else if (props.query) {
        matches = true;
      }
      /* if (props.queries) */
      else {
          matches = Object.keys(_this.props.queries).reduce(function (acc, key) {
            var _extends3;

            return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, acc, (_extends3 = {}, _extends3[key] = true, _extends3));
          }, {});
        }

      _this.state = {
        matches: matches
      };
      return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this);
    }

    _this.initialize(); // Instead of calling this.updateMatches, we manually set the initial state to prevent
    // calling setState, which could trigger an unnecessary second render


    _this.state = {
      matches: _this.props.defaultMatches !== undefined ? _this.props.defaultMatches : _this.getMatches()
    };

    _this.onChange();

    return _this;
  }

  var _proto = Media.prototype;

  _proto.initialize = function initialize() {
    var _this2 = this;

    var targetWindow = this.props.targetWindow || window;
    !(typeof targetWindow.matchMedia === "function") ?  false ? invariant(false, "<Media targetWindow> does not support `matchMedia`.") : __WEBPACK_IMPORTED_MODULE_6_invariant___default()(false) : void 0;
    var queries = this.props.queries || wrapInQueryObject(this.props.query);
    this.queries = Object.keys(queries).map(function (name) {
      var query = queries[name];
      var qs = typeof query !== "string" ? __WEBPACK_IMPORTED_MODULE_7_json2mq___default()(query) : query;
      var mqListener = new MediaQueryListener(targetWindow, qs, _this2.updateMatches);
      return {
        name: name,
        mqListener: mqListener
      };
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initialize(); // If props.defaultMatches has been set, ensure we trigger a two-pass render.
    // This is useful for SSR with mismatching defaultMatches vs actual matches from window.matchMedia
    // Details: https://github.com/ReactTraining/react-media/issues/81

    if (this.props.defaultMatches !== undefined) {
      this.updateMatches();
    }
  };

  _proto.onChange = function onChange() {
    var onChange = this.props.onChange;

    if (onChange) {
      onChange(this.state.matches);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.queries.forEach(function (_ref2) {
      var mqListener = _ref2.mqListener;
      return mqListener.cancel();
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        render = _this$props.render;
    var matches = this.state.matches;
    var isAnyMatches = typeof matches === "object" ? Object.keys(matches).some(function (key) {
      return matches[key];
    }) : matches;
    return render ? isAnyMatches ? render(matches) : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
    ? isAnyMatches ? // We have to check whether child is a composite component or not to decide should we
    // provide `matches` as a prop or not
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children) && typeof __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children).type === "string" ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children), {
      matches: matches
    }) : null : null : null;
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);
/**
 * Wraps a single query in an object. This is used to provide backward compatibility with
 * the old `query` prop (as opposed to `queries`). If only a single query is passed, the object
 * will be unpacked down the line, but this allows our internals to assume an object of queries
 * at all times.
 */


Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Media, "propTypes", {
  defaultMatches: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool)]),
  query: queryType,
  queries: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.objectOf(queryType),
  render: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  targetWindow: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
});

function wrapInQueryObject(query) {
  return {
    __DEFAULT__: query
  };
}
/**
 * Unwraps an object of queries, if it was originally passed as a single query.
 */


function unwrapSingleQuery(queryObject) {
  var queryNames = Object.keys(queryObject);

  if (queryNames.length === 1 && queryNames[0] === "__DEFAULT__") {
    return queryObject.__DEFAULT__;
  }

  return queryObject;
}

/* harmony default export */ __webpack_exports__["default"] = (Media);


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(778);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 778 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(46));

var _reactLifecyclesCompat = __webpack_require__(43);

var _PropTypes = __webpack_require__(780);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(783);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(785);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(786);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(788);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(654);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(227);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(789);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(347);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(227);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(348);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(349);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(350);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(351);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80)))

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(347);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(227);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(348);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(349);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(350);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(351);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(347);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(227);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(348);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(787);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(349);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(350);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(351);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(654);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(791)
} else {
  module.exports = require('./dist/react-table.development.js')
}


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?t(exports,__webpack_require__(0)):"function"==typeof define&&define.amd?define(["exports","react"],t):t((e=e||self).ReactTable={},e.React)}(this,(function(e,t){"use strict";function n(e,t,n,o,r,i,u){try{var l=e[i](u),s=l.value}catch(e){return void n(e)}l.done?t(s):Promise.resolve(s).then(o,r)}function o(e){return function(){var t=this,o=arguments;return new Promise((function(r,i){var u=e.apply(t,o);function l(e){n(u,r,i,l,s,"next",e)}function s(e){n(u,r,i,l,s,"throw",e)}l(void 0)}))}}function r(){return(r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e}).apply(this,arguments)}function i(e,t){if(null==e)return{};var n,o,r={},i=Object.keys(e);for(o=0;o<i.length;o++)n=i[o],t.indexOf(n)>=0||(r[n]=e[n]);return r}function u(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,t||"default");if("object"!=typeof o)return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return("string"===t?String:Number)(e)}(e,"string");return"symbol"==typeof t?t:String(t)}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t;var l={init:"init"},s=function(e){var t=e.value;return void 0===t?"":t},a=function(){return t.createElement(t.Fragment,null," ")},c={Cell:s,width:150,minWidth:0,maxWidth:Number.MAX_SAFE_INTEGER};function d(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return t.reduce((function(e,t){var n=t.style,o=t.className;return e=r({},e,{},i(t,["style","className"])),n&&(e.style=e.style?r({},e.style||{},{},n||{}):n),o&&(e.className=e.className?e.className+" "+o:o),""===e.className&&delete e.className,e}),{})}var f=function(e,t){return void 0===t&&(t={}),function(n){return void 0===n&&(n={}),[].concat(e,[n]).reduce((function(e,o){return function e(t,n,o){return"function"==typeof n?e({},n(t,o)):Array.isArray(n)?d.apply(void 0,[t].concat(n)):d(t,n)}(e,o,r({},t,{userProps:n}))}),{})}},p=function(e,t,n,o){return void 0===n&&(n={}),e.reduce((function(e,t){return t(e,n)}),t)},g=function(e,t,n){return void 0===n&&(n={}),e.forEach((function(e){e(t,n)}))};function v(e,t,n,o){e.findIndex((function(e){return e.pluginName===n}));t.forEach((function(t){e.findIndex((function(e){return e.pluginName===t}))}))}function m(e,t){return"function"==typeof e?e(t):e}function h(e){var n=t.useRef();return n.current=e,t.useCallback((function(){return n.current}),[])}var y="undefined"!=typeof document?t.useLayoutEffect:t.useEffect;function w(e,n){var o=t.useRef(!1);y((function(){o.current&&e(),o.current=!0}),n)}function R(e,t,n){return void 0===n&&(n={}),function(o,i){void 0===i&&(i={});var u="string"==typeof o?t[o]:o;if(void 0===u)throw console.info(t),new Error("Renderer Error ☝️");return b(u,r({},e,{column:t},n,{},i))}}function b(e,n){return function(e){return"function"==typeof e&&((t=Object.getPrototypeOf(e)).prototype&&t.prototype.isReactComponent);var t}(o=e)||"function"==typeof o||function(e){return"object"==typeof e&&"symbol"==typeof e.$$typeof&&["react.memo","react.forward_ref"].includes(e.$$typeof.description)}(o)?t.createElement(e,n):e;var o}function S(e,t,n){return void 0===n&&(n=0),e.map((function(e){return x(e=r({},e,{parent:t,depth:n})),e.columns&&(e.columns=S(e.columns,e,n+1)),e}))}function C(e){return G(e,"columns")}function x(e){var t=e.id,n=e.accessor,o=e.Header;if("string"==typeof n){t=t||n;var r=n.split(".");n=function(e){return function(e,t,n){if(!t)return e;var o,r="function"==typeof t?t:JSON.stringify(t),i=E.get(r)||function(){var e=function(e){return function e(t,n){void 0===n&&(n=[]);if(Array.isArray(t))for(var o=0;o<t.length;o+=1)e(t[o],n);else n.push(t);return n}(e).map((function(e){return String(e).replace(".","_")})).join(".").replace(W,".").replace(O,"").split(".")}(t);return E.set(r,e),e}();try{o=i.reduce((function(e,t){return e[t]}),e)}catch(e){}return void 0!==o?o:n}(e,r)}}if(!t&&"string"==typeof o&&o&&(t=o),!t&&e.columns)throw console.error(e),new Error('A column ID (or unique "Header" value) is required!');if(!t)throw console.error(e),new Error("A column ID (or string accessor) is required!");return Object.assign(e,{id:t,accessor:n}),e}function P(e,t){if(!t)throw new Error;return Object.assign(e,r({Header:a,Footer:a},c,{},t,{},e)),Object.assign(e,{originalWidth:e.width}),e}function B(e,t,n){void 0===n&&(n=function(){return{}});for(var o=[],i=e,u=0,l=function(){return u++},s=function(){var e={headers:[]},u=[],s=i.some((function(e){return e.parent}));i.forEach((function(o){var i,a=[].concat(u).reverse()[0];if(s){if(o.parent)i=r({},o.parent,{originalId:o.parent.id,id:o.parent.id+"_"+l(),headers:[o]},n(o));else i=P(r({originalId:o.id+"_placeholder",id:o.id+"_placeholder_"+l(),placeholderOf:o,headers:[o]},n(o)),t);a&&a.originalId===i.originalId?a.headers.push(o):u.push(i)}e.headers.push(o)})),o.push(e),i=u};i.length;)s();return o.reverse()}var E=new Map;function I(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];for(var o=0;o<t.length;o+=1)if(void 0!==t[o])return t[o]}function F(e){if("function"==typeof e)return e}function G(e,t){var n=[];return function e(o){o.forEach((function(o){o[t]?e(o[t]):n.push(o)}))}(e),n}function A(e,t){var n=t.manualExpandedKey,o=t.expanded,r=t.expandSubRows,i=void 0===r||r,u=[];return e.forEach((function(e){return function e(t,r){void 0===r&&(r=!0),t.isExpanded=t.original&&t.original[n]||o[t.id],t.canExpand=t.subRows&&!!t.subRows.length,r&&u.push(t),t.subRows&&t.subRows.length&&t.isExpanded&&t.subRows.forEach((function(t){return e(t,i)}))}(e)})),u}function k(e,t,n){return F(e)||t[e]||n[e]||n.text}function H(e,t,n){return e?e(t,n):void 0===t}function T(){throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.")}var z=null;var W=/\[/g,O=/\]/g;var M=function(e){return r({role:"table"},e)},j=function(e){return r({role:"rowgroup"},e)},N=function(e,t){var n=t.column;return r({key:"header_"+n.id,colSpan:n.totalVisibleHeaderCount,role:"columnheader"},e)},L=function(e,t){var n=t.column;return r({key:"footer_"+n.id,colSpan:n.totalVisibleHeaderCount},e)},D=function(e,t){return r({key:"headerGroup_"+t.index,role:"row"},e)},V=function(e,t){return r({key:"footerGroup_"+t.index},e)},_=function(e,t){return r({key:"row_"+t.row.id,role:"row"},e)},X=function(e,t){var n=t.cell;return r({key:"cell_"+n.row.id+"_"+n.column.id,role:"cell"},e)};function q(){return{useOptions:[],stateReducers:[],useControlledState:[],columns:[],columnsDeps:[],allColumns:[],allColumnsDeps:[],accessValue:[],materializedColumns:[],materializedColumnsDeps:[],useInstanceAfterData:[],visibleColumns:[],visibleColumnsDeps:[],headerGroups:[],headerGroupsDeps:[],useInstanceBeforeDimensions:[],useInstance:[],prepareRow:[],getTableProps:[M],getTableBodyProps:[j],getHeaderGroupProps:[D],getFooterGroupProps:[V],getHeaderProps:[N],getFooterProps:[L],getRowProps:[_],getCellProps:[X],useFinalInstance:[]}}l.resetHiddenColumns="resetHiddenColumns",l.toggleHideColumn="toggleHideColumn",l.setHiddenColumns="setHiddenColumns",l.toggleHideAllColumns="toggleHideAllColumns";var K=function(e){e.getToggleHiddenProps=[U],e.getToggleHideAllColumnsProps=[$],e.stateReducers.push(J),e.useInstanceBeforeDimensions.push(Y),e.headerGroupsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.hiddenColumns])})),e.useInstance.push(Q)};K.pluginName="useColumnVisibility";var U=function(e,t){var n=t.column;return[e,{onChange:function(e){n.toggleHidden(!e.target.checked)},style:{cursor:"pointer"},checked:n.isVisible,title:"Toggle Column Visible"}]},$=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleHideAllColumns(!e.target.checked)},style:{cursor:"pointer"},checked:!n.allColumnsHidden&&!n.state.hiddenColumns.length,title:"Toggle All Columns Hidden",indeterminate:!n.allColumnsHidden&&n.state.hiddenColumns.length}]};function J(e,t,n,o){if(t.type===l.init)return r({hiddenColumns:[]},e);if(t.type===l.resetHiddenColumns)return r({},e,{hiddenColumns:o.initialState.hiddenColumns||[]});if(t.type===l.toggleHideColumn){var i=(void 0!==t.value?t.value:!e.hiddenColumns.includes(t.columnId))?[].concat(e.hiddenColumns,[t.columnId]):e.hiddenColumns.filter((function(e){return e!==t.columnId}));return r({},e,{hiddenColumns:i})}return t.type===l.setHiddenColumns?r({},e,{hiddenColumns:m(t.value,e.hiddenColumns)}):t.type===l.toggleHideAllColumns?r({},e,{hiddenColumns:(void 0!==t.value?t.value:!e.hiddenColumns.length)?o.allColumns.map((function(e){return e.id})):[]}):void 0}function Y(e){var n=e.headers,o=e.state.hiddenColumns;t.useRef(!1).current;var r=0;n.forEach((function(e){return r+=function e(t,n){t.isVisible=n&&!o.includes(t.id);var r=0;return t.headers&&t.headers.length?t.headers.forEach((function(n){return r+=e(n,t.isVisible)})):r=t.isVisible?1:0,t.totalVisibleHeaderCount=r,r}(e,!0)}))}function Q(e){var n=e.columns,o=e.flatHeaders,r=e.dispatch,i=e.allColumns,u=e.getHooks,s=e.state.hiddenColumns,a=e.autoResetHiddenColumns,c=void 0===a||a,d=h(e),p=i.length===s.length,g=t.useCallback((function(e,t){return r({type:l.toggleHideColumn,columnId:e,value:t})}),[r]),v=t.useCallback((function(e){return r({type:l.setHiddenColumns,value:e})}),[r]),m=t.useCallback((function(e){return r({type:l.toggleHideAllColumns,value:e})}),[r]),y=f(u().getToggleHideAllColumnsProps,{instance:d()});o.forEach((function(e){e.toggleHidden=function(t){r({type:l.toggleHideColumn,columnId:e.id,value:t})},e.getToggleHiddenProps=f(u().getToggleHiddenProps,{instance:d(),column:e})}));var R=h(c);w((function(){R()&&r({type:l.resetHiddenColumns})}),[r,n]),Object.assign(e,{allColumnsHidden:p,toggleHideColumn:g,setHiddenColumns:v,toggleHideAllColumns:m,getToggleHideAllColumnsProps:y})}var Z={},ee={},te=function(e,t,n){return e},ne=function(e,t){return e.subRows||[]},oe=function(e,t,n){return""+(n?[n.id,t].join("."):t)},re=function(e){return e};function ie(e){var t=e.initialState,n=void 0===t?Z:t,o=e.defaultColumn,u=void 0===o?ee:o,l=e.getSubRows,s=void 0===l?ne:l,a=e.getRowId,c=void 0===a?oe:a,d=e.stateReducer,f=void 0===d?te:d,p=e.useControlledState,g=void 0===p?re:p;return r({},i(e,["initialState","defaultColumn","getSubRows","getRowId","stateReducer","useControlledState"]),{initialState:n,defaultColumn:u,getSubRows:s,getRowId:c,stateReducer:f,useControlledState:g})}function ue(e,t){void 0===t&&(t=0);var n=0,o=0,r=0,i=0;return e.forEach((function(e){var u=e.headers;if(e.totalLeft=t,u&&u.length){var l=ue(u,t),s=l[0],a=l[1],c=l[2],d=l[3];e.totalMinWidth=s,e.totalWidth=a,e.totalMaxWidth=c,e.totalFlexWidth=d}else e.totalMinWidth=e.minWidth,e.totalWidth=Math.min(Math.max(e.minWidth,e.width),e.maxWidth),e.totalMaxWidth=e.maxWidth,e.totalFlexWidth=e.canResize?e.totalWidth:0;e.isVisible&&(t+=e.totalWidth,n+=e.totalMinWidth,o+=e.totalWidth,r+=e.totalMaxWidth,i+=e.totalFlexWidth)})),[n,o,r,i]}function le(e){var t=e.data,n=e.rows,o=e.flatRows,r=e.rowsById,i=e.column,u=e.getRowId,l=e.getSubRows,s=e.accessValueHooks,a=e.getInstance;t.forEach((function(e,c){return function e(n,c,d,f,g){void 0===d&&(d=0);var v=n,m=u(n,c,f),h=r[m];if(h)h.subRows&&h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h)}));else if((h={id:m,original:v,index:c,depth:d,cells:[{}]}).cells.map=T,h.cells.filter=T,h.cells.forEach=T,h.cells[0].getCellProps=T,h.values={},g.push(h),o.push(h),r[m]=h,h.originalSubRows=l(n,c),h.originalSubRows){var y=[];h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h,y)})),h.subRows=y}i.accessor&&(h.values[i.id]=i.accessor(n,c,h,g,t)),h.values[i.id]=p(s,h.values[i.id],{row:h,column:i,instance:a()})}(e,c,0,void 0,n)}))}l.resetExpanded="resetExpanded",l.toggleRowExpanded="toggleRowExpanded",l.toggleAllRowsExpanded="toggleAllRowsExpanded";var se=function(e){e.getToggleAllRowsExpandedProps=[ae],e.getToggleRowExpandedProps=[ce],e.stateReducers.push(de),e.useInstance.push(fe),e.prepareRow.push(pe)};se.pluginName="useExpanded";var ae=function(e,t){var n=t.instance;return[e,{onClick:function(e){n.toggleAllRowsExpanded()},style:{cursor:"pointer"},title:"Toggle All Rows Expanded"}]},ce=function(e,t){var n=t.row;return[e,{onClick:function(){n.toggleRowExpanded()},style:{cursor:"pointer"},title:"Toggle Row Expanded"}]};function de(e,t,n,o){if(t.type===l.init)return r({expanded:{}},e);if(t.type===l.resetExpanded)return r({},e,{expanded:o.initialState.expanded||{}});if(t.type===l.toggleAllRowsExpanded){var s=t.value,a=o.isAllRowsExpanded,c=o.rowsById;if(void 0!==s?s:!a){var d={};return Object.keys(c).forEach((function(e){d[e]=!0})),r({},e,{expanded:d})}return r({},e,{expanded:{}})}if(t.type===l.toggleRowExpanded){var f,p=t.id,g=t.value,v=e.expanded[p],m=void 0!==g?g:!v;if(!v&&m)return r({},e,{expanded:r({},e.expanded,(f={},f[p]=!0,f))});if(v&&!m){var h=e.expanded;h[p];return r({},e,{expanded:i(h,[p].map(u))})}return e}}function fe(e){var n=e.data,o=e.rows,r=e.rowsById,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.paginateExpandedRows,a=void 0===s||s,c=e.expandSubRows,d=void 0===c||c,p=e.autoResetExpanded,g=void 0===p||p,m=e.getHooks,y=e.plugins,R=e.state.expanded,b=e.dispatch;v(y,["useSortBy","useGroupBy","usePivotColumns","useGlobalFilter"],"useExpanded");var S=h(g),C=Boolean(Object.keys(r).length&&Object.keys(R).length);C&&Object.keys(r).some((function(e){return!R[e]}))&&(C=!1),w((function(){S()&&b({type:l.resetExpanded})}),[b,n]);var x=t.useCallback((function(e,t){b({type:l.toggleRowExpanded,id:e,value:t})}),[b]),P=t.useCallback((function(e){return b({type:l.toggleAllRowsExpanded,value:e})}),[b]),B=t.useMemo((function(){return a?A(o,{manualExpandedKey:u,expanded:R,expandSubRows:d}):o}),[a,o,u,R,d]),E=t.useMemo((function(){return function(e){var t=0;return Object.keys(e).forEach((function(e){var n=e.split(".");t=Math.max(t,n.length)})),t}(R)}),[R]),I=h(e),F=f(m().getToggleAllRowsExpandedProps,{instance:I()});Object.assign(e,{preExpandedRows:o,expandedRows:B,rows:B,expandedDepth:E,isAllRowsExpanded:C,toggleRowExpanded:x,toggleAllRowsExpanded:P,getToggleAllRowsExpandedProps:F})}function pe(e,t){var n=t.instance.getHooks,o=t.instance;e.toggleRowExpanded=function(t){return o.toggleRowExpanded(e.id,t)},e.getToggleRowExpandedProps=f(n().getToggleRowExpandedProps,{instance:o,row:e})}var ge=function(e,t,n){return e=e.filter((function(e){return t.some((function(t){var o=e.values[t];return String(o).toLowerCase().includes(String(n).toLowerCase())}))}))};ge.autoRemove=function(e){return!e};var ve=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o).toLowerCase()===String(n).toLowerCase()}))}))};ve.autoRemove=function(e){return!e};var me=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o)===String(n)}))}))};me.autoRemove=function(e){return!e};var he=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t].includes(n)}))}))};he.autoRemove=function(e){return!e||!e.length};var ye=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.every((function(e){return o.includes(e)}))}))}))};ye.autoRemove=function(e){return!e||!e.length};var we=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.some((function(e){return o.includes(e)}))}))}))};we.autoRemove=function(e){return!e||!e.length};var Re=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return n.includes(o)}))}))};Re.autoRemove=function(e){return!e||!e.length};var be=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]===n}))}))};be.autoRemove=function(e){return void 0===e};var Se=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]==n}))}))};Se.autoRemove=function(e){return null==e};var Ce=function(e,t,n){var o=n||[],r=o[0],i=o[1];if((r="number"==typeof r?r:-1/0)>(i="number"==typeof i?i:1/0)){var u=r;r=i,i=u}return e.filter((function(e){return t.some((function(t){var n=e.values[t];return n>=r&&n<=i}))}))};Ce.autoRemove=function(e){return!e||"number"!=typeof e[0]&&"number"!=typeof e[1]};var xe=Object.freeze({__proto__:null,text:ge,exactText:ve,exactTextCase:me,includes:he,includesAll:ye,includesSome:we,includesValue:Re,exact:be,equals:Se,between:Ce});l.resetFilters="resetFilters",l.setFilter="setFilter",l.setAllFilters="setAllFilters";var Pe=function(e){e.stateReducers.push(Be),e.useInstance.push(Ee)};function Be(e,t,n,o){if(t.type===l.init)return r({filters:[]},e);if(t.type===l.resetFilters)return r({},e,{filters:o.initialState.filters||[]});if(t.type===l.setFilter){var i=t.columnId,u=t.filterValue,s=o.allColumns,a=o.filterTypes,c=s.find((function(e){return e.id===i}));if(!c)throw new Error("React-Table: Could not find a column with id: "+i);var d=k(c.filter,a||{},xe),f=e.filters.find((function(e){return e.id===i})),p=m(u,f&&f.value);return H(d.autoRemove,p,c)?r({},e,{filters:e.filters.filter((function(e){return e.id!==i}))}):r({},e,f?{filters:e.filters.map((function(e){return e.id===i?{id:i,value:p}:e}))}:{filters:[].concat(e.filters,[{id:i,value:p}])})}if(t.type===l.setAllFilters){var g=t.filters,v=o.allColumns,h=o.filterTypes;return r({},e,{filters:m(g,e.filters).filter((function(e){var t=v.find((function(t){return t.id===e.id}));return!H(k(t.filter,h||{},xe).autoRemove,e.value,t)}))})}}function Ee(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.manualFilters,c=e.defaultCanFilter,d=void 0!==c&&c,f=e.disableFilters,p=e.state.filters,g=e.dispatch,v=e.autoResetFilters,m=void 0===v||v,y=t.useCallback((function(e,t){g({type:l.setFilter,columnId:e,filterValue:t})}),[g]),R=t.useCallback((function(e){g({type:l.setAllFilters,filters:e})}),[g]);u.forEach((function(e){var t=e.id,n=e.accessor,o=e.defaultCanFilter,r=e.disableFilters;e.canFilter=n?I(!0!==r&&void 0,!0!==f&&void 0,!0):I(o,d,!1),e.setFilter=function(t){return y(e.id,t)};var i=p.find((function(e){return e.id===t}));e.filterValue=i&&i.value}));var b=t.useMemo((function(){if(a||!p.length)return[o,r,i];var e=[],t={};return[function n(o,r){void 0===r&&(r=0);var i=o;return(i=p.reduce((function(e,t){var n=t.id,o=t.value,i=u.find((function(e){return e.id===n}));if(!i)return e;0===r&&(i.preFilteredRows=e);var l=k(i.filter,s||{},xe);return l?(i.filteredRows=l(e,[n],o),i.filteredRows):(console.warn("Could not find a valid 'column.filter' for column with the ID: "+i.id+"."),e)}),o)).forEach((function(o){e.push(o),t[o.id]=o,o.subRows&&(o.subRows=o.subRows&&o.subRows.length>0?n(o.subRows,r+1):o.subRows)})),i}(o),e,t]}),[a,p,o,r,i,u,s]),S=b[0],C=b[1],x=b[2];t.useMemo((function(){u.filter((function(e){return!p.find((function(t){return t.id===e.id}))})).forEach((function(e){e.preFilteredRows=S,e.filteredRows=S}))}),[S,p,u]);var P=h(m);w((function(){P()&&g({type:l.resetFilters})}),[g,a?null:n]),Object.assign(e,{preFilteredRows:o,preFilteredFlatRows:r,preFilteredRowsById:i,filteredRows:S,filteredFlatRows:C,filteredRowsById:x,rows:S,flatRows:C,rowsById:x,setFilter:y,setAllFilters:R})}Pe.pluginName="useFilters",l.resetGlobalFilter="resetGlobalFilter",l.setGlobalFilter="setGlobalFilter";var Ie=function(e){e.stateReducers.push(Fe),e.useInstance.push(Ge)};function Fe(e,t,n,o){if(t.type===l.resetGlobalFilter)return r({},e,{globalFilter:o.initialState.globalFilter||void 0});if(t.type===l.setGlobalFilter){var u=t.filterValue,s=o.userFilterTypes,a=k(o.globalFilter,s||{},xe),c=m(u,e.globalFilter);if(H(a.autoRemove,c)){e.globalFilter;return i(e,["globalFilter"])}return r({},e,{globalFilter:c})}}function Ge(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.globalFilter,c=e.manualGlobalFilter,d=e.state.globalFilter,f=e.dispatch,p=e.autoResetGlobalFilter,g=void 0===p||p,v=e.disableGlobalFilter,m=t.useCallback((function(e){f({type:l.setGlobalFilter,filterValue:e})}),[f]),y=t.useMemo((function(){if(c||void 0===d)return[o,r,i];var e=[],t={},n=k(a,s||{},xe);if(!n)return console.warn("Could not find a valid 'globalFilter' option."),o;u.forEach((function(e){var t=e.disableGlobalFilter;e.canFilter=I(!0!==t&&void 0,!0!==v&&void 0,!0)}));var l=u.filter((function(e){return!0===e.canFilter}));return[function o(r){return(r=n(r,l.map((function(e){return e.id})),d)).forEach((function(n){e.push(n),t[n.id]=n,n.subRows=n.subRows&&n.subRows.length?o(n.subRows):n.subRows})),r}(o),e,t]}),[c,d,a,s,u,o,r,i,v]),R=y[0],b=y[1],S=y[2],C=h(g);w((function(){C()&&f({type:l.resetGlobalFilter})}),[f,c?null:n]),Object.assign(e,{preGlobalFilteredRows:o,preGlobalFilteredFlatRows:r,preGlobalFilteredRowsById:i,globalFilteredRows:R,globalFilteredFlatRows:b,globalFilteredRowsById:S,rows:R,flatRows:b,rowsById:S,setGlobalFilter:m,disableGlobalFilter:v})}function Ae(e,t){return t.reduce((function(e,t){return e+("number"==typeof t?t:0)}),0)}Ie.pluginName="useGlobalFilter";var ke=Object.freeze({__proto__:null,sum:Ae,min:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e))})),t},max:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.max(t,e))})),t},minMax:function(e){var t=e[0]||0,n=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e),n=Math.max(n,e))})),t+".."+n},average:function(e){return Ae(0,e)/e.length},median:function(e){if(!e.length)return null;var t=Math.floor(e.length/2),n=[].concat(e).sort((function(e,t){return e-t}));return e.length%2!=0?n[t]:(n[t-1]+n[t])/2},unique:function(e){return Array.from(new Set(e).values())},uniqueCount:function(e){return new Set(e).size},count:function(e){return e.length}}),He=[],Te={};l.resetGroupBy="resetGroupBy",l.setGroupBy="setGroupBy",l.toggleGroupBy="toggleGroupBy";var ze=function(e){e.getGroupByToggleProps=[We],e.stateReducers.push(Oe),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.groupBy])})),e.visibleColumns.push(Me),e.useInstance.push(Ne),e.prepareRow.push(Le)};ze.pluginName="useGroupBy";var We=function(e,t){var n=t.header;return[e,{onClick:n.canGroupBy?function(e){e.persist(),n.toggleGroupBy()}:void 0,style:{cursor:n.canGroupBy?"pointer":void 0},title:"Toggle GroupBy"}]};function Oe(e,t,n,o){if(t.type===l.init)return r({groupBy:[]},e);if(t.type===l.resetGroupBy)return r({},e,{groupBy:o.initialState.groupBy||[]});if(t.type===l.setGroupBy)return r({},e,{groupBy:t.value});if(t.type===l.toggleGroupBy){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.groupBy.includes(i);return r({},e,s?{groupBy:[].concat(e.groupBy,[i])}:{groupBy:e.groupBy.filter((function(e){return e!==i}))})}}function Me(e,t){var n=t.instance.state.groupBy,o=n.map((function(t){return e.find((function(e){return e.id===t}))})).filter(Boolean),r=e.filter((function(e){return!n.includes(e.id)}));return(e=[].concat(o,r)).forEach((function(e){e.isGrouped=n.includes(e.id),e.groupedIndex=n.indexOf(e.id)})),e}var je={};function Ne(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.flatHeaders,a=e.groupByFn,c=void 0===a?De:a,d=e.manualGroupBy,p=e.aggregations,g=void 0===p?je:p,m=e.plugins,y=e.state.groupBy,R=e.dispatch,b=e.autoResetGroupBy,S=void 0===b||b,C=e.disableGroupBy,x=e.defaultCanGroupBy,P=e.getHooks;v(m,["useColumnOrder","useFilters"],"useGroupBy");var B=h(e);u.forEach((function(t){var n=t.accessor,o=t.defaultGroupBy,r=t.disableGroupBy;t.canGroupBy=n?I(t.canGroupBy,!0!==r&&void 0,!0!==C&&void 0,!0):I(t.canGroupBy,o,x,!1),t.canGroupBy&&(t.toggleGroupBy=function(){return e.toggleGroupBy(t.id)}),t.Aggregated=t.Aggregated||t.Cell}));var E=t.useCallback((function(e,t){R({type:l.toggleGroupBy,columnId:e,value:t})}),[R]),F=t.useCallback((function(e){R({type:l.setGroupBy,value:e})}),[R]);s.forEach((function(e){e.getGroupByToggleProps=f(P().getGroupByToggleProps,{instance:B(),header:e})}));var A=t.useMemo((function(){if(d||!y.length)return[o,r,i,He,Te,r,i];var e=y.filter((function(e){return u.find((function(t){return t.id===e}))})),t=[],n={},l=[],s={},a=[],f={},p=function o(r,i,d){if(void 0===i&&(i=0),i===e.length)return r;var p=e[i],v=c(r,p);return Object.entries(v).map((function(r,c){var v=r[0],m=r[1],h=p+":"+v,y=o(m,i+1,h=d?d+">"+h:h),w=i?G(m,"leafRows"):m,R=function(t,n,o){var r={};return u.forEach((function(i){if(e.includes(i.id))r[i.id]=n[0]?n[0].values[i.id]:null;else{var u="function"==typeof i.aggregate?i.aggregate:g[i.aggregate]||ke[i.aggregate];if(u){var l=n.map((function(e){return e.values[i.id]})),s=t.map((function(e){var t=e.values[i.id];if(!o&&i.aggregateValue){var n="function"==typeof i.aggregateValue?i.aggregateValue:g[i.aggregateValue]||ke[i.aggregateValue];if(!n)throw console.info({column:i}),new Error("React Table: Invalid column.aggregateValue option for column listed above");t=n(t,e,i)}return t}));r[i.id]=u(s,l)}else{if(i.aggregate)throw console.info({column:i}),new Error("React Table: Invalid column.aggregate option for column listed above");r[i.id]=null}}})),r}(w,m,i),b={id:h,isGrouped:!0,groupByID:p,groupByVal:v,values:R,subRows:y,leafRows:w,depth:i,index:c};return y.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e)})),b}))}(o);return p.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e)})),[p,t,n,l,s,a,f]}),[d,y,o,r,i,u,g,c]),k=A[0],H=A[1],T=A[2],z=A[3],W=A[4],O=A[5],M=A[6],j=h(S);w((function(){j()&&R({type:l.resetGroupBy})}),[R,d?null:n]),Object.assign(e,{preGroupedRows:o,preGroupedFlatRow:r,preGroupedRowsById:i,groupedRows:k,groupedFlatRows:H,groupedRowsById:T,onlyGroupedFlatRows:z,onlyGroupedRowsById:W,nonGroupedFlatRows:O,nonGroupedRowsById:M,rows:k,flatRows:H,rowsById:T,toggleGroupBy:E,setGroupBy:F})}function Le(e){e.allCells.forEach((function(t){var n;t.isGrouped=t.column.isGrouped&&t.column.id===e.groupByID,t.isPlaceholder=!t.isGrouped&&t.column.isGrouped,t.isAggregated=!t.isGrouped&&!t.isPlaceholder&&(null==(n=e.subRows)?void 0:n.length)}))}function De(e,t){return e.reduce((function(e,n,o){var r=""+n.values[t];return e[r]=Array.isArray(e[r])?e[r]:[],e[r].push(n),e}),{})}var Ve=/([0-9]+)/gm;function _e(e,t){return e===t?0:e>t?1:-1}function Xe(e,t,n){return[e.values[n],t.values[n]]}function qe(e){return"number"==typeof e?isNaN(e)||e===1/0||e===-1/0?"":String(e):"string"==typeof e?e:""}var Ke=Object.freeze({__proto__:null,alphanumeric:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];for(r=qe(r),i=qe(i),r=r.split(Ve).filter(Boolean),i=i.split(Ve).filter(Boolean);r.length&&i.length;){var u=r.shift(),l=i.shift(),s=parseInt(u,10),a=parseInt(l,10),c=[s,a].sort();if(isNaN(c[0])){if(u>l)return 1;if(l>u)return-1}else{if(isNaN(c[1]))return isNaN(s)?-1:1;if(s>a)return 1;if(a>s)return-1}}return r.length-i.length},datetime:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];return _e(r=r.getTime(),i=i.getTime())},basic:function(e,t,n){var o=Xe(e,t,n);return _e(o[0],o[1])},string:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];for(r=r.split("").filter(Boolean),i=i.split("").filter(Boolean);r.length&&i.length;){var u=r.shift(),l=i.shift(),s=u.toLowerCase(),a=l.toLowerCase();if(s>a)return 1;if(a>s)return-1;if(u>l)return 1;if(l>u)return-1}return r.length-i.length},number:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1],u=/[^0-9.]/gi;return _e(r=Number(String(r).replace(u,"")),i=Number(String(i).replace(u,"")))}});l.resetSortBy="resetSortBy",l.setSortBy="setSortBy",l.toggleSortBy="toggleSortBy",l.clearSortBy="clearSortBy",c.sortType="alphanumeric",c.sortDescFirst=!1;var Ue=function(e){e.getSortByToggleProps=[$e],e.stateReducers.push(Je),e.useInstance.push(Ye)};Ue.pluginName="useSortBy";var $e=function(e,t){var n=t.instance,o=t.column,r=n.isMultiSortEvent,i=void 0===r?function(e){return e.shiftKey}:r;return[e,{onClick:o.canSort?function(e){e.persist(),o.toggleSortBy(void 0,!n.disableMultiSort&&i(e))}:void 0,style:{cursor:o.canSort?"pointer":void 0},title:o.canSort?"Toggle SortBy":void 0}]};function Je(e,t,n,o){if(t.type===l.init)return r({sortBy:[]},e);if(t.type===l.resetSortBy)return r({},e,{sortBy:o.initialState.sortBy||[]});if(t.type===l.clearSortBy)return r({},e,{sortBy:e.sortBy.filter((function(e){return e.id!==t.columnId}))});if(t.type===l.setSortBy)return r({},e,{sortBy:t.sortBy});if(t.type===l.toggleSortBy){var i,u=t.columnId,s=t.desc,a=t.multi,c=o.allColumns,d=o.disableMultiSort,f=o.disableSortRemove,p=o.disableMultiRemove,g=o.maxMultiSortColCount,v=void 0===g?Number.MAX_SAFE_INTEGER:g,m=e.sortBy,h=c.find((function(e){return e.id===u})).sortDescFirst,y=m.find((function(e){return e.id===u})),w=m.findIndex((function(e){return e.id===u})),R=null!=s,b=[];return"toggle"!==(i=!d&&a?y?"toggle":"add":w!==m.length-1||1!==m.length?"replace":y?"toggle":"replace")||f||R||a&&p||!(y&&y.desc&&!h||!y.desc&&h)||(i="remove"),"replace"===i?b=[{id:u,desc:R?s:h}]:"add"===i?(b=[].concat(m,[{id:u,desc:R?s:h}])).splice(0,b.length-v):"toggle"===i?b=m.map((function(e){return e.id===u?r({},e,{desc:R?s:!y.desc}):e})):"remove"===i&&(b=m.filter((function(e){return e.id!==u}))),r({},e,{sortBy:b})}}function Ye(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.allColumns,u=e.orderByFn,s=void 0===u?Qe:u,a=e.sortTypes,c=e.manualSortBy,d=e.defaultCanSort,p=e.disableSortBy,g=e.flatHeaders,m=e.state.sortBy,y=e.dispatch,R=e.plugins,b=e.getHooks,S=e.autoResetSortBy,C=void 0===S||S;v(R,["useFilters","useGlobalFilter","useGroupBy","usePivotColumns"],"useSortBy");var x=t.useCallback((function(e){y({type:l.setSortBy,sortBy:e})}),[y]),P=t.useCallback((function(e,t,n){y({type:l.toggleSortBy,columnId:e,desc:t,multi:n})}),[y]),B=h(e);g.forEach((function(e){var t=e.accessor,n=e.canSort,o=e.disableSortBy,r=e.id,i=t?I(!0!==o&&void 0,!0!==p&&void 0,!0):I(d,n,!1);e.canSort=i,e.canSort&&(e.toggleSortBy=function(t,n){return P(e.id,t,n)},e.clearSortBy=function(){y({type:l.clearSortBy,columnId:e.id})}),e.getSortByToggleProps=f(b().getSortByToggleProps,{instance:B(),column:e});var u=m.find((function(e){return e.id===r}));e.isSorted=!!u,e.sortedIndex=m.findIndex((function(e){return e.id===r})),e.isSortedDesc=e.isSorted?u.desc:void 0}));var E=t.useMemo((function(){if(c||!m.length)return[o,r];var e=[],t=m.filter((function(e){return i.find((function(t){return t.id===e.id}))}));return[function n(o){var r=s(o,t.map((function(e){var t=i.find((function(t){return t.id===e.id}));if(!t)throw new Error("React-Table: Could not find a column with id: "+e.id+" while sorting");var n=t.sortType,o=F(n)||(a||{})[n]||Ke[n];if(!o)throw new Error("React-Table: Could not find a valid sortType of '"+n+"' for column '"+e.id+"'.");return function(t,n){return o(t,n,e.id,e.desc)}})),t.map((function(e){var t=i.find((function(t){return t.id===e.id}));return t&&t.sortInverted?e.desc:!e.desc})));return r.forEach((function(t){e.push(t),t.subRows&&0!==t.subRows.length&&(t.subRows=n(t.subRows))})),r}(o),e]}),[c,m,o,r,i,s,a]),G=E[0],A=E[1],k=h(C);w((function(){k()&&y({type:l.resetSortBy})}),[c?null:n]),Object.assign(e,{preSortedRows:o,preSortedFlatRows:r,sortedRows:G,sortedFlatRows:A,rows:G,flatRows:A,setSortBy:x,toggleSortBy:P})}function Qe(e,t,n){return[].concat(e).sort((function(e,o){for(var r=0;r<t.length;r+=1){var i=t[r],u=!1===n[r]||"desc"===n[r],l=i(e,o);if(0!==l)return u?-l:l}return n[0]?e.index-o.index:o.index-e.index}))}l.resetPage="resetPage",l.gotoPage="gotoPage",l.setPageSize="setPageSize";var Ze=function(e){e.stateReducers.push(et),e.useInstance.push(tt)};function et(e,t,n,o){if(t.type===l.init)return r({pageSize:10,pageIndex:0},e);if(t.type===l.resetPage)return r({},e,{pageIndex:o.initialState.pageIndex||0});if(t.type===l.gotoPage){var i=o.pageCount,u=o.page,s=m(t.pageIndex,e.pageIndex),a=!1;return s>e.pageIndex?a=-1===i?u.length>=e.pageSize:s<i:s<e.pageIndex&&(a=s>-1),a?r({},e,{pageIndex:s}):e}if(t.type===l.setPageSize){var c=t.pageSize,d=e.pageSize*e.pageIndex;return r({},e,{pageIndex:Math.floor(d/c),pageSize:c})}}function tt(e){var n=e.rows,o=e.autoResetPage,r=void 0===o||o,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.plugins,a=e.pageCount,c=e.paginateExpandedRows,d=void 0===c||c,f=e.expandSubRows,p=void 0===f||f,g=e.state,m=g.pageSize,y=g.pageIndex,R=g.expanded,b=g.globalFilter,S=g.filters,C=g.groupBy,x=g.sortBy,P=e.dispatch,B=e.data,E=e.manualPagination;v(s,["useGlobalFilter","useFilters","useGroupBy","useSortBy","useExpanded"],"usePagination");var I=h(r);w((function(){I()&&P({type:l.resetPage})}),[P,E?null:B,b,S,C,x]);var F=E?a:Math.ceil(n.length/m),G=t.useMemo((function(){return F>0?[].concat(new Array(F)).fill(null).map((function(e,t){return t})):[]}),[F]),k=t.useMemo((function(){var e;if(E)e=n;else{var t=m*y,o=t+m;e=n.slice(t,o)}return d?e:A(e,{manualExpandedKey:u,expanded:R,expandSubRows:p})}),[p,R,u,E,y,m,d,n]),H=y>0,T=-1===F?k.length>=m:y<F-1,z=t.useCallback((function(e){P({type:l.gotoPage,pageIndex:e})}),[P]),W=t.useCallback((function(){return z((function(e){return e-1}))}),[z]),O=t.useCallback((function(){return z((function(e){return e+1}))}),[z]),M=t.useCallback((function(e){P({type:l.setPageSize,pageSize:e})}),[P]);Object.assign(e,{pageOptions:G,pageCount:F,page:k,canPreviousPage:H,canNextPage:T,gotoPage:z,previousPage:W,nextPage:O,setPageSize:M})}Ze.pluginName="usePagination",l.resetPivot="resetPivot",l.togglePivot="togglePivot";var nt=function(e){e.getPivotToggleProps=[rt],e.stateReducers.push(it),e.useInstanceAfterData.push(ut),e.allColumns.push(lt),e.accessValue.push(st),e.materializedColumns.push(at),e.materializedColumnsDeps.push(ct),e.visibleColumns.push(dt),e.visibleColumnsDeps.push(ft),e.useInstance.push(pt),e.prepareRow.push(gt)};nt.pluginName="usePivotColumns";var ot=[],rt=function(e,t){var n=t.header;return[e,{onClick:n.canPivot?function(e){e.persist(),n.togglePivot()}:void 0,style:{cursor:n.canPivot?"pointer":void 0},title:"Toggle Pivot"}]};function it(e,t,n,o){if(t.type===l.init)return r({pivotColumns:ot},e);if(t.type===l.resetPivot)return r({},e,{pivotColumns:o.initialState.pivotColumns||ot});if(t.type===l.togglePivot){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.pivotColumns.includes(i);return r({},e,s?{pivotColumns:[].concat(e.pivotColumns,[i])}:{pivotColumns:e.pivotColumns.filter((function(e){return e!==i}))})}}function ut(e){e.allColumns.forEach((function(t){t.isPivotSource=e.state.pivotColumns.includes(t.id)}))}function lt(e,t){var n=t.instance;return e.forEach((function(e){e.isPivotSource=n.state.pivotColumns.includes(e.id),e.uniqueValues=new Set})),e}function st(e,t){var n=t.column;return n.uniqueValues&&void 0!==e&&n.uniqueValues.add(e),e}function at(e,t){var n=t.instance,o=n.allColumns,i=n.state;if(!i.pivotColumns.length||!i.groupBy||!i.groupBy.length)return e;var u=i.pivotColumns.map((function(e){return o.find((function(t){return t.id===e}))})).filter(Boolean),l=o.filter((function(e){return!e.isPivotSource&&!i.groupBy.includes(e.id)&&!i.pivotColumns.includes(e.id)})),s=C(function e(t,n,o){void 0===t&&(t=0),void 0===o&&(o=[]);var i=u[t];return i?Array.from(i.uniqueValues).sort().map((function(u){var l=r({},i,{Header:i.PivotHeader||"string"==typeof i.header?i.Header+": "+u:u,isPivotGroup:!0,parent:n,depth:t,id:n?n.id+"."+i.id+"."+u:i.id+"."+u,pivotValue:u});return l.columns=e(t+1,l,[].concat(o,[function(e){return e.values[i.id]===u}])),l})):l.map((function(e){return r({},e,{canPivot:!1,isPivoted:!0,parent:n,depth:t,id:""+(n?n.id+"."+e.id:e.id),accessor:function(t,n,r){if(o.every((function(e){return e(r)})))return r.values[e.id]}})}))}());return[].concat(e,s)}function ct(e,t){var n=t.instance.state,o=n.pivotColumns,r=n.groupBy;return[].concat(e,[o,r])}function dt(e,t){var n=t.instance.state;return e=e.filter((function(e){return!e.isPivotSource})),n.pivotColumns.length&&n.groupBy&&n.groupBy.length&&(e=e.filter((function(e){return e.isGrouped||e.isPivoted}))),e}function ft(e,t){var n=t.instance;return[].concat(e,[n.state.pivotColumns,n.state.groupBy])}function pt(e){var t=e.columns,n=e.allColumns,o=e.flatHeaders,r=e.getHooks,i=e.plugins,u=e.dispatch,s=e.autoResetPivot,a=void 0===s||s,c=e.manaulPivot,d=e.disablePivot,p=e.defaultCanPivot;v(i,["useGroupBy"],"usePivotColumns");var g=h(e);n.forEach((function(t){var n=t.accessor,o=t.defaultPivot,r=t.disablePivot;t.canPivot=n?I(t.canPivot,!0!==r&&void 0,!0!==d&&void 0,!0):I(t.canPivot,o,p,!1),t.canPivot&&(t.togglePivot=function(){return e.togglePivot(t.id)}),t.Aggregated=t.Aggregated||t.Cell}));o.forEach((function(e){e.getPivotToggleProps=f(r().getPivotToggleProps,{instance:g(),header:e})}));var m=h(a);w((function(){m()&&u({type:l.resetPivot})}),[u,c?null:t]),Object.assign(e,{togglePivot:function(e,t){u({type:l.togglePivot,columnId:e,value:t})}})}function gt(e){e.allCells.forEach((function(e){e.isPivoted=e.column.isPivoted}))}l.resetSelectedRows="resetSelectedRows",l.toggleAllRowsSelected="toggleAllRowsSelected",l.toggleRowSelected="toggleRowSelected",l.toggleAllPageRowsSelected="toggleAllPageRowsSelected";var vt=function(e){e.getToggleRowSelectedProps=[mt],e.getToggleAllRowsSelectedProps=[ht],e.getToggleAllPageRowsSelectedProps=[yt],e.stateReducers.push(wt),e.useInstance.push(Rt),e.prepareRow.push(bt)};vt.pluginName="useRowSelect";var mt=function(e,t){var n=t.instance,o=t.row,r=n.manualRowSelectedKey,i=void 0===r?"isSelected":r;return[e,{onChange:function(e){o.toggleRowSelected(e.target.checked)},style:{cursor:"pointer"},checked:!(!o.original||!o.original[i])||o.isSelected,title:"Toggle Row Selected",indeterminate:o.isSomeSelected}]},ht=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleAllRowsSelected(e.target.checked)},style:{cursor:"pointer"},checked:n.isAllRowsSelected,title:"Toggle All Rows Selected",indeterminate:Boolean(!n.isAllRowsSelected&&Object.keys(n.state.selectedRowIds).length)}]},yt=function(e,t){var n=t.instance;return[e,{onChange:function(e){n.toggleAllPageRowsSelected(e.target.checked)},style:{cursor:"pointer"},checked:n.isAllPageRowsSelected,title:"Toggle All Current Page Rows Selected",indeterminate:Boolean(!n.isAllPageRowsSelected&&n.page.some((function(e){var t=e.id;return n.state.selectedRowIds[t]})))}]};function wt(e,t,n,o){if(t.type===l.init)return r({selectedRowIds:{}},e);if(t.type===l.resetSelectedRows)return r({},e,{selectedRowIds:o.initialState.selectedRowIds||{}});if(t.type===l.toggleAllRowsSelected){var i=t.value,u=o.isAllRowsSelected,s=o.rowsById,a=o.nonGroupedRowsById,c=void 0===a?s:a,d=void 0!==i?i:!u,f=Object.assign({},e.selectedRowIds);return d?Object.keys(c).forEach((function(e){f[e]=!0})):Object.keys(c).forEach((function(e){delete f[e]})),r({},e,{selectedRowIds:f})}if(t.type===l.toggleRowSelected){var p=t.id,g=t.value,v=o.rowsById,m=o.selectSubRows,h=void 0===m||m,y=o.getSubRows,w=e.selectedRowIds[p],R=void 0!==g?g:!w;if(w===R)return e;var b=r({},e.selectedRowIds);return function e(t){var n=v[t];if(n.isGrouped||(R?b[t]=!0:delete b[t]),h&&y(n))return y(n).forEach((function(t){return e(t.id)}))}(p),r({},e,{selectedRowIds:b})}if(t.type===l.toggleAllPageRowsSelected){var S=t.value,C=o.page,x=o.rowsById,P=o.selectSubRows,B=void 0===P||P,E=o.isAllPageRowsSelected,I=o.getSubRows,F=void 0!==S?S:!E,G=r({},e.selectedRowIds);return C.forEach((function(e){return function e(t){var n=x[t];if(n.isGrouped||(F?G[t]=!0:delete G[t]),B&&I(n))return I(n).forEach((function(t){return e(t.id)}))}(e.id)})),r({},e,{selectedRowIds:G})}return e}function Rt(e){var n=e.data,o=e.rows,r=e.getHooks,i=e.plugins,u=e.rowsById,s=e.nonGroupedRowsById,a=void 0===s?u:s,c=e.autoResetSelectedRows,d=void 0===c||c,p=e.state.selectedRowIds,g=e.selectSubRows,m=void 0===g||g,y=e.dispatch,R=e.page,b=e.getSubRows;v(i,["useFilters","useGroupBy","useSortBy","useExpanded","usePagination"],"useRowSelect");var S=t.useMemo((function(){var e=[];return o.forEach((function(t){var n=m?function e(t,n,o){if(n[t.id])return!0;var r=o(t);if(r&&r.length){var i=!0,u=!1;return r.forEach((function(t){u&&!i||(e(t,n,o)?u=!0:i=!1)})),!!i||!!u&&null}return!1}(t,p,b):!!p[t.id];t.isSelected=!!n,t.isSomeSelected=null===n,n&&e.push(t)})),e}),[o,m,p,b]),C=Boolean(Object.keys(a).length&&Object.keys(p).length),x=C;C&&Object.keys(a).some((function(e){return!p[e]}))&&(C=!1),C||R&&R.length&&R.some((function(e){var t=e.id;return!p[t]}))&&(x=!1);var P=h(d);w((function(){P()&&y({type:l.resetSelectedRows})}),[y,n]);var B=t.useCallback((function(e){return y({type:l.toggleAllRowsSelected,value:e})}),[y]),E=t.useCallback((function(e){return y({type:l.toggleAllPageRowsSelected,value:e})}),[y]),I=t.useCallback((function(e,t){return y({type:l.toggleRowSelected,id:e,value:t})}),[y]),F=h(e),G=f(r().getToggleAllRowsSelectedProps,{instance:F()}),A=f(r().getToggleAllPageRowsSelectedProps,{instance:F()});Object.assign(e,{selectedFlatRows:S,isAllRowsSelected:C,isAllPageRowsSelected:x,toggleRowSelected:I,toggleAllRowsSelected:B,getToggleAllRowsSelectedProps:G,getToggleAllPageRowsSelectedProps:A,toggleAllPageRowsSelected:E})}function bt(e,t){var n=t.instance;e.toggleRowSelected=function(t){return n.toggleRowSelected(e.id,t)},e.getToggleRowSelectedProps=f(n.getHooks().getToggleRowSelectedProps,{instance:n,row:e})}var St=function(e){return{}},Ct=function(e){return{}};l.setRowState="setRowState",l.setCellState="setCellState",l.resetRowState="resetRowState";var xt=function(e){e.stateReducers.push(Pt),e.useInstance.push(Bt),e.prepareRow.push(Et)};function Pt(e,t,n,o){var i=o.initialRowStateAccessor,u=void 0===i?St:i,s=o.initialCellStateAccessor,a=void 0===s?Ct:s,c=o.rowsById;if(t.type===l.init)return r({rowState:{}},e);if(t.type===l.resetRowState)return r({},e,{rowState:o.initialState.rowState||{}});if(t.type===l.setRowState){var d,f=t.rowId,p=t.value,g=void 0!==e.rowState[f]?e.rowState[f]:u(c[f]);return r({},e,{rowState:r({},e.rowState,(d={},d[f]=m(p,g),d))})}if(t.type===l.setCellState){var v,h,y,w,R,b=t.rowId,S=t.columnId,C=t.value,x=void 0!==e.rowState[b]?e.rowState[b]:u(c[b]),P=void 0!==(null==x?void 0:null==(v=x.cellState)?void 0:v[S])?x.cellState[S]:a(null==(h=c[b])?void 0:null==(y=h.cells)?void 0:y.find((function(e){return e.column.id===S})));return r({},e,{rowState:r({},e.rowState,(R={},R[b]=r({},x,{cellState:r({},x.cellState||{},(w={},w[S]=m(C,P),w))}),R))})}}function Bt(e){var n=e.autoResetRowState,o=void 0===n||n,r=e.data,i=e.dispatch,u=t.useCallback((function(e,t){return i({type:l.setRowState,rowId:e,value:t})}),[i]),s=t.useCallback((function(e,t,n){return i({type:l.setCellState,rowId:e,columnId:t,value:n})}),[i]),a=h(o);w((function(){a()&&i({type:l.resetRowState})}),[r]),Object.assign(e,{setRowState:u,setCellState:s})}function Et(e,t){var n=t.instance,o=n.initialRowStateAccessor,r=void 0===o?St:o,i=n.initialCellStateAccessor,u=void 0===i?Ct:i,l=n.state.rowState;e&&(e.state=void 0!==l[e.id]?l[e.id]:r(e),e.setState=function(t){return n.setRowState(e.id,t)},e.cells.forEach((function(t){e.state.cellState||(e.state.cellState={}),t.state=void 0!==e.state.cellState[t.column.id]?e.state.cellState[t.column.id]:u(t),t.setState=function(o){return n.setCellState(e.id,t.column.id,o)}})))}xt.pluginName="useRowState",l.resetColumnOrder="resetColumnOrder",l.setColumnOrder="setColumnOrder";var It=function(e){e.stateReducers.push(Ft),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return[].concat(e,[n.state.columnOrder])})),e.visibleColumns.push(Gt),e.useInstance.push(At)};function Ft(e,t,n,o){return t.type===l.init?r({columnOrder:[]},e):t.type===l.resetColumnOrder?r({},e,{columnOrder:o.initialState.columnOrder||[]}):t.type===l.setColumnOrder?r({},e,{columnOrder:m(t.columnOrder,e.columnOrder)}):void 0}function Gt(e,t){var n=t.instance.state.columnOrder;if(!n||!n.length)return e;for(var o=[].concat(n),r=[].concat(e),i=[],u=function(){var e=o.shift(),t=r.findIndex((function(t){return t.id===e}));t>-1&&i.push(r.splice(t,1)[0])};r.length&&o.length;)u();return[].concat(i,r)}function At(e){var n=e.dispatch;e.setColumnOrder=t.useCallback((function(e){return n({type:l.setColumnOrder,columnOrder:e})}),[n])}It.pluginName="useColumnOrder",c.canResize=!0,l.columnStartResizing="columnStartResizing",l.columnResizing="columnResizing",l.columnDoneResizing="columnDoneResizing",l.resetResize="resetResize";var kt=function(e){e.getResizerProps=[Ht],e.getHeaderProps.push({style:{position:"relative"}}),e.stateReducers.push(Tt),e.useInstance.push(Wt),e.useInstanceBeforeDimensions.push(zt)},Ht=function(e,t){var n=t.instance,o=t.header,r=n.dispatch,i=function(e,t){var n=!1;if("touchstart"===e.type){if(e.touches&&e.touches.length>1)return;n=!0}var o=function(e){var t=[];return function e(n){n.columns&&n.columns.length&&n.columns.map(e);t.push(n)}(e),t}(t).map((function(e){return[e.id,e.totalWidth]})),i=n?Math.round(e.touches[0].clientX):e.clientX,u=function(e){r({type:l.columnResizing,clientX:e})},s=function(){return r({type:l.columnDoneResizing})},a={mouse:{moveEvent:"mousemove",moveHandler:function(e){return u(e.clientX)},upEvent:"mouseup",upHandler:function(e){document.removeEventListener("mousemove",a.mouse.moveHandler),document.removeEventListener("mouseup",a.mouse.upHandler),s()}},touch:{moveEvent:"touchmove",moveHandler:function(e){return e.cancelable&&(e.preventDefault(),e.stopPropagation()),u(e.touches[0].clientX),!1},upEvent:"touchend",upHandler:function(e){document.removeEventListener(a.touch.moveEvent,a.touch.moveHandler),document.removeEventListener(a.touch.upEvent,a.touch.moveHandler),s()}}},c=n?a.touch:a.mouse,d=!!function(){if("boolean"==typeof z)return z;var e=!1;try{var t={get passive(){return e=!0,!1}};window.addEventListener("test",null,t),window.removeEventListener("test",null,t)}catch(t){e=!1}return z=e}()&&{passive:!1};document.addEventListener(c.moveEvent,c.moveHandler,d),document.addEventListener(c.upEvent,c.upHandler,d),r({type:l.columnStartResizing,columnId:t.id,columnWidth:t.totalWidth,headerIdWidths:o,clientX:i})};return[e,{onMouseDown:function(e){return e.persist()||i(e,o)},onTouchStart:function(e){return e.persist()||i(e,o)},style:{cursor:"col-resize"},draggable:!1,role:"separator"}]};function Tt(e,t){if(t.type===l.init)return r({columnResizing:{columnWidths:{}}},e);if(t.type===l.resetResize)return r({},e,{columnResizing:{columnWidths:{}}});if(t.type===l.columnStartResizing){var n=t.clientX,o=t.columnId,i=t.columnWidth,u=t.headerIdWidths;return r({},e,{columnResizing:r({},e.columnResizing,{startX:n,headerIdWidths:u,columnWidth:i,isResizingColumn:o})})}if(t.type===l.columnResizing){var s=t.clientX,a=e.columnResizing,c=a.startX,d=a.columnWidth,f=a.headerIdWidths,p=(s-c)/d,g={};return(void 0===f?[]:f).forEach((function(e){var t=e[0],n=e[1];g[t]=Math.max(n+n*p,0)})),r({},e,{columnResizing:r({},e.columnResizing,{columnWidths:r({},e.columnResizing.columnWidths,{},g)})})}return t.type===l.columnDoneResizing?r({},e,{columnResizing:r({},e.columnResizing,{startX:null,isResizingColumn:null})}):void 0}kt.pluginName="useResizeColumns";var zt=function(e){var t=e.flatHeaders,n=e.disableResizing,o=e.getHooks,r=e.state.columnResizing,i=h(e);t.forEach((function(e){var t=I(!0!==e.disableResizing&&void 0,!0!==n&&void 0,!0);e.canResize=t,e.width=r.columnWidths[e.id]||e.originalWidth||e.width,e.isResizing=r.isResizingColumn===e.id,t&&(e.getResizerProps=f(o().getResizerProps,{instance:i(),header:e}))}))};function Wt(e){var n=e.plugins,o=e.dispatch,r=e.autoResetResize,i=void 0===r||r,u=e.columns;v(n,["useAbsoluteLayout"],"useResizeColumns");var s=h(i);w((function(){s()&&o({type:l.resetResize})}),[u]);var a=t.useCallback((function(){return o({type:l.resetResize})}),[o]);Object.assign(e,{resetResizing:a})}var Ot={position:"absolute",top:0},Mt=function(e){e.getTableBodyProps.push(jt),e.getRowProps.push(jt),e.getHeaderGroupProps.push(jt),e.getFooterGroupProps.push(jt),e.getHeaderProps.push((function(e,t){var n=t.column;return[e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return[e,{style:r({},Ot,{left:n.column.totalLeft+"px",width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return[e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]}))};Mt.pluginName="useAbsoluteLayout";var jt=function(e,t){return[e,{style:{position:"relative",width:t.instance.totalColumnsWidth+"px"}}]},Nt={display:"inline-block",boxSizing:"border-box"},Lt=function(e,t){return[e,{style:{display:"flex",width:t.instance.totalColumnsWidth+"px"}}]},Dt=function(e){e.getRowProps.push(Lt),e.getHeaderGroupProps.push(Lt),e.getFooterGroupProps.push(Lt),e.getHeaderProps.push((function(e,t){var n=t.column;return[e,{style:r({},Nt,{width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return[e,{style:r({},Nt,{width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return[e,{style:r({},Nt,{width:n.totalWidth+"px"})}]}))};function Vt(e){e.getTableProps.push(_t),e.getRowProps.push(Xt),e.getHeaderGroupProps.push(Xt),e.getFooterGroupProps.push(Xt),e.getHeaderProps.push(qt),e.getCellProps.push(Kt),e.getFooterProps.push(Ut)}Dt.pluginName="useBlockLayout",Vt.pluginName="useFlexLayout";var _t=function(e,t){return[e,{style:{minWidth:t.instance.totalColumnsMinWidth+"px"}}]},Xt=function(e,t){return[e,{style:{display:"flex",flex:"1 0 auto",minWidth:t.instance.totalColumnsMinWidth+"px"}}]},qt=function(e,t){var n=t.column;return[e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]},Kt=function(e,t){var n=t.cell;return[e,{style:{boxSizing:"border-box",flex:n.column.totalFlexWidth+" 0 auto",minWidth:n.column.totalMinWidth+"px",width:n.column.totalWidth+"px"}}]},Ut=function(e,t){var n=t.column;return[e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]};function $t(e){e.stateReducers.push(Qt),e.getTableProps.push(Jt),e.getHeaderProps.push(Yt)}$t.pluginName="useGridLayout";var Jt=function(e,t){return[e,{style:{display:"grid",gridTemplateColumns:t.instance.state.gridLayout.columnWidths.map((function(e){return e})).join(" ")}}]},Yt=function(e,t){return[e,{id:"header-cell-"+t.column.id,style:{position:"sticky"}}]};function Qt(e,t,n,o){if("init"===t.type)return r({gridLayout:{columnWidths:o.columns.map((function(){return"auto"}))}},e);if("columnStartResizing"===t.type){var i=t.columnId,u=o.visibleColumns.findIndex((function(e){return e.id===i})),l=function(e){var t,n=null==(t=document.getElementById("header-cell-"+e))?void 0:t.offsetWidth;if(void 0!==n)return n}(i);return void 0!==l?r({},e,{gridLayout:r({},e.gridLayout,{columnId:i,columnIndex:u,startingWidth:l})}):e}if("columnResizing"===t.type){var s=e.gridLayout,a=s.columnIndex,c=s.startingWidth,d=s.columnWidths,f=c-(e.columnResizing.startX-t.clientX),p=[].concat(d);return p[a]=f+"px",r({},e,{gridLayout:r({},e.gridLayout,{columnWidths:p})})}}e._UNSTABLE_usePivotColumns=nt,e.actions=l,e.defaultColumn=c,e.defaultGroupByFn=De,e.defaultOrderByFn=Qe,e.defaultRenderer=s,e.emptyRenderer=a,e.ensurePluginOrder=v,e.flexRender=b,e.functionalUpdate=m,e.loopHooks=g,e.makePropGetter=f,e.makeRenderer=R,e.reduceHooks=p,e.safeUseLayoutEffect=y,e.useAbsoluteLayout=Mt,e.useAsyncDebounce=function(e,n){void 0===n&&(n=0);var r=t.useRef({}),i=h(e),u=h(n);return t.useCallback(function(){var e=o(regeneratorRuntime.mark((function e(){var t,n,l,s=arguments;return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:for(t=s.length,n=new Array(t),l=0;l<t;l++)n[l]=s[l];return r.current.promise||(r.current.promise=new Promise((function(e,t){r.current.resolve=e,r.current.reject=t}))),r.current.timeout&&clearTimeout(r.current.timeout),r.current.timeout=setTimeout(o(regeneratorRuntime.mark((function e(){return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return delete r.current.timeout,e.prev=1,e.t0=r.current,e.next=5,i().apply(void 0,n);case 5:e.t1=e.sent,e.t0.resolve.call(e.t0,e.t1),e.next=12;break;case 9:e.prev=9,e.t2=e.catch(1),r.current.reject(e.t2);case 12:return e.prev=12,delete r.current.promise,e.finish(12);case 15:case"end":return e.stop()}}),e,null,[[1,9,12,15]])}))),u()),e.abrupt("return",r.current.promise);case 5:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),[i,u])},e.useBlockLayout=Dt,e.useColumnOrder=It,e.useExpanded=se,e.useFilters=Pe,e.useFlexLayout=Vt,e.useGetLatest=h,e.useGlobalFilter=Ie,e.useGridLayout=$t,e.useGroupBy=ze,e.useMountedLayoutEffect=w,e.usePagination=Ze,e.useResizeColumns=kt,e.useRowSelect=vt,e.useRowState=xt,e.useSortBy=Ue,e.useTable=function(e){for(var n=arguments.length,o=new Array(n>1?n-1:0),i=1;i<n;i++)o[i-1]=arguments[i];e=ie(e),o=[K].concat(o);var u=t.useRef({}),s=h(u.current);Object.assign(s(),r({},e,{plugins:o,hooks:q()})),o.filter(Boolean).forEach((function(e){e(s().hooks)}));var a=h(s().hooks);s().getHooks=a,delete s().hooks,Object.assign(s(),p(a().useOptions,ie(e)));var c=s(),d=c.data,v=c.columns,m=c.initialState,y=c.defaultColumn,w=c.getSubRows,b=c.getRowId,E=c.stateReducer,I=c.useControlledState,F=h(E),G=t.useCallback((function(e,t){if(!t.type)throw console.info({action:t}),new Error("Unknown Action 👆");return[].concat(a().stateReducers,Array.isArray(F())?F():[F()]).reduce((function(n,o){return o(n,t,e,s())||n}),e)}),[a,F,s]),A=t.useReducer(G,void 0,(function(){return G(m,{type:l.init})})),k=A[0],H=A[1],T=p([].concat(a().useControlledState,[I]),k,{instance:s()});Object.assign(s(),{state:T,dispatch:H});var z=t.useMemo((function(){return S(p(a().columns,v,{instance:s()}))}),[a,s,v].concat(p(a().columnsDeps,[],{instance:s()})));s().columns=z;var W=t.useMemo((function(){return p(a().allColumns,C(z),{instance:s()}).map(x)}),[z,a,s].concat(p(a().allColumnsDeps,[],{instance:s()})));s().allColumns=W;var O=t.useMemo((function(){for(var e=[],t=[],n={},o=[].concat(W);o.length;){var r=o.shift();le({data:d,rows:e,flatRows:t,rowsById:n,column:r,getRowId:b,getSubRows:w,accessValueHooks:a().accessValue,getInstance:s})}return[e,t,n]}),[W,d,b,w,a,s]),M=O[0],j=O[1],N=O[2];Object.assign(s(),{rows:M,initialRows:[].concat(M),flatRows:j,rowsById:N}),g(a().useInstanceAfterData,s());var L=t.useMemo((function(){return p(a().visibleColumns,W,{instance:s()}).map((function(e){return P(e,y)}))}),[a,W,s,y].concat(p(a().visibleColumnsDeps,[],{instance:s()})));W=t.useMemo((function(){var e=[].concat(L);return W.forEach((function(t){e.find((function(e){return e.id===t.id}))||e.push(t)})),e}),[W,L]),s().allColumns=W;var D=t.useMemo((function(){return p(a().headerGroups,B(L,y),s())}),[a,L,y,s].concat(p(a().headerGroupsDeps,[],{instance:s()})));s().headerGroups=D;var V=t.useMemo((function(){return D.length?D[0].headers:[]}),[D]);s().headers=V,s().flatHeaders=D.reduce((function(e,t){return[].concat(e,t.headers)}),[]),g(a().useInstanceBeforeDimensions,s());var _=L.filter((function(e){return e.isVisible})).map((function(e){return e.id})).sort().join("_");L=t.useMemo((function(){return L.filter((function(e){return e.isVisible}))}),[L,_]),s().visibleColumns=L;var X=ue(V),U=X[0],$=X[1],J=X[2];return s().totalColumnsMinWidth=U,s().totalColumnsWidth=$,s().totalColumnsMaxWidth=J,g(a().useInstance,s()),[].concat(s().flatHeaders,s().allColumns).forEach((function(e){e.render=R(s(),e),e.getHeaderProps=f(a().getHeaderProps,{instance:s(),column:e}),e.getFooterProps=f(a().getFooterProps,{instance:s(),column:e})})),s().headerGroups=t.useMemo((function(){return D.filter((function(e,t){return e.headers=e.headers.filter((function(e){return e.headers?function e(t){return t.filter((function(t){return t.headers?e(t.headers):t.isVisible})).length}(e.headers):e.isVisible})),!!e.headers.length&&(e.getHeaderGroupProps=f(a().getHeaderGroupProps,{instance:s(),headerGroup:e,index:t}),e.getFooterGroupProps=f(a().getFooterGroupProps,{instance:s(),headerGroup:e,index:t}),!0)}))}),[D,s,a]),s().footerGroups=[].concat(s().headerGroups).reverse(),s().prepareRow=t.useCallback((function(e){e.getRowProps=f(a().getRowProps,{instance:s(),row:e}),e.allCells=W.map((function(t){var n=e.values[t.id],o={column:t,row:e,value:n};return o.getCellProps=f(a().getCellProps,{instance:s(),cell:o}),o.render=R(s(),t,{row:e,cell:o,value:n}),o})),e.cells=L.map((function(t){return e.allCells.find((function(e){return e.column.id===t.id}))})),g(a().prepareRow,e,{instance:s()})}),[a,s,W,L]),s().getTableProps=f(a().getTableProps,{instance:s()}),s().getTableBodyProps=f(a().getTableBodyProps,{instance:s()}),g(a().useFinalInstance,s()),s()},Object.defineProperty(e,"__esModule",{value:!0})}));
//# sourceMappingURL=react-table.production.min.js.map


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	_createClass(AutosizeInput, null, [{
		key: 'getDerivedStateFromProps',
		value: function getDerivedStateFromProps(props, state) {
			var id = props.id;

			return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
		}
	}]);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId(),
			prevId: props.id
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 793 */,
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props, propName, componentName) {
  componentName = componentName || 'ANONYMOUS';

  if (props[propName]) {
    return new Error('Passed prop "' + propName + '" with value "' + props[propName] + '" to ' + componentName + '. This prop will be overridden.');
  }

  return null;
};

/***/ }),
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(707);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _CloseButton = __webpack_require__(221);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _jquery = __webpack_require__(671);

var _jquery2 = _interopRequireDefault(_jquery);

var _reactDom = __webpack_require__(46);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var handlerProps = ['onShow', 'onShown', 'onHide', 'onHidden'];
var modalEvent = {
  onShow: 'show.bs.modal',
  onShown: 'shown.bs.modal',
  onHide: 'hide.bs.modal',
  onHidden: 'hidden.bs.modal'
};

var Modal = (_temp = _class = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          backdrop = _props.backdrop,
          isOpen = _props.isOpen,
          keyboard = _props.keyboard,
          show = _props.show,
          remote = _props.remote,
          className = _props.className;


      this.$modal = (0, _jquery2.default)((0, _reactDom.findDOMNode)(this));

      this.$modal.modal({
        backdrop: backdrop,
        keyboard: keyboard,
        show: show,
        remote: remote
      });

      handlerProps.forEach(function (prop) {
        if (_this2.props[prop]) {
          _this2.$modal.on(modalEvent[prop], _this2.props[prop]);
        }
      });

      if (isOpen) {
        this.show();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var isOpen = _ref.isOpen;

      isOpen ? this.show() : this.hide();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      handlerProps.forEach(function (prop) {
        if (_this3.props[prop]) {
          _this3.$modal.off(modalEvent[prop], _this3.props[prop]);
        }
      });
    }
  }, {
    key: 'show',
    value: function show() {
      this.$modal.modal('show');
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$modal.modal('hide');
    }
  }, {
    key: 'renderCloseButton',
    value: function renderCloseButton() {
      var _props2 = this.props,
          showCloseButton = _props2.showCloseButton,
          onCloseClick = _props2.onCloseClick;


      if (showCloseButton) {
        return _react2.default.createElement(_CloseButton2.default, { onClick: onCloseClick });
      }
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader() {
      var header = this.props.header;


      if (header) {
        return _react2.default.createElement(
          'div',
          { className: 'modal-header' },
          this.renderCloseButton(),
          header
        );
      }
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var footer = this.props.footer;


      if (footer) {
        return _react2.default.createElement(
          'div',
          { className: 'modal-footer' },
          footer
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          className = _props3.className,
          header = _props3.header;

      var classes = (0, _classnames2.default)('modal', 'fade', className);

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: 'modal-dialog' },
          _react2.default.createElement(
            'div',
            { className: 'modal-content' },
            this.renderHeader(),
            _react2.default.createElement(
              'div',
              { className: 'modal-body' },
              !header && this.renderCloseButton(),
              children
            ),
            this.renderFooter()
          )
        )
      );
    }
  }]);

  return Modal;
}(_react.Component), _class.propTypes = {
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
  className: _propTypes2.default.string,
  footer: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
  header: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
  isOpen: _propTypes2.default.bool.isRequired,
  keyboard: _propTypes2.default.bool,
  onCloseClick: _propTypes2.default.func.isRequired,
  onHidden: _propTypes2.default.func,
  onHide: _propTypes2.default.func,
  onShow: _propTypes2.default.func,
  onShown: _propTypes2.default.func,
  remote: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  show: _propTypes2.default.bool,
  showCloseButton: _propTypes2.default.bool
}, _class.defaultProps = {
  backdrop: true,
  keyboard: true,
  show: false,
  remote: false,
  showCloseButton: true
}, _temp);
exports.default = Modal;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(125);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortableTableHeader = (_temp = _class = function (_Component) {
  _inherits(SortableTableHeader, _Component);

  function SortableTableHeader(props) {
    _classCallCheck(this, SortableTableHeader);

    var _this = _possibleConstructorReturn(this, (SortableTableHeader.__proto__ || Object.getPrototypeOf(SortableTableHeader)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(SortableTableHeader, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          active = _props.active,
          order = _props.order,
          label = _props.label;


      return active !== nextProps.active || order !== nextProps.order || label !== nextProps.label;
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();

      var order = this.props.order === 'asc' ? 'desc' : 'asc';
      if (!this.props.active) {
        order = 'asc';
      }

      this.props.onClick(order);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          active = _props2.active,
          order = _props2.order,
          label = _props2.label;

      var direction = (0, _classnames2.default)({
        down: order === 'desc',
        up: order === 'asc'
      });

      return _react2.default.createElement(
        'a',
        { onClick: this.handleClick },
        I18n.t(label),
        active && _react2.default.createElement(_Icon2.default, { name: 'chevron-' + direction, className: 'marginLeft5' })
      );
    }
  }]);

  return SortableTableHeader;
}(_react.Component), _class.propTypes = {
  active: _propTypes2.default.bool.isRequired,
  label: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  order: _propTypes2.default.oneOf(['asc', 'desc']).isRequired
}, _class.defaultProps = {
  order: 'asc'
}, _temp);
exports.default = SortableTableHeader;

/***/ }),
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 833 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(835);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(824);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(697),
    baseOrderBy = __webpack_require__(988),
    baseRest = __webpack_require__(218),
    isIterateeCall = __webpack_require__(224);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(53),
    isArguments = __webpack_require__(98),
    isArray = __webpack_require__(17);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _WorkspaceSelector = __webpack_require__(1218);

var _WorkspaceSelector2 = _interopRequireDefault(_WorkspaceSelector);

var _reactRedux = __webpack_require__(6);

var _workspaceActions = __webpack_require__(332);

var _ProTooltip = __webpack_require__(956);

var _ProTooltip2 = _interopRequireDefault(_ProTooltip);

var _emotionTheming = __webpack_require__(668);

var _normalizeTheme = __webpack_require__(957);

var _normalizeTheme2 = _interopRequireDefault(_normalizeTheme);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkspaceSelectorContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, { createWorkspace: _workspaceActions.createWorkspace, fetchWorkspacesIfNeeded: _workspaceActions.fetchWorkspacesIfNeeded }, mergeProps), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  _inherits(WorkspaceSelectorContainer, _PureComponent);

  function WorkspaceSelectorContainer(props) {
    _classCallCheck(this, WorkspaceSelectorContainer);

    var _this = _possibleConstructorReturn(this, (WorkspaceSelectorContainer.__proto__ || Object.getPrototypeOf(WorkspaceSelectorContainer)).call(this, props));

    _this.handleLinkClick = function () {
      var _this$state = _this.state,
          isOpen = _this$state.isOpen,
          isLiteUser = _this$state.isLiteUser;


      if (!isLiteUser) {
        _this.setState({ isOpen: !isOpen });
      }
    };

    _this.renderWorkspaceSelector = function () {
      var _this$props = _this.props,
          isFetching = _this$props.isFetching,
          isSaving = _this$props.isSaving,
          children = _this$props.children,
          workspaces = _this$props.workspaces;
      var _this$state2 = _this.state,
          isOpen = _this$state2.isOpen,
          selectedWorkspaceName = _this$state2.selectedWorkspaceName;


      return _react2.default.createElement(
        _WorkspaceSelector2.default,
        {
          isFetching: isFetching || isSaving,
          isOpen: isOpen,
          onLinkClick: _this.handleLinkClick,
          onSaveClick: _this.onSaveClick,
          onChangeSelectedWorkspace: function onChangeSelectedWorkspace(name) {
            return _this.setState({ selectedWorkspaceName: name });
          },
          selectedWorkspaceName: selectedWorkspaceName,
          workspaces: workspaces
        },
        children
      );
    };

    _this.close = _this.close.bind(_this);
    _this.onSaveClick = _this.onSaveClick.bind(_this);

    _this.state = {
      isOpen: false,
      selectedWorkspaceName: '',
      isLiteUser: _this.props.isLiteUser,
      offset: 0
    };
    return _this;
  }

  _createClass(WorkspaceSelectorContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.close);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.close);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          company = _props.company,
          fetchWorkspacesIfNeeded = _props.fetchWorkspacesIfNeeded;

      fetchWorkspacesIfNeeded(company);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      var offset = this.state.offset;

      var currentOffset = _reactDom2.default.findDOMNode(this).offsetHeight;
      if (offset !== currentOffset) {
        this.setState({ offset: currentOffset });
      }
    }
  }, {
    key: 'close',
    value: function close() {
      this.setState({
        isOpen: false,
        selectedWorkspaceName: ''
      });
    }
  }, {
    key: 'onSaveClick',
    value: function onSaveClick() {
      var _this2 = this;

      var promise = void 0;
      var selectedWorkspaceName = this.state.selectedWorkspaceName;
      var _props2 = this.props,
          company = _props2.company,
          createWorkspace = _props2.createWorkspace,
          onAddToWorkspace = _props2.onAddToWorkspace,
          workspaces = _props2.workspaces;

      var selectedWorkspace = workspaces.find(function (workspace) {
        return workspace.name.toLowerCase() === selectedWorkspaceName.toLowerCase().trim();
      });

      if (selectedWorkspace) {
        promise = onAddToWorkspace(selectedWorkspace);
      } else {
        promise = createWorkspace(company, { name: selectedWorkspaceName }).then(function (action) {
          var workspaceId = action.response.result;
          return onAddToWorkspace(action.response.entities.workspaces[workspaceId]);
        });
      }

      if (promise && typeof promise.then === 'function') {
        promise.then(function () {
          return _this2.close();
        });
      } else {
        this.close();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var isLiteUser = this.state.isLiteUser;


      if (isLiteUser) {
        return _react2.default.createElement(
          _emotionTheming.ThemeProvider,
          { theme: (0, _normalizeTheme2.default)() },
          _react2.default.createElement(_ProTooltip2.default, {
            renderTrigger: { InternalComponent: this.renderWorkspaceSelector },
            tooltipType: 'WORKSPACE',
            position: 'bottom',
            key: this.state.offset
          })
        );
      }

      return this.renderWorkspaceSelector();
    }
  }]);

  return WorkspaceSelectorContainer;
}(_react.PureComponent), _class2.propTypes = {
  children: _propTypes2.default.node,
  company: _propTypes2.default.object.isRequired,
  createWorkspace: _propTypes2.default.func.isRequired,
  fetchWorkspacesIfNeeded: _propTypes2.default.func.isRequired,
  isFetching: _propTypes2.default.bool.isRequired,
  isLiteUser: _propTypes2.default.bool.isRequired,
  isSaving: _propTypes2.default.bool.isRequired,
  onAddToWorkspace: _propTypes2.default.func.isRequired,
  projectGroupId: _propTypes2.default.number,
  projectId: _propTypes2.default.number,
  workspaces: _propTypes2.default.array.isRequired
}, _temp)) || _class);
exports.default = WorkspaceSelectorContainer;


function mergeProps(stateProps, dispatchProps, ownProps) {
  var company = stateProps.company,
      isFetching = stateProps.isFetching,
      isSaving = stateProps.isSaving,
      workspaceEntities = stateProps.workspaceEntities,
      workspaceIds = stateProps.workspaceIds;

  var workspaces = workspaceIds.map(function (id) {
    return workspaceEntities[id];
  });

  return Object.assign({}, dispatchProps, ownProps, {
    company: company,
    isFetching: isFetching,
    isSaving: isSaving,
    workspaces: workspaces
  });
}

function mapStateToProps(state) {
  return {
    company: state.company,
    isFetching: state.workspaces.isSaving,
    isSaving: state.workspaces.isFetching,
    workspaceEntities: state.entities.workspaces,
    workspaceIds: state.workspaces.items
  };
}

/***/ }),
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(687),
    baseEach = __webpack_require__(696),
    castFunction = __webpack_require__(893),
    isArray = __webpack_require__(17);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _DescriptionList = __webpack_require__(987);

var _DescriptionList2 = _interopRequireDefault(_DescriptionList);

var _MetaTagList = __webpack_require__(1213);

var _MetaTagList2 = _interopRequireDefault(_MetaTagList);

var _OverlayInfo = __webpack_require__(1214);

var _OverlayInfo2 = _interopRequireDefault(_OverlayInfo);

var _OverlayTile = __webpack_require__(682);

var _OverlayTile2 = _interopRequireDefault(_OverlayTile);

var _OverlayTileHeading = __webpack_require__(683);

var _OverlayTileHeading2 = _interopRequireDefault(_OverlayTileHeading);

var _ToggleSwitch = __webpack_require__(1142);

var _ToggleSwitch2 = _interopRequireDefault(_ToggleSwitch);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayAboutTile = (_temp = _class = function (_PureComponent) {
  _inherits(OverlayAboutTile, _PureComponent);

  function OverlayAboutTile(props) {
    _classCallCheck(this, OverlayAboutTile);

    var _this = _possibleConstructorReturn(this, (OverlayAboutTile.__proto__ || Object.getPrototypeOf(OverlayAboutTile)).call(this, props));

    _this.state = {
      detailsExpanded: false
    };
    return _this;
  }

  _createClass(OverlayAboutTile, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          date = _props.date,
          details = _props.details,
          expandableDetails = _props.expandableDetails,
          heading = _props.heading,
          metaTags = _props.metaTags,
          searchHighlights = _props.searchHighlights,
          title = _props.title,
          user = _props.user,
          verb = _props.verb;
      var detailsExpanded = this.state.detailsExpanded;


      return _react2.default.createElement(
        _OverlayTile2.default,
        null,
        expandableDetails && _react2.default.createElement(_ToggleSwitch2.default, {
          className: 'blueText right',
          expanded: detailsExpanded,
          onClick: function onClick() {
            return _this2.setState({ detailsExpanded: !detailsExpanded });
          }
        }),
        _react2.default.createElement(_OverlayTileHeading2.default, { icon: 'info', title: heading }),
        _react2.default.createElement(_OverlayInfo2.default, {
          date: date,
          user: user,
          searchHighlights: searchHighlights,
          title: title,
          verb: verb
        }),
        metaTags && _react2.default.createElement(_MetaTagList2.default, { metaTags: metaTags }),
        details && _react2.default.createElement(_DescriptionList2.default, { listItems: details }),
        detailsExpanded && _react2.default.createElement('hr', null),
        detailsExpanded && expandableDetails && _react2.default.createElement(_DescriptionList2.default, { listItems: expandableDetails })
      );
    }
  }]);

  return OverlayAboutTile;
}(_react.PureComponent), _class.propTypes = {
  date: _propTypes2.default.string,
  details: _propTypes2.default.object,
  expandableDetails: _propTypes2.default.object,
  heading: _propTypes2.default.string.isRequired,
  metaTags: _propTypes2.default.array,
  searchHighlights: _propTypes2.default.array,
  title: _propTypes2.default.string,
  user: _propTypes2.default.object,
  verb: _propTypes2.default.string
}, _temp);
exports.default = OverlayAboutTile;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(621),
    isArguments = __webpack_require__(98),
    isArray = __webpack_require__(17),
    isIndex = __webpack_require__(123),
    isLength = __webpack_require__(124),
    toKey = __webpack_require__(263);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayColumn = (_temp = _class = function (_Component) {
  _inherits(OverlayColumn, _Component);

  function OverlayColumn() {
    _classCallCheck(this, OverlayColumn);

    return _possibleConstructorReturn(this, (OverlayColumn.__proto__ || Object.getPrototypeOf(OverlayColumn)).apply(this, arguments));
  }

  _createClass(OverlayColumn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          align = _props.align,
          children = _props.children,
          style = _props.style;


      return _react2.default.createElement(
        'div',
        { className: align + '-column', style: style },
        children
      );
    }
  }]);

  return OverlayColumn;
}(_react.Component), _class.propTypes = {
  align: _propTypes2.default.oneOf(['left', 'right']),
  children: _propTypes2.default.node,
  style: _propTypes2.default.object
}, _class.defaultProps = {
  align: 'left'
}, _temp);
exports.default = OverlayColumn;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _OverlayTile = __webpack_require__(682);

var _OverlayTile2 = _interopRequireDefault(_OverlayTile);

var _OverlayTileHeading = __webpack_require__(683);

var _OverlayTileHeading2 = _interopRequireDefault(_OverlayTileHeading);

var _Tags = __webpack_require__(1215);

var _Tags2 = _interopRequireDefault(_Tags);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayTagTile = (_temp = _class = function (_Component) {
  _inherits(OverlayTagTile, _Component);

  function OverlayTagTile() {
    _classCallCheck(this, OverlayTagTile);

    return _possibleConstructorReturn(this, (OverlayTagTile.__proto__ || Object.getPrototypeOf(OverlayTagTile)).apply(this, arguments));
  }

  _createClass(OverlayTagTile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          searchHighlights = _props.searchHighlights,
          tags = _props.tags;


      return _react2.default.createElement(
        _OverlayTile2.default,
        { count: tags.length },
        _react2.default.createElement(_OverlayTileHeading2.default, { icon: 'tags', title: 'Tags' }),
        _react2.default.createElement(_Tags2.default, { searchHighlights: searchHighlights, tags: tags })
      );
    }
  }]);

  return OverlayTagTile;
}(_react.Component), _class.propTypes = {
  searchHighlights: _propTypes2.default.array,
  tags: _propTypes2.default.array.isRequired
}, _temp);
exports.default = OverlayTagTile;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayTileColumn = (_temp = _class = function (_Component) {
  _inherits(OverlayTileColumn, _Component);

  function OverlayTileColumn() {
    _classCallCheck(this, OverlayTileColumn);

    return _possibleConstructorReturn(this, (OverlayTileColumn.__proto__ || Object.getPrototypeOf(OverlayTileColumn)).apply(this, arguments));
  }

  _createClass(OverlayTileColumn, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          align = _props.align,
          children = _props.children;


      var classes = (0, _classnames2.default)({
        'col-l': align === 'left',
        'col-r': align === 'right'
      });

      return _react2.default.createElement(
        'div',
        { className: classes },
        children
      );
    }
  }]);

  return OverlayTileColumn;
}(_react.Component), _class.propTypes = {
  align: _propTypes2.default.oneOf(['left', 'right']),
  children: _propTypes2.default.node
}, _class.defaultProps = {
  align: 'left'
}, _temp);
exports.default = OverlayTileColumn;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayTileOptionLink = (_temp = _class = function (_PureComponent) {
  _inherits(OverlayTileOptionLink, _PureComponent);

  function OverlayTileOptionLink() {
    _classCallCheck(this, OverlayTileOptionLink);

    return _possibleConstructorReturn(this, (OverlayTileOptionLink.__proto__ || Object.getPrototypeOf(OverlayTileOptionLink)).apply(this, arguments));
  }

  _createClass(OverlayTileOptionLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          icon = _props.icon,
          title = _props.title,
          rest = _objectWithoutProperties(_props, ['className', 'disabled', 'icon', 'title']);

      var classes = (0, _classnames2.default)('option-links', { disabled: disabled });

      return _react2.default.createElement(
        'a',
        Object.assign({ className: classes }, rest),
        _react2.default.createElement(_Icon2.default, { name: icon }),
        I18n.t(title)
      );
    }
  }]);

  return OverlayTileOptionLink;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  icon: _propTypes2.default.string,
  title: _propTypes2.default.string
}, _temp);
exports.default = OverlayTileOptionLink;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _jquery = __webpack_require__(671);

var _jquery2 = _interopRequireDefault(_jquery);

var _reactDom = __webpack_require__(46);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShareLinkPopover = (_temp = _class = function (_PureComponent) {
  _inherits(ShareLinkPopover, _PureComponent);

  function ShareLinkPopover() {
    _classCallCheck(this, ShareLinkPopover);

    return _possibleConstructorReturn(this, (ShareLinkPopover.__proto__ || Object.getPrototypeOf(ShareLinkPopover)).apply(this, arguments));
  }

  _createClass(ShareLinkPopover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Qualvu.InitializeVtipClick((0, _jquery2.default)((0, _reactDom.findDOMNode)(this)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          tip = _props.tip;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'vtip_click', 'data-vtip': tip },
          children
        )
      );
    }
  }]);

  return ShareLinkPopover;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes2.default.node,
  tip: _propTypes2.default.string
}, _temp);
exports.default = ShareLinkPopover;

/***/ }),
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Button = __webpack_require__(81);

var _Button2 = _interopRequireDefault(_Button);

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _FileInput = __webpack_require__(983);

var _FileInput2 = _interopRequireDefault(_FileInput);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FileUploadButton = (_temp = _class = function (_PureComponent) {
  _inherits(FileUploadButton, _PureComponent);

  function FileUploadButton() {
    _classCallCheck(this, FileUploadButton);

    return _possibleConstructorReturn(this, (FileUploadButton.__proto__ || Object.getPrototypeOf(FileUploadButton)).apply(this, arguments));
  }

  _createClass(FileUploadButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          fileProps = _objectWithoutProperties(_props, ['label']);

      return _react2.default.createElement(
        _Button2.default,
        {
          role: 'create',
          className: 'qv-button-upload',
          preventDefault: false,
          disabled: this.props.disabled
        },
        _react2.default.createElement(_Icon2.default, { name: 'upload' }),
        _react2.default.createElement(
          'span',
          null,
          ' ' + I18n.t(label)
        ),
        _react2.default.createElement(_FileInput2.default, fileProps)
      );
    }
  }]);

  return FileUploadButton;
}(_react.PureComponent), _class.propTypes = {
  disabled: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  url: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  disabled: false,
  label: 'Upload'
}, _temp);
exports.default = FileUploadButton;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(45);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(95);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(31),
    isArray = __webpack_require__(17),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(896),
    keys = __webpack_require__(100);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(257);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findEnglishVideo;

var _underscore = __webpack_require__(164);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findEnglishVideo() {
  var videos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var englishVideos = videos.filter(function (video) {
    return _underscore2.default.str.startsWith(video.languageCode, 'en');
  });

  return englishVideos[0];
}

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(899),
    getMatchData = __webpack_require__(900),
    matchesStrictComparable = __webpack_require__(715);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(121),
    baseIsEqual = __webpack_require__(222);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(714),
    keys = __webpack_require__(100);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(222),
    get = __webpack_require__(716),
    hasIn = __webpack_require__(902),
    isKey = __webpack_require__(632),
    isStrictComparable = __webpack_require__(714),
    matchesStrictComparable = __webpack_require__(715),
    toKey = __webpack_require__(263);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(903),
    hasPath = __webpack_require__(859);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 903 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(833),
    basePropertyDeep = __webpack_require__(905),
    isKey = __webpack_require__(632),
    toKey = __webpack_require__(263);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(627);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(696),
    isArrayLike = __webpack_require__(45);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _OverlayTile = __webpack_require__(682);

var _OverlayTile2 = _interopRequireDefault(_OverlayTile);

var _OverlayTileHeading = __webpack_require__(683);

var _OverlayTileHeading2 = _interopRequireDefault(_OverlayTileHeading);

var _OverlayWorkspaceList = __webpack_require__(1217);

var _OverlayWorkspaceList2 = _interopRequireDefault(_OverlayWorkspaceList);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayWorkspaceTile = (_temp = _class = function (_Component) {
  _inherits(OverlayWorkspaceTile, _Component);

  function OverlayWorkspaceTile() {
    _classCallCheck(this, OverlayWorkspaceTile);

    return _possibleConstructorReturn(this, (OverlayWorkspaceTile.__proto__ || Object.getPrototypeOf(OverlayWorkspaceTile)).apply(this, arguments));
  }

  _createClass(OverlayWorkspaceTile, [{
    key: 'render',
    value: function render() {
      var workspaces = this.props.workspaces;


      return _react2.default.createElement(
        _OverlayTile2.default,
        { count: workspaces.length },
        _react2.default.createElement(_OverlayTileHeading2.default, { icon: 'folder-open', title: 'Workspaces' }),
        _react2.default.createElement(_OverlayWorkspaceList2.default, { workspaces: workspaces })
      );
    }
  }]);

  return OverlayWorkspaceTile;
}(_react.Component), _class.propTypes = {
  workspaces: _propTypes2.default.array.isRequired
}, _temp);
exports.default = OverlayWorkspaceTile;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = __webpack_require__(406);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabItem = (_temp = _class = function (_Component) {
  _inherits(TabItem, _Component);

  function TabItem() {
    _classCallCheck(this, TabItem);

    return _possibleConstructorReturn(this, (TabItem.__proto__ || Object.getPrototypeOf(TabItem)).apply(this, arguments));
  }

  _createClass(TabItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isSelected = _props.isSelected,
          href = _props.href,
          onSelect = _props.onSelect,
          title = _props.title;

      var classes = (0, _classnames2.default)('qv-tab', {
        'qv-tab-is-selected': isSelected
      });

      if (href) {
        return _react2.default.createElement(
          _reactRouter.Link,
          { to: href, className: classes },
          I18n.t(title)
        );
      }

      return _react2.default.createElement(
        'div',
        { className: classes, onClick: onSelect },
        I18n.t(title)
      );
    }
  }]);

  return TabItem;
}(_react.Component), _class.propTypes = {
  href: _propTypes2.default.string,
  isSelected: _propTypes2.default.bool.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  isSelected: false
}, _temp);
exports.default = TabItem;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _DropdownMenu = __webpack_require__(910);

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _DropdownMenuTrigger = __webpack_require__(911);

var _DropdownMenuTrigger2 = _interopRequireDefault(_DropdownMenuTrigger);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownActions = (_temp = _class = function (_PureComponent) {
  _inherits(DropdownActions, _PureComponent);

  function DropdownActions() {
    _classCallCheck(this, DropdownActions);

    return _possibleConstructorReturn(this, (DropdownActions.__proto__ || Object.getPrototypeOf(DropdownActions)).apply(this, arguments));
  }

  _createClass(DropdownActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          direction = _props.direction;


      return _react2.default.createElement(
        'div',
        { className: 'btn-group' },
        _react2.default.createElement(_DropdownMenuTrigger2.default, { text: 'Actions' }),
        _react2.default.createElement(
          _DropdownMenu2.default,
          { direction: direction },
          children
        )
      );
    }
  }]);

  return DropdownActions;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes2.default.node.isRequired,
  direction: _propTypes2.default.oneOf(['left', 'right'])
}, _class.defaultProps = {
  direction: 'left'
}, _temp);
exports.default = DropdownActions;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenu = (_temp = _class = function (_Component) {
  _inherits(DropdownMenu, _Component);

  function DropdownMenu() {
    _classCallCheck(this, DropdownMenu);

    return _possibleConstructorReturn(this, (DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).apply(this, arguments));
  }

  _createClass(DropdownMenu, [{
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)('dropdown-menu', {
        'pull-right': this.props.direction === 'left'
      });

      return _react2.default.createElement(
        'ul',
        { className: classes },
        this.props.children
      );
    }
  }]);

  return DropdownMenu;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  direction: _propTypes2.default.oneOf(['left', 'right'])
}, _class.defaultProps = {
  direction: 'right'
}, _temp);
exports.default = DropdownMenu;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Button = __webpack_require__(81);

var _Button2 = _interopRequireDefault(_Button);

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenuTrigger = (_temp = _class = function (_PureComponent) {
  _inherits(DropdownMenuTrigger, _PureComponent);

  function DropdownMenuTrigger() {
    _classCallCheck(this, DropdownMenuTrigger);

    return _possibleConstructorReturn(this, (DropdownMenuTrigger.__proto__ || Object.getPrototypeOf(DropdownMenuTrigger)).apply(this, arguments));
  }

  _createClass(DropdownMenuTrigger, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Button2.default,
        { size: 'small', className: 'dropdown-toggle', 'data-toggle': 'dropdown' },
        _react2.default.createElement(
          'span',
          null,
          this.props.text + ' '
        ),
        _react2.default.createElement(_Icon2.default, { name: 'chevron-down' })
      );
    }
  }]);

  return DropdownMenuTrigger;
}(_react.PureComponent), _class.propTypes = {
  text: _propTypes2.default.string.isRequired
}, _temp);
exports.default = DropdownMenuTrigger;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _noop = __webpack_require__(88);

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenuItem = (_temp = _class = function (_PureComponent) {
  _inherits(DropdownMenuItem, _PureComponent);

  function DropdownMenuItem() {
    _classCallCheck(this, DropdownMenuItem);

    return _possibleConstructorReturn(this, (DropdownMenuItem.__proto__ || Object.getPrototypeOf(DropdownMenuItem)).apply(this, arguments));
  }

  _createClass(DropdownMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          attrs = _objectWithoutProperties(_props, ['text']);

      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          attrs,
          text
        )
      );
    }
  }]);

  return DropdownMenuItem;
}(_react.PureComponent), _class.propTypes = {
  href: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  text: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  onClick: _noop2.default
}, _temp);
exports.default = DropdownMenuItem;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TranscriptWord = __webpack_require__(1243);

var _TranscriptWord2 = _interopRequireDefault(_TranscriptWord);

var _escapeRegexString = __webpack_require__(986);

var _escapeRegexString2 = _interopRequireDefault(_escapeRegexString);

var _shallowEqual = __webpack_require__(620);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TranscriptView = (_temp = _class = function (_Component) {
  _inherits(TranscriptView, _Component);

  function TranscriptView() {
    _classCallCheck(this, TranscriptView);

    return _possibleConstructorReturn(this, (TranscriptView.__proto__ || Object.getPrototypeOf(TranscriptView)).apply(this, arguments));
  }

  _createClass(TranscriptView, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'matchOptions',
    value: function matchOptions() {
      return this.props.caseSensitive ? 'g' : 'gi';
    }
  }, {
    key: 'normalizeTokens',
    value: function normalizeTokens() {
      var _this2 = this;

      var tokens = this.props.tokens;


      if (!tokens) {
        return [];
      }

      return tokens && tokens.reduce(function (prev, value) {
        return {
          snippet: value.snippet,
          tokens: prev.tokens.concat(_this2.splitTokens(value.tokens)),
          fieldName: value.fieldName
        };
      }, { tokens: [] });
    }
  }, {
    key: 'splitTokens',
    value: function splitTokens(tokens) {
      var _this3 = this;

      return tokens.reduce(function (prev, token) {
        return prev.concat(_this3.formattedToken(token));
      }, []);
    }
  }, {
    key: 'tokenMatches',
    value: function tokenMatches(token, word) {
      var regex = new RegExp('(\\b' + (0, _escapeRegexString2.default)(token || '') + '\\b)', this.matchOptions());
      return regex.test(word);
    }
  }, {
    key: 'highlightIndexes',
    value: function highlightIndexes() {
      var _normalizeTokens = this.normalizeTokens(),
          tokens = _normalizeTokens.tokens,
          snippet = _normalizeTokens.snippet,
          fieldName = _normalizeTokens.fieldName;

      if (!tokens || !snippet) {
        return {};
      }
      var snippetWords = snippet.split(' ');
      var selectionOffset = this.selectionOffset(fieldName);

      return tokens.reduce(function (memo, _ref) {
        var token = _ref.token,
            type = _ref.type;

        for (var i = 0; i < snippetWords.length; i++) {
          // if type === 'inner', we don't want to match other cases that don't
          // border brackets, so we make sure that the previous instance is an
          // inner or outer token
          var shouldHighlight = snippetWords[i] === token && (!['inner', 'end'].includes(type) || ['inner', 'start'].includes(memo[i + selectionOffset - 1]));

          if (shouldHighlight) {
            memo[i + selectionOffset] = type || 'default';
          }
        }

        return memo;
      }, {});
    }
  }, {
    key: 'selectionOffset',
    value: function selectionOffset(type) {
      return type === 'text_selection' ? this.firstSelectedIndex() : 0;
    }
  }, {
    key: 'firstSelectedIndex',
    value: function firstSelectedIndex() {
      var _props = this.props,
          selectionStartTime = _props.selectionStartTime,
          timestamps = _props.timestamps;


      return timestamps.findIndex(function (timestamp) {
        return selectionStartTime <= timestamp;
      });
    }
  }, {
    key: 'formattedToken',
    value: function formattedToken(token) {
      var _this4 = this;

      var tokens = token.split(' ');
      return tokens.map(function (_, i) {
        return _this4.formatTokenByIndex(tokens, i);
      });
    }
  }, {
    key: 'formatTokenByIndex',
    value: function formatTokenByIndex(tokens, index) {
      if (tokens.length === 1) {
        return { token: '[[' + tokens[index] + ']]' };
      }

      if (index === tokens.length - 1) {
        return { token: tokens[index] + ']]', type: 'end' };
      }

      if (index === 0) {
        return { token: '[[' + tokens[index], type: 'start' };
      }

      return { token: tokens[index], type: 'inner' };
    }
  }, {
    key: 'isSelected',
    value: function isSelected(timestamp) {
      var _props2 = this.props,
          selectionStartTime = _props2.selectionStartTime,
          selectionEndTime = _props2.selectionEndTime;


      return selectionStartTime <= timestamp && timestamp <= selectionEndTime;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props3 = this.props,
          componentClassName = _props3.componentClassName,
          selectionClassName = _props3.selectionClassName,
          text = _props3.text,
          timestamps = _props3.timestamps,
          onMouseUp = _props3.onMouseUp,
          onMouseDown = _props3.onMouseDown;

      var words = text.split(' ');
      var highlightIndexes = this.highlightIndexes();

      return _react2.default.createElement(
        'div',
        {
          className: componentClassName,
          onMouseUp: onMouseUp,
          onMouseDown: onMouseDown
        },
        words.map(function (word, index) {
          return _react2.default.createElement(_TranscriptWord2.default, {
            word: word,
            key: index,
            timestamp: timestamps[index],
            isSelected: _this5.isSelected(timestamps[index]),
            selectionClassName: selectionClassName,
            highlighted: !!highlightIndexes[index],
            highlightSpace: ['inner', 'end'].includes(highlightIndexes[index])
          });
        })
      );
    }
  }]);

  return TranscriptView;
}(_react.Component), _class.propTypes = {
  caseSensitive: _propTypes2.default.bool,
  componentClassName: _propTypes2.default.string,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  selectionClassName: _propTypes2.default.string,
  selectionEndTime: _propTypes2.default.number,
  selectionStartTime: _propTypes2.default.number,
  text: _propTypes2.default.string,
  timestamps: _propTypes2.default.array,
  tokens: _propTypes2.default.array
}, _class.defaultProps = {
  componentClassName: 'transcript-viewer',
  selectionClassName: 'qv-quote-selection',
  timestamps: []
}, _temp);
exports.default = TranscriptView;

/***/ }),
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(981),
    hasUnicode = __webpack_require__(821),
    unicodeToArray = __webpack_require__(982);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _KeywordHighlight = __webpack_require__(362);

var _KeywordHighlight2 = _interopRequireDefault(_KeywordHighlight);

var _SearchTokenize = __webpack_require__(712);

var _SearchTokenize2 = _interopRequireDefault(_SearchTokenize);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RichText = (0, _SearchTokenize2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(RichText, _Component);

  function RichText() {
    _classCallCheck(this, RichText);

    return _possibleConstructorReturn(this, (RichText.__proto__ || Object.getPrototypeOf(RichText)).apply(this, arguments));
  }

  _createClass(RichText, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          tokens = _props.tokens;


      return _react2.default.createElement(
        'div',
        { className: 'rich-text-container' },
        _react2.default.createElement(_KeywordHighlight2.default, { text: text, tokens: tokens })
      );
    }
  }]);

  return RichText;
}(_react.Component), _class2.propTypes = {
  text: _propTypes2.default.string,
  tokens: _propTypes2.default.array
}, _temp)) || _class;

exports.default = RichText;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FULL_NAME = exports.FIRST_LAST_INITIAL = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIRST_LAST_INITIAL = exports.FIRST_LAST_INITIAL = 'FIRST_LAST_INITIAL';
var FULL_NAME = exports.FULL_NAME = 'FULL_NAME';

var User = (_temp = _class = function (_PureComponent) {
  _inherits(User, _PureComponent);

  function User() {
    _classCallCheck(this, User);

    return _possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
  }

  _createClass(User, [{
    key: 'formatName',
    value: function formatName() {
      var _props = this.props,
          format = _props.format,
          user = _props.user;

      var firstName = user.firstName || '';
      var lastName = user.lastName || '';

      switch (format) {
        case FIRST_LAST_INITIAL:
          return firstName + ' ' + lastName.slice(0, 1) + '.';
        case FULL_NAME:
          return firstName + ' ' + lastName;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        this.formatName()
      );
    }
  }]);

  return User;
}(_react.PureComponent), _class.propTypes = {
  format: _propTypes2.default.oneOf([FIRST_LAST_INITIAL, FULL_NAME]),
  user: _propTypes2.default.object
}, _class.defaultProps = {
  user: {},
  format: FULL_NAME
}, _temp);
exports.default = User;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stylist = __webpack_require__(8);

var _styled = __webpack_require__(5);

var _styled2 = _interopRequireDefault(_styled);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _appConstants = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlexContainer = /*#__PURE__*/(0, _styled2.default)('div', {
  target: 'ef29buh0'
})('display:flex;justify-content:space-between;align-items:center;');

var ProTooltip = (_temp2 = _class = function (_Component) {
  _inherits(ProTooltip, _Component);

  function ProTooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProTooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProTooltip.__proto__ || Object.getPrototypeOf(ProTooltip)).call.apply(_ref, [this].concat(args))), _this), _this.handleHelpRedirect = function () {
      window.location.href = _appConstants.TooltipLink[_this.props.tooltipType];
    }, _this.handleUpgradeRedirect = function () {
      window.location.href = _appConstants.UpgradeLink;
    }, _this.upgradeButton = function () {
      if (_this.props.displayUpgradeButton) {
        return _react2.default.createElement(
          _stylist.Button,
          {
            kind: 'standard',
            dark: true,
            size: 'sm',
            onMouseDown: _this.handleUpgradeRedirect
          },
          I18n.t('Upgrade Now')
        );
      }
    }, _this.renderInternalComponent = function () {
      var _this$props$renderTri = _this.props.renderTrigger,
          InternalComponent = _this$props$renderTri.InternalComponent,
          rest = _objectWithoutProperties(_this$props$renderTri, ['InternalComponent']);

      return _react2.default.createElement(InternalComponent, rest);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProTooltip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          wide = _props.wide,
          transparency = _props.transparency,
          color = _props.color,
          title = _props.title,
          position = _props.position,
          showOnHover = _props.showOnHover,
          tooltipType = _props.tooltipType,
          portal = _props.portal,
          className = _props.className;


      var label = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          ' ',
          _appConstants.TooltipText[tooltipType],
          ' '
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          FlexContainer,
          null,
          _react2.default.createElement(
            'a',
            {
              style: { color: 'white', textDecoration: 'underline' },
              onMouseDown: this.handleHelpRedirect
            },
            I18n.t('Learn more about this feature.')
          ),
          this.upgradeButton()
        )
      );

      return _react2.default.createElement(_stylist.Tooltip, {
        portal: portal,
        position: position,
        wide: wide,
        transparency: transparency,
        color: color,
        label: label,
        title: title,
        containerOpenOnHover: showOnHover,
        render: function render(_ref2) {
          var hide = _ref2.hide,
              show = _ref2.show,
              ref = _ref2.ref;
          return _react2.default.createElement(
            'div',
            {
              tabIndex: '0',
              ref: ref,
              onClick: show,
              onBlur: hide,
              className: className
            },
            _this2.renderInternalComponent()
          );
        }
      });
    }
  }]);

  return ProTooltip;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  color: _propTypes2.default.string,
  displayUpgradeButton: _propTypes2.default.bool,
  portal: _propTypes2.default.bool,
  position: _propTypes2.default.string,
  renderTrigger: _propTypes2.default.object,
  showOnHover: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  tooltipType: _propTypes2.default.string,
  transparency: _propTypes2.default.number,
  wide: _propTypes2.default.bool,
  wrapperClassName: _propTypes2.default.string
}, _class.defaultProps = {
  wide: true,
  transparency: 1.0,
  color: 'darkOcean',
  title: 'Free Account',
  position: 'bottom-left',
  labelText: 'DEFAULT',
  displayUpgradeButton: true,
  showOnHover: false,
  portal: true
}, _temp2);
exports.default = ProTooltip;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stylist = __webpack_require__(8);

var _color = __webpack_require__(1143);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (theme) {
  if (!theme) {
    return _stylist.theme;
  }
  var normalizedTheme = Object.assign({}, _stylist.theme);

  normalizedTheme.fvStyle.brand.lightBrandGreen = theme.primaryColor;
  normalizedTheme.fvStyle.brand.lighterBrandGreen = (0, _color2.default)(theme.primaryColor).darken(0.2).string();
  normalizedTheme.fvStyle.brand.slate = theme.secondaryColor || normalizedTheme.fvStyle.brand.black;
  normalizedTheme.fvStyle.brand = Object.assign({}, normalizedTheme.fvStyle.brand, theme);

  return normalizedTheme;
};

/***/ }),
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = selectableTable;

var _TableColumn = __webpack_require__(229);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _getDisplayName = __webpack_require__(688);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _shallowEqual = __webpack_require__(620);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function selectableTable(dataGetter, onSelect, _ref) {
  var trackBy = _ref.trackBy,
      initialize = _ref.initialize;

  var tableInstance = void 0;

  if (Object({"NODE_ENV":"production","DAYS_UNTIL_PROJECTS_EXPIRE":90}) !== 'production') {
    if (initialize && !trackBy) {
      throw new Error('You must provide the trackBy option when using initialize');
    }
  }

  function toggleRow(collection, rowData, index, selected, props) {
    var key = rowData[trackBy] || index;

    onSelect(rowData, selected, props, index, tableInstance);

    return Object.assign({}, collection, _defineProperty({}, key, selected));
  }

  function toggleAll(data, selected, props) {
    return data.reduce(function (memo, rowData, index) {
      return toggleRow(memo, rowData, index, selected, props);
    }, {});
  }

  return function decorateComponent(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      _inherits(SelectableTable, _React$Component);

      function SelectableTable(props) {
        _classCallCheck(this, SelectableTable);

        var _this = _possibleConstructorReturn(this, (SelectableTable.__proto__ || Object.getPrototypeOf(SelectableTable)).call(this, props));

        _this.handleSelect = _this.handleSelect.bind(_this);
        _this.handleSelectAll = _this.handleSelectAll.bind(_this);
        _this.renderSelect = _this.renderSelect.bind(_this);
        _this.renderSelectHeader = _this.renderSelectHeader.bind(_this);
        _this.renderSelectableTable = _this.renderSelectableTable.bind(_this);

        var selectedRows = {};
        if (initialize) {
          var selectedIds = initialize(props);
          var items = dataGetter(props);

          selectedIds.forEach(function (id) {
            selectedRows[id] = items.find(function (item) {
              return item.id === id;
            });
          });
        }

        _this.state = {
          allSelected: false,
          selectedRows: selectedRows
        };
        return _this;
      }

      _createClass(SelectableTable, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
        }
      }, {
        key: 'getSelectableColumn',
        value: function getSelectableColumn() {
          return _react2.default.createElement(_TableColumn2.default, {
            cellRenderer: this.renderSelect,
            key: 'selectableColumn',
            dataKey: 'selectableTableExpanded',
            headerRenderer: this.renderSelectHeader,
            label: '',
            width: 10
          });
        }
      }, {
        key: 'handleSelect',
        value: function handleSelect(e, rowData, index) {
          var selectedRows = this.state.selectedRows;


          this.setState({
            selectedRows: toggleRow(selectedRows, rowData, index, e.target.checked, this.props)
          });
        }
      }, {
        key: 'handleSelectAll',
        value: function handleSelectAll(e) {
          this.setState({
            allSelected: e.target.checked,
            selectedRows: toggleAll(
            // TODO: Get rid of dataGetter and read from Table props instead
            dataGetter(this.props), e.target.checked, this.props)
          });
        }
      }, {
        key: 'renderSelect',
        value: function renderSelect(selected, rowData, dataKey, index) {
          var _this2 = this;

          return _react2.default.createElement('input', {
            type: 'checkbox',
            checked: this.rowIsSelected(rowData, index),
            onChange: function onChange(e) {
              return _this2.handleSelect(e, rowData, index);
            }
          });
        }
      }, {
        key: 'renderSelectHeader',
        value: function renderSelectHeader() {
          var allSelected = this.state.allSelected;


          return _react2.default.createElement('input', {
            type: 'checkbox',
            checked: allSelected,
            onChange: this.handleSelectAll
          });
        }
      }, {
        key: 'renderSelectableTable',
        value: function renderSelectableTable(Table) {
          return (0, _react.cloneElement)(Table, {}, [this.getSelectableColumn()].concat(_toConsumableArray(_react.Children.toArray(Table.props.children))));
        }
      }, {
        key: 'rowIsSelected',
        value: function rowIsSelected(rowData, index) {
          var key = rowData[trackBy] || index;
          return this.state.selectedRows[key];
        }
      }, {
        key: 'render',
        value: function render() {
          var selectedRows = this.state.selectedRows;

          return _react2.default.createElement(Component, Object.assign({
            ref: function ref(table) {
              return tableInstance = table;
            },
            connectSelectableColumn: this.renderSelectableTable,
            selectedRows: selectedRows
          }, this.props));
        }
      }]);

      return SelectableTable;
    }(_react2.default.Component), _class.displayName = 'SelectableTable(' + (0, _getDisplayName2.default)(Component) + ')', _temp;
  };
}

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollOnTimeUpdateWithFeatures = exports.scrollOnTimeUpdate = undefined;

var _squintjs = __webpack_require__(1246);

var lastScrolled = void 0;

var scrollOnTimeUpdate = exports.scrollOnTimeUpdate = function scrollOnTimeUpdate() {
  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var timestamps = arguments[1];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref = event.target || {},
      currentTime = _ref.currentTime;

  if (typeof currentTime !== 'number') {
    return;
  }

  var _options$scrollDurati = options.scrollDuration,
      scrollDuration = _options$scrollDurati === undefined ? 300 : _options$scrollDurati,
      _options$offset = options.offset,
      offset = _options$offset === undefined ? '25%' : _options$offset,
      scope = options.scope;

  var now = Date.now();

  if (lastScrolled && now - lastScrolled < scrollDuration) {
    return;
  }

  var currentTimestamp = findCurrentTimestamp(timestamps || [], currentTime);
  var element = (scope || document).querySelector('[data="' + currentTimestamp + '"]');
  lastScrolled = now;

  if (!element) {
    return;
  }

  var parent = findScrollingParent(element);

  if (!parent) {
    return;
  }

  (0, _squintjs.scrollIntoView)(element, parent, {
    duration: scrollDuration,
    offset: offset
  });

  if (options.highlight) {
    highlightCurrent(element, parent);
  }

  return true;
};

var highlightCurrent = function highlightCurrent(element, parent) {
  var highlightElement = parent.querySelector('#scroll-into-view-current-indicator');

  var elementY = element.getBoundingClientRect().y;
  var parentY = parent.getBoundingClientRect().top;
  var offset = elementY - parentY + parent.scrollTop;

  if (highlightElement) {
    highlightElement.setAttribute('style', 'top: ' + offset + 'px; height: ' + element.offsetHeight + 'px');
  } else {
    var newElement = document.createElement('div');
    newElement.id = 'scroll-into-view-current-indicator';
    newElement.classList.add('scroll-into-view-current-indicator');
    newElement.setAttribute('style', 'top: ' + offset + 'px; height: ' + element.offsetHeight + 'px');
    parent.appendChild(newElement);
  }
};

var findCurrentTimestamp = function findCurrentTimestamp(timestamps, currentTime) {
  return timestamps.find(function (time, index, array) {
    var nextTime = array[index + 1];
    return !nextTime || nextTime > currentTime;
  });
};

var findScrollingParent = function findScrollingParent(element) {
  var parent = element.parentElement;
  if (!parent) {
    return;
  }

  var overflowY = window.getComputedStyle(parent)['overflow-y'];
  var isScrollable = overflowY === 'scroll' || overflowY === 'auto';

  if (isScrollable && parent.scrollHeight >= parent.clientHeight) {
    return parent;
  }

  return findScrollingParent(parent);
};

var scrollOnTimeUpdateWithFeatures = exports.scrollOnTimeUpdateWithFeatures = function scrollOnTimeUpdateWithFeatures() {
  var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var timestamps = arguments[1];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return scrollOnTimeUpdate(event, timestamps, Object.assign({
    highlight: Tru.Stores.reduxStore.getState().features.includes('transcript_highlighting')
  }, options));
};

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MarkDetails = __webpack_require__(1248);

var _MarkDetails2 = _interopRequireDefault(_MarkDetails);

var _MarkForm = __webpack_require__(1249);

var _MarkForm2 = _interopRequireDefault(_MarkForm);

var _i18n = __webpack_require__(90);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarkRow = (_temp2 = _class = function (_Component) {
  _inherits(MarkRow, _Component);

  function MarkRow() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarkRow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarkRow.__proto__ || Object.getPrototypeOf(MarkRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      editing: false
    }, _this.handleEditClick = function () {
      _this.setState({ editing: true });
    }, _this.handleCancel = function () {
      _this.setState({ editing: false });
      var onCancel = _this.props.onCancel;

      if (onCancel) {
        onCancel();
      }
    }, _this.handleSave = function (mark) {
      _this.props.onSave(mark).then(function () {
        return _this.setState({ editing: false });
      }).catch(function () {
        /* do nothing */
      });
    }, _this.handleDelete = function (mark) {
      var message = _i18n2.default.t('Are you sure you wish to delete this mark?');
      if (window.confirm(message)) {
        _this.props.onDelete(mark);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarkRow, [{
    key: 'render',
    value: function render() {
      var editing = this.state.editing;
      var _props = this.props,
          mark = _props.mark,
          handleClick = _props.handleClick,
          videoLength = _props.videoLength;

      if (editing || !mark.id) {
        return _react2.default.createElement(_MarkForm2.default, {
          key: mark.id || 'new-mark',
          mark: mark,
          onCancelClick: this.handleCancel,
          onSave: this.handleSave,
          videoLength: videoLength
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_MarkDetails2.default, {
          key: mark.id,
          mark: mark,
          handleClick: handleClick,
          onEditClick: this.handleEditClick,
          onDelete: this.handleDelete
        })
      );
    }
  }]);

  return MarkRow;
}(_react.Component), _class.propTypes = {
  onCancel: _propTypes2.default.func,
  handleClick: _propTypes2.default.func.isRequired,
  mark: _propTypes2.default.object,
  onDelete: _propTypes2.default.func,
  onSave: _propTypes2.default.func.isRequired,
  videoLength: _propTypes2.default.number.isRequired
}, _class.defaultProps = {
  mark: {}
}, _temp2);
exports.default = MarkRow;

/***/ }),
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(832);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 981 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _noop = __webpack_require__(88);

var _noop2 = _interopRequireDefault(_noop);

var _shallowEqual = __webpack_require__(620);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _jquery = __webpack_require__(671);

var _jquery2 = _interopRequireDefault(_jquery);

var _forEach = __webpack_require__(857);

var _forEach2 = _interopRequireDefault(_forEach);

var _includes = __webpack_require__(984);

var _includes2 = _interopRequireDefault(_includes);

var _reactDom = __webpack_require__(46);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FILE_UPLOAD_OPTIONS = ['dataType', 'type', 'url'];
var FILE_UPLOAD_CALLBACKS = ['always', 'onAdd', 'onDone', 'onFail', 'onSubmit'];

var FileInput = (_temp = _class = function (_PureComponent) {
  _inherits(FileInput, _PureComponent);

  function FileInput() {
    _classCallCheck(this, FileInput);

    return _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).apply(this, arguments));
  }

  _createClass(FileInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var $el = (0, _jquery2.default)((0, _reactDom.findDOMNode)(this));
      $el.fileupload({
        url: this.props.url,
        type: this.props.type,
        dataType: this.props.dataType,
        replaceFileInput: false
      });

      $el.on('fileuploadadd', this.props.onAdd).on('fileuploadchange', this.props.onChange).on('fileuploaddone', this.props.onDone).on('fileuploadfail', this.props.onFail).on('fileuploadsubmit', this.props.onSubmit).on('fileuploadalways', this.props.always);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if ((0, _shallowEqual2.default)(this.props, nextProps)) {
        return;
      }

      var $el = (0, _jquery2.default)((0, _reactDom.findDOMNode)(this));

      (0, _forEach2.default)(nextProps, function (value, key) {
        if (_this2.isFileUploadOption(key)) {
          $el.fileupload('option', key, value);
        } else if (_this2.isFileUploadCallback(key)) {
          $el.off(key, _this2.props[key]);
          $el.on(key, value);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      (0, _jquery2.default)((0, _reactDom.findDOMNode)(this)).fileupload('destroy');
    }
  }, {
    key: 'isFileUploadOption',
    value: function isFileUploadOption(prop) {
      return (0, _includes2.default)(FILE_UPLOAD_OPTIONS, prop);
    }
  }, {
    key: 'isFileUploadCallback',
    value: function isFileUploadCallback(prop) {
      return (0, _includes2.default)(FILE_UPLOAD_CALLBACKS, prop);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          accept = _props.accept,
          name = _props.name,
          disabled = _props.disabled;


      return _react2.default.createElement('input', { type: 'file', accept: accept, name: name, disabled: disabled });
    }
  }]);

  return FileInput;
}(_react.PureComponent), _class.propTypes = {
  accept: _propTypes2.default.string,
  always: _propTypes2.default.func,
  dataType: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  onAdd: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onDone: _propTypes2.default.func,
  onFail: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  type: _propTypes2.default.oneOf(['POST', 'PUT', 'PATCH']),
  url: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  type: 'POST',
  dataType: 'json',
  onAdd: _noop2.default,
  onChange: _noop2.default,
  onDone: _noop2.default,
  onFail: _noop2.default,
  onSubmit: _noop2.default,
  always: _noop2.default
}, _temp);
exports.default = FileInput;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(246),
    isArrayLike = __webpack_require__(45),
    isString = __webpack_require__(894),
    toInteger = __webpack_require__(822),
    values = __webpack_require__(895);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(218),
    eq = __webpack_require__(42),
    isIterateeCall = __webpack_require__(224),
    keysIn = __webpack_require__(97);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = escapeRegexString;
function escapeRegexString(string) {
  return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _map = __webpack_require__(1212);

var _map2 = _interopRequireDefault(_map);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DescriptionList = (_temp = _class = function (_Component) {
  _inherits(DescriptionList, _Component);

  function DescriptionList() {
    _classCallCheck(this, DescriptionList);

    return _possibleConstructorReturn(this, (DescriptionList.__proto__ || Object.getPrototypeOf(DescriptionList)).apply(this, arguments));
  }

  _createClass(DescriptionList, [{
    key: 'renderItem',
    value: function renderItem(value, key) {
      if (Array.isArray(value)) {
        value = value.join(', ');
      }

      return _react2.default.createElement(
        'div',
        { key: key },
        _react2.default.createElement(
          'span',
          { 'data-qv-description-list': 'key' },
          I18n.t(key) + ':'
        ),
        _react2.default.createElement(
          'span',
          null,
          value
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          listItems = _props.listItems,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['listItems', 'className']);

      return _react2.default.createElement(
        'div',
        Object.assign({ className: 'description-list' }, rest),
        (0, _map2.default)(listItems, this.renderItem)
      );
    }
  }]);

  return DescriptionList;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  listItems: _propTypes2.default.object
}, _class.defaultProps = {
  listItems: {}
}, _temp);
exports.default = DescriptionList;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(257),
    baseGet = __webpack_require__(627),
    baseIteratee = __webpack_require__(672),
    baseMap = __webpack_require__(906),
    baseSortBy = __webpack_require__(989),
    baseUnary = __webpack_require__(130),
    compareMultiple = __webpack_require__(990),
    identity = __webpack_require__(95),
    isArray = __webpack_require__(17);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 989 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(991);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(219);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _KeywordHighlight = __webpack_require__(362);

var _KeywordHighlight2 = _interopRequireDefault(_KeywordHighlight);

var _TabList = __webpack_require__(684);

var _TabList2 = _interopRequireDefault(_TabList);

var _TabPanel = __webpack_require__(674);

var _TabPanel2 = _interopRequireDefault(_TabPanel);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayImageTabs = (_temp = _class = function (_PureComponent) {
  _inherits(OverlayImageTabs, _PureComponent);

  function OverlayImageTabs() {
    _classCallCheck(this, OverlayImageTabs);

    return _possibleConstructorReturn(this, (OverlayImageTabs.__proto__ || Object.getPrototypeOf(OverlayImageTabs)).apply(this, arguments));
  }

  _createClass(OverlayImageTabs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          description = _props.description,
          searchHighlights = _props.searchHighlights;

      var tokens = searchHighlights.reduce(function (memo, highlight) {
        return memo.concat(highlight.tokens);
      }, []);

      return _react2.default.createElement(
        _TabList2.default,
        null,
        _react2.default.createElement(
          _TabPanel2.default,
          { title: 'Description' },
          _react2.default.createElement(
            'div',
            { className: 'transcript-viewer' },
            _react2.default.createElement(
              _KeywordHighlight2.default,
              { text: description, tokens: tokens },
              _react2.default.createElement(
                'span',
                { className: 'grey-reg-i' },
                I18n.t('No description provided')
              )
            )
          )
        )
      );
    }
  }]);

  return OverlayImageTabs;
}(_react.PureComponent), _class.propTypes = {
  description: _propTypes2.default.string,
  searchHighlights: _propTypes2.default.array
}, _class.defaultProps = {
  searchHighlights: []
}, _temp);
exports.default = OverlayImageTabs;

/***/ }),
/* 993 */,
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RowExpander = (_temp = _class = function (_Component) {
  _inherits(RowExpander, _Component);

  function RowExpander() {
    _classCallCheck(this, RowExpander);

    return _possibleConstructorReturn(this, (RowExpander.__proto__ || Object.getPrototypeOf(RowExpander)).apply(this, arguments));
  }

  _createClass(RowExpander, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.expanded !== this.props.expanded;
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)('cursor', {
        'row-expander-rotated': this.props.expanded
      });

      return _react2.default.createElement(_Icon2.default, {
        name: 'chevron-right',
        className: classes,
        onClick: this.props.onClick
      });
    }
  }]);

  return RowExpander;
}(_react.Component), _class.propTypes = {
  expanded: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
  expanded: false
}, _temp);
exports.default = RowExpander;

/***/ }),
/* 995 */,
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Label = (_temp = _class = function (_Component) {
  _inherits(Label, _Component);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          type = _props.type;


      return _react2.default.createElement(
        'span',
        { className: 'label label-' + type },
        I18n.t(text)
      );
    }
  }]);

  return Label;
}(_react.Component), _class.propTypes = {
  text: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.oneOf(['default', 'primary', 'success', 'info', 'warning', 'danger']).isRequired
}, _temp);
exports.default = Label;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Video = __webpack_require__(711);

var _Video2 = _interopRequireDefault(_Video);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _videoPlayerActions = __webpack_require__(250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoContainer = (_temp = _class = function (_Component) {
  _inherits(VideoContainer, _Component);

  function VideoContainer() {
    _classCallCheck(this, VideoContainer);

    return _possibleConstructorReturn(this, (VideoContainer.__proto__ || Object.getPrototypeOf(VideoContainer)).apply(this, arguments));
  }

  _createClass(VideoContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.registerVideoPlayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.paused !== this.props.paused && this.props.paused) {
        this.video.pause();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.deregisterVideoPlayer();
    }
  }, {
    key: 'onPlay',
    value: function onPlay(propListener) {
      this.props.onPlay();
      propListener && propListener();
    }
  }, {
    key: 'onPause',
    value: function onPause(propListener) {
      this.props.onPause();
      propListener && propListener();
    }
  }, {
    key: 'getVideo',
    value: function getVideo() {
      return this.video;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$listeners = _props.listeners,
          listeners = _props$listeners === undefined ? {} : _props$listeners,
          videoProps = _objectWithoutProperties(_props, ['listeners']);

      listeners.play = this.onPlay.bind(this, listeners.play);
      listeners.pause = this.onPause.bind(this, listeners.pause);

      return _react2.default.createElement(_Video2.default, Object.assign({
        ref: function ref(_ref) {
          _this2.video = _ref;
        },
        listeners: listeners
      }, videoProps));
    }
  }]);

  return VideoContainer;
}(_react.Component), _class.propTypes = {
  deregisterVideoPlayer: _propTypes2.default.func.isRequired,
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  listeners: _propTypes2.default.object,
  onPause: _propTypes2.default.func.isRequired,
  onPlay: _propTypes2.default.func.isRequired,
  paused: _propTypes2.default.bool,
  registerVideoPlayer: _propTypes2.default.func.isRequired
}, _temp);


var mapStateToProps = function mapStateToProps(state, props) {
  return {
    paused: Boolean((state.videoPlayers[props.id] || {}).paused)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var id = _ref2.id;
  return {
    deregisterVideoPlayer: function deregisterVideoPlayer() {
      return dispatch((0, _videoPlayerActions.deregisterVideoPlayer)(id));
    },
    registerVideoPlayer: function registerVideoPlayer() {
      return dispatch((0, _videoPlayerActions.registerVideoPlayer)(id));
    },
    onPause: function onPause() {
      return dispatch((0, _videoPlayerActions.pause)(id));
    },
    onPlay: function onPlay() {
      return dispatch((0, _videoPlayerActions.play)(id));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, {
  withRef: true
})(VideoContainer);

/***/ }),
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToggleSwitch = (_temp = _class = function (_Component) {
  _inherits(ToggleSwitch, _Component);

  function ToggleSwitch() {
    _classCallCheck(this, ToggleSwitch);

    return _possibleConstructorReturn(this, (ToggleSwitch.__proto__ || Object.getPrototypeOf(ToggleSwitch)).apply(this, arguments));
  }

  _createClass(ToggleSwitch, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.expanded !== nextProps.expanded;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          expanded = _props.expanded,
          onClick = _props.onClick,
          style = _props.style;

      var classes = (0, _classnames2.default)({
        plus: !expanded,
        minus: expanded
      }, className);

      return _react2.default.createElement(_Icon2.default, { name: classes, onClick: onClick, style: style });
    }
  }]);

  return ToggleSwitch;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.string,
  expanded: _propTypes2.default.bool.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object
}, _temp);
exports.default = ToggleSwitch;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var convert = __webpack_require__(1219),
    string = __webpack_require__(1221);

var Color = function(obj) {
  if (obj instanceof Color) return obj;
  if (! (this instanceof Color)) return new Color(obj);

   this.values = {
      rgb: [0, 0, 0],
      hsl: [0, 0, 0],
      hsv: [0, 0, 0],
      hwb: [0, 0, 0],
      cmyk: [0, 0, 0, 0],
      alpha: 1
   }

   // parse Color() argument
   if (typeof obj == "string") {
      var vals = string.getRgba(obj);
      if (vals) {
         this.setValues("rgb", vals);
      }
      else if(vals = string.getHsla(obj)) {
         this.setValues("hsl", vals);
      }
      else if(vals = string.getHwb(obj)) {
         this.setValues("hwb", vals);
      }
      else {
        throw new Error("Unable to parse color from string \"" + obj + "\"");
      }
   }
   else if (typeof obj == "object") {
      var vals = obj;
      if(vals["r"] !== undefined || vals["red"] !== undefined) {
         this.setValues("rgb", vals)
      }
      else if(vals["l"] !== undefined || vals["lightness"] !== undefined) {
         this.setValues("hsl", vals)
      }
      else if(vals["v"] !== undefined || vals["value"] !== undefined) {
         this.setValues("hsv", vals)
      }
      else if(vals["w"] !== undefined || vals["whiteness"] !== undefined) {
         this.setValues("hwb", vals)
      }
      else if(vals["c"] !== undefined || vals["cyan"] !== undefined) {
         this.setValues("cmyk", vals)
      }
      else {
        throw new Error("Unable to parse color from object " + JSON.stringify(obj));
      }
   }
}

Color.prototype = {
   rgb: function (vals) {
      return this.setSpace("rgb", arguments);
   },
   hsl: function(vals) {
      return this.setSpace("hsl", arguments);
   },
   hsv: function(vals) {
      return this.setSpace("hsv", arguments);
   },
   hwb: function(vals) {
      return this.setSpace("hwb", arguments);
   },
   cmyk: function(vals) {
      return this.setSpace("cmyk", arguments);
   },

   rgbArray: function() {
      return this.values.rgb;
   },
   hslArray: function() {
      return this.values.hsl;
   },
   hsvArray: function() {
      return this.values.hsv;
   },
   hwbArray: function() {
      if (this.values.alpha !== 1) {
        return this.values.hwb.concat([this.values.alpha])
      }
      return this.values.hwb;
   },
   cmykArray: function() {
      return this.values.cmyk;
   },
   rgbaArray: function() {
      var rgb = this.values.rgb;
      return rgb.concat([this.values.alpha]);
   },
   hslaArray: function() {
      var hsl = this.values.hsl;
      return hsl.concat([this.values.alpha]);
   },
   alpha: function(val) {
      if (val === undefined) {
         return this.values.alpha;
      }
      this.setValues("alpha", val);
      return this;
   },

   red: function(val) {
      return this.setChannel("rgb", 0, val);
   },
   green: function(val) {
      return this.setChannel("rgb", 1, val);
   },
   blue: function(val) {
      return this.setChannel("rgb", 2, val);
   },
   hue: function(val) {
      return this.setChannel("hsl", 0, val);
   },
   saturation: function(val) {
      return this.setChannel("hsl", 1, val);
   },
   lightness: function(val) {
      return this.setChannel("hsl", 2, val);
   },
   saturationv: function(val) {
      return this.setChannel("hsv", 1, val);
   },
   whiteness: function(val) {
      return this.setChannel("hwb", 1, val);
   },
   blackness: function(val) {
      return this.setChannel("hwb", 2, val);
   },
   value: function(val) {
      return this.setChannel("hsv", 2, val);
   },
   cyan: function(val) {
      return this.setChannel("cmyk", 0, val);
   },
   magenta: function(val) {
      return this.setChannel("cmyk", 1, val);
   },
   yellow: function(val) {
      return this.setChannel("cmyk", 2, val);
   },
   black: function(val) {
      return this.setChannel("cmyk", 3, val);
   },

   hexString: function() {
      return string.hexString(this.values.rgb);
   },
   rgbString: function() {
      return string.rgbString(this.values.rgb, this.values.alpha);
   },
   rgbaString: function() {
      return string.rgbaString(this.values.rgb, this.values.alpha);
   },
   percentString: function() {
      return string.percentString(this.values.rgb, this.values.alpha);
   },
   hslString: function() {
      return string.hslString(this.values.hsl, this.values.alpha);
   },
   hslaString: function() {
      return string.hslaString(this.values.hsl, this.values.alpha);
   },
   hwbString: function() {
      return string.hwbString(this.values.hwb, this.values.alpha);
   },
   keyword: function() {
      return string.keyword(this.values.rgb, this.values.alpha);
   },

   rgbNumber: function() {
      return (this.values.rgb[0] << 16) | (this.values.rgb[1] << 8) | this.values.rgb[2];
   },

   luminosity: function() {
      // http://www.w3.org/TR/WCAG20/#relativeluminancedef
      var rgb = this.values.rgb;
      var lum = [];
      for (var i = 0; i < rgb.length; i++) {
         var chan = rgb[i] / 255;
         lum[i] = (chan <= 0.03928) ? chan / 12.92
                  : Math.pow(((chan + 0.055) / 1.055), 2.4)
      }
      return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
   },

   contrast: function(color2) {
      // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
      var lum1 = this.luminosity();
      var lum2 = color2.luminosity();
      if (lum1 > lum2) {
         return (lum1 + 0.05) / (lum2 + 0.05)
      };
      return (lum2 + 0.05) / (lum1 + 0.05);
   },

   level: function(color2) {
     var contrastRatio = this.contrast(color2);
     return (contrastRatio >= 7.1)
       ? 'AAA'
       : (contrastRatio >= 4.5)
        ? 'AA'
        : '';
   },

   dark: function() {
      // YIQ equation from http://24ways.org/2010/calculating-color-contrast
      var rgb = this.values.rgb,
          yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
      return yiq < 128;
   },

   light: function() {
      return !this.dark();
   },

   negate: function() {
      var rgb = []
      for (var i = 0; i < 3; i++) {
         rgb[i] = 255 - this.values.rgb[i];
      }
      this.setValues("rgb", rgb);
      return this;
   },

   lighten: function(ratio) {
      this.values.hsl[2] += this.values.hsl[2] * ratio;
      this.setValues("hsl", this.values.hsl);
      return this;
   },

   darken: function(ratio) {
      this.values.hsl[2] -= this.values.hsl[2] * ratio;
      this.setValues("hsl", this.values.hsl);
      return this;
   },

   saturate: function(ratio) {
      this.values.hsl[1] += this.values.hsl[1] * ratio;
      this.setValues("hsl", this.values.hsl);
      return this;
   },

   desaturate: function(ratio) {
      this.values.hsl[1] -= this.values.hsl[1] * ratio;
      this.setValues("hsl", this.values.hsl);
      return this;
   },

   whiten: function(ratio) {
      this.values.hwb[1] += this.values.hwb[1] * ratio;
      this.setValues("hwb", this.values.hwb);
      return this;
   },

   blacken: function(ratio) {
      this.values.hwb[2] += this.values.hwb[2] * ratio;
      this.setValues("hwb", this.values.hwb);
      return this;
   },

   greyscale: function() {
      var rgb = this.values.rgb;
      // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
      var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
      this.setValues("rgb", [val, val, val]);
      return this;
   },

   clearer: function(ratio) {
      this.setValues("alpha", this.values.alpha - (this.values.alpha * ratio));
      return this;
   },

   opaquer: function(ratio) {
      this.setValues("alpha", this.values.alpha + (this.values.alpha * ratio));
      return this;
   },

   rotate: function(degrees) {
      var hue = this.values.hsl[0];
      hue = (hue + degrees) % 360;
      hue = hue < 0 ? 360 + hue : hue;
      this.values.hsl[0] = hue;
      this.setValues("hsl", this.values.hsl);
      return this;
   },

   /**
    * Ported from sass implementation in C
    * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
    */
   mix: function(mixinColor, weight) {
      var color1 = this;
      var color2 = mixinColor;
      var p = weight !== undefined ? weight : 0.5;

      var w = 2 * p - 1;
      var a = color1.alpha() - color2.alpha();

      var w1 = (((w * a == -1) ? w : (w + a)/(1 + w*a)) + 1) / 2.0;
      var w2 = 1 - w1;

      return this
        .rgb(
          w1 * color1.red() + w2 * color2.red(),
          w1 * color1.green() + w2 * color2.green(),
          w1 * color1.blue() + w2 * color2.blue()
        )
        .alpha(color1.alpha() * p + color2.alpha() * (1 - p));
   },

   toJSON: function() {
     return this.rgb();
   },

   clone: function() {
     return new Color(this.rgb());
   }
}


Color.prototype.getValues = function(space) {
   var vals = {};
   for (var i = 0; i < space.length; i++) {
      vals[space.charAt(i)] = this.values[space][i];
   }
   if (this.values.alpha != 1) {
      vals["a"] = this.values.alpha;
   }
   // {r: 255, g: 255, b: 255, a: 0.4}
   return vals;
}

Color.prototype.setValues = function(space, vals) {
   var spaces = {
      "rgb": ["red", "green", "blue"],
      "hsl": ["hue", "saturation", "lightness"],
      "hsv": ["hue", "saturation", "value"],
      "hwb": ["hue", "whiteness", "blackness"],
      "cmyk": ["cyan", "magenta", "yellow", "black"]
   };

   var maxes = {
      "rgb": [255, 255, 255],
      "hsl": [360, 100, 100],
      "hsv": [360, 100, 100],
      "hwb": [360, 100, 100],
      "cmyk": [100, 100, 100, 100]
   };

   var alpha = 1;
   if (space == "alpha") {
      alpha = vals;
   }
   else if (vals.length) {
      // [10, 10, 10]
      this.values[space] = vals.slice(0, space.length);
      alpha = vals[space.length];
   }
   else if (vals[space.charAt(0)] !== undefined) {
      // {r: 10, g: 10, b: 10}
      for (var i = 0; i < space.length; i++) {
        this.values[space][i] = vals[space.charAt(i)];
      }
      alpha = vals.a;
   }
   else if (vals[spaces[space][0]] !== undefined) {
      // {red: 10, green: 10, blue: 10}
      var chans = spaces[space];
      for (var i = 0; i < space.length; i++) {
        this.values[space][i] = vals[chans[i]];
      }
      alpha = vals.alpha;
   }
   this.values.alpha = Math.max(0, Math.min(1, (alpha !== undefined ? alpha : this.values.alpha) ));
   if (space == "alpha") {
      return;
   }

   // cap values of the space prior converting all values
   for (var i = 0; i < space.length; i++) {
      var capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
      this.values[space][i] = Math.round(capped);
   }

   // convert to all the other color spaces
   for (var sname in spaces) {
      if (sname != space) {
         this.values[sname] = convert[space][sname](this.values[space])
      }

      // cap values
      for (var i = 0; i < sname.length; i++) {
         var capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
         this.values[sname][i] = Math.round(capped);
      }
   }
   return true;
}

Color.prototype.setSpace = function(space, args) {
   var vals = args[0];
   if (vals === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof vals == "number") {
      vals = Array.prototype.slice.call(args);
   }
   this.setValues(space, vals);
   return this;
}

Color.prototype.setChannel = function(space, index, val) {
   if (val === undefined) {
      // color.red()
      return this.values[space][index];
   }
   // color.red(100)
   this.values[space][index] = val;
   this.setValues(space, this.values[space]);
   return this;
}

module.exports = Color;


/***/ }),
/* 1144 */,
/* 1145 */,
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _VideoContainer = __webpack_require__(997);

var _VideoContainer2 = _interopRequireDefault(_VideoContainer);

var _humps = __webpack_require__(22);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var guid = 1;

var VideoClipPlayer = (_temp = _class = function (_Component) {
  _inherits(VideoClipPlayer, _Component);

  function VideoClipPlayer() {
    _classCallCheck(this, VideoClipPlayer);

    return _possibleConstructorReturn(this, (VideoClipPlayer.__proto__ || Object.getPrototypeOf(VideoClipPlayer)).apply(this, arguments));
  }

  _createClass(VideoClipPlayer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          startTime = _props.startTime,
          endTime = _props.endTime,
          languages = _props.languages,
          restrictPlaybackToClip = _props.restrictPlaybackToClip,
          props = _objectWithoutProperties(_props, ['startTime', 'endTime', 'languages', 'restrictPlaybackToClip']);

      return _react2.default.createElement(_VideoContainer2.default, Object.assign({}, props, {
        controlBar: {
          clipPlaybackButton: {
            startFromClipBeginning: true
          },
          languageMenu: {}
        },
        plugins: {
          clip: {
            startTime: startTime,
            endTime: endTime,
            restrictPlaybackToClip: restrictPlaybackToClip
          }
        },
        options: { languages: (0, _humps.decamelizeKeys)(languages) }
      }));
    }
  }]);

  return VideoClipPlayer;
}(_react.Component), _class.propTypes = {
  captionSource: _propTypes2.default.string,
  endTime: _propTypes2.default.number,
  height: _propTypes2.default.number,
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  languages: _propTypes2.default.array,
  listeners: _propTypes2.default.object,
  restrictPlaybackToClip: _propTypes2.default.bool,
  src: _propTypes2.default.shape({
    hd: _propTypes2.default.string,
    sd: _propTypes2.default.string
  }).isRequired,
  startTime: _propTypes2.default.number,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
}, _class.defaultProps = {
  startTime: 0,
  endTime: 0,
  id: 'clipPlayer' + guid++
}, _temp);
exports.default = VideoClipPlayer;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _MarkRow = __webpack_require__(963);

var _MarkRow2 = _interopRequireDefault(_MarkRow);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarksList = (_temp = _class = function (_Component) {
  _inherits(MarksList, _Component);

  function MarksList() {
    _classCallCheck(this, MarksList);

    return _possibleConstructorReturn(this, (MarksList.__proto__ || Object.getPrototypeOf(MarksList)).apply(this, arguments));
  }

  _createClass(MarksList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          marks = _props.marks,
          handleMarkClick = _props.handleMarkClick,
          onMarkSave = _props.onMarkSave,
          onMarkDelete = _props.onMarkDelete,
          videoLength = _props.videoLength;


      if (marks.length === 0) {
        return _react2.default.createElement(
          'span',
          { className: 'grey-reg-i' },
          I18n.t('No marks provided')
        );
      }
      return _react2.default.createElement(
        'ul',
        { className: 'cursor' },
        marks.map(function (mark) {
          return _react2.default.createElement(_MarkRow2.default, {
            key: mark.id,
            mark: mark,
            handleClick: handleMarkClick,
            onSave: onMarkSave,
            onDelete: onMarkDelete,
            videoLength: videoLength
          });
        })
      );
    }
  }], [{
    key: 'defaultProps',
    value: function defaultProps() {
      return {
        marks: this.props.marks
      };
    }
  }]);

  return MarksList;
}(_react.Component), _class.propTypes = {
  handleMarkClick: _propTypes2.default.func.isRequired,
  marks: _propTypes2.default.array,
  onMarkDelete: _propTypes2.default.func.isRequired,
  onMarkSave: _propTypes2.default.func.isRequired,
  videoLength: _propTypes2.default.number.isRequired
}, _temp);
exports.default = MarksList;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeMark = exports.updateMark = exports.addMark = exports.removeMarkFailed = exports.removeMarkSuccess = exports.removeMarkRequest = exports.updateMarkFailed = exports.updateMarkSuccess = exports.updateMarkRequest = exports.addMarkFailure = exports.addMarkSuccess = exports.addMarkRequest = exports.REMOVE_MARK_FAILURE = exports.REMOVE_MARK_SUCCESS = exports.REMOVE_MARK_REQUEST = exports.UPDATE_MARK_FAILURE = exports.UPDATE_MARK_SUCCESS = exports.UPDATE_MARK_REQUEST = exports.ADD_MARK_FAILURE = exports.ADD_MARK_SUCCESS = exports.ADD_MARK_REQUEST = undefined;

var _api = __webpack_require__(119);

var _alertActions = __webpack_require__(33);

var _AlertListItem = __webpack_require__(7);

var _i18n = __webpack_require__(90);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADD_MARK_REQUEST = exports.ADD_MARK_REQUEST = 'tru/ADD_MARK_REQUEST';
var ADD_MARK_SUCCESS = exports.ADD_MARK_SUCCESS = 'tru/ADD_MARK_SUCCESS';
var ADD_MARK_FAILURE = exports.ADD_MARK_FAILURE = 'tru/ADD_MARK_FAILURE';

var UPDATE_MARK_REQUEST = exports.UPDATE_MARK_REQUEST = 'tru/UPDATE_MARK_REQUEST';
var UPDATE_MARK_SUCCESS = exports.UPDATE_MARK_SUCCESS = 'tru/UPDATE_MARK_SUCCESS';
var UPDATE_MARK_FAILURE = exports.UPDATE_MARK_FAILURE = 'tru/UPDATE_MARK_FAILURE';

var REMOVE_MARK_REQUEST = exports.REMOVE_MARK_REQUEST = 'tru/REMOVE_MARK_REQUEST';
var REMOVE_MARK_SUCCESS = exports.REMOVE_MARK_SUCCESS = 'tru/REMOVE_MARK_SUCCESS';
var REMOVE_MARK_FAILURE = exports.REMOVE_MARK_FAILURE = 'tru/REMOVE_MARK_FAILURE';

var addMarkRequest = exports.addMarkRequest = function addMarkRequest(mark) {
  return {
    type: ADD_MARK_REQUEST,
    mark: mark
  };
};

var addMarkSuccess = exports.addMarkSuccess = function addMarkSuccess(success) {
  return {
    type: ADD_MARK_SUCCESS,
    success: success
  };
};

var addMarkFailure = exports.addMarkFailure = function addMarkFailure(errors) {
  return {
    type: ADD_MARK_FAILURE,
    errors: errors
  };
};

var updateMarkRequest = exports.updateMarkRequest = function updateMarkRequest(mark) {
  return {
    type: UPDATE_MARK_REQUEST,
    mark: mark
  };
};

var updateMarkSuccess = exports.updateMarkSuccess = function updateMarkSuccess(success) {
  return {
    type: UPDATE_MARK_SUCCESS,
    success: success
  };
};

var updateMarkFailed = exports.updateMarkFailed = function updateMarkFailed(errors) {
  return {
    type: UPDATE_MARK_FAILURE,
    errors: errors
  };
};

var removeMarkRequest = exports.removeMarkRequest = function removeMarkRequest(id) {
  return {
    type: REMOVE_MARK_REQUEST,
    id: id
  };
};

var removeMarkSuccess = exports.removeMarkSuccess = function removeMarkSuccess(success) {
  return {
    type: REMOVE_MARK_SUCCESS,
    success: success
  };
};

var removeMarkFailed = exports.removeMarkFailed = function removeMarkFailed(errors) {
  return {
    type: REMOVE_MARK_FAILURE,
    errors: errors
  };
};

var addMark = exports.addMark = function addMark(mark) {
  return function (dispatch) {
    if (mark.text.trim()) {
      return _api.marks.add(mark).then(function (data) {
        dispatch(addMarkSuccess());
        return data.data;
      }, function (error) {
        dispatch(addMarkFailure(error));
        dispatch((0, _alertActions.createAlert)({
          scope: 'mark',
          type: _AlertListItem.ERROR,
          message: _i18n2.default.t('There was a problem saving your mark.\n                  Please try again.')
        }));
      });
    }
    dispatch((0, _alertActions.createAlert)({
      scope: 'mark',
      type: _AlertListItem.ERROR,
      message: _i18n2.default.t("Mark Name: This is a mandatory field, can't be blank")
    }));
  };
};

var updateMark = exports.updateMark = function updateMark(mark) {
  return function (dispatch) {
    dispatch(updateMarkRequest(mark));
    if (mark.text.trim()) {
      return _api.marks.update(mark).then(function () {
        return dispatch(updateMarkSuccess());
      }, function (error) {
        dispatch(updateMarkFailed(error));
        dispatch((0, _alertActions.createAlert)({
          scope: 'mark',
          type: _AlertListItem.ERROR,
          message: _i18n2.default.t('There was a problem saving your mark.\n                  Please try again.')
        }));
      });
    }
    dispatch((0, _alertActions.createAlert)({
      scope: 'mark',
      type: _AlertListItem.ERROR,
      message: _i18n2.default.t("Mark Name: This is a mandatory field, can't be blank")
    }));
  };
};

var removeMark = exports.removeMark = function removeMark(id) {
  return function (dispatch) {
    dispatch(removeMarkRequest(id));

    return _api.marks.remove(id).then(function () {
      return dispatch(removeMarkSuccess());
    }, function (error) {
      dispatch(removeMarkFailed(error));
      dispatch((0, _alertActions.createAlert)({
        scope: 'mark',
        type: _AlertListItem.ERROR,
        message: _i18n2.default.t('There was a problem deleting your mark.\n                Please try again.')
      }));
    });
  };
};

/***/ }),
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(706),
    castSlice = __webpack_require__(980),
    hasUnicode = __webpack_require__(821),
    isObject = __webpack_require__(9),
    isRegExp = __webpack_require__(1193),
    stringSize = __webpack_require__(1195),
    stringToArray = __webpack_require__(953),
    toInteger = __webpack_require__(822),
    toString = __webpack_require__(670);

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);

  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

module.exports = truncate;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1194),
    baseUnary = __webpack_require__(130),
    nodeUtil = __webpack_require__(216);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(31),
    isObjectLike = __webpack_require__(21);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(1196),
    hasUnicode = __webpack_require__(821),
    unicodeSize = __webpack_require__(1197);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(833);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _HighlightOverlay = __webpack_require__(1199);

var _HighlightOverlay2 = _interopRequireDefault(_HighlightOverlay);

var _Spinner = __webpack_require__(116);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _selectEntity = __webpack_require__(228);

var _selectEntity2 = _interopRequireDefault(_selectEntity);

var _selectList = __webpack_require__(622);

var _selectList2 = _interopRequireDefault(_selectList);

var _highlightActions = __webpack_require__(160);

var _reactRedux = __webpack_require__(6);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HighlightOverlayContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, { addHighlightToWorkspace: _highlightActions.addHighlightToWorkspace, fetchHighlight: _highlightActions.fetchHighlight }, mergeProps), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(HighlightOverlayContainer, _Component);

  function HighlightOverlayContainer() {
    _classCallCheck(this, HighlightOverlayContainer);

    return _possibleConstructorReturn(this, (HighlightOverlayContainer.__proto__ || Object.getPrototypeOf(HighlightOverlayContainer)).apply(this, arguments));
  }

  _createClass(HighlightOverlayContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          company = _props.company,
          fetchHighlight = _props.fetchHighlight,
          highlight = _props.highlight;

      fetchHighlight(company, highlight.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          addHighlightToWorkspace = _props2.addHighlightToWorkspace,
          company = _props2.company,
          isFetching = _props2.isFetching,
          highlight = _props2.highlight,
          metaTags = _props2.metaTags,
          owner = _props2.owner,
          permissions = _props2.permissions,
          searchHighlights = _props2.searchHighlights,
          tags = _props2.tags,
          workspaces = _props2.workspaces;


      if (isFetching) {
        return _react2.default.createElement(_Spinner2.default, { spinning: true, style: { top: 200 } });
      }

      var isLiteUser = Tru.Stores.reduxStore.getState().currentUser.liteRolesPerCompany[company.id];

      return _react2.default.createElement(_HighlightOverlay2.default, {
        company: company,
        highlight: highlight,
        metaTags: metaTags,
        isLiteUser: isLiteUser,
        onAddToWorkspace: function onAddToWorkspace(workspace) {
          return addHighlightToWorkspace(company, highlight, workspace);
        },
        owner: owner,
        permissions: permissions,
        searchHighlights: searchHighlights,
        tags: tags,
        workspaces: workspaces
      });
    }
  }]);

  return HighlightOverlayContainer;
}(_react.Component), _class2.propTypes = {
  addHighlightToWorkspace: _propTypes2.default.func.isRequired,
  company: _propTypes2.default.object.isRequired,
  fetchHighlight: _propTypes2.default.func.isRequired,
  highlight: _propTypes2.default.object.isRequired,
  isFetching: _propTypes2.default.bool.isRequired,
  metaTags: _propTypes2.default.array.isRequired,
  owner: _propTypes2.default.object.isRequired,
  permissions: _propTypes2.default.object.isRequired,
  searchHighlights: _propTypes2.default.array,
  tags: _propTypes2.default.array.isRequired,
  workspaces: _propTypes2.default.array.isRequired
}, _temp)) || _class);
exports.default = HighlightOverlayContainer;


function mergeProps(stateProps, dispatchProps, ownProps) {
  var company = stateProps.company,
      entities = stateProps.entities,
      isFetching = stateProps.isFetching,
      permissions = stateProps.permissions;
  var highlightId = ownProps.highlightId,
      searchHighlights = ownProps.searchHighlights;


  var highlight = (0, _selectEntity2.default)(entities.highlights, highlightId);
  var metaTags = (0, _selectList2.default)(entities.metaTags, highlight.metaTags);
  var owner = (0, _selectEntity2.default)(entities.users, highlight.owner);
  var tags = (0, _selectList2.default)(entities.tags, highlight.tags);
  var workspaces = (0, _selectList2.default)(entities.workspaces, highlight.workspaces);

  return Object.assign({}, dispatchProps, {
    company: company,
    isFetching: isFetching,
    highlight: highlight,
    metaTags: metaTags,
    owner: owner,
    permissions: permissions,
    searchHighlights: searchHighlights,
    tags: tags,
    workspaces: workspaces
  });
}

function mapStateToProps(state) {
  return {
    company: state.company,
    isFetching: state.highlights.isFetching,
    entities: state.entities,
    permissions: state.permissions
  };
}

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _AlertListContainer = __webpack_require__(375);

var _AlertListContainer2 = _interopRequireDefault(_AlertListContainer);

var _DateDisplay = __webpack_require__(669);

var _DateDisplay2 = _interopRequireDefault(_DateDisplay);

var _HighlightContent = __webpack_require__(1200);

var _HighlightContent2 = _interopRequireDefault(_HighlightContent);

var _KeywordHighlight = __webpack_require__(362);

var _KeywordHighlight2 = _interopRequireDefault(_KeywordHighlight);

var _OverlayAboutTile = __webpack_require__(858);

var _OverlayAboutTile2 = _interopRequireDefault(_OverlayAboutTile);

var _OverlayColumn = __webpack_require__(860);

var _OverlayColumn2 = _interopRequireDefault(_OverlayColumn);

var _OverlayTagTile = __webpack_require__(861);

var _OverlayTagTile2 = _interopRequireDefault(_OverlayTagTile);

var _OverlayTile = __webpack_require__(682);

var _OverlayTile2 = _interopRequireDefault(_OverlayTile);

var _OverlayTileColumn = __webpack_require__(862);

var _OverlayTileColumn2 = _interopRequireDefault(_OverlayTileColumn);

var _OverlayTileHeading = __webpack_require__(683);

var _OverlayTileHeading2 = _interopRequireDefault(_OverlayTileHeading);

var _OverlayTileOptionLink = __webpack_require__(863);

var _OverlayTileOptionLink2 = _interopRequireDefault(_OverlayTileOptionLink);

var _OverlayWorkspaceTile = __webpack_require__(907);

var _OverlayWorkspaceTile2 = _interopRequireDefault(_OverlayWorkspaceTile);

var _PermissionGuard = __webpack_require__(633);

var _PermissionGuard2 = _interopRequireDefault(_PermissionGuard);

var _ShareLinkPopover = __webpack_require__(864);

var _ShareLinkPopover2 = _interopRequireDefault(_ShareLinkPopover);

var _WorkspaceSelectorContainer = __webpack_require__(838);

var _WorkspaceSelectorContainer2 = _interopRequireDefault(_WorkspaceSelectorContainer);

var _htmlTruncate = __webpack_require__(1223);

var _htmlTruncate2 = _interopRequireDefault(_htmlTruncate);

var _selectSearchHighlights = __webpack_require__(713);

var _selectSearchHighlights2 = _interopRequireDefault(_selectSearchHighlights);

var _underscore = __webpack_require__(164);

var _underscore2 = _interopRequireDefault(_underscore);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var truncate = _underscore2.default.str.truncate;
var HighlightOverlay = (_temp = _class = function (_Component) {
  _inherits(HighlightOverlay, _Component);

  function HighlightOverlay() {
    _classCallCheck(this, HighlightOverlay);

    return _possibleConstructorReturn(this, (HighlightOverlay.__proto__ || Object.getPrototypeOf(HighlightOverlay)).apply(this, arguments));
  }

  _createClass(HighlightOverlay, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          company = _props.company,
          highlight = _props.highlight,
          isLiteUser = _props.isLiteUser,
          metaTags = _props.metaTags,
          onAddToWorkspace = _props.onAddToWorkspace,
          owner = _props.owner,
          permissions = _props.permissions,
          searchHighlights = _props.searchHighlights,
          tags = _props.tags,
          workspaces = _props.workspaces;

      var image = highlight.image || {};
      var highlightStories = highlight.highlightStories || [];

      var titleHighlights = (0, _selectSearchHighlights2.default)(searchHighlights, 'name');
      var textHighlights = (0, _selectSearchHighlights2.default)(searchHighlights, 'text');

      var titleTokens = titleHighlights.reduce(function (memo, highlight) {
        return memo.concat(highlight.tokens);
      }, []);
      var textTokens = textHighlights.reduce(function (memo, highlight) {
        return memo.concat(highlight.tokens);
      }, []);

      return _react2.default.createElement(
        'div',
        { className: 'insight-overlay-viewer' },
        _react2.default.createElement(_AlertListContainer2.default, { clearOnUnmount: true }),
        _react2.default.createElement(
          _OverlayTile2.default,
          { className: 'insight-content' },
          _react2.default.createElement(
            'div',
            { className: 'highlight-details-container clearfix' },
            _react2.default.createElement('img', { className: 'highlight-cover-photo', src: image.tile }),
            _react2.default.createElement(
              'div',
              { className: 'highlight-details' },
              _react2.default.createElement(
                'div',
                { className: 'editor-title' },
                _react2.default.createElement(_KeywordHighlight2.default, {
                  text: truncate(highlight.name, 135) || I18n.t('No Title'),
                  tokens: titleTokens
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'insight-description' },
                _react2.default.createElement(_KeywordHighlight2.default, {
                  text: (0, _htmlTruncate2.default)(highlight.text || '', 390),
                  tokens: textTokens
                })
              )
            )
          ),
          _react2.default.createElement(_HighlightContent2.default, {
            highlightStories: highlightStories,
            template: highlight.template || {}
          })
        ),
        _react2.default.createElement(
          _OverlayColumn2.default,
          { align: 'left' },
          _react2.default.createElement(_OverlayAboutTile2.default, {
            date: highlight.insertDt,
            details: {
              'Date Research Occurred': _react2.default.createElement(_DateDisplay2.default, { date: highlight.researchDt, format: _DateDisplay.MONTH_YEAR })
            },
            heading: 'About this Highlight',
            metaTags: metaTags,
            searchHighlights: titleHighlights,
            title: highlight.name,
            user: owner
          }),
          _react2.default.createElement(_OverlayTagTile2.default, {
            searchHighlights: (0, _selectSearchHighlights2.default)(searchHighlights, 'tagNames'),
            tags: tags
          })
        ),
        _react2.default.createElement(
          _OverlayColumn2.default,
          { align: 'right' },
          _react2.default.createElement(
            _OverlayTile2.default,
            { className: 'clearfix' },
            _react2.default.createElement(_OverlayTileHeading2.default, { icon: 'settings', title: 'Options' }),
            _react2.default.createElement(
              _OverlayTileColumn2.default,
              { align: 'left' },
              _react2.default.createElement(
                _PermissionGuard2.default,
                {
                  permissions: permissions,
                  object: 'workspace',
                  operation: 'edit'
                },
                _react2.default.createElement(
                  _WorkspaceSelectorContainer2.default,
                  {
                    onAddToWorkspace: onAddToWorkspace,
                    isLiteUser: isLiteUser
                  },
                  _react2.default.createElement(_OverlayTileOptionLink2.default, {
                    icon: 'file-add',
                    title: 'Add To Workspace'
                  })
                )
              )
            ),
            _react2.default.createElement(
              _OverlayTileColumn2.default,
              { align: 'right' },
              company.canShareFl && _react2.default.createElement(
                _ShareLinkPopover2.default,
                { tip: highlight.shareUrl },
                _react2.default.createElement(_OverlayTileOptionLink2.default, { title: 'Share', icon: 'share' })
              )
            )
          ),
          _react2.default.createElement(_OverlayWorkspaceTile2.default, { workspaces: workspaces })
        )
      );
    }
  }]);

  return HighlightOverlay;
}(_react.Component), _class.propTypes = {
  company: _propTypes2.default.object.isRequired,
  highlight: _propTypes2.default.object.isRequired,
  isLiteUser: _propTypes2.default.bool.isRequired,
  metaTags: _propTypes2.default.array.isRequired,
  onAddToWorkspace: _propTypes2.default.func.isRequired,
  owner: _propTypes2.default.object.isRequired,
  permissions: _propTypes2.default.object.isRequired,
  searchHighlights: _propTypes2.default.array,
  tags: _propTypes2.default.array.isRequired,
  workspaces: _propTypes2.default.array.isRequired
}, _temp);
exports.default = HighlightOverlay;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _HighlightStory = __webpack_require__(1201);

var _HighlightStory2 = _interopRequireDefault(_HighlightStory);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HighlightContent = (_temp = _class = function (_PureComponent) {
  _inherits(HighlightContent, _PureComponent);

  function HighlightContent(props) {
    _classCallCheck(this, HighlightContent);

    var _this = _possibleConstructorReturn(this, (HighlightContent.__proto__ || Object.getPrototypeOf(HighlightContent)).call(this, props));

    _this.state = {
      focusedHighlightStory: null
    };
    return _this;
  }

  _createClass(HighlightContent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          highlightStories = _props.highlightStories,
          template = _props.template;
      var focusedHighlightStory = this.state.focusedHighlightStory;

      var templateClasses = (0, _classnames2.default)('clearfix', 'insight-layout-' + template.size + '-item', template.name);

      highlightStories = highlightStories.sort(function (a, b) {
        return a.orderIdx - b.orderIdx;
      });

      return _react2.default.createElement(
        'div',
        { className: 'insight-template-container clear-both' },
        _react2.default.createElement(
          'div',
          { className: templateClasses },
          highlightStories.map(function (highlightStory) {
            return _react2.default.createElement(_HighlightStory2.default, {
              key: highlightStory.id,
              highlightStory: highlightStory,
              isFocused: focusedHighlightStory === highlightStory,
              onLoseFocus: function onLoseFocus() {
                return _this2.setState({ focusedHighlightStory: null });
              },
              onFocus: function onFocus() {
                return _this2.setState({ focusedHighlightStory: highlightStory });
              }
            });
          })
        )
      );
    }
  }]);

  return HighlightContent;
}(_react.PureComponent), _class.propTypes = {
  highlightStories: _propTypes2.default.array.isRequired,
  template: _propTypes2.default.object.isRequired
}, _temp);
exports.default = HighlightContent;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _ImageHighlightStory = __webpack_require__(1202);

var _ImageHighlightStory2 = _interopRequireDefault(_ImageHighlightStory);

var _DocumentHighlightStory = __webpack_require__(1203);

var _DocumentHighlightStory2 = _interopRequireDefault(_DocumentHighlightStory);

var _PlaylistHighlightStory = __webpack_require__(1208);

var _PlaylistHighlightStory2 = _interopRequireDefault(_PlaylistHighlightStory);

var _TextHighlightStory = __webpack_require__(1209);

var _TextHighlightStory2 = _interopRequireDefault(_TextHighlightStory);

var _VideoResponseHighlightStory = __webpack_require__(1210);

var _VideoResponseHighlightStory2 = _interopRequireDefault(_VideoResponseHighlightStory);

var _WorkspaceVideoClipHighlightStory = __webpack_require__(1211);

var _WorkspaceVideoClipHighlightStory2 = _interopRequireDefault(_WorkspaceVideoClipHighlightStory);

var _RichText = __webpack_require__(954);

var _RichText2 = _interopRequireDefault(_RichText);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _humps = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HighlightStory = (_temp = _class = function (_Component) {
  _inherits(HighlightStory, _Component);

  function HighlightStory(props) {
    _classCallCheck(this, HighlightStory);

    var _this = _possibleConstructorReturn(this, (HighlightStory.__proto__ || Object.getPrototypeOf(HighlightStory)).call(this, props));

    _this.onFocus = _this.onFocus.bind(_this);
    _this.onLoseFocus = _this.onLoseFocus.bind(_this);
    return _this;
  }

  _createClass(HighlightStory, [{
    key: 'onFocus',
    value: function onFocus() {
      var _props = this.props,
          highlightStory = _props.highlightStory,
          onFocus = _props.onFocus;

      onFocus(highlightStory);
    }
  }, {
    key: 'onLoseFocus',
    value: function onLoseFocus() {
      var _props2 = this.props,
          highlightStory = _props2.highlightStory,
          onLoseFocus = _props2.onLoseFocus;

      onLoseFocus(highlightStory);
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props3 = this.props,
          highlightStory = _props3.highlightStory,
          isFocused = _props3.isFocused;

      var content = highlightStory.content;

      if (!content || !content.kind) {
        return null;
      }

      switch ((0, _humps.camelize)(content.kind)) {
        case 'imageDocumentClip':
        case 'workspaceImageClip':
          return _react2.default.createElement(_ImageHighlightStory2.default, {
            image: content.image,
            isExpanded: isFocused,
            onCollapseClick: this.onLoseFocus,
            onExpandClick: this.onFocus,
            title: content.name
          });
        case 'imageResponse':
          return _react2.default.createElement(_ImageHighlightStory2.default, {
            image: content.image,
            isExpanded: isFocused,
            onCollapseClick: this.onLoseFocus,
            onExpandClick: this.onFocus,
            title: content.title
          });
        case 'projectDocument':
        case 'workspaceDocument':
          return _react2.default.createElement(_DocumentHighlightStory2.default, {
            isExpanded: isFocused,
            onExpandClick: this.onFocus,
            onCollapseClick: this.onLoseFocus,
            document: content
          });
        case 'playlist':
          return _react2.default.createElement(_PlaylistHighlightStory2.default, {
            isPlaying: isFocused,
            onPlay: this.onFocus,
            onEnded: this.onLoseFocus,
            playlist: content
          });
        case 'textResponse':
          return _react2.default.createElement(_TextHighlightStory2.default, { text: content.commentTxt });
        case 'textDocumentClip':
        case 'workspaceTextClip':
          return _react2.default.createElement(_TextHighlightStory2.default, { text: content.textSelection });
        case 'videoResponse':
          return _react2.default.createElement(_VideoResponseHighlightStory2.default, {
            videoResponse: content,
            isPlaying: isFocused,
            onEnded: this.onLoseFocus,
            onPlay: this.onFocus
          });
        case 'workspaceVideoClip':
          return _react2.default.createElement(_WorkspaceVideoClipHighlightStory2.default, {
            workspaceVideoClip: content,
            isPlaying: isFocused,
            onEnded: this.onLoseFocus,
            onPlay: this.onFocus
          });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var highlightStory = this.props.highlightStory;


      return _react2.default.createElement(
        'div',
        { className: 'insight-story-container clearfix' },
        _react2.default.createElement(
          'div',
          { className: 'insight-story-item' },
          this.renderContent()
        ),
        _react2.default.createElement(
          'div',
          { className: 'insight-story-text' },
          _react2.default.createElement(_RichText2.default, { text: highlightStory.text })
        )
      );
    }
  }]);

  return HighlightStory;
}(_react.Component), _class.propTypes = {
  highlightStory: _propTypes2.default.object.isRequired,
  isFocused: _propTypes2.default.bool.isRequired,
  onFocus: _propTypes2.default.func.isRequired,
  onLoseFocus: _propTypes2.default.func.isRequired
}, _temp);
exports.default = HighlightStory;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _Modal = __webpack_require__(823);

var _Modal2 = _interopRequireDefault(_Modal);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageHighlightStory = (_temp = _class = function (_Component) {
  _inherits(ImageHighlightStory, _Component);

  function ImageHighlightStory() {
    _classCallCheck(this, ImageHighlightStory);

    return _possibleConstructorReturn(this, (ImageHighlightStory.__proto__ || Object.getPrototypeOf(ImageHighlightStory)).apply(this, arguments));
  }

  _createClass(ImageHighlightStory, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          image = _props.image,
          isExpanded = _props.isExpanded,
          onCollapseClick = _props.onCollapseClick,
          onExpandClick = _props.onExpandClick,
          title = _props.title;


      return _react2.default.createElement(
        'div',
        {
          className: 'image-container',
          style: { backgroundImage: 'url(' + image.large + ')' }
        },
        _react2.default.createElement(
          'div',
          { className: 'insight-focus-modal' },
          _react2.default.createElement(
            _Modal2.default,
            {
              backdrop: false,
              header: _react2.default.createElement(
                'h4',
                { className: 'center' },
                title
              ),
              isOpen: isExpanded,
              onCloseClick: onCollapseClick
            },
            _react2.default.createElement('img', {
              className: 'modal-image insight-modal-content',
              src: image.extraLarge
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'story-expand-bar' },
          _react2.default.createElement(_Icon2.default, {
            name: 'fullscreen',
            className: 'right cursor',
            onClick: onExpandClick
          })
        )
      );
    }
  }]);

  return ImageHighlightStory;
}(_react.Component), _class.propTypes = {
  image: _propTypes2.default.object.isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  onCollapseClick: _propTypes2.default.func.isRequired,
  onExpandClick: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string
}, _temp);
exports.default = ImageHighlightStory;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _DocumentViewContainer = __webpack_require__(1204);

var _DocumentViewContainer2 = _interopRequireDefault(_DocumentViewContainer);

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _Modal = __webpack_require__(823);

var _Modal2 = _interopRequireDefault(_Modal);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DocumentHighlightStory = (_temp = _class = function (_Component) {
  _inherits(DocumentHighlightStory, _Component);

  function DocumentHighlightStory() {
    _classCallCheck(this, DocumentHighlightStory);

    return _possibleConstructorReturn(this, (DocumentHighlightStory.__proto__ || Object.getPrototypeOf(DocumentHighlightStory)).apply(this, arguments));
  }

  _createClass(DocumentHighlightStory, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isExpanded = _props.isExpanded,
          onCollapseClick = _props.onCollapseClick,
          onExpandClick = _props.onExpandClick,
          document = _props.document;

      var image = document.image || {};

      return _react2.default.createElement(
        'div',
        {
          className: 'image-container',
          style: { backgroundImage: 'url(' + image.large + ')' }
        },
        _react2.default.createElement(
          'div',
          { className: 'insight-focus-modal' },
          _react2.default.createElement(
            _Modal2.default,
            {
              backdrop: false,
              header: _react2.default.createElement(
                'h4',
                { className: 'center' },
                document.title
              ),
              isOpen: isExpanded,
              onCloseClick: onCollapseClick
            },
            document.boxViewStatus !== 'complete' && _react2.default.createElement('img', {
              className: 'modal-image insight-modal-content',
              src: image.extraLarge
            }),
            document.boxViewStatus === 'complete' && isExpanded && _react2.default.createElement(_DocumentViewContainer2.default, { document: document })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'story-expand-bar' },
          _react2.default.createElement(_Icon2.default, {
            name: 'fullscreen',
            className: 'right cursor',
            onClick: onExpandClick
          })
        )
      );
    }
  }]);

  return DocumentHighlightStory;
}(_react.Component), _class.propTypes = {
  document: _propTypes2.default.object.isRequired,
  isExpanded: _propTypes2.default.bool.isRequired,
  onCollapseClick: _propTypes2.default.func.isRequired,
  onExpandClick: _propTypes2.default.func.isRequired
}, _temp);
exports.default = DocumentHighlightStory;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _DocumentView = __webpack_require__(1205);

var _DocumentView2 = _interopRequireDefault(_DocumentView);

var _reactRedux = __webpack_require__(6);

var _documentActions = __webpack_require__(299);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DocumentViewContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, { fetchDocumentSessionIfNeeded: _documentActions.fetchDocumentSessionIfNeeded }, mergeProps), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  _inherits(DocumentViewContainer, _PureComponent);

  function DocumentViewContainer(props) {
    _classCallCheck(this, DocumentViewContainer);

    var _this = _possibleConstructorReturn(this, (DocumentViewContainer.__proto__ || Object.getPrototypeOf(DocumentViewContainer)).call(this, props));

    _this.handleNextPageClick = _this.handleNextPageClick.bind(_this);
    _this.handlePageFocus = _this.handlePageFocus.bind(_this);
    _this.handlePrevPageClick = _this.handlePrevPageClick.bind(_this);
    _this.handleReady = _this.handleReady.bind(_this);

    _this.state = {
      currentPage: 0,
      totalPages: 0
    };
    return _this;
  }

  _createClass(DocumentViewContainer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          company = _props.company,
          document = _props.document,
          fetchDocumentSessionIfNeeded = _props.fetchDocumentSessionIfNeeded;

      fetchDocumentSessionIfNeeded(company, document);
    }
  }, {
    key: 'handleNextPageClick',
    value: function handleNextPageClick() {
      var _state = this.state,
          currentPage = _state.currentPage,
          totalPages = _state.totalPages;


      if (currentPage < totalPages) {
        this.setState({ currentPage: currentPage + 1 });
      }
    }
  }, {
    key: 'handlePageFocus',
    value: function handlePageFocus(_ref) {
      var page = _ref.data.page;

      this.setState({ currentPage: page });
    }
  }, {
    key: 'handlePrevPageClick',
    value: function handlePrevPageClick() {
      var currentPage = this.state.currentPage;


      if (currentPage > 1) {
        this.setState({ currentPage: currentPage - 1 });
      }
    }
  }, {
    key: 'handleReady',
    value: function handleReady(_ref2) {
      var _ref2$data = _ref2.data,
          page = _ref2$data.page,
          numPages = _ref2$data.numPages;

      this.setState({
        currentPage: page,
        totalPages: numPages
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isFetching = _props2.isFetching,
          sessionId = _props2.sessionId;
      var _state2 = this.state,
          currentPage = _state2.currentPage,
          totalPages = _state2.totalPages;


      return _react2.default.createElement(_DocumentView2.default, {
        isFetching: isFetching,
        currentPage: currentPage,
        onNextPageClick: this.handleNextPageClick,
        onPageFocus: this.handlePageFocus,
        onPrevPageClick: this.handlePrevPageClick,
        onReady: this.handleReady,
        sessionId: sessionId,
        totalPages: totalPages
      });
    }
  }]);

  return DocumentViewContainer;
}(_react.PureComponent), _class2.propTypes = {
  company: _propTypes2.default.object.isRequired,
  document: _propTypes2.default.object.isRequired,
  fetchDocumentSessionIfNeeded: _propTypes2.default.func.isRequired,
  isFetching: _propTypes2.default.bool,
  sessionId: _propTypes2.default.string
}, _temp)) || _class);
exports.default = DocumentViewContainer;


function mergeProps(stateProps, dispatchProps, ownProps) {
  var company = stateProps.company,
      documentSessions = stateProps.documentSessions;
  var document = ownProps.document;

  var session = documentSessions[document.id] || {};

  return Object.assign({}, dispatchProps, {
    company: company,
    document: document,
    isFetching: session.isFetching || false,
    sessionId: session.sessionId
  });
}

function mapStateToProps(state) {
  return {
    company: state.company,
    documentSessions: state.documentSessions
  };
}

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _crocodoc = __webpack_require__(1206);

var _crocodoc2 = _interopRequireDefault(_crocodoc);

var _DocumentViewPaginator = __webpack_require__(1207);

var _DocumentViewPaginator2 = _interopRequireDefault(_DocumentViewPaginator);

var _Spinner = __webpack_require__(116);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _jquery = __webpack_require__(671);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DocumentView = (_temp = _class = function (_PureComponent) {
  _inherits(DocumentView, _PureComponent);

  function DocumentView(props) {
    _classCallCheck(this, DocumentView);

    var _this = _possibleConstructorReturn(this, (DocumentView.__proto__ || Object.getPrototypeOf(DocumentView)).call(this, props));

    _this.onPageLoad = _this.onPageLoad.bind(_this);
    _this.onReady = _this.onReady.bind(_this);

    _this.state = {
      viewerReady: false
    };
    return _this;
  }

  _createClass(DocumentView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var sessionId = this.props.sessionId;


      if (sessionId) {
        this.setupViewer(sessionId);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var currentPage = _ref.currentPage;

      if (this.props.currentPage !== currentPage && !this.scrolling) {
        this.viewer.scrollTo(currentPage);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var sessionId = this.props.sessionId;


      if (sessionId && !this.viewer) {
        this.setupViewer(sessionId);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.viewer.off('ready');
      this.viewer.off('pagefocus');
      this.viewer.off('pageload');
      this.viewer.off('scrollstart');
      this.viewer.off('scrollend');
      this.viewer.destroy();
    }
  }, {
    key: 'onPageLoad',
    value: function onPageLoad(_ref2) {
      var page = _ref2.data.page;

      var $page = (0, _jquery2.default)(this.el).find('.crocodoc-page:nth-child(' + page + ')');

      $page.find('span.tx span:not(.highlightLime)').contents().unwrap();
      $page.find('span.tx:not(.normalized)').each(function (index, elem) {
        elem.normalize();
        (0, _jquery2.default)(elem).addClass('normalized');
      });
    }
  }, {
    key: 'onReady',
    value: function onReady(event) {
      var page = this.el.getElementsByClassName('crocodoc-page')[0];

      this.el.style.height = page.style.height;
      this.setState({ viewerReady: true });
      this.props.onReady(event);
    }
  }, {
    key: 'setupViewer',
    value: function setupViewer(sessionId) {
      var _this2 = this;

      var onPageFocus = this.props.onPageFocus;


      this.viewer = _crocodoc2.default.createViewer(this.el, {
        url: 'https://view-api.box.com/1/sessions/' + sessionId + '/assets',
        zoom: _crocodoc2.default.ZOOM_FIT_WIDTH
      });

      this.viewer.load();
      this.viewer.on('ready', this.onReady);
      this.viewer.on('pagefocus', onPageFocus);
      this.viewer.on('pageload', this.onPageLoad);
      this.viewer.on('scrollstart', function () {
        return _this2.scrolling = true;
      });
      this.viewer.on('scrollend', function () {
        return _this2.scrolling = false;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          currentPage = _props.currentPage,
          isFetching = _props.isFetching,
          onNextPageClick = _props.onNextPageClick,
          onPrevPageClick = _props.onPrevPageClick,
          totalPages = _props.totalPages;
      var viewerReady = this.state.viewerReady;


      return _react2.default.createElement(
        'div',
        { className: 'box-viewer box-draw' },
        _react2.default.createElement(_Spinner2.default, { spinning: isFetching || !viewerReady }),
        _react2.default.createElement(_DocumentViewPaginator2.default, {
          currentPage: currentPage,
          totalPages: totalPages,
          onNextPageClick: onNextPageClick,
          onPrevPageClick: onPrevPageClick
        }),
        _react2.default.createElement('div', {
          ref: function ref(el) {
            _this3.el = el;
          },
          className: 'box-viewer-container',
          style: { minHeight: 600 }
        })
      );
    }
  }]);

  return DocumentView;
}(_react.PureComponent), _class.propTypes = {
  currentPage: _propTypes2.default.number.isRequired,
  isFetching: _propTypes2.default.bool.isRequired,
  onNextPageClick: _propTypes2.default.func.isRequired,
  onPageFocus: _propTypes2.default.func,
  onPrevPageClick: _propTypes2.default.func.isRequired,
  onReady: _propTypes2.default.func,
  sessionId: _propTypes2.default.string,
  totalPages: _propTypes2.default.number.isRequired
}, _temp);
exports.default = DocumentView;

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

module.exports = Crocodoc;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DocumentViewPaginator = (_temp = _class = function (_PureComponent) {
  _inherits(DocumentViewPaginator, _PureComponent);

  function DocumentViewPaginator() {
    _classCallCheck(this, DocumentViewPaginator);

    return _possibleConstructorReturn(this, (DocumentViewPaginator.__proto__ || Object.getPrototypeOf(DocumentViewPaginator)).apply(this, arguments));
  }

  _createClass(DocumentViewPaginator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentPage = _props.currentPage,
          totalPages = _props.totalPages,
          onNextPageClick = _props.onNextPageClick,
          onPrevPageClick = _props.onPrevPageClick;


      return _react2.default.createElement(
        'div',
        { className: 'box-view-paginator' },
        _react2.default.createElement(
          'a',
          { className: 'box-view-btn left', onClick: onPrevPageClick },
          _react2.default.createElement(_Icon2.default, { name: 'chevron-left' })
        ),
        _react2.default.createElement(
          'span',
          { className: 'paginator-pages' },
          currentPage || '-',
          ' / ',
          totalPages || '-'
        ),
        _react2.default.createElement(
          'a',
          { className: 'box-view-btn right', onClick: onNextPageClick },
          _react2.default.createElement(_Icon2.default, { name: 'chevron-right' })
        )
      );
    }
  }]);

  return DocumentViewPaginator;
}(_react.PureComponent), _class.propTypes = {
  currentPage: _propTypes2.default.number.isRequired,
  onNextPageClick: _propTypes2.default.func.isRequired,
  onPrevPageClick: _propTypes2.default.func.isRequired,
  totalPages: _propTypes2.default.number.isRequired
}, _temp);
exports.default = DocumentViewPaginator;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _Video = __webpack_require__(711);

var _Video2 = _interopRequireDefault(_Video);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlaylistHighlightStory = (_temp = _class = function (_Component) {
  _inherits(PlaylistHighlightStory, _Component);

  function PlaylistHighlightStory(props) {
    _classCallCheck(this, PlaylistHighlightStory);

    var _this = _possibleConstructorReturn(this, (PlaylistHighlightStory.__proto__ || Object.getPrototypeOf(PlaylistHighlightStory)).call(this, props));

    _this.handleEnded = _this.handleEnded.bind(_this);

    _this.state = {
      focusedClip: props.playlist.playlistClips[0]
    };
    return _this;
  }

  _createClass(PlaylistHighlightStory, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, _ref) {
      var focusedClip = _ref.focusedClip;

      if (focusedClip !== this.state.focusedClip && this.video) {
        this.video.currentTime(0);
        this.video.play();
      }
    }
  }, {
    key: 'isFinalized',
    value: function isFinalized() {
      var playlist = this.props.playlist;

      return playlist.publishVideo && !playlist.publishDirtyFl;
    }
  }, {
    key: 'handleEnded',
    value: function handleEnded() {
      var _props = this.props,
          onEnded = _props.onEnded,
          playlist = _props.playlist;
      var focusedClip = this.state.focusedClip;
      var playlistClips = playlist.playlistClips;

      var clipIndex = playlistClips.indexOf(focusedClip);

      if (this.isFinalized()) {
        onEnded();
      } else if (clipIndex === playlistClips.length - 1) {
        onEnded();
        this.setState({ focusedClip: playlistClips[0] });
      } else {
        this.setState({ focusedClip: playlistClips[clipIndex + 1] });
      }
    }
  }, {
    key: 'getSrc',
    value: function getSrc() {
      var playlist = this.props.playlist;
      var focusedClip = this.state.focusedClip;


      if (this.isFinalized()) {
        return playlist.publishVideo.src;
      }

      return focusedClip.video.src;
    }
  }, {
    key: 'getPlugins',
    value: function getPlugins() {
      var focusedClip = this.state.focusedClip;


      if (this.isFinalized()) {
        return {};
      }

      return {
        clip: {
          startTime: focusedClip.startTime,
          endTime: focusedClip.endTime,
          restrictPlaybackToClip: true
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          isPlaying = _props2.isPlaying,
          onPlay = _props2.onPlay,
          playlist = _props2.playlist;


      return _react2.default.createElement(
        'div',
        { className: 'insight-story-ng-controller' },
        !isPlaying && _react2.default.createElement(
          'div',
          {
            className: 'image-container',
            style: { backgroundImage: 'url(' + playlist.image.large + ')' },
            onClick: onPlay
          },
          _react2.default.createElement(_Icon2.default, { name: 'play' })
        ),
        isPlaying && playlist.playlistClips.length > 0 && _react2.default.createElement(_Video2.default, {
          ref: function ref(video) {
            _this2.video = video;
          },
          src: this.getSrc(),
          height: '100%',
          listeners: { ended: this.handleEnded },
          options: { autoplay: true },
          plugins: this.getPlugins(),
          controlBar: { volumeControl: false }
        })
      );
    }
  }]);

  return PlaylistHighlightStory;
}(_react.Component), _class.propTypes = {
  isPlaying: _propTypes2.default.bool.isRequired,
  onEnded: _propTypes2.default.func.isRequired,
  onPlay: _propTypes2.default.func.isRequired,
  playlist: _propTypes2.default.object.isRequired
}, _temp);
exports.default = PlaylistHighlightStory;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextHighlightStory = (_temp = _class = function (_PureComponent) {
  _inherits(TextHighlightStory, _PureComponent);

  function TextHighlightStory() {
    _classCallCheck(this, TextHighlightStory);

    return _possibleConstructorReturn(this, (TextHighlightStory.__proto__ || Object.getPrototypeOf(TextHighlightStory)).apply(this, arguments));
  }

  _createClass(TextHighlightStory, [{
    key: 'render',
    value: function render() {
      var text = this.props.text;


      return _react2.default.createElement(
        'div',
        { className: 'text-container' },
        _react2.default.createElement(
          'div',
          { className: 'text-response' },
          text
        )
      );
    }
  }]);

  return TextHighlightStory;
}(_react.PureComponent), _class.propTypes = {
  text: _propTypes2.default.string
}, _temp);
exports.default = TextHighlightStory;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _Video = __webpack_require__(711);

var _Video2 = _interopRequireDefault(_Video);

var _findEnglishVideo = __webpack_require__(897);

var _findEnglishVideo2 = _interopRequireDefault(_findEnglishVideo);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoResponseHighlightStory = (_temp = _class = function (_Component) {
  _inherits(VideoResponseHighlightStory, _Component);

  function VideoResponseHighlightStory() {
    _classCallCheck(this, VideoResponseHighlightStory);

    return _possibleConstructorReturn(this, (VideoResponseHighlightStory.__proto__ || Object.getPrototypeOf(VideoResponseHighlightStory)).apply(this, arguments));
  }

  _createClass(VideoResponseHighlightStory, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isPlaying = _props.isPlaying,
          onEnded = _props.onEnded,
          onPlay = _props.onPlay,
          videoResponse = _props.videoResponse;
      var languages = videoResponse.languages,
          image = videoResponse.image;

      var video = (0, _findEnglishVideo2.default)(languages) || videoResponse.video;

      return _react2.default.createElement(
        'div',
        { className: 'insight-story-ng-controller' },
        !isPlaying && _react2.default.createElement(
          'div',
          {
            className: 'image-container',
            style: { backgroundImage: 'url(' + image.large + ')' },
            onClick: onPlay
          },
          _react2.default.createElement(_Icon2.default, { name: 'play' })
        ),
        isPlaying && _react2.default.createElement(_Video2.default, {
          src: video.src,
          height: '100%',
          listeners: { ended: onEnded },
          options: {
            autoplay: true,
            languages: languages
          },
          controlBar: {
            languageMenu: {},
            volumeControl: false
          }
        })
      );
    }
  }]);

  return VideoResponseHighlightStory;
}(_react.Component), _class.propTypes = {
  isPlaying: _propTypes2.default.bool.isRequired,
  onEnded: _propTypes2.default.func.isRequired,
  onPlay: _propTypes2.default.func.isRequired,
  videoResponse: _propTypes2.default.object.isRequired
}, _temp);
exports.default = VideoResponseHighlightStory;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _Video = __webpack_require__(711);

var _Video2 = _interopRequireDefault(_Video);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkspaceVideoClipHighlightStory = (_temp = _class = function (_Component) {
  _inherits(WorkspaceVideoClipHighlightStory, _Component);

  function WorkspaceVideoClipHighlightStory() {
    _classCallCheck(this, WorkspaceVideoClipHighlightStory);

    return _possibleConstructorReturn(this, (WorkspaceVideoClipHighlightStory.__proto__ || Object.getPrototypeOf(WorkspaceVideoClipHighlightStory)).apply(this, arguments));
  }

  _createClass(WorkspaceVideoClipHighlightStory, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isPlaying = _props.isPlaying,
          onEnded = _props.onEnded,
          onPlay = _props.onPlay,
          workspaceVideoClip = _props.workspaceVideoClip;
      var image = workspaceVideoClip.image;
      var src = workspaceVideoClip.video.src;


      return _react2.default.createElement(
        'div',
        { className: 'insight-story-ng-controller' },
        !isPlaying && _react2.default.createElement(
          'div',
          {
            className: 'image-container',
            style: { backgroundImage: 'url(' + image.large + ')' },
            onClick: onPlay
          },
          _react2.default.createElement(_Icon2.default, { name: 'play' })
        ),
        isPlaying && _react2.default.createElement(_Video2.default, {
          src: src,
          height: '100%',
          listeners: { ended: onEnded },
          options: { autoplay: true },
          plugins: {
            clip: {
              startTime: workspaceVideoClip.startTime,
              endTime: workspaceVideoClip.endTime,
              restrictPlaybackToClip: true
            }
          },
          controlBar: { volumeControl: false }
        })
      );
    }
  }]);

  return WorkspaceVideoClipHighlightStory;
}(_react.Component), _class.propTypes = {
  isPlaying: _propTypes2.default.bool.isRequired,
  onEnded: _propTypes2.default.func.isRequired,
  onPlay: _propTypes2.default.func.isRequired,
  workspaceVideoClip: _propTypes2.default.object.isRequired
}, _temp);
exports.default = WorkspaceVideoClipHighlightStory;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(257),
    baseIteratee = __webpack_require__(672),
    baseMap = __webpack_require__(906),
    isArray = __webpack_require__(17);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _DescriptionList = __webpack_require__(987);

var _DescriptionList2 = _interopRequireDefault(_DescriptionList);

var _sortBy = __webpack_require__(836);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MetaTagList = (_temp = _class = function (_Component) {
  _inherits(MetaTagList, _Component);

  function MetaTagList() {
    _classCallCheck(this, MetaTagList);

    return _possibleConstructorReturn(this, (MetaTagList.__proto__ || Object.getPrototypeOf(MetaTagList)).apply(this, arguments));
  }

  _createClass(MetaTagList, [{
    key: 'formatMetaTags',
    value: function formatMetaTags() {
      var metaTags = this.props.metaTags;

      var ancestryPaths = metaTags.map(function (metaTag) {
        return metaTag.ancestryPath;
      });
      ancestryPaths = (0, _sortBy2.default)(ancestryPaths, function (ancestryPath) {
        return ancestryPath[0].toLowerCase();
      });

      return ancestryPaths.reduce(function (memo, ancestryPath) {
        memo[ancestryPath[0]] = memo[ancestryPath[0]] || [];
        memo[ancestryPath[0]].push(ancestryPath[1]);
        return memo;
      }, {});
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_DescriptionList2.default, { listItems: this.formatMetaTags() });
    }
  }]);

  return MetaTagList;
}(_react.Component), _class.propTypes = {
  metaTags: _propTypes2.default.array.isRequired
}, _temp);
exports.default = MetaTagList;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _DateDisplay = __webpack_require__(669);

var _DateDisplay2 = _interopRequireDefault(_DateDisplay);

var _KeywordHighlight = __webpack_require__(362);

var _KeywordHighlight2 = _interopRequireDefault(_KeywordHighlight);

var _User = __webpack_require__(955);

var _User2 = _interopRequireDefault(_User);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayInfo = (_temp = _class = function (_PureComponent) {
  _inherits(OverlayInfo, _PureComponent);

  function OverlayInfo() {
    _classCallCheck(this, OverlayInfo);

    return _possibleConstructorReturn(this, (OverlayInfo.__proto__ || Object.getPrototypeOf(OverlayInfo)).apply(this, arguments));
  }

  _createClass(OverlayInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          date = _props.date,
          searchHighlights = _props.searchHighlights,
          title = _props.title,
          user = _props.user,
          verb = _props.verb;

      var tokens = searchHighlights.reduce(function (memo, highlight) {
        return memo.concat(highlight.tokens);
      }, []);

      return _react2.default.createElement(
        'div',
        { style: { marginBottom: 10 } },
        _react2.default.createElement(
          'h6',
          null,
          _react2.default.createElement(_KeywordHighlight2.default, { text: title, tokens: tokens })
        ),
        _react2.default.createElement(
          'div',
          { className: 'layout-overlay-aside' },
          _react2.default.createElement(
            'span',
            null,
            I18n.t(verb),
            ' '
          ),
          user && _react2.default.createElement(_User2.default, { user: user, format: _User.FIRST_LAST_INITIAL }),
          _react2.default.createElement(
            'span',
            null,
            ' ',
            I18n.t('on'),
            ' '
          ),
          _react2.default.createElement(_DateDisplay2.default, { date: date, format: _DateDisplay.SHORT_DATE })
        )
      );
    }
  }]);

  return OverlayInfo;
}(_react.PureComponent), _class.propTypes = {
  date: _propTypes2.default.string,
  searchHighlights: _propTypes2.default.array,
  title: _propTypes2.default.string,
  user: _propTypes2.default.object,
  verb: _propTypes2.default.string
}, _class.defaultProps = {
  searchHighlights: [],
  verb: 'Created By'
}, _temp);
exports.default = OverlayInfo;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Tag = __webpack_require__(1216);

var _Tag2 = _interopRequireDefault(_Tag);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tags = (_temp = _class = function (_Component) {
  _inherits(Tags, _Component);

  function Tags() {
    _classCallCheck(this, Tags);

    return _possibleConstructorReturn(this, (Tags.__proto__ || Object.getPrototypeOf(Tags)).apply(this, arguments));
  }

  _createClass(Tags, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          emptyMessage = _props.emptyMessage,
          searchHighlights = _props.searchHighlights,
          tags = _props.tags;


      if (tags.length === 0) {
        return _react2.default.createElement(
          'span',
          { className: 'grey-reg-i' },
          I18n.t(emptyMessage)
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'clearfix tags-display' },
        tags.map(function (tag) {
          return _react2.default.createElement(_Tag2.default, {
            key: tag.id,
            name: tag.name,
            searchHighlights: searchHighlights
          });
        })
      );
    }
  }]);

  return Tags;
}(_react.Component), _class.propTypes = {
  emptyMessage: _propTypes2.default.string,
  searchHighlights: _propTypes2.default.array,
  tags: _propTypes2.default.array.isRequired
}, _class.defaultProps = {
  emptyMessage: 'No tags to display',
  searchHighlights: []
}, _temp);
exports.default = Tags;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _KeywordHighlight = __webpack_require__(362);

var _KeywordHighlight2 = _interopRequireDefault(_KeywordHighlight);

var _SearchTokenize = __webpack_require__(712);

var _SearchTokenize2 = _interopRequireDefault(_SearchTokenize);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tag = (0, _SearchTokenize2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(Tag, _Component);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
  }

  _createClass(Tag, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          tokens = _props.tokens;


      return _react2.default.createElement(
        'div',
        { className: 'tag' },
        _react2.default.createElement(_KeywordHighlight2.default, { text: name, tokens: tokens })
      );
    }
  }]);

  return Tag;
}(_react.Component), _class2.propTypes = {
  name: _propTypes2.default.string.isRequired,
  tokens: _propTypes2.default.array
}, _temp)) || _class;

exports.default = Tag;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _sortBy = __webpack_require__(836);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayWorkspaceList = (_temp = _class = function (_Component) {
  _inherits(OverlayWorkspaceList, _Component);

  function OverlayWorkspaceList() {
    _classCallCheck(this, OverlayWorkspaceList);

    return _possibleConstructorReturn(this, (OverlayWorkspaceList.__proto__ || Object.getPrototypeOf(OverlayWorkspaceList)).apply(this, arguments));
  }

  _createClass(OverlayWorkspaceList, [{
    key: 'renderWorkspace',
    value: function renderWorkspace(workspace) {
      return _react2.default.createElement(
        'div',
        { className: 'clear-both workspace-container', key: workspace.id },
        _react2.default.createElement(
          'a',
          {
            href: Tru.Utils.buildBaseURL('workspaces/' + workspace.id),
            className: 'title'
          },
          workspace.name
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var workspaces = this.props.workspaces;

      workspaces = (0, _sortBy2.default)(workspaces, function (workspace) {
        return workspace.name.toLowerCase();
      });

      if (workspaces.length === 0) {
        return _react2.default.createElement(
          'span',
          { className: 'grey-reg-i' },
          I18n.t('No workspaces to display')
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        workspaces.map(this.renderWorkspace)
      );
    }
  }]);

  return OverlayWorkspaceList;
}(_react.Component), _class.propTypes = {
  workspaces: _propTypes2.default.array.isRequired
}, _temp);
exports.default = OverlayWorkspaceList;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _appConstants = __webpack_require__(38);

var _Button = __webpack_require__(81);

var _Button2 = _interopRequireDefault(_Button);

var _Spinner = __webpack_require__(116);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _sortBy = __webpack_require__(836);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function workspaceMatchesName(workspace, name) {
  return workspace.name.toLowerCase().indexOf(name.toLowerCase()) > -1;
}

var WorkspaceSelector = (_temp = _class = function (_Component) {
  _inherits(WorkspaceSelector, _Component);

  function WorkspaceSelector(props) {
    _classCallCheck(this, WorkspaceSelector);

    var _this = _possibleConstructorReturn(this, (WorkspaceSelector.__proto__ || Object.getPrototypeOf(WorkspaceSelector)).call(this, props));

    _this.onKeyUp = _this.onKeyUp.bind(_this);
    return _this;
  }

  _createClass(WorkspaceSelector, [{
    key: 'onKeyUp',
    value: function onKeyUp(e) {
      var onSaveClick = this.props.onSaveClick;

      if (e.which === _appConstants.KeyCodes.ENTER) {
        onSaveClick();
      }
    }
  }, {
    key: 'renderWorkspace',
    value: function renderWorkspace(workspace) {
      var _props = this.props,
          onChangeSelectedWorkspace = _props.onChangeSelectedWorkspace,
          selectedWorkspaceName = _props.selectedWorkspaceName;


      if (!workspaceMatchesName(workspace, selectedWorkspaceName)) {
        return null;
      }

      return _react2.default.createElement(
        'li',
        {
          className: 'workspace-selector-li',
          onClick: function onClick() {
            return onChangeSelectedWorkspace(workspace.name);
          },
          key: workspace.id
        },
        workspace.name
      );
    }
  }, {
    key: 'renderPopup',
    value: function renderPopup() {
      var _props2 = this.props,
          isFetching = _props2.isFetching,
          onChangeSelectedWorkspace = _props2.onChangeSelectedWorkspace,
          onSaveClick = _props2.onSaveClick,
          selectedWorkspaceName = _props2.selectedWorkspaceName;
      var workspaces = this.props.workspaces;

      workspaces = (0, _sortBy2.default)(workspaces, function (workspace) {
        return workspace.name.toLowerCase();
      });

      return _react2.default.createElement(
        'div',
        { className: 'popup-box' },
        _react2.default.createElement(_Spinner2.default, { spinning: isFetching }),
        _react2.default.createElement(
          'div',
          { className: 'create-workspace' },
          _react2.default.createElement('input', {
            type: 'text',
            placeholder: 'Select or Create Workspace',
            value: selectedWorkspaceName,
            onChange: function onChange(e) {
              return onChangeSelectedWorkspace(e.target.value);
            },
            onKeyUp: this.onKeyUp
          }),
          _react2.default.createElement(
            _Button2.default,
            { className: 'add-workspace-button', onClick: onSaveClick },
            I18n.t('Add')
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'workspace-selector-ul' },
          workspaces.map(this.renderWorkspace, this)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          isOpen = _props3.isOpen,
          onLinkClick = _props3.onLinkClick;


      return _react2.default.createElement(
        'div',
        {
          className: 'workspace-selector-container',
          onClick: function onClick(e) {
            return e.nativeEvent.stopImmediatePropagation();
          }
        },
        _react2.default.createElement(
          'span',
          { onClick: onLinkClick },
          children
        ),
        isOpen && this.renderPopup()
      );
    }
  }]);

  return WorkspaceSelector;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  isFetching: _propTypes2.default.bool.isRequired,
  isOpen: _propTypes2.default.bool.isRequired,
  onChangeSelectedWorkspace: _propTypes2.default.func.isRequired,
  onLinkClick: _propTypes2.default.func.isRequired,
  onSaveClick: _propTypes2.default.func.isRequired,
  selectedWorkspaceName: _propTypes2.default.string,
  workspaces: _propTypes2.default.array.isRequired
}, _temp);
exports.default = WorkspaceSelector;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(1220);

var convert = function() {
   return new Converter();
}

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   }
});

module.exports = convert;

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

/* MIT license */

module.exports = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
}


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(1222);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/,
       hex =  /^#([a-fA-F0-9]{6})$/,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/,
       keyword = /(\D+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),
/* 1223 */,
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _OverlayImageTabs = __webpack_require__(992);

var _OverlayImageTabs2 = _interopRequireDefault(_OverlayImageTabs);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageClipMain = (_temp = _class = function (_Component) {
  _inherits(ImageClipMain, _Component);

  function ImageClipMain() {
    _classCallCheck(this, ImageClipMain);

    return _possibleConstructorReturn(this, (ImageClipMain.__proto__ || Object.getPrototypeOf(ImageClipMain)).apply(this, arguments));
  }

  _createClass(ImageClipMain, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          clip = _props.clip,
          searchHighlights = _props.searchHighlights;

      var description = clip.description || '';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', { src: clip.image.large }),
        _react2.default.createElement(_OverlayImageTabs2.default, {
          searchHighlights: searchHighlights,
          description: description.trim()
        })
      );
    }
  }]);

  return ImageClipMain;
}(_react.Component), _class.propTypes = {
  clip: _propTypes2.default.object.isRequired,
  searchHighlights: _propTypes2.default.array
}, _temp);
exports.default = ImageClipMain;

/***/ }),
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _OverlayImageTabs = __webpack_require__(992);

var _OverlayImageTabs2 = _interopRequireDefault(_OverlayImageTabs);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageResponseMain = (_temp = _class = function (_Component) {
  _inherits(ImageResponseMain, _Component);

  function ImageResponseMain() {
    _classCallCheck(this, ImageResponseMain);

    return _possibleConstructorReturn(this, (ImageResponseMain.__proto__ || Object.getPrototypeOf(ImageResponseMain)).apply(this, arguments));
  }

  _createClass(ImageResponseMain, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          response = _props.response,
          searchHighlights = _props.searchHighlights;

      var commentTxt = response.commentTxt || '';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('img', { src: response.image.large }),
        _react2.default.createElement(_OverlayImageTabs2.default, {
          searchHighlights: searchHighlights,
          description: commentTxt.trim()
        })
      );
    }
  }]);

  return ImageResponseMain;
}(_react.Component), _class.propTypes = {
  response: _propTypes2.default.object.isRequired,
  searchHighlights: _propTypes2.default.array
}, _temp);
exports.default = ImageResponseMain;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = expandableTable;

var _RowExpander = __webpack_require__(994);

var _RowExpander2 = _interopRequireDefault(_RowExpander);

var _TableColumn = __webpack_require__(229);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _getDisplayName = __webpack_require__(688);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _shallowEqual = __webpack_require__(620);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function expandableTable(dataGetter, expandableRenderer, _ref) {
  var trackBy = _ref.trackBy;

  function toggleRow(collection, row, index, expanded) {
    var key = row[trackBy] || index;

    return Object.assign({}, collection, _defineProperty({}, key, expanded));
  }

  function toggleAll(data, expanded) {
    return data.reduce(function (memo, row, index) {
      return toggleRow(memo, row, index, expanded);
    }, {});
  }

  return function decorateComponent(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      _inherits(ExpandableTable, _React$Component);

      function ExpandableTable(props) {
        _classCallCheck(this, ExpandableTable);

        var _this = _possibleConstructorReturn(this, (ExpandableTable.__proto__ || Object.getPrototypeOf(ExpandableTable)).call(this, props));

        _this.handleExpand = _this.handleExpand.bind(_this);
        _this.handleExpandAll = _this.handleExpandAll.bind(_this);
        _this.renderExpand = _this.renderExpand.bind(_this);
        _this.renderExpandHeader = _this.renderExpandHeader.bind(_this);
        _this.renderExpandableTable = _this.renderExpandableTable.bind(_this);
        _this.renderRow = _this.renderRow.bind(_this);

        _this.state = {
          allExpanded: false,
          expandedRows: {}
        };
        return _this;
      }

      _createClass(ExpandableTable, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
          return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
        }
      }, {
        key: 'getExpandableColumn',
        value: function getExpandableColumn() {
          return _react2.default.createElement(_TableColumn2.default, {
            cellRenderer: this.renderExpand,
            key: 'expandableColumn',
            dataKey: 'expandableTableExpanded',
            headerRenderer: this.renderExpandHeader,
            label: '',
            width: 15
          });
        }
      }, {
        key: 'handleExpand',
        value: function handleExpand(rowData, index) {
          var expandedRows = this.state.expandedRows;

          var key = rowData[trackBy] || index;
          var expanded = expandedRows[key];

          this.setState({
            expandedRows: toggleRow(expandedRows, rowData, index, !expanded)
          });
        }
      }, {
        key: 'handleExpandAll',
        value: function handleExpandAll() {
          var allExpanded = this.state.allExpanded;


          this.setState({
            allExpanded: !allExpanded,
            expandedRows: toggleAll(dataGetter(this.props), !allExpanded)
          });
        }
      }, {
        key: 'rowIsExpanded',
        value: function rowIsExpanded(rowData, index) {
          var key = rowData[trackBy] || index;
          return this.state.expandedRows[key];
        }
      }, {
        key: 'renderExpand',
        value: function renderExpand(_, rowData, dataKey, index) {
          var _this2 = this;

          return _react2.default.createElement(_RowExpander2.default, {
            expanded: this.rowIsExpanded(rowData, index),
            onClick: function onClick() {
              return _this2.handleExpand(rowData, index);
            }
          });
        }
      }, {
        key: 'renderExpandHeader',
        value: function renderExpandHeader() {
          var allExpanded = this.state.allExpanded;


          return _react2.default.createElement(_RowExpander2.default, { expanded: allExpanded, onClick: this.handleExpandAll });
        }
      }, {
        key: 'renderRow',
        value: function renderRow(rowData, rowSchema, index) {
          return _react2.default.createElement(
            'tbody',
            { key: index },
            rowSchema,
            this.rowIsExpanded(rowData, index) && expandableRenderer(rowData, this.props)
          );
        }
      }, {
        key: 'renderExpandableTable',
        value: function renderExpandableTable(Table) {
          return (0, _react.cloneElement)(Table, {
            striped: false,
            rowRenderer: this.renderRow,
            wrapInTbody: false,
            className: 'table-expandable'
          }, [this.getExpandableColumn()].concat(_toConsumableArray(_react2.default.Children.toArray(Table.props.children))));
        }
      }, {
        key: 'render',
        value: function render() {
          var expandedRows = this.state.expandedRows;


          return _react2.default.createElement(Component, Object.assign({
            connectExpandableColumn: this.renderExpandableTable,
            expandedRows: expandedRows
          }, this.props));
        }
      }]);

      return ExpandableTable;
    }(_react2.default.Component), _class.displayName = 'ExpandableTable(' + (0, _getDisplayName2.default)(Component) + ')', _temp;
  };
}

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _ReportOverlay = __webpack_require__(1236);

var _ReportOverlay2 = _interopRequireDefault(_ReportOverlay);

var _Spinner = __webpack_require__(116);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _selectList = __webpack_require__(622);

var _selectList2 = _interopRequireDefault(_selectList);

var _selectEntity = __webpack_require__(228);

var _selectEntity2 = _interopRequireDefault(_selectEntity);

var _reactRedux = __webpack_require__(6);

var _reportActions = __webpack_require__(161);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportOverlayContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, { addReportToWorkspace: _reportActions.addReportToWorkspace, fetchReport: _reportActions.fetchReport }, mergeProps), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReportOverlayContainer, _Component);

  function ReportOverlayContainer() {
    _classCallCheck(this, ReportOverlayContainer);

    return _possibleConstructorReturn(this, (ReportOverlayContainer.__proto__ || Object.getPrototypeOf(ReportOverlayContainer)).apply(this, arguments));
  }

  _createClass(ReportOverlayContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          company = _props.company,
          fetchReport = _props.fetchReport,
          report = _props.report;

      fetchReport(company, report.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          addReportToWorkspace = _props2.addReportToWorkspace,
          company = _props2.company,
          isFetching = _props2.isFetching,
          permissions = _props2.permissions,
          report = _props2.report,
          searchHighlights = _props2.searchHighlights,
          tags = _props2.tags,
          workspaces = _props2.workspaces;


      if (isFetching) {
        return _react2.default.createElement(_Spinner2.default, { spinning: true, style: { top: 200 } });
      }

      return _react2.default.createElement(_ReportOverlay2.default, {
        onAddToWorkspace: function onAddToWorkspace(workspace) {
          return addReportToWorkspace(company, report, workspace);
        },
        permissions: permissions,
        report: report,
        searchHighlights: searchHighlights,
        tags: tags,
        workspaces: workspaces
      });
    }
  }]);

  return ReportOverlayContainer;
}(_react.Component), _class2.propTypes = {
  addReportToWorkspace: _propTypes2.default.func.isRequired,
  company: _propTypes2.default.object.isRequired,
  fetchReport: _propTypes2.default.func.isRequired,
  isFetching: _propTypes2.default.bool.isRequired,
  permissions: _propTypes2.default.object,
  report: _propTypes2.default.object.isRequired,
  searchHighlights: _propTypes2.default.array,
  tags: _propTypes2.default.array.isRequired,
  workspaces: _propTypes2.default.array.isRequired
}, _temp)) || _class);
exports.default = ReportOverlayContainer;


function mergeProps(stateProps, dispatchProps, ownProps) {
  var reportId = ownProps.reportId,
      searchHighlights = ownProps.searchHighlights;
  var company = stateProps.company,
      isFetching = stateProps.isFetching,
      entities = stateProps.entities,
      permissions = stateProps.permissions;

  var report = (0, _selectEntity2.default)(entities.reports, reportId);
  var workspaces = (0, _selectList2.default)(entities.workspaces, report.workspaces);
  var tags = (0, _selectList2.default)(entities.tags, report.tags);

  return Object.assign({}, dispatchProps, {
    company: company,
    isFetching: isFetching,
    permissions: permissions,
    report: report,
    searchHighlights: searchHighlights,
    tags: tags,
    workspaces: workspaces
  });
}

function mapStateToProps(state) {
  return {
    company: state.company,
    isFetching: state.reports.isFetching,
    entities: state.entities,
    permissions: state.permissions
  };
}

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _AlertListContainer = __webpack_require__(375);

var _AlertListContainer2 = _interopRequireDefault(_AlertListContainer);

var _OverlayAboutTile = __webpack_require__(858);

var _OverlayAboutTile2 = _interopRequireDefault(_OverlayAboutTile);

var _OverlayColumn = __webpack_require__(860);

var _OverlayColumn2 = _interopRequireDefault(_OverlayColumn);

var _OverlayTagTile = __webpack_require__(861);

var _OverlayTagTile2 = _interopRequireDefault(_OverlayTagTile);

var _OverlayTile = __webpack_require__(682);

var _OverlayTile2 = _interopRequireDefault(_OverlayTile);

var _OverlayTileColumn = __webpack_require__(862);

var _OverlayTileColumn2 = _interopRequireDefault(_OverlayTileColumn);

var _OverlayTileHeading = __webpack_require__(683);

var _OverlayTileHeading2 = _interopRequireDefault(_OverlayTileHeading);

var _OverlayTileOptionLink = __webpack_require__(863);

var _OverlayTileOptionLink2 = _interopRequireDefault(_OverlayTileOptionLink);

var _OverlayWorkspaceTile = __webpack_require__(907);

var _OverlayWorkspaceTile2 = _interopRequireDefault(_OverlayWorkspaceTile);

var _PermissionGuard = __webpack_require__(633);

var _PermissionGuard2 = _interopRequireDefault(_PermissionGuard);

var _RichText = __webpack_require__(954);

var _RichText2 = _interopRequireDefault(_RichText);

var _ShareLinkPopover = __webpack_require__(864);

var _ShareLinkPopover2 = _interopRequireDefault(_ShareLinkPopover);

var _WorkspaceSelectorContainer = __webpack_require__(838);

var _WorkspaceSelectorContainer2 = _interopRequireDefault(_WorkspaceSelectorContainer);

var _selectSearchHighlights = __webpack_require__(713);

var _selectSearchHighlights2 = _interopRequireDefault(_selectSearchHighlights);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportOverlay = (_temp = _class = function (_Component) {
  _inherits(ReportOverlay, _Component);

  function ReportOverlay() {
    _classCallCheck(this, ReportOverlay);

    return _possibleConstructorReturn(this, (ReportOverlay.__proto__ || Object.getPrototypeOf(ReportOverlay)).apply(this, arguments));
  }

  _createClass(ReportOverlay, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onAddToWorkspace = _props.onAddToWorkspace,
          permissions = _props.permissions,
          report = _props.report,
          searchHighlights = _props.searchHighlights,
          tags = _props.tags,
          workspaces = _props.workspaces;


      return _react2.default.createElement(
        'div',
        { className: 'view-display' },
        _react2.default.createElement(_AlertListContainer2.default, { clearOnUnmount: true }),
        _react2.default.createElement(
          _OverlayTile2.default,
          null,
          _react2.default.createElement('iframe', {
            className: 'iframe-contain',
            src: report.shareUrl + '?iframe=true',
            frameBorder: 0
          })
        ),
        _react2.default.createElement(
          _OverlayColumn2.default,
          { align: 'left' },
          _react2.default.createElement(
            'div',
            { className: 'editor-tab-bar' },
            _react2.default.createElement(
              'div',
              { className: 'tab-item selected' },
              I18n.t('Project Background')
            )
          ),
          _react2.default.createElement(
            _OverlayTile2.default,
            null,
            _react2.default.createElement(_RichText2.default, {
              searchHighlights: (0, _selectSearchHighlights2.default)(searchHighlights, 'projectObjectives'),
              text: report.objectives
            })
          )
        ),
        _react2.default.createElement(
          _OverlayColumn2.default,
          { align: 'right' },
          _react2.default.createElement(
            _OverlayTile2.default,
            { className: 'clearfix' },
            _react2.default.createElement(_OverlayTileHeading2.default, { icon: 'settings', title: 'Options' }),
            _react2.default.createElement(
              _OverlayTileColumn2.default,
              { align: 'left' },
              _react2.default.createElement(
                _PermissionGuard2.default,
                {
                  permissions: permissions,
                  object: 'workspace',
                  operation: 'edit'
                },
                _react2.default.createElement(
                  _WorkspaceSelectorContainer2.default,
                  { onAddToWorkspace: onAddToWorkspace },
                  _react2.default.createElement(_OverlayTileOptionLink2.default, {
                    icon: 'file-add',
                    title: 'Add to Workspace'
                  })
                )
              ),
              _react2.default.createElement(
                _ShareLinkPopover2.default,
                { tip: report.shareUrl },
                _react2.default.createElement(_OverlayTileOptionLink2.default, { title: 'Share', icon: 'share' })
              )
            )
          ),
          _react2.default.createElement(_OverlayAboutTile2.default, {
            date: report.insertDt,
            details: {
              'Project Name': report.projectName,
              Description: report.description,
              'Number of pages': report.pageCount
            },
            heading: 'About this Report',
            searchHighlights: (0, _selectSearchHighlights2.default)(searchHighlights, 'title'),
            title: report.reportTitle,
            verb: 'Created'
          }),
          _react2.default.createElement(_OverlayWorkspaceTile2.default, { workspaces: workspaces }),
          _react2.default.createElement(_OverlayTagTile2.default, {
            searchHighlights: (0, _selectSearchHighlights2.default)(searchHighlights, 'tagNames'),
            tags: tags
          })
        )
      );
    }
  }]);

  return ReportOverlay;
}(_react.Component), _class.propTypes = {
  onAddToWorkspace: _propTypes2.default.func.isRequired,
  permissions: _propTypes2.default.object.isRequired,
  report: _propTypes2.default.object.isRequired,
  searchHighlights: _propTypes2.default.array,
  tags: _propTypes2.default.array.isRequired,
  workspaces: _propTypes2.default.array.isRequired
}, _temp);
exports.default = ReportOverlay;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _SelectedTranscriptHighlight = __webpack_require__(1238);

var _SelectedTranscriptHighlight2 = _interopRequireDefault(_SelectedTranscriptHighlight);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextClipMain = (_temp = _class = function (_Component) {
  _inherits(TextClipMain, _Component);

  function TextClipMain() {
    _classCallCheck(this, TextClipMain);

    return _possibleConstructorReturn(this, (TextClipMain.__proto__ || Object.getPrototypeOf(TextClipMain)).apply(this, arguments));
  }

  _createClass(TextClipMain, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          clip = _props.clip,
          searchHighlights = _props.searchHighlights;


      return _react2.default.createElement(_SelectedTranscriptHighlight2.default, {
        transcript: clip.transcript,
        startOffset: clip.startWordIndex,
        endOffset: clip.endWordIndex,
        searchHighlights: searchHighlights
      });
    }
  }]);

  return TextClipMain;
}(_react.Component), _class.propTypes = {
  clip: _propTypes2.default.object.isRequired,
  searchHighlights: _propTypes2.default.array
}, _temp);
exports.default = TextClipMain;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _KeywordHighlight = __webpack_require__(362);

var _KeywordHighlight2 = _interopRequireDefault(_KeywordHighlight);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = __webpack_require__(46);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectedTranscriptHighlight = (_temp = _class = function (_Component) {
  _inherits(SelectedTranscriptHighlight, _Component);

  function SelectedTranscriptHighlight() {
    _classCallCheck(this, SelectedTranscriptHighlight);

    return _possibleConstructorReturn(this, (SelectedTranscriptHighlight.__proto__ || Object.getPrototypeOf(SelectedTranscriptHighlight)).apply(this, arguments));
  }

  _createClass(SelectedTranscriptHighlight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToSelection();
    }
  }, {
    key: 'scrollToSelection',
    value: function scrollToSelection() {
      var node = (0, _reactDom.findDOMNode)(this);
      node.scrollTop = this.quoteSelection.offsetTop - node.offsetTop;
    }
  }, {
    key: 'highlightText',
    value: function highlightText(text) {
      var tokens = this.props.searchHighlights.reduce(function (memo, highlight) {
        return memo.concat(highlight.tokens);
      }, []);

      return _react2.default.createElement(_KeywordHighlight2.default, { text: text, tokens: tokens });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          endOffset = _props.endOffset,
          hasTimestamps = _props.hasTimestamps,
          startOffset = _props.startOffset,
          transcript = _props.transcript;

      var slicePoint = endOffset === 0 ? 0 : endOffset + 1;

      var hasTimestampsClass = (0, _classnames2.default)({
        'grey-reg-i': hasTimestamps
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          this.highlightText(transcript.slice(0, startOffset))
        ),
        _react2.default.createElement(
          'span',
          {
            ref: function ref(quoteSelection) {
              return _this2.quoteSelection = quoteSelection;
            },
            className: 'qv-quote-selection'
          },
          this.highlightText(transcript.slice(startOffset, slicePoint))
        ),
        _react2.default.createElement(
          'span',
          { className: hasTimestampsClass },
          this.highlightText(transcript.slice(slicePoint))
        )
      );
    }
  }]);

  return SelectedTranscriptHighlight;
}(_react.Component), _class.propTypes = {
  endOffset: _propTypes2.default.number,
  hasTimestamps: _propTypes2.default.bool,
  searchHighlights: _propTypes2.default.array,
  startOffset: _propTypes2.default.number,
  transcript: _propTypes2.default.string
}, _class.defaultProps = {
  hasTimestamps: false,
  searchHighlights: []
}, _temp);
exports.default = SelectedTranscriptHighlight;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _KeywordHighlight = __webpack_require__(362);

var _KeywordHighlight2 = _interopRequireDefault(_KeywordHighlight);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextResponseMain = (_temp = _class = function (_Component) {
  _inherits(TextResponseMain, _Component);

  function TextResponseMain() {
    _classCallCheck(this, TextResponseMain);

    return _possibleConstructorReturn(this, (TextResponseMain.__proto__ || Object.getPrototypeOf(TextResponseMain)).apply(this, arguments));
  }

  _createClass(TextResponseMain, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          response = _props.response,
          searchHighlights = _props.searchHighlights;

      var commentTxt = response.commentTxt || '';
      var tokens = searchHighlights.reduce(function (memo, highlight) {
        return memo.concat(highlight.tokens);
      }, []);

      return _react2.default.createElement(_KeywordHighlight2.default, { text: commentTxt.trim(), tokens: tokens });
    }
  }]);

  return TextResponseMain;
}(_react.Component), _class.propTypes = {
  response: _propTypes2.default.object.isRequired,
  searchHighlights: _propTypes2.default.array
}, _class.defaultProps = {
  searchHighlights: []
}, _temp);
exports.default = TextResponseMain;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TextSelection = __webpack_require__(1241);

var _TextSelection2 = _interopRequireDefault(_TextSelection);

var _Label = __webpack_require__(996);

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TranscriptSelection = (_temp2 = _class = function (_Component) {
  _inherits(TranscriptSelection, _Component);

  function TranscriptSelection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TranscriptSelection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TranscriptSelection.__proto__ || Object.getPrototypeOf(TranscriptSelection)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelection = function (_ref2) {
      var startElement = _ref2.startElement,
          endElement = _ref2.endElement,
          collapsed = _ref2.collapsed,
          rest = _objectWithoutProperties(_ref2, ['startElement', 'endElement', 'collapsed']);

      var onSelect = _this.props.onSelect;

      var startTime = collapsed ? 0 : _this.findTimeOfElement(startElement);
      var endTime = collapsed ? 0 : _this.findTimeOfElement(endElement);
      onSelect(Object.assign({ startTime: startTime, endTime: endTime, collapsed: collapsed }, rest));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TranscriptSelection, [{
    key: 'findTimeOfElement',
    value: function findTimeOfElement(element) {
      return parseFloat(element.parentElement.getAttribute('data'));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          endTime = _props.endTime,
          startTime = _props.startTime,
          timestamps = _props.timestamps,
          transcript = _props.transcript,
          rest = _objectWithoutProperties(_props, ['disabled', 'endTime', 'startTime', 'timestamps', 'transcript']);

      if (disabled) {
        return _react2.default.createElement(
          'span',
          null,
          transcript
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        this.props.transcriptType === 'machine' && transcript !== '' && _react2.default.createElement(_Label2.default, {
          type: 'default',
          text: I18n.t("You're viewing a free machine transcription. You may edit it to improve accuracy.")
          // Commenting out the original verbiage that includes requesting a human transcript, to be restored when a provider is re-added.
          // text={ I18n.t("You're viewing a free machine transcription. For greater accuracy, you can edit or request a human transcript.") }
        }),
        _react2.default.createElement(_TextSelection2.default, Object.assign({}, rest, {
          startTime: startTime,
          endTime: endTime,
          text: transcript,
          onSelect: this.handleSelection,
          snapToWords: true,
          timestamps: timestamps
        }))
      );
    }
  }]);

  return TranscriptSelection;
}(_react.Component), _class.propTypes = {
  disabled: _propTypes2.default.bool.isRequired,
  endTime: _propTypes2.default.number.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  startTime: _propTypes2.default.number.isRequired,
  timestamps: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
  transcript: _propTypes2.default.string.isRequired,
  transcriptType: _propTypes2.default.string.isRequired
}, _class.defaultProps = {
  disabled: false,
  endTime: 0,
  startTime: 0,
  timestamps: [],
  transcript: '',
  transcriptType: ''
}, _temp2);
exports.default = TranscriptSelection;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _noop = __webpack_require__(88);

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rangy = __webpack_require__(995);

var _rangy2 = _interopRequireDefault(_rangy);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _range = __webpack_require__(1242);

var _TranscriptView = __webpack_require__(913);

var _TranscriptView2 = _interopRequireDefault(_TranscriptView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextSelection = (_temp2 = _class = function (_Component) {
  _inherits(TextSelection, _Component);

  function TextSelection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextSelection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextSelection.__proto__ || Object.getPrototypeOf(TextSelection)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseDown = function () {
      var _this$props = _this.props,
          startTime = _this$props.startTime,
          endTime = _this$props.endTime,
          onSelect = _this$props.onSelect;


      if (startTime === endTime) {
        return;
      }

      (0, _range.getRangeAt)(0).collapse();

      onSelect({ collapsed: true });
    }, _this.handleMouseUp = function () {
      var onSelect = _this.props.onSelect;

      var range = (0, _range.getRangeAt)(0);

      var startElement = range.startContainer.parentElement;
      var endElement = range.endContainer.parentElement;

      if (!_this.isChild(startElement) || !_this.isChild(endElement)) {
        return;
      }

      onSelect({
        collapsed: range.collapsed,
        startElement: startElement,
        endElement: endElement
      });

      _this.removeSelection();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextSelection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _rangy2.default.init();
    }
  }, {
    key: 'removeSelection',
    value: function removeSelection() {
      var sel = window.getSelection ? window.getSelection() : document.selection;
      if (sel) {
        if (sel.removeAllRanges) {
          sel.removeAllRanges();
        } else if (sel.empty) {
          sel.empty();
        }
      }
    }
  }, {
    key: 'isChild',
    value: function isChild(element) {
      var parent = element.parentNode;

      if (!parent) {
        return false;
      }

      if (parent === document.getElementById('transcript-view-container')) {
        return true;
      }

      return this.isChild(parent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          endTime = _props.endTime,
          selectionClassName = _props.selectionClassName,
          startTime = _props.startTime,
          text = _props.text,
          timestamps = _props.timestamps;


      return _react2.default.createElement(
        'div',
        { id: 'transcript-view-container' },
        _react2.default.createElement(_TranscriptView2.default, {
          text: text,
          timestamps: timestamps,
          selectionClassName: selectionClassName,
          selectionStartTime: startTime,
          selectionEndTime: endTime,
          componentClassName: 'transcript-viewer transcript-viewer-no-max-height',
          onMouseUp: this.handleMouseUp,
          onMouseDown: this.handleMouseDown
        })
      );
    }
  }]);

  return TextSelection;
}(_react.Component), _class.propTypes = {
  endTime: _propTypes2.default.number.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  selectionClassName: _propTypes2.default.string,
  selectionStyle: _propTypes2.default.object,
  snapToWords: _propTypes2.default.bool.isRequired,
  startTime: _propTypes2.default.number.isRequired,
  text: _propTypes2.default.string.isRequired,
  timestamps: _propTypes2.default.array
}, _class.defaultProps = {
  endTime: 0,
  onSelect: _noop2.default,
  snapToWords: false,
  startTime: 0,
  text: ''
}, _temp2);
exports.default = TextSelection;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRangeAt = exports.nodeContainsRange = exports.endOffsetFromRange = exports.startOffsetFromRange = undefined;

var _rangy = __webpack_require__(995);

var _rangy2 = _interopRequireDefault(_rangy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var offsetFromRange = function offsetFromRange(property, calculateOffset) {
  return function (text, range) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { snapToWords: false },
        snapToWords = _ref.snapToWords;

    if (range.collapsed) {
      return 0;
    }

    if (snapToWords) {
      return calculateOffset(text, range[property]);
    }

    return range[property];
  };
};

var startOffsetFromRange = exports.startOffsetFromRange = offsetFromRange('startOffset', function (text, offset) {
  return text.lastIndexOf(' ', offset) + 1;
});

var endOffsetFromRange = exports.endOffsetFromRange = offsetFromRange('endOffset', function (text, offset) {
  return text.indexOf(' ', Math.max(offset - 1, 0));
});

var nodeContainsRange = exports.nodeContainsRange = function nodeContainsRange(node, range) {
  return node.contains(range.startContainer) && node.contains(range.endContainer);
};

var getRangeAt = exports.getRangeAt = function getRangeAt(idx) {
  return _rangy2.default.getSelection().getRangeAt(idx);
};

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeClass = function timeClass(_ref) {
  var selectionClassName = _ref.selectionClassName,
      highlightSpace = _ref.highlightSpace,
      highlighted = _ref.highlighted,
      isSelected = _ref.isSelected;

  var classes = [];

  if (isSelected) {
    classes.push(selectionClassName);
  }

  if (highlightSpace) {
    classes.push('highlight');
  }

  if (!isSelected && !highlighted) {
    classes.push('word-time');
  }

  return classes.join(' ');
};

var TranscriptWord = function TranscriptWord(_ref2) {
  var highlighted = _ref2.highlighted,
      highlightSpace = _ref2.highlightSpace,
      isSelected = _ref2.isSelected,
      timestamp = _ref2.timestamp,
      word = _ref2.word,
      selectionClassName = _ref2.selectionClassName;
  return _react2.default.createElement(
    'time',
    {
      data: timestamp,
      className: timeClass({
        selectionClassName: selectionClassName,
        highlightSpace: highlightSpace,
        highlighted: highlighted,
        isSelected: isSelected
      })
    },
    ['.', '!', '?'].includes(word) ? '' : ' ',
    word.startsWith('\n') && _react2.default.createElement('br', null),
    _react2.default.createElement(
      'span',
      { className: highlighted && !highlightSpace ? 'highlight' : '' },
      word.trim()
    )
  );
};

TranscriptWord.propTypes = {
  highlighted: _propTypes2.default.bool,
  highlightSpace: _propTypes2.default.bool,
  isSelected: _propTypes2.default.bool,
  selectionClassName: _propTypes2.default.string,
  timestamp: _propTypes2.default.number,
  word: _propTypes2.default.string
};

exports.default = TranscriptWord;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _SelectedTranscriptDisplay = __webpack_require__(1245);

var _SelectedTranscriptDisplay2 = _interopRequireDefault(_SelectedTranscriptDisplay);

var _VideoClipPlayer = __webpack_require__(1146);

var _VideoClipPlayer2 = _interopRequireDefault(_VideoClipPlayer);

var _TabList = __webpack_require__(684);

var _TabList2 = _interopRequireDefault(_TabList);

var _TabPanel = __webpack_require__(674);

var _TabPanel2 = _interopRequireDefault(_TabPanel);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollOnTimeUpdate = __webpack_require__(962);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoClipMain = (_temp = _class = function (_Component) {
  _inherits(VideoClipMain, _Component);

  function VideoClipMain(props) {
    _classCallCheck(this, VideoClipMain);

    var _this = _possibleConstructorReturn(this, (VideoClipMain.__proto__ || Object.getPrototypeOf(VideoClipMain)).call(this, props));

    _this.toggleTranscript = _this.toggleTranscript.bind(_this);

    _this.state = {
      showTranscript: true
    };
    return _this;
  }

  _createClass(VideoClipMain, [{
    key: 'toggleTranscript',
    value: function toggleTranscript() {
      var showTranscript = this.state.showTranscript;

      this.setState({ showTranscript: !showTranscript });
    }
  }, {
    key: 'getTranscript',
    value: function getTranscript() {
      var _props = this.props,
          clip = _props.clip,
          searchHighlights = _props.searchHighlights;
      var showTranscript = this.state.showTranscript;

      var transcript = void 0;

      if (clip.video.timestampRequestStatus !== 'processing') {
        transcript = clip.transcript;
      }

      if (!transcript) {
        return _react2.default.createElement(
          'span',
          { className: 'grey-reg-i' },
          I18n.t('No transcript provided')
        );
      }

      if (showTranscript) {
        return [_react2.default.createElement(
          'a',
          { key: 'transcriptLink', onClick: this.toggleTranscript },
          I18n.t('Hide Transcript')
        ), _react2.default.createElement(_SelectedTranscriptDisplay2.default, {
          videoTranscript: clip.videoTranscript,
          startTime: clip.startTime,
          endTime: clip.endTime,
          key: clip.id,
          searchHighlights: searchHighlights
        })];
      } else {
        return _react2.default.createElement(
          'a',
          { onClick: this.toggleTranscript },
          I18n.t('Show Transcript')
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          clip = _props2.clip,
          playerId = _props2.playerId;
      var video = clip.video;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_VideoClipPlayer2.default, {
          id: playerId,
          src: video.src,
          captionSource: video.captionUrl,
          languages: clip.languages,
          startTime: clip.startTime,
          endTime: clip.endTime,
          width: 'auto',
          height: 480,
          restrictPlaybackToClip: clip.restrictPlaybackToClip,
          listeners: {
            timeupdate: function timeupdate(e) {
              return clip.videoTranscript && (0, _scrollOnTimeUpdate.scrollOnTimeUpdateWithFeatures)(e, clip.videoTranscript.jsonTimestamps);
            }
          }
        }),
        clip.restrictPlaybackToClip || _react2.default.createElement(
          _TabList2.default,
          null,
          _react2.default.createElement(
            _TabPanel2.default,
            { title: 'Transcript' },
            this.getTranscript()
          )
        )
      );
    }
  }]);

  return VideoClipMain;
}(_react.Component), _class.propTypes = {
  clip: _propTypes2.default.object.isRequired,
  playerId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  searchHighlights: _propTypes2.default.array
}, _temp);
exports.default = VideoClipMain;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _i18n = __webpack_require__(90);

var _i18n2 = _interopRequireDefault(_i18n);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TranscriptView = __webpack_require__(913);

var _TranscriptView2 = _interopRequireDefault(_TranscriptView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectedTranscriptDisplay = (_temp = _class = function (_Component) {
  _inherits(SelectedTranscriptDisplay, _Component);

  function SelectedTranscriptDisplay() {
    _classCallCheck(this, SelectedTranscriptDisplay);

    return _possibleConstructorReturn(this, (SelectedTranscriptDisplay.__proto__ || Object.getPrototypeOf(SelectedTranscriptDisplay)).apply(this, arguments));
  }

  _createClass(SelectedTranscriptDisplay, [{
    key: 'getTranscript',
    value: function getTranscript() {
      return this.props.videoTranscript.transcript || _i18n2.default.t('No transcript provided');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          startTime = _props.startTime,
          endTime = _props.endTime,
          jsonTimestamps = _props.videoTranscript.jsonTimestamps,
          searchHighlights = _props.searchHighlights;

      return _react2.default.createElement(_TranscriptView2.default, {
        text: this.getTranscript(),
        timestamps: jsonTimestamps,
        tokens: searchHighlights,
        selectionStartTime: startTime,
        selectionEndTime: endTime
      });
    }
  }]);

  return SelectedTranscriptDisplay;
}(_react.Component), _class.propTypes = {
  endTime: _propTypes2.default.number.isRequired,
  searchHighlights: _propTypes2.default.array,
  startTime: _propTypes2.default.number.isRequired,
  videoTranscript: _propTypes2.default.object.isRequired
}, _temp);
exports.default = SelectedTranscriptDisplay;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.squint=e():t.squint=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=0)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=(e.scrollIntoView=function(t,e,n){var i=o(t,e,n||{});return"number"==typeof i&&r(e,i,n.duration||500),t},e.findScrollTo=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!s(t)||!s(e))return!1;if(!e.contains(t))return!1;var o=t.getBoundingClientRect(),r=o.top,f=o.bottom,c=e.getBoundingClientRect(),l=i(c,n.offset),a=u(c,n.offset),p=r+e.scrollTop-c.top;if(r<l){return p+(c.top-l)}if(f>a){return p-e.clientHeight+t.offsetHeight+(c.bottom-a)}return!1}),r=e.animateScrolling=function(t,e,n){var o=(t.scrollTop-e)/2,r=0,i=performance.now(),u=function u(f){if((r+=Math.PI/(n/(f-i)))>=Math.PI)return void(t.scrollTop=e);var c=o+o*Math.cos(r);t.scrollTop=e+c,i=f,window.requestAnimationFrame(u)};window.requestAnimationFrame(u)},i=e.offsetTop=function(t,e){return f(t,"top",e)},u=e.offsetBottom=function(t,e){return f(t,"bottom",e,-1)},f=e.offsetBoundary=function(t,e,n){var o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;return n?"number"==typeof n||"%"!==n.slice(-1)?t[e]+parseInt(n)*o:c(t,e,parseInt(n.slice(0,-1))*o):t[e]},c=e.adjustByPercent=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,o=t.height*n/100;return t[e]+o},s=e.isDOMRect=function(t){return t&&"function"==typeof t.getBoundingClientRect}}])});

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _TabList = __webpack_require__(684);

var _TabList2 = _interopRequireDefault(_TabList);

var _TabPanel = __webpack_require__(674);

var _TabPanel2 = _interopRequireDefault(_TabPanel);

var _MarksList = __webpack_require__(1147);

var _MarksList2 = _interopRequireDefault(_MarksList);

var _VideoContainer = __webpack_require__(997);

var _VideoContainer2 = _interopRequireDefault(_VideoContainer);

var _findEnglishVideo = __webpack_require__(897);

var _findEnglishVideo2 = _interopRequireDefault(_findEnglishVideo);

var _humps = __webpack_require__(22);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TranscriptView = __webpack_require__(913);

var _TranscriptView2 = _interopRequireDefault(_TranscriptView);

var _scrollOnTimeUpdate = __webpack_require__(962);

var _markActions = __webpack_require__(1148);

var _reactRedux = __webpack_require__(6);

var _Button = __webpack_require__(81);

var _Button2 = _interopRequireDefault(_Button);

var _MarkRow = __webpack_require__(963);

var _MarkRow2 = _interopRequireDefault(_MarkRow);

var _MarkAlert = __webpack_require__(1251);

var _MarkAlert2 = _interopRequireDefault(_MarkAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoResponseMain = (_temp = _class = function (_Component) {
  _inherits(VideoResponseMain, _Component);

  function VideoResponseMain(props) {
    _classCallCheck(this, VideoResponseMain);

    var _this = _possibleConstructorReturn(this, (VideoResponseMain.__proto__ || Object.getPrototypeOf(VideoResponseMain)).call(this, props));

    _this.handleMarkUpdate = function (mark) {
      var marks = _this.state.marks;


      if (mark.text.trim()) {
        var index = marks.findIndex(function (m) {
          return m.id === mark.id;
        });

        return _this.props.updateMark(mark).then(function () {
          return _this.setState(function (state) {
            return {
              marks: [].concat(_toConsumableArray(state.marks.slice(0, index)), [mark], _toConsumableArray(state.marks.slice(index + 1))),
              showError: false
            };
          });
        });
      }
      _this.setState({ showError: true });
    };

    _this.handleMarkDelete = function (mark) {
      var marks = _this.state.marks;


      return _this.props.removeMark(mark.id).then(function () {
        return _this.setState({ marks: marks.filter(function (_mark) {
            return _mark.id !== mark.id;
          }) });
      });
    };

    _this.handleMarkAdd = function () {
      _this.setState({ addMarkRow: true });
    };

    _this.cancelMark = function () {
      _this.setState({ addMarkRow: false, showError: false });
    };

    _this.handleNewMarkSave = function (mark) {
      var marks = _this.state.marks;
      var responseId = _this.props.response.id;


      if (mark.text.trim()) {
        return _this.props.addMark(Object.assign({}, mark, { responseId: responseId })).then(function (_ref) {
          var data = _ref.data;
          return _this.setState({
            addMarkRow: false,
            marks: [].concat(_toConsumableArray(marks), [{
              id: parseInt(data.id, 0),
              text: data.attributes.text,
              secondsAfterStart: data.attributes.seconds_after_start
            }])
          });
        });
      }
      _this.setState({ showError: true });
    };

    _this.handleAlertClose = function () {
      _this.setState({ showError: false });
    };

    _this.toggleTranscript = _this.toggleTranscript.bind(_this);

    _this.state = {
      showTranscript: true,
      marks: _this.props.response.responseComments,
      addMarkRow: false,
      showError: false
    };
    return _this;
  }

  _createClass(VideoResponseMain, [{
    key: 'toggleTranscript',
    value: function toggleTranscript() {
      var showTranscript = this.state.showTranscript;

      this.setState({ showTranscript: !showTranscript });
    }
  }, {
    key: 'getTranscript',
    value: function getTranscript() {
      var _props = this.props,
          response = _props.response,
          searchHighlights = _props.searchHighlights;
      var showTranscript = this.state.showTranscript;

      var transcript = void 0;
      var timestamps = void 0;

      if (response.timestampRequestStatus !== 'processing') {
        transcript = response.transcript;
        var videoTranscript = response.video.videoTranscript || {};
        timestamps = videoTranscript.jsonTimestamps || [];
      }

      if (!transcript) {
        return _react2.default.createElement(
          'span',
          { className: 'grey-reg-i' },
          I18n.t('No transcript provided')
        );
      }

      if (showTranscript) {
        return [_react2.default.createElement(
          'a',
          { key: 'transcriptLink', onClick: this.toggleTranscript },
          I18n.t('Hide Transcript')
        ), _react2.default.createElement(
          'div',
          { key: 'transcript' },
          _react2.default.createElement(_TranscriptView2.default, {
            tokens: searchHighlights || [],
            text: transcript.trim(),
            timestamps: timestamps || []
          })
        )];
      }

      return _react2.default.createElement(
        'a',
        { onClick: this.toggleTranscript },
        I18n.t('Show Transcript')
      );
    }
  }, {
    key: 'handleMarkClick',
    value: function handleMarkClick(mark) {
      this.video.currentTime(mark.secondsAfterStart);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          addMarkRow = _state.addMarkRow,
          showError = _state.showError;
      var _props2 = this.props,
          response = _props2.response,
          playerId = _props2.playerId;
      var marks = this.state.marks;

      var video = (0, _findEnglishVideo2.default)(response.languages) || response.video;

      var _ref2 = video.videoTranscript || {},
          _ref2$jsonTimestamps = _ref2.jsonTimestamps,
          jsonTimestamps = _ref2$jsonTimestamps === undefined ? [] : _ref2$jsonTimestamps;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_VideoContainer2.default, {
          ref: function ref(_ref3) {
            _this2.video = _ref3 ? _ref3.getWrappedInstance().getVideo() : null;
          },
          id: playerId,
          src: video.src,
          width: 'auto',
          height: 480,
          options: { languages: (0, _humps.decamelizeKeys)(response.languages) },
          controlBar: { languageMenu: {} },
          closedCaption: true,
          captionSource: video.captionUrl,
          listeners: {
            timeupdate: function timeupdate(e) {
              return (0, _scrollOnTimeUpdate.scrollOnTimeUpdateWithFeatures)(e, jsonTimestamps);
            }
          }
        }),
        _react2.default.createElement(
          _TabList2.default,
          null,
          _react2.default.createElement(
            _TabPanel2.default,
            { title: 'Transcript' },
            this.getTranscript()
          ),
          _react2.default.createElement(
            _TabPanel2.default,
            { title: 'Marks' },
            _react2.default.createElement(
              _Button2.default,
              {
                className: 'qv-button qv-button-create qv-button-small marginBottom10',
                onClick: this.handleMarkAdd
              },
              _react2.default.createElement('i', { className: 'im-icon-tags' }),
              'Add'
            ),
            _react2.default.createElement(
              'div',
              { className: 'marks-viewer' },
              showError && _react2.default.createElement(_MarkAlert2.default, {
                message: 'Mark Name: This is a mandatory field, can\'t be blank',
                onCloseAlert: this.handleAlertClose
              }),
              addMarkRow && _react2.default.createElement(_MarkRow2.default, {
                handleClick: this.handleMarkClick,
                onSave: this.handleNewMarkSave,
                videoLength: response.video.length,
                onCancel: this.cancelMark,
                mark: {
                  secondsAfterStart: this.video.currentTime(),
                  text: ''
                }
              }),
              _react2.default.createElement(_MarksList2.default, {
                marks: marks,
                handleMarkClick: function handleMarkClick(c) {
                  return _this2.handleMarkClick(c);
                },
                onMarkSave: this.handleMarkUpdate,
                onMarkDelete: this.handleMarkDelete,
                videoLength: response.video.length
              })
            )
          )
        )
      );
    }
  }]);

  return VideoResponseMain;
}(_react.Component), _class.defaultProps = {
  scrollDuration: 300
}, _class.propTypes = {
  addMark: _propTypes2.default.func,
  playerId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  removeMark: _propTypes2.default.func,
  response: _propTypes2.default.object.isRequired,
  scrollDuration: _propTypes2.default.number,
  searchHighlights: _propTypes2.default.array,
  updateMark: _propTypes2.default.func
}, _temp);
exports.default = (0, _reactRedux.connect)(null, { addMark: _markActions.addMark, updateMark: _markActions.updateMark, removeMark: _markActions.removeMark })(VideoResponseMain);

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatTime = function formatTime(timeInSeconds) {
  var seconds = Math.floor(timeInSeconds) % 60;
  var minutes = Math.floor(timeInSeconds / 60);

  return minutes + ':' + formatNumAsTwoDigits(seconds);
};

var formatNumAsTwoDigits = function formatNumAsTwoDigits(n) {
  return ('0' + n).slice(-2);
};

function MarkDetails(_ref) {
  var handleClick = _ref.handleClick,
      mark = _ref.mark,
      onDelete = _ref.onDelete,
      onEditClick = _ref.onEditClick;

  return _react2.default.createElement(
    'li',
    { className: 'vi-marks clearfix' },
    _react2.default.createElement(
      'div',
      { className: 'vi-mark-detail', onClick: function onClick() {
          return handleClick(mark);
        } },
      _react2.default.createElement(
        'h6',
        null,
        mark.text
      ),
      _react2.default.createElement(
        'p',
        null,
        formatTime(mark.secondsAfterStart)
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'vi-actions' },
      _react2.default.createElement(_Icon2.default, { name: 'edit', onClick: function onClick() {
          return onEditClick();
        } }),
      _react2.default.createElement(_Icon2.default, { name: 'delete', onClick: function onClick() {
          return onDelete(mark);
        } })
    )
  );
}

MarkDetails.propTypes = {
  handleClick: _propTypes2.default.func.isRequired,
  mark: _propTypes2.default.object,
  onDelete: _propTypes2.default.func.isRequired,
  onEditClick: _propTypes2.default.func.isRequired
};

exports.default = MarkDetails;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TimestampInput = __webpack_require__(1250);

var _TimestampInput2 = _interopRequireDefault(_TimestampInput);

var _Button = __webpack_require__(81);

var _Button2 = _interopRequireDefault(_Button);

var _SaveButton = __webpack_require__(699);

var _SaveButton2 = _interopRequireDefault(_SaveButton);

var _appConstants = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarkForm = (_temp = _class = function (_Component) {
  _inherits(MarkForm, _Component);

  function MarkForm(props) {
    _classCallCheck(this, MarkForm);

    var _this = _possibleConstructorReturn(this, (MarkForm.__proto__ || Object.getPrototypeOf(MarkForm)).call(this, props));

    _this.handleTextChange = function (e) {
      _this.setState({ text: e.target.value });
    };

    _this.handleSubmit = function (e) {
      if (e.keyCode === _appConstants.KeyCodes.ENTER) {
        e.preventDefault();
        _this.submit();
      }
    };

    _this.submit = function () {
      return _this.props.onSave(Object.assign({}, _this.props.mark, {
        secondsAfterStart: _this.state.time,
        text: _this.state.text
      }));
    };

    _this.state = {
      time: props.mark.secondsAfterStart,
      text: props.mark.text
    };
    return _this;
  }

  _createClass(MarkForm, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          time = _state.time,
          text = _state.text;
      var _props = this.props,
          mark = _props.mark,
          onCancelClick = _props.onCancelClick,
          onSave = _props.onSave,
          videoLength = _props.videoLength;


      return _react2.default.createElement(
        'li',
        { className: 'vi-marks' },
        _react2.default.createElement('input', {
          type: 'text',
          value: text,
          onChange: this.handleTextChange,
          onKeyDown: this.handleSubmit
        }),
        _react2.default.createElement(_TimestampInput2.default, {
          max: videoLength,
          onChange: function onChange(time) {
            return _this2.setState({ time: time });
          },
          time: time
        }),
        _react2.default.createElement(
          'div',
          { className: 'vi-buttons' },
          _react2.default.createElement(_SaveButton2.default, { size: 'small', onClick: this.submit }),
          _react2.default.createElement(
            _Button2.default,
            { role: 'default', size: 'small', onClick: onCancelClick },
            I18n.t('Cancel')
          )
        )
      );
    }
  }]);

  return MarkForm;
}(_react.Component), _class.propTypes = {
  isAddingMark: _propTypes2.default.bool,
  mark: _propTypes2.default.object,
  onCancelClick: _propTypes2.default.func.isRequired,
  onSave: _propTypes2.default.func.isRequired,
  videoLength: _propTypes2.default.number.isRequired
}, _temp);
exports.default = MarkForm;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; /* global Qualvu */


var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _appConstants = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TAB = _appConstants.KeyCodes.TAB,
    LEFT = _appConstants.KeyCodes.LEFT,
    RIGHT = _appConstants.KeyCodes.RIGHT,
    UP = _appConstants.KeyCodes.UP,
    DOWN = _appConstants.KeyCodes.DOWN;
var TimestampInput = (_temp2 = _class = function (_Component) {
  _inherits(TimestampInput, _Component);

  function TimestampInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimestampInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimestampInput.__proto__ || Object.getPrototypeOf(TimestampInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectionEnd: 0,
      selectionStart: 0
    }, _this.handleClick = function () {
      _this.selectRangeAtCursorPosition(_this.input.selectionStart);
    }, _this.handleKeyDown = function (e) {
      var selectionStart = _this.input.selectionStart;


      if (e.ctrlKey || e.metaKey || e.keyCode === TAB) {
        return;
      }

      e.preventDefault();

      switch (e.keyCode) {
        case LEFT:
          _this.selectRangeAtCursorPosition(selectionStart - 3);
          break;
        case RIGHT:
          _this.selectRangeAtCursorPosition(selectionStart + 3);
          break;
        case UP:
          _this.incrementTimeAtCursorPosition(selectionStart);
          break;
        case DOWN:
          _this.decrementTimeAtCursorPosition(selectionStart);
          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimestampInput, [{
    key: 'incrementTimeAtCursorPosition',
    value: function incrementTimeAtCursorPosition(cursorPosition) {
      var _props = this.props,
          max = _props.max,
          onChange = _props.onChange,
          time = _props.time;

      var newTime = Math.min(max, time + this.secondsAtCursorPosition(cursorPosition));

      if (newTime !== time) {
        onChange(newTime);
      }
    }
  }, {
    key: 'decrementTimeAtCursorPosition',
    value: function decrementTimeAtCursorPosition(cursorPosition) {
      var _props2 = this.props,
          onChange = _props2.onChange,
          time = _props2.time;

      var newTime = Math.max(0, time - this.secondsAtCursorPosition(cursorPosition));

      if (newTime !== time) {
        onChange(newTime);
      }
    }
  }, {
    key: 'selectRangeAtCursorPosition',
    value: function selectRangeAtCursorPosition(cursorPosition) {
      if (cursorPosition < 3) {
        this.selectRange(0, 2);
      } else if (cursorPosition < 6) {
        this.selectRange(3, 5);
      } else if (cursorPosition < 9) {
        this.selectRange(6, 8);
      } else {
        this.selectRange(9, 11);
      }
    }
  }, {
    key: 'selectRange',
    value: function selectRange(selectionStart, selectionEnd) {
      this.setState({ selectionStart: selectionStart, selectionEnd: selectionEnd });
    }
  }, {
    key: 'secondsAtCursorPosition',
    value: function secondsAtCursorPosition(cursorPosition) {
      if (cursorPosition < 3) {
        return 3600; // hours
      } else if (cursorPosition < 6) {
        return 60; // minutes
      } else if (cursorPosition < 9) {
        return 1; // seconds
      }

      return 0.01; // milliseconds
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _state = this.state,
          selectionStart = _state.selectionStart,
          selectionEnd = _state.selectionEnd;


      this.input.setSelectionRange(selectionStart, selectionEnd);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var time = this.props.time;


      return _react2.default.createElement('input', {
        type: 'text',
        ref: function ref(input) {
          _this2.input = input;
        },
        value: Qualvu.Util.formatTimeFromSeconds(time),
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        readOnly: true
      });
    }
  }]);

  return TimestampInput;
}(_react.Component), _class.propTypes = {
  max: _propTypes2.default.number.isRequired, // in seconds
  onChange: _propTypes2.default.func.isRequired,
  time: _propTypes2.default.number.isRequired // in seconds
}, _class.defaultProps = {
  max: 0,
  time: 0
}, _temp2);
exports.default = TimestampInput;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarkAlert = (_temp2 = _class = function (_Component) {
  _inherits(MarkAlert, _Component);

  function MarkAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MarkAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarkAlert.__proto__ || Object.getPrototypeOf(MarkAlert)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseClick = function () {
      _this.props.onCloseAlert();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MarkAlert, [{
    key: 'render',
    value: function render() {
      var message = this.props.message;


      return _react2.default.createElement(
        'div',
        { className: 'alert alert-danger' },
        _react2.default.createElement(
          'button',
          { className: 'close', onClick: this.handleCloseClick },
          '\xD7'
        ),
        _react2.default.createElement(
          'span',
          null,
          message
        )
      );
    }
  }]);

  return MarkAlert;
}(_react.Component), _class.propTypes = {
  message: _propTypes2.default.string,
  onCloseAlert: _propTypes2.default.func
}, _temp2);
exports.default = MarkAlert;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _renderComponent = __webpack_require__(623);

var _renderComponent2 = _interopRequireDefault(_renderComponent);

var _withTheme = __webpack_require__(1253);

var _withTheme2 = _interopRequireDefault(_withTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderWithTheme = function renderWithTheme(Component) {
  return (0, _renderComponent2.default)((0, _withTheme2.default)(Component));
};

exports.default = renderWithTheme;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _emotionTheming = __webpack_require__(668);

var _normalizeTheme = __webpack_require__(957);

var _normalizeTheme2 = _interopRequireDefault(_normalizeTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function (Component) {
  return function (_ref) {
    var theme = _ref.theme,
        rest = _objectWithoutProperties(_ref, ['theme']);

    return _react2.default.createElement(
      _emotionTheming.ThemeProvider,
      { theme: (0, _normalizeTheme2.default)(theme) },
      _react2.default.createElement(Component, rest)
    );
  };
};

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offsetsAtTime = exports.timeAtOffset = undefined;

var _textHelper = __webpack_require__(1255);

var timestampIsUnknown = function timestampIsUnknown(timestamp) {
  return timestamp === -1;
};

var findIndexOfKnownTimestamp = function findIndexOfKnownTimestamp(wordIndex, timestamps, whenUnknown) {
  if (timestampIsUnknown(timestamps[wordIndex])) {
    return findIndexOfKnownTimestamp(whenUnknown(wordIndex), timestamps, whenUnknown);
  }

  return wordIndex;
};

var estimatedTimeAtIndex = function estimatedTimeAtIndex(timestamps, wordIndex) {
  var previousKnownWordIdx = findIndexOfKnownTimestamp(wordIndex, timestamps, function (idx) {
    return idx - 1;
  });
  var previousKnownTimestamp = parseFloat(timestamps[previousKnownWordIdx]);
  var nextKnownWordIdx = findIndexOfKnownTimestamp(wordIndex, timestamps, function (idx) {
    return idx + 1;
  });
  var nextKnownTimestamp = parseFloat(timestamps[nextKnownWordIdx]);

  var timeDifference = nextKnownTimestamp - previousKnownTimestamp;
  var knownTimestampGap = nextKnownWordIdx - previousKnownWordIdx;
  var gapIndex = wordIndex - previousKnownWordIdx;

  return timeDifference / knownTimestampGap * gapIndex + previousKnownTimestamp;
};

var sizeOfWord = function sizeOfWord(word) {
  return word.replace(/\n+/, '').length;
};

var offsetsOfWordIndex = function offsetsOfWordIndex(index, transcript) {
  var words = transcript.trim().split(/\s+/);
  var whitespaces = transcript.split(/\S+/);
  var whitespacesUpToWord = whitespaces.slice(0, index + 1).map(function (whitespaces) {
    return whitespaces.length;
  }).reduce(function (a, b) {
    return a + b;
  });
  var endOffset = words.slice(0, index + 1).join('').length + whitespacesUpToWord - 1;

  return {
    endOffset: endOffset,
    startOffset: endOffset - (sizeOfWord(words[index]) - 1)
  };
};

var timeAtIndex = function timeAtIndex(timestamps, index) {
  if (timestampIsUnknown(timestamps[index])) {
    return estimatedTimeAtIndex(timestamps, index);
  }

  return parseFloat(timestamps[index]);
};

var timeAtOffset = exports.timeAtOffset = function timeAtOffset(offset, transcript, timestamps) {
  return timeAtIndex(timestamps, (0, _textHelper.wordIndexFromOffset)(offset, transcript));
};

var binarySearchTimestamp = function binarySearchTimestamp(timestamps, time) {
  var lowerIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var upperIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Math.max(timestamps.length - 1, 0);

  var index = timestamps.indexOf(time);

  if (index !== -1) {
    return index;
  }

  var midpoint = Math.floor((upperIndex + lowerIndex) / 2);
  var comparedTime = timeAtIndex(timestamps, midpoint);

  if (time === comparedTime) {
    return midpoint;
  }

  if (upperIndex - lowerIndex <= 1) {
    if (time > timeAtIndex(timestamps, upperIndex)) {
      return upperIndex;
    }

    return lowerIndex;
  }

  if (time > comparedTime) {
    return binarySearchTimestamp(timestamps, time, midpoint, upperIndex);
  }

  return binarySearchTimestamp(timestamps, time, lowerIndex, midpoint);
};

var offsetsAtTime = exports.offsetsAtTime = function offsetsAtTime(time, transcript, timestamps) {
  return offsetsOfWordIndex(binarySearchTimestamp(timestamps, time), transcript);
};

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var wordIndexFromOffset = exports.wordIndexFromOffset = function wordIndexFromOffset(offset, text) {
  return text.slice(0, offset + 1).trim().split(/\s+/).length - 1;
};

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(6);

var _reactDom = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderContainer = function renderContainer(store, Container) {
  return function (props, element) {
    return (0, _reactDom.render)(_react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(Container, props)
    ), element);
  };
};

exports.default = renderContainer;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionStatusLink = exports.LockBadge = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _class2, _temp3, _class3, _temp4;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stylist = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdvancedSearchLink = (_temp2 = _class = function (_Component) {
  _inherits(AdvancedSearchLink, _Component);

  function AdvancedSearchLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AdvancedSearchLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdvancedSearchLink.__proto__ || Object.getPrototypeOf(AdvancedSearchLink)).call.apply(_ref, [this].concat(args))), _this), _this.orderElements = function () {
      var _this$props = _this.props,
          arrow = _this$props.arrow,
          text = _this$props.text,
          textClass = _this$props.textClass;


      switch (arrow) {
        case 'right':
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { className: textClass },
              text
            ),
            _react2.default.createElement('i', { className: 'im-icon-chevron-right' })
          );
        case 'left':
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('i', { className: 'im-icon-chevron-left' }),
            _react2.default.createElement(
              'a',
              { className: textClass },
              text
            )
          );
        default:
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { className: textClass },
              text
            )
          );
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AdvancedSearchLink, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.orderElements()
      );
    }
  }]);

  return AdvancedSearchLink;
}(_react.Component), _class.propTypes = {
  arrow: _propTypes2.default.string,
  text: _propTypes2.default.string,
  textClass: _propTypes2.default.string
}, _class.defaultProps = {
  arrow: '',
  text: 'Advanced Search',
  textClass: ''
}, _temp2);
exports.default = AdvancedSearchLink;
var LockBadge = exports.LockBadge = (_temp3 = _class2 = function (_Component2) {
  _inherits(LockBadge, _Component2);

  function LockBadge() {
    _classCallCheck(this, LockBadge);

    return _possibleConstructorReturn(this, (LockBadge.__proto__ || Object.getPrototypeOf(LockBadge)).apply(this, arguments));
  }

  _createClass(LockBadge, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          kind = _props.kind,
          text = _props.text;


      return _react2.default.createElement(
        'div',
        { style: { width: '200px' } },
        _react2.default.createElement(
          'a',
          { className: 'link-with-badge' },
          _react2.default.createElement(
            'span',
            null,
            I18n.t(text)
          ),
          _react2.default.createElement(
            _stylist.Badge,
            { kind: kind, className: 'right' },
            _react2.default.createElement(_stylist.LockIcon, { size: 's' })
          )
        )
      );
    }
  }]);

  return LockBadge;
}(_react.Component), _class2.propTypes = {
  kind: _propTypes2.default.string,
  text: _propTypes2.default.string
}, _class2.defaultProps = {
  kind: 'pro',
  text: ''
}, _temp3);
var CollectionStatusLink = exports.CollectionStatusLink = (_temp4 = _class3 = function (_Component3) {
  _inherits(CollectionStatusLink, _Component3);

  function CollectionStatusLink() {
    _classCallCheck(this, CollectionStatusLink);

    return _possibleConstructorReturn(this, (CollectionStatusLink.__proto__ || Object.getPrototypeOf(CollectionStatusLink)).apply(this, arguments));
  }

  _createClass(CollectionStatusLink, [{
    key: 'render',
    value: function render() {
      var textClass = this.props.textClass;


      return _react2.default.createElement(
        'a',
        { className: textClass },
        _react2.default.createElement(
          'span',
          null,
          'Collection Status'
        ),
        _react2.default.createElement(
          _stylist.Badge,
          { kind: 'pro', className: 'right' },
          _react2.default.createElement(_stylist.LockIcon, { size: 's' })
        )
      );
    }
  }]);

  return CollectionStatusLink;
}(_react.Component), _class3.propTypes = {
  textClass: _propTypes2.default.string
}, _class3.defaultProps = {
  textClass: 'search-header-tooltip-link wide-collection-status-link'
}, _temp4);

/***/ }),
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BUTTON_PREFIX = 'fv-button';

var applyPrefixes = function applyPrefixes(types) {
  return [].concat(types).map(function (type) {
    return BUTTON_PREFIX + '-' + type;
  }).join(' ');
};

var Button = function Button(_ref) {
  var className = _ref.className,
      children = _ref.children,
      Component = _ref.component,
      kind = _ref.kind,
      kinds = _ref.kinds,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'component', 'kind', 'kinds']);

  return _react2.default.createElement(
    Component,
    Object.assign({
      className: (0, _classnames2.default)('fv-button', className, kind && applyPrefixes(kind), kinds && applyPrefixes(kinds))
    }, props),
    children
  );
};

Button.propTypes = {
  children: _propTypes2.default.node
};

Button.defaultProps = {
  component: 'button',
  role: 'button',
  type: 'button'
};

exports.default = Button;

/***/ }),
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CommentList = __webpack_require__(1563);

var _CommentList2 = _interopRequireDefault(_CommentList);

var _FileUploadButton = __webpack_require__(891);

var _FileUploadButton2 = _interopRequireDefault(_FileUploadButton);

var _findEnglishVideo = __webpack_require__(897);

var _findEnglishVideo2 = _interopRequireDefault(_findEnglishVideo);

var _HighlightOverlayContainer = __webpack_require__(1198);

var _HighlightOverlayContainer2 = _interopRequireDefault(_HighlightOverlayContainer);

var _ImageClipMain = __webpack_require__(1224);

var _ImageClipMain2 = _interopRequireDefault(_ImageClipMain);

var _ImageResponseMain = __webpack_require__(1233);

var _ImageResponseMain2 = _interopRequireDefault(_ImageResponseMain);

var _JoinLiveModalContainer = __webpack_require__(1600);

var _JoinLiveModalContainer2 = _interopRequireDefault(_JoinLiveModalContainer);

var _Paginator = __webpack_require__(628);

var _Paginator2 = _interopRequireDefault(_Paginator);

var _ParticipantList = __webpack_require__(1609);

var _ParticipantList2 = _interopRequireDefault(_ParticipantList);

var _ReportOverlayContainer = __webpack_require__(1235);

var _ReportOverlayContainer2 = _interopRequireDefault(_ReportOverlayContainer);

var _RestrictedWorkspacesWidget = __webpack_require__(1611);

var _RestrictedWorkspacesWidget2 = _interopRequireDefault(_RestrictedWorkspacesWidget);

var _TextClipMain = __webpack_require__(1237);

var _TextClipMain2 = _interopRequireDefault(_TextClipMain);

var _TextResponseMain = __webpack_require__(1239);

var _TextResponseMain2 = _interopRequireDefault(_TextResponseMain);

var _TranscriptSelection = __webpack_require__(1240);

var _TranscriptSelection2 = _interopRequireDefault(_TranscriptSelection);

var _Video = __webpack_require__(711);

var _Video2 = _interopRequireDefault(_Video);

var _VideoClipMain = __webpack_require__(1244);

var _VideoClipMain2 = _interopRequireDefault(_VideoClipMain);

var _VideoClipPlayer = __webpack_require__(1146);

var _VideoClipPlayer2 = _interopRequireDefault(_VideoClipPlayer);

var _VideoResponseMain = __webpack_require__(1247);

var _VideoResponseMain2 = _interopRequireDefault(_VideoResponseMain);

var _configureStore = __webpack_require__(363);

var _configureStore2 = _interopRequireDefault(_configureStore);

var _renderWithTheme = __webpack_require__(1252);

var _renderWithTheme2 = _interopRequireDefault(_renderWithTheme);

var _appConstants = __webpack_require__(38);

var _timeOffsetHelper = __webpack_require__(1254);

var _urlHelper = __webpack_require__(29);

var _renderComponent = __webpack_require__(623);

var _renderComponent2 = _interopRequireDefault(_renderComponent);

var _renderContainer = __webpack_require__(1256);

var _renderContainer2 = _interopRequireDefault(_renderContainer);

var _humps = __webpack_require__(22);

var _alertActions = __webpack_require__(33);

var _searchActions = __webpack_require__(151);

var _modalActions = __webpack_require__(128);

var _hasPermission = __webpack_require__(264);

var _ProTooltip = __webpack_require__(956);

var _ProTooltip2 = _interopRequireDefault(_ProTooltip);

var _TooltipBaseLink = __webpack_require__(1257);

var _TooltipBaseLink2 = _interopRequireDefault(_TooltipBaseLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _configureStore2.default)((0, _humps.camelizeKeys)(window.REDUX_DATA));

window.Tru = window.Tru || {};

window.Tru.Components = {
  ImageClipMain: _ImageClipMain2.default,
  ParticipantList: _ParticipantList2.default,
  TextClipMain: _TextClipMain2.default

  // Actions
};window.Tru.Actions = {
  createSearch: _searchActions.createSearch,
  createAlert: function createAlert(alert) {
    return store.dispatch((0, _alertActions.createAlert)(alert));
  },
  openJoinLiveModal: function openJoinLiveModal() {
    return store.dispatch((0, _modalActions.openModal)(_JoinLiveModalContainer.JOIN_LIVE_MODAL_ID));
  }

  // Stores
};window.Tru.Stores = {
  reduxStore: store

  // Utilities
};window.Tru.Utils = {
  buildAPIBaseURL: _urlHelper.buildAPIBaseURL,
  buildBaseURL: _urlHelper.buildBaseURL,
  offsetsAtTime: _timeOffsetHelper.offsetsAtTime,
  findEnglishVideo: _findEnglishVideo2.default,
  KeyCodes: _appConstants.KeyCodes,
  hasPermission: _hasPermission.hasPermission,
  hasPermissionWithPermissions: _hasPermission.hasPermissionWithPermissions

  // Render Helpers
};window.renderHighlightOverlay = (0, _renderContainer2.default)(store, _HighlightOverlayContainer2.default);
window.renderPaginator = (0, _renderComponent2.default)(_Paginator2.default);
window.renderReportOverlay = (0, _renderContainer2.default)(store, _ReportOverlayContainer2.default);
window.renderVideo = (0, _renderComponent2.default)(_Video2.default);
window.renderVideoClipPlayer = (0, _renderContainer2.default)(store, _VideoClipPlayer2.default);
window.renderFileUploadButton = (0, _renderComponent2.default)(_FileUploadButton2.default);
window.renderCommentList = (0, _renderContainer2.default)(store, _CommentList2.default);
window.renderTranscriptSelection = (0, _renderComponent2.default)(_TranscriptSelection2.default);
window.renderJoinLiveModal = (0, _renderContainer2.default)(store, _JoinLiveModalContainer2.default);
window.renderVideoResponseMain = (0, _renderContainer2.default)(store, _VideoResponseMain2.default);
window.renderImageResponseMain = (0, _renderContainer2.default)(store, _ImageResponseMain2.default);
window.renderTextResponseMain = (0, _renderContainer2.default)(store, _TextResponseMain2.default);
window.renderVideoClipMain = (0, _renderContainer2.default)(store, _VideoClipMain2.default);
window.renderTooltip = (0, _renderWithTheme2.default)(_ProTooltip2.default);
window.renderAdvancedSearchLink = _TooltipBaseLink2.default;
window.renderLockBadge = (0, _renderWithTheme2.default)(_TooltipBaseLink.LockBadge);
window.renderCollectionStatusLink = _TooltipBaseLink.CollectionStatusLink;
window.renderRestrictedWorkspacesWidget = (0, _renderWithTheme2.default)(_RestrictedWorkspacesWidget2.default);

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2, _class3, _temp4;

var _DateDisplay = __webpack_require__(669);

var _DateDisplay2 = _interopRequireDefault(_DateDisplay);

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _Spinner = __webpack_require__(116);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _reactRedux = __webpack_require__(6);

var _appConstants = __webpack_require__(38);

var _truncate = __webpack_require__(1192);

var _truncate2 = _interopRequireDefault(_truncate);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var canDeleteComment = function canDeleteComment(user, comment) {
  return user && comment.owner && user.id === comment.owner.id;
};

var firstLastInitial = function firstLastInitial(user) {
  return user.firstName + ' ' + user.lastName[0] + '.';
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    canBeDeleted: canDeleteComment(state.currentUser, ownProps.comment)
  };
};

var CommentListItem = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp2 = _class2 = function (_Component) {
  _inherits(CommentListItem, _Component);

  function CommentListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CommentListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CommentListItem.__proto__ || Object.getPrototypeOf(CommentListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = { expanded: false }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CommentListItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          canBeDeleted = _props.canBeDeleted,
          comment = _props.comment,
          onRemoveClick = _props.onRemoveClick;
      var expanded = this.state.expanded;


      return _react2.default.createElement(
        'div',
        { className: 'comment-container' },
        _react2.default.createElement(
          'div',
          { className: 'comment-details' },
          _react2.default.createElement(
            'span',
            { className: 'comment-author' },
            firstLastInitial(comment.owner)
          ),
          _react2.default.createElement(
            'span',
            { className: 'comment-date' },
            _react2.default.createElement(_DateDisplay2.default, { date: comment.insertDt, format: 'MMM D, YYYY h:mma' })
          )
        ),
        canBeDeleted && _react2.default.createElement(_Icon2.default, {
          name: 'delete',
          className: 'right cursor',
          onClick: onRemoveClick
        }),
        _react2.default.createElement(
          'div',
          { className: 'comment clear-both' },
          expanded ? comment.commentText : (0, _truncate2.default)(comment.commentText, {
            length: 90,
            separator: ' '
          }),
          ' ',
          comment.commentText.length > 90 && _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                return _this2.setState({ expanded: !expanded });
              } },
            expanded ? 'less' : 'more'
          )
        )
      );
    }
  }]);

  return CommentListItem;
}(_react.Component), _class2.propTypes = {
  canBeDeleted: _propTypes2.default.bool.isRequired,
  comment: _propTypes2.default.shape({
    owner: _propTypes2.default.object.isRequired,
    insertDt: _propTypes2.default.string.isRequired,
    commentText: _propTypes2.default.string
  }).isRequired,
  onRemoveClick: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
var CommentList = (_temp4 = _class3 = function (_Component2) {
  _inherits(CommentList, _Component2);

  function CommentList() {
    var _ref2;

    var _temp3, _this3, _ret2;

    _classCallCheck(this, CommentList);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref2 = CommentList.__proto__ || Object.getPrototypeOf(CommentList)).call.apply(_ref2, [this].concat(args))), _this3), _this3.handleKeyUp = function (e) {
      if (e.which === _appConstants.KeyCodes.ENTER) {
        _this3.props.onSubmit(e.target.value).then(function () {
          return _this3.input.value = '';
        });
      }
    }, _temp3), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(CommentList, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          comments = _props2.comments,
          isLoading = _props2.isLoading,
          onRemove = _props2.onRemove;


      return _react2.default.createElement(
        'div',
        null,
        comments.map(function (comment) {
          return _react2.default.createElement(CommentListItem, {
            key: comment.id,
            comment: comment,
            onRemoveClick: function onRemoveClick() {
              return onRemove(comment.id);
            }
          });
        }),
        _react2.default.createElement(_Spinner2.default, { spinning: isLoading }),
        _react2.default.createElement(
          'div',
          { className: 'new-comment' },
          _react2.default.createElement('input', {
            type: 'text',
            placeholder: I18n.t('Add a comment'),
            ref: function ref(input) {
              return _this4.input = input;
            },
            disabled: isLoading,
            onKeyUp: this.handleKeyUp
          })
        )
      );
    }
  }]);

  return CommentList;
}(_react.Component), _class3.propTypes = {
  comments: _propTypes2.default.array.isRequired,
  isLoading: _propTypes2.default.bool.isRequired,
  onRemove: _propTypes2.default.func.isRequired,
  onSubmit: _propTypes2.default.func.isRequired
}, _temp4);
exports.default = CommentList;

/***/ }),
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.JOIN_LIVE_MODAL_ID = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _initialiseProps;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _modalActions = __webpack_require__(128);

var _alertActions = __webpack_require__(33);

var _reactRedux = __webpack_require__(6);

var _JoinLiveModal = __webpack_require__(1601);

var _JoinLiveModal2 = _interopRequireDefault(_JoinLiveModal);

var _api = __webpack_require__(119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JOIN_LIVE_MODAL_ID = exports.JOIN_LIVE_MODAL_ID = 'JOIN_LIVE_MODAL';

var mapStateToProps = function mapStateToProps(state) {
  return {
    open: state.modals[JOIN_LIVE_MODAL_ID],
    features: state.features
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch((0, _modalActions.closeModal)(JOIN_LIVE_MODAL_ID));
    },
    createAlert: function createAlert(alert) {
      return dispatch((0, _alertActions.createAlert)(alert));
    }
  };
};

var secureLoginRedirectUrl = function secureLoginRedirectUrl(jwt) {
  var backroom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var baseUrl = "https://online.focusvision.com/FV.24TruIntegration.WebAPI/api/authentication/secureLoginRedirect" + '?token=' + jwt;
  return backroom ? baseUrl + '&viewerLocation=2' : baseUrl;
};

var JoinLiveModalContainer = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(JoinLiveModalContainer, _Component);

  function JoinLiveModalContainer(props) {
    _classCallCheck(this, JoinLiveModalContainer);

    var _this = _possibleConstructorReturn(this, (JoinLiveModalContainer.__proto__ || Object.getPrototypeOf(JoinLiveModalContainer)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        playerUrl = _this$props.playerUrl,
        features = _this$props.features,
        jwt = _this$props.jwt;


    if (!_this.isIntervu()) {
      return _possibleConstructorReturn(_this);
    }

    if (features.includes('20200317_secure_login_redirect')) {
      var _ret;

      return _ret = window.location.href = secureLoginRedirectUrl(jwt), _possibleConstructorReturn(_this, _ret);
    }

    _this.getCookies().then(function () {
      window.location.href = playerUrl;
    });
    return _this;
  }

  _createClass(JoinLiveModalContainer, [{
    key: 'isIntervu',
    value: function isIntervu() {
      var sourceType = this.props.sourceType;

      return sourceType === 'InterVu';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var location = this.state.location;
      var open = this.props.open;


      return _react2.default.createElement(_JoinLiveModal2.default, {
        location: location,
        open: open && !this.isIntervu(),
        onClose: this.handleClose,
        onJoin: this.handleJoin,
        onSelectLocation: function onSelectLocation(location) {
          return _this2.setState({ location: location });
        }
      });
    }
  }]);

  return JoinLiveModalContainer;
}(_react.Component), _class2.propTypes = {
  createAlert: _propTypes2.default.func,
  jwt: _propTypes2.default.string.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool,
  playerUrl: _propTypes2.default.string,
  sourceType: _propTypes2.default.string.isRequired,
  features: _propTypes2.default.array.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    location: null
  };

  this.handleClose = function () {
    _this3.setState({ location: null });
    _this3.props.onClose();
  };

  this.getCookies = function () {
    var jwt = _this3.props.jwt;


    return (0, _api.getLiveCookies)({ jwt: jwt });
  };

  this.handleJoin = function () {
    var _props = _this3.props,
        playerUrl = _props.playerUrl,
        createAlert = _props.createAlert,
        features = _props.features,
        jwt = _props.jwt;
    var location = _this3.state.location;


    if (features.includes('20200317_secure_login_redirect')) {
      return window.location.href = secureLoginRedirectUrl(jwt, location === 'backroom');
    }

    _this3.getCookies().then(function () {
      if (location === 'backroom') {
        return window.location.href = playerUrl + '&ViewerLocation=2';
      }

      window.location.href = playerUrl;
    }).catch(function () {
      createAlert({
        type: 'ERROR',
        message: 'Something went wrong, please contact support.',
        scope: 'joinModal'
      });
    });
  };
}, _temp)) || _class);
exports.default = JoinLiveModalContainer;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertListContainer = __webpack_require__(375);

var _AlertListContainer2 = _interopRequireDefault(_AlertListContainer);

var _Button = __webpack_require__(1427);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _i18n = __webpack_require__(90);

var _i18n2 = _interopRequireDefault(_i18n);

var _Modal = __webpack_require__(1602);

var _Modal2 = _interopRequireDefault(_Modal);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JoinLiveModal = function JoinLiveModal(_ref) {
  var location = _ref.location,
      open = _ref.open,
      onClose = _ref.onClose,
      onJoin = _ref.onJoin,
      onSelectLocation = _ref.onSelectLocation;
  return _react2.default.createElement(
    'div',
    { className: 'viewing-location-modal' },
    open && _react2.default.createElement(_AlertListContainer2.default, { scope: 'joinModal', clearOnUnmount: true }),
    _react2.default.createElement(
      _Modal2.default,
      { open: open, onClose: onClose },
      _react2.default.createElement(
        _Modal.ModalHeader,
        null,
        'Select a viewing location'
      ),
      _react2.default.createElement(
        _Modal.ModalBody,
        { unstyled: true },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('location-toggle', {
              'fv-active': location === 'remote'
            }),
            onClick: function onClick() {
              return onSelectLocation('remote');
            }
          },
          _i18n2.default.t('Remote')
        ),
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('location-toggle', {
              'fv-active': location === 'backroom'
            }),
            onClick: function onClick() {
              return onSelectLocation('backroom');
            }
          },
          _i18n2.default.t('Backroom')
        )
      ),
      _react2.default.createElement(
        _Modal.ModalFooter,
        { unstyled: true },
        _react2.default.createElement(
          _Button2.default,
          {
            disabled: !location,
            kinds: ['link', 'block'],
            className: 'join-button',
            onClick: onJoin
          },
          'Join'
        )
      )
    )
  );
};

JoinLiveModal.propTypes = {
  location: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  onJoin: _propTypes2.default.func,
  onSelectLocation: _propTypes2.default.func,
  open: _propTypes2.default.bool
};

exports.default = JoinLiveModal;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBody = exports.ModalFooter = exports.ModalHeader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ModalHeader = __webpack_require__(1603);

Object.defineProperty(exports, 'ModalHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalHeader).default;
  }
});

var _ModalFooter = __webpack_require__(1605);

Object.defineProperty(exports, 'ModalFooter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalFooter).default;
  }
});

var _ModalBody = __webpack_require__(1606);

Object.defineProperty(exports, 'ModalBody', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalBody).default;
  }
});

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _appConstants = __webpack_require__(38);

var _ModalBackground = __webpack_require__(1607);

var _ModalBackground2 = _interopRequireDefault(_ModalBackground);

var _ModalContainer = __webpack_require__(1608);

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.handleEsc = function (e) {
      if (e.which === _appConstants.KeyCodes.ESC) {
        _this.props.onClose();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.dismissable) {
        document.addEventListener('keyup', this.handleEsc);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keyup', this.handleEsc);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          dismissable = _props.dismissable,
          open = _props.open,
          onClose = _props.onClose;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('fv-modal', className),
          style: { display: open ? 'block' : 'none' }
        },
        _react2.default.createElement(_ModalBackground2.default, { open: open, onClick: function onClick() {
            return dismissable && onClose();
          } }),
        _react2.default.createElement(
          _ModalContainer2.default,
          null,
          _react.Children.map(children, function (child) {
            return child.type === _ModalHeader2.default ? (0, _react.cloneElement)(child, { dismissable: dismissable, onClose: onClose }) : child;
          })
        )
      );
    }
  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  children: _propTypes2.default.node,
  dismissable: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func,
  open: _propTypes2.default.bool.isRequired
};

Modal.defaultProps = {
  dismissable: true,
  open: false
};

exports.default = Modal;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CloseButton = __webpack_require__(1604);

var _CloseButton2 = _interopRequireDefault(_CloseButton);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
      dismissable = _ref.dismissable,
      onClose = _ref.onClose;
  return _react2.default.createElement(
    'div',
    { className: 'fv-modal-header' },
    children,
    dismissable && _react2.default.createElement(_CloseButton2.default, { onClick: onClose })
  );
};

ModalHeader.propTypes = {
  children: _propTypes2.default.node,
  dismissable: _propTypes2.default.bool.isRequired
};

ModalHeader.defaultProps = {
  dismissable: true
};

exports.default = ModalHeader;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(1427);

var _Button2 = _interopRequireDefault(_Button);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CloseButton = function CloseButton(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ['className']);

  return _react2.default.createElement(
    _Button2.default,
    Object.assign({}, props, { kind: 'clear', className: 'fv-button-close' }),
    '\xD7'
  );
};

CloseButton.propTypes = {
  children: _propTypes2.default.node
};

exports.default = CloseButton;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalFooter = function ModalFooter(_ref) {
  var children = _ref.children,
      unstyled = _ref.unstyled;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('fv-modal-footer', {
        'fv-modal-unstyled': unstyled
      })
    },
    children
  );
};

ModalFooter.propTypes = {
  children: _propTypes2.default.node,
  unstyled: _propTypes2.default.bool.isRequired
};

ModalFooter.defaultProps = {
  unstyled: false
};

exports.default = ModalFooter;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = __webpack_require__(11);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      unstyled = _ref.unstyled;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _classnames2.default)('fv-modal-body', {
        'fv-modal-unstyled': unstyled
      })
    },
    children
  );
};

ModalBody.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ModalBody;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBackground = function ModalBackground(_ref) {
  var open = _ref.open,
      dismissible = _ref.dismissible,
      onClick = _ref.onClick;
  return _react2.default.createElement('div', {
    className: 'fv-modal-background',
    onClick: onClick,
    style: { display: open ? 'block' : 'none' }
  });
};

exports.default = ModalBackground;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalContainer = function ModalContainer(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'fv-modal-container' },
    children
  );
};

ModalContainer.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ModalContainer;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _class2, _temp;

var _DropdownActions = __webpack_require__(909);

var _DropdownActions2 = _interopRequireDefault(_DropdownActions);

var _DropdownMenuItem = __webpack_require__(912);

var _DropdownMenuItem2 = _interopRequireDefault(_DropdownMenuItem);

var _SetupParticipantsPageExpandedRow = __webpack_require__(1610);

var _SetupParticipantsPageExpandedRow2 = _interopRequireDefault(_SetupParticipantsPageExpandedRow);

var _SortableTableHeader = __webpack_require__(825);

var _SortableTableHeader2 = _interopRequireDefault(_SortableTableHeader);

var _Table = __webpack_require__(356);

var _Table2 = _interopRequireDefault(_Table);

var _TableColumn = __webpack_require__(229);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _ExpandableTable = __webpack_require__(1234);

var _ExpandableTable2 = _interopRequireDefault(_ExpandableTable);

var _SelectableTable = __webpack_require__(961);

var _SelectableTable2 = _interopRequireDefault(_SelectableTable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var expandedRowRenderer = function expandedRowRenderer(participant, props) {
  return _react2.default.createElement(_SetupParticipantsPageExpandedRow2.default, {
    assignments: props.assignmentsByParticipant[participant.id]
  });
};

var ParticipantList = (_dec = (0, _SelectableTable2.default)(mapData, handleSelect, { trackBy: 'id' }), _dec2 = (0, _ExpandableTable2.default)(mapData, expandedRowRenderer, { trackBy: 'id' }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_PureComponent) {
  _inherits(ParticipantList, _PureComponent);

  function ParticipantList(props) {
    _classCallCheck(this, ParticipantList);

    var _this = _possibleConstructorReturn(this, (ParticipantList.__proto__ || Object.getPrototypeOf(ParticipantList)).call(this, props));

    _this.renderActions = _this.renderActions.bind(_this);
    _this.renderSortableColumn = _this.renderSortableColumn.bind(_this);

    _this.state = {
      sortBy: 'firstLastInitial',
      order: 'asc'
    };
    return _this;
  }

  _createClass(ParticipantList, [{
    key: 'getStatus',
    value: function getStatus(participant) {
      return participant.deleteFl ? 'Deleted' : 'Enabled';
    }
  }, {
    key: 'getProjectSegments',
    value: function getProjectSegments(participant) {
      return participant.projectSegments.map(function (segment) {
        return segment.truncatedName;
      }).join(', ');
    }
  }, {
    key: 'renderActions',
    value: function renderActions(_, participant) {
      var _this2 = this;

      return _react2.default.createElement(
        _DropdownActions2.default,
        null,
        _react2.default.createElement(_DropdownMenuItem2.default, { text: 'Edit', href: participant.profilePath }),
        _react2.default.createElement(_DropdownMenuItem2.default, {
          text: 'Impersonate',
          href: participant.impersonatePath
        }),
        _react2.default.createElement(_DropdownMenuItem2.default, {
          text: 'View Communication',
          href: '#recruitNotes',
          'data-toggle': 'modal',
          onClick: function onClick() {
            return _this2.props.onViewCommunications(participant);
          }
        }),
        participant.deleteFl && _react2.default.createElement(_DropdownMenuItem2.default, { text: 'Restore', href: participant.restorePath }),
        !participant.deleteFl && _react2.default.createElement(_DropdownMenuItem2.default, {
          text: 'Delete',
          href: participant.deletePath,
          'data-method': 'delete',
          onClick: function onClick() {
            return confirm('Are you sure you want to delete this participant?');
          }
        })
      );
    }
  }, {
    key: 'renderSortableColumn',
    value: function renderSortableColumn(label, dataKey) {
      var _this3 = this;

      var _state = this.state,
          sortBy = _state.sortBy,
          order = _state.order;


      return _react2.default.createElement(_SortableTableHeader2.default, {
        active: dataKey === sortBy,
        label: label,
        onClick: function onClick(order) {
          return _this3.setState({ order: order, sortBy: dataKey });
        },
        order: order
      });
    }
  }, {
    key: 'compare',
    value: function compare(a, b) {
      var sortBy = this.state.sortBy;


      switch (sortBy) {
        case 'projectSegments':
          return this.getProjectSegments(a).localeCompare(this.getProjectSegments(b));
        default:
          return a[sortBy].localeCompare(b[sortBy]);
      }
    }
  }, {
    key: 'sortedParticipants',
    value: function sortedParticipants() {
      var _this4 = this;

      var order = this.state.order;


      return this.props.participants.sort(function (a, b) {
        return order === 'asc' ? _this4.compare(a, b) : _this4.compare(b, a);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          connectExpandableColumn = _props.connectExpandableColumn,
          connectSelectableColumn = _props.connectSelectableColumn;


      return connectSelectableColumn(connectExpandableColumn(_react2.default.createElement(
        _Table2.default,
        { data: this.sortedParticipants() },
        _react2.default.createElement(_TableColumn2.default, {
          dataGetter: this.getStatus,
          dataKey: 'status',
          label: 'Status'
        }),
        _react2.default.createElement(_TableColumn2.default, {
          dataKey: 'firstLastInitial',
          label: 'Name',
          headerRenderer: this.renderSortableColumn
        }),
        _react2.default.createElement(_TableColumn2.default, {
          dataKey: 'responseCount',
          label: 'Responses',
          headerRenderer: this.renderSortableColumn
        }),
        _react2.default.createElement(_TableColumn2.default, {
          dataGetter: this.getProjectSegments,
          dataKey: 'projectSegments',
          label: 'Segment',
          headerRenderer: this.renderSortableColumn
        }),
        _react2.default.createElement(_TableColumn2.default, {
          dataKey: 'questionGroup',
          label: 'Assignment Group',
          headerRenderer: this.renderSortableColumn
        }),
        _react2.default.createElement(_TableColumn2.default, {
          dataKey: 'lastResponseDt',
          label: 'Last Response',
          headerRenderer: this.renderSortableColumn
        }),
        _react2.default.createElement(_TableColumn2.default, {
          align: 'right',
          cellRenderer: this.renderActions,
          dataKey: 'actions',
          label: 'Actions'
        })
      )));
    }
  }]);

  return ParticipantList;
}(_react.PureComponent), _class2.propTypes = {
  assignmentsByParticipant: _propTypes2.default.object.isRequired,
  connectExpandableColumn: _propTypes2.default.func.isRequired,
  connectSelectableColumn: _propTypes2.default.func.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  onViewCommunications: _propTypes2.default.func.isRequired,
  participants: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
}, _temp)) || _class) || _class);
exports.default = ParticipantList;


function mapData(props) {
  return props.participants;
}

expandedRowRenderer.propTypes = {
  assignmentsByParticipant: _propTypes2.default.object.isRequired
};

function handleSelect(participant, selected, props) {
  props.onSelect(participant, selected);
}

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _Icon = __webpack_require__(35);

var _Icon2 = _interopRequireDefault(_Icon);

var _Table = __webpack_require__(356);

var _Table2 = _interopRequireDefault(_Table);

var _TableColumn = __webpack_require__(229);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SetupParticipantsPageExpandedRow = (_temp = _class = function (_PureComponent) {
  _inherits(SetupParticipantsPageExpandedRow, _PureComponent);

  function SetupParticipantsPageExpandedRow() {
    _classCallCheck(this, SetupParticipantsPageExpandedRow);

    return _possibleConstructorReturn(this, (SetupParticipantsPageExpandedRow.__proto__ || Object.getPrototypeOf(SetupParticipantsPageExpandedRow)).apply(this, arguments));
  }

  _createClass(SetupParticipantsPageExpandedRow, [{
    key: 'renderResponseTypes',
    value: function renderResponseTypes(responseTypes) {
      return responseTypes.map(function (responseType) {
        return responseType !== 'none' && _react2.default.createElement(_Icon2.default, {
          title: responseType.tooltip,
          key: responseType.code,
          name: responseType.code,
          className: 'marginRight5'
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var assignments = this.props.assignments;


      return _react2.default.createElement(
        'tr',
        { className: 'table-expanded-row' },
        _react2.default.createElement('td', { colSpan: 2 }),
        _react2.default.createElement(
          'td',
          { colSpan: 6 },
          _react2.default.createElement(
            _Table2.default,
            { data: assignments },
            _react2.default.createElement(_TableColumn2.default, { dataKey: 'title', label: 'Assignment' }),
            _react2.default.createElement(_TableColumn2.default, { dataKey: 'responseCount', label: 'Responses' }),
            _react2.default.createElement(_TableColumn2.default, { dataKey: 'responseTime', label: 'Video Duration' }),
            _react2.default.createElement(_TableColumn2.default, {
              align: 'right',
              cellRenderer: this.renderResponseTypes,
              dataKey: 'responseTypes',
              label: 'Response Types'
            })
          )
        ),
        _react2.default.createElement('td', null)
      );
    }
  }]);

  return SetupParticipantsPageExpandedRow;
}(_react.PureComponent), _class.propTypes = {
  assignments: _propTypes2.default.array.isRequired
}, _temp);
exports.default = SetupParticipantsPageExpandedRow;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18n = __webpack_require__(90);

var _i18n2 = _interopRequireDefault(_i18n);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _stylist = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestrictedWorkspacesWidget = function RestrictedWorkspacesWidget() {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement('div', { className: 'dashboard-sub' }),
    _react2.default.createElement(
      'div',
      { className: 'dashboard-empty-workspace' },
      _react2.default.createElement(
        'h6',
        null,
        _i18n2.default.t('There are no Workspaces available at this time.')
      ),
      _react2.default.createElement(
        'div',
        { className: 'marginTop10' },
        _react2.default.createElement(
          _stylist.Badge,
          { kind: 'pro' },
          _react2.default.createElement(_stylist.LockIcon, { size: 's' })
        ),
        _react2.default.createElement(
          'span',
          { style: { marginLeft: '.5rem' } },
          _i18n2.default.t('Workspaces are available with a subscription.')
        )
      )
    )
  );
};

exports.default = RestrictedWorkspacesWidget;

/***/ })
],[1562]);


// WEBPACK FOOTER //
// app-bundle.ef95844ab0dfea11b23b.js